// Code generated by '@graphql-codegen'; DO NOT EDIT.
import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export const AnnouncementRecipientFragmentDoc = gql`
    fragment AnnouncementRecipient on AnnouncementRecipientObj {
  id
  value
  type
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on UserObj {
  id
  name
  email
  profileImage
  isEmailVerified
  jobTitle
  primaryOnboardingGoal
  theme
  avatarColor @client
}
    `;
export const RecipientDataFragmentDoc = gql`
    fragment RecipientData on RecipientDataObj {
  id
  name
  email
}
    `;
export const AnnouncementFragmentDoc = gql`
    fragment Announcement on AnnouncementObj {
  id
  subject
  message
  owner {
    ...UserDetails
  }
  launch {
    id
    name
  }
  recipientsData {
    ...RecipientData
  }
  repeatType
  sendAs
  organizationId
  repeatOn
  destinations
  launchModuleIds
  status
}
    ${UserDetailsFragmentDoc}
${RecipientDataFragmentDoc}`;
export const AssetFileFragmentDoc = gql`
    fragment AssetFile on UserInputAssetFilesObj {
  name
  format
  size
  url
}
    `;
export const AssetEditedByFragmentDoc = gql`
    fragment AssetEditedBy on UserObj {
  id
  name
  email
  avatarColor @client
  profileImage
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on TagObj {
  id
  label
  description
  color
  type
  organizationId
  isPreBuilt
}
    `;
export const AssetApproverFragmentDoc = gql`
    fragment AssetApprover on AssetApproverObj {
  userId
  userDetails {
    id
    name
    email
    avatarColor @client
    profileImage
  }
  hasApproved
}
    `;
export const AssetFragmentDoc = gql`
    fragment Asset on AssetObj {
  id
  name
  type
  brandAsset
  assets {
    ...AssetFile
  }
  launches {
    id
    name
  }
  userInput
  lastEditBy {
    ...AssetEditedBy
  }
  lastEditDetails {
    timestamp
  }
  tagsIds
  tags {
    ...Tag
  }
  orderIndex
  approverDetails {
    ...AssetApprover
  }
}
    ${AssetFileFragmentDoc}
${AssetEditedByFragmentDoc}
${TagFragmentDoc}
${AssetApproverFragmentDoc}`;
export const AssetTagFragmentDoc = gql`
    fragment AssetTag on TagObj {
  id
  label
  color
}
    `;
export const AssetsLaunchFragmentDoc = gql`
    fragment AssetsLaunch on AssetObj {
  id
  name
  type
  launches {
    id
    name
  }
}
    `;
export const LastEditDetailsFragmentDoc = gql`
    fragment LastEditDetails on LastEditDetailsObj {
  userId
  timestamp
}
    `;
export const ApproverDetailsFragmentDoc = gql`
    fragment ApproverDetails on ApproverDetailsObj {
  hasApproved
  userDetails {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export const AssetsFileFragmentDoc = gql`
    fragment AssetsFile on UserInputAssetFileObj {
  name
  format
  size
  url
}
    `;
export const CopyAndAssetsModuleContentFragmentDoc = gql`
    fragment CopyAndAssetsModuleContent on UserInputCopyAssetsObj {
  id
  content
  type
  opened
  assets {
    ...AssetsFile
  }
}
    ${AssetsFileFragmentDoc}`;
export const CopyAndAssetsModuleUserInputFragmentDoc = gql`
    fragment CopyAndAssetsModuleUserInput on UserInputObj {
  COPY_ASSETS_EDITOR {
    ...CopyAndAssetsModuleContent
  }
}
    ${CopyAndAssetsModuleContentFragmentDoc}`;
export const LaunchAssetsModuleFragmentDoc = gql`
    fragment LaunchAssetsModule on LaunchModuleObj {
  approvalStatus
  canGenerateWithAI
  dueDate
  editor
  hint
  id
  name
  placeholder
  gptPrompt
  launchId
  approversDetails {
    ...ApproverDetails
  }
  lastEditBy {
    ...UserDetails
  }
  lastEditDetails {
    timestamp
  }
  userInput {
    id
    ...CopyAndAssetsModuleUserInput
  }
  tags {
    id
    label
    color
    type
    organizationId
    isPreBuilt
  }
  tagsIds
  orderIndex
}
    ${ApproverDetailsFragmentDoc}
${UserDetailsFragmentDoc}
${CopyAndAssetsModuleUserInputFragmentDoc}`;
export const LaunchAssetsModuleContentFragmentDoc = gql`
    fragment LaunchAssetsModuleContent on LaunchModuleObj {
  approversDetails {
    ...ApproverDetails
  }
  userInput {
    id
    ...CopyAndAssetsModuleUserInput
  }
}
    ${ApproverDetailsFragmentDoc}
${CopyAndAssetsModuleUserInputFragmentDoc}`;
export const InvoiceFragmentDoc = gql`
    fragment Invoice on StripeInvoiceObj {
  id
  amount_due
  amount_paid
  createdAt
  invoice_pdf
}
    `;
export const MbInvoiceFragmentDoc = gql`
    fragment MBInvoice on MapleBillingInvoiceObj {
  invoice_date
  due_date
  status
  pdf_link
  due {
    value_in_cents
  }
  total {
    value_in_cents
    currency
  }
  paid {
    value_in_cents
  }
}
    `;
export const MaplePaymentMethodFragmentDoc = gql`
    fragment MaplePaymentMethod on MapleBillingPaymentMethodObj {
  id
  brand
  country
  default
  exp_month
  exp_year
  last_4
}
    `;
export const MaplePriceFragmentDoc = gql`
    fragment MaplePrice on MapleBillingPriceObj {
  id
  frequency
  price_per_unit
}
    `;
export const MapleEntitlementFragmentDoc = gql`
    fragment MapleEntitlement on MapleBillingEntitlementObj {
  entitlement_id
  inherited_from_id
  inherited_from_type
  key
  name
  overridden
  type
  value
}
    `;
export const MaplePlanFragmentDoc = gql`
    fragment MaplePlan on MapleBillingProductObj {
  id
  name
  description
  prices {
    ...MaplePrice
  }
  is_subscribed
  upgradable
  downgradable
  display_order
  display_type
  metadata
  company_id
  getInTouch
  additionalDescription
  entitlements {
    ...MapleEntitlement
  }
}
    ${MaplePriceFragmentDoc}
${MapleEntitlementFragmentDoc}`;
export const MapleSubscriptionFragmentDoc = gql`
    fragment MapleSubscription on MapleBillingSubscriptionObj {
  id
  status
  start_date
  num_licenses
  productDetails {
    name
    description
  }
  computed_entitlements {
    ...MapleEntitlement
  }
}
    ${MapleEntitlementFragmentDoc}`;
export const PaymentMethodFragmentDoc = gql`
    fragment PaymentMethod on StripePaymentMethod {
  id
  cardBrand
  cardLast4
}
    `;
export const PriceFragmentDoc = gql`
    fragment Price on StripePriceObj {
  id
  amount
  interval
  tiers {
    flatAmount
    upTo
  }
}
    `;
export const PlanFragmentDoc = gql`
    fragment Plan on StripeProductObj {
  id
  name
  description
  prices {
    ...Price
  }
  isSubscribed
  upgradable
  downgradable
  order
  isVisible
  displayType
}
    ${PriceFragmentDoc}`;
export const SubscriptionFragmentDoc = gql`
    fragment Subscription on StripeSubscriptionObj {
  id
  status
  quantity
  products {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;
export const CommentFragmentDoc = gql`
    fragment Comment on CommentObj {
  id
  text
  json
  parentId
  parentCommentId
  mentionedUsersIds
  createdAt
  updatedAt
  author {
    id
    name
    email
  }
  saved @client
}
    `;
export const CompanyRssFeedUrlFragmentDoc = gql`
    fragment CompanyRssFeedUrl on RssFeedUrlObj {
  key
  pageUrl
}
    `;
export const CompanyInfoFragmentDoc = gql`
    fragment CompanyInfo on CompanyObj {
  id
  domain
  location
  city
  state
  country
  type
  raised
  employees
  estimatedAnnualRevenue
  twitter
  linkedin
  rssFeed {
    ...CompanyRssFeedUrl
  }
}
    ${CompanyRssFeedUrlFragmentDoc}`;
export const CompanyTalkingPointFragmentDoc = gql`
    fragment CompanyTalkingPoint on TalkingPoints {
  title
  text
  placeholder
}
    `;
export const CompanyScreenshotFragmentDoc = gql`
    fragment CompanyScreenshot on Screenshots {
  key
  pageUrl
}
    `;
export const CompanyAttachmentFilesFragmentDoc = gql`
    fragment CompanyAttachmentFiles on AttachmentsFileObj {
  name
  format
  size
  url
}
    `;
export const CompanyAttachmentsFragmentDoc = gql`
    fragment CompanyAttachments on AttachmentsObj {
  content
  userAttachments {
    ...CompanyAttachmentFiles
  }
}
    ${CompanyAttachmentFilesFragmentDoc}`;
export const CompanyFragmentDoc = gql`
    fragment Company on CompanyObj {
  ...CompanyInfo
  id
  name
  legalName
  description
  logo
  messagingSummary
  tags {
    ...Tag
  }
  talkingPoints {
    ...CompanyTalkingPoint
  }
  battlecardScreenshots {
    ...CompanyScreenshot
  }
  publicPageConfig {
    live
    viewsCount
  }
  attachments {
    ...CompanyAttachments
  }
}
    ${CompanyInfoFragmentDoc}
${TagFragmentDoc}
${CompanyTalkingPointFragmentDoc}
${CompanyScreenshotFragmentDoc}
${CompanyAttachmentsFragmentDoc}`;
export const CompanyTagGroupPreviewFragmentDoc = gql`
    fragment CompanyTagGroupPreview on CompanyTagGroup {
  id
  count
  label
  color
  type
}
    `;
export const ExportBattlecardConfigurationFragmentDoc = gql`
    fragment ExportBattlecardConfiguration on ExportBattlecardsConfigurationObj {
  crm
  status
}
    `;
export const GrowthToolCompanyFragmentDoc = gql`
    fragment GrowthToolCompany on ClearbitCompanyObj {
  id
  name
  description
  legalName
  domain
  tags
  logo
  type
  location
  metrics {
    employees
    raised
    annualRevenue
  }
  facebook {
    handle
  }
  linkedin {
    handle
  }
  twitter {
    handle
  }
  geo {
    country
    city
    state
  }
}
    `;
export const ScreenshotFragmentDoc = gql`
    fragment Screenshot on ScreenshotsObj {
  key
  pageUrl
  screenshotUrls {
    screenshotUrl
    createdAt
  }
  createdAt
  updatedAt
}
    `;
export const DealNotesFragmentDoc = gql`
    fragment DealNotes on DealNotesObj {
  id
  name
  lostReason
  lostNotes
  closeDate
  isWon
  isClosed
}
    `;
export const KeywordResultsFragmentDoc = gql`
    fragment KeywordResults on KeywordResultsOutput {
  search_term
  visits
  volume
  position
  cpc
  url
}
    `;
export const KeywordsVisitFragmentDoc = gql`
    fragment KeywordsVisit on SimilarWebOutput {
  organicKeywordVisits
  paidKeywordVisits
}
    `;
export const WinLossTableFragmentDoc = gql`
    fragment WinLossTable on WinLossTableObj {
  dealId
  status
  amount
  closedDate
  owner {
    id
    name
    email
  }
  account {
    id
    name
    website
    logo
  }
  lostReason
  dealNotes
  competitor {
    id
    name
    logo
  }
}
    `;
export const WinlossTakeawaysSummaryFragmentDoc = gql`
    fragment WinlossTakeawaysSummary on WinlossTakeawaysSummaryObj {
  winningPoints
  loosingPoints
  segmentInsights
  recommendations
}
    `;
export const CopysmithAiContentFragmentDoc = gql`
    fragment CopysmithAIContent on CopysmithAIContentObj {
  id
  contentType
  stringContent
  arrayContent
  objectContent
}
    `;
export const CopysmithAiFavoriteFragmentDoc = gql`
    fragment CopysmithAIFavorite on CopysmithAIFavoriteObj {
  id
  organizationId
  templateIds
}
    `;
export const CopysmithAiPromptFragmentDoc = gql`
    fragment CopysmithAIPrompt on CopysmithAIPromptObj {
  key
  promptType
  label
  description
  placeholder
  min
  max
  required
}
    `;
export const CopysmithAiTemplateFragmentDoc = gql`
    fragment CopysmithAITemplate on CopysmithAITemplateObj {
  id
  templateType
  groupType
  prompts {
    key
    promptType
    label
    description
    placeholder
    min
    max
    required
  }
}
    `;
export const PaginatedAssetPreviewFragmentDoc = gql`
    fragment PaginatedAssetPreview on AssetObj {
  id
  name
  type
  userInput
}
    `;
export const PaginatedLaunchesPreviewFragmentDoc = gql`
    fragment PaginatedLaunchesPreview on LaunchObj {
  id
  name
  launchTier
}
    `;
export const CopywriteV2ContentFragmentDoc = gql`
    fragment CopywriteV2Content on CopywriteV2ContentObj {
  templateType
  content
  additionalPrompt
  finalPrompt
}
    `;
export const CopywriteV2FavoriteFragmentDoc = gql`
    fragment CopywriteV2Favorite on CopywriteV2FavoriteObj {
  id
  organizationId
  templateIds
}
    `;
export const CopywriteV2TemplateFragmentDoc = gql`
    fragment CopywriteV2Template on CopywriteV2TemplateObj {
  id
  groupType
  templateType
}
    `;
export const BattlecardPreviewFragmentDoc = gql`
    fragment BattlecardPreview on CompanyObj {
  id
  name
}
    `;
export const CrmIntegrationFragmentDoc = gql`
    fragment CrmIntegration on CrmIntegrationObj {
  id
  crm
  status
  productGaps {
    startDate
    endDate
    createIdeasAutomatically
    crmObject {
      id
      title
      type
    }
    crmObjectProperty {
      id
      title
    }
    crmCustomObjectProperty {
      id
      title
    }
    filters {
      owner {
        id
        name
        email
      }
      dealStage
    }
  }
  winLoss {
    competitorObject {
      id
      title
      type
    }
    lostReasonObject {
      id
      title
      type
    }
    dealNotesObject {
      id
      title
      type
    }
    competitorField {
      id
      title
    }
    lostReasonFields {
      id
      title
    }
    dealNotesFields {
      id
      title
    }
  }
  exportBattlecards {
    objectName
    battlecardIds
  }
}
    `;
export const CrmIntegrationObjectFragmentDoc = gql`
    fragment CrmIntegrationObject on CrmIntegrationObjectObj {
  id
  title
  type
}
    `;
export const DealCompanyFragmentDoc = gql`
    fragment DealCompany on DealCompanyObj {
  id
  logo
  name
}
    `;
export const DealOwnerFragmentDoc = gql`
    fragment DealOwner on DealOwnerObj {
  id
  name
  email
}
    `;
export const PositioningModuleContentFragmentDoc = gql`
    fragment PositioningModuleContent on UserInputPositioningObj {
  id
  alternatives
  attributes
  value
  audience
  problem
  category
  notes
}
    `;
export const FeedbackCustomColumnFragmentDoc = gql`
    fragment FeedbackCustomColumn on FeedbackCustomColumnDto {
  id
  name
  type
}
    `;
export const FeedbackBoardWithCustomColumnsFragmentDoc = gql`
    fragment FeedbackBoardWithCustomColumns on FeedbackBoardDto {
  id
  customColumns {
    ...FeedbackCustomColumn
  }
}
    ${FeedbackCustomColumnFragmentDoc}`;
export const FeedbackBoardInfoFragmentDoc = gql`
    fragment FeedbackBoardInfo on FeedbackBoardDto {
  id
  name
  heading
  subHeading
  internal
  notifyingUserIds
  sendNotification
  emailDomain
  password
  ...FeedbackBoardWithCustomColumns
}
    ${FeedbackBoardWithCustomColumnsFragmentDoc}`;
export const FeedbackBoardOptionFragmentDoc = gql`
    fragment FeedbackBoardOption on FeedbackBoardDto {
  id
  name
}
    `;
export const FeedbackPostCommentFragmentDoc = gql`
    fragment FeedbackPostComment on FeedbackCommentDto {
  id
  text
  postId
  replyTo
  internal
  updatedAt
  createdAt
  author {
    id
    name
    email
    avatarSrc
    admin
  }
}
    `;
export const FeedbackPostUserFragmentDoc = gql`
    fragment FeedbackPostUser on FeedbackUserDto {
  id
  name
  email
  admin
  avatarSrc
  createdAt
}
    `;
export const DealFragmentDoc = gql`
    fragment Deal on DealObj {
  id
  name
  amount
  stage
  closeDate
  crm
  color @client
  company {
    id
    name
    logo
  }
  owner {
    id
    name
    email
  }
}
    `;
export const CdpAccountFragmentDoc = gql`
    fragment CDPAccount on CDPAccountObj {
  id
  accountId
  name
  domain
  description
  logo
  type
  industry
  employees
  region
  ownerId
  annualRevenue
  accountValue
  isEnriched
  manual
  source
  createdAt
  updatedAt
}
    `;
export const InsightMenuOptionFragmentDoc = gql`
    fragment InsightMenuOption on InsightObj {
  id
  name
  user
  title @client
}
    `;
export const ProductBoardItemMenuOptionFragmentDoc = gql`
    fragment ProductBoardItemMenuOption on ProductBoardItemObj {
  id
  title
}
    `;
export const FeedbackPostCustomColumnFragmentDoc = gql`
    fragment FeedbackPostCustomColumn on FeedbackPostCustomColumnDto {
  customColumnId
  value
}
    `;
export const FeedbackPostWithCustomColumnsFragmentDoc = gql`
    fragment FeedbackPostWithCustomColumns on FeedbackPostDto {
  id
  customColumns {
    ...FeedbackPostCustomColumn
  }
}
    ${FeedbackPostCustomColumnFragmentDoc}`;
export const FeedbackPostTableRowFragmentDoc = gql`
    fragment FeedbackPostTableRow on FeedbackPostDto {
  id
  title
  description
  internal
  boardId
  status
  revenueImpact
  source
  upvotedByUser
  upvotes
  importance
  createdAt
  updatedAt
  assignee {
    ...UserDetails
  }
  upvoters {
    ...FeedbackPostUser
  }
  tags {
    ...Tag
  }
  productLineTags {
    ...Tag
  }
  deals {
    ...Deal
  }
  accounts {
    ...CDPAccount
  }
  insights {
    ...InsightMenuOption
  }
  productBoardItems {
    ...ProductBoardItemMenuOption
  }
  ...FeedbackPostWithCustomColumns
}
    ${UserDetailsFragmentDoc}
${FeedbackPostUserFragmentDoc}
${TagFragmentDoc}
${DealFragmentDoc}
${CdpAccountFragmentDoc}
${InsightMenuOptionFragmentDoc}
${ProductBoardItemMenuOptionFragmentDoc}
${FeedbackPostWithCustomColumnsFragmentDoc}`;
export const ReleaseNotesSubscriberFragmentDoc = gql`
    fragment ReleaseNotesSubscriber on ReleaseNotesSubscriberObj {
  email
}
    `;
export const UserReviewFragmentDoc = gql`
    fragment UserReview on G2UserReviewsOutput {
  answers
  segment
  companyName
  industry
  score
  helpful
  reviewSource
  userName
  role
  submittedDate
  publishedDate
}
    `;
export const ChannelTemplateFragmentDoc = gql`
    fragment ChannelTemplate on ChannelTemplateObj {
  id
  name
  recommended
  type
}
    `;
export const InsightPartTextFragmentDoc = gql`
    fragment InsightPartText on InsightPartObj {
  authorName
  text
}
    `;
export const CdpAccountDisplayFragmentDoc = gql`
    fragment CDPAccountDisplay on CDPAccountObj {
  id
  accountId
  name
  domain
  logo
}
    `;
export const PersonaMenuOptionFragmentDoc = gql`
    fragment PersonaMenuOption on PersonaDto {
  id
  name
  avatar
}
    `;
export const LaunchMenuOptionFragmentDoc = gql`
    fragment LaunchMenuOption on LaunchObj {
  id
  name
  launchTier
}
    `;
export const CompanyMenuOptionFragmentDoc = gql`
    fragment CompanyMenuOption on CompanyObj {
  id
  name
  logo
}
    `;
export const FeedbackPostMenuOptionFragmentDoc = gql`
    fragment FeedbackPostMenuOption on FeedbackPostDto {
  id
  title
  internal
  upvoters {
    id
  }
}
    `;
export const InsightConnectionsMenuFragmentDoc = gql`
    fragment InsightConnectionsMenu on InsightObj {
  personas {
    ...PersonaMenuOption
  }
  launches {
    ...LaunchMenuOption
  }
  competitors {
    ...CompanyMenuOption
  }
  feedbackPosts {
    ...FeedbackPostMenuOption
  }
  productBoardItems {
    ...ProductBoardItemMenuOption
  }
}
    ${PersonaMenuOptionFragmentDoc}
${LaunchMenuOptionFragmentDoc}
${CompanyMenuOptionFragmentDoc}
${FeedbackPostMenuOptionFragmentDoc}
${ProductBoardItemMenuOptionFragmentDoc}`;
export const InsightFragmentDoc = gql`
    fragment Insight on InsightObj {
  id
  name
  user
  title @client
  importedContent @client
  isImportedFromIntegration @client
  isEditable @client
  content
  registeredOn
  company
  createdBy
  source
  insightIntegrationItemId
  summary
  createdAt
  updatedAt
  parts {
    ...InsightPartText
  }
  tags {
    ...Tag
  }
  productLineTags {
    ...Tag
  }
  account {
    ...CDPAccountDisplay
  }
  contact {
    id
    name
    email
  }
  assignee {
    id
    name
    email
  }
  metadata {
    summaryName
    conversationType
    customerName
    customerType
    competitorsReferenced
    customerCompany
    customerJobTitle
  }
  ...InsightConnectionsMenu
}
    ${InsightPartTextFragmentDoc}
${TagFragmentDoc}
${CdpAccountDisplayFragmentDoc}
${InsightConnectionsMenuFragmentDoc}`;
export const InsightSummaryGeneratedItemFragmentDoc = gql`
    fragment InsightSummaryGeneratedItem on InsightsSummaryGeneratedItemObj {
  id
  text
  description
  score
  insights {
    ...Insight
  }
  createdAt
  updatedAt
}
    ${InsightFragmentDoc}`;
export const InsightsProductSummaryFragmentDoc = gql`
    fragment InsightsProductSummary on InsightsProductSummaryObj {
  id
  overallSentiment
  featureRequests {
    ...InsightSummaryGeneratedItem
  }
  strengths {
    ...InsightSummaryGeneratedItem
  }
  weaknesses {
    ...InsightSummaryGeneratedItem
  }
  insights {
    ...Insight
  }
  saved
  status
}
    ${InsightSummaryGeneratedItemFragmentDoc}
${InsightFragmentDoc}`;
export const InsightsMarketingSummaryFragmentDoc = gql`
    fragment InsightsMarketingSummary on InsightsMarketingSummaryObj {
  id
  valueDrivers {
    ...InsightSummaryGeneratedItem
  }
  solvedProblems {
    ...InsightSummaryGeneratedItem
  }
  commonTerms {
    ...InsightSummaryGeneratedItem
  }
  confusionPoints {
    ...InsightSummaryGeneratedItem
  }
  insights {
    ...Insight
  }
  saved
  status
}
    ${InsightSummaryGeneratedItemFragmentDoc}
${InsightFragmentDoc}`;
export const InsightSavedSummaryFragmentDoc = gql`
    fragment InsightSavedSummary on InsightsSavedSummaryObj {
  id
  name
  updatedAt
  createdAt
  summary {
    ... on InsightsProductSummaryObj {
      ...InsightsProductSummary
    }
    ... on InsightsMarketingSummaryObj {
      ...InsightsMarketingSummary
    }
  }
  savedBy {
    ...UserDetails
  }
  tags {
    ...Tag
  }
}
    ${InsightsProductSummaryFragmentDoc}
${InsightsMarketingSummaryFragmentDoc}
${UserDetailsFragmentDoc}
${TagFragmentDoc}`;
export const IntegrationResourceFragmentDoc = gql`
    fragment IntegrationResource on IntegrationResourceObj {
  id
  name
  integrationId
  productName
}
    `;
export const IntegrationProjectFragmentDoc = gql`
    fragment IntegrationProject on IntegrationProjectObj {
  id
  name
  integrationId
  productName
  organizationId
  selected
  integrationResourceId
  externalProjectId
  fetchedAllTasks
  lastRefreshedOn
  tasksUpdatedOn
  isValidExternalProjectURL
  active
  tasksCount
}
    `;
export const IntegrationFragmentDoc = gql`
    fragment Integration on IntegrationObj {
  id
  productName
  fetchedAllResources
  resources {
    id
    ...IntegrationResource
  }
  selectedIntegrationProjects {
    ...IntegrationProject
  }
}
    ${IntegrationResourceFragmentDoc}
${IntegrationProjectFragmentDoc}`;
export const IntegrationSubTaskFragmentDoc = gql`
    fragment IntegrationSubTask on IntegrationTaskObj {
  id
  readableExternalId
  externalTaskId
  name
  description
  calculatedStatus
  status
  dueDate
  startDate
  integrationId
  integrationProjectId
  productName
  inWatchList
  externalUrl
  type
  assignedTo
  tags {
    name
    externalId
  }
}
    `;
export const IntegrationTaskFragmentDoc = gql`
    fragment IntegrationTask on IntegrationTaskObj {
  id
  readableExternalId
  externalTaskId
  name
  description
  calculatedStatus
  status
  dueDate
  startDate
  integrationId
  integrationProjectId
  productName
  inWatchList
  externalUrl
  type
  assignedTo
  tags {
    name
    externalId
  }
  subTasks(filter: $filter) {
    ...IntegrationSubTask
  }
}
    ${IntegrationSubTaskFragmentDoc}`;
export const MarketingIntegrationTaskFragmentDoc = gql`
    fragment MarketingIntegrationTask on IntegrationTaskObj {
  id
  readableExternalId
  name
  description
  status
  dueDate
  startDate
  integrationResourceId
  productName
}
    `;
export const ProductIntegrationTaskFragmentDoc = gql`
    fragment ProductIntegrationTask on IntegrationTaskObj {
  id
  readableExternalId
  externalUrl
  name
  description
  calculatedStatus
  status
  type
  assignedTo
  dueDate
  startDate
  integrationId
  productName
  inWatchList
  tags {
    name
    externalId
  }
  assignedTo
  subTasks(filter: $filter) {
    ...IntegrationSubTask
  }
}
    ${IntegrationSubTaskFragmentDoc}`;
export const SupportedIntegrationDataFragmentDoc = gql`
    fragment SupportedIntegrationData on SupportedIntegration {
  name
  displayName
  apiKeyInstructions
  exampleProjectURL
  logoUrl
  manualProjectSelectionSupported
  oAuthSupported
}
    `;
export const IntegrationCreatorFragmentDoc = gql`
    fragment IntegrationCreator on UserObj {
  id
  name
}
    `;
export const OrganizationSettingsIntegrationFragmentDoc = gql`
    fragment OrganizationSettingsIntegration on Integration {
  id
  productName
  name
  authorized
  needsToReintegrate
  creator {
    ...IntegrationCreator
  }
}
    ${IntegrationCreatorFragmentDoc}`;
export const ChannelsFragmentDoc = gql`
    fragment Channels on ChannelObj {
  id
  name
}
    `;
export const LaunchTypeOptionFragmentDoc = gql`
    fragment LaunchTypeOption on LaunchTypeObj {
  id
  name
  createdBy
  description @client
}
    `;
export const LaunchTypeLabelFragmentDoc = gql`
    fragment LaunchTypeLabel on LaunchTypeObj {
  id
  name
}
    `;
export const LaunchCreationTemplateFragmentDoc = gql`
    fragment LaunchCreationTemplate on TemplateObj {
  id
  name
  description
  launchTier
  launchTierDetails {
    launchTier
  }
  launchType {
    ...LaunchTypeLabel
  }
}
    ${LaunchTypeLabelFragmentDoc}`;
export const LaunchCreationPreferenceFragmentDoc = gql`
    fragment LaunchCreationPreference on CopilotLaunchTypePreferenceObj {
  launchType {
    ...LaunchTypeOption
  }
  defaultLaunchTier
  templates {
    ...LaunchCreationTemplate
  }
}
    ${LaunchTypeOptionFragmentDoc}
${LaunchCreationTemplateFragmentDoc}`;
export const LaunchModuleInfoFragmentDoc = gql`
    fragment LaunchModuleInfo on LaunchModuleObj {
  id
  name
  editor
  approvalStatus
  dueDate
  canGenerateWithAI
  hint
  placeholder
  lockingDetails {
    locked
    lockedByUserId
  }
}
    `;
export const LaunchModuleUpdateInfoFragmentDoc = gql`
    fragment LaunchModuleUpdateInfo on LaunchModuleObj {
  lastEditDetails {
    timestamp
  }
  lastEditBy {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export const WysiwygModuleUserInputFragmentDoc = gql`
    fragment WysiwygModuleUserInput on UserInputObj {
  WYSIWYG_EDITOR
}
    `;
export const BudgetModuleContentFragmentDoc = gql`
    fragment BudgetModuleContent on UserInputBudgetObj {
  id
  allocationNotes
  budget {
    id
    name
    value
  }
}
    `;
export const BudgetModuleUserInputFragmentDoc = gql`
    fragment BudgetModuleUserInput on UserInputObj {
  BUDGET_EDITOR {
    ...BudgetModuleContent
  }
}
    ${BudgetModuleContentFragmentDoc}`;
export const KpiModuleContentFragmentDoc = gql`
    fragment KpiModuleContent on UserInputKPIObj {
  id
  metric
  format
  target
  actual
}
    `;
export const KpiModuleUserInputFragmentDoc = gql`
    fragment KPIModuleUserInput on UserInputObj {
  KPI_EDITOR {
    ...KpiModuleContent
  }
}
    ${KpiModuleContentFragmentDoc}`;
export const LaunchTeamModuleContentFragmentDoc = gql`
    fragment LaunchTeamModuleContent on UserInputLaunchTeamObj {
  id
  name
  email
  role
}
    `;
export const LaunchTeamModuleUserInputFragmentDoc = gql`
    fragment LaunchTeamModuleUserInput on UserInputObj {
  LAUNCHTEAM_EDITOR {
    ...LaunchTeamModuleContent
  }
}
    ${LaunchTeamModuleContentFragmentDoc}`;
export const PositioningNewModuleContentFragmentDoc = gql`
    fragment PositioningNewModuleContent on UserInputPositioningNewObj {
  title
  text
  placeholder
}
    `;
export const PositioningModuleUserInputNewFragmentDoc = gql`
    fragment PositioningModuleUserInputNew on UserInputObj {
  POSITIONING_EDITOR_NEW {
    ...PositioningNewModuleContent
  }
}
    ${PositioningNewModuleContentFragmentDoc}`;
export const UserInputFragmentDoc = gql`
    fragment UserInput on UserInputObj {
  id
  updatedAt
  ...WysiwygModuleUserInput
  ...BudgetModuleUserInput
  ...KPIModuleUserInput
  ...LaunchTeamModuleUserInput
  ...PositioningModuleUserInputNew
  ...CopyAndAssetsModuleUserInput
}
    ${WysiwygModuleUserInputFragmentDoc}
${BudgetModuleUserInputFragmentDoc}
${KpiModuleUserInputFragmentDoc}
${LaunchTeamModuleUserInputFragmentDoc}
${PositioningModuleUserInputNewFragmentDoc}
${CopyAndAssetsModuleUserInputFragmentDoc}`;
export const ModuleForImportFragmentDoc = gql`
    fragment ModuleForImport on LaunchModuleObj {
  id
  name
  isVisible
  editor
  userInput {
    ...UserInput
  }
}
    ${UserInputFragmentDoc}`;
export const LaunchInfoFragmentDoc = gql`
    fragment LaunchInfo on LaunchObj {
  id
  name
  description
  budget
  strategicApproach
  launchReadiness
  readinessNote
  stageId
  launchDate
  launchTier
  ownerId
  supportsCopilot
  launchType {
    ...LaunchTypeLabel
  }
}
    ${LaunchTypeLabelFragmentDoc}`;
export const LaunchApproversFragmentDoc = gql`
    fragment LaunchApprovers on LaunchApproversObj {
  userId
  required
  approvalRequestSent
  hasApproved
  approvedAt
  userDetails {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export const LaunchPhaseFragmentDoc = gql`
    fragment LaunchPhase on LaunchPhaseObj {
  id
  name
  status
  approvalRequestSent
  isActive
  startDate
  endDate
  notes
  approvers {
    ...LaunchApprovers
  }
}
    ${LaunchApproversFragmentDoc}`;
export const LaunchWithPhaseFragmentDoc = gql`
    fragment LaunchWithPhase on LaunchObj {
  ...LaunchInfo
  phases {
    ...LaunchPhase
  }
}
    ${LaunchInfoFragmentDoc}
${LaunchPhaseFragmentDoc}`;
export const DefaultApproversFragmentDoc = gql`
    fragment DefaultApprovers on DefaultApproversObj {
  userId
  required
  userDetails {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export const OrganizationPhaseFragmentDoc = gql`
    fragment OrganizationPhase on PhaseObj {
  id
  name
  launchTypeId
  launchTier
  daysAfterLaunch
  durationInDays
  defaultApprovers {
    ...DefaultApprovers
  }
}
    ${DefaultApproversFragmentDoc}`;
export const MilestoneFragmentDoc = gql`
    fragment Milestone on MilestoneObj {
  id
  name
  startDate
  endDate
  description
  type
}
    `;
export const MilestonesGtmTimelineFragmentDoc = gql`
    fragment MilestonesGtmTimeline on GtmTimelineObj {
  launchId
  milestones {
    ...Milestone
  }
}
    ${MilestoneFragmentDoc}`;
export const ChannelTimeframeFragmentDoc = gql`
    fragment ChannelTimeframe on ChannelTimeframeObj {
  id
  name
  budget
  description
  startDate
  endDate
}
    `;
export const ChannelFragmentDoc = gql`
    fragment Channel on ChannelObj {
  id
  channelTemplateId
  name
  description
  type
  logoSrc
  timeframes {
    ...ChannelTimeframe
  }
}
    ${ChannelTimeframeFragmentDoc}`;
export const LaunchWithUsersFragmentDoc = gql`
    fragment LaunchWithUsers on LaunchObj {
  id
  users {
    userId
    userDetails {
      id
      name
      email
    }
    modules {
      role
    }
  }
}
    `;
export const LaunchWithMilestonesAndChannelsFragmentDoc = gql`
    fragment LaunchWithMilestonesAndChannels on LaunchObj {
  id
  name
  gtmTimeline {
    ...MilestonesGtmTimeline
    channels {
      ...Channel
    }
  }
  phases {
    ...LaunchPhase
  }
  ...LaunchWithUsers
}
    ${MilestonesGtmTimelineFragmentDoc}
${ChannelFragmentDoc}
${LaunchPhaseFragmentDoc}
${LaunchWithUsersFragmentDoc}`;
export const CalendarSceneLaunchFragmentDoc = gql`
    fragment CalendarSceneLaunch on LaunchObj {
  id
  name
  description
  launchDate
  launchTier
  launchType {
    ...LaunchTypeLabel
  }
  ...LaunchWithMilestonesAndChannels
}
    ${LaunchTypeLabelFragmentDoc}
${LaunchWithMilestonesAndChannelsFragmentDoc}`;
export const LaunchConnectionFragmentDoc = gql`
    fragment LaunchConnection on LaunchObj {
  id
  name
}
    `;
export const LaunchModuleContentFragmentDoc = gql`
    fragment LaunchModuleContent on LaunchModuleContentObj {
  id
  name
  contentHTML
}
    `;
export const LaunchSectionContentFragmentDoc = gql`
    fragment LaunchSectionContent on LaunchSectionContentObj {
  id
  name
  modules {
    ...LaunchModuleContent
  }
}
    ${LaunchModuleContentFragmentDoc}`;
export const LaunchAssetContentFragmentDoc = gql`
    fragment LaunchAssetContent on LaunchAssetContentObj {
  id
  name
  editor
  contentHTML
}
    `;
export const LaunchContentFragmentDoc = gql`
    fragment LaunchContent on LaunchContentObj {
  id
  name
  description
  launchProgressContentHTML
  measurementsContentHTML
  gtmTimelineContentHTML
  launchDate
  sections {
    ...LaunchSectionContent
  }
  assets {
    ...LaunchAssetContent
  }
}
    ${LaunchSectionContentFragmentDoc}
${LaunchAssetContentFragmentDoc}`;
export const LaunchContentForExportFragmentDoc = gql`
    fragment LaunchContentForExport on LaunchContentObj {
  id
  name
  sections {
    id
    name
    modules {
      id
      name
      editor
      contentHTML
    }
  }
}
    `;
export const LaunchForImportModuleFragmentDoc = gql`
    fragment LaunchForImportModule on LaunchObj {
  id
  name
  launchDate
}
    `;
export const LaunchIdAndNameFragmentDoc = gql`
    fragment LaunchIdAndName on LaunchObj {
  id
  name
}
    `;
export const ProductIntegrationTasksStatusFragmentDoc = gql`
    fragment ProductIntegrationTasksStatus on IntegrationTasksStatusObj {
  status
  progressPercentage
  totalCompletedSubTasks
  totalSubTasks
}
    `;
export const TasksProgressFragmentDoc = gql`
    fragment TasksProgress on TasksProgressObj {
  notStartedCount
  inProgressCount
  inReviewCount
  completedCount
  totalCount
  progressPercentage
  canceledCount
  delayedCount
  notStartedPercentage @client
  inProgressPercentage @client
  inReviewPercentage @client
  completedPercentage @client
  canceledPercentage @client
  delayedPercentage @client
}
    `;
export const ModulesApprovalStatusProgressFragmentDoc = gql`
    fragment ModulesApprovalStatusProgress on ModulesApprovalStatusProgressObj {
  notRequestedCount
  readyToRequestCount
  approvingCount
  approvedCount
  totalCount
  progressPercentage
}
    `;
export const LaunchProgressFragmentDoc = gql`
    fragment LaunchProgress on LaunchProgressObj {
  launchId
  launchReadiness
  launchCountdown
  productProgress {
    ...ProductIntegrationTasksStatus
  }
  tasksProgress {
    ...TasksProgress
  }
  assetsProgress {
    ...ModulesApprovalStatusProgress
  }
}
    ${ProductIntegrationTasksStatusFragmentDoc}
${TasksProgressFragmentDoc}
${ModulesApprovalStatusProgressFragmentDoc}`;
export const ModuleEditorContentFragmentDoc = gql`
    fragment ModuleEditorContent on LaunchModuleObj {
  id
  editor
  userInput {
    ...UserInput
  }
}
    ${UserInputFragmentDoc}`;
export const LaunchModuleFragmentDoc = gql`
    fragment LaunchModule on LaunchModuleObj {
  id
  name
  dueDate
  approvalStatus
  editor
  placeholder
  hint
  templateModuleId
  lockingDetails {
    locked
    lockedByUserId
  }
  ...ModuleEditorContent
}
    ${ModuleEditorContentFragmentDoc}`;
export const LaunchSectionFragmentDoc = gql`
    fragment LaunchSection on LaunchSectionObj {
  id
  name
  hideModules
  launchModuleIds
  launchModules {
    ...LaunchModule
  }
}
    ${LaunchModuleFragmentDoc}`;
export const LaunchUserModuleFragmentDoc = gql`
    fragment LaunchUserModule on UserModuleRoleObj {
  launchModuleId
  role
  hasApproved
  saved @client
}
    `;
export const LaunchUserFragmentDoc = gql`
    fragment LaunchUser on UserWithModulesObj {
  userId
  userDetails {
    ...UserDetails
  }
  modules {
    ...LaunchUserModule
  }
  saved @client
}
    ${UserDetailsFragmentDoc}
${LaunchUserModuleFragmentDoc}`;
export const LaunchLayoutFragmentDoc = gql`
    fragment LaunchLayout on LaunchObj {
  id
  name
  launchSections {
    ...LaunchSection
  }
  owner {
    ...UserDetails
  }
  users {
    ...LaunchUser
  }
  modulesLaunchSections @client {
    ...LaunchSection
  }
  launchModules @client {
    ...LaunchModule
  }
}
    ${LaunchSectionFragmentDoc}
${UserDetailsFragmentDoc}
${LaunchUserFragmentDoc}
${LaunchModuleFragmentDoc}`;
export const LaunchProductTasksDataFragmentDoc = gql`
    fragment LaunchProductTasksData on LaunchObj {
  id
  productIntegrationTaskIds
  productIntegrationSubTaskIds
  launchDate
}
    `;
export const LaunchCopilotOptionsFragmentDoc = gql`
    fragment LaunchCopilotOptions on LaunchObj {
  id
  copilotPreferences {
    generatedTasks
    preferBuildTasks
    generatedAssets
    preferBuildAssets
    generatedChannels
    preferBuildChannels
    lastOnBoardingStep
  }
}
    `;
export const LaunchViewersFragmentDoc = gql`
    fragment LaunchViewers on LaunchObj {
  viewers {
    viewer {
      ...UserDetails
    }
    viewDate
  }
}
    ${UserDetailsFragmentDoc}`;
export const LaunchFragmentDoc = gql`
    fragment Launch on LaunchObj {
  ...LaunchInfo
  ...LaunchProductTasksData
  ...LaunchCopilotOptions
  ...LaunchViewers
  owner {
    ...UserDetails
  }
  users {
    ...LaunchUser
  }
  tags {
    ...Tag
  }
  phases {
    ...LaunchPhase
  }
  launchSections {
    ...LaunchSection
  }
  modulesLaunchSections @client {
    ...LaunchSection
  }
  launchModules @client {
    ...LaunchModule
  }
}
    ${LaunchInfoFragmentDoc}
${LaunchProductTasksDataFragmentDoc}
${LaunchCopilotOptionsFragmentDoc}
${LaunchViewersFragmentDoc}
${UserDetailsFragmentDoc}
${LaunchUserFragmentDoc}
${TagFragmentDoc}
${LaunchPhaseFragmentDoc}
${LaunchSectionFragmentDoc}
${LaunchModuleFragmentDoc}`;
export const LaunchDetailsForChannelsFragmentDoc = gql`
    fragment LaunchDetailsForChannels on LaunchObj {
  id
  strategicApproach
  budget
}
    `;
export const CompanyPreviewFragmentDoc = gql`
    fragment CompanyPreview on CompanyObj {
  id
  name
  legalName
  logo
  launchIds
  tags {
    id
    label
    type
    color
  }
}
    `;
export const FeedbackPostFragmentDoc = gql`
    fragment FeedbackPost on FeedbackPostDto {
  id
  title
  description
  internal
  boardId
  status
  commentsCount
  revenueImpact
  upvotedByUser
  upvotes
  importance
  source
  createdAt
  updatedAt
  assignee {
    ...UserDetails
  }
  upvoters {
    ...FeedbackPostUser
  }
  author {
    ...FeedbackPostUser
  }
  tags {
    ...Tag
  }
  productLineTags {
    ...Tag
  }
  deals {
    ...Deal
  }
  accounts {
    ...CDPAccount
  }
  insights {
    ...InsightMenuOption
  }
  productBoardItems {
    ...ProductBoardItemMenuOption
  }
  ...FeedbackPostWithCustomColumns
}
    ${UserDetailsFragmentDoc}
${FeedbackPostUserFragmentDoc}
${TagFragmentDoc}
${DealFragmentDoc}
${CdpAccountFragmentDoc}
${InsightMenuOptionFragmentDoc}
${ProductBoardItemMenuOptionFragmentDoc}
${FeedbackPostWithCustomColumnsFragmentDoc}`;
export const PersonaDemographicsCategoryFragmentDoc = gql`
    fragment PersonaDemographicsCategory on PersonaDemographicsCategoryDto {
  id
  name
  value
  placeholder
  updatedAt
}
    `;
export const PersonaNoteFragmentDoc = gql`
    fragment PersonaNote on PersonaNoteDto {
  id
  title
  text
  placeholder
  updatedAt
}
    `;
export const PersonaFragmentDoc = gql`
    fragment Persona on PersonaDto {
  id
  name
  occupation
  avatar
  primary
  age
  launchesIds
  messagingLibraryIds
  demographics {
    ...PersonaDemographicsCategory
  }
  notes {
    ...PersonaNote
  }
  tags {
    ...Tag
  }
  updatedAt
}
    ${PersonaDemographicsCategoryFragmentDoc}
${PersonaNoteFragmentDoc}
${TagFragmentDoc}`;
export const ProductBoardItemPreviewFragmentDoc = gql`
    fragment ProductBoardItemPreview on ProductBoardItemObj {
  id
  title
}
    `;
export const LaunchConnectionsFragmentDoc = gql`
    fragment LaunchConnections on LaunchObj {
  competitors {
    ...CompanyPreview
  }
  feedbackPosts {
    ...FeedbackPost
  }
  insights {
    ...Insight
  }
  personas {
    ...Persona
  }
  productBoardItems {
    ...ProductBoardItemPreview
  }
}
    ${CompanyPreviewFragmentDoc}
${FeedbackPostFragmentDoc}
${InsightFragmentDoc}
${PersonaFragmentDoc}
${ProductBoardItemPreviewFragmentDoc}`;
export const LaunchQueryFragmentDoc = gql`
    fragment LaunchQuery on LaunchObj {
  ...LaunchLayout
  ...Launch
  ...LaunchDetailsForChannels
  ...LaunchConnections
}
    ${LaunchLayoutFragmentDoc}
${LaunchFragmentDoc}
${LaunchDetailsForChannelsFragmentDoc}
${LaunchConnectionsFragmentDoc}`;
export const LaunchWithMilestonesFragmentDoc = gql`
    fragment LaunchWithMilestones on LaunchObj {
  id
  name
  gtmTimeline {
    ...MilestonesGtmTimeline
  }
  ...LaunchWithUsers
}
    ${MilestonesGtmTimelineFragmentDoc}
${LaunchWithUsersFragmentDoc}`;
export const LaunchesNameAndDateFragmentDoc = gql`
    fragment LaunchesNameAndDate on LaunchObj {
  id
  name
  launchDate
}
    `;
export const LaunchesSceneLaunchFragmentDoc = gql`
    fragment LaunchesSceneLaunch on LaunchObj {
  id
  name
  description
  launchReadiness
  budget
  launchDate
  launchTier
  launchType {
    ...LaunchTypeLabel
  }
  tags {
    ...Tag
  }
  users {
    userId
    modules {
      launchModuleId
      role
    }
    userDetails {
      ...UserDetails
    }
  }
  isPrivate
  templateId
  stageId
  ownerId
  phases {
    name
    isActive
    status
  }
}
    ${LaunchTypeLabelFragmentDoc}
${TagFragmentDoc}
${UserDetailsFragmentDoc}`;
export const PublicLaunchPageUserInputFragmentDoc = gql`
    fragment PublicLaunchPageUserInput on UserInputObj {
  id
  updatedAt
  ...BudgetModuleUserInput
  ...KPIModuleUserInput
  ...LaunchTeamModuleUserInput
  ...PositioningModuleUserInputNew
  ...CopyAndAssetsModuleUserInput
  WYSIWYG_EDITOR
}
    ${BudgetModuleUserInputFragmentDoc}
${KpiModuleUserInputFragmentDoc}
${LaunchTeamModuleUserInputFragmentDoc}
${PositioningModuleUserInputNewFragmentDoc}
${CopyAndAssetsModuleUserInputFragmentDoc}`;
export const PublicLaunchPageModuleEditorContentFragmentDoc = gql`
    fragment PublicLaunchPageModuleEditorContent on LaunchModuleObj {
  id
  editor
  userInput {
    ...PublicLaunchPageUserInput
  }
}
    ${PublicLaunchPageUserInputFragmentDoc}`;
export const PublicLaunchPageLaunchModuleFragmentDoc = gql`
    fragment PublicLaunchPageLaunchModule on LaunchModuleObj {
  id
  name
  dueDate
  approvalStatus
  editor
  placeholder
  hint
  ...PublicLaunchPageModuleEditorContent
}
    ${PublicLaunchPageModuleEditorContentFragmentDoc}`;
export const PublicLaunchPageLaunchSectionFragmentDoc = gql`
    fragment PublicLaunchPageLaunchSection on LaunchSectionObj {
  id
  name
  hideModules
  launchModuleIds
  launchModules {
    ...PublicLaunchPageLaunchModule
  }
}
    ${PublicLaunchPageLaunchModuleFragmentDoc}`;
export const PublicLaunchPageLaunchFragmentDoc = gql`
    fragment PublicLaunchPageLaunch on LaunchObj {
  id
  name
  description
  launchDate
  launchTier
  stageId
  readinessNote
  phases {
    ...LaunchPhase
  }
  tags {
    ...Tag
  }
  launchSections {
    ...PublicLaunchPageLaunchSection
  }
  modulesLaunchSections @client {
    ...PublicLaunchPageLaunchSection
  }
  launchModules @client {
    ...PublicLaunchPageLaunchModule
  }
}
    ${LaunchPhaseFragmentDoc}
${TagFragmentDoc}
${PublicLaunchPageLaunchSectionFragmentDoc}
${PublicLaunchPageLaunchModuleFragmentDoc}`;
export const LaunchPublicPagesSettingsFragmentDoc = gql`
    fragment LaunchPublicPagesSettings on LaunchPublicPagesSettingsObj {
  launchPlan {
    live
    launchModules
  }
  copyAndAssets {
    live
    assetsModules
  }
  gtmTimeline {
    live
  }
  productStatus {
    live
  }
  tasks {
    live
  }
  customersResearch {
    live
  }
  competitiveIntelligence {
    live
  }
  missionControl {
    live
  }
  measurements {
    live
  }
}
    `;
export const LaunchPublicPageConfigFragmentDoc = gql`
    fragment LaunchPublicPageConfig on LaunchPublicPageConfigObj {
  live
  settings {
    ...LaunchPublicPagesSettings
  }
}
    ${LaunchPublicPagesSettingsFragmentDoc}`;
export const PublicLaunchPageLayoutLaunchFragmentDoc = gql`
    fragment PublicLaunchPageLayoutLaunch on LaunchObj {
  id
  name
  publicPageConfig {
    ...LaunchPublicPageConfig
  }
}
    ${LaunchPublicPageConfigFragmentDoc}`;
export const LaunchWithGtmTimelineFragmentDoc = gql`
    fragment LaunchWithGtmTimeline on LaunchObj {
  id
  name
  description
  launchDate
  gtmTimeline {
    launchId
    channels {
      ...Channel
    }
    milestones {
      ...Milestone
    }
  }
}
    ${ChannelFragmentDoc}
${MilestoneFragmentDoc}`;
export const MixpanelIntegrationFragmentDoc = gql`
    fragment MixpanelIntegration on MixpanelIntegrationObj {
  id
  ownerId
  organizationId
  projectId
  username
  events
}
    `;
export const NonUserFragmentDoc = gql`
    fragment NonUser on NonUserObj {
  id
  email
  avatarColor @client
}
    `;
export const DisplayMessageGroupUserFragmentDoc = gql`
    fragment DisplayMessageGroupUser on DisplayMessageGroupUserObj {
  id
  label
  avatarColor
}
    `;
export const MessageGroupRecipientsFragmentDoc = gql`
    fragment MessageGroupRecipients on MessageGroupRecipientsObj {
  usersData {
    ...UserDetails
  }
  nonUsersData {
    ...NonUser
  }
  displayUsers @client {
    ...DisplayMessageGroupUser
  }
}
    ${UserDetailsFragmentDoc}
${NonUserFragmentDoc}
${DisplayMessageGroupUserFragmentDoc}`;
export const MessageGroupFragmentDoc = gql`
    fragment MessageGroup on MessageGroupObj {
  id
  name
  ownerId
  createdAt
  userIds
  nonUserIds
  users {
    ...MessageGroupRecipients
  }
}
    ${MessageGroupRecipientsFragmentDoc}`;
export const MessageGroupParticipantFragmentDoc = gql`
    fragment MessageGroupParticipant on MessageGroupParticipantObj {
  id
  value
  type
}
    `;
export const AttachedLaunchFragmentDoc = gql`
    fragment AttachedLaunch on LaunchObj {
  id
  name
  launchTier
}
    `;
export const NextProductBoardReleaseFragmentDoc = gql`
    fragment NextProductBoardRelease on ProductBoardReleaseObj {
  id
  name
  endDate
}
    `;
export const ProductBoardReleaseThisMonthFragmentDoc = gql`
    fragment ProductBoardReleaseThisMonth on ProductBoardReleaseObj {
  id
  iconColor
  name
  percentComplete
  endDate
}
    `;
export const CompetitorCompanyNewsArticleFragmentDoc = gql`
    fragment CompetitorCompanyNewsArticle on CompetitorCompanyNewsArticleObj {
  id
  name
  description
  publishedDate
  companyDomain
  companyLogo
  companyName
  providerName
  sourceUrl
  imageUrl
  createdAt
  updatedAt
}
    `;
export const NotificationChannelFragmentDoc = gql`
    fragment NotificationChannel on NotificationChannelObj {
  id
  source
  organizationId
  scope
  isActive
  accessToken
  refreshToken
  accessTokenOwnerId
  validTill
  lastRefresedOn
}
    `;
export const KpiFragmentDoc = gql`
    fragment Kpi on KpiObj {
  id
  title
  dueDate
  format
  currentValue
  targetValue
  qualitativeStatus
  objectiveId
  createdAt
  launchId
  owner {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export const ObjectiveFragmentDoc = gql`
    fragment Objective on ObjectiveObj {
  id
  title
  dueDate
  roadmapId
  releaseId
  createdAt
  launchId
  type
  kpis {
    ...Kpi
  }
  assignee {
    ...UserDetails
  }
}
    ${KpiFragmentDoc}
${UserDetailsFragmentDoc}`;
export const OrganizationContentFragmentDoc = gql`
    fragment OrganizationContent on OrganizationObj {
  id
  logo
  slug
  name
  haveGtm
  peopleRange
  launchesPerYear
  companyType
  billingEmailId
  origin
  hasCreatedFirstLaunch
  appsumoPlanId
  hasPaidSubscription
  isUnderFreeTrial
  billingEmailId
  currentSubscriptionPlanName
  hasExpiredFreeTrial
  isDemo
  billingVersion
}
    `;
export const OrganizationAiSettingsFragmentDoc = gql`
    fragment OrganizationAISettings on AiSettingsObj {
  tone
  companyName
  companyWebsite
  companyDescription
  brandGuidelines
}
    `;
export const StageFragmentDoc = gql`
    fragment Stage on StageObj {
  name
  id
}
    `;
export const SubscriptionRestrictionsFragmentDoc = gql`
    fragment SubscriptionRestrictions on SubscriptionRestrictionsObj {
  numberOfEditorsAllowed
  researchHubAllowed
}
    `;
export const OrganizationUserInfoFragmentDoc = gql`
    fragment OrganizationUserInfo on UserInOrganizationObj {
  userId
  userDetails {
    id
    name
    email
    profileImage
    isEmailVerified
    jobTitle
    primaryOnboardingGoal
    theme
  }
  id @client
  name @client
  email @client
  profileImage @client
  isEmailVerified @client
  jobTitle @client
  primaryOnboardingGoal @client
  theme @client
  avatarColor @client
}
    `;
export const OrganizationUserFragmentDoc = gql`
    fragment OrganizationUser on UserInOrganizationObj {
  role
  userId
  inviteAccepted
  displayedBanners {
    ideas
    insights
    launches
    roadmap
    assets
    okrs
    releaseNotes
    tasks
    competitors
    personas
  }
  userDetails {
    ...UserDetails
  }
  ...OrganizationUserInfo
}
    ${UserDetailsFragmentDoc}
${OrganizationUserInfoFragmentDoc}`;
export const OrganizationFragmentDoc = gql`
    fragment Organization on OrganizationObj {
  ...OrganizationContent
  isActive
  billingEmailId
  isUnderFreeTrial
  hasExpiredFreeTrial
  hasPaidSubscription
  currentSubscriptionPlanName
  admin
  aiSettings {
    ...OrganizationAISettings
  }
  stages {
    ...Stage
  }
  subscriptionRestrictions {
    ...SubscriptionRestrictions
  }
  users {
    ...OrganizationUser
  }
  currentUser @client {
    ...OrganizationUser
  }
}
    ${OrganizationContentFragmentDoc}
${OrganizationAiSettingsFragmentDoc}
${StageFragmentDoc}
${SubscriptionRestrictionsFragmentDoc}
${OrganizationUserFragmentDoc}`;
export const OrganizationPreviewFragmentDoc = gql`
    fragment OrganizationPreview on OrganizationObj {
  id
  logo
  slug
  name
}
    `;
export const OrganizationExpirationFragmentDoc = gql`
    fragment OrganizationExpiration on OrganizationObj {
  id
  isUnderFreeTrial
  hasPaidSubscription
  currentSubscriptionPlanName
}
    `;
export const OrganizationGtmFragmentDoc = gql`
    fragment OrganizationGtm on OrganizationObj {
  id
  haveGtm
}
    `;
export const OrganizationPaginatedUsersFragmentDoc = gql`
    fragment OrganizationPaginatedUsers on UserInOrganizationObj {
  ...OrganizationUser
  canResendInvite
}
    ${OrganizationUserFragmentDoc}`;
export const OrganizationPaymentDataFragmentDoc = gql`
    fragment OrganizationPaymentData on OrganizationObj {
  id
  hasPaidSubscription
  isUnderFreeTrial
  billingEmailId
  currentSubscriptionPlanName
}
    `;
export const PublicLaunchPageOrganizationFragmentDoc = gql`
    fragment PublicLaunchPageOrganization on OrganizationObj {
  id
  name
  logo
  haveGtm
  stages {
    ...Stage
  }
  users {
    ...OrganizationUser
  }
}
    ${StageFragmentDoc}
${OrganizationUserFragmentDoc}`;
export const PublicOrganizationUserFragmentDoc = gql`
    fragment PublicOrganizationUser on PublicUserObj {
  id
  name
  profileImage
  jobTitle
  email @client
  isEmailVerified @client
  primaryOnboardingGoal @client
  theme @client
  avatarColor @client
}
    `;
export const PublicOrganizationFragmentDoc = gql`
    fragment PublicOrganization on PublicOrganizationObj {
  id
  name
  logo
  haveGtm
  stages {
    ...Stage
  }
  users {
    ...PublicOrganizationUser
  }
}
    ${StageFragmentDoc}
${PublicOrganizationUserFragmentDoc}`;
export const OrganizationInfoFragmentDoc = gql`
    fragment OrganizationInfo on OrganizationObj {
  id
  name
  logo
  haveGtm
  stages {
    ...Stage
  }
  users {
    ...OrganizationUserInfo
  }
}
    ${StageFragmentDoc}
${OrganizationUserInfoFragmentDoc}`;
export const SampleDataFlagFragmentDoc = gql`
    fragment SampleDataFlag on SampleDataFlagObj {
  sampleDataDeleted
  showSampleDataDeleteFlag
}
    `;
export const ProductBoardCustomColumnFragmentDoc = gql`
    fragment ProductBoardCustomColumn on ProductBoardCustomColumnDto {
  id
  name
  type
}
    `;
export const RevenueImpactDetailsFragmentDoc = gql`
    fragment RevenueImpactDetails on ProductBoardRevenueImpactDetailsObj {
  totalRevenueImpact
  wonDealsRevenueImpact
  lostDealsRevenueImpact
}
    `;
export const ProductBoardIndicatorsFragmentDoc = gql`
    fragment ProductBoardIndicators on ProductBoardRoadmapObj {
  id
  name
  revenueImpactDetails {
    ...RevenueImpactDetails
  }
  percentComplete
}
    ${RevenueImpactDetailsFragmentDoc}`;
export const ProductRoadmapKanbanPreviewItemFragmentDoc = gql`
    fragment ProductRoadmapKanbanPreviewItem on ProductBoardItemObj {
  id
  title
  id
  title
  status {
    id
    name
    iconColor
  }
  assignee {
    id
  }
  release {
    id
  }
  tags {
    id
  }
  startDate
  endDate
  revenueImpactDetails {
    ...RevenueImpactDetails
  }
}
    ${RevenueImpactDetailsFragmentDoc}`;
export const ProductRoadmapKanbanItemFragmentDoc = gql`
    fragment ProductRoadmapKanbanItem on ProductBoardItemObj {
  ...ProductRoadmapKanbanPreviewItem
  subItems {
    ...ProductRoadmapKanbanPreviewItem
    subItems {
      ...ProductRoadmapKanbanPreviewItem
      subItems {
        ...ProductRoadmapKanbanPreviewItem
        subItems {
          ...ProductRoadmapKanbanPreviewItem
          subItems {
            ...ProductRoadmapKanbanPreviewItem
          }
        }
      }
    }
  }
}
    ${ProductRoadmapKanbanPreviewItemFragmentDoc}`;
export const ProductBoardKanbanCellFragmentDoc = gql`
    fragment ProductBoardKanbanCell on ProductBoardKanbanCellObj {
  axisY {
    id
    key
    name
  }
  axisX {
    id
    key
    name
  }
  items {
    ...ProductRoadmapKanbanItem
  }
}
    ${ProductRoadmapKanbanItemFragmentDoc}`;
export const ProductBoardObjectiveFragmentDoc = gql`
    fragment ProductBoardObjective on ProductBoardObjectiveObj {
  id
  progress
  title
}
    `;
export const ProductBoardOkrProgressFragmentDoc = gql`
    fragment ProductBoardOkrProgress on ProductBoardOkrProgressObj {
  objectives {
    ...ProductBoardObjective
  }
  progress
}
    ${ProductBoardObjectiveFragmentDoc}`;
export const ProductBoardRoadmapForDepenciesFragmentDoc = gql`
    fragment ProductBoardRoadmapForDepencies on ProductBoardRoadmapObj {
  id
  name
}
    `;
export const ProductBoardRoadmapPreviewFragmentDoc = gql`
    fragment ProductBoardRoadmapPreview on ProductBoardRoadmapObj {
  id
  name
  productLineTag {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const ProductBoardItemRoadmapPreviewFragmentDoc = gql`
    fragment ProductBoardItemRoadmapPreview on ProductBoardRoadmapObj {
  id
  name
}
    `;
export const ProductBoardReleasePreviewFragmentDoc = gql`
    fragment ProductBoardReleasePreview on ProductBoardReleaseObj {
  id
  name
  iconColor
}
    `;
export const ProductBoardItemFactorFragmentDoc = gql`
    fragment ProductBoardItemFactor on ProductBoardItemFactorObj {
  factorId
  immutable
  value
}
    `;
export const ProductBoardStatusPreviewFragmentDoc = gql`
    fragment ProductBoardStatusPreview on ProductBoardStatusObj {
  id
  name
  iconColor
}
    `;
export const ProductBoardItemAssigneeFragmentDoc = gql`
    fragment ProductBoardItemAssignee on UserObj {
  id
  name
  email
  profileImage
  avatarColor @client
}
    `;
export const ProductBoardItemDealFragmentDoc = gql`
    fragment ProductBoardItemDeal on DealObj {
  id
  name
  amount
}
    `;
export const ProductBoardItemAccountFragmentDoc = gql`
    fragment ProductBoardItemAccount on CDPAccountObj {
  id
  name
  domain
}
    `;
export const ProductBoardItemDependencyFragmentDoc = gql`
    fragment ProductBoardItemDependency on ProductBoardItemObj {
  id
  title
  status {
    ...ProductBoardStatusPreview
  }
}
    ${ProductBoardStatusPreviewFragmentDoc}`;
export const RoadmapItemCustomColumnFragmentDoc = gql`
    fragment RoadmapItemCustomColumn on ProductBoardItemCustomColumnObj {
  customColumnId
  value
}
    `;
export const IntegrationTaskMenuOptionFragmentDoc = gql`
    fragment IntegrationTaskMenuOption on IntegrationTaskObj {
  id
  readableExternalId
  name
  status
}
    `;
export const ProductBoardItemConnectionsMenuFragmentDoc = gql`
    fragment ProductBoardItemConnectionsMenu on ProductBoardItemObj {
  id
  personas {
    ...PersonaMenuOption
  }
  launches {
    ...LaunchMenuOption
  }
  competitors {
    ...CompanyMenuOption
  }
  feedbackPosts {
    ...FeedbackPostMenuOption
  }
  insights {
    ...InsightMenuOption
  }
  integrationTasks {
    ...IntegrationTaskMenuOption
  }
}
    ${PersonaMenuOptionFragmentDoc}
${LaunchMenuOptionFragmentDoc}
${CompanyMenuOptionFragmentDoc}
${FeedbackPostMenuOptionFragmentDoc}
${InsightMenuOptionFragmentDoc}
${IntegrationTaskMenuOptionFragmentDoc}`;
export const ProductBoardItemTableRowDataFragmentDoc = gql`
    fragment ProductBoardItemTableRowData on ProductBoardItemObj {
  id
  title
  priority
  description
  orderIndex
  roadmapId
  parentItemId
  effort
  score
  startDate
  endDate
  updatedAt
  revenueImpactDetails {
    ...RevenueImpactDetails
  }
  roadmap {
    ...ProductBoardItemRoadmapPreview
  }
  release {
    ...ProductBoardReleasePreview
  }
  factors {
    ...ProductBoardItemFactor
  }
  status {
    ...ProductBoardStatusPreview
  }
  assignee {
    ...ProductBoardItemAssignee
  }
  deals {
    ...ProductBoardItemDeal
  }
  accounts {
    ...ProductBoardItemAccount
  }
  tags {
    ...Tag
  }
  blockedByItems {
    ...ProductBoardItemDependency
  }
  customColumns {
    ...RoadmapItemCustomColumn
  }
  ...ProductBoardItemConnectionsMenu
}
    ${RevenueImpactDetailsFragmentDoc}
${ProductBoardItemRoadmapPreviewFragmentDoc}
${ProductBoardReleasePreviewFragmentDoc}
${ProductBoardItemFactorFragmentDoc}
${ProductBoardStatusPreviewFragmentDoc}
${ProductBoardItemAssigneeFragmentDoc}
${ProductBoardItemDealFragmentDoc}
${ProductBoardItemAccountFragmentDoc}
${TagFragmentDoc}
${ProductBoardItemDependencyFragmentDoc}
${RoadmapItemCustomColumnFragmentDoc}
${ProductBoardItemConnectionsMenuFragmentDoc}`;
export const ProductBoardItemTableRowFragmentDoc = gql`
    fragment ProductBoardItemTableRow on ProductBoardItemObj {
  ...ProductBoardItemTableRowData
  subItems {
    ...ProductBoardItemTableRowData
    subItems {
      ...ProductBoardItemTableRowData
      subItems {
        ...ProductBoardItemTableRowData
        subItems {
          ...ProductBoardItemTableRowData
          subItems {
            ...ProductBoardItemTableRowData
          }
        }
      }
    }
  }
}
    ${ProductBoardItemTableRowDataFragmentDoc}`;
export const ProductBoardRoadmapWithItemsFragmentDoc = gql`
    fragment ProductBoardRoadmapWithItems on ProductBoardRoadmapObj {
  id
  name
  productLineTag {
    ...Tag
  }
  items {
    docs {
      ...ProductBoardItemTableRow
    }
    limit
    page
    totalPages
  }
}
    ${TagFragmentDoc}
${ProductBoardItemTableRowFragmentDoc}`;
export const ProductBoardFactorFragmentDoc = gql`
    fragment ProductBoardFactor on ProductBoardFactorDto {
  id
  name
  scale
  weight
  immutable
  updatedAt
}
    `;
export const BlockingProductBoardItemFragmentDoc = gql`
    fragment BlockingProductBoardItem on ProductBoardItemObj {
  id
  blockedByItems {
    ...ProductBoardItemDependency
  }
}
    ${ProductBoardItemDependencyFragmentDoc}`;
export const ProductBoardItemDependenciesFragmentDoc = gql`
    fragment ProductBoardItemDependencies on ProductBoardItemObj {
  id
  updatedAt
  blockedByItems {
    ...ProductBoardItemDependency
  }
  blockingItems {
    ...ProductBoardItemDependency
  }
}
    ${ProductBoardItemDependencyFragmentDoc}`;
export const PersonaInfoFragmentDoc = gql`
    fragment PersonaInfo on PersonaDto {
  id
  name
  occupation
  avatar
  primary
  launchesIds
  messagingLibraryIds
  tags {
    ...Tag
  }
  updatedAt
}
    ${TagFragmentDoc}`;
export const FeedbackPostPreviewFragmentDoc = gql`
    fragment FeedbackPostPreview on FeedbackPostDto {
  id
  title
  description
  internal
  boardId
  status
  revenueImpact
  upvotedByUser
  upvotes
  importance
  createdAt
  updatedAt
  assignee {
    ...UserDetails
  }
  upvoters {
    ...FeedbackPostUser
  }
  tags {
    ...Tag
  }
  productLineTags {
    ...Tag
  }
  deals {
    ...Deal
  }
  ...FeedbackPostWithCustomColumns
}
    ${UserDetailsFragmentDoc}
${FeedbackPostUserFragmentDoc}
${TagFragmentDoc}
${DealFragmentDoc}
${FeedbackPostWithCustomColumnsFragmentDoc}`;
export const RoadmapItemIntegrationTaskFragmentDoc = gql`
    fragment RoadmapItemIntegrationTask on IntegrationTaskObj {
  id
  readableExternalId
  externalUrl
  externalTaskId
  name
  description
  calculatedStatus
  status
  type
  dueDate
  startDate
  inWatchList
  productName
  integrationId
  integrationProjectId
  assignedTo
  tags {
    name
    externalId
  }
  subTasks {
    ...IntegrationSubTask
  }
}
    ${IntegrationSubTaskFragmentDoc}`;
export const ProductBoardItemDetailedDataFragmentDoc = gql`
    fragment ProductBoardItemDetailedData on ProductBoardItemObj {
  id
  title
  description
  priority
  effort
  score
  startDate
  endDate
  roadmapId
  organizationId
  launchId
  parentItemId
  designFileUrls
  productDocUrls
  customFileUrls
  updatedAt
  orderIndex
  roadmap {
    id
    name
  }
  release {
    ...ProductBoardReleasePreview
  }
  factors {
    ...ProductBoardItemFactor
  }
  status {
    ...ProductBoardStatusPreview
  }
  assignee {
    ...UserDetails
  }
  personas {
    ...PersonaInfo
  }
  launches {
    ...LaunchInfo
  }
  competitors {
    ...CompanyPreview
  }
  feedbackPosts {
    ...FeedbackPostPreview
  }
  insights {
    ...Insight
  }
  tags {
    ...Tag
  }
  accounts {
    ...ProductBoardItemAccount
  }
  productLineTags {
    ...Tag
  }
  blockedByItems {
    ...ProductBoardItemDependency
  }
  blockingItems {
    ...ProductBoardItemDependency
  }
  personasIds @client
  competitorsIds @client
  launchesIds @client
  subItemsIds @client
  feedbackPostIds @client
  insightsIds @client
  deals {
    ...Deal
  }
  integrationTasks {
    ...RoadmapItemIntegrationTask
  }
  customColumns {
    ...RoadmapItemCustomColumn
  }
  revenueImpactDetails {
    ...RevenueImpactDetails
  }
  dealIds @client
}
    ${ProductBoardReleasePreviewFragmentDoc}
${ProductBoardItemFactorFragmentDoc}
${ProductBoardStatusPreviewFragmentDoc}
${UserDetailsFragmentDoc}
${PersonaInfoFragmentDoc}
${LaunchInfoFragmentDoc}
${CompanyPreviewFragmentDoc}
${FeedbackPostPreviewFragmentDoc}
${InsightFragmentDoc}
${TagFragmentDoc}
${ProductBoardItemAccountFragmentDoc}
${ProductBoardItemDependencyFragmentDoc}
${DealFragmentDoc}
${RoadmapItemIntegrationTaskFragmentDoc}
${RoadmapItemCustomColumnFragmentDoc}
${RevenueImpactDetailsFragmentDoc}`;
export const ProductBoardItemDetailedFragmentDoc = gql`
    fragment ProductBoardItemDetailed on ProductBoardItemObj {
  ...ProductBoardItemDetailedData
  subItems {
    ...ProductBoardItemDetailedData
    subItems {
      ...ProductBoardItemDetailedData
      subItems {
        ...ProductBoardItemDetailedData
        subItems {
          ...ProductBoardItemDetailedData
          subItems {
            ...ProductBoardItemDetailedData
          }
        }
      }
    }
  }
}
    ${ProductBoardItemDetailedDataFragmentDoc}`;
export const RoadmapItemWithCustomColumnsFragmentDoc = gql`
    fragment RoadmapItemWithCustomColumns on ProductBoardItemObj {
  id
  customColumns {
    ...RoadmapItemCustomColumn
  }
}
    ${RoadmapItemCustomColumnFragmentDoc}`;
export const ProductBoardRoadmapFilterOptionDataFragmentDoc = gql`
    fragment ProductBoardRoadmapFilterOptionData on ProductBoardRoadmapObj {
  id
  name
}
    `;
export const ProductBoardItemTimelinePreviewFragmentDoc = gql`
    fragment ProductBoardItemTimelinePreview on ProductBoardItemObj {
  id
  title
  startDate
  endDate
}
    `;
export const ProductBoardItemsGroupDetailsFragmentDoc = gql`
    fragment ProductBoardItemsGroupDetails on ProductBoardItemsGroupObj {
  id
  key
  name
  imageSrc
  iconColor
  items {
    ...ProductBoardItemTimelinePreview
  }
}
    ${ProductBoardItemTimelinePreviewFragmentDoc}`;
export const ProductBoardItemsGroupsFragmentDoc = gql`
    fragment ProductBoardItemsGroups on PaginatedRoadmapItemsGroupsObj {
  docs {
    id
    ...ProductBoardItemsGroupDetails
  }
  limit
  page
  totalPages
}
    ${ProductBoardItemsGroupDetailsFragmentDoc}`;
export const ProductBoardReleaseIndicatorsFragmentDoc = gql`
    fragment ProductBoardReleaseIndicators on ProductBoardReleaseObj {
  id
  revenueImpact
  percentComplete
  okrProgress
}
    `;
export const ProductBoardReleaseFragmentDoc = gql`
    fragment ProductBoardRelease on ProductBoardReleaseObj {
  id
  name
  iconColor
  startDate
  endDate
  updatedAt
  owner {
    ...UserDetails
  }
  milestones {
    ...Milestone
  }
  productLineTag {
    ...Tag
  }
}
    ${UserDetailsFragmentDoc}
${MilestoneFragmentDoc}
${TagFragmentDoc}`;
export const ProductBoardReleaseWithItemsFragmentDoc = gql`
    fragment ProductBoardReleaseWithItems on ProductBoardReleaseObj {
  ...ProductBoardRelease
  items(filter: $itemsFilter, sort: $itemsSort, pagination: $itemsPagination) {
    docs {
      ...ProductBoardItemTableRow
    }
    limit
    page
    totalPages
  }
}
    ${ProductBoardReleaseFragmentDoc}
${ProductBoardItemTableRowFragmentDoc}`;
export const ProductBoardStatusFragmentDoc = gql`
    fragment ProductBoardStatus on ProductBoardStatusObj {
  id
  name
  description
  iconColor
  immutable
}
    `;
export const RoadmapsPublicPagesSettingsFragmentDoc = gql`
    fragment RoadmapsPublicPagesSettings on OrganizationObj {
  id
  publicPagesSettings {
    roadmap {
      ids
      live
    }
  }
}
    `;
export const CalendarPublicPageSettingsFragmentDoc = gql`
    fragment CalendarPublicPageSettings on OrganizationObj {
  id
  publicPagesSettings {
    calendar {
      live
    }
  }
}
    `;
export const RetroRespondentAnswerFragmentDoc = gql`
    fragment RetroRespondentAnswer on RetroRespondentAnswerObj {
  name
  email
  score
  answerWell
  answerImprovement
  answerLearning
}
    `;
export const RetroScoreFragmentDoc = gql`
    fragment RetroScore on RetroScoreObj {
  positive
  neutral
  negative
  nps
}
    `;
export const RetroAnswersFragmentDoc = gql`
    fragment RetroAnswers on RetroAnswersObj {
  id
  respondentAnswers {
    ...RetroRespondentAnswer
  }
  internalScore {
    ...RetroScore
  }
}
    ${RetroRespondentAnswerFragmentDoc}
${RetroScoreFragmentDoc}`;
export const RetroDataFragmentDoc = gql`
    fragment RetroData on RetroObj {
  id
  name
  sentOn
  surveyType
  resultLink
  webLink
  status
  takeaways
  emailBody
  isAnonymous
  recipientsData {
    id
    name
    email
  }
}
    `;
export const SurveyFragmentDoc = gql`
    fragment Survey on SurveyObj {
  id
  name
  surveyType
  webLink
  resultLink
  sentOn
  status
  recipients {
    id
    firstname
    lastname
    email
    sent
  }
}
    `;
export const PaginatedTasksPreviewFragmentDoc = gql`
    fragment PaginatedTasksPreview on TaskObj {
  id
  name
  status
}
    `;
export const BlocksTaskFragmentDoc = gql`
    fragment BlocksTask on TaskObj {
  id
  name
  status
}
    `;
export const TaskPreviewFragmentDoc = gql`
    fragment TaskPreview on TaskObj {
  id
  dueDate
  name
  launchId
  parentId
  status
  type
  startDate
  priority
  description
  plainDescription
  blockerTasks {
    ...BlocksTask
  }
  blockingTasks {
    ...BlocksTask
  }
  assets {
    ...AssetsFile
  }
  assignee {
    ...UserDetails
  }
  owner {
    ...UserDetails
  }
  tags {
    ...Tag
  }
}
    ${BlocksTaskFragmentDoc}
${AssetsFileFragmentDoc}
${UserDetailsFragmentDoc}
${TagFragmentDoc}`;
export const TaskFragmentDoc = gql`
    fragment Task on TaskObj {
  ...TaskPreview
  description
  subtasks {
    ...TaskPreview
  }
}
    ${TaskPreviewFragmentDoc}`;
export const TaskWithTagsFragmentDoc = gql`
    fragment TaskWithTags on TaskObj {
  id
  tags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const CustomOrganizationTemplateFragmentDoc = gql`
    fragment CustomOrganizationTemplate on TemplateObj {
  id
  organizationId
  name
  launchTier
  launchType {
    name
  }
  description
  createdAt
  createdBy {
    name
  }
  templateSections {
    id
    name
    hideModules
    templateModuleIds
    templateModules {
      id
      name
      editor
      hint
      placeholder
      canGenerateWithAI
      templateModuleTasks {
        name
        type
        description
        tags
        defaultDueDateDuration
        subTasks {
          name
          type
          description
          tags
          defaultDueDateDuration
        }
      }
    }
  }
  templateTasks {
    name
    type
    description
    tags
    defaultDueDateDuration
    subTasks {
      name
      type
      description
      tags
      defaultDueDateDuration
    }
  }
}
    `;
export const OrganizationTemplateFragmentDoc = gql`
    fragment OrganizationTemplate on TemplateObj {
  id
  launchTier
  templateSections {
    name
    hideModules
    templateModules {
      id
      name
    }
  }
}
    `;
export const LaunchCustomProgressFragmentDoc = gql`
    fragment LaunchCustomProgress on LaunchObj {
  id
  customProgress {
    assetsApproval
    productProgress
    tasksProgress
  }
}
    `;
export const OverdueTasksFragmentDoc = gql`
    fragment OverdueTasks on TaskObj {
  id
  launchId
  name
  status
  dueDate
  assignee {
    id
    name
    email
    profileImage
  }
  launch {
    id
    name
    launchTier
  }
}
    `;
export const PendingApprovalAssetsFragmentDoc = gql`
    fragment PendingApprovalAssets on AssetObj {
  id
  name
  approvalStatus
}
    `;
export const ProductContentFragmentDoc = gql`
    fragment ProductContent on StripeProductObj {
  prices {
    id
    amount
    interval
  }
  id
  name
  order
  description
  downgradable
  upgradable
  isSubscribed
  isVisible
  daysInFreeTrial
}
    `;
export const SubscriptionContentFragmentDoc = gql`
    fragment SubscriptionContent on StripeSubscriptionObj {
  id
  currentPeriodEnd
  currentPeriodStart
  itemId
  priceIds
  productIds
  status
  quantity
  products {
    id
    name
  }
}
    `;
export const ExternalPageSettingsFragmentDoc = gql`
    fragment ExternalPageSettings on ExternalPageSettings {
  textColor
  accentColor
  backgroundColor
  font
  live
  domain
  txtKey
  dismissedWantToPublish
  isVerified
  backgroundImage
}
    `;
export const OrganizationExternalPageSettingsFragmentDoc = gql`
    fragment OrganizationExternalPageSettings on OrganizationObj {
  id
  slug
  externalPageSettings {
    ...ExternalPageSettings
  }
}
    ${ExternalPageSettingsFragmentDoc}`;
export const ExternalPageReleaseNotesSettingsFragmentDoc = gql`
    fragment ExternalPageReleaseNotesSettings on ExternalPageReleaseNotesSettings {
  title
  description
  indexInSearchEngines
  live
}
    `;
export const OrganizationExternalPageReleaseNotesSettingsFragmentDoc = gql`
    fragment OrganizationExternalPageReleaseNotesSettings on OrganizationObj {
  id
  externalPageSettings {
    releaseNotesSettings {
      ...ExternalPageReleaseNotesSettings
    }
  }
}
    ${ExternalPageReleaseNotesSettingsFragmentDoc}`;
export const OrganizationDataFragmentDoc = gql`
    fragment OrganizationData on OrganizationObj {
  id
  logo
  name
  slug
  companyType
  peopleRange
  launchesPerYear
  haveGtm
  hasCreatedFirstLaunch
  isUnderFreeTrial
  hasPaidSubscription
  isFree
  isWorkspaceConfigGenerated
  autoInsightsTaggingEnabled
  roadmapToInsightsMappingEnabled
  users {
    userDetails {
      email
      name
    }
  }
  createdAt
}
    `;
export const AuthorizationDataFragmentDoc = gql`
    fragment AuthorizationData on LoginResponseObj {
  accessToken
  user {
    ...UserDetails
    isEmailVerified
  }
  organizations {
    ...OrganizationData
  }
  firstTimeLogin
}
    ${UserDetailsFragmentDoc}
${OrganizationDataFragmentDoc}`;
export const ProfileDataFragmentDoc = gql`
    fragment ProfileData on UserObj {
  id
  jobTitle
  homepage
  ...UserDetails
}
    ${UserDetailsFragmentDoc}`;
export const LoginResponseFragmentDoc = gql`
    fragment LoginResponse on LoginResponseObj {
  accessToken
  user {
    ...ProfileData
  }
  organizations {
    ...OrganizationData
  }
}
    ${ProfileDataFragmentDoc}
${OrganizationDataFragmentDoc}`;
export const AssetPreviewForCopyFragmentDoc = gql`
    fragment AssetPreviewForCopy on AssetObj {
  id
  name
  type
  userInput
}
    `;
export const ChecklistFragmentDoc = gql`
    fragment Checklist on ChecklistObj {
  organizationId
  selectedFeatures
  updatedAt
  createdAt
  workspaceConfig {
    isWorkspaceConfigured
  }
  competitiveIntel {
    isCompletedCreateBattleCard
  }
  winloss {
    isCompletedWinLossSync
  }
  roadmapping {
    isCompletedImportRoadmapData
    isCompletedCreateRoadmapItem
    isCompletedConnectCRM
    isCompletedConnectTasksIntegration
  }
  campaignPlanning {
    isCompletedCreateFirstLaunch
    isCompletedConfigureTemplate
  }
  voiceOfCustomer {
    isClickedConnectIntegration
    isClickedConfigurePublicBoard
  }
  aiCopywriting {
    isCompletedMarketingOrAssetGeneration
  }
}
    `;
export const CompanyConnectionDataFragmentDoc = gql`
    fragment CompanyConnectionData on CompanyObj {
  id
  name
  logo
}
    `;
export const FeedbackPostConnectionDataFragmentDoc = gql`
    fragment FeedbackPostConnectionData on FeedbackPostDto {
  id
  title
}
    `;
export const InsightConnectionDataFragmentDoc = gql`
    fragment InsightConnectionData on InsightObj {
  id
  name
  user
  company
  title @client
  metadata {
    summaryName
  }
}
    `;
export const LaunchConnectionDataFragmentDoc = gql`
    fragment LaunchConnectionData on LaunchObj {
  id
  name
  launchTier
}
    `;
export const PersonaConnectionDataFragmentDoc = gql`
    fragment PersonaConnectionData on PersonaDto {
  id
  name
  avatar
}
    `;
export const ProductBoardItemConnectionDataFragmentDoc = gql`
    fragment ProductBoardItemConnectionData on ProductBoardItemObj {
  id
  title
}
    `;
export const CdpContactFragmentDoc = gql`
    fragment CDPContact on CDPContactObj {
  id
  contactId
  name
  email
  role
  stage
  type
  industry
  region
  owner {
    name
    email
  }
  manual
  source
  createdAt
  updatedAt
}
    `;
export const CdpDealFragmentDoc = gql`
    fragment CDPDeal on CDPDealObj {
  id
  dealId
  name
  description
  type
  amount
  closedDate
  createdDate
  stage
  ownerId
  accountId
  manual
  source
  owner {
    id
    name
    email
  }
}
    `;
export const FeedbackPostWithStatusFragmentDoc = gql`
    fragment FeedbackPostWithStatus on FeedbackPostDto {
  id
  boardId
  title
  description
  status
}
    `;
export const ProductBoardItemWithStatusFragmentDoc = gql`
    fragment ProductBoardItemWithStatus on ProductBoardItemObj {
  id
  title
  status {
    id
    name
  }
}
    `;
export const InsightForCopyFragmentDoc = gql`
    fragment InsightForCopy on InsightObj {
  id
  name
  content
  user
  company
  title @client
  metadata {
    summaryName
  }
}
    `;
export const CdpAccountDetailFragmentDoc = gql`
    fragment CDPAccountDetail on CDPAccountObj {
  id
  accountId
  name
  domain
  description
  logo
  type
  industry
  employees
  region
  ownerId
  annualRevenue
  accountValue
  isEnriched
  manual
  source
  contacts {
    ...CDPContact
  }
  deals {
    ...CDPDeal
  }
  feedbackPosts {
    ...FeedbackPostWithStatus
  }
  productBoardItems {
    ...ProductBoardItemWithStatus
  }
  insights {
    ...InsightForCopy
  }
}
    ${CdpContactFragmentDoc}
${CdpDealFragmentDoc}
${FeedbackPostWithStatusFragmentDoc}
${ProductBoardItemWithStatusFragmentDoc}
${InsightForCopyFragmentDoc}`;
export const CdpAccountCardFragmentDoc = gql`
    fragment CDPAccountCard on CDPAccountObj {
  id
  accountId
  name
  domain
  logo
  type
  industry
  employees
  region
  annualRevenue
  accountValue
  deals {
    ...CDPDeal
  }
}
    ${CdpDealFragmentDoc}`;
export const CdpContactDetailFragmentDoc = gql`
    fragment CDPContactDetail on CDPContactObj {
  id
  contactId
  name
  description
  email
  role
  stage
  type
  industry
  region
  account {
    ...CDPAccountCard
  }
  owner {
    name
    email
  }
  manual
  source
  deals {
    ...CDPDeal
  }
  feedbackPosts {
    ...FeedbackPostWithStatus
  }
  productBoardItems {
    ...ProductBoardItemWithStatus
  }
  insights {
    ...InsightForCopy
  }
}
    ${CdpAccountCardFragmentDoc}
${CdpDealFragmentDoc}
${FeedbackPostWithStatusFragmentDoc}
${ProductBoardItemWithStatusFragmentDoc}
${InsightForCopyFragmentDoc}`;
export const CdpAccountFilterOptionDataFragmentDoc = gql`
    fragment CDPAccountFilterOptionData on CDPAccountObj {
  id
  name
  domain
  logo
}
    `;
export const CdpContactFilterOptionDataFragmentDoc = gql`
    fragment CDPContactFilterOptionData on CDPContactObj {
  id
  name
  email
}
    `;
export const CdpOwnerFilterOptionDataFragmentDoc = gql`
    fragment CDPOwnerFilterOptionData on CDPOwnerObj {
  id
  name
  email
}
    `;
export const CompanyFilterOptionDataFragmentDoc = gql`
    fragment CompanyFilterOptionData on CompanyObj {
  id
  name
  logo
}
    `;
export const DealFilterOptionDataFragmentDoc = gql`
    fragment DealFilterOptionData on DealObj {
  id
  name
  amount
}
    `;
export const DealFilterOptionFragmentDoc = gql`
    fragment DealFilterOption on DealFilterOptionObj {
  value
  label
  amount
}
    `;
export const FilterOptionFragmentDoc = gql`
    fragment FilterOption on FilterOptionObj {
  value
  label
}
    `;
export const TagFilterOptionFragmentDoc = gql`
    fragment TagFilterOption on TagFilterOptionObj {
  value
  label
  color
}
    `;
export const PersonaFilterOptionFragmentDoc = gql`
    fragment PersonaFilterOption on PersonaFilterOptionObj {
  value
  label
  avatar
}
    `;
export const LaunchFilterOptionFragmentDoc = gql`
    fragment LaunchFilterOption on LaunchFilterOptionObj {
  value
  label
  tier
}
    `;
export const FeedbackPostFilterOptionFragmentDoc = gql`
    fragment FeedbackPostFilterOption on FeedbackPostFilterOptionObj {
  value
  label
  upvotersCount
}
    `;
export const CompetitorCompanyFilterOptionFragmentDoc = gql`
    fragment CompetitorCompanyFilterOption on CompetitorCompanyFilterOptionObj {
  value
  label
  logo
}
    `;
export const CdpAccountFilterOptionFragmentDoc = gql`
    fragment CDPAccountFilterOption on CDPAccountFilterOptionObj {
  value
  label
  logo
}
    `;
export const UserFilterOptionFragmentDoc = gql`
    fragment UserFilterOption on UserFilterOptionObj {
  value
  label
  profileImage
}
    `;
export const ProductBoardReleaseFilterOptionFragmentDoc = gql`
    fragment ProductBoardReleaseFilterOption on ProductBoardReleaseFilterOptionObj {
  value
  label
  color
}
    `;
export const ProductBoardStatusFilterOptionFragmentDoc = gql`
    fragment ProductBoardStatusFilterOption on ProductBoardStatusFilterOptionObj {
  value
  label
  color
}
    `;
export const FeedbackUserFilterOptionFragmentDoc = gql`
    fragment FeedbackUserFilterOption on FeedbackUserFilterOptionObj {
  value
  label
  avatarSrc
}
    `;
export const DealCompanyFilterOptionFragmentDoc = gql`
    fragment DealCompanyFilterOption on DealCompanyFilterOptionObj {
  value
  label
  logo
}
    `;
export const InsightFilterOptionDataFragmentDoc = gql`
    fragment InsightFilterOptionData on InsightObj {
  id
  name
  user
  company
  title @client
  metadata {
    summaryName
  }
}
    `;
export const LaunchFilterOptionDataFragmentDoc = gql`
    fragment LaunchFilterOptionData on LaunchObj {
  id
  name
  launchTier
}
    `;
export const LaunchTypeFilterOptionDataFragmentDoc = gql`
    fragment LaunchTypeFilterOptionData on LaunchTypeObj {
  id
  name
}
    `;
export const OrganizationUserFilterOptionDataFragmentDoc = gql`
    fragment OrganizationUserFilterOptionData on UserInOrganizationObj {
  userId
  userDetails {
    id
    name
    email
    avatarColor @client
    profileImage
  }
}
    `;
export const PersonaFilterOptionDataFragmentDoc = gql`
    fragment PersonaFilterOptionData on PersonaDto {
  id
  name
  avatar
}
    `;
export const ProductBoardReleaseFilterOptionDataFragmentDoc = gql`
    fragment ProductBoardReleaseFilterOptionData on ProductBoardReleaseObj {
  id
  name
  iconColor
}
    `;
export const ProductBoardStatusFilterOptionDataFragmentDoc = gql`
    fragment ProductBoardStatusFilterOptionData on ProductBoardStatusObj {
  id
  name
  iconColor
}
    `;
export const ProductIdeaFilterOptionDataFragmentDoc = gql`
    fragment ProductIdeaFilterOptionData on FeedbackPostDto {
  id
  title
  upvoters {
    id
  }
}
    `;
export const PublicOrganizationUserFilterOptionDataFragmentDoc = gql`
    fragment PublicOrganizationUserFilterOptionData on PublicUserObj {
  id
  name
  profileImage
}
    `;
export const TagFilterOptionDataFragmentDoc = gql`
    fragment TagFilterOptionData on TagObj {
  id
  type
  label
  color
}
    `;
export const UserFilterOptionDataFragmentDoc = gql`
    fragment UserFilterOptionData on UserObj {
  id
  name
  email
  avatarColor @client
  profileImage
}
    `;
export const InsightsGeneratedItemObjFragmentDoc = gql`
    fragment InsightsGeneratedItemObj on InsightsGeneratedItemObj {
  id
  text
  description
  insights {
    ...Insight
  }
  tags {
    ...Tag
  }
  accounts {
    ...CDPAccount
  }
  trendGraph {
    count
    labels
  }
  createdAt
  updatedAt
}
    ${InsightFragmentDoc}
${TagFragmentDoc}
${CdpAccountFragmentDoc}`;
export const InsightsSummarizedTrendItemObjFragmentDoc = gql`
    fragment InsightsSummarizedTrendItemObj on InsightsTrendItemObj {
  id
  text
  description
  insightIds
  tags {
    ...Tag
  }
  accounts {
    ...CDPAccount
  }
  trendGraph {
    count
    labels
  }
  createdAt
  updatedAt
}
    ${TagFragmentDoc}
${CdpAccountFragmentDoc}`;
export const InsightsTrendItemObjFragmentDoc = gql`
    fragment InsightsTrendItemObj on InsightsTrendItemObj {
  id
  text
  description
  insights {
    ...Insight
  }
  tags {
    ...Tag
  }
  accounts {
    ...CDPAccount
  }
  trendGraph {
    count
    labels
  }
  createdAt
  updatedAt
}
    ${InsightFragmentDoc}
${TagFragmentDoc}
${CdpAccountFragmentDoc}`;
export const LaunchCopilotAssetFragmentDoc = gql`
    fragment LaunchCopilotAsset on AssetObj {
  id
  name
  type
  userInput
  tagsIds
}
    `;
export const PreviewDefaultAssetFragmentDoc = gql`
    fragment PreviewDefaultAsset on PreviewDefaultAssetObj {
  name
  type
}
    `;
export const LaunchCopilotPreferencesFragmentDoc = gql`
    fragment LaunchCopilotPreferences on LaunchObj {
  id
  name
  description
  launchType {
    id
    name
    createdBy
  }
  launchTier
  launchDate
  templateId
  copilotPreferences {
    generatedChannels
    generatedAssets
    generatedTasks
    preferBuildChannels
    preferBuildAssets
    preferBuildTasks
    lastOnBoardingStep
  }
  sectionVisibilityPreferences {
    assets
    modules
    objectives
    tasks
    timeline
  }
}
    `;
export const LaunchCopilotTaskInfoFragmentDoc = gql`
    fragment LaunchCopilotTaskInfo on TaskObj {
  id
  launchId
  name
  description
  status
  type
  startDate
  dueDate
  assignee {
    id
    name
    email
    profileImage
    avatarColor @client
  }
  tags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const LaunchCopilotTaskFragmentDoc = gql`
    fragment LaunchCopilotTask on TaskObj {
  ...LaunchCopilotTaskInfo
  subtasks {
    ...LaunchCopilotTaskInfo
  }
}
    ${LaunchCopilotTaskInfoFragmentDoc}`;
export const PreviewDefaultTaskInfoFragmentDoc = gql`
    fragment PreviewDefaultTaskInfo on PreviewDefaultTaskObj {
  name
  description
  plainDescription
  type
  status
  startDate
  dueDate
}
    `;
export const PreviewDefaultTaskFragmentDoc = gql`
    fragment PreviewDefaultTask on PreviewDefaultTaskObj {
  ...PreviewDefaultTaskInfo
  subtasks {
    ...PreviewDefaultTaskInfo
  }
}
    ${PreviewDefaultTaskInfoFragmentDoc}`;
export const LaunchCopilotChannelTimeframeFragmentDoc = gql`
    fragment LaunchCopilotChannelTimeframe on ChannelTimeframeObj {
  id
  name
  budget
  description
  startDate
  endDate
}
    `;
export const LaunchCopilotChannelFragmentDoc = gql`
    fragment LaunchCopilotChannel on ChannelObj {
  id
  channelTemplateId
  name
  description
  type
  logoSrc
  timeframes {
    ...LaunchCopilotChannelTimeframe
  }
}
    ${LaunchCopilotChannelTimeframeFragmentDoc}`;
export const LaunchCopilotMilestoneFragmentDoc = gql`
    fragment LaunchCopilotMilestone on MilestoneObj {
  id
  name
  description
  type
  startDate
  endDate
}
    `;
export const LaunchCopilotPhaseFragmentDoc = gql`
    fragment LaunchCopilotPhase on LaunchPhaseObj {
  id
  name
  notes
  startDate
  endDate
  isActive
}
    `;
export const PreviewDefaultChannelFragmentDoc = gql`
    fragment PreviewDefaultChannel on PreviewDefaultChannelObj {
  channelTemplateId
  name
  description
  type
  logoSrc
  timeframes {
    ...LaunchCopilotChannelTimeframe
  }
}
    ${LaunchCopilotChannelTimeframeFragmentDoc}`;
export const LaunchForChannelsFragmentDoc = gql`
    fragment LaunchForChannels on LaunchObj {
  id
  name
  gtmTimeline {
    launchId
    channels {
      id
      name
      channelTemplateId
      description
      logoSrc
      type
    }
  }
}
    `;
export const LaunchForDisplayModuleFragmentDoc = gql`
    fragment LaunchForDisplayModule on LaunchObj {
  id
  name
  sectionVisibilityPreferences {
    assets
    modules
    objectives
    tasks
    timeline
  }
  launchSections(filter: $sectionfilter) {
    id
    name
    hideModules
    launchModules(filter: $moduleFilter) {
      id
      name
      editor
      orderIndex
      templateModuleId
      isVisible
    }
  }
}
    `;
export const LaunchForImortModuleFragmentDoc = gql`
    fragment LaunchForImortModule on LaunchObj {
  id
  name
  launchDate
  launchSections(filter: $sectionfilter) {
    id
    name
    hideModules
    launchModules(filter: $moduleFilter) {
      id
      name
      editor
      orderIndex
      templateModuleId
      isVisible
      userInput {
        id
        WYSIWYG_EDITOR
        POSITIONING_EDITOR_NEW {
          placeholder
          title
          text
        }
      }
    }
  }
}
    `;
export const LaunchInfoForModuleFragmentDoc = gql`
    fragment LaunchInfoForModule on LaunchObj {
  id
  name
  description
  launchDate
  launchTier
  tags {
    id
    label
    type
    color
    isPreBuilt
  }
}
    `;
export const LaunchModulesVisibleStatesFragmentDoc = gql`
    fragment LaunchModulesVisibleStates on LaunchModuleObj {
  id
  name
  orderIndex
  templateModuleId
  isVisible
}
    `;
export const LaunchSectionsVisibleStatesFragmentDoc = gql`
    fragment LaunchSectionsVisibleStates on LaunchObj {
  id
  sectionVisibilityPreferences {
    assets
    modules
    objectives
    tasks
    timeline
  }
}
    `;
export const RoadmapMenuOptionDataFragmentDoc = gql`
    fragment RoadmapMenuOptionData on ProductBoardRoadmapObj {
  id
  name
}
    `;
export const MessagingLibraryTagFragmentDoc = gql`
    fragment MessagingLibraryTag on TagObj {
  id
  label
  description
  type
  color
  isPreBuilt
  organizationId
}
    `;
export const CustomMessagingFragmentDoc = gql`
    fragment CustomMessaging on CustomMessagingObj {
  title
  description
}
    `;
export const MessageLibraryFragmentDoc = gql`
    fragment MessageLibrary on MessagingLibraryObj {
  id
  organizationId
  isViewed
  productlineTag {
    ...MessagingLibraryTag
  }
  messaging
  positioningStrategy
  customMessaging {
    ...CustomMessaging
  }
}
    ${MessagingLibraryTagFragmentDoc}
${CustomMessagingFragmentDoc}`;
export const MessageLibraryPreviewFragmentDoc = gql`
    fragment MessageLibraryPreview on MessagingLibraryObj {
  id
  organizationId
  productlineTag {
    ...MessagingLibraryTag
  }
}
    ${MessagingLibraryTagFragmentDoc}`;
export const ProductIdeaForCopyFragmentDoc = gql`
    fragment ProductIdeaForCopy on ProductBoardItemObj {
  id
  title
  description
}
    `;
export const PublicFeedbackBoardFragmentDoc = gql`
    fragment PublicFeedbackBoard on FeedbackBoardDto {
  id
  internal
  name
  heading
  subHeading
  updatedAt
  emailDomain
  password
  notifyingUserIds
  postsCount
  sendNotification
}
    `;
export const PublicFeedbackPostFragmentDoc = gql`
    fragment PublicFeedbackPost on FeedbackPostDto {
  id
  boardId
  internal
  status
  title
  description
}
    `;
export const PublicFeedbackBoardSettingsFragmentDoc = gql`
    fragment PublicFeedbackBoardSettings on ProductIdeaBoardSettingsObj {
  boardId
  name
  heading
  internal
  password
  emailDomain
  isAccountRestricted
  productIdeaBoardFilters {
    assigneeIds
    statuses
    tagIds
  }
}
    `;
export const PublicPageFragmentDoc = gql`
    fragment PublicPage on PublicPageObj {
  id
  coverImage
  domain
  txtKey
  name
  description
  headerDescription
  live
  isVerified
  isReleaseNotesLive
  isProductIdeasLive
  styleSettings {
    accentColor
    backgroundColor
    customCss
    font
    textColor
  }
  releaseNotesFilters {
    dueDateExists
    endDueDate
    internal
    launchIds
    live
    ownerIds
    query
    startDueDate
    tagIds
  }
  releaseNotesPassword
  productIdeaBoardSettings {
    ...PublicFeedbackBoardSettings
  }
}
    ${PublicFeedbackBoardSettingsFragmentDoc}`;
export const PublicPagePreviewFragmentDoc = gql`
    fragment PublicPagePreview on PublicPageObj {
  id
  live
  coverImage
  name
  description
  isVerified
  isReleaseNotesLive
  isProductIdeasLive
}
    `;
export const PublicReleaseNoteFragmentDoc = gql`
    fragment PublicReleaseNote on ReleaseNoteObj {
  id
  organizationId
  launchId
  name
  description
  internal
  tagsIds
}
    `;
export const ReleaseNoteFragmentDoc = gql`
    fragment ReleaseNote on ReleaseNoteObj {
  id
  name
  description
  internal
  dueDate
  createdAt
  launchId
  image
  launch {
    id
    name
  }
  owner {
    ...UserDetails
  }
  tags {
    ...Tag
  }
}
    ${UserDetailsFragmentDoc}
${TagFragmentDoc}`;
export const RoadmapForOptionFragmentDoc = gql`
    fragment RoadmapForOption on ProductBoardRoadmapObj {
  id
  name
}
    `;
export const TestimonialFragmentDoc = gql`
    fragment Testimonial on TestimonialObj {
  id
  name
  company
  registeredOn
  quote
  status
  updatedAt
  createdAt
  tags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const PaginatedTestimonialsFragmentDoc = gql`
    fragment PaginatedTestimonials on PaginatedTestimonialObj {
  totalPages
  totalDocs
  page
  limit
  docs {
    ...Testimonial
  }
}
    ${TestimonialFragmentDoc}`;
export const UserDataForApprovalFragmentDoc = gql`
    fragment UserDataForApproval on UserObj {
  id
  name
  email
  profileImage
  avatarColor @client
}
    `;
export const ChecklistAiCopywritingFragmentDoc = gql`
    fragment ChecklistAiCopywriting on ChecklistObj {
  organizationId
  updatedAt
  aiCopywriting {
    isCompletedMarketingOrAssetGeneration
  }
}
    `;
export const ChecklistCampaignPlanningFragmentDoc = gql`
    fragment ChecklistCampaignPlanning on ChecklistObj {
  organizationId
  updatedAt
  campaignPlanning {
    isCompletedConfigureTemplate
    isCompletedCreateFirstLaunch
  }
}
    `;
export const ChecklistCompetitiveIntelFragmentDoc = gql`
    fragment ChecklistCompetitiveIntel on ChecklistObj {
  organizationId
  updatedAt
  competitiveIntel {
    isCompletedCreateBattleCard
  }
}
    `;
export const ChecklistWorkspaceConfigFragmentDoc = gql`
    fragment ChecklistWorkspaceConfig on ChecklistObj {
  organizationId
  updatedAt
  workspaceConfig {
    isWorkspaceConfigured
  }
}
    `;
export const CompanyInfoFromWebsiteFragmentDoc = gql`
    fragment CompanyInfoFromWebsite on CompanyInfoFromWebsiteObj {
  logo
  description
  brandGuidelines
  personas {
    title
    description
  }
  productLineTags {
    label
    description
  }
}
    `;
export const ChecklistRoadmappingFragmentDoc = gql`
    fragment ChecklistRoadmapping on ChecklistObj {
  organizationId
  updatedAt
  roadmapping {
    isCompletedImportRoadmapData
    isCompletedCreateRoadmapItem
    isCompletedConnectCRM
    isCompletedConnectTasksIntegration
  }
}
    `;
export const ChecklistVoiceOfCustomerFragmentDoc = gql`
    fragment ChecklistVoiceOfCustomer on ChecklistObj {
  organizationId
  updatedAt
  voiceOfCustomer {
    isClickedConfigurePublicBoard
    isClickedConnectIntegration
  }
}
    `;
export const ChecklistWinlossAnalysisFragmentDoc = gql`
    fragment ChecklistWinlossAnalysis on ChecklistObj {
  organizationId
  updatedAt
  winloss {
    isCompletedWinLossSync
  }
}
    `;
export const CompanyFeatureTableStatusFragmentDoc = gql`
    fragment CompanyFeatureTableStatus on FeatureTableObj {
  id
  competitorBattlecardId
  status
}
    `;
export const CompanyFeatureFragmentDoc = gql`
    fragment CompanyFeature on CompetitiveIntelligenceFeatureObj {
  id
  competitorBattlecardId
  name
  company
  competitor
  categoryId
}
    `;
export const UserNotificationsPreferencesFragmentDoc = gql`
    fragment UserNotificationsPreferences on NotificationPreferences {
  types {
    STATUS_UPDATES_AND_COMMENTS
    TASKS_AND_REMINDERS_NOTIFICATIONS
    EMAIL_DIGEST
    AI_ALERTS
  }
  sources {
    SLACK
    EMAIL
    APP
  }
}
    `;
export const CdpOwnerFragmentDoc = gql`
    fragment CDPOwner on CDPOwnerObj {
  id
  ownerId
  name
  email
  role
  type
  manual
  source
}
    `;
export const InsightIntegrationInsightMappingFragmentDoc = gql`
    fragment InsightIntegrationInsightMapping on InsightIntegrationInsightMappingObj {
  channelId
  productLineTagId
}
    `;
export const InsightIntegrationFeedbackPostMappingFragmentDoc = gql`
    fragment InsightIntegrationFeedbackPostMapping on InsightIntegrationFeedbackPostMappingObj {
  channelId
  feedbackBoardId
}
    `;
export const InsightIntegrationFragmentDoc = gql`
    fragment InsightIntegration on InsightIntegrationObj {
  id
  integrationSource
  appName
  subdomain
  webhookEnabled
  feedbackBoardId
  generateFeedbackPosts
  insightMappings {
    ...InsightIntegrationInsightMapping
  }
  feedbackPostMappings {
    ...InsightIntegrationFeedbackPostMapping
  }
  owner {
    id
  }
  createdAt
  updatedAt
}
    ${InsightIntegrationInsightMappingFragmentDoc}
${InsightIntegrationFeedbackPostMappingFragmentDoc}`;
export const InsightIntegrationItemFragmentDoc = gql`
    fragment InsightIntegrationItem on InsightIntegrationItemObj {
  id
  content
  externalId
  externalCreatedAt
}
    `;
export const InsightsViewFragmentDoc = gql`
    fragment InsightsView on InsightsViewObj {
  id
  name
  visibleProperties
  sort {
    sort
    sortBy
  }
  filter {
    accountIds
    assigneeIds
    competitorIds
    contactIds
    conversationTypes
    feedbackPostIds
    launchIds
    personaIds
    productBoardItemIds
    tagIds
    taskIds
    query
    source
    createdAt
    createdAtGte
    endRegisteredOn
    startRegisteredOn
    summaryUpdatedAtGte
    tagsUpdatedAtGte
  }
}
    `;
export const PersonaForCopyFragmentDoc = gql`
    fragment PersonaForCopy on PersonaDto {
  id
  name
  avatar
  primary
  occupation
}
    `;
export const CompanyForCopyFragmentDoc = gql`
    fragment CompanyForCopy on CompanyObj {
  id
  name
  logo
}
    `;
export const ProductBoardItemForCopyFragmentDoc = gql`
    fragment ProductBoardItemForCopy on ProductBoardItemObj {
  id
  title
  description
}
    `;
export const FeedbackPostForCopyFragmentDoc = gql`
    fragment FeedbackPostForCopy on FeedbackPostDto {
  id
  title
  description
}
    `;
export const LaunchConnectionForCopyFragmentDoc = gql`
    fragment LaunchConnectionForCopy on LaunchObj {
  id
  name
  description
  personas {
    ...PersonaForCopy
  }
  insights {
    ...InsightForCopy
  }
  competitors {
    ...CompanyForCopy
  }
  productBoardItems {
    ...ProductBoardItemForCopy
  }
  feedbackPosts {
    ...FeedbackPostForCopy
  }
}
    ${PersonaForCopyFragmentDoc}
${InsightForCopyFragmentDoc}
${CompanyForCopyFragmentDoc}
${ProductBoardItemForCopyFragmentDoc}
${FeedbackPostForCopyFragmentDoc}`;
export const UserDataForInviteToLaunchFragmentDoc = gql`
    fragment UserDataForInviteToLaunch on UserObj {
  id
  name
  email
  profileImage
  avatarColor @client
}
    `;
export const OrganizationUserDataForTableFragmentDoc = gql`
    fragment OrganizationUserDataForTable on UserInOrganizationObj {
  id @client
  name @client
  email @client
  profileImage @client
  avatarColor @client
  userId
  role
  inviteAccepted
  canResendInvite
  userDetails {
    id
    name
    email
    profileImage
  }
}
    `;
export const ProductIdeasViewFragmentDoc = gql`
    fragment ProductIdeasView on FeedbackPostsViewObj {
  id
  name
  visibleProperties
  view
  sort {
    sort
    sortBy
  }
  filter {
    query
    maxVotes
    minVotes
    boardId
    assigneeIds
    productBoardItemIds
    statuses
    tagIds
    accountsFilter {
      createdAtGte
      createdAtLte
      updatedAtGte
      updatedAtLte
      accountValueGte
      accountValueLte
      annualRevenueGte
      annualRevenueLte
      employeesGte
      employeesLte
      type
      industry
    }
  }
}
    `;
export const ProductIdeasBoardCustomColumnFragmentDoc = gql`
    fragment ProductIdeasBoardCustomColumn on FeedbackCustomColumnDto {
  id
  name
  type
}
    `;
export const ProductIdeasBoardWithCustomColumnsFragmentDoc = gql`
    fragment ProductIdeasBoardWithCustomColumns on FeedbackBoardDto {
  id
  customColumns {
    ...ProductIdeasBoardCustomColumn
  }
}
    ${ProductIdeasBoardCustomColumnFragmentDoc}`;
export const RoadmapItemOrderIndexFragmentDoc = gql`
    fragment RoadmapItemOrderIndex on ProductBoardItemOrderIndexObj {
  roadmapItemId
  orderIndex
}
    `;
export const CustomFieldSortOptionFragmentDoc = gql`
    fragment CustomFieldSortOption on CustomFieldSortObj {
  customFieldId
  order
}
    `;
export const FieldSortOptionFragmentDoc = gql`
    fragment FieldSortOption on FieldSortObj {
  order
}
    `;
export const RoadmapItemSortOptionsFragmentDoc = gql`
    fragment RoadmapItemSortOptions on ProductBoardItemsViewSortObj {
  factor {
    ...CustomFieldSortOption
  }
  customColumn {
    ...CustomFieldSortOption
  }
  assignee {
    ...FieldSortOption
  }
  createdAt {
    ...FieldSortOption
  }
  effort {
    ...FieldSortOption
  }
  endDate {
    ...FieldSortOption
  }
  orderIndex {
    ...FieldSortOption
  }
  release {
    ...FieldSortOption
  }
  roadmap {
    ...FieldSortOption
  }
  score {
    ...FieldSortOption
  }
  startDate {
    ...FieldSortOption
  }
  status {
    ...FieldSortOption
  }
  priority {
    ...FieldSortOption
  }
  title {
    ...FieldSortOption
  }
  value {
    ...FieldSortOption
  }
  revenueImpact {
    ...FieldSortOption
  }
}
    ${CustomFieldSortOptionFragmentDoc}
${FieldSortOptionFragmentDoc}`;
export const RoadmapItemsViewFragmentDoc = gql`
    fragment RoadmapItemsView on ProductBoardItemsViewObj {
  id
  name
  visibleProperties
  groupBy
  view
  orderIndexes {
    ...RoadmapItemOrderIndex
  }
  sort {
    ...RoadmapItemSortOptions
  }
  filter {
    query
    endDateGte
    endDateLte
    assigneeIds
    competitorIds
    feedbackPostIds
    insightIds
    launchIds
    personaIds
    productLineTagIds
    releaseIds
    roadmapIds
    statusIds
    priority
    tagIds
  }
}
    ${RoadmapItemOrderIndexFragmentDoc}
${RoadmapItemSortOptionsFragmentDoc}`;
export const RoadmapColumnDisplayPropertyFragmentDoc = gql`
    fragment RoadmapColumnDisplayProperty on ProductBoardCustomColumnDto {
  id
  name
  type
}
    `;
export const RoadmapFactorDisplayPropertyFragmentDoc = gql`
    fragment RoadmapFactorDisplayProperty on ProductBoardFactorDto {
  id
  name
  immutable
}
    `;
export const TestimonialFromInsightObjFragmentDoc = gql`
    fragment TestimonialFromInsightObj on TestimonialObj {
  id
  company
  name
  quote
  registeredOn
  status
  insightSource
}
    `;
export const GeneratedTestimonialFromInsightObjFragmentDoc = gql`
    fragment GeneratedTestimonialFromInsightObj on TestimonialFromInsightObj {
  id
  company
  name
  quote
  registeredOn
  insightSource
}
    `;
export const CompanyNewsArticleSummaryFragmentDoc = gql`
    fragment CompanyNewsArticleSummary on CompetitorCompanyNewsArticleObj {
  name
  description
  publishedDate
  providerName
  sourceUrl
  companyName
}
    `;
export const CompanyReviewDigestSummaryFragmentDoc = gql`
    fragment CompanyReviewDigestSummary on G2UserReviewsOutput {
  score
  answers
  companyName
  segment
  industry
}
    `;
export const WinLossInsightDigestSummaryFragmentDoc = gql`
    fragment WinLossInsightDigestSummary on WinLossTableObj {
  status
  amount
  closedDate
  dealId
  account {
    id
    name
    website
    logo
  }
}
    `;
export const FeedbackPostSummaryFragmentDoc = gql`
    fragment FeedbackPostSummary on FeedbackPostDto {
  id
  title
  revenueImpact
  image
  isAIGenerated
  source
}
    `;
export const DealsFeedbackPostDigestFragmentDoc = gql`
    fragment DealsFeedbackPostDigest on FeedbackPostsByDealDigestObj {
  id
  name
  amount
  stage
  closeDate
  crm
  company {
    id
    name
    logo
  }
  owner {
    id
    name
    email
  }
  ideas {
    ...FeedbackPostSummary
  }
}
    ${FeedbackPostSummaryFragmentDoc}`;
export const CreateCompletionDocument = gql`
    mutation CreateCompletion($input: CreateCompletionInput!) {
  createCompletion(input: $input)
}
    `;
export type CreateCompletionMutationFn = Apollo.MutationFunction<Types.CreateCompletionMutation, Types.CreateCompletionMutationVariables>;

/**
 * __useCreateCompletionMutation__
 *
 * To run a mutation, you first call `useCreateCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompletionMutation, { data, loading, error }] = useCreateCompletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompletionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCompletionMutation, Types.CreateCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCompletionMutation, Types.CreateCompletionMutationVariables>(CreateCompletionDocument, options);
      }
export type CreateCompletionMutationHookResult = ReturnType<typeof useCreateCompletionMutation>;
export type CreateCompletionMutationResult = Apollo.MutationResult<Types.CreateCompletionMutation>;
export type CreateCompletionMutationOptions = Apollo.BaseMutationOptions<Types.CreateCompletionMutation, Types.CreateCompletionMutationVariables>;
export const TranslateDocument = gql`
    mutation Translate($input: TranslateInput!) {
  translate(input: $input)
}
    `;
export type TranslateMutationFn = Apollo.MutationFunction<Types.TranslateMutation, Types.TranslateMutationVariables>;

/**
 * __useTranslateMutation__
 *
 * To run a mutation, you first call `useTranslateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranslateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [translateMutation, { data, loading, error }] = useTranslateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTranslateMutation(baseOptions?: Apollo.MutationHookOptions<Types.TranslateMutation, Types.TranslateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TranslateMutation, Types.TranslateMutationVariables>(TranslateDocument, options);
      }
export type TranslateMutationHookResult = ReturnType<typeof useTranslateMutation>;
export type TranslateMutationResult = Apollo.MutationResult<Types.TranslateMutation>;
export type TranslateMutationOptions = Apollo.BaseMutationOptions<Types.TranslateMutation, Types.TranslateMutationVariables>;
export const SearchAnnouncementRecipientsDocument = gql`
    query SearchAnnouncementRecipients($input: SearchAnnouncementRecipientsInput!) {
  searchAnnouncementRecipients(input: $input) {
    ...AnnouncementRecipient
  }
}
    ${AnnouncementRecipientFragmentDoc}`;

/**
 * __useSearchAnnouncementRecipientsQuery__
 *
 * To run a query within a React component, call `useSearchAnnouncementRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAnnouncementRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAnnouncementRecipientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchAnnouncementRecipientsQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchAnnouncementRecipientsQuery, Types.SearchAnnouncementRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchAnnouncementRecipientsQuery, Types.SearchAnnouncementRecipientsQueryVariables>(SearchAnnouncementRecipientsDocument, options);
      }
export function useSearchAnnouncementRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchAnnouncementRecipientsQuery, Types.SearchAnnouncementRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchAnnouncementRecipientsQuery, Types.SearchAnnouncementRecipientsQueryVariables>(SearchAnnouncementRecipientsDocument, options);
        }
export type SearchAnnouncementRecipientsQueryHookResult = ReturnType<typeof useSearchAnnouncementRecipientsQuery>;
export type SearchAnnouncementRecipientsLazyQueryHookResult = ReturnType<typeof useSearchAnnouncementRecipientsLazyQuery>;
export type SearchAnnouncementRecipientsQueryResult = Apollo.QueryResult<Types.SearchAnnouncementRecipientsQuery, Types.SearchAnnouncementRecipientsQueryVariables>;
export const AnnouncementsDocument = gql`
    query Announcements($pagination: PaginationInput) {
  paginatedAnnouncements(pagination: $pagination) {
    page
    totalPages
    docs {
      ...Announcement
    }
  }
}
    ${AnnouncementFragmentDoc}`;

/**
 * __useAnnouncementsQuery__
 *
 * To run a query within a React component, call `useAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AnnouncementsQuery, Types.AnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnnouncementsQuery, Types.AnnouncementsQueryVariables>(AnnouncementsDocument, options);
      }
export function useAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnnouncementsQuery, Types.AnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnnouncementsQuery, Types.AnnouncementsQueryVariables>(AnnouncementsDocument, options);
        }
export type AnnouncementsQueryHookResult = ReturnType<typeof useAnnouncementsQuery>;
export type AnnouncementsLazyQueryHookResult = ReturnType<typeof useAnnouncementsLazyQuery>;
export type AnnouncementsQueryResult = Apollo.QueryResult<Types.AnnouncementsQuery, Types.AnnouncementsQueryVariables>;
export const CreateAnnouncementDocument = gql`
    mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    ...Announcement
  }
}
    ${AnnouncementFragmentDoc}`;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<Types.CreateAnnouncementMutation, Types.CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAnnouncementMutation, Types.CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAnnouncementMutation, Types.CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<Types.CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<Types.CreateAnnouncementMutation, Types.CreateAnnouncementMutationVariables>;
export const DeleteAnnouncementDocument = gql`
    mutation DeleteAnnouncement($id: String!) {
  deleteAnnouncement(id: $id) {
    id
  }
}
    `;
export type DeleteAnnouncementMutationFn = Apollo.MutationFunction<Types.DeleteAnnouncementMutation, Types.DeleteAnnouncementMutationVariables>;

/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAnnouncementMutation, Types.DeleteAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAnnouncementMutation, Types.DeleteAnnouncementMutationVariables>(DeleteAnnouncementDocument, options);
      }
export type DeleteAnnouncementMutationHookResult = ReturnType<typeof useDeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationResult = Apollo.MutationResult<Types.DeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAnnouncementMutation, Types.DeleteAnnouncementMutationVariables>;
export const UpdateAnnouncementsRecipientsDocument = gql`
    mutation UpdateAnnouncementsRecipients($input: UpdateAnnouncementUsersInput!) {
  updateAnnouncementsRecipients(input: $input) {
    id
    recipientsData {
      ...RecipientData
    }
  }
}
    ${RecipientDataFragmentDoc}`;
export type UpdateAnnouncementsRecipientsMutationFn = Apollo.MutationFunction<Types.UpdateAnnouncementsRecipientsMutation, Types.UpdateAnnouncementsRecipientsMutationVariables>;

/**
 * __useUpdateAnnouncementsRecipientsMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementsRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementsRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementsRecipientsMutation, { data, loading, error }] = useUpdateAnnouncementsRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnnouncementsRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAnnouncementsRecipientsMutation, Types.UpdateAnnouncementsRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAnnouncementsRecipientsMutation, Types.UpdateAnnouncementsRecipientsMutationVariables>(UpdateAnnouncementsRecipientsDocument, options);
      }
export type UpdateAnnouncementsRecipientsMutationHookResult = ReturnType<typeof useUpdateAnnouncementsRecipientsMutation>;
export type UpdateAnnouncementsRecipientsMutationResult = Apollo.MutationResult<Types.UpdateAnnouncementsRecipientsMutation>;
export type UpdateAnnouncementsRecipientsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAnnouncementsRecipientsMutation, Types.UpdateAnnouncementsRecipientsMutationVariables>;
export const GetTemplatesForCopysmithDocument = gql`
    query GetTemplatesForCopysmith {
  getTemplatesForCopysmith
}
    `;

/**
 * __useGetTemplatesForCopysmithQuery__
 *
 * To run a query within a React component, call `useGetTemplatesForCopysmithQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesForCopysmithQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesForCopysmithQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesForCopysmithQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetTemplatesForCopysmithQuery, Types.GetTemplatesForCopysmithQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTemplatesForCopysmithQuery, Types.GetTemplatesForCopysmithQueryVariables>(GetTemplatesForCopysmithDocument, options);
      }
export function useGetTemplatesForCopysmithLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTemplatesForCopysmithQuery, Types.GetTemplatesForCopysmithQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTemplatesForCopysmithQuery, Types.GetTemplatesForCopysmithQueryVariables>(GetTemplatesForCopysmithDocument, options);
        }
export type GetTemplatesForCopysmithQueryHookResult = ReturnType<typeof useGetTemplatesForCopysmithQuery>;
export type GetTemplatesForCopysmithLazyQueryHookResult = ReturnType<typeof useGetTemplatesForCopysmithLazyQuery>;
export type GetTemplatesForCopysmithQueryResult = Apollo.QueryResult<Types.GetTemplatesForCopysmithQuery, Types.GetTemplatesForCopysmithQueryVariables>;
export const ApproveAssetDocument = gql`
    mutation ApproveAsset($input: ApproveAssetInput!) {
  publicApproveAssets(input: $input) {
    id
  }
}
    `;
export type ApproveAssetMutationFn = Apollo.MutationFunction<Types.ApproveAssetMutation, Types.ApproveAssetMutationVariables>;

/**
 * __useApproveAssetMutation__
 *
 * To run a mutation, you first call `useApproveAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAssetMutation, { data, loading, error }] = useApproveAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.ApproveAssetMutation, Types.ApproveAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ApproveAssetMutation, Types.ApproveAssetMutationVariables>(ApproveAssetDocument, options);
      }
export type ApproveAssetMutationHookResult = ReturnType<typeof useApproveAssetMutation>;
export type ApproveAssetMutationResult = Apollo.MutationResult<Types.ApproveAssetMutation>;
export type ApproveAssetMutationOptions = Apollo.BaseMutationOptions<Types.ApproveAssetMutation, Types.ApproveAssetMutationVariables>;
export const CreateAssetDocument = gql`
    mutation CreateAsset($input: CreateAssetInput!) {
  createAsset(input: $input) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export type CreateAssetMutationFn = Apollo.MutationFunction<Types.CreateAssetMutation, Types.CreateAssetMutationVariables>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAssetMutation, Types.CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAssetMutation, Types.CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<Types.CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<Types.CreateAssetMutation, Types.CreateAssetMutationVariables>;
export const CreateAssetsModuleDocument = gql`
    mutation CreateAssetsModule($input: CreateLaunchModuleInput!) {
  createLaunchModule(input: $input) {
    ...LaunchAssetsModule
  }
}
    ${LaunchAssetsModuleFragmentDoc}`;
export type CreateAssetsModuleMutationFn = Apollo.MutationFunction<Types.CreateAssetsModuleMutation, Types.CreateAssetsModuleMutationVariables>;

/**
 * __useCreateAssetsModuleMutation__
 *
 * To run a mutation, you first call `useCreateAssetsModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetsModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetsModuleMutation, { data, loading, error }] = useCreateAssetsModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetsModuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAssetsModuleMutation, Types.CreateAssetsModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAssetsModuleMutation, Types.CreateAssetsModuleMutationVariables>(CreateAssetsModuleDocument, options);
      }
export type CreateAssetsModuleMutationHookResult = ReturnType<typeof useCreateAssetsModuleMutation>;
export type CreateAssetsModuleMutationResult = Apollo.MutationResult<Types.CreateAssetsModuleMutation>;
export type CreateAssetsModuleMutationOptions = Apollo.BaseMutationOptions<Types.CreateAssetsModuleMutation, Types.CreateAssetsModuleMutationVariables>;
export const DeleteAssetDocument = gql`
    mutation DeleteAsset($id: String!) {
  deleteAsset(id: $id) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export type DeleteAssetMutationFn = Apollo.MutationFunction<Types.DeleteAssetMutation, Types.DeleteAssetMutationVariables>;

/**
 * __useDeleteAssetMutation__
 *
 * To run a mutation, you first call `useDeleteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetMutation, { data, loading, error }] = useDeleteAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAssetMutation, Types.DeleteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAssetMutation, Types.DeleteAssetMutationVariables>(DeleteAssetDocument, options);
      }
export type DeleteAssetMutationHookResult = ReturnType<typeof useDeleteAssetMutation>;
export type DeleteAssetMutationResult = Apollo.MutationResult<Types.DeleteAssetMutation>;
export type DeleteAssetMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAssetMutation, Types.DeleteAssetMutationVariables>;
export const DragAssetDocument = gql`
    mutation DragAsset($input: DragAssetInput!) {
  dragOrgAsset(input: $input) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export type DragAssetMutationFn = Apollo.MutationFunction<Types.DragAssetMutation, Types.DragAssetMutationVariables>;

/**
 * __useDragAssetMutation__
 *
 * To run a mutation, you first call `useDragAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDragAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dragAssetMutation, { data, loading, error }] = useDragAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDragAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.DragAssetMutation, Types.DragAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DragAssetMutation, Types.DragAssetMutationVariables>(DragAssetDocument, options);
      }
export type DragAssetMutationHookResult = ReturnType<typeof useDragAssetMutation>;
export type DragAssetMutationResult = Apollo.MutationResult<Types.DragAssetMutation>;
export type DragAssetMutationOptions = Apollo.BaseMutationOptions<Types.DragAssetMutation, Types.DragAssetMutationVariables>;
export const GenerateCopyUsingSummaryDocument = gql`
    mutation GenerateCopyUsingSummary($input: GenerateCopyUsingSummaryInput!) {
  generateCopyUsingSummary(input: $input)
}
    `;
export type GenerateCopyUsingSummaryMutationFn = Apollo.MutationFunction<Types.GenerateCopyUsingSummaryMutation, Types.GenerateCopyUsingSummaryMutationVariables>;

/**
 * __useGenerateCopyUsingSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateCopyUsingSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCopyUsingSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCopyUsingSummaryMutation, { data, loading, error }] = useGenerateCopyUsingSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCopyUsingSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateCopyUsingSummaryMutation, Types.GenerateCopyUsingSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateCopyUsingSummaryMutation, Types.GenerateCopyUsingSummaryMutationVariables>(GenerateCopyUsingSummaryDocument, options);
      }
export type GenerateCopyUsingSummaryMutationHookResult = ReturnType<typeof useGenerateCopyUsingSummaryMutation>;
export type GenerateCopyUsingSummaryMutationResult = Apollo.MutationResult<Types.GenerateCopyUsingSummaryMutation>;
export type GenerateCopyUsingSummaryMutationOptions = Apollo.BaseMutationOptions<Types.GenerateCopyUsingSummaryMutation, Types.GenerateCopyUsingSummaryMutationVariables>;
export const RequestApproveAssetDocument = gql`
    mutation RequestApproveAsset($input: RequestApproveAssetInput!) {
  requestApproveAsset(input: $input) {
    email
    sent
  }
}
    `;
export type RequestApproveAssetMutationFn = Apollo.MutationFunction<Types.RequestApproveAssetMutation, Types.RequestApproveAssetMutationVariables>;

/**
 * __useRequestApproveAssetMutation__
 *
 * To run a mutation, you first call `useRequestApproveAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApproveAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApproveAssetMutation, { data, loading, error }] = useRequestApproveAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestApproveAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.RequestApproveAssetMutation, Types.RequestApproveAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RequestApproveAssetMutation, Types.RequestApproveAssetMutationVariables>(RequestApproveAssetDocument, options);
      }
export type RequestApproveAssetMutationHookResult = ReturnType<typeof useRequestApproveAssetMutation>;
export type RequestApproveAssetMutationResult = Apollo.MutationResult<Types.RequestApproveAssetMutation>;
export type RequestApproveAssetMutationOptions = Apollo.BaseMutationOptions<Types.RequestApproveAssetMutation, Types.RequestApproveAssetMutationVariables>;
export const UpdateAssetApproverDocument = gql`
    mutation UpdateAssetApprover($input: UpdateAssetApproverInput!) {
  updateApproverInAsset(input: $input) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export type UpdateAssetApproverMutationFn = Apollo.MutationFunction<Types.UpdateAssetApproverMutation, Types.UpdateAssetApproverMutationVariables>;

/**
 * __useUpdateAssetApproverMutation__
 *
 * To run a mutation, you first call `useUpdateAssetApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetApproverMutation, { data, loading, error }] = useUpdateAssetApproverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetApproverMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAssetApproverMutation, Types.UpdateAssetApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAssetApproverMutation, Types.UpdateAssetApproverMutationVariables>(UpdateAssetApproverDocument, options);
      }
export type UpdateAssetApproverMutationHookResult = ReturnType<typeof useUpdateAssetApproverMutation>;
export type UpdateAssetApproverMutationResult = Apollo.MutationResult<Types.UpdateAssetApproverMutation>;
export type UpdateAssetApproverMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAssetApproverMutation, Types.UpdateAssetApproverMutationVariables>;
export const UpdateAssetDocument = gql`
    mutation UpdateAsset($input: UpdateAssetInput!) {
  updateAsset(input: $input) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export type UpdateAssetMutationFn = Apollo.MutationFunction<Types.UpdateAssetMutation, Types.UpdateAssetMutationVariables>;

/**
 * __useUpdateAssetMutation__
 *
 * To run a mutation, you first call `useUpdateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetMutation, { data, loading, error }] = useUpdateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAssetMutation, Types.UpdateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAssetMutation, Types.UpdateAssetMutationVariables>(UpdateAssetDocument, options);
      }
export type UpdateAssetMutationHookResult = ReturnType<typeof useUpdateAssetMutation>;
export type UpdateAssetMutationResult = Apollo.MutationResult<Types.UpdateAssetMutation>;
export type UpdateAssetMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAssetMutation, Types.UpdateAssetMutationVariables>;
export const UpdateAssetsModuleInputDocument = gql`
    mutation UpdateAssetsModuleInput($input: UpdateLaunchModuleUserInputInput!) {
  updateLaunchModuleUserInput(input: $input) {
    id
    approvalStatus
    ...LaunchAssetsModuleContent
  }
}
    ${LaunchAssetsModuleContentFragmentDoc}`;
export type UpdateAssetsModuleInputMutationFn = Apollo.MutationFunction<Types.UpdateAssetsModuleInputMutation, Types.UpdateAssetsModuleInputMutationVariables>;

/**
 * __useUpdateAssetsModuleInputMutation__
 *
 * To run a mutation, you first call `useUpdateAssetsModuleInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetsModuleInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetsModuleInputMutation, { data, loading, error }] = useUpdateAssetsModuleInputMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetsModuleInputMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAssetsModuleInputMutation, Types.UpdateAssetsModuleInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAssetsModuleInputMutation, Types.UpdateAssetsModuleInputMutationVariables>(UpdateAssetsModuleInputDocument, options);
      }
export type UpdateAssetsModuleInputMutationHookResult = ReturnType<typeof useUpdateAssetsModuleInputMutation>;
export type UpdateAssetsModuleInputMutationResult = Apollo.MutationResult<Types.UpdateAssetsModuleInputMutation>;
export type UpdateAssetsModuleInputMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAssetsModuleInputMutation, Types.UpdateAssetsModuleInputMutationVariables>;
export const UpdateLaunchAssetsApprovalStatusDocument = gql`
    mutation UpdateLaunchAssetsApprovalStatus($input: UpdateLaunchModuleApprovalStatusInput!) {
  updateLaunchModuleApprovalStatus(input: $input) {
    ...LaunchAssetsModule
  }
}
    ${LaunchAssetsModuleFragmentDoc}`;
export type UpdateLaunchAssetsApprovalStatusMutationFn = Apollo.MutationFunction<Types.UpdateLaunchAssetsApprovalStatusMutation, Types.UpdateLaunchAssetsApprovalStatusMutationVariables>;

/**
 * __useUpdateLaunchAssetsApprovalStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchAssetsApprovalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchAssetsApprovalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchAssetsApprovalStatusMutation, { data, loading, error }] = useUpdateLaunchAssetsApprovalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchAssetsApprovalStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchAssetsApprovalStatusMutation, Types.UpdateLaunchAssetsApprovalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchAssetsApprovalStatusMutation, Types.UpdateLaunchAssetsApprovalStatusMutationVariables>(UpdateLaunchAssetsApprovalStatusDocument, options);
      }
export type UpdateLaunchAssetsApprovalStatusMutationHookResult = ReturnType<typeof useUpdateLaunchAssetsApprovalStatusMutation>;
export type UpdateLaunchAssetsApprovalStatusMutationResult = Apollo.MutationResult<Types.UpdateLaunchAssetsApprovalStatusMutation>;
export type UpdateLaunchAssetsApprovalStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchAssetsApprovalStatusMutation, Types.UpdateLaunchAssetsApprovalStatusMutationVariables>;
export const AssetDocument = gql`
    query Asset($id: String!) {
  asset(id: $id) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;

/**
 * __useAssetQuery__
 *
 * To run a query within a React component, call `useAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetQuery(baseOptions: Apollo.QueryHookOptions<Types.AssetQuery, Types.AssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AssetQuery, Types.AssetQueryVariables>(AssetDocument, options);
      }
export function useAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AssetQuery, Types.AssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AssetQuery, Types.AssetQueryVariables>(AssetDocument, options);
        }
export type AssetQueryHookResult = ReturnType<typeof useAssetQuery>;
export type AssetLazyQueryHookResult = ReturnType<typeof useAssetLazyQuery>;
export type AssetQueryResult = Apollo.QueryResult<Types.AssetQuery, Types.AssetQueryVariables>;
export const AssetIdsDocument = gql`
    query AssetIds($sort: SortAssetsInput, $filter: FilterAssetsInput) {
  assets(sort: $sort, filter: $filter) {
    id
  }
}
    `;

/**
 * __useAssetIdsQuery__
 *
 * To run a query within a React component, call `useAssetIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetIdsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAssetIdsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AssetIdsQuery, Types.AssetIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AssetIdsQuery, Types.AssetIdsQueryVariables>(AssetIdsDocument, options);
      }
export function useAssetIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AssetIdsQuery, Types.AssetIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AssetIdsQuery, Types.AssetIdsQueryVariables>(AssetIdsDocument, options);
        }
export type AssetIdsQueryHookResult = ReturnType<typeof useAssetIdsQuery>;
export type AssetIdsLazyQueryHookResult = ReturnType<typeof useAssetIdsLazyQuery>;
export type AssetIdsQueryResult = Apollo.QueryResult<Types.AssetIdsQuery, Types.AssetIdsQueryVariables>;
export const AssetTagsDocument = gql`
    query AssetTags($launchId: String) {
  productLineTags: tags(
    input: {types: [PRODUCT_LINE], launchId: $launchId, parentName: LAUNCH}
  ) {
    ...Tag
  }
  launchTags: tags(input: {types: [LAUNCH_NAME]}) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __useAssetTagsQuery__
 *
 * To run a query within a React component, call `useAssetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetTagsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useAssetTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AssetTagsQuery, Types.AssetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AssetTagsQuery, Types.AssetTagsQueryVariables>(AssetTagsDocument, options);
      }
export function useAssetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AssetTagsQuery, Types.AssetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AssetTagsQuery, Types.AssetTagsQueryVariables>(AssetTagsDocument, options);
        }
export type AssetTagsQueryHookResult = ReturnType<typeof useAssetTagsQuery>;
export type AssetTagsLazyQueryHookResult = ReturnType<typeof useAssetTagsLazyQuery>;
export type AssetTagsQueryResult = Apollo.QueryResult<Types.AssetTagsQuery, Types.AssetTagsQueryVariables>;
export const AssetsPreviewDocument = gql`
    query AssetsPreview($sort: SortAssetsInput, $filter: FilterAssetsInput) {
  assets(sort: $sort, filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __useAssetsPreviewQuery__
 *
 * To run a query within a React component, call `useAssetsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsPreviewQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAssetsPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.AssetsPreviewQuery, Types.AssetsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AssetsPreviewQuery, Types.AssetsPreviewQueryVariables>(AssetsPreviewDocument, options);
      }
export function useAssetsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AssetsPreviewQuery, Types.AssetsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AssetsPreviewQuery, Types.AssetsPreviewQueryVariables>(AssetsPreviewDocument, options);
        }
export type AssetsPreviewQueryHookResult = ReturnType<typeof useAssetsPreviewQuery>;
export type AssetsPreviewLazyQueryHookResult = ReturnType<typeof useAssetsPreviewLazyQuery>;
export type AssetsPreviewQueryResult = Apollo.QueryResult<Types.AssetsPreviewQuery, Types.AssetsPreviewQueryVariables>;
export const LaunchModulesDataDocument = gql`
    query LaunchModulesData($id: String!, $filter: FilterLaunchSectionInput) {
  launch(id: $id) {
    id
    name
    launchSections(filter: $filter) {
      id
      name
      launchModules {
        id
        name
        editor
        userInput {
          id
          WYSIWYG_EDITOR
          TARGET_AUDIENCE_EDITOR_NEW {
            id
            name
          }
          POSITIONING_EDITOR_NEW {
            title
            text
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLaunchModulesDataQuery__
 *
 * To run a query within a React component, call `useLaunchModulesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchModulesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchModulesDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLaunchModulesDataQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchModulesDataQuery, Types.LaunchModulesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchModulesDataQuery, Types.LaunchModulesDataQueryVariables>(LaunchModulesDataDocument, options);
      }
export function useLaunchModulesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchModulesDataQuery, Types.LaunchModulesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchModulesDataQuery, Types.LaunchModulesDataQueryVariables>(LaunchModulesDataDocument, options);
        }
export type LaunchModulesDataQueryHookResult = ReturnType<typeof useLaunchModulesDataQuery>;
export type LaunchModulesDataLazyQueryHookResult = ReturnType<typeof useLaunchModulesDataLazyQuery>;
export type LaunchModulesDataQueryResult = Apollo.QueryResult<Types.LaunchModulesDataQuery, Types.LaunchModulesDataQueryVariables>;
export const PaginatedAssetGroupsDocument = gql`
    query PaginatedAssetGroups($filter: FilterAssetsInput, $pagination: PaginationInput) {
  paginatedAssetGroups(filter: $filter, pagination: $pagination) {
    limit
    page
    totalPages
    docs {
      key
      title
      color
      docs {
        ...Asset
      }
    }
  }
}
    ${AssetFragmentDoc}`;

/**
 * __usePaginatedAssetGroupsQuery__
 *
 * To run a query within a React component, call `usePaginatedAssetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAssetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAssetGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedAssetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedAssetGroupsQuery, Types.PaginatedAssetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedAssetGroupsQuery, Types.PaginatedAssetGroupsQueryVariables>(PaginatedAssetGroupsDocument, options);
      }
export function usePaginatedAssetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedAssetGroupsQuery, Types.PaginatedAssetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedAssetGroupsQuery, Types.PaginatedAssetGroupsQueryVariables>(PaginatedAssetGroupsDocument, options);
        }
export type PaginatedAssetGroupsQueryHookResult = ReturnType<typeof usePaginatedAssetGroupsQuery>;
export type PaginatedAssetGroupsLazyQueryHookResult = ReturnType<typeof usePaginatedAssetGroupsLazyQuery>;
export type PaginatedAssetGroupsQueryResult = Apollo.QueryResult<Types.PaginatedAssetGroupsQuery, Types.PaginatedAssetGroupsQueryVariables>;
export const PaginatedAssetsDocument = gql`
    query PaginatedAssets($sort: SortAssetsInput, $filter: FilterAssetsInput, $pagination: PaginationInput) {
  paginatedAssets(sort: $sort, filter: $filter, pagination: $pagination) {
    page
    totalDocs
    totalPages
    docs {
      ...Asset
    }
  }
}
    ${AssetFragmentDoc}`;

/**
 * __usePaginatedAssetsQuery__
 *
 * To run a query within a React component, call `usePaginatedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAssetsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedAssetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedAssetsQuery, Types.PaginatedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedAssetsQuery, Types.PaginatedAssetsQueryVariables>(PaginatedAssetsDocument, options);
      }
export function usePaginatedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedAssetsQuery, Types.PaginatedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedAssetsQuery, Types.PaginatedAssetsQueryVariables>(PaginatedAssetsDocument, options);
        }
export type PaginatedAssetsQueryHookResult = ReturnType<typeof usePaginatedAssetsQuery>;
export type PaginatedAssetsLazyQueryHookResult = ReturnType<typeof usePaginatedAssetsLazyQuery>;
export type PaginatedAssetsQueryResult = Apollo.QueryResult<Types.PaginatedAssetsQuery, Types.PaginatedAssetsQueryVariables>;
export const PublicLaunchPagePaginatedAssetsDocument = gql`
    query PublicLaunchPagePaginatedAssets($pagination: PaginationInput, $filter: FilterAssetsInput, $sort: SortAssetsInput) {
  publicLaunchPagePaginatedAssets(
    pagination: $pagination
    filter: $filter
    sort: $sort
  ) {
    page
    totalPages
    totalDocs
    docs {
      ...Asset
    }
  }
}
    ${AssetFragmentDoc}`;

/**
 * __usePublicLaunchPagePaginatedAssetsQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPagePaginatedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPagePaginatedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPagePaginatedAssetsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePublicLaunchPagePaginatedAssetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPagePaginatedAssetsQuery, Types.PublicLaunchPagePaginatedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPagePaginatedAssetsQuery, Types.PublicLaunchPagePaginatedAssetsQueryVariables>(PublicLaunchPagePaginatedAssetsDocument, options);
      }
export function usePublicLaunchPagePaginatedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPagePaginatedAssetsQuery, Types.PublicLaunchPagePaginatedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPagePaginatedAssetsQuery, Types.PublicLaunchPagePaginatedAssetsQueryVariables>(PublicLaunchPagePaginatedAssetsDocument, options);
        }
export type PublicLaunchPagePaginatedAssetsQueryHookResult = ReturnType<typeof usePublicLaunchPagePaginatedAssetsQuery>;
export type PublicLaunchPagePaginatedAssetsLazyQueryHookResult = ReturnType<typeof usePublicLaunchPagePaginatedAssetsLazyQuery>;
export type PublicLaunchPagePaginatedAssetsQueryResult = Apollo.QueryResult<Types.PublicLaunchPagePaginatedAssetsQuery, Types.PublicLaunchPagePaginatedAssetsQueryVariables>;
export const CreateCheckoutLinkV2Document = gql`
    mutation CreateCheckoutLinkV2($input: StripeCheckoutLinkV2Input!) {
  createCheckoutLinkV2(input: $input)
}
    `;
export type CreateCheckoutLinkV2MutationFn = Apollo.MutationFunction<Types.CreateCheckoutLinkV2Mutation, Types.CreateCheckoutLinkV2MutationVariables>;

/**
 * __useCreateCheckoutLinkV2Mutation__
 *
 * To run a mutation, you first call `useCreateCheckoutLinkV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutLinkV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutLinkV2Mutation, { data, loading, error }] = useCreateCheckoutLinkV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutLinkV2Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCheckoutLinkV2Mutation, Types.CreateCheckoutLinkV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCheckoutLinkV2Mutation, Types.CreateCheckoutLinkV2MutationVariables>(CreateCheckoutLinkV2Document, options);
      }
export type CreateCheckoutLinkV2MutationHookResult = ReturnType<typeof useCreateCheckoutLinkV2Mutation>;
export type CreateCheckoutLinkV2MutationResult = Apollo.MutationResult<Types.CreateCheckoutLinkV2Mutation>;
export type CreateCheckoutLinkV2MutationOptions = Apollo.BaseMutationOptions<Types.CreateCheckoutLinkV2Mutation, Types.CreateCheckoutLinkV2MutationVariables>;
export const CreateCheckoutLinkV3Document = gql`
    mutation CreateCheckoutLinkV3($input: StripeCheckoutLinkV3Input!) {
  createCheckoutLinkV3(input: $input)
}
    `;
export type CreateCheckoutLinkV3MutationFn = Apollo.MutationFunction<Types.CreateCheckoutLinkV3Mutation, Types.CreateCheckoutLinkV3MutationVariables>;

/**
 * __useCreateCheckoutLinkV3Mutation__
 *
 * To run a mutation, you first call `useCreateCheckoutLinkV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutLinkV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutLinkV3Mutation, { data, loading, error }] = useCreateCheckoutLinkV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutLinkV3Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCheckoutLinkV3Mutation, Types.CreateCheckoutLinkV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCheckoutLinkV3Mutation, Types.CreateCheckoutLinkV3MutationVariables>(CreateCheckoutLinkV3Document, options);
      }
export type CreateCheckoutLinkV3MutationHookResult = ReturnType<typeof useCreateCheckoutLinkV3Mutation>;
export type CreateCheckoutLinkV3MutationResult = Apollo.MutationResult<Types.CreateCheckoutLinkV3Mutation>;
export type CreateCheckoutLinkV3MutationOptions = Apollo.BaseMutationOptions<Types.CreateCheckoutLinkV3Mutation, Types.CreateCheckoutLinkV3MutationVariables>;
export const CreateMbCheckoutLinkDocument = gql`
    mutation CreateMbCheckoutLink($frequency: String!, $priceIds: [String!]!, $quantity: Float!) {
  MBCheckoutURL(frequency: $frequency, priceIds: $priceIds, quantity: $quantity)
}
    `;
export type CreateMbCheckoutLinkMutationFn = Apollo.MutationFunction<Types.CreateMbCheckoutLinkMutation, Types.CreateMbCheckoutLinkMutationVariables>;

/**
 * __useCreateMbCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useCreateMbCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMbCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMbCheckoutLinkMutation, { data, loading, error }] = useCreateMbCheckoutLinkMutation({
 *   variables: {
 *      frequency: // value for 'frequency'
 *      priceIds: // value for 'priceIds'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useCreateMbCheckoutLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMbCheckoutLinkMutation, Types.CreateMbCheckoutLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMbCheckoutLinkMutation, Types.CreateMbCheckoutLinkMutationVariables>(CreateMbCheckoutLinkDocument, options);
      }
export type CreateMbCheckoutLinkMutationHookResult = ReturnType<typeof useCreateMbCheckoutLinkMutation>;
export type CreateMbCheckoutLinkMutationResult = Apollo.MutationResult<Types.CreateMbCheckoutLinkMutation>;
export type CreateMbCheckoutLinkMutationOptions = Apollo.BaseMutationOptions<Types.CreateMbCheckoutLinkMutation, Types.CreateMbCheckoutLinkMutationVariables>;
export const MbCreateSubscriptionDocument = gql`
    mutation MBCreateSubscription($priceIds: [String!]!, $quantity: Float!, $frequency: String!) {
  MBCreateSubscription(
    priceIds: $priceIds
    quantity: $quantity
    frequency: $frequency
  ) {
    id
    start_date
    end_date
    status
    computed_entitlements {
      ...MapleEntitlement
    }
  }
}
    ${MapleEntitlementFragmentDoc}`;
export type MbCreateSubscriptionMutationFn = Apollo.MutationFunction<Types.MbCreateSubscriptionMutation, Types.MbCreateSubscriptionMutationVariables>;

/**
 * __useMbCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useMbCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMbCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mbCreateSubscriptionMutation, { data, loading, error }] = useMbCreateSubscriptionMutation({
 *   variables: {
 *      priceIds: // value for 'priceIds'
 *      quantity: // value for 'quantity'
 *      frequency: // value for 'frequency'
 *   },
 * });
 */
export function useMbCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.MbCreateSubscriptionMutation, Types.MbCreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MbCreateSubscriptionMutation, Types.MbCreateSubscriptionMutationVariables>(MbCreateSubscriptionDocument, options);
      }
export type MbCreateSubscriptionMutationHookResult = ReturnType<typeof useMbCreateSubscriptionMutation>;
export type MbCreateSubscriptionMutationResult = Apollo.MutationResult<Types.MbCreateSubscriptionMutation>;
export type MbCreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<Types.MbCreateSubscriptionMutation, Types.MbCreateSubscriptionMutationVariables>;
export const AvailableProductsV2Document = gql`
    query AvailableProductsV2 {
  availableProductsV2 {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;

/**
 * __useAvailableProductsV2Query__
 *
 * To run a query within a React component, call `useAvailableProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProductsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useAvailableProductsV2Query(baseOptions?: Apollo.QueryHookOptions<Types.AvailableProductsV2Query, Types.AvailableProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AvailableProductsV2Query, Types.AvailableProductsV2QueryVariables>(AvailableProductsV2Document, options);
      }
export function useAvailableProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AvailableProductsV2Query, Types.AvailableProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AvailableProductsV2Query, Types.AvailableProductsV2QueryVariables>(AvailableProductsV2Document, options);
        }
export type AvailableProductsV2QueryHookResult = ReturnType<typeof useAvailableProductsV2Query>;
export type AvailableProductsV2LazyQueryHookResult = ReturnType<typeof useAvailableProductsV2LazyQuery>;
export type AvailableProductsV2QueryResult = Apollo.QueryResult<Types.AvailableProductsV2Query, Types.AvailableProductsV2QueryVariables>;
export const AvailableProductsV3Document = gql`
    query AvailableProductsV3 {
  availableProductsV3 {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;

/**
 * __useAvailableProductsV3Query__
 *
 * To run a query within a React component, call `useAvailableProductsV3Query` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProductsV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProductsV3Query({
 *   variables: {
 *   },
 * });
 */
export function useAvailableProductsV3Query(baseOptions?: Apollo.QueryHookOptions<Types.AvailableProductsV3Query, Types.AvailableProductsV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AvailableProductsV3Query, Types.AvailableProductsV3QueryVariables>(AvailableProductsV3Document, options);
      }
export function useAvailableProductsV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AvailableProductsV3Query, Types.AvailableProductsV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AvailableProductsV3Query, Types.AvailableProductsV3QueryVariables>(AvailableProductsV3Document, options);
        }
export type AvailableProductsV3QueryHookResult = ReturnType<typeof useAvailableProductsV3Query>;
export type AvailableProductsV3LazyQueryHookResult = ReturnType<typeof useAvailableProductsV3LazyQuery>;
export type AvailableProductsV3QueryResult = Apollo.QueryResult<Types.AvailableProductsV3Query, Types.AvailableProductsV3QueryVariables>;
export const GetMbPaymentMethodUrlDocument = gql`
    query GetMbPaymentMethodURL {
  MBPaymentMethodURL
}
    `;

/**
 * __useGetMbPaymentMethodUrlQuery__
 *
 * To run a query within a React component, call `useGetMbPaymentMethodUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMbPaymentMethodUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMbPaymentMethodUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMbPaymentMethodUrlQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMbPaymentMethodUrlQuery, Types.GetMbPaymentMethodUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMbPaymentMethodUrlQuery, Types.GetMbPaymentMethodUrlQueryVariables>(GetMbPaymentMethodUrlDocument, options);
      }
export function useGetMbPaymentMethodUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMbPaymentMethodUrlQuery, Types.GetMbPaymentMethodUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMbPaymentMethodUrlQuery, Types.GetMbPaymentMethodUrlQueryVariables>(GetMbPaymentMethodUrlDocument, options);
        }
export type GetMbPaymentMethodUrlQueryHookResult = ReturnType<typeof useGetMbPaymentMethodUrlQuery>;
export type GetMbPaymentMethodUrlLazyQueryHookResult = ReturnType<typeof useGetMbPaymentMethodUrlLazyQuery>;
export type GetMbPaymentMethodUrlQueryResult = Apollo.QueryResult<Types.GetMbPaymentMethodUrlQuery, Types.GetMbPaymentMethodUrlQueryVariables>;
export const IsMapleBillingDocument = gql`
    query IsMapleBilling {
  organization {
    id
    mapleBillingCustomerId
  }
}
    `;

/**
 * __useIsMapleBillingQuery__
 *
 * To run a query within a React component, call `useIsMapleBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMapleBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMapleBillingQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsMapleBillingQuery(baseOptions?: Apollo.QueryHookOptions<Types.IsMapleBillingQuery, Types.IsMapleBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IsMapleBillingQuery, Types.IsMapleBillingQueryVariables>(IsMapleBillingDocument, options);
      }
export function useIsMapleBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IsMapleBillingQuery, Types.IsMapleBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IsMapleBillingQuery, Types.IsMapleBillingQueryVariables>(IsMapleBillingDocument, options);
        }
export type IsMapleBillingQueryHookResult = ReturnType<typeof useIsMapleBillingQuery>;
export type IsMapleBillingLazyQueryHookResult = ReturnType<typeof useIsMapleBillingLazyQuery>;
export type IsMapleBillingQueryResult = Apollo.QueryResult<Types.IsMapleBillingQuery, Types.IsMapleBillingQueryVariables>;
export const MbAccessDocument = gql`
    query MBAccess {
  MBAccess {
    organizationId
    canCreateLaunch
    canCreateBattleCard
    canCreateSurvey
    canCreateProductIdeaBoard
    canCreateRoadmap
    canCreateRoadmapItem
  }
}
    `;

/**
 * __useMbAccessQuery__
 *
 * To run a query within a React component, call `useMbAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useMbAccessQuery(baseOptions?: Apollo.QueryHookOptions<Types.MbAccessQuery, Types.MbAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MbAccessQuery, Types.MbAccessQueryVariables>(MbAccessDocument, options);
      }
export function useMbAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MbAccessQuery, Types.MbAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MbAccessQuery, Types.MbAccessQueryVariables>(MbAccessDocument, options);
        }
export type MbAccessQueryHookResult = ReturnType<typeof useMbAccessQuery>;
export type MbAccessLazyQueryHookResult = ReturnType<typeof useMbAccessLazyQuery>;
export type MbAccessQueryResult = Apollo.QueryResult<Types.MbAccessQuery, Types.MbAccessQueryVariables>;
export const MbActiveSubscriptionsDocument = gql`
    query MBActiveSubscriptions {
  MBActiveSubscriptions {
    ...MapleSubscription
  }
}
    ${MapleSubscriptionFragmentDoc}`;

/**
 * __useMbActiveSubscriptionsQuery__
 *
 * To run a query within a React component, call `useMbActiveSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbActiveSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbActiveSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMbActiveSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.MbActiveSubscriptionsQuery, Types.MbActiveSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MbActiveSubscriptionsQuery, Types.MbActiveSubscriptionsQueryVariables>(MbActiveSubscriptionsDocument, options);
      }
export function useMbActiveSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MbActiveSubscriptionsQuery, Types.MbActiveSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MbActiveSubscriptionsQuery, Types.MbActiveSubscriptionsQueryVariables>(MbActiveSubscriptionsDocument, options);
        }
export type MbActiveSubscriptionsQueryHookResult = ReturnType<typeof useMbActiveSubscriptionsQuery>;
export type MbActiveSubscriptionsLazyQueryHookResult = ReturnType<typeof useMbActiveSubscriptionsLazyQuery>;
export type MbActiveSubscriptionsQueryResult = Apollo.QueryResult<Types.MbActiveSubscriptionsQuery, Types.MbActiveSubscriptionsQueryVariables>;
export const MbAvailableProductsDocument = gql`
    query MBAvailableProducts {
  MBAvailableProducts {
    ...MaplePlan
  }
}
    ${MaplePlanFragmentDoc}`;

/**
 * __useMbAvailableProductsQuery__
 *
 * To run a query within a React component, call `useMbAvailableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbAvailableProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbAvailableProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMbAvailableProductsQuery(baseOptions?: Apollo.QueryHookOptions<Types.MbAvailableProductsQuery, Types.MbAvailableProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MbAvailableProductsQuery, Types.MbAvailableProductsQueryVariables>(MbAvailableProductsDocument, options);
      }
export function useMbAvailableProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MbAvailableProductsQuery, Types.MbAvailableProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MbAvailableProductsQuery, Types.MbAvailableProductsQueryVariables>(MbAvailableProductsDocument, options);
        }
export type MbAvailableProductsQueryHookResult = ReturnType<typeof useMbAvailableProductsQuery>;
export type MbAvailableProductsLazyQueryHookResult = ReturnType<typeof useMbAvailableProductsLazyQuery>;
export type MbAvailableProductsQueryResult = Apollo.QueryResult<Types.MbAvailableProductsQuery, Types.MbAvailableProductsQueryVariables>;
export const MbHasPaymentMethodDocument = gql`
    query MBHasPaymentMethod {
  MBHasPaymentMethod
}
    `;

/**
 * __useMbHasPaymentMethodQuery__
 *
 * To run a query within a React component, call `useMbHasPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbHasPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbHasPaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useMbHasPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<Types.MbHasPaymentMethodQuery, Types.MbHasPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MbHasPaymentMethodQuery, Types.MbHasPaymentMethodQueryVariables>(MbHasPaymentMethodDocument, options);
      }
export function useMbHasPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MbHasPaymentMethodQuery, Types.MbHasPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MbHasPaymentMethodQuery, Types.MbHasPaymentMethodQueryVariables>(MbHasPaymentMethodDocument, options);
        }
export type MbHasPaymentMethodQueryHookResult = ReturnType<typeof useMbHasPaymentMethodQuery>;
export type MbHasPaymentMethodLazyQueryHookResult = ReturnType<typeof useMbHasPaymentMethodLazyQuery>;
export type MbHasPaymentMethodQueryResult = Apollo.QueryResult<Types.MbHasPaymentMethodQuery, Types.MbHasPaymentMethodQueryVariables>;
export const MbInvoicesDocument = gql`
    query MBInvoices {
  MBInvoices {
    ...MBInvoice
  }
}
    ${MbInvoiceFragmentDoc}`;

/**
 * __useMbInvoicesQuery__
 *
 * To run a query within a React component, call `useMbInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMbInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<Types.MbInvoicesQuery, Types.MbInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MbInvoicesQuery, Types.MbInvoicesQueryVariables>(MbInvoicesDocument, options);
      }
export function useMbInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MbInvoicesQuery, Types.MbInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MbInvoicesQuery, Types.MbInvoicesQueryVariables>(MbInvoicesDocument, options);
        }
export type MbInvoicesQueryHookResult = ReturnType<typeof useMbInvoicesQuery>;
export type MbInvoicesLazyQueryHookResult = ReturnType<typeof useMbInvoicesLazyQuery>;
export type MbInvoicesQueryResult = Apollo.QueryResult<Types.MbInvoicesQuery, Types.MbInvoicesQueryVariables>;
export const MbShowUpgradeButtonDocument = gql`
    query MBShowUpgradeButton {
  MBShowUpgradeButton
}
    `;

/**
 * __useMbShowUpgradeButtonQuery__
 *
 * To run a query within a React component, call `useMbShowUpgradeButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbShowUpgradeButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbShowUpgradeButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useMbShowUpgradeButtonQuery(baseOptions?: Apollo.QueryHookOptions<Types.MbShowUpgradeButtonQuery, Types.MbShowUpgradeButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MbShowUpgradeButtonQuery, Types.MbShowUpgradeButtonQueryVariables>(MbShowUpgradeButtonDocument, options);
      }
export function useMbShowUpgradeButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MbShowUpgradeButtonQuery, Types.MbShowUpgradeButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MbShowUpgradeButtonQuery, Types.MbShowUpgradeButtonQueryVariables>(MbShowUpgradeButtonDocument, options);
        }
export type MbShowUpgradeButtonQueryHookResult = ReturnType<typeof useMbShowUpgradeButtonQuery>;
export type MbShowUpgradeButtonLazyQueryHookResult = ReturnType<typeof useMbShowUpgradeButtonLazyQuery>;
export type MbShowUpgradeButtonQueryResult = Apollo.QueryResult<Types.MbShowUpgradeButtonQuery, Types.MbShowUpgradeButtonQueryVariables>;
export const MBgetPaymentMethodsDocument = gql`
    query MBgetPaymentMethods {
  MBgetPaymentMethods {
    ...MaplePaymentMethod
  }
}
    ${MaplePaymentMethodFragmentDoc}`;

/**
 * __useMBgetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useMBgetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMBgetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMBgetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMBgetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<Types.MBgetPaymentMethodsQuery, Types.MBgetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MBgetPaymentMethodsQuery, Types.MBgetPaymentMethodsQueryVariables>(MBgetPaymentMethodsDocument, options);
      }
export function useMBgetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MBgetPaymentMethodsQuery, Types.MBgetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MBgetPaymentMethodsQuery, Types.MBgetPaymentMethodsQueryVariables>(MBgetPaymentMethodsDocument, options);
        }
export type MBgetPaymentMethodsQueryHookResult = ReturnType<typeof useMBgetPaymentMethodsQuery>;
export type MBgetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useMBgetPaymentMethodsLazyQuery>;
export type MBgetPaymentMethodsQueryResult = Apollo.QueryResult<Types.MBgetPaymentMethodsQuery, Types.MBgetPaymentMethodsQueryVariables>;
export const NumberOfActiveLaunchesDocument = gql`
    query NumberOfActiveLaunches {
  numberOfActiveLaunches
}
    `;

/**
 * __useNumberOfActiveLaunchesQuery__
 *
 * To run a query within a React component, call `useNumberOfActiveLaunchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfActiveLaunchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberOfActiveLaunchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNumberOfActiveLaunchesQuery(baseOptions?: Apollo.QueryHookOptions<Types.NumberOfActiveLaunchesQuery, Types.NumberOfActiveLaunchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NumberOfActiveLaunchesQuery, Types.NumberOfActiveLaunchesQueryVariables>(NumberOfActiveLaunchesDocument, options);
      }
export function useNumberOfActiveLaunchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NumberOfActiveLaunchesQuery, Types.NumberOfActiveLaunchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NumberOfActiveLaunchesQuery, Types.NumberOfActiveLaunchesQueryVariables>(NumberOfActiveLaunchesDocument, options);
        }
export type NumberOfActiveLaunchesQueryHookResult = ReturnType<typeof useNumberOfActiveLaunchesQuery>;
export type NumberOfActiveLaunchesLazyQueryHookResult = ReturnType<typeof useNumberOfActiveLaunchesLazyQuery>;
export type NumberOfActiveLaunchesQueryResult = Apollo.QueryResult<Types.NumberOfActiveLaunchesQuery, Types.NumberOfActiveLaunchesQueryVariables>;
export const NumberOfLaunchesCurrentlyBilledDocument = gql`
    query NumberOfLaunchesCurrentlyBilled {
  numberOfLaunchesCurrentlyBilled
}
    `;

/**
 * __useNumberOfLaunchesCurrentlyBilledQuery__
 *
 * To run a query within a React component, call `useNumberOfLaunchesCurrentlyBilledQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfLaunchesCurrentlyBilledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberOfLaunchesCurrentlyBilledQuery({
 *   variables: {
 *   },
 * });
 */
export function useNumberOfLaunchesCurrentlyBilledQuery(baseOptions?: Apollo.QueryHookOptions<Types.NumberOfLaunchesCurrentlyBilledQuery, Types.NumberOfLaunchesCurrentlyBilledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NumberOfLaunchesCurrentlyBilledQuery, Types.NumberOfLaunchesCurrentlyBilledQueryVariables>(NumberOfLaunchesCurrentlyBilledDocument, options);
      }
export function useNumberOfLaunchesCurrentlyBilledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NumberOfLaunchesCurrentlyBilledQuery, Types.NumberOfLaunchesCurrentlyBilledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NumberOfLaunchesCurrentlyBilledQuery, Types.NumberOfLaunchesCurrentlyBilledQueryVariables>(NumberOfLaunchesCurrentlyBilledDocument, options);
        }
export type NumberOfLaunchesCurrentlyBilledQueryHookResult = ReturnType<typeof useNumberOfLaunchesCurrentlyBilledQuery>;
export type NumberOfLaunchesCurrentlyBilledLazyQueryHookResult = ReturnType<typeof useNumberOfLaunchesCurrentlyBilledLazyQuery>;
export type NumberOfLaunchesCurrentlyBilledQueryResult = Apollo.QueryResult<Types.NumberOfLaunchesCurrentlyBilledQuery, Types.NumberOfLaunchesCurrentlyBilledQueryVariables>;
export const ShowUpgradeButtonDocument = gql`
    query ShowUpgradeButton {
  showUpgradeButton
}
    `;

/**
 * __useShowUpgradeButtonQuery__
 *
 * To run a query within a React component, call `useShowUpgradeButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowUpgradeButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowUpgradeButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowUpgradeButtonQuery(baseOptions?: Apollo.QueryHookOptions<Types.ShowUpgradeButtonQuery, Types.ShowUpgradeButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ShowUpgradeButtonQuery, Types.ShowUpgradeButtonQueryVariables>(ShowUpgradeButtonDocument, options);
      }
export function useShowUpgradeButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ShowUpgradeButtonQuery, Types.ShowUpgradeButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ShowUpgradeButtonQuery, Types.ShowUpgradeButtonQueryVariables>(ShowUpgradeButtonDocument, options);
        }
export type ShowUpgradeButtonQueryHookResult = ReturnType<typeof useShowUpgradeButtonQuery>;
export type ShowUpgradeButtonLazyQueryHookResult = ReturnType<typeof useShowUpgradeButtonLazyQuery>;
export type ShowUpgradeButtonQueryResult = Apollo.QueryResult<Types.ShowUpgradeButtonQuery, Types.ShowUpgradeButtonQueryVariables>;
export const StripeAccessDocument = gql`
    query StripeAccess {
  stripeAccess {
    organizationId
    canCreateLaunch
    canCreateBattleCard
    canCreateSurvey
    canCreateProductIdeaBoard
    canCreateRoadmap
    canCreateRoadmapItem
  }
}
    `;

/**
 * __useStripeAccessQuery__
 *
 * To run a query within a React component, call `useStripeAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripeAccessQuery(baseOptions?: Apollo.QueryHookOptions<Types.StripeAccessQuery, Types.StripeAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StripeAccessQuery, Types.StripeAccessQueryVariables>(StripeAccessDocument, options);
      }
export function useStripeAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StripeAccessQuery, Types.StripeAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StripeAccessQuery, Types.StripeAccessQueryVariables>(StripeAccessDocument, options);
        }
export type StripeAccessQueryHookResult = ReturnType<typeof useStripeAccessQuery>;
export type StripeAccessLazyQueryHookResult = ReturnType<typeof useStripeAccessLazyQuery>;
export type StripeAccessQueryResult = Apollo.QueryResult<Types.StripeAccessQuery, Types.StripeAccessQueryVariables>;
export const ChatGtmDocument = gql`
    query ChatGTM($sessionId: String!, $query: String!) {
  chatGTM(sessionId: $sessionId, query: $query)
}
    `;

/**
 * __useChatGtmQuery__
 *
 * To run a query within a React component, call `useChatGtmQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGtmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGtmQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useChatGtmQuery(baseOptions: Apollo.QueryHookOptions<Types.ChatGtmQuery, Types.ChatGtmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChatGtmQuery, Types.ChatGtmQueryVariables>(ChatGtmDocument, options);
      }
export function useChatGtmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChatGtmQuery, Types.ChatGtmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChatGtmQuery, Types.ChatGtmQueryVariables>(ChatGtmDocument, options);
        }
export type ChatGtmQueryHookResult = ReturnType<typeof useChatGtmQuery>;
export type ChatGtmLazyQueryHookResult = ReturnType<typeof useChatGtmLazyQuery>;
export type ChatGtmQueryResult = Apollo.QueryResult<Types.ChatGtmQuery, Types.ChatGtmQueryVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    id
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<Types.CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<Types.CreateCommentMutation, Types.CreateCommentMutationVariables>;
export const RemoveCommentDocument = gql`
    mutation RemoveComment($id: String!) {
  removeComment(id: $id)
}
    `;
export type RemoveCommentMutationFn = Apollo.MutationFunction<Types.RemoveCommentMutation, Types.RemoveCommentMutationVariables>;

/**
 * __useRemoveCommentMutation__
 *
 * To run a mutation, you first call `useRemoveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentMutation, { data, loading, error }] = useRemoveCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveCommentMutation, Types.RemoveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveCommentMutation, Types.RemoveCommentMutationVariables>(RemoveCommentDocument, options);
      }
export type RemoveCommentMutationHookResult = ReturnType<typeof useRemoveCommentMutation>;
export type RemoveCommentMutationResult = Apollo.MutationResult<Types.RemoveCommentMutation>;
export type RemoveCommentMutationOptions = Apollo.BaseMutationOptions<Types.RemoveCommentMutation, Types.RemoveCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    id
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateCommentMutationFn = Apollo.MutationFunction<Types.UpdateCommentMutation, Types.UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCommentMutation, Types.UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCommentMutation, Types.UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<Types.UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCommentMutation, Types.UpdateCommentMutationVariables>;
export const CommentsDocument = gql`
    query Comments($filter: FilterCommentInput) {
  comments(filter: $filter) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CommentsQuery, Types.CommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CommentsQuery, Types.CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CommentsQuery, Types.CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CommentsQuery, Types.CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsQueryResult = Apollo.QueryResult<Types.CommentsQuery, Types.CommentsQueryVariables>;
export const PaginatedCommentsDocument = gql`
    query PaginatedComments($filter: FilterCommentInput, $pagination: PaginationInput) {
  paginatedComments(filter: $filter, pagination: $pagination) {
    docs {
      ...Comment
    }
    page
    parentId
    totalPages
  }
}
    ${CommentFragmentDoc}`;

/**
 * __usePaginatedCommentsQuery__
 *
 * To run a query within a React component, call `usePaginatedCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCommentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedCommentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedCommentsQuery, Types.PaginatedCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCommentsQuery, Types.PaginatedCommentsQueryVariables>(PaginatedCommentsDocument, options);
      }
export function usePaginatedCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCommentsQuery, Types.PaginatedCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCommentsQuery, Types.PaginatedCommentsQueryVariables>(PaginatedCommentsDocument, options);
        }
export type PaginatedCommentsQueryHookResult = ReturnType<typeof usePaginatedCommentsQuery>;
export type PaginatedCommentsLazyQueryHookResult = ReturnType<typeof usePaginatedCommentsLazyQuery>;
export type PaginatedCommentsQueryResult = Apollo.QueryResult<Types.PaginatedCommentsQuery, Types.PaginatedCommentsQueryVariables>;
export const CommentCreatedDocument = gql`
    subscription CommentCreated($parentIds: [String!]!) {
  commentCreated(parentIds: $parentIds) {
    id
    ...Comment
  }
}
    ${CommentFragmentDoc}`;

/**
 * __useCommentCreatedSubscription__
 *
 * To run a query within a React component, call `useCommentCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentCreatedSubscription({
 *   variables: {
 *      parentIds: // value for 'parentIds'
 *   },
 * });
 */
export function useCommentCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.CommentCreatedSubscription, Types.CommentCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.CommentCreatedSubscription, Types.CommentCreatedSubscriptionVariables>(CommentCreatedDocument, options);
      }
export type CommentCreatedSubscriptionHookResult = ReturnType<typeof useCommentCreatedSubscription>;
export type CommentCreatedSubscriptionResult = Apollo.SubscriptionResult<Types.CommentCreatedSubscription>;
export const CommentUpdatedDocument = gql`
    subscription CommentUpdated($parentIds: [String!]!) {
  commentUpdated(parentIds: $parentIds) {
    id
    ...Comment
  }
}
    ${CommentFragmentDoc}`;

/**
 * __useCommentUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentUpdatedSubscription({
 *   variables: {
 *      parentIds: // value for 'parentIds'
 *   },
 * });
 */
export function useCommentUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.CommentUpdatedSubscription, Types.CommentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.CommentUpdatedSubscription, Types.CommentUpdatedSubscriptionVariables>(CommentUpdatedDocument, options);
      }
export type CommentUpdatedSubscriptionHookResult = ReturnType<typeof useCommentUpdatedSubscription>;
export type CommentUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.CommentUpdatedSubscription>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($companyUrl: String!, $companyName: String, $launchId: String) {
  createCompany(
    companyUrl: $companyUrl
    companyName: $companyName
    launchId: $launchId
  ) {
    ...CompanyPreview
  }
}
    ${CompanyPreviewFragmentDoc}`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<Types.CreateCompanyMutation, Types.CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      companyUrl: // value for 'companyUrl'
 *      companyName: // value for 'companyName'
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCompanyMutation, Types.CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCompanyMutation, Types.CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<Types.CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<Types.CreateCompanyMutation, Types.CreateCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($id: String!, $launchId: String) {
  deleteCompany(id: $id, launchId: $launchId)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<Types.DeleteCompanyMutation, Types.DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCompanyMutation, Types.DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCompanyMutation, Types.DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<Types.DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCompanyMutation, Types.DeleteCompanyMutationVariables>;
export const EditCustomScreenshotDocument = gql`
    mutation EditCustomScreenshot($id: String!, $domainsList: UpdateCompanyInput!) {
  editCustomScreenshot(id: $id, domainsList: $domainsList) {
    battlecardScreenshots {
      key
      pageUrl
    }
  }
}
    `;
export type EditCustomScreenshotMutationFn = Apollo.MutationFunction<Types.EditCustomScreenshotMutation, Types.EditCustomScreenshotMutationVariables>;

/**
 * __useEditCustomScreenshotMutation__
 *
 * To run a mutation, you first call `useEditCustomScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomScreenshotMutation, { data, loading, error }] = useEditCustomScreenshotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      domainsList: // value for 'domainsList'
 *   },
 * });
 */
export function useEditCustomScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<Types.EditCustomScreenshotMutation, Types.EditCustomScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EditCustomScreenshotMutation, Types.EditCustomScreenshotMutationVariables>(EditCustomScreenshotDocument, options);
      }
export type EditCustomScreenshotMutationHookResult = ReturnType<typeof useEditCustomScreenshotMutation>;
export type EditCustomScreenshotMutationResult = Apollo.MutationResult<Types.EditCustomScreenshotMutation>;
export type EditCustomScreenshotMutationOptions = Apollo.BaseMutationOptions<Types.EditCustomScreenshotMutation, Types.EditCustomScreenshotMutationVariables>;
export const GenerateCompanyTalkingPointsDocument = gql`
    mutation GenerateCompanyTalkingPoints($companyId: String!) {
  generateCompanyTalkingPoints(companyId: $companyId) {
    id
    talkingPoints {
      title
      text
      placeholder
    }
  }
}
    `;
export type GenerateCompanyTalkingPointsMutationFn = Apollo.MutationFunction<Types.GenerateCompanyTalkingPointsMutation, Types.GenerateCompanyTalkingPointsMutationVariables>;

/**
 * __useGenerateCompanyTalkingPointsMutation__
 *
 * To run a mutation, you first call `useGenerateCompanyTalkingPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompanyTalkingPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCompanyTalkingPointsMutation, { data, loading, error }] = useGenerateCompanyTalkingPointsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGenerateCompanyTalkingPointsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateCompanyTalkingPointsMutation, Types.GenerateCompanyTalkingPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateCompanyTalkingPointsMutation, Types.GenerateCompanyTalkingPointsMutationVariables>(GenerateCompanyTalkingPointsDocument, options);
      }
export type GenerateCompanyTalkingPointsMutationHookResult = ReturnType<typeof useGenerateCompanyTalkingPointsMutation>;
export type GenerateCompanyTalkingPointsMutationResult = Apollo.MutationResult<Types.GenerateCompanyTalkingPointsMutation>;
export type GenerateCompanyTalkingPointsMutationOptions = Apollo.BaseMutationOptions<Types.GenerateCompanyTalkingPointsMutation, Types.GenerateCompanyTalkingPointsMutationVariables>;
export const GenerateGrowthToolCompanyTalkingPointsDocument = gql`
    mutation GenerateGrowthToolCompanyTalkingPoints($companyName: String!, $competitorName: String!, $competitorURL: String!) {
  generateGrowthToolCompanyTalkingPoints(
    companyName: $companyName
    competitorName: $competitorName
    competitorURL: $competitorURL
  ) {
    title
    text
    placeholder
  }
}
    `;
export type GenerateGrowthToolCompanyTalkingPointsMutationFn = Apollo.MutationFunction<Types.GenerateGrowthToolCompanyTalkingPointsMutation, Types.GenerateGrowthToolCompanyTalkingPointsMutationVariables>;

/**
 * __useGenerateGrowthToolCompanyTalkingPointsMutation__
 *
 * To run a mutation, you first call `useGenerateGrowthToolCompanyTalkingPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGrowthToolCompanyTalkingPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGrowthToolCompanyTalkingPointsMutation, { data, loading, error }] = useGenerateGrowthToolCompanyTalkingPointsMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      competitorName: // value for 'competitorName'
 *      competitorURL: // value for 'competitorURL'
 *   },
 * });
 */
export function useGenerateGrowthToolCompanyTalkingPointsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateGrowthToolCompanyTalkingPointsMutation, Types.GenerateGrowthToolCompanyTalkingPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateGrowthToolCompanyTalkingPointsMutation, Types.GenerateGrowthToolCompanyTalkingPointsMutationVariables>(GenerateGrowthToolCompanyTalkingPointsDocument, options);
      }
export type GenerateGrowthToolCompanyTalkingPointsMutationHookResult = ReturnType<typeof useGenerateGrowthToolCompanyTalkingPointsMutation>;
export type GenerateGrowthToolCompanyTalkingPointsMutationResult = Apollo.MutationResult<Types.GenerateGrowthToolCompanyTalkingPointsMutation>;
export type GenerateGrowthToolCompanyTalkingPointsMutationOptions = Apollo.BaseMutationOptions<Types.GenerateGrowthToolCompanyTalkingPointsMutation, Types.GenerateGrowthToolCompanyTalkingPointsMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    ...Company
    tagIds
  }
}
    ${CompanyFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<Types.UpdateCompanyMutation, Types.UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCompanyMutation, Types.UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCompanyMutation, Types.UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<Types.UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCompanyMutation, Types.UpdateCompanyMutationVariables>;
export const CheckExportBattlecardsConfigurationQueryDocument = gql`
    query CheckExportBattlecardsConfigurationQuery {
  checkConfigurations {
    ...ExportBattlecardConfiguration
  }
}
    ${ExportBattlecardConfigurationFragmentDoc}`;

/**
 * __useCheckExportBattlecardsConfigurationQueryQuery__
 *
 * To run a query within a React component, call `useCheckExportBattlecardsConfigurationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExportBattlecardsConfigurationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckExportBattlecardsConfigurationQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckExportBattlecardsConfigurationQueryQuery(baseOptions?: Apollo.QueryHookOptions<Types.CheckExportBattlecardsConfigurationQueryQuery, Types.CheckExportBattlecardsConfigurationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CheckExportBattlecardsConfigurationQueryQuery, Types.CheckExportBattlecardsConfigurationQueryQueryVariables>(CheckExportBattlecardsConfigurationQueryDocument, options);
      }
export function useCheckExportBattlecardsConfigurationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CheckExportBattlecardsConfigurationQueryQuery, Types.CheckExportBattlecardsConfigurationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CheckExportBattlecardsConfigurationQueryQuery, Types.CheckExportBattlecardsConfigurationQueryQueryVariables>(CheckExportBattlecardsConfigurationQueryDocument, options);
        }
export type CheckExportBattlecardsConfigurationQueryQueryHookResult = ReturnType<typeof useCheckExportBattlecardsConfigurationQueryQuery>;
export type CheckExportBattlecardsConfigurationQueryLazyQueryHookResult = ReturnType<typeof useCheckExportBattlecardsConfigurationQueryLazyQuery>;
export type CheckExportBattlecardsConfigurationQueryQueryResult = Apollo.QueryResult<Types.CheckExportBattlecardsConfigurationQueryQuery, Types.CheckExportBattlecardsConfigurationQueryQueryVariables>;
export const ClearbitCompanyDocument = gql`
    query ClearbitCompany($companyUrl: String!) {
  clearbitCompany(companyUrl: $companyUrl) {
    id
  }
}
    `;

/**
 * __useClearbitCompanyQuery__
 *
 * To run a query within a React component, call `useClearbitCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useClearbitCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClearbitCompanyQuery({
 *   variables: {
 *      companyUrl: // value for 'companyUrl'
 *   },
 * });
 */
export function useClearbitCompanyQuery(baseOptions: Apollo.QueryHookOptions<Types.ClearbitCompanyQuery, Types.ClearbitCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ClearbitCompanyQuery, Types.ClearbitCompanyQueryVariables>(ClearbitCompanyDocument, options);
      }
export function useClearbitCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ClearbitCompanyQuery, Types.ClearbitCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ClearbitCompanyQuery, Types.ClearbitCompanyQueryVariables>(ClearbitCompanyDocument, options);
        }
export type ClearbitCompanyQueryHookResult = ReturnType<typeof useClearbitCompanyQuery>;
export type ClearbitCompanyLazyQueryHookResult = ReturnType<typeof useClearbitCompanyLazyQuery>;
export type ClearbitCompanyQueryResult = Apollo.QueryResult<Types.ClearbitCompanyQuery, Types.ClearbitCompanyQueryVariables>;
export const CompaniesPreviewDocument = gql`
    query CompaniesPreview($launchId: String) {
  companies(launchId: $launchId) {
    ...CompanyPreview
  }
}
    ${CompanyPreviewFragmentDoc}`;

/**
 * __useCompaniesPreviewQuery__
 *
 * To run a query within a React component, call `useCompaniesPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesPreviewQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useCompaniesPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.CompaniesPreviewQuery, Types.CompaniesPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CompaniesPreviewQuery, Types.CompaniesPreviewQueryVariables>(CompaniesPreviewDocument, options);
      }
export function useCompaniesPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CompaniesPreviewQuery, Types.CompaniesPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CompaniesPreviewQuery, Types.CompaniesPreviewQueryVariables>(CompaniesPreviewDocument, options);
        }
export type CompaniesPreviewQueryHookResult = ReturnType<typeof useCompaniesPreviewQuery>;
export type CompaniesPreviewLazyQueryHookResult = ReturnType<typeof useCompaniesPreviewLazyQuery>;
export type CompaniesPreviewQueryResult = Apollo.QueryResult<Types.CompaniesPreviewQuery, Types.CompaniesPreviewQueryVariables>;
export const CompanyDocument = gql`
    query Company($id: String!) {
  company(id: $id) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<Types.CompanyQuery, Types.CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CompanyQuery, Types.CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CompanyQuery, Types.CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CompanyQuery, Types.CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<Types.CompanyQuery, Types.CompanyQueryVariables>;
export const CompanyInfoForSeoDocument = gql`
    query CompanyInfoForSeo($id: String!) {
  company(id: $id) {
    id
    name
    domain
  }
}
    `;

/**
 * __useCompanyInfoForSeoQuery__
 *
 * To run a query within a React component, call `useCompanyInfoForSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInfoForSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInfoForSeoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyInfoForSeoQuery(baseOptions: Apollo.QueryHookOptions<Types.CompanyInfoForSeoQuery, Types.CompanyInfoForSeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CompanyInfoForSeoQuery, Types.CompanyInfoForSeoQueryVariables>(CompanyInfoForSeoDocument, options);
      }
export function useCompanyInfoForSeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CompanyInfoForSeoQuery, Types.CompanyInfoForSeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CompanyInfoForSeoQuery, Types.CompanyInfoForSeoQueryVariables>(CompanyInfoForSeoDocument, options);
        }
export type CompanyInfoForSeoQueryHookResult = ReturnType<typeof useCompanyInfoForSeoQuery>;
export type CompanyInfoForSeoLazyQueryHookResult = ReturnType<typeof useCompanyInfoForSeoLazyQuery>;
export type CompanyInfoForSeoQueryResult = Apollo.QueryResult<Types.CompanyInfoForSeoQuery, Types.CompanyInfoForSeoQueryVariables>;
export const CompanyScreenshotsDocument = gql`
    query CompanyScreenshots($id: String!) {
  getScreenshots(id: $id) {
    id
    screenshotsObj {
      ...Screenshot
    }
  }
}
    ${ScreenshotFragmentDoc}`;

/**
 * __useCompanyScreenshotsQuery__
 *
 * To run a query within a React component, call `useCompanyScreenshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyScreenshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyScreenshotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyScreenshotsQuery(baseOptions: Apollo.QueryHookOptions<Types.CompanyScreenshotsQuery, Types.CompanyScreenshotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CompanyScreenshotsQuery, Types.CompanyScreenshotsQueryVariables>(CompanyScreenshotsDocument, options);
      }
export function useCompanyScreenshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CompanyScreenshotsQuery, Types.CompanyScreenshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CompanyScreenshotsQuery, Types.CompanyScreenshotsQueryVariables>(CompanyScreenshotsDocument, options);
        }
export type CompanyScreenshotsQueryHookResult = ReturnType<typeof useCompanyScreenshotsQuery>;
export type CompanyScreenshotsLazyQueryHookResult = ReturnType<typeof useCompanyScreenshotsLazyQuery>;
export type CompanyScreenshotsQueryResult = Apollo.QueryResult<Types.CompanyScreenshotsQuery, Types.CompanyScreenshotsQueryVariables>;
export const GrowthToolCompanyNewsDocument = gql`
    query GrowthToolCompanyNews($companyUrl: String!) {
  growthToolCompanyNews(companyUrl: $companyUrl) {
    page
    limit
    totalDocs
    totalPages
    hasNextPage
    docs {
      ...CompetitorCompanyNewsArticle
    }
  }
}
    ${CompetitorCompanyNewsArticleFragmentDoc}`;

/**
 * __useGrowthToolCompanyNewsQuery__
 *
 * To run a query within a React component, call `useGrowthToolCompanyNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowthToolCompanyNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowthToolCompanyNewsQuery({
 *   variables: {
 *      companyUrl: // value for 'companyUrl'
 *   },
 * });
 */
export function useGrowthToolCompanyNewsQuery(baseOptions: Apollo.QueryHookOptions<Types.GrowthToolCompanyNewsQuery, Types.GrowthToolCompanyNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GrowthToolCompanyNewsQuery, Types.GrowthToolCompanyNewsQueryVariables>(GrowthToolCompanyNewsDocument, options);
      }
export function useGrowthToolCompanyNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GrowthToolCompanyNewsQuery, Types.GrowthToolCompanyNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GrowthToolCompanyNewsQuery, Types.GrowthToolCompanyNewsQueryVariables>(GrowthToolCompanyNewsDocument, options);
        }
export type GrowthToolCompanyNewsQueryHookResult = ReturnType<typeof useGrowthToolCompanyNewsQuery>;
export type GrowthToolCompanyNewsLazyQueryHookResult = ReturnType<typeof useGrowthToolCompanyNewsLazyQuery>;
export type GrowthToolCompanyNewsQueryResult = Apollo.QueryResult<Types.GrowthToolCompanyNewsQuery, Types.GrowthToolCompanyNewsQueryVariables>;
export const GrowthToolCompanyDocument = gql`
    query GrowthToolCompany($companyUrl: String!) {
  growthToolCompany(companyUrl: $companyUrl) {
    ...GrowthToolCompany
  }
}
    ${GrowthToolCompanyFragmentDoc}`;

/**
 * __useGrowthToolCompanyQuery__
 *
 * To run a query within a React component, call `useGrowthToolCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowthToolCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowthToolCompanyQuery({
 *   variables: {
 *      companyUrl: // value for 'companyUrl'
 *   },
 * });
 */
export function useGrowthToolCompanyQuery(baseOptions: Apollo.QueryHookOptions<Types.GrowthToolCompanyQuery, Types.GrowthToolCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GrowthToolCompanyQuery, Types.GrowthToolCompanyQueryVariables>(GrowthToolCompanyDocument, options);
      }
export function useGrowthToolCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GrowthToolCompanyQuery, Types.GrowthToolCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GrowthToolCompanyQuery, Types.GrowthToolCompanyQueryVariables>(GrowthToolCompanyDocument, options);
        }
export type GrowthToolCompanyQueryHookResult = ReturnType<typeof useGrowthToolCompanyQuery>;
export type GrowthToolCompanyLazyQueryHookResult = ReturnType<typeof useGrowthToolCompanyLazyQuery>;
export type GrowthToolCompanyQueryResult = Apollo.QueryResult<Types.GrowthToolCompanyQuery, Types.GrowthToolCompanyQueryVariables>;
export const PaginatedCompaniesPreviewDocument = gql`
    query PaginatedCompaniesPreview($pagination: PaginationInput, $filter: PaginatedCompaniesFilterInput, $sort: SortCompetitorCompaniesInput) {
  paginatedCompanies(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    docs {
      ...CompanyPreview
    }
  }
}
    ${CompanyPreviewFragmentDoc}`;

/**
 * __usePaginatedCompaniesPreviewQuery__
 *
 * To run a query within a React component, call `usePaginatedCompaniesPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCompaniesPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCompaniesPreviewQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCompaniesPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedCompaniesPreviewQuery, Types.PaginatedCompaniesPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCompaniesPreviewQuery, Types.PaginatedCompaniesPreviewQueryVariables>(PaginatedCompaniesPreviewDocument, options);
      }
export function usePaginatedCompaniesPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCompaniesPreviewQuery, Types.PaginatedCompaniesPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCompaniesPreviewQuery, Types.PaginatedCompaniesPreviewQueryVariables>(PaginatedCompaniesPreviewDocument, options);
        }
export type PaginatedCompaniesPreviewQueryHookResult = ReturnType<typeof usePaginatedCompaniesPreviewQuery>;
export type PaginatedCompaniesPreviewLazyQueryHookResult = ReturnType<typeof usePaginatedCompaniesPreviewLazyQuery>;
export type PaginatedCompaniesPreviewQueryResult = Apollo.QueryResult<Types.PaginatedCompaniesPreviewQuery, Types.PaginatedCompaniesPreviewQueryVariables>;
export const PaginatedCompanyGroupsDocument = gql`
    query PaginatedCompanyGroups($pagination: PaginationInput, $filter: PaginatedCompanyGroupsFilterInput, $sort: SortCompetitorCompaniesInput) {
  paginatedCompanyGroups(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    nextPage
    docs {
      ... on CompanyTagGroup {
        id
        count
        label
        color
        type
      }
    }
  }
}
    `;

/**
 * __usePaginatedCompanyGroupsQuery__
 *
 * To run a query within a React component, call `usePaginatedCompanyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCompanyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCompanyGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCompanyGroupsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedCompanyGroupsQuery, Types.PaginatedCompanyGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCompanyGroupsQuery, Types.PaginatedCompanyGroupsQueryVariables>(PaginatedCompanyGroupsDocument, options);
      }
export function usePaginatedCompanyGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCompanyGroupsQuery, Types.PaginatedCompanyGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCompanyGroupsQuery, Types.PaginatedCompanyGroupsQueryVariables>(PaginatedCompanyGroupsDocument, options);
        }
export type PaginatedCompanyGroupsQueryHookResult = ReturnType<typeof usePaginatedCompanyGroupsQuery>;
export type PaginatedCompanyGroupsLazyQueryHookResult = ReturnType<typeof usePaginatedCompanyGroupsLazyQuery>;
export type PaginatedCompanyGroupsQueryResult = Apollo.QueryResult<Types.PaginatedCompanyGroupsQuery, Types.PaginatedCompanyGroupsQueryVariables>;
export const PaginatedCompaniesByGroupDocument = gql`
    query PaginatedCompaniesByGroup($pagination: PaginationInput, $filter: PaginatedCompaniesFilterInput, $sort: SortCompetitorCompaniesInput) {
  paginatedCompaniesByGroup(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    nextPage
    docs {
      ...CompanyPreview
    }
  }
}
    ${CompanyPreviewFragmentDoc}`;

/**
 * __usePaginatedCompaniesByGroupQuery__
 *
 * To run a query within a React component, call `usePaginatedCompaniesByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCompaniesByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCompaniesByGroupQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCompaniesByGroupQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedCompaniesByGroupQuery, Types.PaginatedCompaniesByGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCompaniesByGroupQuery, Types.PaginatedCompaniesByGroupQueryVariables>(PaginatedCompaniesByGroupDocument, options);
      }
export function usePaginatedCompaniesByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCompaniesByGroupQuery, Types.PaginatedCompaniesByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCompaniesByGroupQuery, Types.PaginatedCompaniesByGroupQueryVariables>(PaginatedCompaniesByGroupDocument, options);
        }
export type PaginatedCompaniesByGroupQueryHookResult = ReturnType<typeof usePaginatedCompaniesByGroupQuery>;
export type PaginatedCompaniesByGroupLazyQueryHookResult = ReturnType<typeof usePaginatedCompaniesByGroupLazyQuery>;
export type PaginatedCompaniesByGroupQueryResult = Apollo.QueryResult<Types.PaginatedCompaniesByGroupQuery, Types.PaginatedCompaniesByGroupQueryVariables>;
export const PublicCompanyDocument = gql`
    query PublicCompany {
  publicCompany {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __usePublicCompanyQuery__
 *
 * To run a query within a React component, call `usePublicCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicCompanyQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicCompanyQuery, Types.PublicCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicCompanyQuery, Types.PublicCompanyQueryVariables>(PublicCompanyDocument, options);
      }
export function usePublicCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicCompanyQuery, Types.PublicCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicCompanyQuery, Types.PublicCompanyQueryVariables>(PublicCompanyDocument, options);
        }
export type PublicCompanyQueryHookResult = ReturnType<typeof usePublicCompanyQuery>;
export type PublicCompanyLazyQueryHookResult = ReturnType<typeof usePublicCompanyLazyQuery>;
export type PublicCompanyQueryResult = Apollo.QueryResult<Types.PublicCompanyQuery, Types.PublicCompanyQueryVariables>;
export const PublicCompanyNewsDocument = gql`
    query PublicCompanyNews {
  publicCompanyNews {
    page
    limit
    totalDocs
    totalPages
    hasNextPage
    docs {
      ...CompetitorCompanyNewsArticle
    }
  }
}
    ${CompetitorCompanyNewsArticleFragmentDoc}`;

/**
 * __usePublicCompanyNewsQuery__
 *
 * To run a query within a React component, call `usePublicCompanyNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCompanyNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCompanyNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicCompanyNewsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicCompanyNewsQuery, Types.PublicCompanyNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicCompanyNewsQuery, Types.PublicCompanyNewsQueryVariables>(PublicCompanyNewsDocument, options);
      }
export function usePublicCompanyNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicCompanyNewsQuery, Types.PublicCompanyNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicCompanyNewsQuery, Types.PublicCompanyNewsQueryVariables>(PublicCompanyNewsDocument, options);
        }
export type PublicCompanyNewsQueryHookResult = ReturnType<typeof usePublicCompanyNewsQuery>;
export type PublicCompanyNewsLazyQueryHookResult = ReturnType<typeof usePublicCompanyNewsLazyQuery>;
export type PublicCompanyNewsQueryResult = Apollo.QueryResult<Types.PublicCompanyNewsQuery, Types.PublicCompanyNewsQueryVariables>;
export const PublicCompanyScreenshotsDocument = gql`
    query PublicCompanyScreenshots {
  publicCompanyScreenshots {
    id
    screenshotsObj {
      ...Screenshot
    }
  }
}
    ${ScreenshotFragmentDoc}`;

/**
 * __usePublicCompanyScreenshotsQuery__
 *
 * To run a query within a React component, call `usePublicCompanyScreenshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCompanyScreenshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCompanyScreenshotsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicCompanyScreenshotsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicCompanyScreenshotsQuery, Types.PublicCompanyScreenshotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicCompanyScreenshotsQuery, Types.PublicCompanyScreenshotsQueryVariables>(PublicCompanyScreenshotsDocument, options);
      }
export function usePublicCompanyScreenshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicCompanyScreenshotsQuery, Types.PublicCompanyScreenshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicCompanyScreenshotsQuery, Types.PublicCompanyScreenshotsQueryVariables>(PublicCompanyScreenshotsDocument, options);
        }
export type PublicCompanyScreenshotsQueryHookResult = ReturnType<typeof usePublicCompanyScreenshotsQuery>;
export type PublicCompanyScreenshotsLazyQueryHookResult = ReturnType<typeof usePublicCompanyScreenshotsLazyQuery>;
export type PublicCompanyScreenshotsQueryResult = Apollo.QueryResult<Types.PublicCompanyScreenshotsQuery, Types.PublicCompanyScreenshotsQueryVariables>;
export const CustomDomainScreenshotDocument = gql`
    subscription customDomainScreenshot($id: String!) {
  customDomainScreenshot(id: $id) {
    pageUrl
    key
    screenshotUrls {
      createdAt
      screenshotUrl
    }
  }
}
    `;

/**
 * __useCustomDomainScreenshotSubscription__
 *
 * To run a query within a React component, call `useCustomDomainScreenshotSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCustomDomainScreenshotSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDomainScreenshotSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDomainScreenshotSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.CustomDomainScreenshotSubscription, Types.CustomDomainScreenshotSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.CustomDomainScreenshotSubscription, Types.CustomDomainScreenshotSubscriptionVariables>(CustomDomainScreenshotDocument, options);
      }
export type CustomDomainScreenshotSubscriptionHookResult = ReturnType<typeof useCustomDomainScreenshotSubscription>;
export type CustomDomainScreenshotSubscriptionResult = Apollo.SubscriptionResult<Types.CustomDomainScreenshotSubscription>;
export const RssFeedSubscriptionDocument = gql`
    subscription rssFeedSubscription($id: String!) {
  rssFeedSubscription(id: $id) {
    pageUrl
    key
    rssFeedData {
      title
      link
      published_date
      description
      sourceUrl
      sourceTitle
    }
  }
}
    `;

/**
 * __useRssFeedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useRssFeedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRssFeedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRssFeedSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRssFeedSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.RssFeedSubscriptionSubscription, Types.RssFeedSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.RssFeedSubscriptionSubscription, Types.RssFeedSubscriptionSubscriptionVariables>(RssFeedSubscriptionDocument, options);
      }
export type RssFeedSubscriptionSubscriptionHookResult = ReturnType<typeof useRssFeedSubscriptionSubscription>;
export type RssFeedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<Types.RssFeedSubscriptionSubscription>;
export const EditRssFeedsDocument = gql`
    mutation EditRssFeeds($input: UpdateCompanyInput!) {
  editRssFeeds(input: $input) {
    id
  }
}
    `;
export type EditRssFeedsMutationFn = Apollo.MutationFunction<Types.EditRssFeedsMutation, Types.EditRssFeedsMutationVariables>;

/**
 * __useEditRssFeedsMutation__
 *
 * To run a mutation, you first call `useEditRssFeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRssFeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRssFeedsMutation, { data, loading, error }] = useEditRssFeedsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRssFeedsMutation(baseOptions?: Apollo.MutationHookOptions<Types.EditRssFeedsMutation, Types.EditRssFeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EditRssFeedsMutation, Types.EditRssFeedsMutationVariables>(EditRssFeedsDocument, options);
      }
export type EditRssFeedsMutationHookResult = ReturnType<typeof useEditRssFeedsMutation>;
export type EditRssFeedsMutationResult = Apollo.MutationResult<Types.EditRssFeedsMutation>;
export type EditRssFeedsMutationOptions = Apollo.BaseMutationOptions<Types.EditRssFeedsMutation, Types.EditRssFeedsMutationVariables>;
export const GenerateWinlossSummaryDocument = gql`
    mutation GenerateWinlossSummary($filter: FilterWinlossTableInput, $sort: SortWinlossTableInput) {
  generateWinlossSummary(filter: $filter, sort: $sort) {
    ...WinlossTakeawaysSummary
  }
}
    ${WinlossTakeawaysSummaryFragmentDoc}`;
export type GenerateWinlossSummaryMutationFn = Apollo.MutationFunction<Types.GenerateWinlossSummaryMutation, Types.GenerateWinlossSummaryMutationVariables>;

/**
 * __useGenerateWinlossSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateWinlossSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWinlossSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWinlossSummaryMutation, { data, loading, error }] = useGenerateWinlossSummaryMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGenerateWinlossSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateWinlossSummaryMutation, Types.GenerateWinlossSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateWinlossSummaryMutation, Types.GenerateWinlossSummaryMutationVariables>(GenerateWinlossSummaryDocument, options);
      }
export type GenerateWinlossSummaryMutationHookResult = ReturnType<typeof useGenerateWinlossSummaryMutation>;
export type GenerateWinlossSummaryMutationResult = Apollo.MutationResult<Types.GenerateWinlossSummaryMutation>;
export type GenerateWinlossSummaryMutationOptions = Apollo.BaseMutationOptions<Types.GenerateWinlossSummaryMutation, Types.GenerateWinlossSummaryMutationVariables>;
export const LinkSalesforceObjectToOrganizationDocument = gql`
    mutation LinkSalesforceObjectToOrganization($competitorObjectName: String!, $competitorFieldType: String!, $dealNotesFieldName: String, $lostNotesFieldName: String) {
  linkSalesforceObjectToOrganization(
    competitorObjectName: $competitorObjectName
    competitorFieldType: $competitorFieldType
    dealNotesFieldName: $dealNotesFieldName
    lostNotesFieldName: $lostNotesFieldName
  )
}
    `;
export type LinkSalesforceObjectToOrganizationMutationFn = Apollo.MutationFunction<Types.LinkSalesforceObjectToOrganizationMutation, Types.LinkSalesforceObjectToOrganizationMutationVariables>;

/**
 * __useLinkSalesforceObjectToOrganizationMutation__
 *
 * To run a mutation, you first call `useLinkSalesforceObjectToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkSalesforceObjectToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkSalesforceObjectToOrganizationMutation, { data, loading, error }] = useLinkSalesforceObjectToOrganizationMutation({
 *   variables: {
 *      competitorObjectName: // value for 'competitorObjectName'
 *      competitorFieldType: // value for 'competitorFieldType'
 *      dealNotesFieldName: // value for 'dealNotesFieldName'
 *      lostNotesFieldName: // value for 'lostNotesFieldName'
 *   },
 * });
 */
export function useLinkSalesforceObjectToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.LinkSalesforceObjectToOrganizationMutation, Types.LinkSalesforceObjectToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LinkSalesforceObjectToOrganizationMutation, Types.LinkSalesforceObjectToOrganizationMutationVariables>(LinkSalesforceObjectToOrganizationDocument, options);
      }
export type LinkSalesforceObjectToOrganizationMutationHookResult = ReturnType<typeof useLinkSalesforceObjectToOrganizationMutation>;
export type LinkSalesforceObjectToOrganizationMutationResult = Apollo.MutationResult<Types.LinkSalesforceObjectToOrganizationMutation>;
export type LinkSalesforceObjectToOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.LinkSalesforceObjectToOrganizationMutation, Types.LinkSalesforceObjectToOrganizationMutationVariables>;
export const CheckWinlossIntegrationDocument = gql`
    query CheckWinlossIntegration {
  checkWinlossIntegration
}
    `;

/**
 * __useCheckWinlossIntegrationQuery__
 *
 * To run a query within a React component, call `useCheckWinlossIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckWinlossIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckWinlossIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckWinlossIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<Types.CheckWinlossIntegrationQuery, Types.CheckWinlossIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CheckWinlossIntegrationQuery, Types.CheckWinlossIntegrationQueryVariables>(CheckWinlossIntegrationDocument, options);
      }
export function useCheckWinlossIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CheckWinlossIntegrationQuery, Types.CheckWinlossIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CheckWinlossIntegrationQuery, Types.CheckWinlossIntegrationQueryVariables>(CheckWinlossIntegrationDocument, options);
        }
export type CheckWinlossIntegrationQueryHookResult = ReturnType<typeof useCheckWinlossIntegrationQuery>;
export type CheckWinlossIntegrationLazyQueryHookResult = ReturnType<typeof useCheckWinlossIntegrationLazyQuery>;
export type CheckWinlossIntegrationQueryResult = Apollo.QueryResult<Types.CheckWinlossIntegrationQuery, Types.CheckWinlossIntegrationQueryVariables>;
export const GetDealsCompaniesDocument = gql`
    query GetDealsCompanies {
  paginatedDealsCompanies {
    totalPages
    page
    limit
    docs {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDealsCompaniesQuery__
 *
 * To run a query within a React component, call `useGetDealsCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDealsCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetDealsCompaniesQuery, Types.GetDealsCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDealsCompaniesQuery, Types.GetDealsCompaniesQueryVariables>(GetDealsCompaniesDocument, options);
      }
export function useGetDealsCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDealsCompaniesQuery, Types.GetDealsCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDealsCompaniesQuery, Types.GetDealsCompaniesQueryVariables>(GetDealsCompaniesDocument, options);
        }
export type GetDealsCompaniesQueryHookResult = ReturnType<typeof useGetDealsCompaniesQuery>;
export type GetDealsCompaniesLazyQueryHookResult = ReturnType<typeof useGetDealsCompaniesLazyQuery>;
export type GetDealsCompaniesQueryResult = Apollo.QueryResult<Types.GetDealsCompaniesQuery, Types.GetDealsCompaniesQueryVariables>;
export const GetKeywordsDocument = gql`
    query GetKeywords($pagination: PaginationInput, $input: SimilarWebKeywordsQueryInput!, $filter: FilterKeywordsInput!) {
  getKeywords(pagination: $pagination, input: $input, filter: $filter) {
    docs {
      ...KeywordResults
    }
    totalPages
  }
}
    ${KeywordResultsFragmentDoc}`;

/**
 * __useGetKeywordsQuery__
 *
 * To run a query within a React component, call `useGetKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeywordsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      input: // value for 'input'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetKeywordsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetKeywordsQuery, Types.GetKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetKeywordsQuery, Types.GetKeywordsQueryVariables>(GetKeywordsDocument, options);
      }
export function useGetKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetKeywordsQuery, Types.GetKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetKeywordsQuery, Types.GetKeywordsQueryVariables>(GetKeywordsDocument, options);
        }
export type GetKeywordsQueryHookResult = ReturnType<typeof useGetKeywordsQuery>;
export type GetKeywordsLazyQueryHookResult = ReturnType<typeof useGetKeywordsLazyQuery>;
export type GetKeywordsQueryResult = Apollo.QueryResult<Types.GetKeywordsQuery, Types.GetKeywordsQueryVariables>;
export const GetSalesforceOpportunityCustomFieldsDocument = gql`
    query GetSalesforceOpportunityCustomFields {
  getSalesforceOpportunityCustomFields {
    value
    label
  }
}
    `;

/**
 * __useGetSalesforceOpportunityCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetSalesforceOpportunityCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesforceOpportunityCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesforceOpportunityCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesforceOpportunityCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSalesforceOpportunityCustomFieldsQuery, Types.GetSalesforceOpportunityCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSalesforceOpportunityCustomFieldsQuery, Types.GetSalesforceOpportunityCustomFieldsQueryVariables>(GetSalesforceOpportunityCustomFieldsDocument, options);
      }
export function useGetSalesforceOpportunityCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSalesforceOpportunityCustomFieldsQuery, Types.GetSalesforceOpportunityCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSalesforceOpportunityCustomFieldsQuery, Types.GetSalesforceOpportunityCustomFieldsQueryVariables>(GetSalesforceOpportunityCustomFieldsDocument, options);
        }
export type GetSalesforceOpportunityCustomFieldsQueryHookResult = ReturnType<typeof useGetSalesforceOpportunityCustomFieldsQuery>;
export type GetSalesforceOpportunityCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetSalesforceOpportunityCustomFieldsLazyQuery>;
export type GetSalesforceOpportunityCustomFieldsQueryResult = Apollo.QueryResult<Types.GetSalesforceOpportunityCustomFieldsQuery, Types.GetSalesforceOpportunityCustomFieldsQueryVariables>;
export const GetSelectedSalesforceIntegrationFieldsDocument = gql`
    query GetSelectedSalesforceIntegrationFields {
  getSelectedSalesforceIntegrationFields {
    competitorObjectName
    competitorFieldType
    dealNotesFieldName
    lostNotesFieldName
  }
}
    `;

/**
 * __useGetSelectedSalesforceIntegrationFieldsQuery__
 *
 * To run a query within a React component, call `useGetSelectedSalesforceIntegrationFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedSalesforceIntegrationFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedSalesforceIntegrationFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelectedSalesforceIntegrationFieldsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSelectedSalesforceIntegrationFieldsQuery, Types.GetSelectedSalesforceIntegrationFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSelectedSalesforceIntegrationFieldsQuery, Types.GetSelectedSalesforceIntegrationFieldsQueryVariables>(GetSelectedSalesforceIntegrationFieldsDocument, options);
      }
export function useGetSelectedSalesforceIntegrationFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSelectedSalesforceIntegrationFieldsQuery, Types.GetSelectedSalesforceIntegrationFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSelectedSalesforceIntegrationFieldsQuery, Types.GetSelectedSalesforceIntegrationFieldsQueryVariables>(GetSelectedSalesforceIntegrationFieldsDocument, options);
        }
export type GetSelectedSalesforceIntegrationFieldsQueryHookResult = ReturnType<typeof useGetSelectedSalesforceIntegrationFieldsQuery>;
export type GetSelectedSalesforceIntegrationFieldsLazyQueryHookResult = ReturnType<typeof useGetSelectedSalesforceIntegrationFieldsLazyQuery>;
export type GetSelectedSalesforceIntegrationFieldsQueryResult = Apollo.QueryResult<Types.GetSelectedSalesforceIntegrationFieldsQuery, Types.GetSelectedSalesforceIntegrationFieldsQueryVariables>;
export const GetSeoKeywordsDocument = gql`
    query GetSeoKeywords($filter: FilterKeywordsInput!, $pagination: PaginationInput, $input: SimilarWebKeywordsQueryInput!, $sort: SortKeywordsInput!) {
  getKeywords(
    filter: $filter
    pagination: $pagination
    input: $input
    sort: $sort
  ) {
    docs {
      ...KeywordResults
    }
    totalPages
  }
}
    ${KeywordResultsFragmentDoc}`;

/**
 * __useGetSeoKeywordsQuery__
 *
 * To run a query within a React component, call `useGetSeoKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoKeywordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSeoKeywordsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSeoKeywordsQuery, Types.GetSeoKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSeoKeywordsQuery, Types.GetSeoKeywordsQueryVariables>(GetSeoKeywordsDocument, options);
      }
export function useGetSeoKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSeoKeywordsQuery, Types.GetSeoKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSeoKeywordsQuery, Types.GetSeoKeywordsQueryVariables>(GetSeoKeywordsDocument, options);
        }
export type GetSeoKeywordsQueryHookResult = ReturnType<typeof useGetSeoKeywordsQuery>;
export type GetSeoKeywordsLazyQueryHookResult = ReturnType<typeof useGetSeoKeywordsLazyQuery>;
export type GetSeoKeywordsQueryResult = Apollo.QueryResult<Types.GetSeoKeywordsQuery, Types.GetSeoKeywordsQueryVariables>;
export const GetTotalTrafficChartDocument = gql`
    query GetTotalTrafficChart($input: SimilarWebChartQueryInput!) {
  getTotalTrafficChart(input: $input) {
    dates
    visits
  }
}
    `;

/**
 * __useGetTotalTrafficChartQuery__
 *
 * To run a query within a React component, call `useGetTotalTrafficChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalTrafficChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalTrafficChartQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTotalTrafficChartQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTotalTrafficChartQuery, Types.GetTotalTrafficChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTotalTrafficChartQuery, Types.GetTotalTrafficChartQueryVariables>(GetTotalTrafficChartDocument, options);
      }
export function useGetTotalTrafficChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTotalTrafficChartQuery, Types.GetTotalTrafficChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTotalTrafficChartQuery, Types.GetTotalTrafficChartQueryVariables>(GetTotalTrafficChartDocument, options);
        }
export type GetTotalTrafficChartQueryHookResult = ReturnType<typeof useGetTotalTrafficChartQuery>;
export type GetTotalTrafficChartLazyQueryHookResult = ReturnType<typeof useGetTotalTrafficChartLazyQuery>;
export type GetTotalTrafficChartQueryResult = Apollo.QueryResult<Types.GetTotalTrafficChartQuery, Types.GetTotalTrafficChartQueryVariables>;
export const GetVisitsDocument = gql`
    query GetVisits($websiteName: String!) {
  getVisits(websiteName: $websiteName) {
    websiteName
    totalVisits
    organicKeywordVisits
    paidKeywordVisits
  }
}
    `;

/**
 * __useGetVisitsQuery__
 *
 * To run a query within a React component, call `useGetVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitsQuery({
 *   variables: {
 *      websiteName: // value for 'websiteName'
 *   },
 * });
 */
export function useGetVisitsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetVisitsQuery, Types.GetVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetVisitsQuery, Types.GetVisitsQueryVariables>(GetVisitsDocument, options);
      }
export function useGetVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetVisitsQuery, Types.GetVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetVisitsQuery, Types.GetVisitsQueryVariables>(GetVisitsDocument, options);
        }
export type GetVisitsQueryHookResult = ReturnType<typeof useGetVisitsQuery>;
export type GetVisitsLazyQueryHookResult = ReturnType<typeof useGetVisitsLazyQuery>;
export type GetVisitsQueryResult = Apollo.QueryResult<Types.GetVisitsQuery, Types.GetVisitsQueryVariables>;
export const GetWinlossCompetitorsDocument = gql`
    query GetWinlossCompetitors {
  paginatedCompetitors {
    totalPages
    page
    limit
    docs {
      id
      name
    }
  }
}
    `;

/**
 * __useGetWinlossCompetitorsQuery__
 *
 * To run a query within a React component, call `useGetWinlossCompetitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinlossCompetitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinlossCompetitorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWinlossCompetitorsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetWinlossCompetitorsQuery, Types.GetWinlossCompetitorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWinlossCompetitorsQuery, Types.GetWinlossCompetitorsQueryVariables>(GetWinlossCompetitorsDocument, options);
      }
export function useGetWinlossCompetitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWinlossCompetitorsQuery, Types.GetWinlossCompetitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWinlossCompetitorsQuery, Types.GetWinlossCompetitorsQueryVariables>(GetWinlossCompetitorsDocument, options);
        }
export type GetWinlossCompetitorsQueryHookResult = ReturnType<typeof useGetWinlossCompetitorsQuery>;
export type GetWinlossCompetitorsLazyQueryHookResult = ReturnType<typeof useGetWinlossCompetitorsLazyQuery>;
export type GetWinlossCompetitorsQueryResult = Apollo.QueryResult<Types.GetWinlossCompetitorsQuery, Types.GetWinlossCompetitorsQueryVariables>;
export const GetWinLossGraphDataDocument = gql`
    query GetWinLossGraphData($input: FilterWinlossGraphInput!) {
  winLossGraph(filter: $input) {
    labels
    dealsWonArray
    dealsLostArray
  }
}
    `;

/**
 * __useGetWinLossGraphDataQuery__
 *
 * To run a query within a React component, call `useGetWinLossGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinLossGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinLossGraphDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWinLossGraphDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWinLossGraphDataQuery, Types.GetWinLossGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWinLossGraphDataQuery, Types.GetWinLossGraphDataQueryVariables>(GetWinLossGraphDataDocument, options);
      }
export function useGetWinLossGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWinLossGraphDataQuery, Types.GetWinLossGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWinLossGraphDataQuery, Types.GetWinLossGraphDataQueryVariables>(GetWinLossGraphDataDocument, options);
        }
export type GetWinLossGraphDataQueryHookResult = ReturnType<typeof useGetWinLossGraphDataQuery>;
export type GetWinLossGraphDataLazyQueryHookResult = ReturnType<typeof useGetWinLossGraphDataLazyQuery>;
export type GetWinLossGraphDataQueryResult = Apollo.QueryResult<Types.GetWinLossGraphDataQuery, Types.GetWinLossGraphDataQueryVariables>;
export const GetWinLossMetricsDocument = gql`
    query GetWinLossMetrics($input: FilterWinlossMetricsInput!) {
  winlossMetrics(filter: $input) {
    wonTotalRatio
    acv
    averageDealVelocity
  }
}
    `;

/**
 * __useGetWinLossMetricsQuery__
 *
 * To run a query within a React component, call `useGetWinLossMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinLossMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinLossMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWinLossMetricsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWinLossMetricsQuery, Types.GetWinLossMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWinLossMetricsQuery, Types.GetWinLossMetricsQueryVariables>(GetWinLossMetricsDocument, options);
      }
export function useGetWinLossMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWinLossMetricsQuery, Types.GetWinLossMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWinLossMetricsQuery, Types.GetWinLossMetricsQueryVariables>(GetWinLossMetricsDocument, options);
        }
export type GetWinLossMetricsQueryHookResult = ReturnType<typeof useGetWinLossMetricsQuery>;
export type GetWinLossMetricsLazyQueryHookResult = ReturnType<typeof useGetWinLossMetricsLazyQuery>;
export type GetWinLossMetricsQueryResult = Apollo.QueryResult<Types.GetWinLossMetricsQuery, Types.GetWinLossMetricsQueryVariables>;
export const GetWinlossAuthUrlDocument = gql`
    query GetWinlossAuthUrl($integrationType: String!) {
  getWinlossAuthUrl(integrationType: $integrationType)
}
    `;

/**
 * __useGetWinlossAuthUrlQuery__
 *
 * To run a query within a React component, call `useGetWinlossAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinlossAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinlossAuthUrlQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useGetWinlossAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWinlossAuthUrlQuery, Types.GetWinlossAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWinlossAuthUrlQuery, Types.GetWinlossAuthUrlQueryVariables>(GetWinlossAuthUrlDocument, options);
      }
export function useGetWinlossAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWinlossAuthUrlQuery, Types.GetWinlossAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWinlossAuthUrlQuery, Types.GetWinlossAuthUrlQueryVariables>(GetWinlossAuthUrlDocument, options);
        }
export type GetWinlossAuthUrlQueryHookResult = ReturnType<typeof useGetWinlossAuthUrlQuery>;
export type GetWinlossAuthUrlLazyQueryHookResult = ReturnType<typeof useGetWinlossAuthUrlLazyQuery>;
export type GetWinlossAuthUrlQueryResult = Apollo.QueryResult<Types.GetWinlossAuthUrlQuery, Types.GetWinlossAuthUrlQueryVariables>;
export const GetWinlossCustomObjectsDocument = gql`
    query GetWinlossCustomObjects {
  getWinlossCustomObjects {
    value
    label
  }
}
    `;

/**
 * __useGetWinlossCustomObjectsQuery__
 *
 * To run a query within a React component, call `useGetWinlossCustomObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinlossCustomObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinlossCustomObjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWinlossCustomObjectsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetWinlossCustomObjectsQuery, Types.GetWinlossCustomObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWinlossCustomObjectsQuery, Types.GetWinlossCustomObjectsQueryVariables>(GetWinlossCustomObjectsDocument, options);
      }
export function useGetWinlossCustomObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWinlossCustomObjectsQuery, Types.GetWinlossCustomObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWinlossCustomObjectsQuery, Types.GetWinlossCustomObjectsQueryVariables>(GetWinlossCustomObjectsDocument, options);
        }
export type GetWinlossCustomObjectsQueryHookResult = ReturnType<typeof useGetWinlossCustomObjectsQuery>;
export type GetWinlossCustomObjectsLazyQueryHookResult = ReturnType<typeof useGetWinlossCustomObjectsLazyQuery>;
export type GetWinlossCustomObjectsQueryResult = Apollo.QueryResult<Types.GetWinlossCustomObjectsQuery, Types.GetWinlossCustomObjectsQueryVariables>;
export const PaginatedWinLossTableDocument = gql`
    query PaginatedWinLossTable($filter: FilterWinlossTableInput, $sort: SortWinlossTableInput, $pagination: PaginationInput) {
  paginatedWinlossTable(filter: $filter, sort: $sort, pagination: $pagination) {
    totalPages
    page
    limit
    docs {
      ...WinLossTable
    }
  }
}
    ${WinLossTableFragmentDoc}`;

/**
 * __usePaginatedWinLossTableQuery__
 *
 * To run a query within a React component, call `usePaginatedWinLossTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedWinLossTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedWinLossTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedWinLossTableQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedWinLossTableQuery, Types.PaginatedWinLossTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedWinLossTableQuery, Types.PaginatedWinLossTableQueryVariables>(PaginatedWinLossTableDocument, options);
      }
export function usePaginatedWinLossTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedWinLossTableQuery, Types.PaginatedWinLossTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedWinLossTableQuery, Types.PaginatedWinLossTableQueryVariables>(PaginatedWinLossTableDocument, options);
        }
export type PaginatedWinLossTableQueryHookResult = ReturnType<typeof usePaginatedWinLossTableQuery>;
export type PaginatedWinLossTableLazyQueryHookResult = ReturnType<typeof usePaginatedWinLossTableLazyQuery>;
export type PaginatedWinLossTableQueryResult = Apollo.QueryResult<Types.PaginatedWinLossTableQuery, Types.PaginatedWinLossTableQueryVariables>;
export const WinlossTakeawaysSummaryDocument = gql`
    query WinlossTakeawaysSummary {
  winlossTakeawaysSummary {
    ...WinlossTakeawaysSummary
  }
}
    ${WinlossTakeawaysSummaryFragmentDoc}`;

/**
 * __useWinlossTakeawaysSummaryQuery__
 *
 * To run a query within a React component, call `useWinlossTakeawaysSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWinlossTakeawaysSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWinlossTakeawaysSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useWinlossTakeawaysSummaryQuery(baseOptions?: Apollo.QueryHookOptions<Types.WinlossTakeawaysSummaryQuery, Types.WinlossTakeawaysSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.WinlossTakeawaysSummaryQuery, Types.WinlossTakeawaysSummaryQueryVariables>(WinlossTakeawaysSummaryDocument, options);
      }
export function useWinlossTakeawaysSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.WinlossTakeawaysSummaryQuery, Types.WinlossTakeawaysSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.WinlossTakeawaysSummaryQuery, Types.WinlossTakeawaysSummaryQueryVariables>(WinlossTakeawaysSummaryDocument, options);
        }
export type WinlossTakeawaysSummaryQueryHookResult = ReturnType<typeof useWinlossTakeawaysSummaryQuery>;
export type WinlossTakeawaysSummaryLazyQueryHookResult = ReturnType<typeof useWinlossTakeawaysSummaryLazyQuery>;
export type WinlossTakeawaysSummaryQueryResult = Apollo.QueryResult<Types.WinlossTakeawaysSummaryQuery, Types.WinlossTakeawaysSummaryQueryVariables>;
export const KeyPeopleDocument = gql`
    subscription keyPeople($id: String!) {
  keyPeopleFetched(id: $id) {
    fullName
    givenName
    familyName
    title
    role
    subRole
    email
    linkedIn
  }
}
    `;

/**
 * __useKeyPeopleSubscription__
 *
 * To run a query within a React component, call `useKeyPeopleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKeyPeopleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyPeopleSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKeyPeopleSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.KeyPeopleSubscription, Types.KeyPeopleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.KeyPeopleSubscription, Types.KeyPeopleSubscriptionVariables>(KeyPeopleDocument, options);
      }
export type KeyPeopleSubscriptionHookResult = ReturnType<typeof useKeyPeopleSubscription>;
export type KeyPeopleSubscriptionResult = Apollo.SubscriptionResult<Types.KeyPeopleSubscription>;
export const AddLaunchConnectionsDocument = gql`
    mutation AddLaunchConnections($input: AddLaunchConnectionsInput!) {
  addLaunchConnections(input: $input) {
    ...LaunchQuery
  }
}
    ${LaunchQueryFragmentDoc}`;
export type AddLaunchConnectionsMutationFn = Apollo.MutationFunction<Types.AddLaunchConnectionsMutation, Types.AddLaunchConnectionsMutationVariables>;

/**
 * __useAddLaunchConnectionsMutation__
 *
 * To run a mutation, you first call `useAddLaunchConnectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLaunchConnectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLaunchConnectionsMutation, { data, loading, error }] = useAddLaunchConnectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLaunchConnectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddLaunchConnectionsMutation, Types.AddLaunchConnectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddLaunchConnectionsMutation, Types.AddLaunchConnectionsMutationVariables>(AddLaunchConnectionsDocument, options);
      }
export type AddLaunchConnectionsMutationHookResult = ReturnType<typeof useAddLaunchConnectionsMutation>;
export type AddLaunchConnectionsMutationResult = Apollo.MutationResult<Types.AddLaunchConnectionsMutation>;
export type AddLaunchConnectionsMutationOptions = Apollo.BaseMutationOptions<Types.AddLaunchConnectionsMutation, Types.AddLaunchConnectionsMutationVariables>;
export const RemoveLaunchConnectionsDocument = gql`
    mutation RemoveLaunchConnections($input: AddLaunchConnectionsInput!) {
  removeLaunchConnections(input: $input) {
    ...LaunchQuery
  }
}
    ${LaunchQueryFragmentDoc}`;
export type RemoveLaunchConnectionsMutationFn = Apollo.MutationFunction<Types.RemoveLaunchConnectionsMutation, Types.RemoveLaunchConnectionsMutationVariables>;

/**
 * __useRemoveLaunchConnectionsMutation__
 *
 * To run a mutation, you first call `useRemoveLaunchConnectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLaunchConnectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLaunchConnectionsMutation, { data, loading, error }] = useRemoveLaunchConnectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLaunchConnectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveLaunchConnectionsMutation, Types.RemoveLaunchConnectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveLaunchConnectionsMutation, Types.RemoveLaunchConnectionsMutationVariables>(RemoveLaunchConnectionsDocument, options);
      }
export type RemoveLaunchConnectionsMutationHookResult = ReturnType<typeof useRemoveLaunchConnectionsMutation>;
export type RemoveLaunchConnectionsMutationResult = Apollo.MutationResult<Types.RemoveLaunchConnectionsMutation>;
export type RemoveLaunchConnectionsMutationOptions = Apollo.BaseMutationOptions<Types.RemoveLaunchConnectionsMutation, Types.RemoveLaunchConnectionsMutationVariables>;
export const CreateOrUpdateCopysmithAiFavoriteDocument = gql`
    mutation CreateOrUpdateCopysmithAIFavorite($input: CopysmithAIFavoriteInput!) {
  createOrUpdateCopysmithAIFavorite(input: $input) {
    ...CopysmithAIFavorite
  }
}
    ${CopysmithAiFavoriteFragmentDoc}`;
export type CreateOrUpdateCopysmithAiFavoriteMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateCopysmithAiFavoriteMutation, Types.CreateOrUpdateCopysmithAiFavoriteMutationVariables>;

/**
 * __useCreateOrUpdateCopysmithAiFavoriteMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCopysmithAiFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCopysmithAiFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCopysmithAiFavoriteMutation, { data, loading, error }] = useCreateOrUpdateCopysmithAiFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCopysmithAiFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateCopysmithAiFavoriteMutation, Types.CreateOrUpdateCopysmithAiFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateCopysmithAiFavoriteMutation, Types.CreateOrUpdateCopysmithAiFavoriteMutationVariables>(CreateOrUpdateCopysmithAiFavoriteDocument, options);
      }
export type CreateOrUpdateCopysmithAiFavoriteMutationHookResult = ReturnType<typeof useCreateOrUpdateCopysmithAiFavoriteMutation>;
export type CreateOrUpdateCopysmithAiFavoriteMutationResult = Apollo.MutationResult<Types.CreateOrUpdateCopysmithAiFavoriteMutation>;
export type CreateOrUpdateCopysmithAiFavoriteMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateCopysmithAiFavoriteMutation, Types.CreateOrUpdateCopysmithAiFavoriteMutationVariables>;
export const GenarateCopysmithAiContentV2Document = gql`
    mutation GenarateCopysmithAIContentV2($input: CopysmithAIPromptInput!) {
  generateCopysmithAIContentV2(input: $input) {
    ...CopysmithAIContent
  }
}
    ${CopysmithAiContentFragmentDoc}`;
export type GenarateCopysmithAiContentV2MutationFn = Apollo.MutationFunction<Types.GenarateCopysmithAiContentV2Mutation, Types.GenarateCopysmithAiContentV2MutationVariables>;

/**
 * __useGenarateCopysmithAiContentV2Mutation__
 *
 * To run a mutation, you first call `useGenarateCopysmithAiContentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenarateCopysmithAiContentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [genarateCopysmithAiContentV2Mutation, { data, loading, error }] = useGenarateCopysmithAiContentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenarateCopysmithAiContentV2Mutation(baseOptions?: Apollo.MutationHookOptions<Types.GenarateCopysmithAiContentV2Mutation, Types.GenarateCopysmithAiContentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenarateCopysmithAiContentV2Mutation, Types.GenarateCopysmithAiContentV2MutationVariables>(GenarateCopysmithAiContentV2Document, options);
      }
export type GenarateCopysmithAiContentV2MutationHookResult = ReturnType<typeof useGenarateCopysmithAiContentV2Mutation>;
export type GenarateCopysmithAiContentV2MutationResult = Apollo.MutationResult<Types.GenarateCopysmithAiContentV2Mutation>;
export type GenarateCopysmithAiContentV2MutationOptions = Apollo.BaseMutationOptions<Types.GenarateCopysmithAiContentV2Mutation, Types.GenarateCopysmithAiContentV2MutationVariables>;
export const CopysmithAiFavoritesDocument = gql`
    query CopysmithAIFavorites {
  copysmithAIFavorites {
    id
    organizationId
    templateIds
  }
}
    `;

/**
 * __useCopysmithAiFavoritesQuery__
 *
 * To run a query within a React component, call `useCopysmithAiFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopysmithAiFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopysmithAiFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCopysmithAiFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CopysmithAiFavoritesQuery, Types.CopysmithAiFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CopysmithAiFavoritesQuery, Types.CopysmithAiFavoritesQueryVariables>(CopysmithAiFavoritesDocument, options);
      }
export function useCopysmithAiFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CopysmithAiFavoritesQuery, Types.CopysmithAiFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CopysmithAiFavoritesQuery, Types.CopysmithAiFavoritesQueryVariables>(CopysmithAiFavoritesDocument, options);
        }
export type CopysmithAiFavoritesQueryHookResult = ReturnType<typeof useCopysmithAiFavoritesQuery>;
export type CopysmithAiFavoritesLazyQueryHookResult = ReturnType<typeof useCopysmithAiFavoritesLazyQuery>;
export type CopysmithAiFavoritesQueryResult = Apollo.QueryResult<Types.CopysmithAiFavoritesQuery, Types.CopysmithAiFavoritesQueryVariables>;
export const CopysmithAiTemplatesDocument = gql`
    query CopysmithAITemplates {
  copysmithAITemplates {
    id
    groupType
    templateType
    prompts {
      key
      label
      description
      promptType
      placeholder
      min
      max
      required
    }
  }
}
    `;

/**
 * __useCopysmithAiTemplatesQuery__
 *
 * To run a query within a React component, call `useCopysmithAiTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopysmithAiTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopysmithAiTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCopysmithAiTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CopysmithAiTemplatesQuery, Types.CopysmithAiTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CopysmithAiTemplatesQuery, Types.CopysmithAiTemplatesQueryVariables>(CopysmithAiTemplatesDocument, options);
      }
export function useCopysmithAiTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CopysmithAiTemplatesQuery, Types.CopysmithAiTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CopysmithAiTemplatesQuery, Types.CopysmithAiTemplatesQueryVariables>(CopysmithAiTemplatesDocument, options);
        }
export type CopysmithAiTemplatesQueryHookResult = ReturnType<typeof useCopysmithAiTemplatesQuery>;
export type CopysmithAiTemplatesLazyQueryHookResult = ReturnType<typeof useCopysmithAiTemplatesLazyQuery>;
export type CopysmithAiTemplatesQueryResult = Apollo.QueryResult<Types.CopysmithAiTemplatesQuery, Types.CopysmithAiTemplatesQueryVariables>;
export const PaginatedAssetsPreviewDocument = gql`
    query PaginatedAssetsPreview($sort: SortAssetsInput, $filter: FilterAssetsInput, $pagination: PaginationInput) {
  paginatedAssets(sort: $sort, filter: $filter, pagination: $pagination) {
    page
    totalDocs
    totalPages
    docs {
      ...PaginatedAssetPreview
    }
  }
}
    ${PaginatedAssetPreviewFragmentDoc}`;

/**
 * __usePaginatedAssetsPreviewQuery__
 *
 * To run a query within a React component, call `usePaginatedAssetsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAssetsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAssetsPreviewQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedAssetsPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedAssetsPreviewQuery, Types.PaginatedAssetsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedAssetsPreviewQuery, Types.PaginatedAssetsPreviewQueryVariables>(PaginatedAssetsPreviewDocument, options);
      }
export function usePaginatedAssetsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedAssetsPreviewQuery, Types.PaginatedAssetsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedAssetsPreviewQuery, Types.PaginatedAssetsPreviewQueryVariables>(PaginatedAssetsPreviewDocument, options);
        }
export type PaginatedAssetsPreviewQueryHookResult = ReturnType<typeof usePaginatedAssetsPreviewQuery>;
export type PaginatedAssetsPreviewLazyQueryHookResult = ReturnType<typeof usePaginatedAssetsPreviewLazyQuery>;
export type PaginatedAssetsPreviewQueryResult = Apollo.QueryResult<Types.PaginatedAssetsPreviewQuery, Types.PaginatedAssetsPreviewQueryVariables>;
export const PagniatedLaunchesPreviewDocument = gql`
    query PagniatedLaunchesPreview($sort: SortLaunchInput, $filter: FilterLaunchInput, $pagination: PaginationInput) {
  paginatedLaunches(sort: $sort, filter: $filter, pagination: $pagination) {
    docs {
      ...PaginatedLaunchesPreview
    }
    totalDocs
    totalPages
  }
}
    ${PaginatedLaunchesPreviewFragmentDoc}`;

/**
 * __usePagniatedLaunchesPreviewQuery__
 *
 * To run a query within a React component, call `usePagniatedLaunchesPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagniatedLaunchesPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagniatedLaunchesPreviewQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePagniatedLaunchesPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PagniatedLaunchesPreviewQuery, Types.PagniatedLaunchesPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PagniatedLaunchesPreviewQuery, Types.PagniatedLaunchesPreviewQueryVariables>(PagniatedLaunchesPreviewDocument, options);
      }
export function usePagniatedLaunchesPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PagniatedLaunchesPreviewQuery, Types.PagniatedLaunchesPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PagniatedLaunchesPreviewQuery, Types.PagniatedLaunchesPreviewQueryVariables>(PagniatedLaunchesPreviewDocument, options);
        }
export type PagniatedLaunchesPreviewQueryHookResult = ReturnType<typeof usePagniatedLaunchesPreviewQuery>;
export type PagniatedLaunchesPreviewLazyQueryHookResult = ReturnType<typeof usePagniatedLaunchesPreviewLazyQuery>;
export type PagniatedLaunchesPreviewQueryResult = Apollo.QueryResult<Types.PagniatedLaunchesPreviewQuery, Types.PagniatedLaunchesPreviewQueryVariables>;
export const CopywriteGenerationDocument = gql`
    mutation CopywriteGeneration($assetType: String!, $deliverableFormat: String!, $exampleDeliverables: String!, $finalPrompt: String!, $llm: String!, $messaging: String!, $organizationName: String!, $productDescription: String!, $productName: String!, $tone: String!) {
  copywriteGeneration(
    assetType: $assetType
    deliverableFormat: $deliverableFormat
    exampleDeliverables: $exampleDeliverables
    finalPrompt: $finalPrompt
    llm: $llm
    messaging: $messaging
    organizationName: $organizationName
    productDescription: $productDescription
    productName: $productName
    tone: $tone
  )
}
    `;
export type CopywriteGenerationMutationFn = Apollo.MutationFunction<Types.CopywriteGenerationMutation, Types.CopywriteGenerationMutationVariables>;

/**
 * __useCopywriteGenerationMutation__
 *
 * To run a mutation, you first call `useCopywriteGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopywriteGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copywriteGenerationMutation, { data, loading, error }] = useCopywriteGenerationMutation({
 *   variables: {
 *      assetType: // value for 'assetType'
 *      deliverableFormat: // value for 'deliverableFormat'
 *      exampleDeliverables: // value for 'exampleDeliverables'
 *      finalPrompt: // value for 'finalPrompt'
 *      llm: // value for 'llm'
 *      messaging: // value for 'messaging'
 *      organizationName: // value for 'organizationName'
 *      productDescription: // value for 'productDescription'
 *      productName: // value for 'productName'
 *      tone: // value for 'tone'
 *   },
 * });
 */
export function useCopywriteGenerationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CopywriteGenerationMutation, Types.CopywriteGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CopywriteGenerationMutation, Types.CopywriteGenerationMutationVariables>(CopywriteGenerationDocument, options);
      }
export type CopywriteGenerationMutationHookResult = ReturnType<typeof useCopywriteGenerationMutation>;
export type CopywriteGenerationMutationResult = Apollo.MutationResult<Types.CopywriteGenerationMutation>;
export type CopywriteGenerationMutationOptions = Apollo.BaseMutationOptions<Types.CopywriteGenerationMutation, Types.CopywriteGenerationMutationVariables>;
export const CreateCopywriteV2FavoritesDocument = gql`
    mutation CreateCopywriteV2Favorites($input: CreateCopywriteV2FavoriteInput!) {
  createCopywriteV2Favorites(input: $input) {
    ...CopywriteV2Favorite
  }
}
    ${CopywriteV2FavoriteFragmentDoc}`;
export type CreateCopywriteV2FavoritesMutationFn = Apollo.MutationFunction<Types.CreateCopywriteV2FavoritesMutation, Types.CreateCopywriteV2FavoritesMutationVariables>;

/**
 * __useCreateCopywriteV2FavoritesMutation__
 *
 * To run a mutation, you first call `useCreateCopywriteV2FavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCopywriteV2FavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCopywriteV2FavoritesMutation, { data, loading, error }] = useCreateCopywriteV2FavoritesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCopywriteV2FavoritesMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCopywriteV2FavoritesMutation, Types.CreateCopywriteV2FavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCopywriteV2FavoritesMutation, Types.CreateCopywriteV2FavoritesMutationVariables>(CreateCopywriteV2FavoritesDocument, options);
      }
export type CreateCopywriteV2FavoritesMutationHookResult = ReturnType<typeof useCreateCopywriteV2FavoritesMutation>;
export type CreateCopywriteV2FavoritesMutationResult = Apollo.MutationResult<Types.CreateCopywriteV2FavoritesMutation>;
export type CreateCopywriteV2FavoritesMutationOptions = Apollo.BaseMutationOptions<Types.CreateCopywriteV2FavoritesMutation, Types.CreateCopywriteV2FavoritesMutationVariables>;
export const GenerateCopywriteV2CampaignContentDocument = gql`
    mutation GenerateCopywriteV2CampaignContent($input: CopywriteV2CampaignPromptInput!) {
  generateCopywriteV2CampaignContent(input: $input) {
    ...CopywriteV2Content
  }
}
    ${CopywriteV2ContentFragmentDoc}`;
export type GenerateCopywriteV2CampaignContentMutationFn = Apollo.MutationFunction<Types.GenerateCopywriteV2CampaignContentMutation, Types.GenerateCopywriteV2CampaignContentMutationVariables>;

/**
 * __useGenerateCopywriteV2CampaignContentMutation__
 *
 * To run a mutation, you first call `useGenerateCopywriteV2CampaignContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCopywriteV2CampaignContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCopywriteV2CampaignContentMutation, { data, loading, error }] = useGenerateCopywriteV2CampaignContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCopywriteV2CampaignContentMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateCopywriteV2CampaignContentMutation, Types.GenerateCopywriteV2CampaignContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateCopywriteV2CampaignContentMutation, Types.GenerateCopywriteV2CampaignContentMutationVariables>(GenerateCopywriteV2CampaignContentDocument, options);
      }
export type GenerateCopywriteV2CampaignContentMutationHookResult = ReturnType<typeof useGenerateCopywriteV2CampaignContentMutation>;
export type GenerateCopywriteV2CampaignContentMutationResult = Apollo.MutationResult<Types.GenerateCopywriteV2CampaignContentMutation>;
export type GenerateCopywriteV2CampaignContentMutationOptions = Apollo.BaseMutationOptions<Types.GenerateCopywriteV2CampaignContentMutation, Types.GenerateCopywriteV2CampaignContentMutationVariables>;
export const GenerateCopywriteV2TemplateContentDocument = gql`
    mutation GenerateCopywriteV2TemplateContent($input: CopywriteV2TemplatePromptInput!) {
  generateCopywriteV2TemplateContent(input: $input) {
    ...CopywriteV2Content
  }
}
    ${CopywriteV2ContentFragmentDoc}`;
export type GenerateCopywriteV2TemplateContentMutationFn = Apollo.MutationFunction<Types.GenerateCopywriteV2TemplateContentMutation, Types.GenerateCopywriteV2TemplateContentMutationVariables>;

/**
 * __useGenerateCopywriteV2TemplateContentMutation__
 *
 * To run a mutation, you first call `useGenerateCopywriteV2TemplateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCopywriteV2TemplateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCopywriteV2TemplateContentMutation, { data, loading, error }] = useGenerateCopywriteV2TemplateContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCopywriteV2TemplateContentMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateCopywriteV2TemplateContentMutation, Types.GenerateCopywriteV2TemplateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateCopywriteV2TemplateContentMutation, Types.GenerateCopywriteV2TemplateContentMutationVariables>(GenerateCopywriteV2TemplateContentDocument, options);
      }
export type GenerateCopywriteV2TemplateContentMutationHookResult = ReturnType<typeof useGenerateCopywriteV2TemplateContentMutation>;
export type GenerateCopywriteV2TemplateContentMutationResult = Apollo.MutationResult<Types.GenerateCopywriteV2TemplateContentMutation>;
export type GenerateCopywriteV2TemplateContentMutationOptions = Apollo.BaseMutationOptions<Types.GenerateCopywriteV2TemplateContentMutation, Types.GenerateCopywriteV2TemplateContentMutationVariables>;
export const UpdateCopywriteV2FavoritesDocument = gql`
    mutation UpdateCopywriteV2Favorites($input: UpdateCopywriteV2FavoriteInput!) {
  updateCopywriteV2Favorites(input: $input) {
    ...CopywriteV2Favorite
  }
}
    ${CopywriteV2FavoriteFragmentDoc}`;
export type UpdateCopywriteV2FavoritesMutationFn = Apollo.MutationFunction<Types.UpdateCopywriteV2FavoritesMutation, Types.UpdateCopywriteV2FavoritesMutationVariables>;

/**
 * __useUpdateCopywriteV2FavoritesMutation__
 *
 * To run a mutation, you first call `useUpdateCopywriteV2FavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCopywriteV2FavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCopywriteV2FavoritesMutation, { data, loading, error }] = useUpdateCopywriteV2FavoritesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCopywriteV2FavoritesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCopywriteV2FavoritesMutation, Types.UpdateCopywriteV2FavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCopywriteV2FavoritesMutation, Types.UpdateCopywriteV2FavoritesMutationVariables>(UpdateCopywriteV2FavoritesDocument, options);
      }
export type UpdateCopywriteV2FavoritesMutationHookResult = ReturnType<typeof useUpdateCopywriteV2FavoritesMutation>;
export type UpdateCopywriteV2FavoritesMutationResult = Apollo.MutationResult<Types.UpdateCopywriteV2FavoritesMutation>;
export type UpdateCopywriteV2FavoritesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCopywriteV2FavoritesMutation, Types.UpdateCopywriteV2FavoritesMutationVariables>;
export const CopywriteV2FavoritesDocument = gql`
    query CopywriteV2Favorites {
  copywriteV2Favorites {
    ...CopywriteV2Favorite
  }
}
    ${CopywriteV2FavoriteFragmentDoc}`;

/**
 * __useCopywriteV2FavoritesQuery__
 *
 * To run a query within a React component, call `useCopywriteV2FavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopywriteV2FavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopywriteV2FavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCopywriteV2FavoritesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CopywriteV2FavoritesQuery, Types.CopywriteV2FavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CopywriteV2FavoritesQuery, Types.CopywriteV2FavoritesQueryVariables>(CopywriteV2FavoritesDocument, options);
      }
export function useCopywriteV2FavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CopywriteV2FavoritesQuery, Types.CopywriteV2FavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CopywriteV2FavoritesQuery, Types.CopywriteV2FavoritesQueryVariables>(CopywriteV2FavoritesDocument, options);
        }
export type CopywriteV2FavoritesQueryHookResult = ReturnType<typeof useCopywriteV2FavoritesQuery>;
export type CopywriteV2FavoritesLazyQueryHookResult = ReturnType<typeof useCopywriteV2FavoritesLazyQuery>;
export type CopywriteV2FavoritesQueryResult = Apollo.QueryResult<Types.CopywriteV2FavoritesQuery, Types.CopywriteV2FavoritesQueryVariables>;
export const CopywriteV2TemplatesDocument = gql`
    query CopywriteV2Templates {
  copywriteV2Templates {
    ...CopywriteV2Template
  }
}
    ${CopywriteV2TemplateFragmentDoc}`;

/**
 * __useCopywriteV2TemplatesQuery__
 *
 * To run a query within a React component, call `useCopywriteV2TemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopywriteV2TemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopywriteV2TemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCopywriteV2TemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CopywriteV2TemplatesQuery, Types.CopywriteV2TemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CopywriteV2TemplatesQuery, Types.CopywriteV2TemplatesQueryVariables>(CopywriteV2TemplatesDocument, options);
      }
export function useCopywriteV2TemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CopywriteV2TemplatesQuery, Types.CopywriteV2TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CopywriteV2TemplatesQuery, Types.CopywriteV2TemplatesQueryVariables>(CopywriteV2TemplatesDocument, options);
        }
export type CopywriteV2TemplatesQueryHookResult = ReturnType<typeof useCopywriteV2TemplatesQuery>;
export type CopywriteV2TemplatesLazyQueryHookResult = ReturnType<typeof useCopywriteV2TemplatesLazyQuery>;
export type CopywriteV2TemplatesQueryResult = Apollo.QueryResult<Types.CopywriteV2TemplatesQuery, Types.CopywriteV2TemplatesQueryVariables>;
export const DeleteCrmIntegrationDocument = gql`
    mutation DeleteCrmIntegration($input: DeleteCrmIntegrationInput!) {
  deleteCrmIntegration(input: $input) {
    id
  }
}
    `;
export type DeleteCrmIntegrationMutationFn = Apollo.MutationFunction<Types.DeleteCrmIntegrationMutation, Types.DeleteCrmIntegrationMutationVariables>;

/**
 * __useDeleteCrmIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteCrmIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCrmIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCrmIntegrationMutation, { data, loading, error }] = useDeleteCrmIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCrmIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCrmIntegrationMutation, Types.DeleteCrmIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCrmIntegrationMutation, Types.DeleteCrmIntegrationMutationVariables>(DeleteCrmIntegrationDocument, options);
      }
export type DeleteCrmIntegrationMutationHookResult = ReturnType<typeof useDeleteCrmIntegrationMutation>;
export type DeleteCrmIntegrationMutationResult = Apollo.MutationResult<Types.DeleteCrmIntegrationMutation>;
export type DeleteCrmIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCrmIntegrationMutation, Types.DeleteCrmIntegrationMutationVariables>;
export const ExportBattlecardsDocument = gql`
    mutation ExportBattlecards($input: ExportBattlecardsInput!) {
  exportBattlecards(input: $input)
}
    `;
export type ExportBattlecardsMutationFn = Apollo.MutationFunction<Types.ExportBattlecardsMutation, Types.ExportBattlecardsMutationVariables>;

/**
 * __useExportBattlecardsMutation__
 *
 * To run a mutation, you first call `useExportBattlecardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportBattlecardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportBattlecardsMutation, { data, loading, error }] = useExportBattlecardsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportBattlecardsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportBattlecardsMutation, Types.ExportBattlecardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportBattlecardsMutation, Types.ExportBattlecardsMutationVariables>(ExportBattlecardsDocument, options);
      }
export type ExportBattlecardsMutationHookResult = ReturnType<typeof useExportBattlecardsMutation>;
export type ExportBattlecardsMutationResult = Apollo.MutationResult<Types.ExportBattlecardsMutation>;
export type ExportBattlecardsMutationOptions = Apollo.BaseMutationOptions<Types.ExportBattlecardsMutation, Types.ExportBattlecardsMutationVariables>;
export const CrmIntegrationDocument = gql`
    query CrmIntegration($input: CrmIntegrationInput!) {
  crmIntegration(input: $input) {
    ...CrmIntegration
  }
}
    ${CrmIntegrationFragmentDoc}`;

/**
 * __useCrmIntegrationQuery__
 *
 * To run a query within a React component, call `useCrmIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmIntegrationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrmIntegrationQuery(baseOptions: Apollo.QueryHookOptions<Types.CrmIntegrationQuery, Types.CrmIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CrmIntegrationQuery, Types.CrmIntegrationQueryVariables>(CrmIntegrationDocument, options);
      }
export function useCrmIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CrmIntegrationQuery, Types.CrmIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CrmIntegrationQuery, Types.CrmIntegrationQueryVariables>(CrmIntegrationDocument, options);
        }
export type CrmIntegrationQueryHookResult = ReturnType<typeof useCrmIntegrationQuery>;
export type CrmIntegrationLazyQueryHookResult = ReturnType<typeof useCrmIntegrationLazyQuery>;
export type CrmIntegrationQueryResult = Apollo.QueryResult<Types.CrmIntegrationQuery, Types.CrmIntegrationQueryVariables>;
export const CrmIntegrationOAuthUrlDocument = gql`
    query CrmIntegrationOAuthUrl($input: CrmIntegrationOAuthUrlInput!) {
  crmIntegrationOAuthUrl(input: $input)
}
    `;

/**
 * __useCrmIntegrationOAuthUrlQuery__
 *
 * To run a query within a React component, call `useCrmIntegrationOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmIntegrationOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmIntegrationOAuthUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrmIntegrationOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.CrmIntegrationOAuthUrlQuery, Types.CrmIntegrationOAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CrmIntegrationOAuthUrlQuery, Types.CrmIntegrationOAuthUrlQueryVariables>(CrmIntegrationOAuthUrlDocument, options);
      }
export function useCrmIntegrationOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CrmIntegrationOAuthUrlQuery, Types.CrmIntegrationOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CrmIntegrationOAuthUrlQuery, Types.CrmIntegrationOAuthUrlQueryVariables>(CrmIntegrationOAuthUrlDocument, options);
        }
export type CrmIntegrationOAuthUrlQueryHookResult = ReturnType<typeof useCrmIntegrationOAuthUrlQuery>;
export type CrmIntegrationOAuthUrlLazyQueryHookResult = ReturnType<typeof useCrmIntegrationOAuthUrlLazyQuery>;
export type CrmIntegrationOAuthUrlQueryResult = Apollo.QueryResult<Types.CrmIntegrationOAuthUrlQuery, Types.CrmIntegrationOAuthUrlQueryVariables>;
export const CrmIntegrationObjectPropertiesDocument = gql`
    query CrmIntegrationObjectProperties($input: CrmIntegrationObjectPropertiesInput!) {
  crmIntegrationObjectProperties(input: $input) {
    id
    title
  }
}
    `;

/**
 * __useCrmIntegrationObjectPropertiesQuery__
 *
 * To run a query within a React component, call `useCrmIntegrationObjectPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmIntegrationObjectPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmIntegrationObjectPropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrmIntegrationObjectPropertiesQuery(baseOptions: Apollo.QueryHookOptions<Types.CrmIntegrationObjectPropertiesQuery, Types.CrmIntegrationObjectPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CrmIntegrationObjectPropertiesQuery, Types.CrmIntegrationObjectPropertiesQueryVariables>(CrmIntegrationObjectPropertiesDocument, options);
      }
export function useCrmIntegrationObjectPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CrmIntegrationObjectPropertiesQuery, Types.CrmIntegrationObjectPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CrmIntegrationObjectPropertiesQuery, Types.CrmIntegrationObjectPropertiesQueryVariables>(CrmIntegrationObjectPropertiesDocument, options);
        }
export type CrmIntegrationObjectPropertiesQueryHookResult = ReturnType<typeof useCrmIntegrationObjectPropertiesQuery>;
export type CrmIntegrationObjectPropertiesLazyQueryHookResult = ReturnType<typeof useCrmIntegrationObjectPropertiesLazyQuery>;
export type CrmIntegrationObjectPropertiesQueryResult = Apollo.QueryResult<Types.CrmIntegrationObjectPropertiesQuery, Types.CrmIntegrationObjectPropertiesQueryVariables>;
export const CrmIntegrationsDocument = gql`
    query CrmIntegrations {
  crmIntegrations {
    ...CrmIntegration
  }
}
    ${CrmIntegrationFragmentDoc}`;

/**
 * __useCrmIntegrationsQuery__
 *
 * To run a query within a React component, call `useCrmIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CrmIntegrationsQuery, Types.CrmIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CrmIntegrationsQuery, Types.CrmIntegrationsQueryVariables>(CrmIntegrationsDocument, options);
      }
export function useCrmIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CrmIntegrationsQuery, Types.CrmIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CrmIntegrationsQuery, Types.CrmIntegrationsQueryVariables>(CrmIntegrationsDocument, options);
        }
export type CrmIntegrationsQueryHookResult = ReturnType<typeof useCrmIntegrationsQuery>;
export type CrmIntegrationsLazyQueryHookResult = ReturnType<typeof useCrmIntegrationsLazyQuery>;
export type CrmIntegrationsQueryResult = Apollo.QueryResult<Types.CrmIntegrationsQuery, Types.CrmIntegrationsQueryVariables>;
export const PaginatedBattlecardsPreviewDocument = gql`
    query PaginatedBattlecardsPreview($pagination: PaginationInput, $filter: PaginatedCompaniesFilterInput, $sort: SortCompetitorCompaniesInput) {
  paginatedCompanies(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    docs {
      ...BattlecardPreview
    }
  }
}
    ${BattlecardPreviewFragmentDoc}`;

/**
 * __usePaginatedBattlecardsPreviewQuery__
 *
 * To run a query within a React component, call `usePaginatedBattlecardsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedBattlecardsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedBattlecardsPreviewQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedBattlecardsPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedBattlecardsPreviewQuery, Types.PaginatedBattlecardsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedBattlecardsPreviewQuery, Types.PaginatedBattlecardsPreviewQueryVariables>(PaginatedBattlecardsPreviewDocument, options);
      }
export function usePaginatedBattlecardsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedBattlecardsPreviewQuery, Types.PaginatedBattlecardsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedBattlecardsPreviewQuery, Types.PaginatedBattlecardsPreviewQueryVariables>(PaginatedBattlecardsPreviewDocument, options);
        }
export type PaginatedBattlecardsPreviewQueryHookResult = ReturnType<typeof usePaginatedBattlecardsPreviewQuery>;
export type PaginatedBattlecardsPreviewLazyQueryHookResult = ReturnType<typeof usePaginatedBattlecardsPreviewLazyQuery>;
export type PaginatedBattlecardsPreviewQueryResult = Apollo.QueryResult<Types.PaginatedBattlecardsPreviewQuery, Types.PaginatedBattlecardsPreviewQueryVariables>;
export const PaginatedCrmIntegrationObjectsDocument = gql`
    query PaginatedCrmIntegrationObjects($filter: CrmIntegrationObjectsFilterInput!, $pagination: PaginationInput) {
  paginatedCrmIntegrationObjects(filter: $filter, pagination: $pagination) {
    totalPages
    totalDocs
    page
    docs {
      ...CrmIntegrationObject
    }
  }
}
    ${CrmIntegrationObjectFragmentDoc}`;

/**
 * __usePaginatedCrmIntegrationObjectsQuery__
 *
 * To run a query within a React component, call `usePaginatedCrmIntegrationObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCrmIntegrationObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCrmIntegrationObjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedCrmIntegrationObjectsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedCrmIntegrationObjectsQuery, Types.PaginatedCrmIntegrationObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCrmIntegrationObjectsQuery, Types.PaginatedCrmIntegrationObjectsQueryVariables>(PaginatedCrmIntegrationObjectsDocument, options);
      }
export function usePaginatedCrmIntegrationObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCrmIntegrationObjectsQuery, Types.PaginatedCrmIntegrationObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCrmIntegrationObjectsQuery, Types.PaginatedCrmIntegrationObjectsQueryVariables>(PaginatedCrmIntegrationObjectsDocument, options);
        }
export type PaginatedCrmIntegrationObjectsQueryHookResult = ReturnType<typeof usePaginatedCrmIntegrationObjectsQuery>;
export type PaginatedCrmIntegrationObjectsLazyQueryHookResult = ReturnType<typeof usePaginatedCrmIntegrationObjectsLazyQuery>;
export type PaginatedCrmIntegrationObjectsQueryResult = Apollo.QueryResult<Types.PaginatedCrmIntegrationObjectsQuery, Types.PaginatedCrmIntegrationObjectsQueryVariables>;
export const CrmIntegrationCreatedDocument = gql`
    subscription CrmIntegrationCreated($input: CrmIntegrationCreatedSubscriptionInput!) {
  crmIntegrationCreated(input: $input) {
    id
    crm
  }
}
    `;

/**
 * __useCrmIntegrationCreatedSubscription__
 *
 * To run a query within a React component, call `useCrmIntegrationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCrmIntegrationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmIntegrationCreatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrmIntegrationCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.CrmIntegrationCreatedSubscription, Types.CrmIntegrationCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.CrmIntegrationCreatedSubscription, Types.CrmIntegrationCreatedSubscriptionVariables>(CrmIntegrationCreatedDocument, options);
      }
export type CrmIntegrationCreatedSubscriptionHookResult = ReturnType<typeof useCrmIntegrationCreatedSubscription>;
export type CrmIntegrationCreatedSubscriptionResult = Apollo.SubscriptionResult<Types.CrmIntegrationCreatedSubscription>;
export const DealsCountDocument = gql`
    query DealsCount {
  dealsCount: paginatedDeals {
    count: totalDocs
  }
}
    `;

/**
 * __useDealsCountQuery__
 *
 * To run a query within a React component, call `useDealsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealsCountQuery(baseOptions?: Apollo.QueryHookOptions<Types.DealsCountQuery, Types.DealsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DealsCountQuery, Types.DealsCountQueryVariables>(DealsCountDocument, options);
      }
export function useDealsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DealsCountQuery, Types.DealsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DealsCountQuery, Types.DealsCountQueryVariables>(DealsCountDocument, options);
        }
export type DealsCountQueryHookResult = ReturnType<typeof useDealsCountQuery>;
export type DealsCountLazyQueryHookResult = ReturnType<typeof useDealsCountLazyQuery>;
export type DealsCountQueryResult = Apollo.QueryResult<Types.DealsCountQuery, Types.DealsCountQueryVariables>;
export const DealsOwnersDocument = gql`
    query DealsOwners {
  dealsOwners {
    ...DealOwner
  }
}
    ${DealOwnerFragmentDoc}`;

/**
 * __useDealsOwnersQuery__
 *
 * To run a query within a React component, call `useDealsOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealsOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealsOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealsOwnersQuery(baseOptions?: Apollo.QueryHookOptions<Types.DealsOwnersQuery, Types.DealsOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DealsOwnersQuery, Types.DealsOwnersQueryVariables>(DealsOwnersDocument, options);
      }
export function useDealsOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DealsOwnersQuery, Types.DealsOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DealsOwnersQuery, Types.DealsOwnersQueryVariables>(DealsOwnersDocument, options);
        }
export type DealsOwnersQueryHookResult = ReturnType<typeof useDealsOwnersQuery>;
export type DealsOwnersLazyQueryHookResult = ReturnType<typeof useDealsOwnersLazyQuery>;
export type DealsOwnersQueryResult = Apollo.QueryResult<Types.DealsOwnersQuery, Types.DealsOwnersQueryVariables>;
export const PaginatedDealsDocument = gql`
    query PaginatedDeals($pagination: PaginationInput, $filter: FilterDealsInput, $sort: SortDealsInput) {
  paginatedDeals(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    docs {
      ...Deal
    }
  }
}
    ${DealFragmentDoc}`;

/**
 * __usePaginatedDealsQuery__
 *
 * To run a query within a React component, call `usePaginatedDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedDealsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedDealsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedDealsQuery, Types.PaginatedDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedDealsQuery, Types.PaginatedDealsQueryVariables>(PaginatedDealsDocument, options);
      }
export function usePaginatedDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedDealsQuery, Types.PaginatedDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedDealsQuery, Types.PaginatedDealsQueryVariables>(PaginatedDealsDocument, options);
        }
export type PaginatedDealsQueryHookResult = ReturnType<typeof usePaginatedDealsQuery>;
export type PaginatedDealsLazyQueryHookResult = ReturnType<typeof usePaginatedDealsLazyQuery>;
export type PaginatedDealsQueryResult = Apollo.QueryResult<Types.PaginatedDealsQuery, Types.PaginatedDealsQueryVariables>;
export const PaginatedDealsOwnersDocument = gql`
    query PaginatedDealsOwners($pagination: PaginationInput, $filter: FilterDealsOwnersInput) {
  paginatedDealsOwners(pagination: $pagination, filter: $filter) {
    totalPages
    totalDocs
    page
    docs {
      ...DealOwner
    }
  }
}
    ${DealOwnerFragmentDoc}`;

/**
 * __usePaginatedDealsOwnersQuery__
 *
 * To run a query within a React component, call `usePaginatedDealsOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedDealsOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedDealsOwnersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedDealsOwnersQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedDealsOwnersQuery, Types.PaginatedDealsOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedDealsOwnersQuery, Types.PaginatedDealsOwnersQueryVariables>(PaginatedDealsOwnersDocument, options);
      }
export function usePaginatedDealsOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedDealsOwnersQuery, Types.PaginatedDealsOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedDealsOwnersQuery, Types.PaginatedDealsOwnersQueryVariables>(PaginatedDealsOwnersDocument, options);
        }
export type PaginatedDealsOwnersQueryHookResult = ReturnType<typeof usePaginatedDealsOwnersQuery>;
export type PaginatedDealsOwnersLazyQueryHookResult = ReturnType<typeof usePaginatedDealsOwnersLazyQuery>;
export type PaginatedDealsOwnersQueryResult = Apollo.QueryResult<Types.PaginatedDealsOwnersQuery, Types.PaginatedDealsOwnersQueryVariables>;
export const CreateFeedbackBoardDocument = gql`
    mutation CreateFeedbackBoard($input: CreateFeedbackBoardInput!) {
  createFeedbackBoard(input: $input) {
    ...FeedbackBoardInfo
  }
}
    ${FeedbackBoardInfoFragmentDoc}`;
export type CreateFeedbackBoardMutationFn = Apollo.MutationFunction<Types.CreateFeedbackBoardMutation, Types.CreateFeedbackBoardMutationVariables>;

/**
 * __useCreateFeedbackBoardMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackBoardMutation, { data, loading, error }] = useCreateFeedbackBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackBoardMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFeedbackBoardMutation, Types.CreateFeedbackBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFeedbackBoardMutation, Types.CreateFeedbackBoardMutationVariables>(CreateFeedbackBoardDocument, options);
      }
export type CreateFeedbackBoardMutationHookResult = ReturnType<typeof useCreateFeedbackBoardMutation>;
export type CreateFeedbackBoardMutationResult = Apollo.MutationResult<Types.CreateFeedbackBoardMutation>;
export type CreateFeedbackBoardMutationOptions = Apollo.BaseMutationOptions<Types.CreateFeedbackBoardMutation, Types.CreateFeedbackBoardMutationVariables>;
export const CreateFeedbackPostDocument = gql`
    mutation CreateFeedbackPost($input: CreateFeedbackPostAsAdminInput!) {
  createFeedbackPostAsAdmin(input: $input) {
    ...FeedbackPost
  }
}
    ${FeedbackPostFragmentDoc}`;
export type CreateFeedbackPostMutationFn = Apollo.MutationFunction<Types.CreateFeedbackPostMutation, Types.CreateFeedbackPostMutationVariables>;

/**
 * __useCreateFeedbackPostMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackPostMutation, { data, loading, error }] = useCreateFeedbackPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackPostMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFeedbackPostMutation, Types.CreateFeedbackPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFeedbackPostMutation, Types.CreateFeedbackPostMutationVariables>(CreateFeedbackPostDocument, options);
      }
export type CreateFeedbackPostMutationHookResult = ReturnType<typeof useCreateFeedbackPostMutation>;
export type CreateFeedbackPostMutationResult = Apollo.MutationResult<Types.CreateFeedbackPostMutation>;
export type CreateFeedbackPostMutationOptions = Apollo.BaseMutationOptions<Types.CreateFeedbackPostMutation, Types.CreateFeedbackPostMutationVariables>;
export const CreateFeedbackPostCommentDocument = gql`
    mutation CreateFeedbackPostComment($input: CreateFeedbackCommentInput!) {
  createFeedbackCommentAsAdmin(input: $input) {
    ...FeedbackPostComment
  }
}
    ${FeedbackPostCommentFragmentDoc}`;
export type CreateFeedbackPostCommentMutationFn = Apollo.MutationFunction<Types.CreateFeedbackPostCommentMutation, Types.CreateFeedbackPostCommentMutationVariables>;

/**
 * __useCreateFeedbackPostCommentMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackPostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackPostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackPostCommentMutation, { data, loading, error }] = useCreateFeedbackPostCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackPostCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFeedbackPostCommentMutation, Types.CreateFeedbackPostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFeedbackPostCommentMutation, Types.CreateFeedbackPostCommentMutationVariables>(CreateFeedbackPostCommentDocument, options);
      }
export type CreateFeedbackPostCommentMutationHookResult = ReturnType<typeof useCreateFeedbackPostCommentMutation>;
export type CreateFeedbackPostCommentMutationResult = Apollo.MutationResult<Types.CreateFeedbackPostCommentMutation>;
export type CreateFeedbackPostCommentMutationOptions = Apollo.BaseMutationOptions<Types.CreateFeedbackPostCommentMutation, Types.CreateFeedbackPostCommentMutationVariables>;
export const DeleteFeedbackBoardDocument = gql`
    mutation DeleteFeedbackBoard($id: String!) {
  deleteFeedbackBoard(id: $id) {
    id
  }
}
    `;
export type DeleteFeedbackBoardMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackBoardMutation, Types.DeleteFeedbackBoardMutationVariables>;

/**
 * __useDeleteFeedbackBoardMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackBoardMutation, { data, loading, error }] = useDeleteFeedbackBoardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackBoardMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackBoardMutation, Types.DeleteFeedbackBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackBoardMutation, Types.DeleteFeedbackBoardMutationVariables>(DeleteFeedbackBoardDocument, options);
      }
export type DeleteFeedbackBoardMutationHookResult = ReturnType<typeof useDeleteFeedbackBoardMutation>;
export type DeleteFeedbackBoardMutationResult = Apollo.MutationResult<Types.DeleteFeedbackBoardMutation>;
export type DeleteFeedbackBoardMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackBoardMutation, Types.DeleteFeedbackBoardMutationVariables>;
export const DeleteFeedbackCommentAsAdminDocument = gql`
    mutation DeleteFeedbackCommentAsAdmin($id: String!) {
  deleteFeedbackCommentAsAdmin(id: $id) {
    id
  }
}
    `;
export type DeleteFeedbackCommentAsAdminMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackCommentAsAdminMutation, Types.DeleteFeedbackCommentAsAdminMutationVariables>;

/**
 * __useDeleteFeedbackCommentAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackCommentAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackCommentAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackCommentAsAdminMutation, { data, loading, error }] = useDeleteFeedbackCommentAsAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackCommentAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackCommentAsAdminMutation, Types.DeleteFeedbackCommentAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackCommentAsAdminMutation, Types.DeleteFeedbackCommentAsAdminMutationVariables>(DeleteFeedbackCommentAsAdminDocument, options);
      }
export type DeleteFeedbackCommentAsAdminMutationHookResult = ReturnType<typeof useDeleteFeedbackCommentAsAdminMutation>;
export type DeleteFeedbackCommentAsAdminMutationResult = Apollo.MutationResult<Types.DeleteFeedbackCommentAsAdminMutation>;
export type DeleteFeedbackCommentAsAdminMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackCommentAsAdminMutation, Types.DeleteFeedbackCommentAsAdminMutationVariables>;
export const DeleteFeedbackPostAsAdminDocument = gql`
    mutation DeleteFeedbackPostAsAdmin($id: String!) {
  deleteFeedbackPostAsAdmin(id: $id) {
    id
  }
}
    `;
export type DeleteFeedbackPostAsAdminMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackPostAsAdminMutation, Types.DeleteFeedbackPostAsAdminMutationVariables>;

/**
 * __useDeleteFeedbackPostAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackPostAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackPostAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackPostAsAdminMutation, { data, loading, error }] = useDeleteFeedbackPostAsAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackPostAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackPostAsAdminMutation, Types.DeleteFeedbackPostAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackPostAsAdminMutation, Types.DeleteFeedbackPostAsAdminMutationVariables>(DeleteFeedbackPostAsAdminDocument, options);
      }
export type DeleteFeedbackPostAsAdminMutationHookResult = ReturnType<typeof useDeleteFeedbackPostAsAdminMutation>;
export type DeleteFeedbackPostAsAdminMutationResult = Apollo.MutationResult<Types.DeleteFeedbackPostAsAdminMutation>;
export type DeleteFeedbackPostAsAdminMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackPostAsAdminMutation, Types.DeleteFeedbackPostAsAdminMutationVariables>;
export const DownvoteFeedbackPostDocument = gql`
    mutation DownvoteFeedbackPost($postId: String!) {
  removeFeedbackPostUpvoteAsAdmin(postId: $postId) {
    id
    upvotedByUser
    updatedAt
    upvotes
    upvoters {
      ...FeedbackPostUser
    }
  }
}
    ${FeedbackPostUserFragmentDoc}`;
export type DownvoteFeedbackPostMutationFn = Apollo.MutationFunction<Types.DownvoteFeedbackPostMutation, Types.DownvoteFeedbackPostMutationVariables>;

/**
 * __useDownvoteFeedbackPostMutation__
 *
 * To run a mutation, you first call `useDownvoteFeedbackPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownvoteFeedbackPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downvoteFeedbackPostMutation, { data, loading, error }] = useDownvoteFeedbackPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDownvoteFeedbackPostMutation(baseOptions?: Apollo.MutationHookOptions<Types.DownvoteFeedbackPostMutation, Types.DownvoteFeedbackPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DownvoteFeedbackPostMutation, Types.DownvoteFeedbackPostMutationVariables>(DownvoteFeedbackPostDocument, options);
      }
export type DownvoteFeedbackPostMutationHookResult = ReturnType<typeof useDownvoteFeedbackPostMutation>;
export type DownvoteFeedbackPostMutationResult = Apollo.MutationResult<Types.DownvoteFeedbackPostMutation>;
export type DownvoteFeedbackPostMutationOptions = Apollo.BaseMutationOptions<Types.DownvoteFeedbackPostMutation, Types.DownvoteFeedbackPostMutationVariables>;
export const ExportFeedbackPostsToCsvDocument = gql`
    mutation ExportFeedbackPostsToCsv($filter: FilterFeedbackPostsInput) {
  exportFeedbackPostsToCsv(filter: $filter)
}
    `;
export type ExportFeedbackPostsToCsvMutationFn = Apollo.MutationFunction<Types.ExportFeedbackPostsToCsvMutation, Types.ExportFeedbackPostsToCsvMutationVariables>;

/**
 * __useExportFeedbackPostsToCsvMutation__
 *
 * To run a mutation, you first call `useExportFeedbackPostsToCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportFeedbackPostsToCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportFeedbackPostsToCsvMutation, { data, loading, error }] = useExportFeedbackPostsToCsvMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportFeedbackPostsToCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportFeedbackPostsToCsvMutation, Types.ExportFeedbackPostsToCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportFeedbackPostsToCsvMutation, Types.ExportFeedbackPostsToCsvMutationVariables>(ExportFeedbackPostsToCsvDocument, options);
      }
export type ExportFeedbackPostsToCsvMutationHookResult = ReturnType<typeof useExportFeedbackPostsToCsvMutation>;
export type ExportFeedbackPostsToCsvMutationResult = Apollo.MutationResult<Types.ExportFeedbackPostsToCsvMutation>;
export type ExportFeedbackPostsToCsvMutationOptions = Apollo.BaseMutationOptions<Types.ExportFeedbackPostsToCsvMutation, Types.ExportFeedbackPostsToCsvMutationVariables>;
export const ImportFeedbackPostsFromCsvDocument = gql`
    mutation ImportFeedbackPostsFromCsv($input: ImportFeedbackPostsFromCsvInput!) {
  importFeedbackPostsFromCsv(input: $input) {
    ...FeedbackPost
  }
}
    ${FeedbackPostFragmentDoc}`;
export type ImportFeedbackPostsFromCsvMutationFn = Apollo.MutationFunction<Types.ImportFeedbackPostsFromCsvMutation, Types.ImportFeedbackPostsFromCsvMutationVariables>;

/**
 * __useImportFeedbackPostsFromCsvMutation__
 *
 * To run a mutation, you first call `useImportFeedbackPostsFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFeedbackPostsFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFeedbackPostsFromCsvMutation, { data, loading, error }] = useImportFeedbackPostsFromCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportFeedbackPostsFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportFeedbackPostsFromCsvMutation, Types.ImportFeedbackPostsFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportFeedbackPostsFromCsvMutation, Types.ImportFeedbackPostsFromCsvMutationVariables>(ImportFeedbackPostsFromCsvDocument, options);
      }
export type ImportFeedbackPostsFromCsvMutationHookResult = ReturnType<typeof useImportFeedbackPostsFromCsvMutation>;
export type ImportFeedbackPostsFromCsvMutationResult = Apollo.MutationResult<Types.ImportFeedbackPostsFromCsvMutation>;
export type ImportFeedbackPostsFromCsvMutationOptions = Apollo.BaseMutationOptions<Types.ImportFeedbackPostsFromCsvMutation, Types.ImportFeedbackPostsFromCsvMutationVariables>;
export const TurnFeedbackToRoadmapItemDocument = gql`
    mutation TurnFeedbackToRoadmapItem($input: TurnFeedbackPostIntoProductBoardItemInput!) {
  turnFeedbackPostIntoProductBoardItem(input: $input) {
    ...ProductBoardItemDetailed
  }
}
    ${ProductBoardItemDetailedFragmentDoc}`;
export type TurnFeedbackToRoadmapItemMutationFn = Apollo.MutationFunction<Types.TurnFeedbackToRoadmapItemMutation, Types.TurnFeedbackToRoadmapItemMutationVariables>;

/**
 * __useTurnFeedbackToRoadmapItemMutation__
 *
 * To run a mutation, you first call `useTurnFeedbackToRoadmapItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnFeedbackToRoadmapItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnFeedbackToRoadmapItemMutation, { data, loading, error }] = useTurnFeedbackToRoadmapItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTurnFeedbackToRoadmapItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.TurnFeedbackToRoadmapItemMutation, Types.TurnFeedbackToRoadmapItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TurnFeedbackToRoadmapItemMutation, Types.TurnFeedbackToRoadmapItemMutationVariables>(TurnFeedbackToRoadmapItemDocument, options);
      }
export type TurnFeedbackToRoadmapItemMutationHookResult = ReturnType<typeof useTurnFeedbackToRoadmapItemMutation>;
export type TurnFeedbackToRoadmapItemMutationResult = Apollo.MutationResult<Types.TurnFeedbackToRoadmapItemMutation>;
export type TurnFeedbackToRoadmapItemMutationOptions = Apollo.BaseMutationOptions<Types.TurnFeedbackToRoadmapItemMutation, Types.TurnFeedbackToRoadmapItemMutationVariables>;
export const UpdateFeedbackBoardDocument = gql`
    mutation UpdateFeedbackBoard($input: UpdateFeedbackBoardInput!) {
  updateFeedbackBoard(input: $input) {
    id
    name
    heading
    subHeading
    internal
    sendNotification
  }
}
    `;
export type UpdateFeedbackBoardMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackBoardMutation, Types.UpdateFeedbackBoardMutationVariables>;

/**
 * __useUpdateFeedbackBoardMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackBoardMutation, { data, loading, error }] = useUpdateFeedbackBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackBoardMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackBoardMutation, Types.UpdateFeedbackBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackBoardMutation, Types.UpdateFeedbackBoardMutationVariables>(UpdateFeedbackBoardDocument, options);
      }
export type UpdateFeedbackBoardMutationHookResult = ReturnType<typeof useUpdateFeedbackBoardMutation>;
export type UpdateFeedbackBoardMutationResult = Apollo.MutationResult<Types.UpdateFeedbackBoardMutation>;
export type UpdateFeedbackBoardMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackBoardMutation, Types.UpdateFeedbackBoardMutationVariables>;
export const UpdateFeedbackPostStatusDocument = gql`
    mutation UpdateFeedbackPostStatus($id: String!, $status: FeedbackPostStatus) {
  updateFeedbackPostAsAdmin(input: {id: $id, status: $status}) {
    id
    status
    updatedAt
  }
}
    `;
export type UpdateFeedbackPostStatusMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostStatusMutation, Types.UpdateFeedbackPostStatusMutationVariables>;

/**
 * __useUpdateFeedbackPostStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostStatusMutation, { data, loading, error }] = useUpdateFeedbackPostStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateFeedbackPostStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostStatusMutation, Types.UpdateFeedbackPostStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostStatusMutation, Types.UpdateFeedbackPostStatusMutationVariables>(UpdateFeedbackPostStatusDocument, options);
      }
export type UpdateFeedbackPostStatusMutationHookResult = ReturnType<typeof useUpdateFeedbackPostStatusMutation>;
export type UpdateFeedbackPostStatusMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostStatusMutation>;
export type UpdateFeedbackPostStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostStatusMutation, Types.UpdateFeedbackPostStatusMutationVariables>;
export const UpdateFeedbackPostDealsDocument = gql`
    mutation UpdateFeedbackPostDeals($id: String!, $dealIds: [String!]) {
  updateFeedbackPostAsAdmin(input: {id: $id, dealIds: $dealIds}) {
    id
    updatedAt
    deals {
      ...Deal
    }
  }
}
    ${DealFragmentDoc}`;
export type UpdateFeedbackPostDealsMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostDealsMutation, Types.UpdateFeedbackPostDealsMutationVariables>;

/**
 * __useUpdateFeedbackPostDealsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostDealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostDealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostDealsMutation, { data, loading, error }] = useUpdateFeedbackPostDealsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dealIds: // value for 'dealIds'
 *   },
 * });
 */
export function useUpdateFeedbackPostDealsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostDealsMutation, Types.UpdateFeedbackPostDealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostDealsMutation, Types.UpdateFeedbackPostDealsMutationVariables>(UpdateFeedbackPostDealsDocument, options);
      }
export type UpdateFeedbackPostDealsMutationHookResult = ReturnType<typeof useUpdateFeedbackPostDealsMutation>;
export type UpdateFeedbackPostDealsMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostDealsMutation>;
export type UpdateFeedbackPostDealsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostDealsMutation, Types.UpdateFeedbackPostDealsMutationVariables>;
export const UpdateFeedbackPostScopeDocument = gql`
    mutation UpdateFeedbackPostScope($id: String!, $internal: Boolean) {
  updateFeedbackPostAsAdmin(input: {id: $id, internal: $internal}) {
    id
    internal
    updatedAt
  }
}
    `;
export type UpdateFeedbackPostScopeMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostScopeMutation, Types.UpdateFeedbackPostScopeMutationVariables>;

/**
 * __useUpdateFeedbackPostScopeMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostScopeMutation, { data, loading, error }] = useUpdateFeedbackPostScopeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      internal: // value for 'internal'
 *   },
 * });
 */
export function useUpdateFeedbackPostScopeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostScopeMutation, Types.UpdateFeedbackPostScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostScopeMutation, Types.UpdateFeedbackPostScopeMutationVariables>(UpdateFeedbackPostScopeDocument, options);
      }
export type UpdateFeedbackPostScopeMutationHookResult = ReturnType<typeof useUpdateFeedbackPostScopeMutation>;
export type UpdateFeedbackPostScopeMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostScopeMutation>;
export type UpdateFeedbackPostScopeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostScopeMutation, Types.UpdateFeedbackPostScopeMutationVariables>;
export const UpdateFeedbackPostAssigneeDocument = gql`
    mutation UpdateFeedbackPostAssignee($id: String!, $assigneeId: String) {
  updateFeedbackPostAsAdmin(input: {id: $id, assigneeId: $assigneeId}) {
    id
    updatedAt
    assignee {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;
export type UpdateFeedbackPostAssigneeMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostAssigneeMutation, Types.UpdateFeedbackPostAssigneeMutationVariables>;

/**
 * __useUpdateFeedbackPostAssigneeMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostAssigneeMutation, { data, loading, error }] = useUpdateFeedbackPostAssigneeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useUpdateFeedbackPostAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostAssigneeMutation, Types.UpdateFeedbackPostAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostAssigneeMutation, Types.UpdateFeedbackPostAssigneeMutationVariables>(UpdateFeedbackPostAssigneeDocument, options);
      }
export type UpdateFeedbackPostAssigneeMutationHookResult = ReturnType<typeof useUpdateFeedbackPostAssigneeMutation>;
export type UpdateFeedbackPostAssigneeMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostAssigneeMutation>;
export type UpdateFeedbackPostAssigneeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostAssigneeMutation, Types.UpdateFeedbackPostAssigneeMutationVariables>;
export const UpdateFeedbackPostTagsDocument = gql`
    mutation UpdateFeedbackPostTags($id: String!, $tagIds: [String!]) {
  updateFeedbackPostAsAdmin(input: {id: $id, tagIds: $tagIds}) {
    id
    updatedAt
    tags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type UpdateFeedbackPostTagsMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostTagsMutation, Types.UpdateFeedbackPostTagsMutationVariables>;

/**
 * __useUpdateFeedbackPostTagsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostTagsMutation, { data, loading, error }] = useUpdateFeedbackPostTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useUpdateFeedbackPostTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostTagsMutation, Types.UpdateFeedbackPostTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostTagsMutation, Types.UpdateFeedbackPostTagsMutationVariables>(UpdateFeedbackPostTagsDocument, options);
      }
export type UpdateFeedbackPostTagsMutationHookResult = ReturnType<typeof useUpdateFeedbackPostTagsMutation>;
export type UpdateFeedbackPostTagsMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostTagsMutation>;
export type UpdateFeedbackPostTagsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostTagsMutation, Types.UpdateFeedbackPostTagsMutationVariables>;
export const UpdateFeedbackPostProductLineTagsDocument = gql`
    mutation UpdateFeedbackPostProductLineTags($id: String!, $productLineTagIds: [String!]) {
  updateFeedbackPostAsAdmin(
    input: {id: $id, productLineTagIds: $productLineTagIds}
  ) {
    id
    updatedAt
    productLineTags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type UpdateFeedbackPostProductLineTagsMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostProductLineTagsMutation, Types.UpdateFeedbackPostProductLineTagsMutationVariables>;

/**
 * __useUpdateFeedbackPostProductLineTagsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostProductLineTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostProductLineTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostProductLineTagsMutation, { data, loading, error }] = useUpdateFeedbackPostProductLineTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productLineTagIds: // value for 'productLineTagIds'
 *   },
 * });
 */
export function useUpdateFeedbackPostProductLineTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostProductLineTagsMutation, Types.UpdateFeedbackPostProductLineTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostProductLineTagsMutation, Types.UpdateFeedbackPostProductLineTagsMutationVariables>(UpdateFeedbackPostProductLineTagsDocument, options);
      }
export type UpdateFeedbackPostProductLineTagsMutationHookResult = ReturnType<typeof useUpdateFeedbackPostProductLineTagsMutation>;
export type UpdateFeedbackPostProductLineTagsMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostProductLineTagsMutation>;
export type UpdateFeedbackPostProductLineTagsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostProductLineTagsMutation, Types.UpdateFeedbackPostProductLineTagsMutationVariables>;
export const UpdateFeedbackPostCustomColumnsDocument = gql`
    mutation UpdateFeedbackPostCustomColumns($id: String!, $customColumns: [FeedbackPostCustomColumnInput!]) {
  updateFeedbackPostAsAdmin(input: {id: $id, customColumns: $customColumns}) {
    id
    updatedAt
    customColumns {
      ...FeedbackPostCustomColumn
    }
  }
}
    ${FeedbackPostCustomColumnFragmentDoc}`;
export type UpdateFeedbackPostCustomColumnsMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostCustomColumnsMutation, Types.UpdateFeedbackPostCustomColumnsMutationVariables>;

/**
 * __useUpdateFeedbackPostCustomColumnsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostCustomColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostCustomColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostCustomColumnsMutation, { data, loading, error }] = useUpdateFeedbackPostCustomColumnsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customColumns: // value for 'customColumns'
 *   },
 * });
 */
export function useUpdateFeedbackPostCustomColumnsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostCustomColumnsMutation, Types.UpdateFeedbackPostCustomColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostCustomColumnsMutation, Types.UpdateFeedbackPostCustomColumnsMutationVariables>(UpdateFeedbackPostCustomColumnsDocument, options);
      }
export type UpdateFeedbackPostCustomColumnsMutationHookResult = ReturnType<typeof useUpdateFeedbackPostCustomColumnsMutation>;
export type UpdateFeedbackPostCustomColumnsMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostCustomColumnsMutation>;
export type UpdateFeedbackPostCustomColumnsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostCustomColumnsMutation, Types.UpdateFeedbackPostCustomColumnsMutationVariables>;
export const UpdateFeedbackPostConnectionsDocument = gql`
    mutation UpdateFeedbackPostConnections($input: UpdateFeedbackPostAsAdminInput!) {
  updateFeedbackPostAsAdmin(input: $input) {
    id
    updatedAt
    insights {
      ...InsightMenuOption
    }
    productBoardItems {
      ...ProductBoardItemMenuOption
    }
  }
}
    ${InsightMenuOptionFragmentDoc}
${ProductBoardItemMenuOptionFragmentDoc}`;
export type UpdateFeedbackPostConnectionsMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostConnectionsMutation, Types.UpdateFeedbackPostConnectionsMutationVariables>;

/**
 * __useUpdateFeedbackPostConnectionsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostConnectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostConnectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostConnectionsMutation, { data, loading, error }] = useUpdateFeedbackPostConnectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackPostConnectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostConnectionsMutation, Types.UpdateFeedbackPostConnectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostConnectionsMutation, Types.UpdateFeedbackPostConnectionsMutationVariables>(UpdateFeedbackPostConnectionsDocument, options);
      }
export type UpdateFeedbackPostConnectionsMutationHookResult = ReturnType<typeof useUpdateFeedbackPostConnectionsMutation>;
export type UpdateFeedbackPostConnectionsMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostConnectionsMutation>;
export type UpdateFeedbackPostConnectionsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostConnectionsMutation, Types.UpdateFeedbackPostConnectionsMutationVariables>;
export const UpdateFeedbackPostDocument = gql`
    mutation UpdateFeedbackPost($input: UpdateFeedbackPostAsAdminInput!) {
  updateFeedbackPostAsAdmin(input: $input) {
    ...FeedbackPost
  }
}
    ${FeedbackPostFragmentDoc}`;
export type UpdateFeedbackPostMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostMutation, Types.UpdateFeedbackPostMutationVariables>;

/**
 * __useUpdateFeedbackPostMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostMutation, { data, loading, error }] = useUpdateFeedbackPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackPostMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostMutation, Types.UpdateFeedbackPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostMutation, Types.UpdateFeedbackPostMutationVariables>(UpdateFeedbackPostDocument, options);
      }
export type UpdateFeedbackPostMutationHookResult = ReturnType<typeof useUpdateFeedbackPostMutation>;
export type UpdateFeedbackPostMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostMutation>;
export type UpdateFeedbackPostMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostMutation, Types.UpdateFeedbackPostMutationVariables>;
export const UpdateFeedbackPostPreviewDocument = gql`
    mutation UpdateFeedbackPostPreview($input: UpdateFeedbackPostAsAdminInput!) {
  updateFeedbackPostAsAdmin(input: $input) {
    ...FeedbackPost
  }
}
    ${FeedbackPostFragmentDoc}`;
export type UpdateFeedbackPostPreviewMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackPostPreviewMutation, Types.UpdateFeedbackPostPreviewMutationVariables>;

/**
 * __useUpdateFeedbackPostPreviewMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackPostPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackPostPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackPostPreviewMutation, { data, loading, error }] = useUpdateFeedbackPostPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackPostPreviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackPostPreviewMutation, Types.UpdateFeedbackPostPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackPostPreviewMutation, Types.UpdateFeedbackPostPreviewMutationVariables>(UpdateFeedbackPostPreviewDocument, options);
      }
export type UpdateFeedbackPostPreviewMutationHookResult = ReturnType<typeof useUpdateFeedbackPostPreviewMutation>;
export type UpdateFeedbackPostPreviewMutationResult = Apollo.MutationResult<Types.UpdateFeedbackPostPreviewMutation>;
export type UpdateFeedbackPostPreviewMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackPostPreviewMutation, Types.UpdateFeedbackPostPreviewMutationVariables>;
export const AttachTagsToFeedbackPostsDocument = gql`
    mutation AttachTagsToFeedbackPosts($input: UpdateTagsOfFeedbackPostsInput!) {
  attachTagsToFeedbackPostsAsAdmin(input: $input) {
    id
    updatedAt
    tags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type AttachTagsToFeedbackPostsMutationFn = Apollo.MutationFunction<Types.AttachTagsToFeedbackPostsMutation, Types.AttachTagsToFeedbackPostsMutationVariables>;

/**
 * __useAttachTagsToFeedbackPostsMutation__
 *
 * To run a mutation, you first call `useAttachTagsToFeedbackPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachTagsToFeedbackPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachTagsToFeedbackPostsMutation, { data, loading, error }] = useAttachTagsToFeedbackPostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachTagsToFeedbackPostsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttachTagsToFeedbackPostsMutation, Types.AttachTagsToFeedbackPostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttachTagsToFeedbackPostsMutation, Types.AttachTagsToFeedbackPostsMutationVariables>(AttachTagsToFeedbackPostsDocument, options);
      }
export type AttachTagsToFeedbackPostsMutationHookResult = ReturnType<typeof useAttachTagsToFeedbackPostsMutation>;
export type AttachTagsToFeedbackPostsMutationResult = Apollo.MutationResult<Types.AttachTagsToFeedbackPostsMutation>;
export type AttachTagsToFeedbackPostsMutationOptions = Apollo.BaseMutationOptions<Types.AttachTagsToFeedbackPostsMutation, Types.AttachTagsToFeedbackPostsMutationVariables>;
export const DetachTagsFromFeedbackPostsDocument = gql`
    mutation DetachTagsFromFeedbackPosts($input: UpdateTagsOfFeedbackPostsInput!) {
  detachTagsFromFeedbackPostsAsAdmin(input: $input) {
    id
    updatedAt
    tags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type DetachTagsFromFeedbackPostsMutationFn = Apollo.MutationFunction<Types.DetachTagsFromFeedbackPostsMutation, Types.DetachTagsFromFeedbackPostsMutationVariables>;

/**
 * __useDetachTagsFromFeedbackPostsMutation__
 *
 * To run a mutation, you first call `useDetachTagsFromFeedbackPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachTagsFromFeedbackPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachTagsFromFeedbackPostsMutation, { data, loading, error }] = useDetachTagsFromFeedbackPostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetachTagsFromFeedbackPostsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DetachTagsFromFeedbackPostsMutation, Types.DetachTagsFromFeedbackPostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DetachTagsFromFeedbackPostsMutation, Types.DetachTagsFromFeedbackPostsMutationVariables>(DetachTagsFromFeedbackPostsDocument, options);
      }
export type DetachTagsFromFeedbackPostsMutationHookResult = ReturnType<typeof useDetachTagsFromFeedbackPostsMutation>;
export type DetachTagsFromFeedbackPostsMutationResult = Apollo.MutationResult<Types.DetachTagsFromFeedbackPostsMutation>;
export type DetachTagsFromFeedbackPostsMutationOptions = Apollo.BaseMutationOptions<Types.DetachTagsFromFeedbackPostsMutation, Types.DetachTagsFromFeedbackPostsMutationVariables>;
export const UpvoteFeedbackPostDocument = gql`
    mutation UpvoteFeedbackPost($postId: String!) {
  upvoteFeedbackPostAsAdmin(postId: $postId) {
    id
    upvotedByUser
    updatedAt
    upvotes
    upvoters {
      ...FeedbackPostUser
    }
  }
}
    ${FeedbackPostUserFragmentDoc}`;
export type UpvoteFeedbackPostMutationFn = Apollo.MutationFunction<Types.UpvoteFeedbackPostMutation, Types.UpvoteFeedbackPostMutationVariables>;

/**
 * __useUpvoteFeedbackPostMutation__
 *
 * To run a mutation, you first call `useUpvoteFeedbackPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpvoteFeedbackPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upvoteFeedbackPostMutation, { data, loading, error }] = useUpvoteFeedbackPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useUpvoteFeedbackPostMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpvoteFeedbackPostMutation, Types.UpvoteFeedbackPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpvoteFeedbackPostMutation, Types.UpvoteFeedbackPostMutationVariables>(UpvoteFeedbackPostDocument, options);
      }
export type UpvoteFeedbackPostMutationHookResult = ReturnType<typeof useUpvoteFeedbackPostMutation>;
export type UpvoteFeedbackPostMutationResult = Apollo.MutationResult<Types.UpvoteFeedbackPostMutation>;
export type UpvoteFeedbackPostMutationOptions = Apollo.BaseMutationOptions<Types.UpvoteFeedbackPostMutation, Types.UpvoteFeedbackPostMutationVariables>;
export const CreateFeedbackCustomColumnDocument = gql`
    mutation CreateFeedbackCustomColumn($input: CreateFeedbackCustomColumnInput!) {
  createFeedbackCustomColumn(input: $input) {
    ...FeedbackCustomColumn
  }
}
    ${FeedbackCustomColumnFragmentDoc}`;
export type CreateFeedbackCustomColumnMutationFn = Apollo.MutationFunction<Types.CreateFeedbackCustomColumnMutation, Types.CreateFeedbackCustomColumnMutationVariables>;

/**
 * __useCreateFeedbackCustomColumnMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackCustomColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackCustomColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackCustomColumnMutation, { data, loading, error }] = useCreateFeedbackCustomColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackCustomColumnMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFeedbackCustomColumnMutation, Types.CreateFeedbackCustomColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFeedbackCustomColumnMutation, Types.CreateFeedbackCustomColumnMutationVariables>(CreateFeedbackCustomColumnDocument, options);
      }
export type CreateFeedbackCustomColumnMutationHookResult = ReturnType<typeof useCreateFeedbackCustomColumnMutation>;
export type CreateFeedbackCustomColumnMutationResult = Apollo.MutationResult<Types.CreateFeedbackCustomColumnMutation>;
export type CreateFeedbackCustomColumnMutationOptions = Apollo.BaseMutationOptions<Types.CreateFeedbackCustomColumnMutation, Types.CreateFeedbackCustomColumnMutationVariables>;
export const UpdateFeedbackCustomColumnDocument = gql`
    mutation UpdateFeedbackCustomColumn($input: UpdateFeedbackCustomColumnInput!) {
  updateFeedbackCustomColumn(input: $input) {
    ...FeedbackCustomColumn
  }
}
    ${FeedbackCustomColumnFragmentDoc}`;
export type UpdateFeedbackCustomColumnMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackCustomColumnMutation, Types.UpdateFeedbackCustomColumnMutationVariables>;

/**
 * __useUpdateFeedbackCustomColumnMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackCustomColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackCustomColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackCustomColumnMutation, { data, loading, error }] = useUpdateFeedbackCustomColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackCustomColumnMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackCustomColumnMutation, Types.UpdateFeedbackCustomColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackCustomColumnMutation, Types.UpdateFeedbackCustomColumnMutationVariables>(UpdateFeedbackCustomColumnDocument, options);
      }
export type UpdateFeedbackCustomColumnMutationHookResult = ReturnType<typeof useUpdateFeedbackCustomColumnMutation>;
export type UpdateFeedbackCustomColumnMutationResult = Apollo.MutationResult<Types.UpdateFeedbackCustomColumnMutation>;
export type UpdateFeedbackCustomColumnMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackCustomColumnMutation, Types.UpdateFeedbackCustomColumnMutationVariables>;
export const DeleteFeedbackCustomColumnDocument = gql`
    mutation DeleteFeedbackCustomColumn($id: String!) {
  deleteFeedbackCustomColumn(id: $id) {
    ...FeedbackCustomColumn
  }
}
    ${FeedbackCustomColumnFragmentDoc}`;
export type DeleteFeedbackCustomColumnMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackCustomColumnMutation, Types.DeleteFeedbackCustomColumnMutationVariables>;

/**
 * __useDeleteFeedbackCustomColumnMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackCustomColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackCustomColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackCustomColumnMutation, { data, loading, error }] = useDeleteFeedbackCustomColumnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackCustomColumnMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackCustomColumnMutation, Types.DeleteFeedbackCustomColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackCustomColumnMutation, Types.DeleteFeedbackCustomColumnMutationVariables>(DeleteFeedbackCustomColumnDocument, options);
      }
export type DeleteFeedbackCustomColumnMutationHookResult = ReturnType<typeof useDeleteFeedbackCustomColumnMutation>;
export type DeleteFeedbackCustomColumnMutationResult = Apollo.MutationResult<Types.DeleteFeedbackCustomColumnMutation>;
export type DeleteFeedbackCustomColumnMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackCustomColumnMutation, Types.DeleteFeedbackCustomColumnMutationVariables>;
export const FeedbackBoardsDocument = gql`
    query FeedbackBoards {
  feedbackBoards {
    ...FeedbackBoardInfo
  }
}
    ${FeedbackBoardInfoFragmentDoc}`;

/**
 * __useFeedbackBoardsQuery__
 *
 * To run a query within a React component, call `useFeedbackBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedbackBoardsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FeedbackBoardsQuery, Types.FeedbackBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeedbackBoardsQuery, Types.FeedbackBoardsQueryVariables>(FeedbackBoardsDocument, options);
      }
export function useFeedbackBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeedbackBoardsQuery, Types.FeedbackBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeedbackBoardsQuery, Types.FeedbackBoardsQueryVariables>(FeedbackBoardsDocument, options);
        }
export type FeedbackBoardsQueryHookResult = ReturnType<typeof useFeedbackBoardsQuery>;
export type FeedbackBoardsLazyQueryHookResult = ReturnType<typeof useFeedbackBoardsLazyQuery>;
export type FeedbackBoardsQueryResult = Apollo.QueryResult<Types.FeedbackBoardsQuery, Types.FeedbackBoardsQueryVariables>;
export const FeedbackBoardsOptionsDocument = gql`
    query FeedbackBoardsOptions {
  feedbackBoards {
    ...FeedbackBoardOption
  }
}
    ${FeedbackBoardOptionFragmentDoc}`;

/**
 * __useFeedbackBoardsOptionsQuery__
 *
 * To run a query within a React component, call `useFeedbackBoardsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackBoardsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackBoardsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedbackBoardsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FeedbackBoardsOptionsQuery, Types.FeedbackBoardsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeedbackBoardsOptionsQuery, Types.FeedbackBoardsOptionsQueryVariables>(FeedbackBoardsOptionsDocument, options);
      }
export function useFeedbackBoardsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeedbackBoardsOptionsQuery, Types.FeedbackBoardsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeedbackBoardsOptionsQuery, Types.FeedbackBoardsOptionsQueryVariables>(FeedbackBoardsOptionsDocument, options);
        }
export type FeedbackBoardsOptionsQueryHookResult = ReturnType<typeof useFeedbackBoardsOptionsQuery>;
export type FeedbackBoardsOptionsLazyQueryHookResult = ReturnType<typeof useFeedbackBoardsOptionsLazyQuery>;
export type FeedbackBoardsOptionsQueryResult = Apollo.QueryResult<Types.FeedbackBoardsOptionsQuery, Types.FeedbackBoardsOptionsQueryVariables>;
export const FeedbackPostDocument = gql`
    query FeedbackPost($id: String!) {
  feedbackPost(id: $id) {
    ...FeedbackPost
  }
}
    ${FeedbackPostFragmentDoc}`;

/**
 * __useFeedbackPostQuery__
 *
 * To run a query within a React component, call `useFeedbackPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackPostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeedbackPostQuery(baseOptions: Apollo.QueryHookOptions<Types.FeedbackPostQuery, Types.FeedbackPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeedbackPostQuery, Types.FeedbackPostQueryVariables>(FeedbackPostDocument, options);
      }
export function useFeedbackPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeedbackPostQuery, Types.FeedbackPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeedbackPostQuery, Types.FeedbackPostQueryVariables>(FeedbackPostDocument, options);
        }
export type FeedbackPostQueryHookResult = ReturnType<typeof useFeedbackPostQuery>;
export type FeedbackPostLazyQueryHookResult = ReturnType<typeof useFeedbackPostLazyQuery>;
export type FeedbackPostQueryResult = Apollo.QueryResult<Types.FeedbackPostQuery, Types.FeedbackPostQueryVariables>;
export const FeedbackPostCommentsDocument = gql`
    query FeedbackPostComments($id: String!) {
  feedbackPost(id: $id) {
    id
    comments {
      ...FeedbackPostComment
    }
  }
}
    ${FeedbackPostCommentFragmentDoc}`;

/**
 * __useFeedbackPostCommentsQuery__
 *
 * To run a query within a React component, call `useFeedbackPostCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackPostCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackPostCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeedbackPostCommentsQuery(baseOptions: Apollo.QueryHookOptions<Types.FeedbackPostCommentsQuery, Types.FeedbackPostCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeedbackPostCommentsQuery, Types.FeedbackPostCommentsQueryVariables>(FeedbackPostCommentsDocument, options);
      }
export function useFeedbackPostCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeedbackPostCommentsQuery, Types.FeedbackPostCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeedbackPostCommentsQuery, Types.FeedbackPostCommentsQueryVariables>(FeedbackPostCommentsDocument, options);
        }
export type FeedbackPostCommentsQueryHookResult = ReturnType<typeof useFeedbackPostCommentsQuery>;
export type FeedbackPostCommentsLazyQueryHookResult = ReturnType<typeof useFeedbackPostCommentsLazyQuery>;
export type FeedbackPostCommentsQueryResult = Apollo.QueryResult<Types.FeedbackPostCommentsQuery, Types.FeedbackPostCommentsQueryVariables>;
export const FeedbackPostsDocument = gql`
    query FeedbackPosts($filter: FilterFeedbackPostsInput, $sort: SortFeedbackPostsInput) {
  feedbackPosts(filter: $filter, sort: $sort) {
    ...FeedbackPost
  }
}
    ${FeedbackPostFragmentDoc}`;

/**
 * __useFeedbackPostsQuery__
 *
 * To run a query within a React component, call `useFeedbackPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackPostsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFeedbackPostsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FeedbackPostsQuery, Types.FeedbackPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeedbackPostsQuery, Types.FeedbackPostsQueryVariables>(FeedbackPostsDocument, options);
      }
export function useFeedbackPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeedbackPostsQuery, Types.FeedbackPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeedbackPostsQuery, Types.FeedbackPostsQueryVariables>(FeedbackPostsDocument, options);
        }
export type FeedbackPostsQueryHookResult = ReturnType<typeof useFeedbackPostsQuery>;
export type FeedbackPostsLazyQueryHookResult = ReturnType<typeof useFeedbackPostsLazyQuery>;
export type FeedbackPostsQueryResult = Apollo.QueryResult<Types.FeedbackPostsQuery, Types.FeedbackPostsQueryVariables>;
export const PaginatedFeedbackPostsDocument = gql`
    query PaginatedFeedbackPosts($pagination: PaginationInput!, $filter: FilterFeedbackPostsInput, $sort: SortFeedbackPostsInput) {
  paginatedFeedbackPosts(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    docs {
      ...FeedbackPostTableRow
    }
  }
}
    ${FeedbackPostTableRowFragmentDoc}`;

/**
 * __usePaginatedFeedbackPostsQuery__
 *
 * To run a query within a React component, call `usePaginatedFeedbackPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFeedbackPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFeedbackPostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedFeedbackPostsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedFeedbackPostsQuery, Types.PaginatedFeedbackPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedFeedbackPostsQuery, Types.PaginatedFeedbackPostsQueryVariables>(PaginatedFeedbackPostsDocument, options);
      }
export function usePaginatedFeedbackPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedFeedbackPostsQuery, Types.PaginatedFeedbackPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedFeedbackPostsQuery, Types.PaginatedFeedbackPostsQueryVariables>(PaginatedFeedbackPostsDocument, options);
        }
export type PaginatedFeedbackPostsQueryHookResult = ReturnType<typeof usePaginatedFeedbackPostsQuery>;
export type PaginatedFeedbackPostsLazyQueryHookResult = ReturnType<typeof usePaginatedFeedbackPostsLazyQuery>;
export type PaginatedFeedbackPostsQueryResult = Apollo.QueryResult<Types.PaginatedFeedbackPostsQuery, Types.PaginatedFeedbackPostsQueryVariables>;
export const ReleaseNotesSubscribersDocument = gql`
    query ReleaseNotesSubscribers {
  releaseNotesSubscribers {
    ...ReleaseNotesSubscriber
  }
}
    ${ReleaseNotesSubscriberFragmentDoc}`;

/**
 * __useReleaseNotesSubscribersQuery__
 *
 * To run a query within a React component, call `useReleaseNotesSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReleaseNotesSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReleaseNotesSubscribersQuery({
 *   variables: {
 *   },
 * });
 */
export function useReleaseNotesSubscribersQuery(baseOptions?: Apollo.QueryHookOptions<Types.ReleaseNotesSubscribersQuery, Types.ReleaseNotesSubscribersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReleaseNotesSubscribersQuery, Types.ReleaseNotesSubscribersQueryVariables>(ReleaseNotesSubscribersDocument, options);
      }
export function useReleaseNotesSubscribersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReleaseNotesSubscribersQuery, Types.ReleaseNotesSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReleaseNotesSubscribersQuery, Types.ReleaseNotesSubscribersQueryVariables>(ReleaseNotesSubscribersDocument, options);
        }
export type ReleaseNotesSubscribersQueryHookResult = ReturnType<typeof useReleaseNotesSubscribersQuery>;
export type ReleaseNotesSubscribersLazyQueryHookResult = ReturnType<typeof useReleaseNotesSubscribersLazyQuery>;
export type ReleaseNotesSubscribersQueryResult = Apollo.QueryResult<Types.ReleaseNotesSubscribersQuery, Types.ReleaseNotesSubscribersQueryVariables>;
export const GenerateSummaryUsingAiDocument = gql`
    mutation GenerateSummaryUsingAI($companyName: String!) {
  generateSummaryUsingAI(companyName: $companyName) {
    companyName
    strengths
    weaknesses
  }
}
    `;
export type GenerateSummaryUsingAiMutationFn = Apollo.MutationFunction<Types.GenerateSummaryUsingAiMutation, Types.GenerateSummaryUsingAiMutationVariables>;

/**
 * __useGenerateSummaryUsingAiMutation__
 *
 * To run a mutation, you first call `useGenerateSummaryUsingAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSummaryUsingAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSummaryUsingAiMutation, { data, loading, error }] = useGenerateSummaryUsingAiMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useGenerateSummaryUsingAiMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateSummaryUsingAiMutation, Types.GenerateSummaryUsingAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateSummaryUsingAiMutation, Types.GenerateSummaryUsingAiMutationVariables>(GenerateSummaryUsingAiDocument, options);
      }
export type GenerateSummaryUsingAiMutationHookResult = ReturnType<typeof useGenerateSummaryUsingAiMutation>;
export type GenerateSummaryUsingAiMutationResult = Apollo.MutationResult<Types.GenerateSummaryUsingAiMutation>;
export type GenerateSummaryUsingAiMutationOptions = Apollo.BaseMutationOptions<Types.GenerateSummaryUsingAiMutation, Types.GenerateSummaryUsingAiMutationVariables>;
export const RequestUserReviewsDocument = gql`
    mutation RequestUserReviews($companyName: String!) {
  requestUserReviews(companyName: $companyName)
}
    `;
export type RequestUserReviewsMutationFn = Apollo.MutationFunction<Types.RequestUserReviewsMutation, Types.RequestUserReviewsMutationVariables>;

/**
 * __useRequestUserReviewsMutation__
 *
 * To run a mutation, you first call `useRequestUserReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUserReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUserReviewsMutation, { data, loading, error }] = useRequestUserReviewsMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useRequestUserReviewsMutation(baseOptions?: Apollo.MutationHookOptions<Types.RequestUserReviewsMutation, Types.RequestUserReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RequestUserReviewsMutation, Types.RequestUserReviewsMutationVariables>(RequestUserReviewsDocument, options);
      }
export type RequestUserReviewsMutationHookResult = ReturnType<typeof useRequestUserReviewsMutation>;
export type RequestUserReviewsMutationResult = Apollo.MutationResult<Types.RequestUserReviewsMutation>;
export type RequestUserReviewsMutationOptions = Apollo.BaseMutationOptions<Types.RequestUserReviewsMutation, Types.RequestUserReviewsMutationVariables>;
export const GetAiSummaryDocument = gql`
    query GetAISummary($companyName: String!) {
  getAISummary(companyName: $companyName) {
    companyName
    strengths
    weaknesses
  }
}
    `;

/**
 * __useGetAiSummaryQuery__
 *
 * To run a query within a React component, call `useGetAiSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiSummaryQuery({
 *   variables: {
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useGetAiSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAiSummaryQuery, Types.GetAiSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAiSummaryQuery, Types.GetAiSummaryQueryVariables>(GetAiSummaryDocument, options);
      }
export function useGetAiSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAiSummaryQuery, Types.GetAiSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAiSummaryQuery, Types.GetAiSummaryQueryVariables>(GetAiSummaryDocument, options);
        }
export type GetAiSummaryQueryHookResult = ReturnType<typeof useGetAiSummaryQuery>;
export type GetAiSummaryLazyQueryHookResult = ReturnType<typeof useGetAiSummaryLazyQuery>;
export type GetAiSummaryQueryResult = Apollo.QueryResult<Types.GetAiSummaryQuery, Types.GetAiSummaryQueryVariables>;
export const CompanyRatingDocument = gql`
    query CompanyRating($companyName: String!) {
  companyRating(companyName: $companyName) {
    rating
    noOfReviews
  }
}
    `;

/**
 * __useCompanyRatingQuery__
 *
 * To run a query within a React component, call `useCompanyRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyRatingQuery({
 *   variables: {
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useCompanyRatingQuery(baseOptions: Apollo.QueryHookOptions<Types.CompanyRatingQuery, Types.CompanyRatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CompanyRatingQuery, Types.CompanyRatingQueryVariables>(CompanyRatingDocument, options);
      }
export function useCompanyRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CompanyRatingQuery, Types.CompanyRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CompanyRatingQuery, Types.CompanyRatingQueryVariables>(CompanyRatingDocument, options);
        }
export type CompanyRatingQueryHookResult = ReturnType<typeof useCompanyRatingQuery>;
export type CompanyRatingLazyQueryHookResult = ReturnType<typeof useCompanyRatingLazyQuery>;
export type CompanyRatingQueryResult = Apollo.QueryResult<Types.CompanyRatingQuery, Types.CompanyRatingQueryVariables>;
export const PaginatedG2UserReviewsDocument = gql`
    query PaginatedG2UserReviews($pagination: PaginationInput, $companyName: String!) {
  paginatedG2UserReviews(pagination: $pagination, companyName: $companyName) {
    docs {
      ...UserReview
    }
    totalPages
    totalDocs
  }
}
    ${UserReviewFragmentDoc}`;

/**
 * __usePaginatedG2UserReviewsQuery__
 *
 * To run a query within a React component, call `usePaginatedG2UserReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedG2UserReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedG2UserReviewsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function usePaginatedG2UserReviewsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedG2UserReviewsQuery, Types.PaginatedG2UserReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedG2UserReviewsQuery, Types.PaginatedG2UserReviewsQueryVariables>(PaginatedG2UserReviewsDocument, options);
      }
export function usePaginatedG2UserReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedG2UserReviewsQuery, Types.PaginatedG2UserReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedG2UserReviewsQuery, Types.PaginatedG2UserReviewsQueryVariables>(PaginatedG2UserReviewsDocument, options);
        }
export type PaginatedG2UserReviewsQueryHookResult = ReturnType<typeof usePaginatedG2UserReviewsQuery>;
export type PaginatedG2UserReviewsLazyQueryHookResult = ReturnType<typeof usePaginatedG2UserReviewsLazyQuery>;
export type PaginatedG2UserReviewsQueryResult = Apollo.QueryResult<Types.PaginatedG2UserReviewsQuery, Types.PaginatedG2UserReviewsQueryVariables>;
export const RatingSummaryDocument = gql`
    query RatingSummary($companyName: String!) {
  ratingSummary(companyName: $companyName) {
    rating
    percentage
    noOfReviews
  }
}
    `;

/**
 * __useRatingSummaryQuery__
 *
 * To run a query within a React component, call `useRatingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatingSummaryQuery({
 *   variables: {
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useRatingSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.RatingSummaryQuery, Types.RatingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RatingSummaryQuery, Types.RatingSummaryQueryVariables>(RatingSummaryDocument, options);
      }
export function useRatingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RatingSummaryQuery, Types.RatingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RatingSummaryQuery, Types.RatingSummaryQueryVariables>(RatingSummaryDocument, options);
        }
export type RatingSummaryQueryHookResult = ReturnType<typeof useRatingSummaryQuery>;
export type RatingSummaryLazyQueryHookResult = ReturnType<typeof useRatingSummaryLazyQuery>;
export type RatingSummaryQueryResult = Apollo.QueryResult<Types.RatingSummaryQuery, Types.RatingSummaryQueryVariables>;
export const CreateChannelDocument = gql`
    mutation CreateChannel($input: CreateChannelInput!) {
  createChannel(input: $input) {
    ...Channel
  }
}
    ${ChannelFragmentDoc}`;
export type CreateChannelMutationFn = Apollo.MutationFunction<Types.CreateChannelMutation, Types.CreateChannelMutationVariables>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateChannelMutation, Types.CreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateChannelMutation, Types.CreateChannelMutationVariables>(CreateChannelDocument, options);
      }
export type CreateChannelMutationHookResult = ReturnType<typeof useCreateChannelMutation>;
export type CreateChannelMutationResult = Apollo.MutationResult<Types.CreateChannelMutation>;
export type CreateChannelMutationOptions = Apollo.BaseMutationOptions<Types.CreateChannelMutation, Types.CreateChannelMutationVariables>;
export const CreateChannelTimeframeDocument = gql`
    mutation CreateChannelTimeframe($input: CreateChannelTimeframeInput!) {
  createChannelTimeframe(input: $input) {
    ...ChannelTimeframe
  }
}
    ${ChannelTimeframeFragmentDoc}`;
export type CreateChannelTimeframeMutationFn = Apollo.MutationFunction<Types.CreateChannelTimeframeMutation, Types.CreateChannelTimeframeMutationVariables>;

/**
 * __useCreateChannelTimeframeMutation__
 *
 * To run a mutation, you first call `useCreateChannelTimeframeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelTimeframeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelTimeframeMutation, { data, loading, error }] = useCreateChannelTimeframeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChannelTimeframeMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateChannelTimeframeMutation, Types.CreateChannelTimeframeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateChannelTimeframeMutation, Types.CreateChannelTimeframeMutationVariables>(CreateChannelTimeframeDocument, options);
      }
export type CreateChannelTimeframeMutationHookResult = ReturnType<typeof useCreateChannelTimeframeMutation>;
export type CreateChannelTimeframeMutationResult = Apollo.MutationResult<Types.CreateChannelTimeframeMutation>;
export type CreateChannelTimeframeMutationOptions = Apollo.BaseMutationOptions<Types.CreateChannelTimeframeMutation, Types.CreateChannelTimeframeMutationVariables>;
export const CreateDefaultChannelsDocument = gql`
    mutation CreateDefaultChannels($input: CreateDefaultChannelsInput!) {
  createDefaultChannels(input: $input) {
    ...Channel
  }
}
    ${ChannelFragmentDoc}`;
export type CreateDefaultChannelsMutationFn = Apollo.MutationFunction<Types.CreateDefaultChannelsMutation, Types.CreateDefaultChannelsMutationVariables>;

/**
 * __useCreateDefaultChannelsMutation__
 *
 * To run a mutation, you first call `useCreateDefaultChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultChannelsMutation, { data, loading, error }] = useCreateDefaultChannelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDefaultChannelsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDefaultChannelsMutation, Types.CreateDefaultChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDefaultChannelsMutation, Types.CreateDefaultChannelsMutationVariables>(CreateDefaultChannelsDocument, options);
      }
export type CreateDefaultChannelsMutationHookResult = ReturnType<typeof useCreateDefaultChannelsMutation>;
export type CreateDefaultChannelsMutationResult = Apollo.MutationResult<Types.CreateDefaultChannelsMutation>;
export type CreateDefaultChannelsMutationOptions = Apollo.BaseMutationOptions<Types.CreateDefaultChannelsMutation, Types.CreateDefaultChannelsMutationVariables>;
export const CreateMilestoneDocument = gql`
    mutation CreateMilestone($input: CreateMilestoneInput!) {
  createMilestone(input: $input) {
    ...Milestone
  }
}
    ${MilestoneFragmentDoc}`;
export type CreateMilestoneMutationFn = Apollo.MutationFunction<Types.CreateMilestoneMutation, Types.CreateMilestoneMutationVariables>;

/**
 * __useCreateMilestoneMutation__
 *
 * To run a mutation, you first call `useCreateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMilestoneMutation, { data, loading, error }] = useCreateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMilestoneMutation, Types.CreateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMilestoneMutation, Types.CreateMilestoneMutationVariables>(CreateMilestoneDocument, options);
      }
export type CreateMilestoneMutationHookResult = ReturnType<typeof useCreateMilestoneMutation>;
export type CreateMilestoneMutationResult = Apollo.MutationResult<Types.CreateMilestoneMutation>;
export type CreateMilestoneMutationOptions = Apollo.BaseMutationOptions<Types.CreateMilestoneMutation, Types.CreateMilestoneMutationVariables>;
export const DeleteChannelDocument = gql`
    mutation DeleteChannel($input: DeleteChannelInput!) {
  deleteChannel(input: $input) {
    id
  }
}
    `;
export type DeleteChannelMutationFn = Apollo.MutationFunction<Types.DeleteChannelMutation, Types.DeleteChannelMutationVariables>;

/**
 * __useDeleteChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMutation, { data, loading, error }] = useDeleteChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteChannelMutation, Types.DeleteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteChannelMutation, Types.DeleteChannelMutationVariables>(DeleteChannelDocument, options);
      }
export type DeleteChannelMutationHookResult = ReturnType<typeof useDeleteChannelMutation>;
export type DeleteChannelMutationResult = Apollo.MutationResult<Types.DeleteChannelMutation>;
export type DeleteChannelMutationOptions = Apollo.BaseMutationOptions<Types.DeleteChannelMutation, Types.DeleteChannelMutationVariables>;
export const DeleteChannelTimeframeDocument = gql`
    mutation DeleteChannelTimeframe($input: DeleteChannelTimeframeInput!) {
  deleteChannelTimeframe(input: $input) {
    id
  }
}
    `;
export type DeleteChannelTimeframeMutationFn = Apollo.MutationFunction<Types.DeleteChannelTimeframeMutation, Types.DeleteChannelTimeframeMutationVariables>;

/**
 * __useDeleteChannelTimeframeMutation__
 *
 * To run a mutation, you first call `useDeleteChannelTimeframeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelTimeframeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelTimeframeMutation, { data, loading, error }] = useDeleteChannelTimeframeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChannelTimeframeMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteChannelTimeframeMutation, Types.DeleteChannelTimeframeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteChannelTimeframeMutation, Types.DeleteChannelTimeframeMutationVariables>(DeleteChannelTimeframeDocument, options);
      }
export type DeleteChannelTimeframeMutationHookResult = ReturnType<typeof useDeleteChannelTimeframeMutation>;
export type DeleteChannelTimeframeMutationResult = Apollo.MutationResult<Types.DeleteChannelTimeframeMutation>;
export type DeleteChannelTimeframeMutationOptions = Apollo.BaseMutationOptions<Types.DeleteChannelTimeframeMutation, Types.DeleteChannelTimeframeMutationVariables>;
export const DeleteMilestoneDocument = gql`
    mutation DeleteMilestone($input: DeleteMilestoneInput!) {
  deleteMilestone(input: $input) {
    id
  }
}
    `;
export type DeleteMilestoneMutationFn = Apollo.MutationFunction<Types.DeleteMilestoneMutation, Types.DeleteMilestoneMutationVariables>;

/**
 * __useDeleteMilestoneMutation__
 *
 * To run a mutation, you first call `useDeleteMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMilestoneMutation, { data, loading, error }] = useDeleteMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMilestoneMutation, Types.DeleteMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMilestoneMutation, Types.DeleteMilestoneMutationVariables>(DeleteMilestoneDocument, options);
      }
export type DeleteMilestoneMutationHookResult = ReturnType<typeof useDeleteMilestoneMutation>;
export type DeleteMilestoneMutationResult = Apollo.MutationResult<Types.DeleteMilestoneMutation>;
export type DeleteMilestoneMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMilestoneMutation, Types.DeleteMilestoneMutationVariables>;
export const UpdateChannelDocument = gql`
    mutation UpdateChannel($input: UpdateChannelInput!) {
  updateChannel(input: $input) {
    ...Channel
  }
}
    ${ChannelFragmentDoc}`;
export type UpdateChannelMutationFn = Apollo.MutationFunction<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>;

/**
 * __useUpdateChannelMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMutation, { data, loading, error }] = useUpdateChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>(UpdateChannelDocument, options);
      }
export type UpdateChannelMutationHookResult = ReturnType<typeof useUpdateChannelMutation>;
export type UpdateChannelMutationResult = Apollo.MutationResult<Types.UpdateChannelMutation>;
export type UpdateChannelMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChannelMutation, Types.UpdateChannelMutationVariables>;
export const UpdateChannelTimeframeDocument = gql`
    mutation UpdateChannelTimeframe($input: UpdateChannelTimeframeInput!) {
  updateChannelTimeframe(input: $input) {
    ...ChannelTimeframe
  }
}
    ${ChannelTimeframeFragmentDoc}`;
export type UpdateChannelTimeframeMutationFn = Apollo.MutationFunction<Types.UpdateChannelTimeframeMutation, Types.UpdateChannelTimeframeMutationVariables>;

/**
 * __useUpdateChannelTimeframeMutation__
 *
 * To run a mutation, you first call `useUpdateChannelTimeframeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelTimeframeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelTimeframeMutation, { data, loading, error }] = useUpdateChannelTimeframeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelTimeframeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChannelTimeframeMutation, Types.UpdateChannelTimeframeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChannelTimeframeMutation, Types.UpdateChannelTimeframeMutationVariables>(UpdateChannelTimeframeDocument, options);
      }
export type UpdateChannelTimeframeMutationHookResult = ReturnType<typeof useUpdateChannelTimeframeMutation>;
export type UpdateChannelTimeframeMutationResult = Apollo.MutationResult<Types.UpdateChannelTimeframeMutation>;
export type UpdateChannelTimeframeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChannelTimeframeMutation, Types.UpdateChannelTimeframeMutationVariables>;
export const UpdateMilestoneDocument = gql`
    mutation UpdateMilestone($input: UpdateMilestoneInput!) {
  updateMilestone(input: $input) {
    ...Milestone
  }
}
    ${MilestoneFragmentDoc}`;
export type UpdateMilestoneMutationFn = Apollo.MutationFunction<Types.UpdateMilestoneMutation, Types.UpdateMilestoneMutationVariables>;

/**
 * __useUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMilestoneMutation, { data, loading, error }] = useUpdateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMilestoneMutation, Types.UpdateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMilestoneMutation, Types.UpdateMilestoneMutationVariables>(UpdateMilestoneDocument, options);
      }
export type UpdateMilestoneMutationHookResult = ReturnType<typeof useUpdateMilestoneMutation>;
export type UpdateMilestoneMutationResult = Apollo.MutationResult<Types.UpdateMilestoneMutation>;
export type UpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMilestoneMutation, Types.UpdateMilestoneMutationVariables>;
export const GtmTimelineDocument = gql`
    query GtmTimeline($launchId: String!) {
  gtmTimeline(launchId: $launchId) {
    launchId
    channels {
      ...Channel
    }
    milestones {
      ...Milestone
    }
  }
}
    ${ChannelFragmentDoc}
${MilestoneFragmentDoc}`;

/**
 * __useGtmTimelineQuery__
 *
 * To run a query within a React component, call `useGtmTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGtmTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGtmTimelineQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useGtmTimelineQuery(baseOptions: Apollo.QueryHookOptions<Types.GtmTimelineQuery, Types.GtmTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GtmTimelineQuery, Types.GtmTimelineQueryVariables>(GtmTimelineDocument, options);
      }
export function useGtmTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GtmTimelineQuery, Types.GtmTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GtmTimelineQuery, Types.GtmTimelineQueryVariables>(GtmTimelineDocument, options);
        }
export type GtmTimelineQueryHookResult = ReturnType<typeof useGtmTimelineQuery>;
export type GtmTimelineLazyQueryHookResult = ReturnType<typeof useGtmTimelineLazyQuery>;
export type GtmTimelineQueryResult = Apollo.QueryResult<Types.GtmTimelineQuery, Types.GtmTimelineQueryVariables>;
export const LaunchViewTimelineFilterOptionsDocument = gql`
    query LaunchViewTimelineFilterOptions($launchId: String!) {
  tasksAssignees(filter: {launchIds: [$launchId]}) {
    ...UserDetails
  }
  tasksTags: tags(input: {launchId: $launchId, types: [TASK, PRODUCT_LINE]}) {
    ...Tag
  }
  productBoardReleases {
    id
    name
    items {
      docs {
        id
      }
    }
  }
}
    ${UserDetailsFragmentDoc}
${TagFragmentDoc}`;

/**
 * __useLaunchViewTimelineFilterOptionsQuery__
 *
 * To run a query within a React component, call `useLaunchViewTimelineFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchViewTimelineFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchViewTimelineFilterOptionsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchViewTimelineFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchViewTimelineFilterOptionsQuery, Types.LaunchViewTimelineFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchViewTimelineFilterOptionsQuery, Types.LaunchViewTimelineFilterOptionsQueryVariables>(LaunchViewTimelineFilterOptionsDocument, options);
      }
export function useLaunchViewTimelineFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchViewTimelineFilterOptionsQuery, Types.LaunchViewTimelineFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchViewTimelineFilterOptionsQuery, Types.LaunchViewTimelineFilterOptionsQueryVariables>(LaunchViewTimelineFilterOptionsDocument, options);
        }
export type LaunchViewTimelineFilterOptionsQueryHookResult = ReturnType<typeof useLaunchViewTimelineFilterOptionsQuery>;
export type LaunchViewTimelineFilterOptionsLazyQueryHookResult = ReturnType<typeof useLaunchViewTimelineFilterOptionsLazyQuery>;
export type LaunchViewTimelineFilterOptionsQueryResult = Apollo.QueryResult<Types.LaunchViewTimelineFilterOptionsQuery, Types.LaunchViewTimelineFilterOptionsQueryVariables>;
export const ProposedChannelsDocument = gql`
    query ProposedChannels($launchId: String!) {
  proposedChannels(launchId: $launchId) {
    launchId
    items {
      ...ChannelTemplate
    }
  }
}
    ${ChannelTemplateFragmentDoc}`;

/**
 * __useProposedChannelsQuery__
 *
 * To run a query within a React component, call `useProposedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposedChannelsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useProposedChannelsQuery(baseOptions: Apollo.QueryHookOptions<Types.ProposedChannelsQuery, Types.ProposedChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProposedChannelsQuery, Types.ProposedChannelsQueryVariables>(ProposedChannelsDocument, options);
      }
export function useProposedChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProposedChannelsQuery, Types.ProposedChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProposedChannelsQuery, Types.ProposedChannelsQueryVariables>(ProposedChannelsDocument, options);
        }
export type ProposedChannelsQueryHookResult = ReturnType<typeof useProposedChannelsQuery>;
export type ProposedChannelsLazyQueryHookResult = ReturnType<typeof useProposedChannelsLazyQuery>;
export type ProposedChannelsQueryResult = Apollo.QueryResult<Types.ProposedChannelsQuery, Types.ProposedChannelsQueryVariables>;
export const PublicLaunchPageGtmTimelineDocument = gql`
    query PublicLaunchPageGtmTimeline {
  publicLaunchPageGtmTimeline {
    launchId
    channels {
      ...Channel
    }
    milestones {
      ...Milestone
    }
  }
}
    ${ChannelFragmentDoc}
${MilestoneFragmentDoc}`;

/**
 * __usePublicLaunchPageGtmTimelineQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageGtmTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageGtmTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageGtmTimelineQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchPageGtmTimelineQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageGtmTimelineQuery, Types.PublicLaunchPageGtmTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageGtmTimelineQuery, Types.PublicLaunchPageGtmTimelineQueryVariables>(PublicLaunchPageGtmTimelineDocument, options);
      }
export function usePublicLaunchPageGtmTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageGtmTimelineQuery, Types.PublicLaunchPageGtmTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageGtmTimelineQuery, Types.PublicLaunchPageGtmTimelineQueryVariables>(PublicLaunchPageGtmTimelineDocument, options);
        }
export type PublicLaunchPageGtmTimelineQueryHookResult = ReturnType<typeof usePublicLaunchPageGtmTimelineQuery>;
export type PublicLaunchPageGtmTimelineLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageGtmTimelineLazyQuery>;
export type PublicLaunchPageGtmTimelineQueryResult = Apollo.QueryResult<Types.PublicLaunchPageGtmTimelineQuery, Types.PublicLaunchPageGtmTimelineQueryVariables>;
export const ChannelTimeframesUpdatedDocument = gql`
    subscription ChannelTimeframesUpdated($launchId: String!) {
  timeframesUpdated(launchId: $launchId) {
    event
    channelId
    timeframe {
      ...ChannelTimeframe
    }
  }
}
    ${ChannelTimeframeFragmentDoc}`;

/**
 * __useChannelTimeframesUpdatedSubscription__
 *
 * To run a query within a React component, call `useChannelTimeframesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChannelTimeframesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelTimeframesUpdatedSubscription({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useChannelTimeframesUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ChannelTimeframesUpdatedSubscription, Types.ChannelTimeframesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ChannelTimeframesUpdatedSubscription, Types.ChannelTimeframesUpdatedSubscriptionVariables>(ChannelTimeframesUpdatedDocument, options);
      }
export type ChannelTimeframesUpdatedSubscriptionHookResult = ReturnType<typeof useChannelTimeframesUpdatedSubscription>;
export type ChannelTimeframesUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ChannelTimeframesUpdatedSubscription>;
export const ChannelsUpdatedDocument = gql`
    subscription ChannelsUpdated($launchId: String!) {
  channelsUpdated(launchId: $launchId) {
    event
    channel {
      ...Channel
    }
  }
}
    ${ChannelFragmentDoc}`;

/**
 * __useChannelsUpdatedSubscription__
 *
 * To run a query within a React component, call `useChannelsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChannelsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsUpdatedSubscription({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useChannelsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.ChannelsUpdatedSubscription, Types.ChannelsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ChannelsUpdatedSubscription, Types.ChannelsUpdatedSubscriptionVariables>(ChannelsUpdatedDocument, options);
      }
export type ChannelsUpdatedSubscriptionHookResult = ReturnType<typeof useChannelsUpdatedSubscription>;
export type ChannelsUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.ChannelsUpdatedSubscription>;
export const MilestonesUpdatedDocument = gql`
    subscription MilestonesUpdated($launchId: String!) {
  milestonesUpdated(launchId: $launchId) {
    event
    milestone {
      ...Milestone
    }
  }
}
    ${MilestoneFragmentDoc}`;

/**
 * __useMilestonesUpdatedSubscription__
 *
 * To run a query within a React component, call `useMilestonesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMilestonesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestonesUpdatedSubscription({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useMilestonesUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.MilestonesUpdatedSubscription, Types.MilestonesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.MilestonesUpdatedSubscription, Types.MilestonesUpdatedSubscriptionVariables>(MilestonesUpdatedDocument, options);
      }
export type MilestonesUpdatedSubscriptionHookResult = ReturnType<typeof useMilestonesUpdatedSubscription>;
export type MilestonesUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.MilestonesUpdatedSubscription>;
export const AttachTagsToInsightsDocument = gql`
    mutation AttachTagsToInsights($input: UpdateInsightsTagsInput!) {
  attachTagsToInsights(input: $input) {
    id
    tags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type AttachTagsToInsightsMutationFn = Apollo.MutationFunction<Types.AttachTagsToInsightsMutation, Types.AttachTagsToInsightsMutationVariables>;

/**
 * __useAttachTagsToInsightsMutation__
 *
 * To run a mutation, you first call `useAttachTagsToInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachTagsToInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachTagsToInsightsMutation, { data, loading, error }] = useAttachTagsToInsightsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachTagsToInsightsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttachTagsToInsightsMutation, Types.AttachTagsToInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttachTagsToInsightsMutation, Types.AttachTagsToInsightsMutationVariables>(AttachTagsToInsightsDocument, options);
      }
export type AttachTagsToInsightsMutationHookResult = ReturnType<typeof useAttachTagsToInsightsMutation>;
export type AttachTagsToInsightsMutationResult = Apollo.MutationResult<Types.AttachTagsToInsightsMutation>;
export type AttachTagsToInsightsMutationOptions = Apollo.BaseMutationOptions<Types.AttachTagsToInsightsMutation, Types.AttachTagsToInsightsMutationVariables>;
export const CreateInsightDocument = gql`
    mutation CreateInsight($input: CreateInsightInput) {
  createInsight(input: $input) {
    ...Insight
  }
}
    ${InsightFragmentDoc}`;
export type CreateInsightMutationFn = Apollo.MutationFunction<Types.CreateInsightMutation, Types.CreateInsightMutationVariables>;

/**
 * __useCreateInsightMutation__
 *
 * To run a mutation, you first call `useCreateInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightMutation, { data, loading, error }] = useCreateInsightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInsightMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInsightMutation, Types.CreateInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInsightMutation, Types.CreateInsightMutationVariables>(CreateInsightDocument, options);
      }
export type CreateInsightMutationHookResult = ReturnType<typeof useCreateInsightMutation>;
export type CreateInsightMutationResult = Apollo.MutationResult<Types.CreateInsightMutation>;
export type CreateInsightMutationOptions = Apollo.BaseMutationOptions<Types.CreateInsightMutation, Types.CreateInsightMutationVariables>;
export const DeleteInsightsDocument = gql`
    mutation DeleteInsights($ids: [String!]!) {
  deleteInsights(ids: $ids) {
    id
  }
}
    `;
export type DeleteInsightsMutationFn = Apollo.MutationFunction<Types.DeleteInsightsMutation, Types.DeleteInsightsMutationVariables>;

/**
 * __useDeleteInsightsMutation__
 *
 * To run a mutation, you first call `useDeleteInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightsMutation, { data, loading, error }] = useDeleteInsightsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteInsightsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInsightsMutation, Types.DeleteInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInsightsMutation, Types.DeleteInsightsMutationVariables>(DeleteInsightsDocument, options);
      }
export type DeleteInsightsMutationHookResult = ReturnType<typeof useDeleteInsightsMutation>;
export type DeleteInsightsMutationResult = Apollo.MutationResult<Types.DeleteInsightsMutation>;
export type DeleteInsightsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInsightsMutation, Types.DeleteInsightsMutationVariables>;
export const DeleteSavedInsightsSummaryDocument = gql`
    mutation DeleteSavedInsightsSummary($id: String!) {
  deleteSavedInsightsSummary(id: $id) {
    id
  }
}
    `;
export type DeleteSavedInsightsSummaryMutationFn = Apollo.MutationFunction<Types.DeleteSavedInsightsSummaryMutation, Types.DeleteSavedInsightsSummaryMutationVariables>;

/**
 * __useDeleteSavedInsightsSummaryMutation__
 *
 * To run a mutation, you first call `useDeleteSavedInsightsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedInsightsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedInsightsSummaryMutation, { data, loading, error }] = useDeleteSavedInsightsSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavedInsightsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSavedInsightsSummaryMutation, Types.DeleteSavedInsightsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSavedInsightsSummaryMutation, Types.DeleteSavedInsightsSummaryMutationVariables>(DeleteSavedInsightsSummaryDocument, options);
      }
export type DeleteSavedInsightsSummaryMutationHookResult = ReturnType<typeof useDeleteSavedInsightsSummaryMutation>;
export type DeleteSavedInsightsSummaryMutationResult = Apollo.MutationResult<Types.DeleteSavedInsightsSummaryMutation>;
export type DeleteSavedInsightsSummaryMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSavedInsightsSummaryMutation, Types.DeleteSavedInsightsSummaryMutationVariables>;
export const ExportInsightsToCsvDocument = gql`
    mutation ExportInsightsToCsv($filter: FilterInsightsInput) {
  exportInsightsToCsv(filter: $filter)
}
    `;
export type ExportInsightsToCsvMutationFn = Apollo.MutationFunction<Types.ExportInsightsToCsvMutation, Types.ExportInsightsToCsvMutationVariables>;

/**
 * __useExportInsightsToCsvMutation__
 *
 * To run a mutation, you first call `useExportInsightsToCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportInsightsToCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportInsightsToCsvMutation, { data, loading, error }] = useExportInsightsToCsvMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportInsightsToCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportInsightsToCsvMutation, Types.ExportInsightsToCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportInsightsToCsvMutation, Types.ExportInsightsToCsvMutationVariables>(ExportInsightsToCsvDocument, options);
      }
export type ExportInsightsToCsvMutationHookResult = ReturnType<typeof useExportInsightsToCsvMutation>;
export type ExportInsightsToCsvMutationResult = Apollo.MutationResult<Types.ExportInsightsToCsvMutation>;
export type ExportInsightsToCsvMutationOptions = Apollo.BaseMutationOptions<Types.ExportInsightsToCsvMutation, Types.ExportInsightsToCsvMutationVariables>;
export const GenerateMarketingInsightsSummaryDocument = gql`
    mutation GenerateMarketingInsightsSummary($insightsFilter: FilterInsightsInput, $additionalContext: String) {
  generateMarketingInsightsSummary(
    insightsFilter: $insightsFilter
    additionalContext: $additionalContext
  ) {
    ...InsightsMarketingSummary
  }
}
    ${InsightsMarketingSummaryFragmentDoc}`;
export type GenerateMarketingInsightsSummaryMutationFn = Apollo.MutationFunction<Types.GenerateMarketingInsightsSummaryMutation, Types.GenerateMarketingInsightsSummaryMutationVariables>;

/**
 * __useGenerateMarketingInsightsSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateMarketingInsightsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMarketingInsightsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMarketingInsightsSummaryMutation, { data, loading, error }] = useGenerateMarketingInsightsSummaryMutation({
 *   variables: {
 *      insightsFilter: // value for 'insightsFilter'
 *      additionalContext: // value for 'additionalContext'
 *   },
 * });
 */
export function useGenerateMarketingInsightsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateMarketingInsightsSummaryMutation, Types.GenerateMarketingInsightsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateMarketingInsightsSummaryMutation, Types.GenerateMarketingInsightsSummaryMutationVariables>(GenerateMarketingInsightsSummaryDocument, options);
      }
export type GenerateMarketingInsightsSummaryMutationHookResult = ReturnType<typeof useGenerateMarketingInsightsSummaryMutation>;
export type GenerateMarketingInsightsSummaryMutationResult = Apollo.MutationResult<Types.GenerateMarketingInsightsSummaryMutation>;
export type GenerateMarketingInsightsSummaryMutationOptions = Apollo.BaseMutationOptions<Types.GenerateMarketingInsightsSummaryMutation, Types.GenerateMarketingInsightsSummaryMutationVariables>;
export const GenerateProductInsightsSummaryDocument = gql`
    mutation GenerateProductInsightsSummary($insightsFilter: FilterInsightsInput, $additionalContext: String) {
  generateProductInsightsSummary(
    insightsFilter: $insightsFilter
    additionalContext: $additionalContext
  ) {
    ...InsightsProductSummary
  }
}
    ${InsightsProductSummaryFragmentDoc}`;
export type GenerateProductInsightsSummaryMutationFn = Apollo.MutationFunction<Types.GenerateProductInsightsSummaryMutation, Types.GenerateProductInsightsSummaryMutationVariables>;

/**
 * __useGenerateProductInsightsSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateProductInsightsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProductInsightsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProductInsightsSummaryMutation, { data, loading, error }] = useGenerateProductInsightsSummaryMutation({
 *   variables: {
 *      insightsFilter: // value for 'insightsFilter'
 *      additionalContext: // value for 'additionalContext'
 *   },
 * });
 */
export function useGenerateProductInsightsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateProductInsightsSummaryMutation, Types.GenerateProductInsightsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateProductInsightsSummaryMutation, Types.GenerateProductInsightsSummaryMutationVariables>(GenerateProductInsightsSummaryDocument, options);
      }
export type GenerateProductInsightsSummaryMutationHookResult = ReturnType<typeof useGenerateProductInsightsSummaryMutation>;
export type GenerateProductInsightsSummaryMutationResult = Apollo.MutationResult<Types.GenerateProductInsightsSummaryMutation>;
export type GenerateProductInsightsSummaryMutationOptions = Apollo.BaseMutationOptions<Types.GenerateProductInsightsSummaryMutation, Types.GenerateProductInsightsSummaryMutationVariables>;
export const SaveInsightsSummaryDocument = gql`
    mutation SaveInsightsSummary($input: SaveInsightsSummaryInput!) {
  saveInsightsSummary(input: $input) {
    ...InsightSavedSummary
  }
}
    ${InsightSavedSummaryFragmentDoc}`;
export type SaveInsightsSummaryMutationFn = Apollo.MutationFunction<Types.SaveInsightsSummaryMutation, Types.SaveInsightsSummaryMutationVariables>;

/**
 * __useSaveInsightsSummaryMutation__
 *
 * To run a mutation, you first call `useSaveInsightsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInsightsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInsightsSummaryMutation, { data, loading, error }] = useSaveInsightsSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInsightsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveInsightsSummaryMutation, Types.SaveInsightsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveInsightsSummaryMutation, Types.SaveInsightsSummaryMutationVariables>(SaveInsightsSummaryDocument, options);
      }
export type SaveInsightsSummaryMutationHookResult = ReturnType<typeof useSaveInsightsSummaryMutation>;
export type SaveInsightsSummaryMutationResult = Apollo.MutationResult<Types.SaveInsightsSummaryMutation>;
export type SaveInsightsSummaryMutationOptions = Apollo.BaseMutationOptions<Types.SaveInsightsSummaryMutation, Types.SaveInsightsSummaryMutationVariables>;
export const SummarizeInsightDocument = gql`
    mutation SummarizeInsight($id: String!) {
  summarizeInsight(id: $id) {
    id
    summary
    updatedAt
  }
}
    `;
export type SummarizeInsightMutationFn = Apollo.MutationFunction<Types.SummarizeInsightMutation, Types.SummarizeInsightMutationVariables>;

/**
 * __useSummarizeInsightMutation__
 *
 * To run a mutation, you first call `useSummarizeInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSummarizeInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [summarizeInsightMutation, { data, loading, error }] = useSummarizeInsightMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSummarizeInsightMutation(baseOptions?: Apollo.MutationHookOptions<Types.SummarizeInsightMutation, Types.SummarizeInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SummarizeInsightMutation, Types.SummarizeInsightMutationVariables>(SummarizeInsightDocument, options);
      }
export type SummarizeInsightMutationHookResult = ReturnType<typeof useSummarizeInsightMutation>;
export type SummarizeInsightMutationResult = Apollo.MutationResult<Types.SummarizeInsightMutation>;
export type SummarizeInsightMutationOptions = Apollo.BaseMutationOptions<Types.SummarizeInsightMutation, Types.SummarizeInsightMutationVariables>;
export const UpdateInsightUserDocument = gql`
    mutation UpdateInsightUser($id: String!, $user: String!) {
  updateInsight(input: {id: $id, user: $user}) {
    id
    user
    updatedAt
  }
}
    `;
export type UpdateInsightUserMutationFn = Apollo.MutationFunction<Types.UpdateInsightUserMutation, Types.UpdateInsightUserMutationVariables>;

/**
 * __useUpdateInsightUserMutation__
 *
 * To run a mutation, you first call `useUpdateInsightUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightUserMutation, { data, loading, error }] = useUpdateInsightUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateInsightUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightUserMutation, Types.UpdateInsightUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightUserMutation, Types.UpdateInsightUserMutationVariables>(UpdateInsightUserDocument, options);
      }
export type UpdateInsightUserMutationHookResult = ReturnType<typeof useUpdateInsightUserMutation>;
export type UpdateInsightUserMutationResult = Apollo.MutationResult<Types.UpdateInsightUserMutation>;
export type UpdateInsightUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightUserMutation, Types.UpdateInsightUserMutationVariables>;
export const UpdateInsightTagsDocument = gql`
    mutation UpdateInsightTags($id: String!, $tagIds: [String!]!) {
  updateInsight(input: {id: $id, tags: $tagIds}) {
    id
    updatedAt
    tags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type UpdateInsightTagsMutationFn = Apollo.MutationFunction<Types.UpdateInsightTagsMutation, Types.UpdateInsightTagsMutationVariables>;

/**
 * __useUpdateInsightTagsMutation__
 *
 * To run a mutation, you first call `useUpdateInsightTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightTagsMutation, { data, loading, error }] = useUpdateInsightTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useUpdateInsightTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightTagsMutation, Types.UpdateInsightTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightTagsMutation, Types.UpdateInsightTagsMutationVariables>(UpdateInsightTagsDocument, options);
      }
export type UpdateInsightTagsMutationHookResult = ReturnType<typeof useUpdateInsightTagsMutation>;
export type UpdateInsightTagsMutationResult = Apollo.MutationResult<Types.UpdateInsightTagsMutation>;
export type UpdateInsightTagsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightTagsMutation, Types.UpdateInsightTagsMutationVariables>;
export const UpdateInsightProductLineTagsDocument = gql`
    mutation UpdateInsightProductLineTags($id: String!, $productLineTagIds: [String!]!) {
  updateInsight(input: {id: $id, productLineTagIds: $productLineTagIds}) {
    id
    updatedAt
    productLineTags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type UpdateInsightProductLineTagsMutationFn = Apollo.MutationFunction<Types.UpdateInsightProductLineTagsMutation, Types.UpdateInsightProductLineTagsMutationVariables>;

/**
 * __useUpdateInsightProductLineTagsMutation__
 *
 * To run a mutation, you first call `useUpdateInsightProductLineTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightProductLineTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightProductLineTagsMutation, { data, loading, error }] = useUpdateInsightProductLineTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productLineTagIds: // value for 'productLineTagIds'
 *   },
 * });
 */
export function useUpdateInsightProductLineTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightProductLineTagsMutation, Types.UpdateInsightProductLineTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightProductLineTagsMutation, Types.UpdateInsightProductLineTagsMutationVariables>(UpdateInsightProductLineTagsDocument, options);
      }
export type UpdateInsightProductLineTagsMutationHookResult = ReturnType<typeof useUpdateInsightProductLineTagsMutation>;
export type UpdateInsightProductLineTagsMutationResult = Apollo.MutationResult<Types.UpdateInsightProductLineTagsMutation>;
export type UpdateInsightProductLineTagsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightProductLineTagsMutation, Types.UpdateInsightProductLineTagsMutationVariables>;
export const UpdateInsightRegisteredOnDocument = gql`
    mutation UpdateInsightRegisteredOn($id: String!, $registeredOn: DateTime!) {
  updateInsight(input: {id: $id, registeredOn: $registeredOn}) {
    id
    registeredOn
    updatedAt
  }
}
    `;
export type UpdateInsightRegisteredOnMutationFn = Apollo.MutationFunction<Types.UpdateInsightRegisteredOnMutation, Types.UpdateInsightRegisteredOnMutationVariables>;

/**
 * __useUpdateInsightRegisteredOnMutation__
 *
 * To run a mutation, you first call `useUpdateInsightRegisteredOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightRegisteredOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightRegisteredOnMutation, { data, loading, error }] = useUpdateInsightRegisteredOnMutation({
 *   variables: {
 *      id: // value for 'id'
 *      registeredOn: // value for 'registeredOn'
 *   },
 * });
 */
export function useUpdateInsightRegisteredOnMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightRegisteredOnMutation, Types.UpdateInsightRegisteredOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightRegisteredOnMutation, Types.UpdateInsightRegisteredOnMutationVariables>(UpdateInsightRegisteredOnDocument, options);
      }
export type UpdateInsightRegisteredOnMutationHookResult = ReturnType<typeof useUpdateInsightRegisteredOnMutation>;
export type UpdateInsightRegisteredOnMutationResult = Apollo.MutationResult<Types.UpdateInsightRegisteredOnMutation>;
export type UpdateInsightRegisteredOnMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightRegisteredOnMutation, Types.UpdateInsightRegisteredOnMutationVariables>;
export const UpdateInsightContentDocument = gql`
    mutation UpdateInsightContent($id: String!, $content: String!) {
  updateInsight(input: {id: $id, content: $content}) {
    id
    content
    updatedAt
  }
}
    `;
export type UpdateInsightContentMutationFn = Apollo.MutationFunction<Types.UpdateInsightContentMutation, Types.UpdateInsightContentMutationVariables>;

/**
 * __useUpdateInsightContentMutation__
 *
 * To run a mutation, you first call `useUpdateInsightContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightContentMutation, { data, loading, error }] = useUpdateInsightContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateInsightContentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightContentMutation, Types.UpdateInsightContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightContentMutation, Types.UpdateInsightContentMutationVariables>(UpdateInsightContentDocument, options);
      }
export type UpdateInsightContentMutationHookResult = ReturnType<typeof useUpdateInsightContentMutation>;
export type UpdateInsightContentMutationResult = Apollo.MutationResult<Types.UpdateInsightContentMutation>;
export type UpdateInsightContentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightContentMutation, Types.UpdateInsightContentMutationVariables>;
export const UpdateInsightCompanyDocument = gql`
    mutation UpdateInsightCompany($id: String!, $company: String!) {
  updateInsight(input: {id: $id, company: $company}) {
    id
    company
    updatedAt
  }
}
    `;
export type UpdateInsightCompanyMutationFn = Apollo.MutationFunction<Types.UpdateInsightCompanyMutation, Types.UpdateInsightCompanyMutationVariables>;

/**
 * __useUpdateInsightCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateInsightCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightCompanyMutation, { data, loading, error }] = useUpdateInsightCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useUpdateInsightCompanyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightCompanyMutation, Types.UpdateInsightCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightCompanyMutation, Types.UpdateInsightCompanyMutationVariables>(UpdateInsightCompanyDocument, options);
      }
export type UpdateInsightCompanyMutationHookResult = ReturnType<typeof useUpdateInsightCompanyMutation>;
export type UpdateInsightCompanyMutationResult = Apollo.MutationResult<Types.UpdateInsightCompanyMutation>;
export type UpdateInsightCompanyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightCompanyMutation, Types.UpdateInsightCompanyMutationVariables>;
export const UpdateInsightDocument = gql`
    mutation UpdateInsight($input: UpdateInsightInput!) {
  updateInsight(input: $input) {
    ...Insight
  }
}
    ${InsightFragmentDoc}`;
export type UpdateInsightMutationFn = Apollo.MutationFunction<Types.UpdateInsightMutation, Types.UpdateInsightMutationVariables>;

/**
 * __useUpdateInsightMutation__
 *
 * To run a mutation, you first call `useUpdateInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightMutation, { data, loading, error }] = useUpdateInsightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInsightMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightMutation, Types.UpdateInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightMutation, Types.UpdateInsightMutationVariables>(UpdateInsightDocument, options);
      }
export type UpdateInsightMutationHookResult = ReturnType<typeof useUpdateInsightMutation>;
export type UpdateInsightMutationResult = Apollo.MutationResult<Types.UpdateInsightMutation>;
export type UpdateInsightMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightMutation, Types.UpdateInsightMutationVariables>;
export const UpdateInsightConnectionsDocument = gql`
    mutation UpdateInsightConnections($id: String!, $competitorIds: [String!], $feedbackPostIds: [String!], $launchIds: [String!], $personasIds: [String!], $productBoardItemsIds: [String!], $taskIds: [String!]) {
  updateInsight(
    input: {id: $id, competitorIds: $competitorIds, feedbackPostIds: $feedbackPostIds, launchIds: $launchIds, personasIds: $personasIds, productBoardItemsIds: $productBoardItemsIds, taskIds: $taskIds}
  ) {
    id
    updatedAt
    ...InsightConnectionsMenu
  }
}
    ${InsightConnectionsMenuFragmentDoc}`;
export type UpdateInsightConnectionsMutationFn = Apollo.MutationFunction<Types.UpdateInsightConnectionsMutation, Types.UpdateInsightConnectionsMutationVariables>;

/**
 * __useUpdateInsightConnectionsMutation__
 *
 * To run a mutation, you first call `useUpdateInsightConnectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightConnectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightConnectionsMutation, { data, loading, error }] = useUpdateInsightConnectionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      competitorIds: // value for 'competitorIds'
 *      feedbackPostIds: // value for 'feedbackPostIds'
 *      launchIds: // value for 'launchIds'
 *      personasIds: // value for 'personasIds'
 *      productBoardItemsIds: // value for 'productBoardItemsIds'
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function useUpdateInsightConnectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightConnectionsMutation, Types.UpdateInsightConnectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightConnectionsMutation, Types.UpdateInsightConnectionsMutationVariables>(UpdateInsightConnectionsDocument, options);
      }
export type UpdateInsightConnectionsMutationHookResult = ReturnType<typeof useUpdateInsightConnectionsMutation>;
export type UpdateInsightConnectionsMutationResult = Apollo.MutationResult<Types.UpdateInsightConnectionsMutation>;
export type UpdateInsightConnectionsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightConnectionsMutation, Types.UpdateInsightConnectionsMutationVariables>;
export const UpdateMarketingInsightsSummaryDocument = gql`
    mutation UpdateMarketingInsightsSummary($input: UpdateInsightsMarketingSummaryInput!) {
  updateMarketingInsightsSummary(input: $input) {
    ...InsightsMarketingSummary
  }
}
    ${InsightsMarketingSummaryFragmentDoc}`;
export type UpdateMarketingInsightsSummaryMutationFn = Apollo.MutationFunction<Types.UpdateMarketingInsightsSummaryMutation, Types.UpdateMarketingInsightsSummaryMutationVariables>;

/**
 * __useUpdateMarketingInsightsSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingInsightsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingInsightsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketingInsightsSummaryMutation, { data, loading, error }] = useUpdateMarketingInsightsSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketingInsightsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMarketingInsightsSummaryMutation, Types.UpdateMarketingInsightsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMarketingInsightsSummaryMutation, Types.UpdateMarketingInsightsSummaryMutationVariables>(UpdateMarketingInsightsSummaryDocument, options);
      }
export type UpdateMarketingInsightsSummaryMutationHookResult = ReturnType<typeof useUpdateMarketingInsightsSummaryMutation>;
export type UpdateMarketingInsightsSummaryMutationResult = Apollo.MutationResult<Types.UpdateMarketingInsightsSummaryMutation>;
export type UpdateMarketingInsightsSummaryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMarketingInsightsSummaryMutation, Types.UpdateMarketingInsightsSummaryMutationVariables>;
export const UpdateProductInsightsSummaryDocument = gql`
    mutation UpdateProductInsightsSummary($input: UpdateInsightsProductSummaryInput!) {
  updateProductInsightsSummary(input: $input) {
    ...InsightsProductSummary
  }
}
    ${InsightsProductSummaryFragmentDoc}`;
export type UpdateProductInsightsSummaryMutationFn = Apollo.MutationFunction<Types.UpdateProductInsightsSummaryMutation, Types.UpdateProductInsightsSummaryMutationVariables>;

/**
 * __useUpdateProductInsightsSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateProductInsightsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductInsightsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductInsightsSummaryMutation, { data, loading, error }] = useUpdateProductInsightsSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductInsightsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductInsightsSummaryMutation, Types.UpdateProductInsightsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductInsightsSummaryMutation, Types.UpdateProductInsightsSummaryMutationVariables>(UpdateProductInsightsSummaryDocument, options);
      }
export type UpdateProductInsightsSummaryMutationHookResult = ReturnType<typeof useUpdateProductInsightsSummaryMutation>;
export type UpdateProductInsightsSummaryMutationResult = Apollo.MutationResult<Types.UpdateProductInsightsSummaryMutation>;
export type UpdateProductInsightsSummaryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductInsightsSummaryMutation, Types.UpdateProductInsightsSummaryMutationVariables>;
export const UpdateSavedInsightsSummaryDocument = gql`
    mutation UpdateSavedInsightsSummary($input: UpdateSavedInsightsSummaryInput!) {
  updateSavedInsightsSummary(input: $input) {
    ...InsightSavedSummary
  }
}
    ${InsightSavedSummaryFragmentDoc}`;
export type UpdateSavedInsightsSummaryMutationFn = Apollo.MutationFunction<Types.UpdateSavedInsightsSummaryMutation, Types.UpdateSavedInsightsSummaryMutationVariables>;

/**
 * __useUpdateSavedInsightsSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateSavedInsightsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedInsightsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedInsightsSummaryMutation, { data, loading, error }] = useUpdateSavedInsightsSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSavedInsightsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSavedInsightsSummaryMutation, Types.UpdateSavedInsightsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSavedInsightsSummaryMutation, Types.UpdateSavedInsightsSummaryMutationVariables>(UpdateSavedInsightsSummaryDocument, options);
      }
export type UpdateSavedInsightsSummaryMutationHookResult = ReturnType<typeof useUpdateSavedInsightsSummaryMutation>;
export type UpdateSavedInsightsSummaryMutationResult = Apollo.MutationResult<Types.UpdateSavedInsightsSummaryMutation>;
export type UpdateSavedInsightsSummaryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSavedInsightsSummaryMutation, Types.UpdateSavedInsightsSummaryMutationVariables>;
export const InsightDocument = gql`
    query Insight($id: String!) {
  insight(id: $id) {
    ...Insight
  }
}
    ${InsightFragmentDoc}`;

/**
 * __useInsightQuery__
 *
 * To run a query within a React component, call `useInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightQuery(baseOptions: Apollo.QueryHookOptions<Types.InsightQuery, Types.InsightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightQuery, Types.InsightQueryVariables>(InsightDocument, options);
      }
export function useInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightQuery, Types.InsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightQuery, Types.InsightQueryVariables>(InsightDocument, options);
        }
export type InsightQueryHookResult = ReturnType<typeof useInsightQuery>;
export type InsightLazyQueryHookResult = ReturnType<typeof useInsightLazyQuery>;
export type InsightQueryResult = Apollo.QueryResult<Types.InsightQuery, Types.InsightQueryVariables>;
export const InsightsDocument = gql`
    query Insights($filter: FilterInsightsInput) {
  insights(filter: $filter) {
    ...Insight
  }
}
    ${InsightFragmentDoc}`;

/**
 * __useInsightsQuery__
 *
 * To run a query within a React component, call `useInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInsightsQuery(baseOptions?: Apollo.QueryHookOptions<Types.InsightsQuery, Types.InsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightsQuery, Types.InsightsQueryVariables>(InsightsDocument, options);
      }
export function useInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightsQuery, Types.InsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightsQuery, Types.InsightsQueryVariables>(InsightsDocument, options);
        }
export type InsightsQueryHookResult = ReturnType<typeof useInsightsQuery>;
export type InsightsLazyQueryHookResult = ReturnType<typeof useInsightsLazyQuery>;
export type InsightsQueryResult = Apollo.QueryResult<Types.InsightsQuery, Types.InsightsQueryVariables>;
export const InsightsNumberDocument = gql`
    query InsightsNumber($filter: FilterInsightsInput) {
  insightsNumber: paginatedInsights(
    filter: $filter
    pagination: {page: 1, limit: 1}
  ) {
    number: totalDocs
  }
}
    `;

/**
 * __useInsightsNumberQuery__
 *
 * To run a query within a React component, call `useInsightsNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsNumberQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInsightsNumberQuery(baseOptions?: Apollo.QueryHookOptions<Types.InsightsNumberQuery, Types.InsightsNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightsNumberQuery, Types.InsightsNumberQueryVariables>(InsightsNumberDocument, options);
      }
export function useInsightsNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightsNumberQuery, Types.InsightsNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightsNumberQuery, Types.InsightsNumberQueryVariables>(InsightsNumberDocument, options);
        }
export type InsightsNumberQueryHookResult = ReturnType<typeof useInsightsNumberQuery>;
export type InsightsNumberLazyQueryHookResult = ReturnType<typeof useInsightsNumberLazyQuery>;
export type InsightsNumberQueryResult = Apollo.QueryResult<Types.InsightsNumberQuery, Types.InsightsNumberQueryVariables>;
export const PaginatedInsightsDocument = gql`
    query PaginatedInsights($pagination: PaginationInput, $filter: FilterInsightsInput, $sort: SortInsightsInput) {
  paginatedInsights(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    docs {
      ...Insight
    }
  }
}
    ${InsightFragmentDoc}`;

/**
 * __usePaginatedInsightsQuery__
 *
 * To run a query within a React component, call `usePaginatedInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInsightsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedInsightsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedInsightsQuery, Types.PaginatedInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedInsightsQuery, Types.PaginatedInsightsQueryVariables>(PaginatedInsightsDocument, options);
      }
export function usePaginatedInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedInsightsQuery, Types.PaginatedInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedInsightsQuery, Types.PaginatedInsightsQueryVariables>(PaginatedInsightsDocument, options);
        }
export type PaginatedInsightsQueryHookResult = ReturnType<typeof usePaginatedInsightsQuery>;
export type PaginatedInsightsLazyQueryHookResult = ReturnType<typeof usePaginatedInsightsLazyQuery>;
export type PaginatedInsightsQueryResult = Apollo.QueryResult<Types.PaginatedInsightsQuery, Types.PaginatedInsightsQueryVariables>;
export const SavedInsightsSummariesDocument = gql`
    query SavedInsightsSummaries($input: SavedInsightsSummariesInput) {
  savedInsightsSummaries(input: $input) {
    ...InsightSavedSummary
  }
}
    ${InsightSavedSummaryFragmentDoc}`;

/**
 * __useSavedInsightsSummariesQuery__
 *
 * To run a query within a React component, call `useSavedInsightsSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedInsightsSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedInsightsSummariesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavedInsightsSummariesQuery(baseOptions?: Apollo.QueryHookOptions<Types.SavedInsightsSummariesQuery, Types.SavedInsightsSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SavedInsightsSummariesQuery, Types.SavedInsightsSummariesQueryVariables>(SavedInsightsSummariesDocument, options);
      }
export function useSavedInsightsSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SavedInsightsSummariesQuery, Types.SavedInsightsSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SavedInsightsSummariesQuery, Types.SavedInsightsSummariesQueryVariables>(SavedInsightsSummariesDocument, options);
        }
export type SavedInsightsSummariesQueryHookResult = ReturnType<typeof useSavedInsightsSummariesQuery>;
export type SavedInsightsSummariesLazyQueryHookResult = ReturnType<typeof useSavedInsightsSummariesLazyQuery>;
export type SavedInsightsSummariesQueryResult = Apollo.QueryResult<Types.SavedInsightsSummariesQuery, Types.SavedInsightsSummariesQueryVariables>;
export const CreateIntegrationByApiKeyDocument = gql`
    mutation CreateIntegrationByApiKey($input: CreateIntegrationInput!) {
  createIntegration(input: $input) {
    id
    ...Integration
  }
}
    ${IntegrationFragmentDoc}`;
export type CreateIntegrationByApiKeyMutationFn = Apollo.MutationFunction<Types.CreateIntegrationByApiKeyMutation, Types.CreateIntegrationByApiKeyMutationVariables>;

/**
 * __useCreateIntegrationByApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationByApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationByApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationByApiKeyMutation, { data, loading, error }] = useCreateIntegrationByApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationByApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateIntegrationByApiKeyMutation, Types.CreateIntegrationByApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateIntegrationByApiKeyMutation, Types.CreateIntegrationByApiKeyMutationVariables>(CreateIntegrationByApiKeyDocument, options);
      }
export type CreateIntegrationByApiKeyMutationHookResult = ReturnType<typeof useCreateIntegrationByApiKeyMutation>;
export type CreateIntegrationByApiKeyMutationResult = Apollo.MutationResult<Types.CreateIntegrationByApiKeyMutation>;
export type CreateIntegrationByApiKeyMutationOptions = Apollo.BaseMutationOptions<Types.CreateIntegrationByApiKeyMutation, Types.CreateIntegrationByApiKeyMutationVariables>;
export const DeleteIntegrationDocument = gql`
    mutation DeleteIntegration($integrationId: String!) {
  deleteIntegration(integrationId: $integrationId) {
    id
  }
}
    `;
export type DeleteIntegrationMutationFn = Apollo.MutationFunction<Types.DeleteIntegrationMutation, Types.DeleteIntegrationMutationVariables>;

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteIntegrationMutation, Types.DeleteIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteIntegrationMutation, Types.DeleteIntegrationMutationVariables>(DeleteIntegrationDocument, options);
      }
export type DeleteIntegrationMutationHookResult = ReturnType<typeof useDeleteIntegrationMutation>;
export type DeleteIntegrationMutationResult = Apollo.MutationResult<Types.DeleteIntegrationMutation>;
export type DeleteIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteIntegrationMutation, Types.DeleteIntegrationMutationVariables>;
export const DisableIntegrationProjectDocument = gql`
    mutation DisableIntegrationProject($id: String!) {
  disableIntegrationProject(id: $id) {
    ...IntegrationProject
  }
}
    ${IntegrationProjectFragmentDoc}`;
export type DisableIntegrationProjectMutationFn = Apollo.MutationFunction<Types.DisableIntegrationProjectMutation, Types.DisableIntegrationProjectMutationVariables>;

/**
 * __useDisableIntegrationProjectMutation__
 *
 * To run a mutation, you first call `useDisableIntegrationProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableIntegrationProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableIntegrationProjectMutation, { data, loading, error }] = useDisableIntegrationProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableIntegrationProjectMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisableIntegrationProjectMutation, Types.DisableIntegrationProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisableIntegrationProjectMutation, Types.DisableIntegrationProjectMutationVariables>(DisableIntegrationProjectDocument, options);
      }
export type DisableIntegrationProjectMutationHookResult = ReturnType<typeof useDisableIntegrationProjectMutation>;
export type DisableIntegrationProjectMutationResult = Apollo.MutationResult<Types.DisableIntegrationProjectMutation>;
export type DisableIntegrationProjectMutationOptions = Apollo.BaseMutationOptions<Types.DisableIntegrationProjectMutation, Types.DisableIntegrationProjectMutationVariables>;
export const EnableIntegrationProjectDocument = gql`
    mutation EnableIntegrationProject($id: String!) {
  enableIntegrationProject(id: $id) {
    ...IntegrationProject
  }
}
    ${IntegrationProjectFragmentDoc}`;
export type EnableIntegrationProjectMutationFn = Apollo.MutationFunction<Types.EnableIntegrationProjectMutation, Types.EnableIntegrationProjectMutationVariables>;

/**
 * __useEnableIntegrationProjectMutation__
 *
 * To run a mutation, you first call `useEnableIntegrationProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableIntegrationProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableIntegrationProjectMutation, { data, loading, error }] = useEnableIntegrationProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableIntegrationProjectMutation(baseOptions?: Apollo.MutationHookOptions<Types.EnableIntegrationProjectMutation, Types.EnableIntegrationProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EnableIntegrationProjectMutation, Types.EnableIntegrationProjectMutationVariables>(EnableIntegrationProjectDocument, options);
      }
export type EnableIntegrationProjectMutationHookResult = ReturnType<typeof useEnableIntegrationProjectMutation>;
export type EnableIntegrationProjectMutationResult = Apollo.MutationResult<Types.EnableIntegrationProjectMutation>;
export type EnableIntegrationProjectMutationOptions = Apollo.BaseMutationOptions<Types.EnableIntegrationProjectMutation, Types.EnableIntegrationProjectMutationVariables>;
export const ExportTasksToIntegrationDocument = gql`
    mutation ExportTasksToIntegration($input: ExportTasksToIntegrationInput!) {
  exportTasksToIntegration(input: $input)
}
    `;
export type ExportTasksToIntegrationMutationFn = Apollo.MutationFunction<Types.ExportTasksToIntegrationMutation, Types.ExportTasksToIntegrationMutationVariables>;

/**
 * __useExportTasksToIntegrationMutation__
 *
 * To run a mutation, you first call `useExportTasksToIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTasksToIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTasksToIntegrationMutation, { data, loading, error }] = useExportTasksToIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportTasksToIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportTasksToIntegrationMutation, Types.ExportTasksToIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportTasksToIntegrationMutation, Types.ExportTasksToIntegrationMutationVariables>(ExportTasksToIntegrationDocument, options);
      }
export type ExportTasksToIntegrationMutationHookResult = ReturnType<typeof useExportTasksToIntegrationMutation>;
export type ExportTasksToIntegrationMutationResult = Apollo.MutationResult<Types.ExportTasksToIntegrationMutation>;
export type ExportTasksToIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ExportTasksToIntegrationMutation, Types.ExportTasksToIntegrationMutationVariables>;
export const FetchIntegrationProjectsDocument = gql`
    mutation FetchIntegrationProjects($input: FetchIntegrationProjectsInput!) {
  fetchIntegrationProjects(input: $input) {
    ...IntegrationProject
  }
}
    ${IntegrationProjectFragmentDoc}`;
export type FetchIntegrationProjectsMutationFn = Apollo.MutationFunction<Types.FetchIntegrationProjectsMutation, Types.FetchIntegrationProjectsMutationVariables>;

/**
 * __useFetchIntegrationProjectsMutation__
 *
 * To run a mutation, you first call `useFetchIntegrationProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchIntegrationProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchIntegrationProjectsMutation, { data, loading, error }] = useFetchIntegrationProjectsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchIntegrationProjectsMutation(baseOptions?: Apollo.MutationHookOptions<Types.FetchIntegrationProjectsMutation, Types.FetchIntegrationProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.FetchIntegrationProjectsMutation, Types.FetchIntegrationProjectsMutationVariables>(FetchIntegrationProjectsDocument, options);
      }
export type FetchIntegrationProjectsMutationHookResult = ReturnType<typeof useFetchIntegrationProjectsMutation>;
export type FetchIntegrationProjectsMutationResult = Apollo.MutationResult<Types.FetchIntegrationProjectsMutation>;
export type FetchIntegrationProjectsMutationOptions = Apollo.BaseMutationOptions<Types.FetchIntegrationProjectsMutation, Types.FetchIntegrationProjectsMutationVariables>;
export const ImportTasksFromIntegrationDocument = gql`
    mutation ImportTasksFromIntegration($input: ImportTasksFromIntegrationInput!) {
  importTasksFromIntegration(input: $input) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;
export type ImportTasksFromIntegrationMutationFn = Apollo.MutationFunction<Types.ImportTasksFromIntegrationMutation, Types.ImportTasksFromIntegrationMutationVariables>;

/**
 * __useImportTasksFromIntegrationMutation__
 *
 * To run a mutation, you first call `useImportTasksFromIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTasksFromIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTasksFromIntegrationMutation, { data, loading, error }] = useImportTasksFromIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportTasksFromIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportTasksFromIntegrationMutation, Types.ImportTasksFromIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportTasksFromIntegrationMutation, Types.ImportTasksFromIntegrationMutationVariables>(ImportTasksFromIntegrationDocument, options);
      }
export type ImportTasksFromIntegrationMutationHookResult = ReturnType<typeof useImportTasksFromIntegrationMutation>;
export type ImportTasksFromIntegrationMutationResult = Apollo.MutationResult<Types.ImportTasksFromIntegrationMutation>;
export type ImportTasksFromIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ImportTasksFromIntegrationMutation, Types.ImportTasksFromIntegrationMutationVariables>;
export const MapIntegrationProjectColumnsDocument = gql`
    mutation MapIntegrationProjectColumns($input: MapIntegrationProjectColumnsInput!) {
  mapIntegrationProjectColumns(input: $input) {
    ...IntegrationProject
  }
}
    ${IntegrationProjectFragmentDoc}`;
export type MapIntegrationProjectColumnsMutationFn = Apollo.MutationFunction<Types.MapIntegrationProjectColumnsMutation, Types.MapIntegrationProjectColumnsMutationVariables>;

/**
 * __useMapIntegrationProjectColumnsMutation__
 *
 * To run a mutation, you first call `useMapIntegrationProjectColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMapIntegrationProjectColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mapIntegrationProjectColumnsMutation, { data, loading, error }] = useMapIntegrationProjectColumnsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMapIntegrationProjectColumnsMutation(baseOptions?: Apollo.MutationHookOptions<Types.MapIntegrationProjectColumnsMutation, Types.MapIntegrationProjectColumnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MapIntegrationProjectColumnsMutation, Types.MapIntegrationProjectColumnsMutationVariables>(MapIntegrationProjectColumnsDocument, options);
      }
export type MapIntegrationProjectColumnsMutationHookResult = ReturnType<typeof useMapIntegrationProjectColumnsMutation>;
export type MapIntegrationProjectColumnsMutationResult = Apollo.MutationResult<Types.MapIntegrationProjectColumnsMutation>;
export type MapIntegrationProjectColumnsMutationOptions = Apollo.BaseMutationOptions<Types.MapIntegrationProjectColumnsMutation, Types.MapIntegrationProjectColumnsMutationVariables>;
export const SelectIntegrationProjectDocument = gql`
    mutation SelectIntegrationProject($input: SelectIntegrationProjectInput!) {
  selectIntegrationProject(input: $input) {
    id
  }
}
    `;
export type SelectIntegrationProjectMutationFn = Apollo.MutationFunction<Types.SelectIntegrationProjectMutation, Types.SelectIntegrationProjectMutationVariables>;

/**
 * __useSelectIntegrationProjectMutation__
 *
 * To run a mutation, you first call `useSelectIntegrationProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectIntegrationProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectIntegrationProjectMutation, { data, loading, error }] = useSelectIntegrationProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectIntegrationProjectMutation(baseOptions?: Apollo.MutationHookOptions<Types.SelectIntegrationProjectMutation, Types.SelectIntegrationProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SelectIntegrationProjectMutation, Types.SelectIntegrationProjectMutationVariables>(SelectIntegrationProjectDocument, options);
      }
export type SelectIntegrationProjectMutationHookResult = ReturnType<typeof useSelectIntegrationProjectMutation>;
export type SelectIntegrationProjectMutationResult = Apollo.MutationResult<Types.SelectIntegrationProjectMutation>;
export type SelectIntegrationProjectMutationOptions = Apollo.BaseMutationOptions<Types.SelectIntegrationProjectMutation, Types.SelectIntegrationProjectMutationVariables>;
export const IntegrationDocument = gql`
    query Integration($id: String!) {
  integration(id: $id) {
    ...Integration
  }
}
    ${IntegrationFragmentDoc}`;

/**
 * __useIntegrationQuery__
 *
 * To run a query within a React component, call `useIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationQuery, Types.IntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationQuery, Types.IntegrationQueryVariables>(IntegrationDocument, options);
      }
export function useIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationQuery, Types.IntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationQuery, Types.IntegrationQueryVariables>(IntegrationDocument, options);
        }
export type IntegrationQueryHookResult = ReturnType<typeof useIntegrationQuery>;
export type IntegrationLazyQueryHookResult = ReturnType<typeof useIntegrationLazyQuery>;
export type IntegrationQueryResult = Apollo.QueryResult<Types.IntegrationQuery, Types.IntegrationQueryVariables>;
export const IntegrationIdsDocument = gql`
    query IntegrationIds {
  integrations {
    id
  }
}
    `;

/**
 * __useIntegrationIdsQuery__
 *
 * To run a query within a React component, call `useIntegrationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationIdsQuery(baseOptions?: Apollo.QueryHookOptions<Types.IntegrationIdsQuery, Types.IntegrationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationIdsQuery, Types.IntegrationIdsQueryVariables>(IntegrationIdsDocument, options);
      }
export function useIntegrationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationIdsQuery, Types.IntegrationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationIdsQuery, Types.IntegrationIdsQueryVariables>(IntegrationIdsDocument, options);
        }
export type IntegrationIdsQueryHookResult = ReturnType<typeof useIntegrationIdsQuery>;
export type IntegrationIdsLazyQueryHookResult = ReturnType<typeof useIntegrationIdsLazyQuery>;
export type IntegrationIdsQueryResult = Apollo.QueryResult<Types.IntegrationIdsQuery, Types.IntegrationIdsQueryVariables>;
export const IntegrationOAuthUrlDocument = gql`
    query IntegrationOAuthUrl($productName: String!) {
  integrationOAuthUrl(productName: $productName)
}
    `;

/**
 * __useIntegrationOAuthUrlQuery__
 *
 * To run a query within a React component, call `useIntegrationOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationOAuthUrlQuery({
 *   variables: {
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useIntegrationOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationOAuthUrlQuery, Types.IntegrationOAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationOAuthUrlQuery, Types.IntegrationOAuthUrlQueryVariables>(IntegrationOAuthUrlDocument, options);
      }
export function useIntegrationOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationOAuthUrlQuery, Types.IntegrationOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationOAuthUrlQuery, Types.IntegrationOAuthUrlQueryVariables>(IntegrationOAuthUrlDocument, options);
        }
export type IntegrationOAuthUrlQueryHookResult = ReturnType<typeof useIntegrationOAuthUrlQuery>;
export type IntegrationOAuthUrlLazyQueryHookResult = ReturnType<typeof useIntegrationOAuthUrlLazyQuery>;
export type IntegrationOAuthUrlQueryResult = Apollo.QueryResult<Types.IntegrationOAuthUrlQuery, Types.IntegrationOAuthUrlQueryVariables>;
export const IntegrationProjectsDocument = gql`
    query IntegrationProjects($filter: FilterIntegrationProjectsInput) {
  integrationProjects(filter: $filter) {
    id
    ...IntegrationProject
  }
}
    ${IntegrationProjectFragmentDoc}`;

/**
 * __useIntegrationProjectsQuery__
 *
 * To run a query within a React component, call `useIntegrationProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationProjectsQuery(baseOptions?: Apollo.QueryHookOptions<Types.IntegrationProjectsQuery, Types.IntegrationProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationProjectsQuery, Types.IntegrationProjectsQueryVariables>(IntegrationProjectsDocument, options);
      }
export function useIntegrationProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationProjectsQuery, Types.IntegrationProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationProjectsQuery, Types.IntegrationProjectsQueryVariables>(IntegrationProjectsDocument, options);
        }
export type IntegrationProjectsQueryHookResult = ReturnType<typeof useIntegrationProjectsQuery>;
export type IntegrationProjectsLazyQueryHookResult = ReturnType<typeof useIntegrationProjectsLazyQuery>;
export type IntegrationProjectsQueryResult = Apollo.QueryResult<Types.IntegrationProjectsQuery, Types.IntegrationProjectsQueryVariables>;
export const IntegrationProjectDocument = gql`
    query IntegrationProject($id: String!) {
  integrationProject(id: $id) {
    id
    ...IntegrationProject
  }
}
    ${IntegrationProjectFragmentDoc}`;

/**
 * __useIntegrationProjectQuery__
 *
 * To run a query within a React component, call `useIntegrationProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationProjectQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationProjectQuery, Types.IntegrationProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationProjectQuery, Types.IntegrationProjectQueryVariables>(IntegrationProjectDocument, options);
      }
export function useIntegrationProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationProjectQuery, Types.IntegrationProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationProjectQuery, Types.IntegrationProjectQueryVariables>(IntegrationProjectDocument, options);
        }
export type IntegrationProjectQueryHookResult = ReturnType<typeof useIntegrationProjectQuery>;
export type IntegrationProjectLazyQueryHookResult = ReturnType<typeof useIntegrationProjectLazyQuery>;
export type IntegrationProjectQueryResult = Apollo.QueryResult<Types.IntegrationProjectQuery, Types.IntegrationProjectQueryVariables>;
export const IntegrationProjectsFetchStatusDocument = gql`
    query IntegrationProjectsFetchStatus($id: String!) {
  integrationProjectsFetchStatus(id: $id)
}
    `;

/**
 * __useIntegrationProjectsFetchStatusQuery__
 *
 * To run a query within a React component, call `useIntegrationProjectsFetchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationProjectsFetchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationProjectsFetchStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationProjectsFetchStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationProjectsFetchStatusQuery, Types.IntegrationProjectsFetchStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationProjectsFetchStatusQuery, Types.IntegrationProjectsFetchStatusQueryVariables>(IntegrationProjectsFetchStatusDocument, options);
      }
export function useIntegrationProjectsFetchStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationProjectsFetchStatusQuery, Types.IntegrationProjectsFetchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationProjectsFetchStatusQuery, Types.IntegrationProjectsFetchStatusQueryVariables>(IntegrationProjectsFetchStatusDocument, options);
        }
export type IntegrationProjectsFetchStatusQueryHookResult = ReturnType<typeof useIntegrationProjectsFetchStatusQuery>;
export type IntegrationProjectsFetchStatusLazyQueryHookResult = ReturnType<typeof useIntegrationProjectsFetchStatusLazyQuery>;
export type IntegrationProjectsFetchStatusQueryResult = Apollo.QueryResult<Types.IntegrationProjectsFetchStatusQuery, Types.IntegrationProjectsFetchStatusQueryVariables>;
export const IntegrationResourcesDocument = gql`
    query IntegrationResources($integrationId: String!) {
  integrationResources(integrationId: $integrationId) {
    id
    ...IntegrationResource
  }
}
    ${IntegrationResourceFragmentDoc}`;

/**
 * __useIntegrationResourcesQuery__
 *
 * To run a query within a React component, call `useIntegrationResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationResourcesQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrationResourcesQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationResourcesQuery, Types.IntegrationResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationResourcesQuery, Types.IntegrationResourcesQueryVariables>(IntegrationResourcesDocument, options);
      }
export function useIntegrationResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationResourcesQuery, Types.IntegrationResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationResourcesQuery, Types.IntegrationResourcesQueryVariables>(IntegrationResourcesDocument, options);
        }
export type IntegrationResourcesQueryHookResult = ReturnType<typeof useIntegrationResourcesQuery>;
export type IntegrationResourcesLazyQueryHookResult = ReturnType<typeof useIntegrationResourcesLazyQuery>;
export type IntegrationResourcesQueryResult = Apollo.QueryResult<Types.IntegrationResourcesQuery, Types.IntegrationResourcesQueryVariables>;
export const IntegrationResourcesFetchStatusDocument = gql`
    query IntegrationResourcesFetchStatus($id: String!) {
  integrationResourcesFetchStatus(id: $id)
}
    `;

/**
 * __useIntegrationResourcesFetchStatusQuery__
 *
 * To run a query within a React component, call `useIntegrationResourcesFetchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationResourcesFetchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationResourcesFetchStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationResourcesFetchStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationResourcesFetchStatusQuery, Types.IntegrationResourcesFetchStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationResourcesFetchStatusQuery, Types.IntegrationResourcesFetchStatusQueryVariables>(IntegrationResourcesFetchStatusDocument, options);
      }
export function useIntegrationResourcesFetchStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationResourcesFetchStatusQuery, Types.IntegrationResourcesFetchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationResourcesFetchStatusQuery, Types.IntegrationResourcesFetchStatusQueryVariables>(IntegrationResourcesFetchStatusDocument, options);
        }
export type IntegrationResourcesFetchStatusQueryHookResult = ReturnType<typeof useIntegrationResourcesFetchStatusQuery>;
export type IntegrationResourcesFetchStatusLazyQueryHookResult = ReturnType<typeof useIntegrationResourcesFetchStatusLazyQuery>;
export type IntegrationResourcesFetchStatusQueryResult = Apollo.QueryResult<Types.IntegrationResourcesFetchStatusQuery, Types.IntegrationResourcesFetchStatusQueryVariables>;
export const IntegrationSubTasksDocument = gql`
    query IntegrationSubTasks($parentIntegrationTaskId: String!) {
  integrationSubTasks(parentIntegrationTaskId: $parentIntegrationTaskId) {
    id
    ...IntegrationSubTask
  }
}
    ${IntegrationSubTaskFragmentDoc}`;

/**
 * __useIntegrationSubTasksQuery__
 *
 * To run a query within a React component, call `useIntegrationSubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSubTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationSubTasksQuery({
 *   variables: {
 *      parentIntegrationTaskId: // value for 'parentIntegrationTaskId'
 *   },
 * });
 */
export function useIntegrationSubTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationSubTasksQuery, Types.IntegrationSubTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationSubTasksQuery, Types.IntegrationSubTasksQueryVariables>(IntegrationSubTasksDocument, options);
      }
export function useIntegrationSubTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationSubTasksQuery, Types.IntegrationSubTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationSubTasksQuery, Types.IntegrationSubTasksQueryVariables>(IntegrationSubTasksDocument, options);
        }
export type IntegrationSubTasksQueryHookResult = ReturnType<typeof useIntegrationSubTasksQuery>;
export type IntegrationSubTasksLazyQueryHookResult = ReturnType<typeof useIntegrationSubTasksLazyQuery>;
export type IntegrationSubTasksQueryResult = Apollo.QueryResult<Types.IntegrationSubTasksQuery, Types.IntegrationSubTasksQueryVariables>;
export const IntegrationTasksDocument = gql`
    query IntegrationTasks($filter: FilterIntegrationTasksInput!) {
  integrationTasks(filter: $filter) {
    ...IntegrationTask
  }
}
    ${IntegrationTaskFragmentDoc}`;

/**
 * __useIntegrationTasksQuery__
 *
 * To run a query within a React component, call `useIntegrationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationTasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationTasksQuery, Types.IntegrationTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationTasksQuery, Types.IntegrationTasksQueryVariables>(IntegrationTasksDocument, options);
      }
export function useIntegrationTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationTasksQuery, Types.IntegrationTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationTasksQuery, Types.IntegrationTasksQueryVariables>(IntegrationTasksDocument, options);
        }
export type IntegrationTasksQueryHookResult = ReturnType<typeof useIntegrationTasksQuery>;
export type IntegrationTasksLazyQueryHookResult = ReturnType<typeof useIntegrationTasksLazyQuery>;
export type IntegrationTasksQueryResult = Apollo.QueryResult<Types.IntegrationTasksQuery, Types.IntegrationTasksQueryVariables>;
export const IntegrationsTasksAssigneesDocument = gql`
    query IntegrationsTasksAssignees($integrationsIds: [String!]) {
  integrationsTasksAssignees(integrationsIds: $integrationsIds)
}
    `;

/**
 * __useIntegrationsTasksAssigneesQuery__
 *
 * To run a query within a React component, call `useIntegrationsTasksAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsTasksAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsTasksAssigneesQuery({
 *   variables: {
 *      integrationsIds: // value for 'integrationsIds'
 *   },
 * });
 */
export function useIntegrationsTasksAssigneesQuery(baseOptions?: Apollo.QueryHookOptions<Types.IntegrationsTasksAssigneesQuery, Types.IntegrationsTasksAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationsTasksAssigneesQuery, Types.IntegrationsTasksAssigneesQueryVariables>(IntegrationsTasksAssigneesDocument, options);
      }
export function useIntegrationsTasksAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationsTasksAssigneesQuery, Types.IntegrationsTasksAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationsTasksAssigneesQuery, Types.IntegrationsTasksAssigneesQueryVariables>(IntegrationsTasksAssigneesDocument, options);
        }
export type IntegrationsTasksAssigneesQueryHookResult = ReturnType<typeof useIntegrationsTasksAssigneesQuery>;
export type IntegrationsTasksAssigneesLazyQueryHookResult = ReturnType<typeof useIntegrationsTasksAssigneesLazyQuery>;
export type IntegrationsTasksAssigneesQueryResult = Apollo.QueryResult<Types.IntegrationsTasksAssigneesQuery, Types.IntegrationsTasksAssigneesQueryVariables>;
export const IntegrationTasksFetchStatusDocument = gql`
    query IntegrationTasksFetchStatus($id: String!) {
  integrationTasksFetchStatus(id: $id)
}
    `;

/**
 * __useIntegrationTasksFetchStatusQuery__
 *
 * To run a query within a React component, call `useIntegrationTasksFetchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationTasksFetchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationTasksFetchStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationTasksFetchStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationTasksFetchStatusQuery, Types.IntegrationTasksFetchStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationTasksFetchStatusQuery, Types.IntegrationTasksFetchStatusQueryVariables>(IntegrationTasksFetchStatusDocument, options);
      }
export function useIntegrationTasksFetchStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationTasksFetchStatusQuery, Types.IntegrationTasksFetchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationTasksFetchStatusQuery, Types.IntegrationTasksFetchStatusQueryVariables>(IntegrationTasksFetchStatusDocument, options);
        }
export type IntegrationTasksFetchStatusQueryHookResult = ReturnType<typeof useIntegrationTasksFetchStatusQuery>;
export type IntegrationTasksFetchStatusLazyQueryHookResult = ReturnType<typeof useIntegrationTasksFetchStatusLazyQuery>;
export type IntegrationTasksFetchStatusQueryResult = Apollo.QueryResult<Types.IntegrationTasksFetchStatusQuery, Types.IntegrationTasksFetchStatusQueryVariables>;
export const IntegrationsDocument = gql`
    query Integrations {
  integrations {
    ...Integration
  }
}
    ${IntegrationFragmentDoc}`;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.IntegrationsQuery, Types.IntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationsQuery, Types.IntegrationsQueryVariables>(IntegrationsDocument, options);
      }
export function useIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationsQuery, Types.IntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationsQuery, Types.IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
export type IntegrationsQueryHookResult = ReturnType<typeof useIntegrationsQuery>;
export type IntegrationsLazyQueryHookResult = ReturnType<typeof useIntegrationsLazyQuery>;
export type IntegrationsQueryResult = Apollo.QueryResult<Types.IntegrationsQuery, Types.IntegrationsQueryVariables>;
export const PaginatedIntegrationTasksDocument = gql`
    query PaginatedIntegrationTasks($filter: FilterIntegrationTasksInput, $pagination: PaginationInput) {
  paginatedIntegrationTasks(filter: $filter, pagination: $pagination) {
    docs {
      ...IntegrationTask
    }
    limit
    totalDocs
    totalPages
    page
    pagingCounter
    hasPrevPage
    hasNextPage
    prevPage
    nextPage
  }
}
    ${IntegrationTaskFragmentDoc}`;

/**
 * __usePaginatedIntegrationTasksQuery__
 *
 * To run a query within a React component, call `usePaginatedIntegrationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedIntegrationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedIntegrationTasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedIntegrationTasksQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedIntegrationTasksQuery, Types.PaginatedIntegrationTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedIntegrationTasksQuery, Types.PaginatedIntegrationTasksQueryVariables>(PaginatedIntegrationTasksDocument, options);
      }
export function usePaginatedIntegrationTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedIntegrationTasksQuery, Types.PaginatedIntegrationTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedIntegrationTasksQuery, Types.PaginatedIntegrationTasksQueryVariables>(PaginatedIntegrationTasksDocument, options);
        }
export type PaginatedIntegrationTasksQueryHookResult = ReturnType<typeof usePaginatedIntegrationTasksQuery>;
export type PaginatedIntegrationTasksLazyQueryHookResult = ReturnType<typeof usePaginatedIntegrationTasksLazyQuery>;
export type PaginatedIntegrationTasksQueryResult = Apollo.QueryResult<Types.PaginatedIntegrationTasksQuery, Types.PaginatedIntegrationTasksQueryVariables>;
export const ProductIntegrationTaskTypesDocument = gql`
    query ProductIntegrationTaskTypes($integrationIds: [String!]!) {
  productIntegrationTaskTypes(integrationIds: $integrationIds)
}
    `;

/**
 * __useProductIntegrationTaskTypesQuery__
 *
 * To run a query within a React component, call `useProductIntegrationTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIntegrationTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIntegrationTaskTypesQuery({
 *   variables: {
 *      integrationIds: // value for 'integrationIds'
 *   },
 * });
 */
export function useProductIntegrationTaskTypesQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductIntegrationTaskTypesQuery, Types.ProductIntegrationTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductIntegrationTaskTypesQuery, Types.ProductIntegrationTaskTypesQueryVariables>(ProductIntegrationTaskTypesDocument, options);
      }
export function useProductIntegrationTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductIntegrationTaskTypesQuery, Types.ProductIntegrationTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductIntegrationTaskTypesQuery, Types.ProductIntegrationTaskTypesQueryVariables>(ProductIntegrationTaskTypesDocument, options);
        }
export type ProductIntegrationTaskTypesQueryHookResult = ReturnType<typeof useProductIntegrationTaskTypesQuery>;
export type ProductIntegrationTaskTypesLazyQueryHookResult = ReturnType<typeof useProductIntegrationTaskTypesLazyQuery>;
export type ProductIntegrationTaskTypesQueryResult = Apollo.QueryResult<Types.ProductIntegrationTaskTypesQuery, Types.ProductIntegrationTaskTypesQueryVariables>;
export const ProductIntegrationTasksStatusDocument = gql`
    query ProductIntegrationTasksStatus($launchId: String!) {
  productIntegrationTasksStatus(launchId: $launchId) {
    status
    progressPercentage
    totalCompletedSubTasks
    totalSubTasks
  }
}
    `;

/**
 * __useProductIntegrationTasksStatusQuery__
 *
 * To run a query within a React component, call `useProductIntegrationTasksStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIntegrationTasksStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIntegrationTasksStatusQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useProductIntegrationTasksStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductIntegrationTasksStatusQuery, Types.ProductIntegrationTasksStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductIntegrationTasksStatusQuery, Types.ProductIntegrationTasksStatusQueryVariables>(ProductIntegrationTasksStatusDocument, options);
      }
export function useProductIntegrationTasksStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductIntegrationTasksStatusQuery, Types.ProductIntegrationTasksStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductIntegrationTasksStatusQuery, Types.ProductIntegrationTasksStatusQueryVariables>(ProductIntegrationTasksStatusDocument, options);
        }
export type ProductIntegrationTasksStatusQueryHookResult = ReturnType<typeof useProductIntegrationTasksStatusQuery>;
export type ProductIntegrationTasksStatusLazyQueryHookResult = ReturnType<typeof useProductIntegrationTasksStatusLazyQuery>;
export type ProductIntegrationTasksStatusQueryResult = Apollo.QueryResult<Types.ProductIntegrationTasksStatusQuery, Types.ProductIntegrationTasksStatusQueryVariables>;
export const SupportedIntegrationsDocument = gql`
    query SupportedIntegrations {
  supportedIntegrations {
    ...SupportedIntegrationData
  }
}
    ${SupportedIntegrationDataFragmentDoc}`;

/**
 * __useSupportedIntegrationsQuery__
 *
 * To run a query within a React component, call `useSupportedIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.SupportedIntegrationsQuery, Types.SupportedIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SupportedIntegrationsQuery, Types.SupportedIntegrationsQueryVariables>(SupportedIntegrationsDocument, options);
      }
export function useSupportedIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SupportedIntegrationsQuery, Types.SupportedIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SupportedIntegrationsQuery, Types.SupportedIntegrationsQueryVariables>(SupportedIntegrationsDocument, options);
        }
export type SupportedIntegrationsQueryHookResult = ReturnType<typeof useSupportedIntegrationsQuery>;
export type SupportedIntegrationsLazyQueryHookResult = ReturnType<typeof useSupportedIntegrationsLazyQuery>;
export type SupportedIntegrationsQueryResult = Apollo.QueryResult<Types.SupportedIntegrationsQuery, Types.SupportedIntegrationsQueryVariables>;
export const ValidateExternalProjectUrLsDocument = gql`
    query ValidateExternalProjectURLs($input: FetchIntegrationProjectsInput!) {
  validateExternalProjectURLs(input: $input) {
    ...IntegrationProject
  }
}
    ${IntegrationProjectFragmentDoc}`;

/**
 * __useValidateExternalProjectUrLsQuery__
 *
 * To run a query within a React component, call `useValidateExternalProjectUrLsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateExternalProjectUrLsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateExternalProjectUrLsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateExternalProjectUrLsQuery(baseOptions: Apollo.QueryHookOptions<Types.ValidateExternalProjectUrLsQuery, Types.ValidateExternalProjectUrLsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ValidateExternalProjectUrLsQuery, Types.ValidateExternalProjectUrLsQueryVariables>(ValidateExternalProjectUrLsDocument, options);
      }
export function useValidateExternalProjectUrLsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ValidateExternalProjectUrLsQuery, Types.ValidateExternalProjectUrLsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ValidateExternalProjectUrLsQuery, Types.ValidateExternalProjectUrLsQueryVariables>(ValidateExternalProjectUrLsDocument, options);
        }
export type ValidateExternalProjectUrLsQueryHookResult = ReturnType<typeof useValidateExternalProjectUrLsQuery>;
export type ValidateExternalProjectUrLsLazyQueryHookResult = ReturnType<typeof useValidateExternalProjectUrLsLazyQuery>;
export type ValidateExternalProjectUrLsQueryResult = Apollo.QueryResult<Types.ValidateExternalProjectUrLsQuery, Types.ValidateExternalProjectUrLsQueryVariables>;
export const OrganizationIntegrationsDocument = gql`
    query OrganizationIntegrations($filter: OrganizationIntegrationsQueryFilterInput) {
  organizationIntegrations(filter: $filter) {
    items {
      ...OrganizationSettingsIntegration
    }
  }
}
    ${OrganizationSettingsIntegrationFragmentDoc}`;

/**
 * __useOrganizationIntegrationsQuery__
 *
 * To run a query within a React component, call `useOrganizationIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationIntegrationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationIntegrationsQuery, Types.OrganizationIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationIntegrationsQuery, Types.OrganizationIntegrationsQueryVariables>(OrganizationIntegrationsDocument, options);
      }
export function useOrganizationIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationIntegrationsQuery, Types.OrganizationIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationIntegrationsQuery, Types.OrganizationIntegrationsQueryVariables>(OrganizationIntegrationsDocument, options);
        }
export type OrganizationIntegrationsQueryHookResult = ReturnType<typeof useOrganizationIntegrationsQuery>;
export type OrganizationIntegrationsLazyQueryHookResult = ReturnType<typeof useOrganizationIntegrationsLazyQuery>;
export type OrganizationIntegrationsQueryResult = Apollo.QueryResult<Types.OrganizationIntegrationsQuery, Types.OrganizationIntegrationsQueryVariables>;
export const OrganizationIntegrationDocument = gql`
    query OrganizationIntegration($id: String!) {
  organizationIntegration(id: $id) {
    ...OrganizationSettingsIntegration
  }
}
    ${OrganizationSettingsIntegrationFragmentDoc}`;

/**
 * __useOrganizationIntegrationQuery__
 *
 * To run a query within a React component, call `useOrganizationIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationIntegrationQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationIntegrationQuery, Types.OrganizationIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationIntegrationQuery, Types.OrganizationIntegrationQueryVariables>(OrganizationIntegrationDocument, options);
      }
export function useOrganizationIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationIntegrationQuery, Types.OrganizationIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationIntegrationQuery, Types.OrganizationIntegrationQueryVariables>(OrganizationIntegrationDocument, options);
        }
export type OrganizationIntegrationQueryHookResult = ReturnType<typeof useOrganizationIntegrationQuery>;
export type OrganizationIntegrationLazyQueryHookResult = ReturnType<typeof useOrganizationIntegrationLazyQuery>;
export type OrganizationIntegrationQueryResult = Apollo.QueryResult<Types.OrganizationIntegrationQuery, Types.OrganizationIntegrationQueryVariables>;
export const GenerateIntegrationCreateUrlDocument = gql`
    mutation GenerateIntegrationCreateUrl($input: GenerateIntegrationCreateUrlInput!) {
  generateIntegrationCreateUrl(input: $input)
}
    `;
export type GenerateIntegrationCreateUrlMutationFn = Apollo.MutationFunction<Types.GenerateIntegrationCreateUrlMutation, Types.GenerateIntegrationCreateUrlMutationVariables>;

/**
 * __useGenerateIntegrationCreateUrlMutation__
 *
 * To run a mutation, you first call `useGenerateIntegrationCreateUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIntegrationCreateUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIntegrationCreateUrlMutation, { data, loading, error }] = useGenerateIntegrationCreateUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateIntegrationCreateUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateIntegrationCreateUrlMutation, Types.GenerateIntegrationCreateUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateIntegrationCreateUrlMutation, Types.GenerateIntegrationCreateUrlMutationVariables>(GenerateIntegrationCreateUrlDocument, options);
      }
export type GenerateIntegrationCreateUrlMutationHookResult = ReturnType<typeof useGenerateIntegrationCreateUrlMutation>;
export type GenerateIntegrationCreateUrlMutationResult = Apollo.MutationResult<Types.GenerateIntegrationCreateUrlMutation>;
export type GenerateIntegrationCreateUrlMutationOptions = Apollo.BaseMutationOptions<Types.GenerateIntegrationCreateUrlMutation, Types.GenerateIntegrationCreateUrlMutationVariables>;
export const GenerateIntegrationJoinUrlDocument = gql`
    mutation GenerateIntegrationJoinUrl($input: GenerateIntegrationJoinUrlInput!) {
  generateIntegrationJoinUrl(input: $input)
}
    `;
export type GenerateIntegrationJoinUrlMutationFn = Apollo.MutationFunction<Types.GenerateIntegrationJoinUrlMutation, Types.GenerateIntegrationJoinUrlMutationVariables>;

/**
 * __useGenerateIntegrationJoinUrlMutation__
 *
 * To run a mutation, you first call `useGenerateIntegrationJoinUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIntegrationJoinUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIntegrationJoinUrlMutation, { data, loading, error }] = useGenerateIntegrationJoinUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateIntegrationJoinUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateIntegrationJoinUrlMutation, Types.GenerateIntegrationJoinUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateIntegrationJoinUrlMutation, Types.GenerateIntegrationJoinUrlMutationVariables>(GenerateIntegrationJoinUrlDocument, options);
      }
export type GenerateIntegrationJoinUrlMutationHookResult = ReturnType<typeof useGenerateIntegrationJoinUrlMutation>;
export type GenerateIntegrationJoinUrlMutationResult = Apollo.MutationResult<Types.GenerateIntegrationJoinUrlMutation>;
export type GenerateIntegrationJoinUrlMutationOptions = Apollo.BaseMutationOptions<Types.GenerateIntegrationJoinUrlMutation, Types.GenerateIntegrationJoinUrlMutationVariables>;
export const RemoveUserFromIntegrationDocument = gql`
    mutation RemoveUserFromIntegration($id: String!) {
  removeUserFromIntegration(id: $id) {
    ...OrganizationSettingsIntegration
  }
}
    ${OrganizationSettingsIntegrationFragmentDoc}`;
export type RemoveUserFromIntegrationMutationFn = Apollo.MutationFunction<Types.RemoveUserFromIntegrationMutation, Types.RemoveUserFromIntegrationMutationVariables>;

/**
 * __useRemoveUserFromIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromIntegrationMutation, { data, loading, error }] = useRemoveUserFromIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserFromIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveUserFromIntegrationMutation, Types.RemoveUserFromIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveUserFromIntegrationMutation, Types.RemoveUserFromIntegrationMutationVariables>(RemoveUserFromIntegrationDocument, options);
      }
export type RemoveUserFromIntegrationMutationHookResult = ReturnType<typeof useRemoveUserFromIntegrationMutation>;
export type RemoveUserFromIntegrationMutationResult = Apollo.MutationResult<Types.RemoveUserFromIntegrationMutation>;
export type RemoveUserFromIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveUserFromIntegrationMutation, Types.RemoveUserFromIntegrationMutationVariables>;
export const RemoveIntegrationDocument = gql`
    mutation RemoveIntegration($id: String!) {
  removeIntegration(id: $id) {
    ...OrganizationSettingsIntegration
  }
}
    ${OrganizationSettingsIntegrationFragmentDoc}`;
export type RemoveIntegrationMutationFn = Apollo.MutationFunction<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>;

/**
 * __useRemoveIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationMutation, { data, loading, error }] = useRemoveIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>(RemoveIntegrationDocument, options);
      }
export type RemoveIntegrationMutationHookResult = ReturnType<typeof useRemoveIntegrationMutation>;
export type RemoveIntegrationMutationResult = Apollo.MutationResult<Types.RemoveIntegrationMutation>;
export type RemoveIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>;
export const IntegrationCreatedDocument = gql`
    subscription IntegrationCreated($productName: IntegrationProductNames) {
  integrationCreated(productName: $productName) {
    ...OrganizationSettingsIntegration
  }
}
    ${OrganizationSettingsIntegrationFragmentDoc}`;

/**
 * __useIntegrationCreatedSubscription__
 *
 * To run a query within a React component, call `useIntegrationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationCreatedSubscription({
 *   variables: {
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useIntegrationCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<Types.IntegrationCreatedSubscription, Types.IntegrationCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.IntegrationCreatedSubscription, Types.IntegrationCreatedSubscriptionVariables>(IntegrationCreatedDocument, options);
      }
export type IntegrationCreatedSubscriptionHookResult = ReturnType<typeof useIntegrationCreatedSubscription>;
export type IntegrationCreatedSubscriptionResult = Apollo.SubscriptionResult<Types.IntegrationCreatedSubscription>;
export const IntegrationRemovedDocument = gql`
    subscription IntegrationRemoved($productName: IntegrationProductNames) {
  integrationRemoved(productName: $productName) {
    id
  }
}
    `;

/**
 * __useIntegrationRemovedSubscription__
 *
 * To run a query within a React component, call `useIntegrationRemovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationRemovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationRemovedSubscription({
 *   variables: {
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useIntegrationRemovedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<Types.IntegrationRemovedSubscription, Types.IntegrationRemovedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.IntegrationRemovedSubscription, Types.IntegrationRemovedSubscriptionVariables>(IntegrationRemovedDocument, options);
      }
export type IntegrationRemovedSubscriptionHookResult = ReturnType<typeof useIntegrationRemovedSubscription>;
export type IntegrationRemovedSubscriptionResult = Apollo.SubscriptionResult<Types.IntegrationRemovedSubscription>;
export const CalendarFilterOptionsDocument = gql`
    query CalendarFilterOptions {
  launchOptions: launchesFilterOptionsV2 {
    owners {
      ...UserDetails
    }
    tags {
      ...Tag
    }
    launchNames {
      id
      name
    }
    launchTypes {
      id
      name
    }
  }
}
    ${UserDetailsFragmentDoc}
${TagFragmentDoc}`;

/**
 * __useCalendarFilterOptionsQuery__
 *
 * To run a query within a React component, call `useCalendarFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CalendarFilterOptionsQuery, Types.CalendarFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CalendarFilterOptionsQuery, Types.CalendarFilterOptionsQueryVariables>(CalendarFilterOptionsDocument, options);
      }
export function useCalendarFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CalendarFilterOptionsQuery, Types.CalendarFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CalendarFilterOptionsQuery, Types.CalendarFilterOptionsQueryVariables>(CalendarFilterOptionsDocument, options);
        }
export type CalendarFilterOptionsQueryHookResult = ReturnType<typeof useCalendarFilterOptionsQuery>;
export type CalendarFilterOptionsLazyQueryHookResult = ReturnType<typeof useCalendarFilterOptionsLazyQuery>;
export type CalendarFilterOptionsQueryResult = Apollo.QueryResult<Types.CalendarFilterOptionsQuery, Types.CalendarFilterOptionsQueryVariables>;
export const PublicCalendarOrganizationDocument = gql`
    query PublicCalendarOrganization {
  organization {
    ...OrganizationPreview
    publicPagesSettings {
      calendar {
        live
      }
    }
  }
}
    ${OrganizationPreviewFragmentDoc}`;

/**
 * __usePublicCalendarOrganizationQuery__
 *
 * To run a query within a React component, call `usePublicCalendarOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCalendarOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCalendarOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicCalendarOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicCalendarOrganizationQuery, Types.PublicCalendarOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicCalendarOrganizationQuery, Types.PublicCalendarOrganizationQueryVariables>(PublicCalendarOrganizationDocument, options);
      }
export function usePublicCalendarOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicCalendarOrganizationQuery, Types.PublicCalendarOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicCalendarOrganizationQuery, Types.PublicCalendarOrganizationQueryVariables>(PublicCalendarOrganizationDocument, options);
        }
export type PublicCalendarOrganizationQueryHookResult = ReturnType<typeof usePublicCalendarOrganizationQuery>;
export type PublicCalendarOrganizationLazyQueryHookResult = ReturnType<typeof usePublicCalendarOrganizationLazyQuery>;
export type PublicCalendarOrganizationQueryResult = Apollo.QueryResult<Types.PublicCalendarOrganizationQuery, Types.PublicCalendarOrganizationQueryVariables>;
export const ChannelsDocument = gql`
    query Channels($launchId: String!) {
  channels(launchId: $launchId) {
    ...Channels
  }
}
    ${ChannelsFragmentDoc}`;

/**
 * __useChannelsQuery__
 *
 * To run a query within a React component, call `useChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useChannelsQuery(baseOptions: Apollo.QueryHookOptions<Types.ChannelsQuery, Types.ChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChannelsQuery, Types.ChannelsQueryVariables>(ChannelsDocument, options);
      }
export function useChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChannelsQuery, Types.ChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChannelsQuery, Types.ChannelsQueryVariables>(ChannelsDocument, options);
        }
export type ChannelsQueryHookResult = ReturnType<typeof useChannelsQuery>;
export type ChannelsLazyQueryHookResult = ReturnType<typeof useChannelsLazyQuery>;
export type ChannelsQueryResult = Apollo.QueryResult<Types.ChannelsQuery, Types.ChannelsQueryVariables>;
export const LaunchesForCalendarDocument = gql`
    query LaunchesForCalendar($pagination: PaginationInput = {page: 1, limit: 15}, $filter: FilterLaunchInput = {status: UPCOMING}, $sort: SortLaunchInput) {
  paginatedLaunches(filter: $filter, pagination: $pagination, sort: $sort) {
    docs {
      id
      ...CalendarSceneLaunch
    }
    page
    totalDocs
    totalPages
    hasNextPage
  }
}
    ${CalendarSceneLaunchFragmentDoc}`;

/**
 * __useLaunchesForCalendarQuery__
 *
 * To run a query within a React component, call `useLaunchesForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchesForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchesForCalendarQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLaunchesForCalendarQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchesForCalendarQuery, Types.LaunchesForCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchesForCalendarQuery, Types.LaunchesForCalendarQueryVariables>(LaunchesForCalendarDocument, options);
      }
export function useLaunchesForCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchesForCalendarQuery, Types.LaunchesForCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchesForCalendarQuery, Types.LaunchesForCalendarQueryVariables>(LaunchesForCalendarDocument, options);
        }
export type LaunchesForCalendarQueryHookResult = ReturnType<typeof useLaunchesForCalendarQuery>;
export type LaunchesForCalendarLazyQueryHookResult = ReturnType<typeof useLaunchesForCalendarLazyQuery>;
export type LaunchesForCalendarQueryResult = Apollo.QueryResult<Types.LaunchesForCalendarQuery, Types.LaunchesForCalendarQueryVariables>;
export const LaunchCreationTemplatesDocument = gql`
    query LaunchCreationTemplates {
  customOrganizationTemplates {
    ...LaunchCreationTemplate
  }
}
    ${LaunchCreationTemplateFragmentDoc}`;

/**
 * __useLaunchCreationTemplatesQuery__
 *
 * To run a query within a React component, call `useLaunchCreationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCreationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCreationTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaunchCreationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchCreationTemplatesQuery, Types.LaunchCreationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCreationTemplatesQuery, Types.LaunchCreationTemplatesQueryVariables>(LaunchCreationTemplatesDocument, options);
      }
export function useLaunchCreationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCreationTemplatesQuery, Types.LaunchCreationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCreationTemplatesQuery, Types.LaunchCreationTemplatesQueryVariables>(LaunchCreationTemplatesDocument, options);
        }
export type LaunchCreationTemplatesQueryHookResult = ReturnType<typeof useLaunchCreationTemplatesQuery>;
export type LaunchCreationTemplatesLazyQueryHookResult = ReturnType<typeof useLaunchCreationTemplatesLazyQuery>;
export type LaunchCreationTemplatesQueryResult = Apollo.QueryResult<Types.LaunchCreationTemplatesQuery, Types.LaunchCreationTemplatesQueryVariables>;
export const LaunchCreationPreferencesDocument = gql`
    query LaunchCreationPreferences {
  launchTypePreferences {
    ...LaunchCreationPreference
  }
}
    ${LaunchCreationPreferenceFragmentDoc}`;

/**
 * __useLaunchCreationPreferencesQuery__
 *
 * To run a query within a React component, call `useLaunchCreationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCreationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCreationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaunchCreationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchCreationPreferencesQuery, Types.LaunchCreationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCreationPreferencesQuery, Types.LaunchCreationPreferencesQueryVariables>(LaunchCreationPreferencesDocument, options);
      }
export function useLaunchCreationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCreationPreferencesQuery, Types.LaunchCreationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCreationPreferencesQuery, Types.LaunchCreationPreferencesQueryVariables>(LaunchCreationPreferencesDocument, options);
        }
export type LaunchCreationPreferencesQueryHookResult = ReturnType<typeof useLaunchCreationPreferencesQuery>;
export type LaunchCreationPreferencesLazyQueryHookResult = ReturnType<typeof useLaunchCreationPreferencesLazyQuery>;
export type LaunchCreationPreferencesQueryResult = Apollo.QueryResult<Types.LaunchCreationPreferencesQuery, Types.LaunchCreationPreferencesQueryVariables>;
export const CreateLaunchModuleDocument = gql`
    mutation CreateLaunchModule($input: CreateLaunchModuleInput!) {
  createLaunchModule(input: $input) {
    ...LaunchModule
  }
}
    ${LaunchModuleFragmentDoc}`;
export type CreateLaunchModuleMutationFn = Apollo.MutationFunction<Types.CreateLaunchModuleMutation, Types.CreateLaunchModuleMutationVariables>;

/**
 * __useCreateLaunchModuleMutation__
 *
 * To run a mutation, you first call `useCreateLaunchModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaunchModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaunchModuleMutation, { data, loading, error }] = useCreateLaunchModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLaunchModuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLaunchModuleMutation, Types.CreateLaunchModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLaunchModuleMutation, Types.CreateLaunchModuleMutationVariables>(CreateLaunchModuleDocument, options);
      }
export type CreateLaunchModuleMutationHookResult = ReturnType<typeof useCreateLaunchModuleMutation>;
export type CreateLaunchModuleMutationResult = Apollo.MutationResult<Types.CreateLaunchModuleMutation>;
export type CreateLaunchModuleMutationOptions = Apollo.BaseMutationOptions<Types.CreateLaunchModuleMutation, Types.CreateLaunchModuleMutationVariables>;
export const RemoveLaunchModuleDocument = gql`
    mutation RemoveLaunchModule($id: String!) {
  removeLaunchModule(id: $id) {
    id
  }
}
    `;
export type RemoveLaunchModuleMutationFn = Apollo.MutationFunction<Types.RemoveLaunchModuleMutation, Types.RemoveLaunchModuleMutationVariables>;

/**
 * __useRemoveLaunchModuleMutation__
 *
 * To run a mutation, you first call `useRemoveLaunchModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLaunchModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLaunchModuleMutation, { data, loading, error }] = useRemoveLaunchModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLaunchModuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveLaunchModuleMutation, Types.RemoveLaunchModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveLaunchModuleMutation, Types.RemoveLaunchModuleMutationVariables>(RemoveLaunchModuleDocument, options);
      }
export type RemoveLaunchModuleMutationHookResult = ReturnType<typeof useRemoveLaunchModuleMutation>;
export type RemoveLaunchModuleMutationResult = Apollo.MutationResult<Types.RemoveLaunchModuleMutation>;
export type RemoveLaunchModuleMutationOptions = Apollo.BaseMutationOptions<Types.RemoveLaunchModuleMutation, Types.RemoveLaunchModuleMutationVariables>;
export const SwapModuleBetweenSectionsDocument = gql`
    mutation SwapModuleBetweenSections($input: SwapModuleSectionInput!) {
  swapModuleSection(input: $input) {
    id
  }
}
    `;
export type SwapModuleBetweenSectionsMutationFn = Apollo.MutationFunction<Types.SwapModuleBetweenSectionsMutation, Types.SwapModuleBetweenSectionsMutationVariables>;

/**
 * __useSwapModuleBetweenSectionsMutation__
 *
 * To run a mutation, you first call `useSwapModuleBetweenSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapModuleBetweenSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapModuleBetweenSectionsMutation, { data, loading, error }] = useSwapModuleBetweenSectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwapModuleBetweenSectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SwapModuleBetweenSectionsMutation, Types.SwapModuleBetweenSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SwapModuleBetweenSectionsMutation, Types.SwapModuleBetweenSectionsMutationVariables>(SwapModuleBetweenSectionsDocument, options);
      }
export type SwapModuleBetweenSectionsMutationHookResult = ReturnType<typeof useSwapModuleBetweenSectionsMutation>;
export type SwapModuleBetweenSectionsMutationResult = Apollo.MutationResult<Types.SwapModuleBetweenSectionsMutation>;
export type SwapModuleBetweenSectionsMutationOptions = Apollo.BaseMutationOptions<Types.SwapModuleBetweenSectionsMutation, Types.SwapModuleBetweenSectionsMutationVariables>;
export const ToggleModuleLockDocument = gql`
    mutation ToggleModuleLock($input: ToggleModuleLockInput!) {
  toggleModuleLock(input: $input) {
    locked
    lockedByUserId
  }
}
    `;
export type ToggleModuleLockMutationFn = Apollo.MutationFunction<Types.ToggleModuleLockMutation, Types.ToggleModuleLockMutationVariables>;

/**
 * __useToggleModuleLockMutation__
 *
 * To run a mutation, you first call `useToggleModuleLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleModuleLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleModuleLockMutation, { data, loading, error }] = useToggleModuleLockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleModuleLockMutation(baseOptions?: Apollo.MutationHookOptions<Types.ToggleModuleLockMutation, Types.ToggleModuleLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ToggleModuleLockMutation, Types.ToggleModuleLockMutationVariables>(ToggleModuleLockDocument, options);
      }
export type ToggleModuleLockMutationHookResult = ReturnType<typeof useToggleModuleLockMutation>;
export type ToggleModuleLockMutationResult = Apollo.MutationResult<Types.ToggleModuleLockMutation>;
export type ToggleModuleLockMutationOptions = Apollo.BaseMutationOptions<Types.ToggleModuleLockMutation, Types.ToggleModuleLockMutationVariables>;
export const UpdateApprovalStatusDocument = gql`
    mutation UpdateApprovalStatus($input: UpdateLaunchApprovalStatusInput!) {
  updateApprovalStatus(input: $input) {
    id
    users {
      ...LaunchUser
    }
    launchSections {
      id
      launchModules {
        id
        approvalStatus
      }
    }
  }
}
    ${LaunchUserFragmentDoc}`;
export type UpdateApprovalStatusMutationFn = Apollo.MutationFunction<Types.UpdateApprovalStatusMutation, Types.UpdateApprovalStatusMutationVariables>;

/**
 * __useUpdateApprovalStatusMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovalStatusMutation, { data, loading, error }] = useUpdateApprovalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApprovalStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateApprovalStatusMutation, Types.UpdateApprovalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateApprovalStatusMutation, Types.UpdateApprovalStatusMutationVariables>(UpdateApprovalStatusDocument, options);
      }
export type UpdateApprovalStatusMutationHookResult = ReturnType<typeof useUpdateApprovalStatusMutation>;
export type UpdateApprovalStatusMutationResult = Apollo.MutationResult<Types.UpdateApprovalStatusMutation>;
export type UpdateApprovalStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateApprovalStatusMutation, Types.UpdateApprovalStatusMutationVariables>;
export const UpdateLaunchModuleDetailsDocument = gql`
    mutation UpdateLaunchModuleDetails($input: UpdateLaunchModuleDetailsInput!) {
  updateLaunchModuleDetails(input: $input) {
    id
    dueDate
    approvalStatus
    name
    tagsIds
  }
}
    `;
export type UpdateLaunchModuleDetailsMutationFn = Apollo.MutationFunction<Types.UpdateLaunchModuleDetailsMutation, Types.UpdateLaunchModuleDetailsMutationVariables>;

/**
 * __useUpdateLaunchModuleDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchModuleDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchModuleDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchModuleDetailsMutation, { data, loading, error }] = useUpdateLaunchModuleDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchModuleDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchModuleDetailsMutation, Types.UpdateLaunchModuleDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchModuleDetailsMutation, Types.UpdateLaunchModuleDetailsMutationVariables>(UpdateLaunchModuleDetailsDocument, options);
      }
export type UpdateLaunchModuleDetailsMutationHookResult = ReturnType<typeof useUpdateLaunchModuleDetailsMutation>;
export type UpdateLaunchModuleDetailsMutationResult = Apollo.MutationResult<Types.UpdateLaunchModuleDetailsMutation>;
export type UpdateLaunchModuleDetailsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchModuleDetailsMutation, Types.UpdateLaunchModuleDetailsMutationVariables>;
export const UpdateLaunchModuleUserInputDocument = gql`
    mutation UpdateLaunchModuleUserInput($input: UpdateLaunchModuleUserInputInput!) {
  updateLaunchModuleUserInput(input: $input) {
    id
    ...ModuleEditorContent
  }
}
    ${ModuleEditorContentFragmentDoc}`;
export type UpdateLaunchModuleUserInputMutationFn = Apollo.MutationFunction<Types.UpdateLaunchModuleUserInputMutation, Types.UpdateLaunchModuleUserInputMutationVariables>;

/**
 * __useUpdateLaunchModuleUserInputMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchModuleUserInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchModuleUserInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchModuleUserInputMutation, { data, loading, error }] = useUpdateLaunchModuleUserInputMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchModuleUserInputMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchModuleUserInputMutation, Types.UpdateLaunchModuleUserInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchModuleUserInputMutation, Types.UpdateLaunchModuleUserInputMutationVariables>(UpdateLaunchModuleUserInputDocument, options);
      }
export type UpdateLaunchModuleUserInputMutationHookResult = ReturnType<typeof useUpdateLaunchModuleUserInputMutation>;
export type UpdateLaunchModuleUserInputMutationResult = Apollo.MutationResult<Types.UpdateLaunchModuleUserInputMutation>;
export type UpdateLaunchModuleUserInputMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchModuleUserInputMutation, Types.UpdateLaunchModuleUserInputMutationVariables>;
export const AddApproversToLaunchPhaseDocument = gql`
    mutation AddApproversToLaunchPhase($input: AddLaunchPhaseApproversInput!) {
  addApproversToLaunchPhase(input: $input) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type AddApproversToLaunchPhaseMutationFn = Apollo.MutationFunction<Types.AddApproversToLaunchPhaseMutation, Types.AddApproversToLaunchPhaseMutationVariables>;

/**
 * __useAddApproversToLaunchPhaseMutation__
 *
 * To run a mutation, you first call `useAddApproversToLaunchPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApproversToLaunchPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApproversToLaunchPhaseMutation, { data, loading, error }] = useAddApproversToLaunchPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddApproversToLaunchPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddApproversToLaunchPhaseMutation, Types.AddApproversToLaunchPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddApproversToLaunchPhaseMutation, Types.AddApproversToLaunchPhaseMutationVariables>(AddApproversToLaunchPhaseDocument, options);
      }
export type AddApproversToLaunchPhaseMutationHookResult = ReturnType<typeof useAddApproversToLaunchPhaseMutation>;
export type AddApproversToLaunchPhaseMutationResult = Apollo.MutationResult<Types.AddApproversToLaunchPhaseMutation>;
export type AddApproversToLaunchPhaseMutationOptions = Apollo.BaseMutationOptions<Types.AddApproversToLaunchPhaseMutation, Types.AddApproversToLaunchPhaseMutationVariables>;
export const AddApproversToOrganizationPhaseDocument = gql`
    mutation AddApproversToOrganizationPhase($input: AddPhaseApproversInput!) {
  addApproversToOrganizationPhase(input: $input) {
    ...OrganizationPhase
  }
}
    ${OrganizationPhaseFragmentDoc}`;
export type AddApproversToOrganizationPhaseMutationFn = Apollo.MutationFunction<Types.AddApproversToOrganizationPhaseMutation, Types.AddApproversToOrganizationPhaseMutationVariables>;

/**
 * __useAddApproversToOrganizationPhaseMutation__
 *
 * To run a mutation, you first call `useAddApproversToOrganizationPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApproversToOrganizationPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApproversToOrganizationPhaseMutation, { data, loading, error }] = useAddApproversToOrganizationPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddApproversToOrganizationPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddApproversToOrganizationPhaseMutation, Types.AddApproversToOrganizationPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddApproversToOrganizationPhaseMutation, Types.AddApproversToOrganizationPhaseMutationVariables>(AddApproversToOrganizationPhaseDocument, options);
      }
export type AddApproversToOrganizationPhaseMutationHookResult = ReturnType<typeof useAddApproversToOrganizationPhaseMutation>;
export type AddApproversToOrganizationPhaseMutationResult = Apollo.MutationResult<Types.AddApproversToOrganizationPhaseMutation>;
export type AddApproversToOrganizationPhaseMutationOptions = Apollo.BaseMutationOptions<Types.AddApproversToOrganizationPhaseMutation, Types.AddApproversToOrganizationPhaseMutationVariables>;
export const AddLaunchPhaseDocument = gql`
    mutation AddLaunchPhase($input: AddLaunchPhaseInput!) {
  addLaunchPhase(input: $input) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type AddLaunchPhaseMutationFn = Apollo.MutationFunction<Types.AddLaunchPhaseMutation, Types.AddLaunchPhaseMutationVariables>;

/**
 * __useAddLaunchPhaseMutation__
 *
 * To run a mutation, you first call `useAddLaunchPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLaunchPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLaunchPhaseMutation, { data, loading, error }] = useAddLaunchPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLaunchPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddLaunchPhaseMutation, Types.AddLaunchPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddLaunchPhaseMutation, Types.AddLaunchPhaseMutationVariables>(AddLaunchPhaseDocument, options);
      }
export type AddLaunchPhaseMutationHookResult = ReturnType<typeof useAddLaunchPhaseMutation>;
export type AddLaunchPhaseMutationResult = Apollo.MutationResult<Types.AddLaunchPhaseMutation>;
export type AddLaunchPhaseMutationOptions = Apollo.BaseMutationOptions<Types.AddLaunchPhaseMutation, Types.AddLaunchPhaseMutationVariables>;
export const AddOrganizationPhaseDocument = gql`
    mutation AddOrganizationPhase($input: AddPhaseInput!) {
  addOrganizationPhase(input: $input) {
    ...OrganizationPhase
  }
}
    ${OrganizationPhaseFragmentDoc}`;
export type AddOrganizationPhaseMutationFn = Apollo.MutationFunction<Types.AddOrganizationPhaseMutation, Types.AddOrganizationPhaseMutationVariables>;

/**
 * __useAddOrganizationPhaseMutation__
 *
 * To run a mutation, you first call `useAddOrganizationPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationPhaseMutation, { data, loading, error }] = useAddOrganizationPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationPhaseMutation, Types.AddOrganizationPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationPhaseMutation, Types.AddOrganizationPhaseMutationVariables>(AddOrganizationPhaseDocument, options);
      }
export type AddOrganizationPhaseMutationHookResult = ReturnType<typeof useAddOrganizationPhaseMutation>;
export type AddOrganizationPhaseMutationResult = Apollo.MutationResult<Types.AddOrganizationPhaseMutation>;
export type AddOrganizationPhaseMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationPhaseMutation, Types.AddOrganizationPhaseMutationVariables>;
export const MoveLaunchToCustomPhaseDocument = gql`
    mutation MoveLaunchToCustomPhase($launchId: String!, $phaseId: String!) {
  moveLaunchToCustomPhase(launchId: $launchId, phaseId: $phaseId) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type MoveLaunchToCustomPhaseMutationFn = Apollo.MutationFunction<Types.MoveLaunchToCustomPhaseMutation, Types.MoveLaunchToCustomPhaseMutationVariables>;

/**
 * __useMoveLaunchToCustomPhaseMutation__
 *
 * To run a mutation, you first call `useMoveLaunchToCustomPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLaunchToCustomPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLaunchToCustomPhaseMutation, { data, loading, error }] = useMoveLaunchToCustomPhaseMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useMoveLaunchToCustomPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveLaunchToCustomPhaseMutation, Types.MoveLaunchToCustomPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveLaunchToCustomPhaseMutation, Types.MoveLaunchToCustomPhaseMutationVariables>(MoveLaunchToCustomPhaseDocument, options);
      }
export type MoveLaunchToCustomPhaseMutationHookResult = ReturnType<typeof useMoveLaunchToCustomPhaseMutation>;
export type MoveLaunchToCustomPhaseMutationResult = Apollo.MutationResult<Types.MoveLaunchToCustomPhaseMutation>;
export type MoveLaunchToCustomPhaseMutationOptions = Apollo.BaseMutationOptions<Types.MoveLaunchToCustomPhaseMutation, Types.MoveLaunchToCustomPhaseMutationVariables>;
export const MoveLaunchToNextPhaseDocument = gql`
    mutation MoveLaunchToNextPhase($launchId: String!, $force: Boolean!) {
  moveLaunchToNextPhase(launchId: $launchId, force: $force) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type MoveLaunchToNextPhaseMutationFn = Apollo.MutationFunction<Types.MoveLaunchToNextPhaseMutation, Types.MoveLaunchToNextPhaseMutationVariables>;

/**
 * __useMoveLaunchToNextPhaseMutation__
 *
 * To run a mutation, you first call `useMoveLaunchToNextPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLaunchToNextPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLaunchToNextPhaseMutation, { data, loading, error }] = useMoveLaunchToNextPhaseMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useMoveLaunchToNextPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveLaunchToNextPhaseMutation, Types.MoveLaunchToNextPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveLaunchToNextPhaseMutation, Types.MoveLaunchToNextPhaseMutationVariables>(MoveLaunchToNextPhaseDocument, options);
      }
export type MoveLaunchToNextPhaseMutationHookResult = ReturnType<typeof useMoveLaunchToNextPhaseMutation>;
export type MoveLaunchToNextPhaseMutationResult = Apollo.MutationResult<Types.MoveLaunchToNextPhaseMutation>;
export type MoveLaunchToNextPhaseMutationOptions = Apollo.BaseMutationOptions<Types.MoveLaunchToNextPhaseMutation, Types.MoveLaunchToNextPhaseMutationVariables>;
export const MoveLaunchToPrevPhaseDocument = gql`
    mutation MoveLaunchToPrevPhase($launchId: String!) {
  moveLaunchToPrevPhase(launchId: $launchId) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type MoveLaunchToPrevPhaseMutationFn = Apollo.MutationFunction<Types.MoveLaunchToPrevPhaseMutation, Types.MoveLaunchToPrevPhaseMutationVariables>;

/**
 * __useMoveLaunchToPrevPhaseMutation__
 *
 * To run a mutation, you first call `useMoveLaunchToPrevPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLaunchToPrevPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLaunchToPrevPhaseMutation, { data, loading, error }] = useMoveLaunchToPrevPhaseMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useMoveLaunchToPrevPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveLaunchToPrevPhaseMutation, Types.MoveLaunchToPrevPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveLaunchToPrevPhaseMutation, Types.MoveLaunchToPrevPhaseMutationVariables>(MoveLaunchToPrevPhaseDocument, options);
      }
export type MoveLaunchToPrevPhaseMutationHookResult = ReturnType<typeof useMoveLaunchToPrevPhaseMutation>;
export type MoveLaunchToPrevPhaseMutationResult = Apollo.MutationResult<Types.MoveLaunchToPrevPhaseMutation>;
export type MoveLaunchToPrevPhaseMutationOptions = Apollo.BaseMutationOptions<Types.MoveLaunchToPrevPhaseMutation, Types.MoveLaunchToPrevPhaseMutationVariables>;
export const PublicToggleLaunchPhaseApprovalDocument = gql`
    mutation PublicToggleLaunchPhaseApproval($input: PublicLaunchPhaseApprovalInput!) {
  publicToggleLaunchPhaseApproval(input: $input) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type PublicToggleLaunchPhaseApprovalMutationFn = Apollo.MutationFunction<Types.PublicToggleLaunchPhaseApprovalMutation, Types.PublicToggleLaunchPhaseApprovalMutationVariables>;

/**
 * __usePublicToggleLaunchPhaseApprovalMutation__
 *
 * To run a mutation, you first call `usePublicToggleLaunchPhaseApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicToggleLaunchPhaseApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicToggleLaunchPhaseApprovalMutation, { data, loading, error }] = usePublicToggleLaunchPhaseApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicToggleLaunchPhaseApprovalMutation(baseOptions?: Apollo.MutationHookOptions<Types.PublicToggleLaunchPhaseApprovalMutation, Types.PublicToggleLaunchPhaseApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PublicToggleLaunchPhaseApprovalMutation, Types.PublicToggleLaunchPhaseApprovalMutationVariables>(PublicToggleLaunchPhaseApprovalDocument, options);
      }
export type PublicToggleLaunchPhaseApprovalMutationHookResult = ReturnType<typeof usePublicToggleLaunchPhaseApprovalMutation>;
export type PublicToggleLaunchPhaseApprovalMutationResult = Apollo.MutationResult<Types.PublicToggleLaunchPhaseApprovalMutation>;
export type PublicToggleLaunchPhaseApprovalMutationOptions = Apollo.BaseMutationOptions<Types.PublicToggleLaunchPhaseApprovalMutation, Types.PublicToggleLaunchPhaseApprovalMutationVariables>;
export const RemoveApproversFromLaunchPhaseDocument = gql`
    mutation RemoveApproversFromLaunchPhase($input: RemoveLaunchPhaseApproversInput!) {
  removeApproversFromLaunchPhase(input: $input) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type RemoveApproversFromLaunchPhaseMutationFn = Apollo.MutationFunction<Types.RemoveApproversFromLaunchPhaseMutation, Types.RemoveApproversFromLaunchPhaseMutationVariables>;

/**
 * __useRemoveApproversFromLaunchPhaseMutation__
 *
 * To run a mutation, you first call `useRemoveApproversFromLaunchPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApproversFromLaunchPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApproversFromLaunchPhaseMutation, { data, loading, error }] = useRemoveApproversFromLaunchPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveApproversFromLaunchPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveApproversFromLaunchPhaseMutation, Types.RemoveApproversFromLaunchPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveApproversFromLaunchPhaseMutation, Types.RemoveApproversFromLaunchPhaseMutationVariables>(RemoveApproversFromLaunchPhaseDocument, options);
      }
export type RemoveApproversFromLaunchPhaseMutationHookResult = ReturnType<typeof useRemoveApproversFromLaunchPhaseMutation>;
export type RemoveApproversFromLaunchPhaseMutationResult = Apollo.MutationResult<Types.RemoveApproversFromLaunchPhaseMutation>;
export type RemoveApproversFromLaunchPhaseMutationOptions = Apollo.BaseMutationOptions<Types.RemoveApproversFromLaunchPhaseMutation, Types.RemoveApproversFromLaunchPhaseMutationVariables>;
export const RemoveApproversFromOrganizationPhaseDocument = gql`
    mutation RemoveApproversFromOrganizationPhase($input: RemovePhaseApproversInput!) {
  removeApproversFromOrganizationPhase(input: $input) {
    ...OrganizationPhase
  }
}
    ${OrganizationPhaseFragmentDoc}`;
export type RemoveApproversFromOrganizationPhaseMutationFn = Apollo.MutationFunction<Types.RemoveApproversFromOrganizationPhaseMutation, Types.RemoveApproversFromOrganizationPhaseMutationVariables>;

/**
 * __useRemoveApproversFromOrganizationPhaseMutation__
 *
 * To run a mutation, you first call `useRemoveApproversFromOrganizationPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApproversFromOrganizationPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApproversFromOrganizationPhaseMutation, { data, loading, error }] = useRemoveApproversFromOrganizationPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveApproversFromOrganizationPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveApproversFromOrganizationPhaseMutation, Types.RemoveApproversFromOrganizationPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveApproversFromOrganizationPhaseMutation, Types.RemoveApproversFromOrganizationPhaseMutationVariables>(RemoveApproversFromOrganizationPhaseDocument, options);
      }
export type RemoveApproversFromOrganizationPhaseMutationHookResult = ReturnType<typeof useRemoveApproversFromOrganizationPhaseMutation>;
export type RemoveApproversFromOrganizationPhaseMutationResult = Apollo.MutationResult<Types.RemoveApproversFromOrganizationPhaseMutation>;
export type RemoveApproversFromOrganizationPhaseMutationOptions = Apollo.BaseMutationOptions<Types.RemoveApproversFromOrganizationPhaseMutation, Types.RemoveApproversFromOrganizationPhaseMutationVariables>;
export const RemoveLaunchPhaseDocument = gql`
    mutation RemoveLaunchPhase($launchId: String!, $phaseId: String!) {
  removeLaunchPhase(launchId: $launchId, phaseId: $phaseId) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type RemoveLaunchPhaseMutationFn = Apollo.MutationFunction<Types.RemoveLaunchPhaseMutation, Types.RemoveLaunchPhaseMutationVariables>;

/**
 * __useRemoveLaunchPhaseMutation__
 *
 * To run a mutation, you first call `useRemoveLaunchPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLaunchPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLaunchPhaseMutation, { data, loading, error }] = useRemoveLaunchPhaseMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useRemoveLaunchPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveLaunchPhaseMutation, Types.RemoveLaunchPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveLaunchPhaseMutation, Types.RemoveLaunchPhaseMutationVariables>(RemoveLaunchPhaseDocument, options);
      }
export type RemoveLaunchPhaseMutationHookResult = ReturnType<typeof useRemoveLaunchPhaseMutation>;
export type RemoveLaunchPhaseMutationResult = Apollo.MutationResult<Types.RemoveLaunchPhaseMutation>;
export type RemoveLaunchPhaseMutationOptions = Apollo.BaseMutationOptions<Types.RemoveLaunchPhaseMutation, Types.RemoveLaunchPhaseMutationVariables>;
export const RemoveOrganizationPhaseDocument = gql`
    mutation RemoveOrganizationPhase($ids: [String!]!) {
  removeOrganizationPhase(ids: $ids) {
    ...OrganizationPhase
  }
}
    ${OrganizationPhaseFragmentDoc}`;
export type RemoveOrganizationPhaseMutationFn = Apollo.MutationFunction<Types.RemoveOrganizationPhaseMutation, Types.RemoveOrganizationPhaseMutationVariables>;

/**
 * __useRemoveOrganizationPhaseMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationPhaseMutation, { data, loading, error }] = useRemoveOrganizationPhaseMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRemoveOrganizationPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveOrganizationPhaseMutation, Types.RemoveOrganizationPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveOrganizationPhaseMutation, Types.RemoveOrganizationPhaseMutationVariables>(RemoveOrganizationPhaseDocument, options);
      }
export type RemoveOrganizationPhaseMutationHookResult = ReturnType<typeof useRemoveOrganizationPhaseMutation>;
export type RemoveOrganizationPhaseMutationResult = Apollo.MutationResult<Types.RemoveOrganizationPhaseMutation>;
export type RemoveOrganizationPhaseMutationOptions = Apollo.BaseMutationOptions<Types.RemoveOrganizationPhaseMutation, Types.RemoveOrganizationPhaseMutationVariables>;
export const ToggleLaunchPhaseApprovalDocument = gql`
    mutation ToggleLaunchPhaseApproval($input: ToggleLaunchPhaseApprovalInput!) {
  toggleLaunchPhaseApproval(input: $input) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type ToggleLaunchPhaseApprovalMutationFn = Apollo.MutationFunction<Types.ToggleLaunchPhaseApprovalMutation, Types.ToggleLaunchPhaseApprovalMutationVariables>;

/**
 * __useToggleLaunchPhaseApprovalMutation__
 *
 * To run a mutation, you first call `useToggleLaunchPhaseApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLaunchPhaseApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLaunchPhaseApprovalMutation, { data, loading, error }] = useToggleLaunchPhaseApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleLaunchPhaseApprovalMutation(baseOptions?: Apollo.MutationHookOptions<Types.ToggleLaunchPhaseApprovalMutation, Types.ToggleLaunchPhaseApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ToggleLaunchPhaseApprovalMutation, Types.ToggleLaunchPhaseApprovalMutationVariables>(ToggleLaunchPhaseApprovalDocument, options);
      }
export type ToggleLaunchPhaseApprovalMutationHookResult = ReturnType<typeof useToggleLaunchPhaseApprovalMutation>;
export type ToggleLaunchPhaseApprovalMutationResult = Apollo.MutationResult<Types.ToggleLaunchPhaseApprovalMutation>;
export type ToggleLaunchPhaseApprovalMutationOptions = Apollo.BaseMutationOptions<Types.ToggleLaunchPhaseApprovalMutation, Types.ToggleLaunchPhaseApprovalMutationVariables>;
export const UpdateApprovalRequestStatusDocument = gql`
    mutation UpdateApprovalRequestStatus($input: UpdateApprovalRequestStatusInput!) {
  updateApprovalRequestStatus(input: $input) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type UpdateApprovalRequestStatusMutationFn = Apollo.MutationFunction<Types.UpdateApprovalRequestStatusMutation, Types.UpdateApprovalRequestStatusMutationVariables>;

/**
 * __useUpdateApprovalRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovalRequestStatusMutation, { data, loading, error }] = useUpdateApprovalRequestStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApprovalRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateApprovalRequestStatusMutation, Types.UpdateApprovalRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateApprovalRequestStatusMutation, Types.UpdateApprovalRequestStatusMutationVariables>(UpdateApprovalRequestStatusDocument, options);
      }
export type UpdateApprovalRequestStatusMutationHookResult = ReturnType<typeof useUpdateApprovalRequestStatusMutation>;
export type UpdateApprovalRequestStatusMutationResult = Apollo.MutationResult<Types.UpdateApprovalRequestStatusMutation>;
export type UpdateApprovalRequestStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateApprovalRequestStatusMutation, Types.UpdateApprovalRequestStatusMutationVariables>;
export const UpdateLaunchPhaseDocument = gql`
    mutation UpdateLaunchPhase($input: UpdateLaunchPhaseInput!) {
  updateLaunchPhase(input: $input) {
    ...LaunchWithPhase
  }
}
    ${LaunchWithPhaseFragmentDoc}`;
export type UpdateLaunchPhaseMutationFn = Apollo.MutationFunction<Types.UpdateLaunchPhaseMutation, Types.UpdateLaunchPhaseMutationVariables>;

/**
 * __useUpdateLaunchPhaseMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchPhaseMutation, { data, loading, error }] = useUpdateLaunchPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchPhaseMutation, Types.UpdateLaunchPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchPhaseMutation, Types.UpdateLaunchPhaseMutationVariables>(UpdateLaunchPhaseDocument, options);
      }
export type UpdateLaunchPhaseMutationHookResult = ReturnType<typeof useUpdateLaunchPhaseMutation>;
export type UpdateLaunchPhaseMutationResult = Apollo.MutationResult<Types.UpdateLaunchPhaseMutation>;
export type UpdateLaunchPhaseMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchPhaseMutation, Types.UpdateLaunchPhaseMutationVariables>;
export const UpdateOrganizationPhaseDocument = gql`
    mutation UpdateOrganizationPhase($input: UpdatePhaseInput!) {
  updateOrganizationPhase(input: $input) {
    ...OrganizationPhase
  }
}
    ${OrganizationPhaseFragmentDoc}`;
export type UpdateOrganizationPhaseMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationPhaseMutation, Types.UpdateOrganizationPhaseMutationVariables>;

/**
 * __useUpdateOrganizationPhaseMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPhaseMutation, { data, loading, error }] = useUpdateOrganizationPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationPhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationPhaseMutation, Types.UpdateOrganizationPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationPhaseMutation, Types.UpdateOrganizationPhaseMutationVariables>(UpdateOrganizationPhaseDocument, options);
      }
export type UpdateOrganizationPhaseMutationHookResult = ReturnType<typeof useUpdateOrganizationPhaseMutation>;
export type UpdateOrganizationPhaseMutationResult = Apollo.MutationResult<Types.UpdateOrganizationPhaseMutation>;
export type UpdateOrganizationPhaseMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationPhaseMutation, Types.UpdateOrganizationPhaseMutationVariables>;
export const OrganizationPhasesDocument = gql`
    query OrganizationPhases($filter: FilterPhaseInput) {
  organizationPhases(filter: $filter) {
    ...OrganizationPhase
  }
}
    ${OrganizationPhaseFragmentDoc}`;

/**
 * __useOrganizationPhasesQuery__
 *
 * To run a query within a React component, call `useOrganizationPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPhasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationPhasesQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationPhasesQuery, Types.OrganizationPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationPhasesQuery, Types.OrganizationPhasesQueryVariables>(OrganizationPhasesDocument, options);
      }
export function useOrganizationPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationPhasesQuery, Types.OrganizationPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationPhasesQuery, Types.OrganizationPhasesQueryVariables>(OrganizationPhasesDocument, options);
        }
export type OrganizationPhasesQueryHookResult = ReturnType<typeof useOrganizationPhasesQuery>;
export type OrganizationPhasesLazyQueryHookResult = ReturnType<typeof useOrganizationPhasesLazyQuery>;
export type OrganizationPhasesQueryResult = Apollo.QueryResult<Types.OrganizationPhasesQuery, Types.OrganizationPhasesQueryVariables>;
export const CreateLaunchTypeDocument = gql`
    mutation CreateLaunchType($input: CreateLaunchTypeInput!) {
  createLaunchType(input: $input) {
    ...LaunchTypeOption
  }
}
    ${LaunchTypeOptionFragmentDoc}`;
export type CreateLaunchTypeMutationFn = Apollo.MutationFunction<Types.CreateLaunchTypeMutation, Types.CreateLaunchTypeMutationVariables>;

/**
 * __useCreateLaunchTypeMutation__
 *
 * To run a mutation, you first call `useCreateLaunchTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaunchTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaunchTypeMutation, { data, loading, error }] = useCreateLaunchTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLaunchTypeMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLaunchTypeMutation, Types.CreateLaunchTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLaunchTypeMutation, Types.CreateLaunchTypeMutationVariables>(CreateLaunchTypeDocument, options);
      }
export type CreateLaunchTypeMutationHookResult = ReturnType<typeof useCreateLaunchTypeMutation>;
export type CreateLaunchTypeMutationResult = Apollo.MutationResult<Types.CreateLaunchTypeMutation>;
export type CreateLaunchTypeMutationOptions = Apollo.BaseMutationOptions<Types.CreateLaunchTypeMutation, Types.CreateLaunchTypeMutationVariables>;
export const LaunchTypesDocument = gql`
    query LaunchTypes {
  launchTypes {
    ...LaunchTypeOption
  }
}
    ${LaunchTypeOptionFragmentDoc}`;

/**
 * __useLaunchTypesQuery__
 *
 * To run a query within a React component, call `useLaunchTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaunchTypesQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchTypesQuery, Types.LaunchTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchTypesQuery, Types.LaunchTypesQueryVariables>(LaunchTypesDocument, options);
      }
export function useLaunchTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchTypesQuery, Types.LaunchTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchTypesQuery, Types.LaunchTypesQueryVariables>(LaunchTypesDocument, options);
        }
export type LaunchTypesQueryHookResult = ReturnType<typeof useLaunchTypesQuery>;
export type LaunchTypesLazyQueryHookResult = ReturnType<typeof useLaunchTypesLazyQuery>;
export type LaunchTypesQueryResult = Apollo.QueryResult<Types.LaunchTypesQuery, Types.LaunchTypesQueryVariables>;
export const UsersBySearchStringDocument = gql`
    query UsersBySearchString($search: String!) {
  users(filter: {search: $search}) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useUsersBySearchStringQuery__
 *
 * To run a query within a React component, call `useUsersBySearchStringQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersBySearchStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersBySearchStringQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUsersBySearchStringQuery(baseOptions: Apollo.QueryHookOptions<Types.UsersBySearchStringQuery, Types.UsersBySearchStringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UsersBySearchStringQuery, Types.UsersBySearchStringQueryVariables>(UsersBySearchStringDocument, options);
      }
export function useUsersBySearchStringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UsersBySearchStringQuery, Types.UsersBySearchStringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UsersBySearchStringQuery, Types.UsersBySearchStringQueryVariables>(UsersBySearchStringDocument, options);
        }
export type UsersBySearchStringQueryHookResult = ReturnType<typeof useUsersBySearchStringQuery>;
export type UsersBySearchStringLazyQueryHookResult = ReturnType<typeof useUsersBySearchStringLazyQuery>;
export type UsersBySearchStringQueryResult = Apollo.QueryResult<Types.UsersBySearchStringQuery, Types.UsersBySearchStringQueryVariables>;
export const UpdateUserRolesInLaunchModuleDocument = gql`
    mutation UpdateUserRolesInLaunchModule($input: UpdateUsersInLaunchInput!) {
  updateUserRolesInLaunchModule(input: $input) {
    id
    users {
      ...LaunchUser
    }
  }
}
    ${LaunchUserFragmentDoc}`;
export type UpdateUserRolesInLaunchModuleMutationFn = Apollo.MutationFunction<Types.UpdateUserRolesInLaunchModuleMutation, Types.UpdateUserRolesInLaunchModuleMutationVariables>;

/**
 * __useUpdateUserRolesInLaunchModuleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesInLaunchModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesInLaunchModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesInLaunchModuleMutation, { data, loading, error }] = useUpdateUserRolesInLaunchModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRolesInLaunchModuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserRolesInLaunchModuleMutation, Types.UpdateUserRolesInLaunchModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserRolesInLaunchModuleMutation, Types.UpdateUserRolesInLaunchModuleMutationVariables>(UpdateUserRolesInLaunchModuleDocument, options);
      }
export type UpdateUserRolesInLaunchModuleMutationHookResult = ReturnType<typeof useUpdateUserRolesInLaunchModuleMutation>;
export type UpdateUserRolesInLaunchModuleMutationResult = Apollo.MutationResult<Types.UpdateUserRolesInLaunchModuleMutation>;
export type UpdateUserRolesInLaunchModuleMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserRolesInLaunchModuleMutation, Types.UpdateUserRolesInLaunchModuleMutationVariables>;
export const RemoveNotificationChannelDocument = gql`
    mutation RemoveNotificationChannel($id: String!) {
  removeNotificationChannel(id: $id) {
    id
  }
}
    `;
export type RemoveNotificationChannelMutationFn = Apollo.MutationFunction<Types.RemoveNotificationChannelMutation, Types.RemoveNotificationChannelMutationVariables>;

/**
 * __useRemoveNotificationChannelMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationChannelMutation, { data, loading, error }] = useRemoveNotificationChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveNotificationChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveNotificationChannelMutation, Types.RemoveNotificationChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveNotificationChannelMutation, Types.RemoveNotificationChannelMutationVariables>(RemoveNotificationChannelDocument, options);
      }
export type RemoveNotificationChannelMutationHookResult = ReturnType<typeof useRemoveNotificationChannelMutation>;
export type RemoveNotificationChannelMutationResult = Apollo.MutationResult<Types.RemoveNotificationChannelMutation>;
export type RemoveNotificationChannelMutationOptions = Apollo.BaseMutationOptions<Types.RemoveNotificationChannelMutation, Types.RemoveNotificationChannelMutationVariables>;
export const CreateConfluenceDocDocument = gql`
    mutation CreateConfluenceDoc($launchId: String, $launchModuleId: String) {
  createConfluenceDoc(launchId: $launchId, launchModuleId: $launchModuleId)
}
    `;
export type CreateConfluenceDocMutationFn = Apollo.MutationFunction<Types.CreateConfluenceDocMutation, Types.CreateConfluenceDocMutationVariables>;

/**
 * __useCreateConfluenceDocMutation__
 *
 * To run a mutation, you first call `useCreateConfluenceDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConfluenceDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConfluenceDocMutation, { data, loading, error }] = useCreateConfluenceDocMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      launchModuleId: // value for 'launchModuleId'
 *   },
 * });
 */
export function useCreateConfluenceDocMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateConfluenceDocMutation, Types.CreateConfluenceDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateConfluenceDocMutation, Types.CreateConfluenceDocMutationVariables>(CreateConfluenceDocDocument, options);
      }
export type CreateConfluenceDocMutationHookResult = ReturnType<typeof useCreateConfluenceDocMutation>;
export type CreateConfluenceDocMutationResult = Apollo.MutationResult<Types.CreateConfluenceDocMutation>;
export type CreateConfluenceDocMutationOptions = Apollo.BaseMutationOptions<Types.CreateConfluenceDocMutation, Types.CreateConfluenceDocMutationVariables>;
export const CreateDemoLaunchDocument = gql`
    mutation CreateDemoLaunch {
  createDemoLaunch {
    id
  }
}
    `;
export type CreateDemoLaunchMutationFn = Apollo.MutationFunction<Types.CreateDemoLaunchMutation, Types.CreateDemoLaunchMutationVariables>;

/**
 * __useCreateDemoLaunchMutation__
 *
 * To run a mutation, you first call `useCreateDemoLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemoLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemoLaunchMutation, { data, loading, error }] = useCreateDemoLaunchMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDemoLaunchMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDemoLaunchMutation, Types.CreateDemoLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDemoLaunchMutation, Types.CreateDemoLaunchMutationVariables>(CreateDemoLaunchDocument, options);
      }
export type CreateDemoLaunchMutationHookResult = ReturnType<typeof useCreateDemoLaunchMutation>;
export type CreateDemoLaunchMutationResult = Apollo.MutationResult<Types.CreateDemoLaunchMutation>;
export type CreateDemoLaunchMutationOptions = Apollo.BaseMutationOptions<Types.CreateDemoLaunchMutation, Types.CreateDemoLaunchMutationVariables>;
export const CreateGoogleDocDocument = gql`
    mutation CreateGoogleDoc($launchId: String, $launchModuleId: String) {
  createGoogleDoc(launchId: $launchId, launchModuleId: $launchModuleId)
}
    `;
export type CreateGoogleDocMutationFn = Apollo.MutationFunction<Types.CreateGoogleDocMutation, Types.CreateGoogleDocMutationVariables>;

/**
 * __useCreateGoogleDocMutation__
 *
 * To run a mutation, you first call `useCreateGoogleDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoogleDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoogleDocMutation, { data, loading, error }] = useCreateGoogleDocMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      launchModuleId: // value for 'launchModuleId'
 *   },
 * });
 */
export function useCreateGoogleDocMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateGoogleDocMutation, Types.CreateGoogleDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateGoogleDocMutation, Types.CreateGoogleDocMutationVariables>(CreateGoogleDocDocument, options);
      }
export type CreateGoogleDocMutationHookResult = ReturnType<typeof useCreateGoogleDocMutation>;
export type CreateGoogleDocMutationResult = Apollo.MutationResult<Types.CreateGoogleDocMutation>;
export type CreateGoogleDocMutationOptions = Apollo.BaseMutationOptions<Types.CreateGoogleDocMutation, Types.CreateGoogleDocMutationVariables>;
export const CreateGoogleSlideDocument = gql`
    mutation CreateGoogleSlide($launchId: String, $launchModuleId: String) {
  createGoogleSlide(launchId: $launchId, launchModuleId: $launchModuleId)
}
    `;
export type CreateGoogleSlideMutationFn = Apollo.MutationFunction<Types.CreateGoogleSlideMutation, Types.CreateGoogleSlideMutationVariables>;

/**
 * __useCreateGoogleSlideMutation__
 *
 * To run a mutation, you first call `useCreateGoogleSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoogleSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoogleSlideMutation, { data, loading, error }] = useCreateGoogleSlideMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      launchModuleId: // value for 'launchModuleId'
 *   },
 * });
 */
export function useCreateGoogleSlideMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateGoogleSlideMutation, Types.CreateGoogleSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateGoogleSlideMutation, Types.CreateGoogleSlideMutationVariables>(CreateGoogleSlideDocument, options);
      }
export type CreateGoogleSlideMutationHookResult = ReturnType<typeof useCreateGoogleSlideMutation>;
export type CreateGoogleSlideMutationResult = Apollo.MutationResult<Types.CreateGoogleSlideMutation>;
export type CreateGoogleSlideMutationOptions = Apollo.BaseMutationOptions<Types.CreateGoogleSlideMutation, Types.CreateGoogleSlideMutationVariables>;
export const CreateLaunchDocument = gql`
    mutation CreateLaunch($input: CreateLaunchInput!) {
  createLaunch(input: $input) {
    ...LaunchQuery
    ...LaunchesSceneLaunch
    ...LaunchWithMilestonesAndChannels
  }
}
    ${LaunchQueryFragmentDoc}
${LaunchesSceneLaunchFragmentDoc}
${LaunchWithMilestonesAndChannelsFragmentDoc}`;
export type CreateLaunchMutationFn = Apollo.MutationFunction<Types.CreateLaunchMutation, Types.CreateLaunchMutationVariables>;

/**
 * __useCreateLaunchMutation__
 *
 * To run a mutation, you first call `useCreateLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaunchMutation, { data, loading, error }] = useCreateLaunchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLaunchMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLaunchMutation, Types.CreateLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLaunchMutation, Types.CreateLaunchMutationVariables>(CreateLaunchDocument, options);
      }
export type CreateLaunchMutationHookResult = ReturnType<typeof useCreateLaunchMutation>;
export type CreateLaunchMutationResult = Apollo.MutationResult<Types.CreateLaunchMutation>;
export type CreateLaunchMutationOptions = Apollo.BaseMutationOptions<Types.CreateLaunchMutation, Types.CreateLaunchMutationVariables>;
export const CreateLaunchSectionDocument = gql`
    mutation CreateLaunchSection($input: CreateOrRemoveLaunchSectionInput!) {
  createLaunchSection(input: $input) {
    launchSections {
      id
      name
      launchModules {
        ...LaunchModule
      }
    }
  }
}
    ${LaunchModuleFragmentDoc}`;
export type CreateLaunchSectionMutationFn = Apollo.MutationFunction<Types.CreateLaunchSectionMutation, Types.CreateLaunchSectionMutationVariables>;

/**
 * __useCreateLaunchSectionMutation__
 *
 * To run a mutation, you first call `useCreateLaunchSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaunchSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaunchSectionMutation, { data, loading, error }] = useCreateLaunchSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLaunchSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLaunchSectionMutation, Types.CreateLaunchSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLaunchSectionMutation, Types.CreateLaunchSectionMutationVariables>(CreateLaunchSectionDocument, options);
      }
export type CreateLaunchSectionMutationHookResult = ReturnType<typeof useCreateLaunchSectionMutation>;
export type CreateLaunchSectionMutationResult = Apollo.MutationResult<Types.CreateLaunchSectionMutation>;
export type CreateLaunchSectionMutationOptions = Apollo.BaseMutationOptions<Types.CreateLaunchSectionMutation, Types.CreateLaunchSectionMutationVariables>;
export const CreateOrganizationStageDocument = gql`
    mutation CreateOrganizationStage($name: String!) {
  createOrganizationStage(name: $name) {
    id
    stages {
      id
      name
    }
  }
}
    `;
export type CreateOrganizationStageMutationFn = Apollo.MutationFunction<Types.CreateOrganizationStageMutation, Types.CreateOrganizationStageMutationVariables>;

/**
 * __useCreateOrganizationStageMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationStageMutation, { data, loading, error }] = useCreateOrganizationStageMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOrganizationStageMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationStageMutation, Types.CreateOrganizationStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationStageMutation, Types.CreateOrganizationStageMutationVariables>(CreateOrganizationStageDocument, options);
      }
export type CreateOrganizationStageMutationHookResult = ReturnType<typeof useCreateOrganizationStageMutation>;
export type CreateOrganizationStageMutationResult = Apollo.MutationResult<Types.CreateOrganizationStageMutation>;
export type CreateOrganizationStageMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationStageMutation, Types.CreateOrganizationStageMutationVariables>;
export const CreateTemplateFromLaunchDocument = gql`
    mutation CreateTemplateFromLaunch($input: CreateTemplateFromLaunchInput!) {
  createTemplateFromLaunch(input: $input) {
    id
    name
    description
    organizationId
  }
}
    `;
export type CreateTemplateFromLaunchMutationFn = Apollo.MutationFunction<Types.CreateTemplateFromLaunchMutation, Types.CreateTemplateFromLaunchMutationVariables>;

/**
 * __useCreateTemplateFromLaunchMutation__
 *
 * To run a mutation, you first call `useCreateTemplateFromLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateFromLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateFromLaunchMutation, { data, loading, error }] = useCreateTemplateFromLaunchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateFromLaunchMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTemplateFromLaunchMutation, Types.CreateTemplateFromLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTemplateFromLaunchMutation, Types.CreateTemplateFromLaunchMutationVariables>(CreateTemplateFromLaunchDocument, options);
      }
export type CreateTemplateFromLaunchMutationHookResult = ReturnType<typeof useCreateTemplateFromLaunchMutation>;
export type CreateTemplateFromLaunchMutationResult = Apollo.MutationResult<Types.CreateTemplateFromLaunchMutation>;
export type CreateTemplateFromLaunchMutationOptions = Apollo.BaseMutationOptions<Types.CreateTemplateFromLaunchMutation, Types.CreateTemplateFromLaunchMutationVariables>;
export const DuplicateLaunchDocument = gql`
    mutation DuplicateLaunch($input: DuplicateLaunchInput!) {
  duplicateLaunch(input: $input) {
    ...LaunchesSceneLaunch
  }
}
    ${LaunchesSceneLaunchFragmentDoc}`;
export type DuplicateLaunchMutationFn = Apollo.MutationFunction<Types.DuplicateLaunchMutation, Types.DuplicateLaunchMutationVariables>;

/**
 * __useDuplicateLaunchMutation__
 *
 * To run a mutation, you first call `useDuplicateLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateLaunchMutation, { data, loading, error }] = useDuplicateLaunchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateLaunchMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateLaunchMutation, Types.DuplicateLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateLaunchMutation, Types.DuplicateLaunchMutationVariables>(DuplicateLaunchDocument, options);
      }
export type DuplicateLaunchMutationHookResult = ReturnType<typeof useDuplicateLaunchMutation>;
export type DuplicateLaunchMutationResult = Apollo.MutationResult<Types.DuplicateLaunchMutation>;
export type DuplicateLaunchMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateLaunchMutation, Types.DuplicateLaunchMutationVariables>;
export const ExchangeCodeForTokensConfluenceDocument = gql`
    mutation ExchangeCodeForTokensConfluence($code: String!) {
  exchangeCodeForTokensConfluence(code: $code)
}
    `;
export type ExchangeCodeForTokensConfluenceMutationFn = Apollo.MutationFunction<Types.ExchangeCodeForTokensConfluenceMutation, Types.ExchangeCodeForTokensConfluenceMutationVariables>;

/**
 * __useExchangeCodeForTokensConfluenceMutation__
 *
 * To run a mutation, you first call `useExchangeCodeForTokensConfluenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeCodeForTokensConfluenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeCodeForTokensConfluenceMutation, { data, loading, error }] = useExchangeCodeForTokensConfluenceMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useExchangeCodeForTokensConfluenceMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExchangeCodeForTokensConfluenceMutation, Types.ExchangeCodeForTokensConfluenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExchangeCodeForTokensConfluenceMutation, Types.ExchangeCodeForTokensConfluenceMutationVariables>(ExchangeCodeForTokensConfluenceDocument, options);
      }
export type ExchangeCodeForTokensConfluenceMutationHookResult = ReturnType<typeof useExchangeCodeForTokensConfluenceMutation>;
export type ExchangeCodeForTokensConfluenceMutationResult = Apollo.MutationResult<Types.ExchangeCodeForTokensConfluenceMutation>;
export type ExchangeCodeForTokensConfluenceMutationOptions = Apollo.BaseMutationOptions<Types.ExchangeCodeForTokensConfluenceMutation, Types.ExchangeCodeForTokensConfluenceMutationVariables>;
export const ExchangeCodeForTokensGoogleDocument = gql`
    mutation ExchangeCodeForTokensGoogle($code: String!) {
  exchangeCodeForTokensGoogle(code: $code)
}
    `;
export type ExchangeCodeForTokensGoogleMutationFn = Apollo.MutationFunction<Types.ExchangeCodeForTokensGoogleMutation, Types.ExchangeCodeForTokensGoogleMutationVariables>;

/**
 * __useExchangeCodeForTokensGoogleMutation__
 *
 * To run a mutation, you first call `useExchangeCodeForTokensGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeCodeForTokensGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeCodeForTokensGoogleMutation, { data, loading, error }] = useExchangeCodeForTokensGoogleMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useExchangeCodeForTokensGoogleMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExchangeCodeForTokensGoogleMutation, Types.ExchangeCodeForTokensGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExchangeCodeForTokensGoogleMutation, Types.ExchangeCodeForTokensGoogleMutationVariables>(ExchangeCodeForTokensGoogleDocument, options);
      }
export type ExchangeCodeForTokensGoogleMutationHookResult = ReturnType<typeof useExchangeCodeForTokensGoogleMutation>;
export type ExchangeCodeForTokensGoogleMutationResult = Apollo.MutationResult<Types.ExchangeCodeForTokensGoogleMutation>;
export type ExchangeCodeForTokensGoogleMutationOptions = Apollo.BaseMutationOptions<Types.ExchangeCodeForTokensGoogleMutation, Types.ExchangeCodeForTokensGoogleMutationVariables>;
export const GetExpertHelpDocument = gql`
    mutation GetExpertHelp($input: LaunchModuleHelpInput!) {
  getExpertHelp(input: $input)
}
    `;
export type GetExpertHelpMutationFn = Apollo.MutationFunction<Types.GetExpertHelpMutation, Types.GetExpertHelpMutationVariables>;

/**
 * __useGetExpertHelpMutation__
 *
 * To run a mutation, you first call `useGetExpertHelpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetExpertHelpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getExpertHelpMutation, { data, loading, error }] = useGetExpertHelpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExpertHelpMutation(baseOptions?: Apollo.MutationHookOptions<Types.GetExpertHelpMutation, Types.GetExpertHelpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GetExpertHelpMutation, Types.GetExpertHelpMutationVariables>(GetExpertHelpDocument, options);
      }
export type GetExpertHelpMutationHookResult = ReturnType<typeof useGetExpertHelpMutation>;
export type GetExpertHelpMutationResult = Apollo.MutationResult<Types.GetExpertHelpMutation>;
export type GetExpertHelpMutationOptions = Apollo.BaseMutationOptions<Types.GetExpertHelpMutation, Types.GetExpertHelpMutationVariables>;
export const RemoveLaunchDocument = gql`
    mutation RemoveLaunch($id: String!) {
  removeLaunch(id: $id) {
    id
  }
}
    `;
export type RemoveLaunchMutationFn = Apollo.MutationFunction<Types.RemoveLaunchMutation, Types.RemoveLaunchMutationVariables>;

/**
 * __useRemoveLaunchMutation__
 *
 * To run a mutation, you first call `useRemoveLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLaunchMutation, { data, loading, error }] = useRemoveLaunchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLaunchMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveLaunchMutation, Types.RemoveLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveLaunchMutation, Types.RemoveLaunchMutationVariables>(RemoveLaunchDocument, options);
      }
export type RemoveLaunchMutationHookResult = ReturnType<typeof useRemoveLaunchMutation>;
export type RemoveLaunchMutationResult = Apollo.MutationResult<Types.RemoveLaunchMutation>;
export type RemoveLaunchMutationOptions = Apollo.BaseMutationOptions<Types.RemoveLaunchMutation, Types.RemoveLaunchMutationVariables>;
export const RemoveOrganizationStageDocument = gql`
    mutation RemoveOrganizationStage($stageId: String!) {
  removeOrganizationStage(stageId: $stageId) {
    id
    stages {
      id
      name
    }
  }
}
    `;
export type RemoveOrganizationStageMutationFn = Apollo.MutationFunction<Types.RemoveOrganizationStageMutation, Types.RemoveOrganizationStageMutationVariables>;

/**
 * __useRemoveOrganizationStageMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationStageMutation, { data, loading, error }] = useRemoveOrganizationStageMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useRemoveOrganizationStageMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveOrganizationStageMutation, Types.RemoveOrganizationStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveOrganizationStageMutation, Types.RemoveOrganizationStageMutationVariables>(RemoveOrganizationStageDocument, options);
      }
export type RemoveOrganizationStageMutationHookResult = ReturnType<typeof useRemoveOrganizationStageMutation>;
export type RemoveOrganizationStageMutationResult = Apollo.MutationResult<Types.RemoveOrganizationStageMutation>;
export type RemoveOrganizationStageMutationOptions = Apollo.BaseMutationOptions<Types.RemoveOrganizationStageMutation, Types.RemoveOrganizationStageMutationVariables>;
export const RemoveTemplateDocument = gql`
    mutation RemoveTemplate($id: String!) {
  removeTemplate(id: $id) {
    id
  }
}
    `;
export type RemoveTemplateMutationFn = Apollo.MutationFunction<Types.RemoveTemplateMutation, Types.RemoveTemplateMutationVariables>;

/**
 * __useRemoveTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTemplateMutation, { data, loading, error }] = useRemoveTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveTemplateMutation, Types.RemoveTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveTemplateMutation, Types.RemoveTemplateMutationVariables>(RemoveTemplateDocument, options);
      }
export type RemoveTemplateMutationHookResult = ReturnType<typeof useRemoveTemplateMutation>;
export type RemoveTemplateMutationResult = Apollo.MutationResult<Types.RemoveTemplateMutation>;
export type RemoveTemplateMutationOptions = Apollo.BaseMutationOptions<Types.RemoveTemplateMutation, Types.RemoveTemplateMutationVariables>;
export const ToggleLaunchPrivateDocument = gql`
    mutation ToggleLaunchPrivate($input: ToggleLaunchPrivateInput!) {
  toggleLaunchPrivate(input: $input)
}
    `;
export type ToggleLaunchPrivateMutationFn = Apollo.MutationFunction<Types.ToggleLaunchPrivateMutation, Types.ToggleLaunchPrivateMutationVariables>;

/**
 * __useToggleLaunchPrivateMutation__
 *
 * To run a mutation, you first call `useToggleLaunchPrivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLaunchPrivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLaunchPrivateMutation, { data, loading, error }] = useToggleLaunchPrivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleLaunchPrivateMutation(baseOptions?: Apollo.MutationHookOptions<Types.ToggleLaunchPrivateMutation, Types.ToggleLaunchPrivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ToggleLaunchPrivateMutation, Types.ToggleLaunchPrivateMutationVariables>(ToggleLaunchPrivateDocument, options);
      }
export type ToggleLaunchPrivateMutationHookResult = ReturnType<typeof useToggleLaunchPrivateMutation>;
export type ToggleLaunchPrivateMutationResult = Apollo.MutationResult<Types.ToggleLaunchPrivateMutation>;
export type ToggleLaunchPrivateMutationOptions = Apollo.BaseMutationOptions<Types.ToggleLaunchPrivateMutation, Types.ToggleLaunchPrivateMutationVariables>;
export const UpdateLaunchCopilotOptionsDocument = gql`
    mutation UpdateLaunchCopilotOptions($input: UpdateLaunchCopilotOptionsInput!) {
  updateCopilotOptions(input: $input) {
    id
    ...LaunchCopilotOptions
  }
}
    ${LaunchCopilotOptionsFragmentDoc}`;
export type UpdateLaunchCopilotOptionsMutationFn = Apollo.MutationFunction<Types.UpdateLaunchCopilotOptionsMutation, Types.UpdateLaunchCopilotOptionsMutationVariables>;

/**
 * __useUpdateLaunchCopilotOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchCopilotOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchCopilotOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchCopilotOptionsMutation, { data, loading, error }] = useUpdateLaunchCopilotOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchCopilotOptionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchCopilotOptionsMutation, Types.UpdateLaunchCopilotOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchCopilotOptionsMutation, Types.UpdateLaunchCopilotOptionsMutationVariables>(UpdateLaunchCopilotOptionsDocument, options);
      }
export type UpdateLaunchCopilotOptionsMutationHookResult = ReturnType<typeof useUpdateLaunchCopilotOptionsMutation>;
export type UpdateLaunchCopilotOptionsMutationResult = Apollo.MutationResult<Types.UpdateLaunchCopilotOptionsMutation>;
export type UpdateLaunchCopilotOptionsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchCopilotOptionsMutation, Types.UpdateLaunchCopilotOptionsMutationVariables>;
export const UpdateLaunchDetailsDocument = gql`
    mutation UpdateLaunchDetails($input: UpdateLaunchDetailsInput!) {
  updateLaunchDetails(input: $input) {
    id
    ...LaunchInfo
    ...LaunchProductTasksData
  }
}
    ${LaunchInfoFragmentDoc}
${LaunchProductTasksDataFragmentDoc}`;
export type UpdateLaunchDetailsMutationFn = Apollo.MutationFunction<Types.UpdateLaunchDetailsMutation, Types.UpdateLaunchDetailsMutationVariables>;

/**
 * __useUpdateLaunchDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchDetailsMutation, { data, loading, error }] = useUpdateLaunchDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchDetailsMutation, Types.UpdateLaunchDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchDetailsMutation, Types.UpdateLaunchDetailsMutationVariables>(UpdateLaunchDetailsDocument, options);
      }
export type UpdateLaunchDetailsMutationHookResult = ReturnType<typeof useUpdateLaunchDetailsMutation>;
export type UpdateLaunchDetailsMutationResult = Apollo.MutationResult<Types.UpdateLaunchDetailsMutation>;
export type UpdateLaunchDetailsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchDetailsMutation, Types.UpdateLaunchDetailsMutationVariables>;
export const UpdateLaunchPublicPageConfigDocument = gql`
    mutation UpdateLaunchPublicPageConfig($input: UpdateLaunchPublicPageConfigInput!) {
  updateLaunchPublicPageConfig(input: $input) {
    id
    publicPageConfig {
      ...LaunchPublicPageConfig
    }
  }
}
    ${LaunchPublicPageConfigFragmentDoc}`;
export type UpdateLaunchPublicPageConfigMutationFn = Apollo.MutationFunction<Types.UpdateLaunchPublicPageConfigMutation, Types.UpdateLaunchPublicPageConfigMutationVariables>;

/**
 * __useUpdateLaunchPublicPageConfigMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchPublicPageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchPublicPageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchPublicPageConfigMutation, { data, loading, error }] = useUpdateLaunchPublicPageConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchPublicPageConfigMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchPublicPageConfigMutation, Types.UpdateLaunchPublicPageConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchPublicPageConfigMutation, Types.UpdateLaunchPublicPageConfigMutationVariables>(UpdateLaunchPublicPageConfigDocument, options);
      }
export type UpdateLaunchPublicPageConfigMutationHookResult = ReturnType<typeof useUpdateLaunchPublicPageConfigMutation>;
export type UpdateLaunchPublicPageConfigMutationResult = Apollo.MutationResult<Types.UpdateLaunchPublicPageConfigMutation>;
export type UpdateLaunchPublicPageConfigMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchPublicPageConfigMutation, Types.UpdateLaunchPublicPageConfigMutationVariables>;
export const UpdateLaunchViewerDocument = gql`
    mutation UpdateLaunchViewer($launchId: String!) {
  updateLaunchViewer(launchId: $launchId) {
    id
    ...LaunchViewers
  }
}
    ${LaunchViewersFragmentDoc}`;
export type UpdateLaunchViewerMutationFn = Apollo.MutationFunction<Types.UpdateLaunchViewerMutation, Types.UpdateLaunchViewerMutationVariables>;

/**
 * __useUpdateLaunchViewerMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchViewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchViewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchViewerMutation, { data, loading, error }] = useUpdateLaunchViewerMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useUpdateLaunchViewerMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchViewerMutation, Types.UpdateLaunchViewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchViewerMutation, Types.UpdateLaunchViewerMutationVariables>(UpdateLaunchViewerDocument, options);
      }
export type UpdateLaunchViewerMutationHookResult = ReturnType<typeof useUpdateLaunchViewerMutation>;
export type UpdateLaunchViewerMutationResult = Apollo.MutationResult<Types.UpdateLaunchViewerMutation>;
export type UpdateLaunchViewerMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchViewerMutation, Types.UpdateLaunchViewerMutationVariables>;
export const GetConfluenceAuthUrlDocument = gql`
    query GetConfluenceAuthUrl {
  getConfluenceAuthUrl
}
    `;

/**
 * __useGetConfluenceAuthUrlQuery__
 *
 * To run a query within a React component, call `useGetConfluenceAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfluenceAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfluenceAuthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfluenceAuthUrlQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetConfluenceAuthUrlQuery, Types.GetConfluenceAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetConfluenceAuthUrlQuery, Types.GetConfluenceAuthUrlQueryVariables>(GetConfluenceAuthUrlDocument, options);
      }
export function useGetConfluenceAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetConfluenceAuthUrlQuery, Types.GetConfluenceAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetConfluenceAuthUrlQuery, Types.GetConfluenceAuthUrlQueryVariables>(GetConfluenceAuthUrlDocument, options);
        }
export type GetConfluenceAuthUrlQueryHookResult = ReturnType<typeof useGetConfluenceAuthUrlQuery>;
export type GetConfluenceAuthUrlLazyQueryHookResult = ReturnType<typeof useGetConfluenceAuthUrlLazyQuery>;
export type GetConfluenceAuthUrlQueryResult = Apollo.QueryResult<Types.GetConfluenceAuthUrlQuery, Types.GetConfluenceAuthUrlQueryVariables>;
export const GetGoogleAuthUrlDocument = gql`
    query GetGoogleAuthUrl {
  getGoogleAuthUrl
}
    `;

/**
 * __useGetGoogleAuthUrlQuery__
 *
 * To run a query within a React component, call `useGetGoogleAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleAuthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleAuthUrlQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetGoogleAuthUrlQuery, Types.GetGoogleAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGoogleAuthUrlQuery, Types.GetGoogleAuthUrlQueryVariables>(GetGoogleAuthUrlDocument, options);
      }
export function useGetGoogleAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGoogleAuthUrlQuery, Types.GetGoogleAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGoogleAuthUrlQuery, Types.GetGoogleAuthUrlQueryVariables>(GetGoogleAuthUrlDocument, options);
        }
export type GetGoogleAuthUrlQueryHookResult = ReturnType<typeof useGetGoogleAuthUrlQuery>;
export type GetGoogleAuthUrlLazyQueryHookResult = ReturnType<typeof useGetGoogleAuthUrlLazyQuery>;
export type GetGoogleAuthUrlQueryResult = Apollo.QueryResult<Types.GetGoogleAuthUrlQuery, Types.GetGoogleAuthUrlQueryVariables>;
export const GetLaunchWithUsersDocument = gql`
    query GetLaunchWithUsers($id: String!) {
  launch(id: $id) {
    id
    ...LaunchWithUsers
  }
}
    ${LaunchWithUsersFragmentDoc}`;

/**
 * __useGetLaunchWithUsersQuery__
 *
 * To run a query within a React component, call `useGetLaunchWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaunchWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaunchWithUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLaunchWithUsersQuery(baseOptions: Apollo.QueryHookOptions<Types.GetLaunchWithUsersQuery, Types.GetLaunchWithUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLaunchWithUsersQuery, Types.GetLaunchWithUsersQueryVariables>(GetLaunchWithUsersDocument, options);
      }
export function useGetLaunchWithUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLaunchWithUsersQuery, Types.GetLaunchWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLaunchWithUsersQuery, Types.GetLaunchWithUsersQueryVariables>(GetLaunchWithUsersDocument, options);
        }
export type GetLaunchWithUsersQueryHookResult = ReturnType<typeof useGetLaunchWithUsersQuery>;
export type GetLaunchWithUsersLazyQueryHookResult = ReturnType<typeof useGetLaunchWithUsersLazyQuery>;
export type GetLaunchWithUsersQueryResult = Apollo.QueryResult<Types.GetLaunchWithUsersQuery, Types.GetLaunchWithUsersQueryVariables>;
export const LaunchDocument = gql`
    query Launch($id: String!) {
  launch(id: $id) {
    ...LaunchQuery
  }
}
    ${LaunchQueryFragmentDoc}`;

/**
 * __useLaunchQuery__
 *
 * To run a query within a React component, call `useLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchQuery, Types.LaunchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchQuery, Types.LaunchQueryVariables>(LaunchDocument, options);
      }
export function useLaunchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchQuery, Types.LaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchQuery, Types.LaunchQueryVariables>(LaunchDocument, options);
        }
export type LaunchQueryHookResult = ReturnType<typeof useLaunchQuery>;
export type LaunchLazyQueryHookResult = ReturnType<typeof useLaunchLazyQuery>;
export type LaunchQueryResult = Apollo.QueryResult<Types.LaunchQuery, Types.LaunchQueryVariables>;
export const LaunchConnectionsDocument = gql`
    query LaunchConnections {
  launches {
    ...LaunchConnection
  }
}
    ${LaunchConnectionFragmentDoc}`;

/**
 * __useLaunchConnectionsQuery__
 *
 * To run a query within a React component, call `useLaunchConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaunchConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchConnectionsQuery, Types.LaunchConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchConnectionsQuery, Types.LaunchConnectionsQueryVariables>(LaunchConnectionsDocument, options);
      }
export function useLaunchConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchConnectionsQuery, Types.LaunchConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchConnectionsQuery, Types.LaunchConnectionsQueryVariables>(LaunchConnectionsDocument, options);
        }
export type LaunchConnectionsQueryHookResult = ReturnType<typeof useLaunchConnectionsQuery>;
export type LaunchConnectionsLazyQueryHookResult = ReturnType<typeof useLaunchConnectionsLazyQuery>;
export type LaunchConnectionsQueryResult = Apollo.QueryResult<Types.LaunchConnectionsQuery, Types.LaunchConnectionsQueryVariables>;
export const LaunchContentDocument = gql`
    query LaunchContent($launchId: String!) {
  launchContent(launchId: $launchId) {
    ...LaunchContent
  }
}
    ${LaunchContentFragmentDoc}`;

/**
 * __useLaunchContentQuery__
 *
 * To run a query within a React component, call `useLaunchContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchContentQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchContentQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchContentQuery, Types.LaunchContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchContentQuery, Types.LaunchContentQueryVariables>(LaunchContentDocument, options);
      }
export function useLaunchContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchContentQuery, Types.LaunchContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchContentQuery, Types.LaunchContentQueryVariables>(LaunchContentDocument, options);
        }
export type LaunchContentQueryHookResult = ReturnType<typeof useLaunchContentQuery>;
export type LaunchContentLazyQueryHookResult = ReturnType<typeof useLaunchContentLazyQuery>;
export type LaunchContentQueryResult = Apollo.QueryResult<Types.LaunchContentQuery, Types.LaunchContentQueryVariables>;
export const LaunchForExportDocument = gql`
    query LaunchForExport($launchId: String!, $filter: FilterTasksInput, $sort: SortTasksInput) {
  launch(id: $launchId) {
    id
    name
    launchType {
      id
      name
    }
    launchTier
    launchDate
    launchSections {
      id
      name
      launchModules {
        id
        name
        editor
        userInput {
          id
          WYSIWYG_EDITOR
          ...BudgetModuleUserInput
          ...KPIModuleUserInput
          ...LaunchTeamModuleUserInput
          ...PositioningModuleUserInputNew
          ...CopyAndAssetsModuleUserInput
        }
      }
    }
  }
  launchProgress(launchId: $launchId) {
    ...LaunchProgress
  }
  paginatedTasks(filter: $filter, sort: $sort, pagination: {limit: 3, page: 1}) {
    docs {
      ...TaskPreview
      subtasks(filter: $filter) {
        ...TaskPreview
      }
    }
  }
  gtmTimeline(launchId: $launchId) {
    launchId
    channels {
      ...Channel
    }
    milestones {
      ...Milestone
    }
  }
}
    ${BudgetModuleUserInputFragmentDoc}
${KpiModuleUserInputFragmentDoc}
${LaunchTeamModuleUserInputFragmentDoc}
${PositioningModuleUserInputNewFragmentDoc}
${CopyAndAssetsModuleUserInputFragmentDoc}
${LaunchProgressFragmentDoc}
${TaskPreviewFragmentDoc}
${ChannelFragmentDoc}
${MilestoneFragmentDoc}`;

/**
 * __useLaunchForExportQuery__
 *
 * To run a query within a React component, call `useLaunchForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchForExportQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLaunchForExportQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchForExportQuery, Types.LaunchForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchForExportQuery, Types.LaunchForExportQueryVariables>(LaunchForExportDocument, options);
      }
export function useLaunchForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchForExportQuery, Types.LaunchForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchForExportQuery, Types.LaunchForExportQueryVariables>(LaunchForExportDocument, options);
        }
export type LaunchForExportQueryHookResult = ReturnType<typeof useLaunchForExportQuery>;
export type LaunchForExportLazyQueryHookResult = ReturnType<typeof useLaunchForExportLazyQuery>;
export type LaunchForExportQueryResult = Apollo.QueryResult<Types.LaunchForExportQuery, Types.LaunchForExportQueryVariables>;
export const LaunchForExportToGoogleDocsDocument = gql`
    query LaunchForExportToGoogleDocs($launchId: String!) {
  launchContent(launchId: $launchId) {
    ...LaunchContentForExport
  }
  gtmTimeline(launchId: $launchId) {
    launchId
    channels {
      ...Channel
    }
    milestones {
      ...Milestone
    }
  }
}
    ${LaunchContentForExportFragmentDoc}
${ChannelFragmentDoc}
${MilestoneFragmentDoc}`;

/**
 * __useLaunchForExportToGoogleDocsQuery__
 *
 * To run a query within a React component, call `useLaunchForExportToGoogleDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchForExportToGoogleDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchForExportToGoogleDocsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchForExportToGoogleDocsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchForExportToGoogleDocsQuery, Types.LaunchForExportToGoogleDocsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchForExportToGoogleDocsQuery, Types.LaunchForExportToGoogleDocsQueryVariables>(LaunchForExportToGoogleDocsDocument, options);
      }
export function useLaunchForExportToGoogleDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchForExportToGoogleDocsQuery, Types.LaunchForExportToGoogleDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchForExportToGoogleDocsQuery, Types.LaunchForExportToGoogleDocsQueryVariables>(LaunchForExportToGoogleDocsDocument, options);
        }
export type LaunchForExportToGoogleDocsQueryHookResult = ReturnType<typeof useLaunchForExportToGoogleDocsQuery>;
export type LaunchForExportToGoogleDocsLazyQueryHookResult = ReturnType<typeof useLaunchForExportToGoogleDocsLazyQuery>;
export type LaunchForExportToGoogleDocsQueryResult = Apollo.QueryResult<Types.LaunchForExportToGoogleDocsQuery, Types.LaunchForExportToGoogleDocsQueryVariables>;
export const LaunchForImportModuleDocument = gql`
    query LaunchForImportModule($id: String!) {
  launch(id: $id) {
    ...LaunchForImportModule
    launchSections {
      id
      name
      launchModules(filter: {}) {
        ...ModuleForImport
      }
    }
  }
}
    ${LaunchForImportModuleFragmentDoc}
${ModuleForImportFragmentDoc}`;

/**
 * __useLaunchForImportModuleQuery__
 *
 * To run a query within a React component, call `useLaunchForImportModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchForImportModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchForImportModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchForImportModuleQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchForImportModuleQuery, Types.LaunchForImportModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchForImportModuleQuery, Types.LaunchForImportModuleQueryVariables>(LaunchForImportModuleDocument, options);
      }
export function useLaunchForImportModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchForImportModuleQuery, Types.LaunchForImportModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchForImportModuleQuery, Types.LaunchForImportModuleQueryVariables>(LaunchForImportModuleDocument, options);
        }
export type LaunchForImportModuleQueryHookResult = ReturnType<typeof useLaunchForImportModuleQuery>;
export type LaunchForImportModuleLazyQueryHookResult = ReturnType<typeof useLaunchForImportModuleLazyQuery>;
export type LaunchForImportModuleQueryResult = Apollo.QueryResult<Types.LaunchForImportModuleQuery, Types.LaunchForImportModuleQueryVariables>;
export const LaunchProgressDocument = gql`
    query LaunchProgress($launchId: String!) {
  launchProgress(launchId: $launchId) {
    ...LaunchProgress
  }
}
    ${LaunchProgressFragmentDoc}`;

/**
 * __useLaunchProgressQuery__
 *
 * To run a query within a React component, call `useLaunchProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchProgressQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchProgressQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchProgressQuery, Types.LaunchProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchProgressQuery, Types.LaunchProgressQueryVariables>(LaunchProgressDocument, options);
      }
export function useLaunchProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchProgressQuery, Types.LaunchProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchProgressQuery, Types.LaunchProgressQueryVariables>(LaunchProgressDocument, options);
        }
export type LaunchProgressQueryHookResult = ReturnType<typeof useLaunchProgressQuery>;
export type LaunchProgressLazyQueryHookResult = ReturnType<typeof useLaunchProgressLazyQuery>;
export type LaunchProgressQueryResult = Apollo.QueryResult<Types.LaunchProgressQuery, Types.LaunchProgressQueryVariables>;
export const LaunchPublicPageConfigDocument = gql`
    query LaunchPublicPageConfig($id: String!) {
  launch(id: $id) {
    id
    publicPageConfig {
      ...LaunchPublicPageConfig
    }
    launchSections {
      ...LaunchSection
    }
    modulesLaunchSections @client {
      ...LaunchSection
    }
    launchModules @client {
      ...LaunchModule
    }
  }
}
    ${LaunchPublicPageConfigFragmentDoc}
${LaunchSectionFragmentDoc}
${LaunchModuleFragmentDoc}`;

/**
 * __useLaunchPublicPageConfigQuery__
 *
 * To run a query within a React component, call `useLaunchPublicPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchPublicPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchPublicPageConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchPublicPageConfigQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchPublicPageConfigQuery, Types.LaunchPublicPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchPublicPageConfigQuery, Types.LaunchPublicPageConfigQueryVariables>(LaunchPublicPageConfigDocument, options);
      }
export function useLaunchPublicPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchPublicPageConfigQuery, Types.LaunchPublicPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchPublicPageConfigQuery, Types.LaunchPublicPageConfigQueryVariables>(LaunchPublicPageConfigDocument, options);
        }
export type LaunchPublicPageConfigQueryHookResult = ReturnType<typeof useLaunchPublicPageConfigQuery>;
export type LaunchPublicPageConfigLazyQueryHookResult = ReturnType<typeof useLaunchPublicPageConfigLazyQuery>;
export type LaunchPublicPageConfigQueryResult = Apollo.QueryResult<Types.LaunchPublicPageConfigQuery, Types.LaunchPublicPageConfigQueryVariables>;
export const LaunchesCountDocument = gql`
    query LaunchesCount {
  upcoming: paginatedLaunches(filter: {status: UPCOMING}) {
    totalDocs
  }
  past: paginatedLaunches(filter: {status: PAST}) {
    totalDocs
  }
}
    `;

/**
 * __useLaunchesCountQuery__
 *
 * To run a query within a React component, call `useLaunchesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaunchesCountQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchesCountQuery, Types.LaunchesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchesCountQuery, Types.LaunchesCountQueryVariables>(LaunchesCountDocument, options);
      }
export function useLaunchesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchesCountQuery, Types.LaunchesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchesCountQuery, Types.LaunchesCountQueryVariables>(LaunchesCountDocument, options);
        }
export type LaunchesCountQueryHookResult = ReturnType<typeof useLaunchesCountQuery>;
export type LaunchesCountLazyQueryHookResult = ReturnType<typeof useLaunchesCountLazyQuery>;
export type LaunchesCountQueryResult = Apollo.QueryResult<Types.LaunchesCountQuery, Types.LaunchesCountQueryVariables>;
export const LaunchesIdsAndNamesDocument = gql`
    query LaunchesIdsAndNames($pagination: PaginationInput, $filter: FilterLaunchInput, $sort: SortLaunchInput) {
  paginatedLaunches(filter: $filter, pagination: $pagination, sort: $sort) {
    docs {
      id
      ...LaunchIdAndName
    }
  }
}
    ${LaunchIdAndNameFragmentDoc}`;

/**
 * __useLaunchesIdsAndNamesQuery__
 *
 * To run a query within a React component, call `useLaunchesIdsAndNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchesIdsAndNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchesIdsAndNamesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLaunchesIdsAndNamesQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchesIdsAndNamesQuery, Types.LaunchesIdsAndNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchesIdsAndNamesQuery, Types.LaunchesIdsAndNamesQueryVariables>(LaunchesIdsAndNamesDocument, options);
      }
export function useLaunchesIdsAndNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchesIdsAndNamesQuery, Types.LaunchesIdsAndNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchesIdsAndNamesQuery, Types.LaunchesIdsAndNamesQueryVariables>(LaunchesIdsAndNamesDocument, options);
        }
export type LaunchesIdsAndNamesQueryHookResult = ReturnType<typeof useLaunchesIdsAndNamesQuery>;
export type LaunchesIdsAndNamesLazyQueryHookResult = ReturnType<typeof useLaunchesIdsAndNamesLazyQuery>;
export type LaunchesIdsAndNamesQueryResult = Apollo.QueryResult<Types.LaunchesIdsAndNamesQuery, Types.LaunchesIdsAndNamesQueryVariables>;
export const LaunchesNamesAndDatesDocument = gql`
    query LaunchesNamesAndDates($pagination: PaginationInput, $filter: FilterLaunchInput, $sort: SortLaunchInput) {
  paginatedLaunches(filter: $filter, pagination: $pagination, sort: $sort) {
    docs {
      id
      ...LaunchesNameAndDate
    }
  }
}
    ${LaunchesNameAndDateFragmentDoc}`;

/**
 * __useLaunchesNamesAndDatesQuery__
 *
 * To run a query within a React component, call `useLaunchesNamesAndDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchesNamesAndDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchesNamesAndDatesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLaunchesNamesAndDatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchesNamesAndDatesQuery, Types.LaunchesNamesAndDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchesNamesAndDatesQuery, Types.LaunchesNamesAndDatesQueryVariables>(LaunchesNamesAndDatesDocument, options);
      }
export function useLaunchesNamesAndDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchesNamesAndDatesQuery, Types.LaunchesNamesAndDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchesNamesAndDatesQuery, Types.LaunchesNamesAndDatesQueryVariables>(LaunchesNamesAndDatesDocument, options);
        }
export type LaunchesNamesAndDatesQueryHookResult = ReturnType<typeof useLaunchesNamesAndDatesQuery>;
export type LaunchesNamesAndDatesLazyQueryHookResult = ReturnType<typeof useLaunchesNamesAndDatesLazyQuery>;
export type LaunchesNamesAndDatesQueryResult = Apollo.QueryResult<Types.LaunchesNamesAndDatesQuery, Types.LaunchesNamesAndDatesQueryVariables>;
export const LaunchesPreviewForImportModuleDocument = gql`
    query LaunchesPreviewForImportModule($pagination: PaginationInput = {page: 1, limit: 15}, $filter: FilterLaunchInput, $sort: SortLaunchInput) {
  paginatedLaunches(pagination: $pagination, filter: $filter, sort: $sort) {
    docs {
      ...LaunchForImportModule
      launchSections {
        id
        name
        launchModules(filter: {}) {
          ...ModuleForImport
        }
      }
    }
    totalDocs
    totalPages
    hasNextPage
  }
}
    ${LaunchForImportModuleFragmentDoc}
${ModuleForImportFragmentDoc}`;

/**
 * __useLaunchesPreviewForImportModuleQuery__
 *
 * To run a query within a React component, call `useLaunchesPreviewForImportModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchesPreviewForImportModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchesPreviewForImportModuleQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLaunchesPreviewForImportModuleQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchesPreviewForImportModuleQuery, Types.LaunchesPreviewForImportModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchesPreviewForImportModuleQuery, Types.LaunchesPreviewForImportModuleQueryVariables>(LaunchesPreviewForImportModuleDocument, options);
      }
export function useLaunchesPreviewForImportModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchesPreviewForImportModuleQuery, Types.LaunchesPreviewForImportModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchesPreviewForImportModuleQuery, Types.LaunchesPreviewForImportModuleQueryVariables>(LaunchesPreviewForImportModuleDocument, options);
        }
export type LaunchesPreviewForImportModuleQueryHookResult = ReturnType<typeof useLaunchesPreviewForImportModuleQuery>;
export type LaunchesPreviewForImportModuleLazyQueryHookResult = ReturnType<typeof useLaunchesPreviewForImportModuleLazyQuery>;
export type LaunchesPreviewForImportModuleQueryResult = Apollo.QueryResult<Types.LaunchesPreviewForImportModuleQuery, Types.LaunchesPreviewForImportModuleQueryVariables>;
export const PaginatedLaunchesDocument = gql`
    query PaginatedLaunches($pagination: PaginationInput = {page: 1, limit: 15}, $filter: FilterLaunchInput = {status: UPCOMING}, $sort: SortLaunchInput) {
  paginatedLaunches(filter: $filter, pagination: $pagination, sort: $sort) {
    docs {
      ...LaunchesSceneLaunch
    }
    totalDocs
    totalPages
    hasNextPage
  }
}
    ${LaunchesSceneLaunchFragmentDoc}`;

/**
 * __usePaginatedLaunchesQuery__
 *
 * To run a query within a React component, call `usePaginatedLaunchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedLaunchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedLaunchesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedLaunchesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedLaunchesQuery, Types.PaginatedLaunchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedLaunchesQuery, Types.PaginatedLaunchesQueryVariables>(PaginatedLaunchesDocument, options);
      }
export function usePaginatedLaunchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedLaunchesQuery, Types.PaginatedLaunchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedLaunchesQuery, Types.PaginatedLaunchesQueryVariables>(PaginatedLaunchesDocument, options);
        }
export type PaginatedLaunchesQueryHookResult = ReturnType<typeof usePaginatedLaunchesQuery>;
export type PaginatedLaunchesLazyQueryHookResult = ReturnType<typeof usePaginatedLaunchesLazyQuery>;
export type PaginatedLaunchesQueryResult = Apollo.QueryResult<Types.PaginatedLaunchesQuery, Types.PaginatedLaunchesQueryVariables>;
export const PaginatedLaunchesInfoDocument = gql`
    query PaginatedLaunchesInfo($sort: SortLaunchInput, $filter: FilterLaunchInput, $pagination: PaginationInput) {
  paginatedLaunches(sort: $sort, filter: $filter, pagination: $pagination) {
    page
    totalPages
    docs {
      ...LaunchInfo
    }
  }
}
    ${LaunchInfoFragmentDoc}`;

/**
 * __usePaginatedLaunchesInfoQuery__
 *
 * To run a query within a React component, call `usePaginatedLaunchesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedLaunchesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedLaunchesInfoQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedLaunchesInfoQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedLaunchesInfoQuery, Types.PaginatedLaunchesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedLaunchesInfoQuery, Types.PaginatedLaunchesInfoQueryVariables>(PaginatedLaunchesInfoDocument, options);
      }
export function usePaginatedLaunchesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedLaunchesInfoQuery, Types.PaginatedLaunchesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedLaunchesInfoQuery, Types.PaginatedLaunchesInfoQueryVariables>(PaginatedLaunchesInfoDocument, options);
        }
export type PaginatedLaunchesInfoQueryHookResult = ReturnType<typeof usePaginatedLaunchesInfoQuery>;
export type PaginatedLaunchesInfoLazyQueryHookResult = ReturnType<typeof usePaginatedLaunchesInfoLazyQuery>;
export type PaginatedLaunchesInfoQueryResult = Apollo.QueryResult<Types.PaginatedLaunchesInfoQuery, Types.PaginatedLaunchesInfoQueryVariables>;
export const PublicLaunchPageLaunchDocument = gql`
    query PublicLaunchPageLaunch {
  publicLaunchPageLaunch {
    ...PublicLaunchPageLayoutLaunch
    ...PublicLaunchPageLaunch
    ...LaunchCustomProgress
  }
}
    ${PublicLaunchPageLayoutLaunchFragmentDoc}
${PublicLaunchPageLaunchFragmentDoc}
${LaunchCustomProgressFragmentDoc}`;

/**
 * __usePublicLaunchPageLaunchQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageLaunchQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchPageLaunchQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageLaunchQuery, Types.PublicLaunchPageLaunchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageLaunchQuery, Types.PublicLaunchPageLaunchQueryVariables>(PublicLaunchPageLaunchDocument, options);
      }
export function usePublicLaunchPageLaunchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageLaunchQuery, Types.PublicLaunchPageLaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageLaunchQuery, Types.PublicLaunchPageLaunchQueryVariables>(PublicLaunchPageLaunchDocument, options);
        }
export type PublicLaunchPageLaunchQueryHookResult = ReturnType<typeof usePublicLaunchPageLaunchQuery>;
export type PublicLaunchPageLaunchLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageLaunchLazyQuery>;
export type PublicLaunchPageLaunchQueryResult = Apollo.QueryResult<Types.PublicLaunchPageLaunchQuery, Types.PublicLaunchPageLaunchQueryVariables>;
export const PublicLaunchPageLaunchProgressDocument = gql`
    query PublicLaunchPageLaunchProgress {
  publicLaunchPageLaunchProgress {
    ...LaunchProgress
  }
}
    ${LaunchProgressFragmentDoc}`;

/**
 * __usePublicLaunchPageLaunchProgressQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageLaunchProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageLaunchProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageLaunchProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchPageLaunchProgressQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageLaunchProgressQuery, Types.PublicLaunchPageLaunchProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageLaunchProgressQuery, Types.PublicLaunchPageLaunchProgressQueryVariables>(PublicLaunchPageLaunchProgressDocument, options);
      }
export function usePublicLaunchPageLaunchProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageLaunchProgressQuery, Types.PublicLaunchPageLaunchProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageLaunchProgressQuery, Types.PublicLaunchPageLaunchProgressQueryVariables>(PublicLaunchPageLaunchProgressDocument, options);
        }
export type PublicLaunchPageLaunchProgressQueryHookResult = ReturnType<typeof usePublicLaunchPageLaunchProgressQuery>;
export type PublicLaunchPageLaunchProgressLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageLaunchProgressLazyQuery>;
export type PublicLaunchPageLaunchProgressQueryResult = Apollo.QueryResult<Types.PublicLaunchPageLaunchProgressQuery, Types.PublicLaunchPageLaunchProgressQueryVariables>;
export const PublicLaunchPageLayoutLaunchDocument = gql`
    query PublicLaunchPageLayoutLaunch {
  publicLaunchPageLaunch {
    ...PublicLaunchPageLayoutLaunch
  }
}
    ${PublicLaunchPageLayoutLaunchFragmentDoc}`;

/**
 * __usePublicLaunchPageLayoutLaunchQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageLayoutLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageLayoutLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageLayoutLaunchQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchPageLayoutLaunchQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageLayoutLaunchQuery, Types.PublicLaunchPageLayoutLaunchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageLayoutLaunchQuery, Types.PublicLaunchPageLayoutLaunchQueryVariables>(PublicLaunchPageLayoutLaunchDocument, options);
      }
export function usePublicLaunchPageLayoutLaunchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageLayoutLaunchQuery, Types.PublicLaunchPageLayoutLaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageLayoutLaunchQuery, Types.PublicLaunchPageLayoutLaunchQueryVariables>(PublicLaunchPageLayoutLaunchDocument, options);
        }
export type PublicLaunchPageLayoutLaunchQueryHookResult = ReturnType<typeof usePublicLaunchPageLayoutLaunchQuery>;
export type PublicLaunchPageLayoutLaunchLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageLayoutLaunchLazyQuery>;
export type PublicLaunchPageLayoutLaunchQueryResult = Apollo.QueryResult<Types.PublicLaunchPageLayoutLaunchQuery, Types.PublicLaunchPageLayoutLaunchQueryVariables>;
export const CreateMeasurementsIntegrationMetricDocument = gql`
    mutation CreateMeasurementsIntegrationMetric($input: CreateMeasurementIntegrationMetricInput!) {
  createMeasurementIntegrationsMetric(input: $input) {
    id
    ownerId
    organizationId
    integrationType
    measurementsIntegrationId
    eventName
    filters {
      parameter
      parameterValue
    }
  }
}
    `;
export type CreateMeasurementsIntegrationMetricMutationFn = Apollo.MutationFunction<Types.CreateMeasurementsIntegrationMetricMutation, Types.CreateMeasurementsIntegrationMetricMutationVariables>;

/**
 * __useCreateMeasurementsIntegrationMetricMutation__
 *
 * To run a mutation, you first call `useCreateMeasurementsIntegrationMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasurementsIntegrationMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasurementsIntegrationMetricMutation, { data, loading, error }] = useCreateMeasurementsIntegrationMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeasurementsIntegrationMetricMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMeasurementsIntegrationMetricMutation, Types.CreateMeasurementsIntegrationMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMeasurementsIntegrationMetricMutation, Types.CreateMeasurementsIntegrationMetricMutationVariables>(CreateMeasurementsIntegrationMetricDocument, options);
      }
export type CreateMeasurementsIntegrationMetricMutationHookResult = ReturnType<typeof useCreateMeasurementsIntegrationMetricMutation>;
export type CreateMeasurementsIntegrationMetricMutationResult = Apollo.MutationResult<Types.CreateMeasurementsIntegrationMetricMutation>;
export type CreateMeasurementsIntegrationMetricMutationOptions = Apollo.BaseMutationOptions<Types.CreateMeasurementsIntegrationMetricMutation, Types.CreateMeasurementsIntegrationMetricMutationVariables>;
export const CreateMixpanelIntegrationDocument = gql`
    mutation CreateMixpanelIntegration($projectId: String!, $username: String!, $password: String!) {
  createMixpanelIntegration(
    projectId: $projectId
    username: $username
    password: $password
  ) {
    ...MixpanelIntegration
  }
}
    ${MixpanelIntegrationFragmentDoc}`;
export type CreateMixpanelIntegrationMutationFn = Apollo.MutationFunction<Types.CreateMixpanelIntegrationMutation, Types.CreateMixpanelIntegrationMutationVariables>;

/**
 * __useCreateMixpanelIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateMixpanelIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMixpanelIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMixpanelIntegrationMutation, { data, loading, error }] = useCreateMixpanelIntegrationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateMixpanelIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMixpanelIntegrationMutation, Types.CreateMixpanelIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMixpanelIntegrationMutation, Types.CreateMixpanelIntegrationMutationVariables>(CreateMixpanelIntegrationDocument, options);
      }
export type CreateMixpanelIntegrationMutationHookResult = ReturnType<typeof useCreateMixpanelIntegrationMutation>;
export type CreateMixpanelIntegrationMutationResult = Apollo.MutationResult<Types.CreateMixpanelIntegrationMutation>;
export type CreateMixpanelIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.CreateMixpanelIntegrationMutation, Types.CreateMixpanelIntegrationMutationVariables>;
export const GetHubspotAuthorizationUrlDocument = gql`
    query GetHubspotAuthorizationUrl {
  getHubspotAuthorizationUrl
}
    `;

/**
 * __useGetHubspotAuthorizationUrlQuery__
 *
 * To run a query within a React component, call `useGetHubspotAuthorizationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubspotAuthorizationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubspotAuthorizationUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHubspotAuthorizationUrlQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetHubspotAuthorizationUrlQuery, Types.GetHubspotAuthorizationUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHubspotAuthorizationUrlQuery, Types.GetHubspotAuthorizationUrlQueryVariables>(GetHubspotAuthorizationUrlDocument, options);
      }
export function useGetHubspotAuthorizationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHubspotAuthorizationUrlQuery, Types.GetHubspotAuthorizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHubspotAuthorizationUrlQuery, Types.GetHubspotAuthorizationUrlQueryVariables>(GetHubspotAuthorizationUrlDocument, options);
        }
export type GetHubspotAuthorizationUrlQueryHookResult = ReturnType<typeof useGetHubspotAuthorizationUrlQuery>;
export type GetHubspotAuthorizationUrlLazyQueryHookResult = ReturnType<typeof useGetHubspotAuthorizationUrlLazyQuery>;
export type GetHubspotAuthorizationUrlQueryResult = Apollo.QueryResult<Types.GetHubspotAuthorizationUrlQuery, Types.GetHubspotAuthorizationUrlQueryVariables>;
export const GetIntegrationEventPropertiesDocument = gql`
    query GetIntegrationEventProperties($integrationType: String!) {
  getMeasurementIntegrationEventProperties(integrationType: $integrationType) {
    parameter
    parameterValues {
      key
      value
    }
  }
}
    `;

/**
 * __useGetIntegrationEventPropertiesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationEventPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationEventPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationEventPropertiesQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useGetIntegrationEventPropertiesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetIntegrationEventPropertiesQuery, Types.GetIntegrationEventPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetIntegrationEventPropertiesQuery, Types.GetIntegrationEventPropertiesQueryVariables>(GetIntegrationEventPropertiesDocument, options);
      }
export function useGetIntegrationEventPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetIntegrationEventPropertiesQuery, Types.GetIntegrationEventPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetIntegrationEventPropertiesQuery, Types.GetIntegrationEventPropertiesQueryVariables>(GetIntegrationEventPropertiesDocument, options);
        }
export type GetIntegrationEventPropertiesQueryHookResult = ReturnType<typeof useGetIntegrationEventPropertiesQuery>;
export type GetIntegrationEventPropertiesLazyQueryHookResult = ReturnType<typeof useGetIntegrationEventPropertiesLazyQuery>;
export type GetIntegrationEventPropertiesQueryResult = Apollo.QueryResult<Types.GetIntegrationEventPropertiesQuery, Types.GetIntegrationEventPropertiesQueryVariables>;
export const GetIntegrationEventsDocument = gql`
    query GetIntegrationEvents($integrationType: String!) {
  getMeasurementIntegrationEvents(integrationType: $integrationType)
}
    `;

/**
 * __useGetIntegrationEventsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationEventsQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useGetIntegrationEventsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetIntegrationEventsQuery, Types.GetIntegrationEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetIntegrationEventsQuery, Types.GetIntegrationEventsQueryVariables>(GetIntegrationEventsDocument, options);
      }
export function useGetIntegrationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetIntegrationEventsQuery, Types.GetIntegrationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetIntegrationEventsQuery, Types.GetIntegrationEventsQueryVariables>(GetIntegrationEventsDocument, options);
        }
export type GetIntegrationEventsQueryHookResult = ReturnType<typeof useGetIntegrationEventsQuery>;
export type GetIntegrationEventsLazyQueryHookResult = ReturnType<typeof useGetIntegrationEventsLazyQuery>;
export type GetIntegrationEventsQueryResult = Apollo.QueryResult<Types.GetIntegrationEventsQuery, Types.GetIntegrationEventsQueryVariables>;
export const GetIntegrationTypesDocument = gql`
    query GetIntegrationTypes {
  getMeasurementIntegrationTypes
}
    `;

/**
 * __useGetIntegrationTypesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationTypesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetIntegrationTypesQuery, Types.GetIntegrationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetIntegrationTypesQuery, Types.GetIntegrationTypesQueryVariables>(GetIntegrationTypesDocument, options);
      }
export function useGetIntegrationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetIntegrationTypesQuery, Types.GetIntegrationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetIntegrationTypesQuery, Types.GetIntegrationTypesQueryVariables>(GetIntegrationTypesDocument, options);
        }
export type GetIntegrationTypesQueryHookResult = ReturnType<typeof useGetIntegrationTypesQuery>;
export type GetIntegrationTypesLazyQueryHookResult = ReturnType<typeof useGetIntegrationTypesLazyQuery>;
export type GetIntegrationTypesQueryResult = Apollo.QueryResult<Types.GetIntegrationTypesQuery, Types.GetIntegrationTypesQueryVariables>;
export const GetLaunchesWithGtmTimelineDocument = gql`
    query GetLaunchesWithGtmTimeline($filter: FilterLaunchInput, $sort: SortLaunchInput) {
  launches(filter: $filter, sort: $sort) {
    ...LaunchWithGtmTimeline
  }
}
    ${LaunchWithGtmTimelineFragmentDoc}`;

/**
 * __useGetLaunchesWithGtmTimelineQuery__
 *
 * To run a query within a React component, call `useGetLaunchesWithGtmTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaunchesWithGtmTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaunchesWithGtmTimelineQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLaunchesWithGtmTimelineQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetLaunchesWithGtmTimelineQuery, Types.GetLaunchesWithGtmTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLaunchesWithGtmTimelineQuery, Types.GetLaunchesWithGtmTimelineQueryVariables>(GetLaunchesWithGtmTimelineDocument, options);
      }
export function useGetLaunchesWithGtmTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLaunchesWithGtmTimelineQuery, Types.GetLaunchesWithGtmTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLaunchesWithGtmTimelineQuery, Types.GetLaunchesWithGtmTimelineQueryVariables>(GetLaunchesWithGtmTimelineDocument, options);
        }
export type GetLaunchesWithGtmTimelineQueryHookResult = ReturnType<typeof useGetLaunchesWithGtmTimelineQuery>;
export type GetLaunchesWithGtmTimelineLazyQueryHookResult = ReturnType<typeof useGetLaunchesWithGtmTimelineLazyQuery>;
export type GetLaunchesWithGtmTimelineQueryResult = Apollo.QueryResult<Types.GetLaunchesWithGtmTimelineQuery, Types.GetLaunchesWithGtmTimelineQueryVariables>;
export const GetMeasurementDocument = gql`
    query GetMeasurement($input: MeasurementIntegrationsQueryInput!) {
  measurementQuery(input: $input) {
    dates
    values
    valuesNormalized
    avgBeforeLaunch
    avgAfterLaunch
    avgBeforeLaunchNormalized
    avgAfterLaunchNormalized
  }
}
    `;

/**
 * __useGetMeasurementQuery__
 *
 * To run a query within a React component, call `useGetMeasurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeasurementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeasurementQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMeasurementQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMeasurementQuery, Types.GetMeasurementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMeasurementQuery, Types.GetMeasurementQueryVariables>(GetMeasurementDocument, options);
      }
export function useGetMeasurementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMeasurementQuery, Types.GetMeasurementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMeasurementQuery, Types.GetMeasurementQueryVariables>(GetMeasurementDocument, options);
        }
export type GetMeasurementQueryHookResult = ReturnType<typeof useGetMeasurementQuery>;
export type GetMeasurementLazyQueryHookResult = ReturnType<typeof useGetMeasurementLazyQuery>;
export type GetMeasurementQueryResult = Apollo.QueryResult<Types.GetMeasurementQuery, Types.GetMeasurementQueryVariables>;
export const GetMeasurementIntegrationMetricsDocument = gql`
    query GetMeasurementIntegrationMetrics {
  getMeasurementIntegrationMetrics {
    id
    ownerId
    organizationId
    eventName
    integrationType
    measurementsIntegrationId
    filters {
      parameter
      parameterValue
    }
  }
}
    `;

/**
 * __useGetMeasurementIntegrationMetricsQuery__
 *
 * To run a query within a React component, call `useGetMeasurementIntegrationMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeasurementIntegrationMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeasurementIntegrationMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeasurementIntegrationMetricsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMeasurementIntegrationMetricsQuery, Types.GetMeasurementIntegrationMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMeasurementIntegrationMetricsQuery, Types.GetMeasurementIntegrationMetricsQueryVariables>(GetMeasurementIntegrationMetricsDocument, options);
      }
export function useGetMeasurementIntegrationMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMeasurementIntegrationMetricsQuery, Types.GetMeasurementIntegrationMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMeasurementIntegrationMetricsQuery, Types.GetMeasurementIntegrationMetricsQueryVariables>(GetMeasurementIntegrationMetricsDocument, options);
        }
export type GetMeasurementIntegrationMetricsQueryHookResult = ReturnType<typeof useGetMeasurementIntegrationMetricsQuery>;
export type GetMeasurementIntegrationMetricsLazyQueryHookResult = ReturnType<typeof useGetMeasurementIntegrationMetricsLazyQuery>;
export type GetMeasurementIntegrationMetricsQueryResult = Apollo.QueryResult<Types.GetMeasurementIntegrationMetricsQuery, Types.GetMeasurementIntegrationMetricsQueryVariables>;
export const GetMeasurementIntegrationsDocument = gql`
    query GetMeasurementIntegrations {
  getMeasurementIntegrations {
    name
    id
  }
}
    `;

/**
 * __useGetMeasurementIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetMeasurementIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeasurementIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeasurementIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeasurementIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMeasurementIntegrationsQuery, Types.GetMeasurementIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMeasurementIntegrationsQuery, Types.GetMeasurementIntegrationsQueryVariables>(GetMeasurementIntegrationsDocument, options);
      }
export function useGetMeasurementIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMeasurementIntegrationsQuery, Types.GetMeasurementIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMeasurementIntegrationsQuery, Types.GetMeasurementIntegrationsQueryVariables>(GetMeasurementIntegrationsDocument, options);
        }
export type GetMeasurementIntegrationsQueryHookResult = ReturnType<typeof useGetMeasurementIntegrationsQuery>;
export type GetMeasurementIntegrationsLazyQueryHookResult = ReturnType<typeof useGetMeasurementIntegrationsLazyQuery>;
export type GetMeasurementIntegrationsQueryResult = Apollo.QueryResult<Types.GetMeasurementIntegrationsQuery, Types.GetMeasurementIntegrationsQueryVariables>;
export const GetSalesforceAuthorizationUrlDocument = gql`
    query GetSalesforceAuthorizationUrl {
  getSalesforceAuthorizationUrl
}
    `;

/**
 * __useGetSalesforceAuthorizationUrlQuery__
 *
 * To run a query within a React component, call `useGetSalesforceAuthorizationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesforceAuthorizationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesforceAuthorizationUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesforceAuthorizationUrlQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSalesforceAuthorizationUrlQuery, Types.GetSalesforceAuthorizationUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSalesforceAuthorizationUrlQuery, Types.GetSalesforceAuthorizationUrlQueryVariables>(GetSalesforceAuthorizationUrlDocument, options);
      }
export function useGetSalesforceAuthorizationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSalesforceAuthorizationUrlQuery, Types.GetSalesforceAuthorizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSalesforceAuthorizationUrlQuery, Types.GetSalesforceAuthorizationUrlQueryVariables>(GetSalesforceAuthorizationUrlDocument, options);
        }
export type GetSalesforceAuthorizationUrlQueryHookResult = ReturnType<typeof useGetSalesforceAuthorizationUrlQuery>;
export type GetSalesforceAuthorizationUrlLazyQueryHookResult = ReturnType<typeof useGetSalesforceAuthorizationUrlLazyQuery>;
export type GetSalesforceAuthorizationUrlQueryResult = Apollo.QueryResult<Types.GetSalesforceAuthorizationUrlQuery, Types.GetSalesforceAuthorizationUrlQueryVariables>;
export const SearchMessagesGroupsParticipantsDocument = gql`
    query SearchMessagesGroupsParticipants($input: SearchMessagesGroupsParticipantsInput!) {
  searchMessagesGroupsParticipants(input: $input) {
    ...MessageGroupParticipant
  }
}
    ${MessageGroupParticipantFragmentDoc}`;

/**
 * __useSearchMessagesGroupsParticipantsQuery__
 *
 * To run a query within a React component, call `useSearchMessagesGroupsParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMessagesGroupsParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMessagesGroupsParticipantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchMessagesGroupsParticipantsQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchMessagesGroupsParticipantsQuery, Types.SearchMessagesGroupsParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchMessagesGroupsParticipantsQuery, Types.SearchMessagesGroupsParticipantsQueryVariables>(SearchMessagesGroupsParticipantsDocument, options);
      }
export function useSearchMessagesGroupsParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchMessagesGroupsParticipantsQuery, Types.SearchMessagesGroupsParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchMessagesGroupsParticipantsQuery, Types.SearchMessagesGroupsParticipantsQueryVariables>(SearchMessagesGroupsParticipantsDocument, options);
        }
export type SearchMessagesGroupsParticipantsQueryHookResult = ReturnType<typeof useSearchMessagesGroupsParticipantsQuery>;
export type SearchMessagesGroupsParticipantsLazyQueryHookResult = ReturnType<typeof useSearchMessagesGroupsParticipantsLazyQuery>;
export type SearchMessagesGroupsParticipantsQueryResult = Apollo.QueryResult<Types.SearchMessagesGroupsParticipantsQuery, Types.SearchMessagesGroupsParticipantsQueryVariables>;
export const MessageGroupsDocument = gql`
    query MessageGroups($pagination: PaginationInput) {
  messageGroups(pagination: $pagination) {
    totalPages
    page
    docs {
      ...MessageGroup
    }
  }
}
    ${MessageGroupFragmentDoc}`;

/**
 * __useMessageGroupsQuery__
 *
 * To run a query within a React component, call `useMessageGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMessageGroupsQuery(baseOptions?: Apollo.QueryHookOptions<Types.MessageGroupsQuery, Types.MessageGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MessageGroupsQuery, Types.MessageGroupsQueryVariables>(MessageGroupsDocument, options);
      }
export function useMessageGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MessageGroupsQuery, Types.MessageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MessageGroupsQuery, Types.MessageGroupsQueryVariables>(MessageGroupsDocument, options);
        }
export type MessageGroupsQueryHookResult = ReturnType<typeof useMessageGroupsQuery>;
export type MessageGroupsLazyQueryHookResult = ReturnType<typeof useMessageGroupsLazyQuery>;
export type MessageGroupsQueryResult = Apollo.QueryResult<Types.MessageGroupsQuery, Types.MessageGroupsQueryVariables>;
export const CreateMessageGroupDocument = gql`
    mutation CreateMessageGroup($input: CreateMessageGroupInput!) {
  createMessageGroup(input: $input) {
    ...MessageGroup
  }
}
    ${MessageGroupFragmentDoc}`;
export type CreateMessageGroupMutationFn = Apollo.MutationFunction<Types.CreateMessageGroupMutation, Types.CreateMessageGroupMutationVariables>;

/**
 * __useCreateMessageGroupMutation__
 *
 * To run a mutation, you first call `useCreateMessageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageGroupMutation, { data, loading, error }] = useCreateMessageGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateMessageGroupMutation, Types.CreateMessageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateMessageGroupMutation, Types.CreateMessageGroupMutationVariables>(CreateMessageGroupDocument, options);
      }
export type CreateMessageGroupMutationHookResult = ReturnType<typeof useCreateMessageGroupMutation>;
export type CreateMessageGroupMutationResult = Apollo.MutationResult<Types.CreateMessageGroupMutation>;
export type CreateMessageGroupMutationOptions = Apollo.BaseMutationOptions<Types.CreateMessageGroupMutation, Types.CreateMessageGroupMutationVariables>;
export const UpdateMessageGroupDocument = gql`
    mutation UpdateMessageGroup($input: UpdateMessageGroupInput!) {
  updateMessageGroup(input: $input) {
    ...MessageGroup
  }
}
    ${MessageGroupFragmentDoc}`;
export type UpdateMessageGroupMutationFn = Apollo.MutationFunction<Types.UpdateMessageGroupMutation, Types.UpdateMessageGroupMutationVariables>;

/**
 * __useUpdateMessageGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMessageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageGroupMutation, { data, loading, error }] = useUpdateMessageGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMessageGroupMutation, Types.UpdateMessageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMessageGroupMutation, Types.UpdateMessageGroupMutationVariables>(UpdateMessageGroupDocument, options);
      }
export type UpdateMessageGroupMutationHookResult = ReturnType<typeof useUpdateMessageGroupMutation>;
export type UpdateMessageGroupMutationResult = Apollo.MutationResult<Types.UpdateMessageGroupMutation>;
export type UpdateMessageGroupMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMessageGroupMutation, Types.UpdateMessageGroupMutationVariables>;
export const DeleteMessageGroupDocument = gql`
    mutation DeleteMessageGroup($id: String!) {
  deleteMessageGroup(id: $id) {
    ...MessageGroup
  }
}
    ${MessageGroupFragmentDoc}`;
export type DeleteMessageGroupMutationFn = Apollo.MutationFunction<Types.DeleteMessageGroupMutation, Types.DeleteMessageGroupMutationVariables>;

/**
 * __useDeleteMessageGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMessageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageGroupMutation, { data, loading, error }] = useDeleteMessageGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMessageGroupMutation, Types.DeleteMessageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMessageGroupMutation, Types.DeleteMessageGroupMutationVariables>(DeleteMessageGroupDocument, options);
      }
export type DeleteMessageGroupMutationHookResult = ReturnType<typeof useDeleteMessageGroupMutation>;
export type DeleteMessageGroupMutationResult = Apollo.MutationResult<Types.DeleteMessageGroupMutation>;
export type DeleteMessageGroupMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMessageGroupMutation, Types.DeleteMessageGroupMutationVariables>;
export const DuplicateMessageGroupDocument = gql`
    mutation DuplicateMessageGroup($id: String!) {
  duplicateMessageGroup(id: $id) {
    ...MessageGroup
  }
}
    ${MessageGroupFragmentDoc}`;
export type DuplicateMessageGroupMutationFn = Apollo.MutationFunction<Types.DuplicateMessageGroupMutation, Types.DuplicateMessageGroupMutationVariables>;

/**
 * __useDuplicateMessageGroupMutation__
 *
 * To run a mutation, you first call `useDuplicateMessageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateMessageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateMessageGroupMutation, { data, loading, error }] = useDuplicateMessageGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateMessageGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateMessageGroupMutation, Types.DuplicateMessageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateMessageGroupMutation, Types.DuplicateMessageGroupMutationVariables>(DuplicateMessageGroupDocument, options);
      }
export type DuplicateMessageGroupMutationHookResult = ReturnType<typeof useDuplicateMessageGroupMutation>;
export type DuplicateMessageGroupMutationResult = Apollo.MutationResult<Types.DuplicateMessageGroupMutation>;
export type DuplicateMessageGroupMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateMessageGroupMutation, Types.DuplicateMessageGroupMutationVariables>;
export const UpdateUsersInMessageGroupDocument = gql`
    mutation UpdateUsersInMessageGroup($input: UpdateMessageGroupUsersInput!) {
  updateUsersInMessageGroup(input: $input) {
    ...MessageGroup
  }
}
    ${MessageGroupFragmentDoc}`;
export type UpdateUsersInMessageGroupMutationFn = Apollo.MutationFunction<Types.UpdateUsersInMessageGroupMutation, Types.UpdateUsersInMessageGroupMutationVariables>;

/**
 * __useUpdateUsersInMessageGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUsersInMessageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersInMessageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersInMessageGroupMutation, { data, loading, error }] = useUpdateUsersInMessageGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUsersInMessageGroupMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUsersInMessageGroupMutation, Types.UpdateUsersInMessageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUsersInMessageGroupMutation, Types.UpdateUsersInMessageGroupMutationVariables>(UpdateUsersInMessageGroupDocument, options);
      }
export type UpdateUsersInMessageGroupMutationHookResult = ReturnType<typeof useUpdateUsersInMessageGroupMutation>;
export type UpdateUsersInMessageGroupMutationResult = Apollo.MutationResult<Types.UpdateUsersInMessageGroupMutation>;
export type UpdateUsersInMessageGroupMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUsersInMessageGroupMutation, Types.UpdateUsersInMessageGroupMutationVariables>;
export const ProductBoardSummaryDocument = gql`
    query ProductBoardSummary($input: ProductBoardSummaryInput) {
  productBoardSummary(input: $input) {
    attachedLaunches {
      ...AttachedLaunch
    }
    nextRelease {
      ...NextProductBoardRelease
    }
    releasesThisMonth {
      ...ProductBoardReleaseThisMonth
    }
  }
}
    ${AttachedLaunchFragmentDoc}
${NextProductBoardReleaseFragmentDoc}
${ProductBoardReleaseThisMonthFragmentDoc}`;

/**
 * __useProductBoardSummaryQuery__
 *
 * To run a query within a React component, call `useProductBoardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductBoardSummaryQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardSummaryQuery, Types.ProductBoardSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardSummaryQuery, Types.ProductBoardSummaryQueryVariables>(ProductBoardSummaryDocument, options);
      }
export function useProductBoardSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardSummaryQuery, Types.ProductBoardSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardSummaryQuery, Types.ProductBoardSummaryQueryVariables>(ProductBoardSummaryDocument, options);
        }
export type ProductBoardSummaryQueryHookResult = ReturnType<typeof useProductBoardSummaryQuery>;
export type ProductBoardSummaryLazyQueryHookResult = ReturnType<typeof useProductBoardSummaryLazyQuery>;
export type ProductBoardSummaryQueryResult = Apollo.QueryResult<Types.ProductBoardSummaryQuery, Types.ProductBoardSummaryQueryVariables>;
export const PaginatedCompetingCompaniesNewsArticlesDocument = gql`
    query PaginatedCompetingCompaniesNewsArticles($filter: FilterCompetingCompaniesNewsAticlesInput, $pagination: PaginationInput) {
  paginatedCompetingCompaniesNewsArticles(
    filter: $filter
    pagination: $pagination
  ) {
    page
    limit
    totalDocs
    totalPages
    hasNextPage
    docs {
      ...CompetitorCompanyNewsArticle
    }
  }
}
    ${CompetitorCompanyNewsArticleFragmentDoc}`;

/**
 * __usePaginatedCompetingCompaniesNewsArticlesQuery__
 *
 * To run a query within a React component, call `usePaginatedCompetingCompaniesNewsArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCompetingCompaniesNewsArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCompetingCompaniesNewsArticlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedCompetingCompaniesNewsArticlesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedCompetingCompaniesNewsArticlesQuery, Types.PaginatedCompetingCompaniesNewsArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCompetingCompaniesNewsArticlesQuery, Types.PaginatedCompetingCompaniesNewsArticlesQueryVariables>(PaginatedCompetingCompaniesNewsArticlesDocument, options);
      }
export function usePaginatedCompetingCompaniesNewsArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCompetingCompaniesNewsArticlesQuery, Types.PaginatedCompetingCompaniesNewsArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCompetingCompaniesNewsArticlesQuery, Types.PaginatedCompetingCompaniesNewsArticlesQueryVariables>(PaginatedCompetingCompaniesNewsArticlesDocument, options);
        }
export type PaginatedCompetingCompaniesNewsArticlesQueryHookResult = ReturnType<typeof usePaginatedCompetingCompaniesNewsArticlesQuery>;
export type PaginatedCompetingCompaniesNewsArticlesLazyQueryHookResult = ReturnType<typeof usePaginatedCompetingCompaniesNewsArticlesLazyQuery>;
export type PaginatedCompetingCompaniesNewsArticlesQueryResult = Apollo.QueryResult<Types.PaginatedCompetingCompaniesNewsArticlesQuery, Types.PaginatedCompetingCompaniesNewsArticlesQueryVariables>;
export const RegisterNotificationChannelDocument = gql`
    mutation RegisterNotificationChannel($input: RegisterNotificationChannelInput!) {
  registerNotificationChannel(input: $input) {
    id
    accessToken
  }
}
    `;
export type RegisterNotificationChannelMutationFn = Apollo.MutationFunction<Types.RegisterNotificationChannelMutation, Types.RegisterNotificationChannelMutationVariables>;

/**
 * __useRegisterNotificationChannelMutation__
 *
 * To run a mutation, you first call `useRegisterNotificationChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNotificationChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNotificationChannelMutation, { data, loading, error }] = useRegisterNotificationChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterNotificationChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.RegisterNotificationChannelMutation, Types.RegisterNotificationChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RegisterNotificationChannelMutation, Types.RegisterNotificationChannelMutationVariables>(RegisterNotificationChannelDocument, options);
      }
export type RegisterNotificationChannelMutationHookResult = ReturnType<typeof useRegisterNotificationChannelMutation>;
export type RegisterNotificationChannelMutationResult = Apollo.MutationResult<Types.RegisterNotificationChannelMutation>;
export type RegisterNotificationChannelMutationOptions = Apollo.BaseMutationOptions<Types.RegisterNotificationChannelMutation, Types.RegisterNotificationChannelMutationVariables>;
export const FindIntegrationChannelsDocument = gql`
    query FindIntegrationChannels($filter: FindIntegrationChannelsInput, $limit: Int, $cursor: String) {
  findIntegrationChannels(
    filter: $filter
    pagination: {limit: $limit, cursor: $cursor}
  ) {
    nextCursor
    docs {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useFindIntegrationChannelsQuery__
 *
 * To run a query within a React component, call `useFindIntegrationChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindIntegrationChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindIntegrationChannelsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFindIntegrationChannelsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FindIntegrationChannelsQuery, Types.FindIntegrationChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindIntegrationChannelsQuery, Types.FindIntegrationChannelsQueryVariables>(FindIntegrationChannelsDocument, options);
      }
export function useFindIntegrationChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindIntegrationChannelsQuery, Types.FindIntegrationChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindIntegrationChannelsQuery, Types.FindIntegrationChannelsQueryVariables>(FindIntegrationChannelsDocument, options);
        }
export type FindIntegrationChannelsQueryHookResult = ReturnType<typeof useFindIntegrationChannelsQuery>;
export type FindIntegrationChannelsLazyQueryHookResult = ReturnType<typeof useFindIntegrationChannelsLazyQuery>;
export type FindIntegrationChannelsQueryResult = Apollo.QueryResult<Types.FindIntegrationChannelsQuery, Types.FindIntegrationChannelsQueryVariables>;
export const NotificationChannelDocument = gql`
    query NotificationChannel($input: FindNotificationChannelInput!) {
  notificationChannel(input: $input) {
    ...NotificationChannel
  }
}
    ${NotificationChannelFragmentDoc}`;

/**
 * __useNotificationChannelQuery__
 *
 * To run a query within a React component, call `useNotificationChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationChannelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationChannelQuery(baseOptions: Apollo.QueryHookOptions<Types.NotificationChannelQuery, Types.NotificationChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NotificationChannelQuery, Types.NotificationChannelQueryVariables>(NotificationChannelDocument, options);
      }
export function useNotificationChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NotificationChannelQuery, Types.NotificationChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NotificationChannelQuery, Types.NotificationChannelQueryVariables>(NotificationChannelDocument, options);
        }
export type NotificationChannelQueryHookResult = ReturnType<typeof useNotificationChannelQuery>;
export type NotificationChannelLazyQueryHookResult = ReturnType<typeof useNotificationChannelLazyQuery>;
export type NotificationChannelQueryResult = Apollo.QueryResult<Types.NotificationChannelQuery, Types.NotificationChannelQueryVariables>;
export const NotificationChannelsAllDocument = gql`
    query NotificationChannelsAll {
  notificationChannelsAll {
    ...NotificationChannel
  }
}
    ${NotificationChannelFragmentDoc}`;

/**
 * __useNotificationChannelsAllQuery__
 *
 * To run a query within a React component, call `useNotificationChannelsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationChannelsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationChannelsAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationChannelsAllQuery(baseOptions?: Apollo.QueryHookOptions<Types.NotificationChannelsAllQuery, Types.NotificationChannelsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NotificationChannelsAllQuery, Types.NotificationChannelsAllQueryVariables>(NotificationChannelsAllDocument, options);
      }
export function useNotificationChannelsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NotificationChannelsAllQuery, Types.NotificationChannelsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NotificationChannelsAllQuery, Types.NotificationChannelsAllQueryVariables>(NotificationChannelsAllDocument, options);
        }
export type NotificationChannelsAllQueryHookResult = ReturnType<typeof useNotificationChannelsAllQuery>;
export type NotificationChannelsAllLazyQueryHookResult = ReturnType<typeof useNotificationChannelsAllLazyQuery>;
export type NotificationChannelsAllQueryResult = Apollo.QueryResult<Types.NotificationChannelsAllQuery, Types.NotificationChannelsAllQueryVariables>;
export const CreateOrUpdateKpiDocument = gql`
    mutation CreateOrUpdateKpi($input: UpdateKpiInput!) {
  createOrUpdateKpi(input: $input) {
    ...Kpi
  }
}
    ${KpiFragmentDoc}`;
export type CreateOrUpdateKpiMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateKpiMutation, Types.CreateOrUpdateKpiMutationVariables>;

/**
 * __useCreateOrUpdateKpiMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateKpiMutation, { data, loading, error }] = useCreateOrUpdateKpiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateKpiMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateKpiMutation, Types.CreateOrUpdateKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateKpiMutation, Types.CreateOrUpdateKpiMutationVariables>(CreateOrUpdateKpiDocument, options);
      }
export type CreateOrUpdateKpiMutationHookResult = ReturnType<typeof useCreateOrUpdateKpiMutation>;
export type CreateOrUpdateKpiMutationResult = Apollo.MutationResult<Types.CreateOrUpdateKpiMutation>;
export type CreateOrUpdateKpiMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateKpiMutation, Types.CreateOrUpdateKpiMutationVariables>;
export const DuplicateObjectiveDocument = gql`
    mutation DuplicateObjective($input: DuplicateObjectiveInput!) {
  duplicateObjective(input: $input) {
    ...Objective
  }
}
    ${ObjectiveFragmentDoc}`;
export type DuplicateObjectiveMutationFn = Apollo.MutationFunction<Types.DuplicateObjectiveMutation, Types.DuplicateObjectiveMutationVariables>;

/**
 * __useDuplicateObjectiveMutation__
 *
 * To run a mutation, you first call `useDuplicateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateObjectiveMutation, { data, loading, error }] = useDuplicateObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateObjectiveMutation, Types.DuplicateObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateObjectiveMutation, Types.DuplicateObjectiveMutationVariables>(DuplicateObjectiveDocument, options);
      }
export type DuplicateObjectiveMutationHookResult = ReturnType<typeof useDuplicateObjectiveMutation>;
export type DuplicateObjectiveMutationResult = Apollo.MutationResult<Types.DuplicateObjectiveMutation>;
export type DuplicateObjectiveMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateObjectiveMutation, Types.DuplicateObjectiveMutationVariables>;
export const RemoveKpiDocument = gql`
    mutation RemoveKpi($id: String!) {
  removeKpi(id: $id) {
    id
  }
}
    `;
export type RemoveKpiMutationFn = Apollo.MutationFunction<Types.RemoveKpiMutation, Types.RemoveKpiMutationVariables>;

/**
 * __useRemoveKpiMutation__
 *
 * To run a mutation, you first call `useRemoveKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKpiMutation, { data, loading, error }] = useRemoveKpiMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveKpiMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveKpiMutation, Types.RemoveKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveKpiMutation, Types.RemoveKpiMutationVariables>(RemoveKpiDocument, options);
      }
export type RemoveKpiMutationHookResult = ReturnType<typeof useRemoveKpiMutation>;
export type RemoveKpiMutationResult = Apollo.MutationResult<Types.RemoveKpiMutation>;
export type RemoveKpiMutationOptions = Apollo.BaseMutationOptions<Types.RemoveKpiMutation, Types.RemoveKpiMutationVariables>;
export const CountObjectivesDocument = gql`
    query CountObjectives($filter: ObjectiveFilterInput) {
  countObjectives(filter: $filter)
}
    `;

/**
 * __useCountObjectivesQuery__
 *
 * To run a query within a React component, call `useCountObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountObjectivesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountObjectivesQuery, Types.CountObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountObjectivesQuery, Types.CountObjectivesQueryVariables>(CountObjectivesDocument, options);
      }
export function useCountObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountObjectivesQuery, Types.CountObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountObjectivesQuery, Types.CountObjectivesQueryVariables>(CountObjectivesDocument, options);
        }
export type CountObjectivesQueryHookResult = ReturnType<typeof useCountObjectivesQuery>;
export type CountObjectivesLazyQueryHookResult = ReturnType<typeof useCountObjectivesLazyQuery>;
export type CountObjectivesQueryResult = Apollo.QueryResult<Types.CountObjectivesQuery, Types.CountObjectivesQueryVariables>;
export const PaginatedObjectivesDocument = gql`
    query PaginatedObjectives($pagination: PaginationInput, $filter: ObjectiveFilterInput) {
  paginatedObjectives(pagination: $pagination, filter: $filter) {
    totalPages
    totalDocs
    page
    docs {
      ...Objective
    }
  }
}
    ${ObjectiveFragmentDoc}`;

/**
 * __usePaginatedObjectivesQuery__
 *
 * To run a query within a React component, call `usePaginatedObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedObjectivesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedObjectivesQuery, Types.PaginatedObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedObjectivesQuery, Types.PaginatedObjectivesQueryVariables>(PaginatedObjectivesDocument, options);
      }
export function usePaginatedObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedObjectivesQuery, Types.PaginatedObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedObjectivesQuery, Types.PaginatedObjectivesQueryVariables>(PaginatedObjectivesDocument, options);
        }
export type PaginatedObjectivesQueryHookResult = ReturnType<typeof usePaginatedObjectivesQuery>;
export type PaginatedObjectivesLazyQueryHookResult = ReturnType<typeof usePaginatedObjectivesLazyQuery>;
export type PaginatedObjectivesQueryResult = Apollo.QueryResult<Types.PaginatedObjectivesQuery, Types.PaginatedObjectivesQueryVariables>;
export const PublicLaunchPageObjectivesDocument = gql`
    query PublicLaunchPageObjectives($pagination: PaginationInput, $filter: ObjectiveFilterInput) {
  publicLaunchPageObjectives(pagination: $pagination, filter: $filter) {
    totalPages
    totalDocs
    page
    docs {
      ...Objective
    }
  }
}
    ${ObjectiveFragmentDoc}`;

/**
 * __usePublicLaunchPageObjectivesQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageObjectivesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePublicLaunchPageObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageObjectivesQuery, Types.PublicLaunchPageObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageObjectivesQuery, Types.PublicLaunchPageObjectivesQueryVariables>(PublicLaunchPageObjectivesDocument, options);
      }
export function usePublicLaunchPageObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageObjectivesQuery, Types.PublicLaunchPageObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageObjectivesQuery, Types.PublicLaunchPageObjectivesQueryVariables>(PublicLaunchPageObjectivesDocument, options);
        }
export type PublicLaunchPageObjectivesQueryHookResult = ReturnType<typeof usePublicLaunchPageObjectivesQuery>;
export type PublicLaunchPageObjectivesLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageObjectivesLazyQuery>;
export type PublicLaunchPageObjectivesQueryResult = Apollo.QueryResult<Types.PublicLaunchPageObjectivesQuery, Types.PublicLaunchPageObjectivesQueryVariables>;
export const CreateKpiDocument = gql`
    mutation CreateKPI($input: UpdateKpiInput!) {
  createOrUpdateKpi(input: $input) {
    ...Kpi
  }
}
    ${KpiFragmentDoc}`;
export type CreateKpiMutationFn = Apollo.MutationFunction<Types.CreateKpiMutation, Types.CreateKpiMutationVariables>;

/**
 * __useCreateKpiMutation__
 *
 * To run a mutation, you first call `useCreateKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKpiMutation, { data, loading, error }] = useCreateKpiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKpiMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateKpiMutation, Types.CreateKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateKpiMutation, Types.CreateKpiMutationVariables>(CreateKpiDocument, options);
      }
export type CreateKpiMutationHookResult = ReturnType<typeof useCreateKpiMutation>;
export type CreateKpiMutationResult = Apollo.MutationResult<Types.CreateKpiMutation>;
export type CreateKpiMutationOptions = Apollo.BaseMutationOptions<Types.CreateKpiMutation, Types.CreateKpiMutationVariables>;
export const CreateObjectiveDocument = gql`
    mutation CreateObjective($input: UpdateObjectiveInput!) {
  createOrUpdateObjectives(input: $input) {
    ...Objective
  }
}
    ${ObjectiveFragmentDoc}`;
export type CreateObjectiveMutationFn = Apollo.MutationFunction<Types.CreateObjectiveMutation, Types.CreateObjectiveMutationVariables>;

/**
 * __useCreateObjectiveMutation__
 *
 * To run a mutation, you first call `useCreateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjectiveMutation, { data, loading, error }] = useCreateObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateObjectiveMutation, Types.CreateObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateObjectiveMutation, Types.CreateObjectiveMutationVariables>(CreateObjectiveDocument, options);
      }
export type CreateObjectiveMutationHookResult = ReturnType<typeof useCreateObjectiveMutation>;
export type CreateObjectiveMutationResult = Apollo.MutationResult<Types.CreateObjectiveMutation>;
export type CreateObjectiveMutationOptions = Apollo.BaseMutationOptions<Types.CreateObjectiveMutation, Types.CreateObjectiveMutationVariables>;
export const DeleteKpiDocument = gql`
    mutation DeleteKPI($id: String!) {
  removeKpi(id: $id) {
    id
  }
}
    `;
export type DeleteKpiMutationFn = Apollo.MutationFunction<Types.DeleteKpiMutation, Types.DeleteKpiMutationVariables>;

/**
 * __useDeleteKpiMutation__
 *
 * To run a mutation, you first call `useDeleteKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKpiMutation, { data, loading, error }] = useDeleteKpiMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKpiMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteKpiMutation, Types.DeleteKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteKpiMutation, Types.DeleteKpiMutationVariables>(DeleteKpiDocument, options);
      }
export type DeleteKpiMutationHookResult = ReturnType<typeof useDeleteKpiMutation>;
export type DeleteKpiMutationResult = Apollo.MutationResult<Types.DeleteKpiMutation>;
export type DeleteKpiMutationOptions = Apollo.BaseMutationOptions<Types.DeleteKpiMutation, Types.DeleteKpiMutationVariables>;
export const DeleteObjectiveDocument = gql`
    mutation DeleteObjective($id: String!) {
  removeObjective(id: $id) {
    id
  }
}
    `;
export type DeleteObjectiveMutationFn = Apollo.MutationFunction<Types.DeleteObjectiveMutation, Types.DeleteObjectiveMutationVariables>;

/**
 * __useDeleteObjectiveMutation__
 *
 * To run a mutation, you first call `useDeleteObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteObjectiveMutation, { data, loading, error }] = useDeleteObjectiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteObjectiveMutation, Types.DeleteObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteObjectiveMutation, Types.DeleteObjectiveMutationVariables>(DeleteObjectiveDocument, options);
      }
export type DeleteObjectiveMutationHookResult = ReturnType<typeof useDeleteObjectiveMutation>;
export type DeleteObjectiveMutationResult = Apollo.MutationResult<Types.DeleteObjectiveMutation>;
export type DeleteObjectiveMutationOptions = Apollo.BaseMutationOptions<Types.DeleteObjectiveMutation, Types.DeleteObjectiveMutationVariables>;
export const UpdateKpiDocument = gql`
    mutation UpdateKPI($input: UpdateKpiInput!) {
  createOrUpdateKpi(input: $input) {
    ...Kpi
  }
}
    ${KpiFragmentDoc}`;
export type UpdateKpiMutationFn = Apollo.MutationFunction<Types.UpdateKpiMutation, Types.UpdateKpiMutationVariables>;

/**
 * __useUpdateKpiMutation__
 *
 * To run a mutation, you first call `useUpdateKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKpiMutation, { data, loading, error }] = useUpdateKpiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKpiMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateKpiMutation, Types.UpdateKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateKpiMutation, Types.UpdateKpiMutationVariables>(UpdateKpiDocument, options);
      }
export type UpdateKpiMutationHookResult = ReturnType<typeof useUpdateKpiMutation>;
export type UpdateKpiMutationResult = Apollo.MutationResult<Types.UpdateKpiMutation>;
export type UpdateKpiMutationOptions = Apollo.BaseMutationOptions<Types.UpdateKpiMutation, Types.UpdateKpiMutationVariables>;
export const UpdateObjectivesDocument = gql`
    mutation UpdateObjectives($input: UpdateObjectiveInput!) {
  createOrUpdateObjectives(input: $input) {
    ...Objective
  }
}
    ${ObjectiveFragmentDoc}`;
export type UpdateObjectivesMutationFn = Apollo.MutationFunction<Types.UpdateObjectivesMutation, Types.UpdateObjectivesMutationVariables>;

/**
 * __useUpdateObjectivesMutation__
 *
 * To run a mutation, you first call `useUpdateObjectivesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectivesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectivesMutation, { data, loading, error }] = useUpdateObjectivesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateObjectivesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateObjectivesMutation, Types.UpdateObjectivesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateObjectivesMutation, Types.UpdateObjectivesMutationVariables>(UpdateObjectivesDocument, options);
      }
export type UpdateObjectivesMutationHookResult = ReturnType<typeof useUpdateObjectivesMutation>;
export type UpdateObjectivesMutationResult = Apollo.MutationResult<Types.UpdateObjectivesMutation>;
export type UpdateObjectivesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateObjectivesMutation, Types.UpdateObjectivesMutationVariables>;
export const KpIsDocument = gql`
    query KPIs($pagination: PaginationInput, $filter: KpiFilterInput) {
  kpis(pagination: $pagination, filter: $filter) {
    totalPages
    totalDocs
    page
    docs {
      ...Kpi
    }
  }
}
    ${KpiFragmentDoc}`;

/**
 * __useKpIsQuery__
 *
 * To run a query within a React component, call `useKpIsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpIsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpIsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useKpIsQuery(baseOptions?: Apollo.QueryHookOptions<Types.KpIsQuery, Types.KpIsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.KpIsQuery, Types.KpIsQueryVariables>(KpIsDocument, options);
      }
export function useKpIsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.KpIsQuery, Types.KpIsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.KpIsQuery, Types.KpIsQueryVariables>(KpIsDocument, options);
        }
export type KpIsQueryHookResult = ReturnType<typeof useKpIsQuery>;
export type KpIsLazyQueryHookResult = ReturnType<typeof useKpIsLazyQuery>;
export type KpIsQueryResult = Apollo.QueryResult<Types.KpIsQuery, Types.KpIsQueryVariables>;
export const DeleteSampleDataDocument = gql`
    mutation DeleteSampleData($input: DeleteSampleDataInput!) {
  deleteSampleData(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export type DeleteSampleDataMutationFn = Apollo.MutationFunction<Types.DeleteSampleDataMutation, Types.DeleteSampleDataMutationVariables>;

/**
 * __useDeleteSampleDataMutation__
 *
 * To run a mutation, you first call `useDeleteSampleDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSampleDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSampleDataMutation, { data, loading, error }] = useDeleteSampleDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSampleDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSampleDataMutation, Types.DeleteSampleDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSampleDataMutation, Types.DeleteSampleDataMutationVariables>(DeleteSampleDataDocument, options);
      }
export type DeleteSampleDataMutationHookResult = ReturnType<typeof useDeleteSampleDataMutation>;
export type DeleteSampleDataMutationResult = Apollo.MutationResult<Types.DeleteSampleDataMutation>;
export type DeleteSampleDataMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSampleDataMutation, Types.DeleteSampleDataMutationVariables>;
export const SaveFailedCsvUploadDocument = gql`
    mutation SaveFailedCsvUpload($input: SaveFailedCsvUploadInput!) {
  saveFailedCsvUpload(input: $input)
}
    `;
export type SaveFailedCsvUploadMutationFn = Apollo.MutationFunction<Types.SaveFailedCsvUploadMutation, Types.SaveFailedCsvUploadMutationVariables>;

/**
 * __useSaveFailedCsvUploadMutation__
 *
 * To run a mutation, you first call `useSaveFailedCsvUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFailedCsvUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFailedCsvUploadMutation, { data, loading, error }] = useSaveFailedCsvUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFailedCsvUploadMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveFailedCsvUploadMutation, Types.SaveFailedCsvUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveFailedCsvUploadMutation, Types.SaveFailedCsvUploadMutationVariables>(SaveFailedCsvUploadDocument, options);
      }
export type SaveFailedCsvUploadMutationHookResult = ReturnType<typeof useSaveFailedCsvUploadMutation>;
export type SaveFailedCsvUploadMutationResult = Apollo.MutationResult<Types.SaveFailedCsvUploadMutation>;
export type SaveFailedCsvUploadMutationOptions = Apollo.BaseMutationOptions<Types.SaveFailedCsvUploadMutation, Types.SaveFailedCsvUploadMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ...OrganizationContent
  }
}
    ${OrganizationContentFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<Types.UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>;
export const OrganizationDocument = gql`
    query Organization {
  organization {
    ...OrganizationContent
    isFree
    isActive
    billingEmailId
    isWorkspaceConfigGenerated
    isUnderFreeTrial
    hasExpiredFreeTrial
    hasPaidSubscription
    currentSubscriptionPlanName
    admin
    createdAt
    chatGTMEnabled
    mapleBillingCustomerId
    roadmapToInsightsMappingEnabled
    autoInsightsTaggingEnabled
    aiSettings {
      ...OrganizationAISettings
    }
    stages {
      ...Stage
    }
    subscriptionRestrictions {
      ...SubscriptionRestrictions
    }
    users {
      ...OrganizationUser
    }
    currentUser @client {
      ...OrganizationUser
    }
  }
}
    ${OrganizationContentFragmentDoc}
${OrganizationAiSettingsFragmentDoc}
${StageFragmentDoc}
${SubscriptionRestrictionsFragmentDoc}
${OrganizationUserFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationQuery, Types.OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationQuery, Types.OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationQuery, Types.OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationQuery, Types.OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<Types.OrganizationQuery, Types.OrganizationQueryVariables>;
export const OrganizationAdminDocument = gql`
    query OrganizationAdmin {
  organization {
    id
    admin
  }
}
    `;

/**
 * __useOrganizationAdminQuery__
 *
 * To run a query within a React component, call `useOrganizationAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationAdminQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationAdminQuery, Types.OrganizationAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationAdminQuery, Types.OrganizationAdminQueryVariables>(OrganizationAdminDocument, options);
      }
export function useOrganizationAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationAdminQuery, Types.OrganizationAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationAdminQuery, Types.OrganizationAdminQueryVariables>(OrganizationAdminDocument, options);
        }
export type OrganizationAdminQueryHookResult = ReturnType<typeof useOrganizationAdminQuery>;
export type OrganizationAdminLazyQueryHookResult = ReturnType<typeof useOrganizationAdminLazyQuery>;
export type OrganizationAdminQueryResult = Apollo.QueryResult<Types.OrganizationAdminQuery, Types.OrganizationAdminQueryVariables>;
export const OrganizationExpirationDocument = gql`
    query OrganizationExpiration($id: String!) {
  organization(id: $id) {
    ...OrganizationExpiration
  }
}
    ${OrganizationExpirationFragmentDoc}`;

/**
 * __useOrganizationExpirationQuery__
 *
 * To run a query within a React component, call `useOrganizationExpirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationExpirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationExpirationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationExpirationQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationExpirationQuery, Types.OrganizationExpirationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationExpirationQuery, Types.OrganizationExpirationQueryVariables>(OrganizationExpirationDocument, options);
      }
export function useOrganizationExpirationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationExpirationQuery, Types.OrganizationExpirationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationExpirationQuery, Types.OrganizationExpirationQueryVariables>(OrganizationExpirationDocument, options);
        }
export type OrganizationExpirationQueryHookResult = ReturnType<typeof useOrganizationExpirationQuery>;
export type OrganizationExpirationLazyQueryHookResult = ReturnType<typeof useOrganizationExpirationLazyQuery>;
export type OrganizationExpirationQueryResult = Apollo.QueryResult<Types.OrganizationExpirationQuery, Types.OrganizationExpirationQueryVariables>;
export const OrganizationGtmDocument = gql`
    query OrganizationGtm {
  organization {
    ...OrganizationGtm
  }
}
    ${OrganizationGtmFragmentDoc}`;

/**
 * __useOrganizationGtmQuery__
 *
 * To run a query within a React component, call `useOrganizationGtmQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationGtmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationGtmQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationGtmQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationGtmQuery, Types.OrganizationGtmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationGtmQuery, Types.OrganizationGtmQueryVariables>(OrganizationGtmDocument, options);
      }
export function useOrganizationGtmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationGtmQuery, Types.OrganizationGtmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationGtmQuery, Types.OrganizationGtmQueryVariables>(OrganizationGtmDocument, options);
        }
export type OrganizationGtmQueryHookResult = ReturnType<typeof useOrganizationGtmQuery>;
export type OrganizationGtmLazyQueryHookResult = ReturnType<typeof useOrganizationGtmLazyQuery>;
export type OrganizationGtmQueryResult = Apollo.QueryResult<Types.OrganizationGtmQuery, Types.OrganizationGtmQueryVariables>;
export const OrganizationPaginatedUsersDocument = gql`
    query OrganizationPaginatedUsers($pagination: PaginationInput = {page: 1, limit: 10}, $search: String) {
  usersInOrganization(pagination: $pagination, search: $search) {
    hasNextPage
    totalPages
    totalDocs
    page
    docs {
      ...OrganizationPaginatedUsers
    }
  }
}
    ${OrganizationPaginatedUsersFragmentDoc}`;

/**
 * __useOrganizationPaginatedUsersQuery__
 *
 * To run a query within a React component, call `useOrganizationPaginatedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPaginatedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPaginatedUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOrganizationPaginatedUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationPaginatedUsersQuery, Types.OrganizationPaginatedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationPaginatedUsersQuery, Types.OrganizationPaginatedUsersQueryVariables>(OrganizationPaginatedUsersDocument, options);
      }
export function useOrganizationPaginatedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationPaginatedUsersQuery, Types.OrganizationPaginatedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationPaginatedUsersQuery, Types.OrganizationPaginatedUsersQueryVariables>(OrganizationPaginatedUsersDocument, options);
        }
export type OrganizationPaginatedUsersQueryHookResult = ReturnType<typeof useOrganizationPaginatedUsersQuery>;
export type OrganizationPaginatedUsersLazyQueryHookResult = ReturnType<typeof useOrganizationPaginatedUsersLazyQuery>;
export type OrganizationPaginatedUsersQueryResult = Apollo.QueryResult<Types.OrganizationPaginatedUsersQuery, Types.OrganizationPaginatedUsersQueryVariables>;
export const OrganizationUsersDocument = gql`
    query OrganizationUsers {
  organization {
    id
    users {
      ...OrganizationUser
    }
    currentUser @client {
      ...OrganizationUser
    }
  }
}
    ${OrganizationUserFragmentDoc}`;

/**
 * __useOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationUsersQuery, Types.OrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationUsersQuery, Types.OrganizationUsersQueryVariables>(OrganizationUsersDocument, options);
      }
export function useOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationUsersQuery, Types.OrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationUsersQuery, Types.OrganizationUsersQueryVariables>(OrganizationUsersDocument, options);
        }
export type OrganizationUsersQueryHookResult = ReturnType<typeof useOrganizationUsersQuery>;
export type OrganizationUsersLazyQueryHookResult = ReturnType<typeof useOrganizationUsersLazyQuery>;
export type OrganizationUsersQueryResult = Apollo.QueryResult<Types.OrganizationUsersQuery, Types.OrganizationUsersQueryVariables>;
export const PublicCompanyOrganizationDocument = gql`
    query PublicCompanyOrganization {
  publicCompanyOrganization {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __usePublicCompanyOrganizationQuery__
 *
 * To run a query within a React component, call `usePublicCompanyOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCompanyOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCompanyOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicCompanyOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicCompanyOrganizationQuery, Types.PublicCompanyOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicCompanyOrganizationQuery, Types.PublicCompanyOrganizationQueryVariables>(PublicCompanyOrganizationDocument, options);
      }
export function usePublicCompanyOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicCompanyOrganizationQuery, Types.PublicCompanyOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicCompanyOrganizationQuery, Types.PublicCompanyOrganizationQueryVariables>(PublicCompanyOrganizationDocument, options);
        }
export type PublicCompanyOrganizationQueryHookResult = ReturnType<typeof usePublicCompanyOrganizationQuery>;
export type PublicCompanyOrganizationLazyQueryHookResult = ReturnType<typeof usePublicCompanyOrganizationLazyQuery>;
export type PublicCompanyOrganizationQueryResult = Apollo.QueryResult<Types.PublicCompanyOrganizationQuery, Types.PublicCompanyOrganizationQueryVariables>;
export const PublicLaunchPageOrganizationDocument = gql`
    query PublicLaunchPageOrganization {
  publicLaunchPageOrganization {
    ...PublicLaunchPageOrganization
  }
}
    ${PublicLaunchPageOrganizationFragmentDoc}`;

/**
 * __usePublicLaunchPageOrganizationQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchPageOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageOrganizationQuery, Types.PublicLaunchPageOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageOrganizationQuery, Types.PublicLaunchPageOrganizationQueryVariables>(PublicLaunchPageOrganizationDocument, options);
      }
export function usePublicLaunchPageOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageOrganizationQuery, Types.PublicLaunchPageOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageOrganizationQuery, Types.PublicLaunchPageOrganizationQueryVariables>(PublicLaunchPageOrganizationDocument, options);
        }
export type PublicLaunchPageOrganizationQueryHookResult = ReturnType<typeof usePublicLaunchPageOrganizationQuery>;
export type PublicLaunchPageOrganizationLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageOrganizationLazyQuery>;
export type PublicLaunchPageOrganizationQueryResult = Apollo.QueryResult<Types.PublicLaunchPageOrganizationQuery, Types.PublicLaunchPageOrganizationQueryVariables>;
export const PublicLaunchPageOrganizationUsersDocument = gql`
    query PublicLaunchPageOrganizationUsers {
  publicLaunchPageOrganization {
    id
    users {
      ...OrganizationUser
    }
    currentUser @client {
      ...OrganizationUser
    }
  }
}
    ${OrganizationUserFragmentDoc}`;

/**
 * __usePublicLaunchPageOrganizationUsersQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageOrganizationUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchPageOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageOrganizationUsersQuery, Types.PublicLaunchPageOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageOrganizationUsersQuery, Types.PublicLaunchPageOrganizationUsersQueryVariables>(PublicLaunchPageOrganizationUsersDocument, options);
      }
export function usePublicLaunchPageOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageOrganizationUsersQuery, Types.PublicLaunchPageOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageOrganizationUsersQuery, Types.PublicLaunchPageOrganizationUsersQueryVariables>(PublicLaunchPageOrganizationUsersDocument, options);
        }
export type PublicLaunchPageOrganizationUsersQueryHookResult = ReturnType<typeof usePublicLaunchPageOrganizationUsersQuery>;
export type PublicLaunchPageOrganizationUsersLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageOrganizationUsersLazyQuery>;
export type PublicLaunchPageOrganizationUsersQueryResult = Apollo.QueryResult<Types.PublicLaunchPageOrganizationUsersQuery, Types.PublicLaunchPageOrganizationUsersQueryVariables>;
export const PublicOrganizationDocument = gql`
    query PublicOrganization {
  publicOrganization {
    ...PublicOrganization
  }
}
    ${PublicOrganizationFragmentDoc}`;

/**
 * __usePublicOrganizationQuery__
 *
 * To run a query within a React component, call `usePublicOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicOrganizationQuery, Types.PublicOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicOrganizationQuery, Types.PublicOrganizationQueryVariables>(PublicOrganizationDocument, options);
      }
export function usePublicOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicOrganizationQuery, Types.PublicOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicOrganizationQuery, Types.PublicOrganizationQueryVariables>(PublicOrganizationDocument, options);
        }
export type PublicOrganizationQueryHookResult = ReturnType<typeof usePublicOrganizationQuery>;
export type PublicOrganizationLazyQueryHookResult = ReturnType<typeof usePublicOrganizationLazyQuery>;
export type PublicOrganizationQueryResult = Apollo.QueryResult<Types.PublicOrganizationQuery, Types.PublicOrganizationQueryVariables>;
export const CreateRoadmapDocument = gql`
    mutation CreateRoadmap($input: CreateProductBoardRoadmapInput!) {
  createProductBoardRoadmap(input: $input) {
    ...ProductBoardRoadmapWithItems
  }
}
    ${ProductBoardRoadmapWithItemsFragmentDoc}`;
export type CreateRoadmapMutationFn = Apollo.MutationFunction<Types.CreateRoadmapMutation, Types.CreateRoadmapMutationVariables>;

/**
 * __useCreateRoadmapMutation__
 *
 * To run a mutation, you first call `useCreateRoadmapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoadmapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoadmapMutation, { data, loading, error }] = useCreateRoadmapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoadmapMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateRoadmapMutation, Types.CreateRoadmapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateRoadmapMutation, Types.CreateRoadmapMutationVariables>(CreateRoadmapDocument, options);
      }
export type CreateRoadmapMutationHookResult = ReturnType<typeof useCreateRoadmapMutation>;
export type CreateRoadmapMutationResult = Apollo.MutationResult<Types.CreateRoadmapMutation>;
export type CreateRoadmapMutationOptions = Apollo.BaseMutationOptions<Types.CreateRoadmapMutation, Types.CreateRoadmapMutationVariables>;
export const DeleteRoadmapDocument = gql`
    mutation DeleteRoadmap($id: String!) {
  deleteProductBoardRoadmap(id: $id) {
    id
  }
}
    `;
export type DeleteRoadmapMutationFn = Apollo.MutationFunction<Types.DeleteRoadmapMutation, Types.DeleteRoadmapMutationVariables>;

/**
 * __useDeleteRoadmapMutation__
 *
 * To run a mutation, you first call `useDeleteRoadmapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoadmapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoadmapMutation, { data, loading, error }] = useDeleteRoadmapMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoadmapMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRoadmapMutation, Types.DeleteRoadmapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRoadmapMutation, Types.DeleteRoadmapMutationVariables>(DeleteRoadmapDocument, options);
      }
export type DeleteRoadmapMutationHookResult = ReturnType<typeof useDeleteRoadmapMutation>;
export type DeleteRoadmapMutationResult = Apollo.MutationResult<Types.DeleteRoadmapMutation>;
export type DeleteRoadmapMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRoadmapMutation, Types.DeleteRoadmapMutationVariables>;
export const UpdateRoadmapDocument = gql`
    mutation UpdateRoadmap($input: UpdateProductBoardRoadmapInput!) {
  updateProductBoardRoadmap(input: $input) {
    ...ProductBoardRoadmapWithItems
  }
}
    ${ProductBoardRoadmapWithItemsFragmentDoc}`;
export type UpdateRoadmapMutationFn = Apollo.MutationFunction<Types.UpdateRoadmapMutation, Types.UpdateRoadmapMutationVariables>;

/**
 * __useUpdateRoadmapMutation__
 *
 * To run a mutation, you first call `useUpdateRoadmapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoadmapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoadmapMutation, { data, loading, error }] = useUpdateRoadmapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoadmapMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRoadmapMutation, Types.UpdateRoadmapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRoadmapMutation, Types.UpdateRoadmapMutationVariables>(UpdateRoadmapDocument, options);
      }
export type UpdateRoadmapMutationHookResult = ReturnType<typeof useUpdateRoadmapMutation>;
export type UpdateRoadmapMutationResult = Apollo.MutationResult<Types.UpdateRoadmapMutation>;
export type UpdateRoadmapMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRoadmapMutation, Types.UpdateRoadmapMutationVariables>;
export const CreateProductBoardCustomColumnDocument = gql`
    mutation CreateProductBoardCustomColumn($input: CreateProductBoardCustomColumnInput!) {
  createProductBoardCustomColumn(input: $input) {
    ...ProductBoardCustomColumn
  }
}
    ${ProductBoardCustomColumnFragmentDoc}`;
export type CreateProductBoardCustomColumnMutationFn = Apollo.MutationFunction<Types.CreateProductBoardCustomColumnMutation, Types.CreateProductBoardCustomColumnMutationVariables>;

/**
 * __useCreateProductBoardCustomColumnMutation__
 *
 * To run a mutation, you first call `useCreateProductBoardCustomColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBoardCustomColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBoardCustomColumnMutation, { data, loading, error }] = useCreateProductBoardCustomColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductBoardCustomColumnMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductBoardCustomColumnMutation, Types.CreateProductBoardCustomColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductBoardCustomColumnMutation, Types.CreateProductBoardCustomColumnMutationVariables>(CreateProductBoardCustomColumnDocument, options);
      }
export type CreateProductBoardCustomColumnMutationHookResult = ReturnType<typeof useCreateProductBoardCustomColumnMutation>;
export type CreateProductBoardCustomColumnMutationResult = Apollo.MutationResult<Types.CreateProductBoardCustomColumnMutation>;
export type CreateProductBoardCustomColumnMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductBoardCustomColumnMutation, Types.CreateProductBoardCustomColumnMutationVariables>;
export const UpdateProductBoardCustomColumnDocument = gql`
    mutation UpdateProductBoardCustomColumn($input: UpdateProductBoardCustomColumnInput!) {
  updateProductBoardCustomColumn(input: $input) {
    ...ProductBoardCustomColumn
  }
}
    ${ProductBoardCustomColumnFragmentDoc}`;
export type UpdateProductBoardCustomColumnMutationFn = Apollo.MutationFunction<Types.UpdateProductBoardCustomColumnMutation, Types.UpdateProductBoardCustomColumnMutationVariables>;

/**
 * __useUpdateProductBoardCustomColumnMutation__
 *
 * To run a mutation, you first call `useUpdateProductBoardCustomColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBoardCustomColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBoardCustomColumnMutation, { data, loading, error }] = useUpdateProductBoardCustomColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBoardCustomColumnMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductBoardCustomColumnMutation, Types.UpdateProductBoardCustomColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductBoardCustomColumnMutation, Types.UpdateProductBoardCustomColumnMutationVariables>(UpdateProductBoardCustomColumnDocument, options);
      }
export type UpdateProductBoardCustomColumnMutationHookResult = ReturnType<typeof useUpdateProductBoardCustomColumnMutation>;
export type UpdateProductBoardCustomColumnMutationResult = Apollo.MutationResult<Types.UpdateProductBoardCustomColumnMutation>;
export type UpdateProductBoardCustomColumnMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductBoardCustomColumnMutation, Types.UpdateProductBoardCustomColumnMutationVariables>;
export const DeleteProductBoardCustomColumnDocument = gql`
    mutation DeleteProductBoardCustomColumn($id: String!) {
  deleteProductBoardCustomColumn(id: $id) {
    ...ProductBoardCustomColumn
  }
}
    ${ProductBoardCustomColumnFragmentDoc}`;
export type DeleteProductBoardCustomColumnMutationFn = Apollo.MutationFunction<Types.DeleteProductBoardCustomColumnMutation, Types.DeleteProductBoardCustomColumnMutationVariables>;

/**
 * __useDeleteProductBoardCustomColumnMutation__
 *
 * To run a mutation, you first call `useDeleteProductBoardCustomColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductBoardCustomColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductBoardCustomColumnMutation, { data, loading, error }] = useDeleteProductBoardCustomColumnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductBoardCustomColumnMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductBoardCustomColumnMutation, Types.DeleteProductBoardCustomColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductBoardCustomColumnMutation, Types.DeleteProductBoardCustomColumnMutationVariables>(DeleteProductBoardCustomColumnDocument, options);
      }
export type DeleteProductBoardCustomColumnMutationHookResult = ReturnType<typeof useDeleteProductBoardCustomColumnMutation>;
export type DeleteProductBoardCustomColumnMutationResult = Apollo.MutationResult<Types.DeleteProductBoardCustomColumnMutation>;
export type DeleteProductBoardCustomColumnMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductBoardCustomColumnMutation, Types.DeleteProductBoardCustomColumnMutationVariables>;
export const PaginatedConnectionsDocument = gql`
    query PaginatedConnections($limit: Int = 10, $page: Int = 1, $query: String) {
  competitors: paginatedCompanies(
    pagination: {limit: $limit, page: $page}
    filter: {query: $query}
  ) {
    docs {
      ...CompanyPreview
    }
  }
  personas: paginatedPersonas(input: {limit: $limit, page: $page, query: $query}) {
    docs {
      ...PersonaInfo
    }
  }
  feedbackPosts: paginatedFeedbackPosts(
    pagination: {limit: $limit, page: $page}
    filter: {query: $query}
  ) {
    docs {
      ...FeedbackPostPreview
    }
  }
  insights: paginatedInsights(
    pagination: {limit: $limit, page: $page}
    filter: {query: $query}
  ) {
    docs {
      ...Insight
    }
  }
  launches: paginatedLaunches(
    pagination: {limit: $limit, page: $page}
    filter: {search: $query}
  ) {
    docs {
      ...LaunchInfo
    }
  }
}
    ${CompanyPreviewFragmentDoc}
${PersonaInfoFragmentDoc}
${FeedbackPostPreviewFragmentDoc}
${InsightFragmentDoc}
${LaunchInfoFragmentDoc}`;

/**
 * __usePaginatedConnectionsQuery__
 *
 * To run a query within a React component, call `usePaginatedConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedConnectionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePaginatedConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedConnectionsQuery, Types.PaginatedConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedConnectionsQuery, Types.PaginatedConnectionsQueryVariables>(PaginatedConnectionsDocument, options);
      }
export function usePaginatedConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedConnectionsQuery, Types.PaginatedConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedConnectionsQuery, Types.PaginatedConnectionsQueryVariables>(PaginatedConnectionsDocument, options);
        }
export type PaginatedConnectionsQueryHookResult = ReturnType<typeof usePaginatedConnectionsQuery>;
export type PaginatedConnectionsLazyQueryHookResult = ReturnType<typeof usePaginatedConnectionsLazyQuery>;
export type PaginatedConnectionsQueryResult = Apollo.QueryResult<Types.PaginatedConnectionsQuery, Types.PaginatedConnectionsQueryVariables>;
export const ProductBoardCustomColumnsDocument = gql`
    query ProductBoardCustomColumns {
  productBoardCustomColumns {
    ...ProductBoardCustomColumn
  }
}
    ${ProductBoardCustomColumnFragmentDoc}`;

/**
 * __useProductBoardCustomColumnsQuery__
 *
 * To run a query within a React component, call `useProductBoardCustomColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardCustomColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardCustomColumnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBoardCustomColumnsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardCustomColumnsQuery, Types.ProductBoardCustomColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardCustomColumnsQuery, Types.ProductBoardCustomColumnsQueryVariables>(ProductBoardCustomColumnsDocument, options);
      }
export function useProductBoardCustomColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardCustomColumnsQuery, Types.ProductBoardCustomColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardCustomColumnsQuery, Types.ProductBoardCustomColumnsQueryVariables>(ProductBoardCustomColumnsDocument, options);
        }
export type ProductBoardCustomColumnsQueryHookResult = ReturnType<typeof useProductBoardCustomColumnsQuery>;
export type ProductBoardCustomColumnsLazyQueryHookResult = ReturnType<typeof useProductBoardCustomColumnsLazyQuery>;
export type ProductBoardCustomColumnsQueryResult = Apollo.QueryResult<Types.ProductBoardCustomColumnsQuery, Types.ProductBoardCustomColumnsQueryVariables>;
export const ProductBoardIndicatorsDocument = gql`
    query ProductBoardIndicators($ids: [String!]) {
  productBoardRoadmaps(input: {ids: $ids}) {
    ...ProductBoardIndicators
  }
  roadmapOkrProgress(ids: $ids) {
    ...ProductBoardOkrProgress
  }
}
    ${ProductBoardIndicatorsFragmentDoc}
${ProductBoardOkrProgressFragmentDoc}`;

/**
 * __useProductBoardIndicatorsQuery__
 *
 * To run a query within a React component, call `useProductBoardIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardIndicatorsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProductBoardIndicatorsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardIndicatorsQuery, Types.ProductBoardIndicatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardIndicatorsQuery, Types.ProductBoardIndicatorsQueryVariables>(ProductBoardIndicatorsDocument, options);
      }
export function useProductBoardIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardIndicatorsQuery, Types.ProductBoardIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardIndicatorsQuery, Types.ProductBoardIndicatorsQueryVariables>(ProductBoardIndicatorsDocument, options);
        }
export type ProductBoardIndicatorsQueryHookResult = ReturnType<typeof useProductBoardIndicatorsQuery>;
export type ProductBoardIndicatorsLazyQueryHookResult = ReturnType<typeof useProductBoardIndicatorsLazyQuery>;
export type ProductBoardIndicatorsQueryResult = Apollo.QueryResult<Types.ProductBoardIndicatorsQuery, Types.ProductBoardIndicatorsQueryVariables>;
export const PublicProductBoardIndicatorsDocument = gql`
    query PublicProductBoardIndicators($input: ProductBoardRoadmapsInput) {
  publicProductRoadmaps(input: $input) {
    ...ProductBoardIndicators
  }
}
    ${ProductBoardIndicatorsFragmentDoc}`;

/**
 * __usePublicProductBoardIndicatorsQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardIndicatorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicProductBoardIndicatorsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductBoardIndicatorsQuery, Types.PublicProductBoardIndicatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardIndicatorsQuery, Types.PublicProductBoardIndicatorsQueryVariables>(PublicProductBoardIndicatorsDocument, options);
      }
export function usePublicProductBoardIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardIndicatorsQuery, Types.PublicProductBoardIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardIndicatorsQuery, Types.PublicProductBoardIndicatorsQueryVariables>(PublicProductBoardIndicatorsDocument, options);
        }
export type PublicProductBoardIndicatorsQueryHookResult = ReturnType<typeof usePublicProductBoardIndicatorsQuery>;
export type PublicProductBoardIndicatorsLazyQueryHookResult = ReturnType<typeof usePublicProductBoardIndicatorsLazyQuery>;
export type PublicProductBoardIndicatorsQueryResult = Apollo.QueryResult<Types.PublicProductBoardIndicatorsQuery, Types.PublicProductBoardIndicatorsQueryVariables>;
export const ProductBoardRoadmapOkrProgressDocument = gql`
    query ProductBoardRoadmapOkrProgress($ids: [String!]!) {
  roadmapOkrProgress(ids: $ids) {
    ...ProductBoardOkrProgress
  }
}
    ${ProductBoardOkrProgressFragmentDoc}`;

/**
 * __useProductBoardRoadmapOkrProgressQuery__
 *
 * To run a query within a React component, call `useProductBoardRoadmapOkrProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardRoadmapOkrProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardRoadmapOkrProgressQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProductBoardRoadmapOkrProgressQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardRoadmapOkrProgressQuery, Types.ProductBoardRoadmapOkrProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardRoadmapOkrProgressQuery, Types.ProductBoardRoadmapOkrProgressQueryVariables>(ProductBoardRoadmapOkrProgressDocument, options);
      }
export function useProductBoardRoadmapOkrProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardRoadmapOkrProgressQuery, Types.ProductBoardRoadmapOkrProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardRoadmapOkrProgressQuery, Types.ProductBoardRoadmapOkrProgressQueryVariables>(ProductBoardRoadmapOkrProgressDocument, options);
        }
export type ProductBoardRoadmapOkrProgressQueryHookResult = ReturnType<typeof useProductBoardRoadmapOkrProgressQuery>;
export type ProductBoardRoadmapOkrProgressLazyQueryHookResult = ReturnType<typeof useProductBoardRoadmapOkrProgressLazyQuery>;
export type ProductBoardRoadmapOkrProgressQueryResult = Apollo.QueryResult<Types.ProductBoardRoadmapOkrProgressQuery, Types.ProductBoardRoadmapOkrProgressQueryVariables>;
export const ProductBoardItemsStatsDocument = gql`
    query ProductBoardItemsStats($filter: ProductBoardItemsFilterInput!) {
  productBoardItemsStats(filter: $filter) {
    totalRevenueImpact
    wonDealsRevenueImpact
    lostDealsRevenueImpact
    todaysDealsRevenueImpact
    percentComplete
  }
}
    `;

/**
 * __useProductBoardItemsStatsQuery__
 *
 * To run a query within a React component, call `useProductBoardItemsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardItemsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardItemsStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductBoardItemsStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardItemsStatsQuery, Types.ProductBoardItemsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardItemsStatsQuery, Types.ProductBoardItemsStatsQueryVariables>(ProductBoardItemsStatsDocument, options);
      }
export function useProductBoardItemsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardItemsStatsQuery, Types.ProductBoardItemsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardItemsStatsQuery, Types.ProductBoardItemsStatsQueryVariables>(ProductBoardItemsStatsDocument, options);
        }
export type ProductBoardItemsStatsQueryHookResult = ReturnType<typeof useProductBoardItemsStatsQuery>;
export type ProductBoardItemsStatsLazyQueryHookResult = ReturnType<typeof useProductBoardItemsStatsLazyQuery>;
export type ProductBoardItemsStatsQueryResult = Apollo.QueryResult<Types.ProductBoardItemsStatsQuery, Types.ProductBoardItemsStatsQueryVariables>;
export const ProductBoardKanbanMatrixDocument = gql`
    query ProductBoardKanbanMatrix($input: ProductBoardKanbanMatrixInput!) {
  productBoardKanbanMatrix(input: $input) {
    ...ProductBoardKanbanCell
  }
}
    ${ProductBoardKanbanCellFragmentDoc}`;

/**
 * __useProductBoardKanbanMatrixQuery__
 *
 * To run a query within a React component, call `useProductBoardKanbanMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardKanbanMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardKanbanMatrixQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductBoardKanbanMatrixQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardKanbanMatrixQuery, Types.ProductBoardKanbanMatrixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardKanbanMatrixQuery, Types.ProductBoardKanbanMatrixQueryVariables>(ProductBoardKanbanMatrixDocument, options);
      }
export function useProductBoardKanbanMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardKanbanMatrixQuery, Types.ProductBoardKanbanMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardKanbanMatrixQuery, Types.ProductBoardKanbanMatrixQueryVariables>(ProductBoardKanbanMatrixDocument, options);
        }
export type ProductBoardKanbanMatrixQueryHookResult = ReturnType<typeof useProductBoardKanbanMatrixQuery>;
export type ProductBoardKanbanMatrixLazyQueryHookResult = ReturnType<typeof useProductBoardKanbanMatrixLazyQuery>;
export type ProductBoardKanbanMatrixQueryResult = Apollo.QueryResult<Types.ProductBoardKanbanMatrixQuery, Types.ProductBoardKanbanMatrixQueryVariables>;
export const PublicProductBoardKanbanMatrixDocument = gql`
    query PublicProductBoardKanbanMatrix($input: ProductBoardKanbanMatrixInput!) {
  publicProductRoadmapKanbanMatrix(input: $input) {
    ...ProductBoardKanbanCell
  }
}
    ${ProductBoardKanbanCellFragmentDoc}`;

/**
 * __usePublicProductBoardKanbanMatrixQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardKanbanMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardKanbanMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardKanbanMatrixQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicProductBoardKanbanMatrixQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicProductBoardKanbanMatrixQuery, Types.PublicProductBoardKanbanMatrixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardKanbanMatrixQuery, Types.PublicProductBoardKanbanMatrixQueryVariables>(PublicProductBoardKanbanMatrixDocument, options);
      }
export function usePublicProductBoardKanbanMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardKanbanMatrixQuery, Types.PublicProductBoardKanbanMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardKanbanMatrixQuery, Types.PublicProductBoardKanbanMatrixQueryVariables>(PublicProductBoardKanbanMatrixDocument, options);
        }
export type PublicProductBoardKanbanMatrixQueryHookResult = ReturnType<typeof usePublicProductBoardKanbanMatrixQuery>;
export type PublicProductBoardKanbanMatrixLazyQueryHookResult = ReturnType<typeof usePublicProductBoardKanbanMatrixLazyQuery>;
export type PublicProductBoardKanbanMatrixQueryResult = Apollo.QueryResult<Types.PublicProductBoardKanbanMatrixQuery, Types.PublicProductBoardKanbanMatrixQueryVariables>;
export const ProductBoardRoadmapDocument = gql`
    query ProductBoardRoadmap($id: String!) {
  productBoardRoadmap(id: $id) {
    ...ProductBoardRoadmapWithItems
  }
}
    ${ProductBoardRoadmapWithItemsFragmentDoc}`;

/**
 * __useProductBoardRoadmapQuery__
 *
 * To run a query within a React component, call `useProductBoardRoadmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardRoadmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardRoadmapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductBoardRoadmapQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardRoadmapQuery, Types.ProductBoardRoadmapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardRoadmapQuery, Types.ProductBoardRoadmapQueryVariables>(ProductBoardRoadmapDocument, options);
      }
export function useProductBoardRoadmapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardRoadmapQuery, Types.ProductBoardRoadmapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardRoadmapQuery, Types.ProductBoardRoadmapQueryVariables>(ProductBoardRoadmapDocument, options);
        }
export type ProductBoardRoadmapQueryHookResult = ReturnType<typeof useProductBoardRoadmapQuery>;
export type ProductBoardRoadmapLazyQueryHookResult = ReturnType<typeof useProductBoardRoadmapLazyQuery>;
export type ProductBoardRoadmapQueryResult = Apollo.QueryResult<Types.ProductBoardRoadmapQuery, Types.ProductBoardRoadmapQueryVariables>;
export const PublicProductBoardRoadmapDocument = gql`
    query PublicProductBoardRoadmap($id: String!) {
  publicProductRoadmap(id: $id) {
    ...ProductBoardRoadmapWithItems
  }
}
    ${ProductBoardRoadmapWithItemsFragmentDoc}`;

/**
 * __usePublicProductBoardRoadmapQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardRoadmapQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardRoadmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardRoadmapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicProductBoardRoadmapQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicProductBoardRoadmapQuery, Types.PublicProductBoardRoadmapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardRoadmapQuery, Types.PublicProductBoardRoadmapQueryVariables>(PublicProductBoardRoadmapDocument, options);
      }
export function usePublicProductBoardRoadmapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardRoadmapQuery, Types.PublicProductBoardRoadmapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardRoadmapQuery, Types.PublicProductBoardRoadmapQueryVariables>(PublicProductBoardRoadmapDocument, options);
        }
export type PublicProductBoardRoadmapQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapQuery>;
export type PublicProductBoardRoadmapLazyQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapLazyQuery>;
export type PublicProductBoardRoadmapQueryResult = Apollo.QueryResult<Types.PublicProductBoardRoadmapQuery, Types.PublicProductBoardRoadmapQueryVariables>;
export const ProductBoardRoadmapItemsForDependenciesDocument = gql`
    query ProductBoardRoadmapItemsForDependencies($id: String!) {
  productBoardRoadmap(id: $id) {
    id
    items {
      limit
      page
      totalPages
      docs {
        ...ProductBoardItemDependency
      }
    }
  }
}
    ${ProductBoardItemDependencyFragmentDoc}`;

/**
 * __useProductBoardRoadmapItemsForDependenciesQuery__
 *
 * To run a query within a React component, call `useProductBoardRoadmapItemsForDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardRoadmapItemsForDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardRoadmapItemsForDependenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductBoardRoadmapItemsForDependenciesQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardRoadmapItemsForDependenciesQuery, Types.ProductBoardRoadmapItemsForDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardRoadmapItemsForDependenciesQuery, Types.ProductBoardRoadmapItemsForDependenciesQueryVariables>(ProductBoardRoadmapItemsForDependenciesDocument, options);
      }
export function useProductBoardRoadmapItemsForDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardRoadmapItemsForDependenciesQuery, Types.ProductBoardRoadmapItemsForDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardRoadmapItemsForDependenciesQuery, Types.ProductBoardRoadmapItemsForDependenciesQueryVariables>(ProductBoardRoadmapItemsForDependenciesDocument, options);
        }
export type ProductBoardRoadmapItemsForDependenciesQueryHookResult = ReturnType<typeof useProductBoardRoadmapItemsForDependenciesQuery>;
export type ProductBoardRoadmapItemsForDependenciesLazyQueryHookResult = ReturnType<typeof useProductBoardRoadmapItemsForDependenciesLazyQuery>;
export type ProductBoardRoadmapItemsForDependenciesQueryResult = Apollo.QueryResult<Types.ProductBoardRoadmapItemsForDependenciesQuery, Types.ProductBoardRoadmapItemsForDependenciesQueryVariables>;
export const PublicProductBoardRoadmapItemsForDependenciesDocument = gql`
    query PublicProductBoardRoadmapItemsForDependencies($id: String!) {
  publicProductRoadmap(id: $id) {
    id
    items {
      limit
      page
      totalPages
      docs {
        ...ProductBoardItemDependency
      }
    }
  }
}
    ${ProductBoardItemDependencyFragmentDoc}`;

/**
 * __usePublicProductBoardRoadmapItemsForDependenciesQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardRoadmapItemsForDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardRoadmapItemsForDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardRoadmapItemsForDependenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicProductBoardRoadmapItemsForDependenciesQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicProductBoardRoadmapItemsForDependenciesQuery, Types.PublicProductBoardRoadmapItemsForDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardRoadmapItemsForDependenciesQuery, Types.PublicProductBoardRoadmapItemsForDependenciesQueryVariables>(PublicProductBoardRoadmapItemsForDependenciesDocument, options);
      }
export function usePublicProductBoardRoadmapItemsForDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardRoadmapItemsForDependenciesQuery, Types.PublicProductBoardRoadmapItemsForDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardRoadmapItemsForDependenciesQuery, Types.PublicProductBoardRoadmapItemsForDependenciesQueryVariables>(PublicProductBoardRoadmapItemsForDependenciesDocument, options);
        }
export type PublicProductBoardRoadmapItemsForDependenciesQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapItemsForDependenciesQuery>;
export type PublicProductBoardRoadmapItemsForDependenciesLazyQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapItemsForDependenciesLazyQuery>;
export type PublicProductBoardRoadmapItemsForDependenciesQueryResult = Apollo.QueryResult<Types.PublicProductBoardRoadmapItemsForDependenciesQuery, Types.PublicProductBoardRoadmapItemsForDependenciesQueryVariables>;
export const ProductBoardRoadmapsForDependenciesDocument = gql`
    query ProductBoardRoadmapsForDependencies($input: ProductBoardRoadmapsInput) {
  productBoardRoadmaps(input: $input) {
    ...ProductBoardRoadmapForDepencies
  }
}
    ${ProductBoardRoadmapForDepenciesFragmentDoc}`;

/**
 * __useProductBoardRoadmapsForDependenciesQuery__
 *
 * To run a query within a React component, call `useProductBoardRoadmapsForDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardRoadmapsForDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardRoadmapsForDependenciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductBoardRoadmapsForDependenciesQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardRoadmapsForDependenciesQuery, Types.ProductBoardRoadmapsForDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardRoadmapsForDependenciesQuery, Types.ProductBoardRoadmapsForDependenciesQueryVariables>(ProductBoardRoadmapsForDependenciesDocument, options);
      }
export function useProductBoardRoadmapsForDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardRoadmapsForDependenciesQuery, Types.ProductBoardRoadmapsForDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardRoadmapsForDependenciesQuery, Types.ProductBoardRoadmapsForDependenciesQueryVariables>(ProductBoardRoadmapsForDependenciesDocument, options);
        }
export type ProductBoardRoadmapsForDependenciesQueryHookResult = ReturnType<typeof useProductBoardRoadmapsForDependenciesQuery>;
export type ProductBoardRoadmapsForDependenciesLazyQueryHookResult = ReturnType<typeof useProductBoardRoadmapsForDependenciesLazyQuery>;
export type ProductBoardRoadmapsForDependenciesQueryResult = Apollo.QueryResult<Types.ProductBoardRoadmapsForDependenciesQuery, Types.ProductBoardRoadmapsForDependenciesQueryVariables>;
export const PublicProductBoardRoadmapsForDependenciesDocument = gql`
    query PublicProductBoardRoadmapsForDependencies($input: ProductBoardRoadmapsInput) {
  publicProductRoadmaps(input: $input) {
    ...ProductBoardRoadmapForDepencies
  }
}
    ${ProductBoardRoadmapForDepenciesFragmentDoc}`;

/**
 * __usePublicProductBoardRoadmapsForDependenciesQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardRoadmapsForDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardRoadmapsForDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardRoadmapsForDependenciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicProductBoardRoadmapsForDependenciesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductBoardRoadmapsForDependenciesQuery, Types.PublicProductBoardRoadmapsForDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardRoadmapsForDependenciesQuery, Types.PublicProductBoardRoadmapsForDependenciesQueryVariables>(PublicProductBoardRoadmapsForDependenciesDocument, options);
      }
export function usePublicProductBoardRoadmapsForDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardRoadmapsForDependenciesQuery, Types.PublicProductBoardRoadmapsForDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardRoadmapsForDependenciesQuery, Types.PublicProductBoardRoadmapsForDependenciesQueryVariables>(PublicProductBoardRoadmapsForDependenciesDocument, options);
        }
export type PublicProductBoardRoadmapsForDependenciesQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapsForDependenciesQuery>;
export type PublicProductBoardRoadmapsForDependenciesLazyQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapsForDependenciesLazyQuery>;
export type PublicProductBoardRoadmapsForDependenciesQueryResult = Apollo.QueryResult<Types.PublicProductBoardRoadmapsForDependenciesQuery, Types.PublicProductBoardRoadmapsForDependenciesQueryVariables>;
export const ProductBoardRoadmapsPreviewDocument = gql`
    query ProductBoardRoadmapsPreview($input: ProductBoardRoadmapsInput) {
  productBoardRoadmaps(input: $input) {
    ...ProductBoardRoadmapPreview
  }
}
    ${ProductBoardRoadmapPreviewFragmentDoc}`;

/**
 * __useProductBoardRoadmapsPreviewQuery__
 *
 * To run a query within a React component, call `useProductBoardRoadmapsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardRoadmapsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardRoadmapsPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductBoardRoadmapsPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardRoadmapsPreviewQuery, Types.ProductBoardRoadmapsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardRoadmapsPreviewQuery, Types.ProductBoardRoadmapsPreviewQueryVariables>(ProductBoardRoadmapsPreviewDocument, options);
      }
export function useProductBoardRoadmapsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardRoadmapsPreviewQuery, Types.ProductBoardRoadmapsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardRoadmapsPreviewQuery, Types.ProductBoardRoadmapsPreviewQueryVariables>(ProductBoardRoadmapsPreviewDocument, options);
        }
export type ProductBoardRoadmapsPreviewQueryHookResult = ReturnType<typeof useProductBoardRoadmapsPreviewQuery>;
export type ProductBoardRoadmapsPreviewLazyQueryHookResult = ReturnType<typeof useProductBoardRoadmapsPreviewLazyQuery>;
export type ProductBoardRoadmapsPreviewQueryResult = Apollo.QueryResult<Types.ProductBoardRoadmapsPreviewQuery, Types.ProductBoardRoadmapsPreviewQueryVariables>;
export const PublicProductBoardRoadmapsPreviewDocument = gql`
    query PublicProductBoardRoadmapsPreview($input: ProductBoardRoadmapsInput) {
  publicProductRoadmaps(input: $input) {
    ...ProductBoardRoadmapPreview
  }
}
    ${ProductBoardRoadmapPreviewFragmentDoc}`;

/**
 * __usePublicProductBoardRoadmapsPreviewQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardRoadmapsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardRoadmapsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardRoadmapsPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicProductBoardRoadmapsPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductBoardRoadmapsPreviewQuery, Types.PublicProductBoardRoadmapsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardRoadmapsPreviewQuery, Types.PublicProductBoardRoadmapsPreviewQueryVariables>(PublicProductBoardRoadmapsPreviewDocument, options);
      }
export function usePublicProductBoardRoadmapsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardRoadmapsPreviewQuery, Types.PublicProductBoardRoadmapsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardRoadmapsPreviewQuery, Types.PublicProductBoardRoadmapsPreviewQueryVariables>(PublicProductBoardRoadmapsPreviewDocument, options);
        }
export type PublicProductBoardRoadmapsPreviewQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapsPreviewQuery>;
export type PublicProductBoardRoadmapsPreviewLazyQueryHookResult = ReturnType<typeof usePublicProductBoardRoadmapsPreviewLazyQuery>;
export type PublicProductBoardRoadmapsPreviewQueryResult = Apollo.QueryResult<Types.PublicProductBoardRoadmapsPreviewQuery, Types.PublicProductBoardRoadmapsPreviewQueryVariables>;
export const ProductRoadmapIdsDocument = gql`
    query ProductRoadmapIds($input: ProductBoardRoadmapsInput) {
  productBoardRoadmaps(input: $input) {
    id
  }
}
    `;

/**
 * __useProductRoadmapIdsQuery__
 *
 * To run a query within a React component, call `useProductRoadmapIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRoadmapIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRoadmapIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductRoadmapIdsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductRoadmapIdsQuery, Types.ProductRoadmapIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductRoadmapIdsQuery, Types.ProductRoadmapIdsQueryVariables>(ProductRoadmapIdsDocument, options);
      }
export function useProductRoadmapIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductRoadmapIdsQuery, Types.ProductRoadmapIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductRoadmapIdsQuery, Types.ProductRoadmapIdsQueryVariables>(ProductRoadmapIdsDocument, options);
        }
export type ProductRoadmapIdsQueryHookResult = ReturnType<typeof useProductRoadmapIdsQuery>;
export type ProductRoadmapIdsLazyQueryHookResult = ReturnType<typeof useProductRoadmapIdsLazyQuery>;
export type ProductRoadmapIdsQueryResult = Apollo.QueryResult<Types.ProductRoadmapIdsQuery, Types.ProductRoadmapIdsQueryVariables>;
export const PublicProductRoadmapIdsDocument = gql`
    query PublicProductRoadmapIds($input: ProductBoardRoadmapsInput) {
  publicProductRoadmaps(input: $input) {
    id
  }
}
    `;

/**
 * __usePublicProductRoadmapIdsQuery__
 *
 * To run a query within a React component, call `usePublicProductRoadmapIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductRoadmapIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductRoadmapIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicProductRoadmapIdsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductRoadmapIdsQuery, Types.PublicProductRoadmapIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductRoadmapIdsQuery, Types.PublicProductRoadmapIdsQueryVariables>(PublicProductRoadmapIdsDocument, options);
      }
export function usePublicProductRoadmapIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductRoadmapIdsQuery, Types.PublicProductRoadmapIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductRoadmapIdsQuery, Types.PublicProductRoadmapIdsQueryVariables>(PublicProductRoadmapIdsDocument, options);
        }
export type PublicProductRoadmapIdsQueryHookResult = ReturnType<typeof usePublicProductRoadmapIdsQuery>;
export type PublicProductRoadmapIdsLazyQueryHookResult = ReturnType<typeof usePublicProductRoadmapIdsLazyQuery>;
export type PublicProductRoadmapIdsQueryResult = Apollo.QueryResult<Types.PublicProductRoadmapIdsQuery, Types.PublicProductRoadmapIdsQueryVariables>;
export const CreateProductBoardFactorDocument = gql`
    mutation CreateProductBoardFactor($input: CreateProductBoardFactorInput!) {
  createProductBoardFactor(input: $input) {
    ...ProductBoardFactor
  }
}
    ${ProductBoardFactorFragmentDoc}`;
export type CreateProductBoardFactorMutationFn = Apollo.MutationFunction<Types.CreateProductBoardFactorMutation, Types.CreateProductBoardFactorMutationVariables>;

/**
 * __useCreateProductBoardFactorMutation__
 *
 * To run a mutation, you first call `useCreateProductBoardFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBoardFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBoardFactorMutation, { data, loading, error }] = useCreateProductBoardFactorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductBoardFactorMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductBoardFactorMutation, Types.CreateProductBoardFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductBoardFactorMutation, Types.CreateProductBoardFactorMutationVariables>(CreateProductBoardFactorDocument, options);
      }
export type CreateProductBoardFactorMutationHookResult = ReturnType<typeof useCreateProductBoardFactorMutation>;
export type CreateProductBoardFactorMutationResult = Apollo.MutationResult<Types.CreateProductBoardFactorMutation>;
export type CreateProductBoardFactorMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductBoardFactorMutation, Types.CreateProductBoardFactorMutationVariables>;
export const DeleteProductBoardFactorDocument = gql`
    mutation DeleteProductBoardFactor($id: String!) {
  deleteProductBoardFactor(id: $id) {
    id
  }
}
    `;
export type DeleteProductBoardFactorMutationFn = Apollo.MutationFunction<Types.DeleteProductBoardFactorMutation, Types.DeleteProductBoardFactorMutationVariables>;

/**
 * __useDeleteProductBoardFactorMutation__
 *
 * To run a mutation, you first call `useDeleteProductBoardFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductBoardFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductBoardFactorMutation, { data, loading, error }] = useDeleteProductBoardFactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductBoardFactorMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductBoardFactorMutation, Types.DeleteProductBoardFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductBoardFactorMutation, Types.DeleteProductBoardFactorMutationVariables>(DeleteProductBoardFactorDocument, options);
      }
export type DeleteProductBoardFactorMutationHookResult = ReturnType<typeof useDeleteProductBoardFactorMutation>;
export type DeleteProductBoardFactorMutationResult = Apollo.MutationResult<Types.DeleteProductBoardFactorMutation>;
export type DeleteProductBoardFactorMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductBoardFactorMutation, Types.DeleteProductBoardFactorMutationVariables>;
export const UpdateProductBoardFactorDocument = gql`
    mutation UpdateProductBoardFactor($input: UpdateProductBoardFactorInput!) {
  updateProductBoardFactor(input: $input) {
    ...ProductBoardFactor
  }
}
    ${ProductBoardFactorFragmentDoc}`;
export type UpdateProductBoardFactorMutationFn = Apollo.MutationFunction<Types.UpdateProductBoardFactorMutation, Types.UpdateProductBoardFactorMutationVariables>;

/**
 * __useUpdateProductBoardFactorMutation__
 *
 * To run a mutation, you first call `useUpdateProductBoardFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBoardFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBoardFactorMutation, { data, loading, error }] = useUpdateProductBoardFactorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBoardFactorMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductBoardFactorMutation, Types.UpdateProductBoardFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductBoardFactorMutation, Types.UpdateProductBoardFactorMutationVariables>(UpdateProductBoardFactorDocument, options);
      }
export type UpdateProductBoardFactorMutationHookResult = ReturnType<typeof useUpdateProductBoardFactorMutation>;
export type UpdateProductBoardFactorMutationResult = Apollo.MutationResult<Types.UpdateProductBoardFactorMutation>;
export type UpdateProductBoardFactorMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductBoardFactorMutation, Types.UpdateProductBoardFactorMutationVariables>;
export const ProductBoardFactorsDocument = gql`
    query ProductBoardFactors {
  productBoardFactors {
    ...ProductBoardFactor
  }
}
    ${ProductBoardFactorFragmentDoc}`;

/**
 * __useProductBoardFactorsQuery__
 *
 * To run a query within a React component, call `useProductBoardFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardFactorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBoardFactorsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardFactorsQuery, Types.ProductBoardFactorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardFactorsQuery, Types.ProductBoardFactorsQueryVariables>(ProductBoardFactorsDocument, options);
      }
export function useProductBoardFactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardFactorsQuery, Types.ProductBoardFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardFactorsQuery, Types.ProductBoardFactorsQueryVariables>(ProductBoardFactorsDocument, options);
        }
export type ProductBoardFactorsQueryHookResult = ReturnType<typeof useProductBoardFactorsQuery>;
export type ProductBoardFactorsLazyQueryHookResult = ReturnType<typeof useProductBoardFactorsLazyQuery>;
export type ProductBoardFactorsQueryResult = Apollo.QueryResult<Types.ProductBoardFactorsQuery, Types.ProductBoardFactorsQueryVariables>;
export const PublicProductBoardFactorsDocument = gql`
    query PublicProductBoardFactors {
  publicProductRoadmapFactors {
    ...ProductBoardFactor
  }
}
    ${ProductBoardFactorFragmentDoc}`;

/**
 * __usePublicProductBoardFactorsQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardFactorsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicProductBoardFactorsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductBoardFactorsQuery, Types.PublicProductBoardFactorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardFactorsQuery, Types.PublicProductBoardFactorsQueryVariables>(PublicProductBoardFactorsDocument, options);
      }
export function usePublicProductBoardFactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardFactorsQuery, Types.PublicProductBoardFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardFactorsQuery, Types.PublicProductBoardFactorsQueryVariables>(PublicProductBoardFactorsDocument, options);
        }
export type PublicProductBoardFactorsQueryHookResult = ReturnType<typeof usePublicProductBoardFactorsQuery>;
export type PublicProductBoardFactorsLazyQueryHookResult = ReturnType<typeof usePublicProductBoardFactorsLazyQuery>;
export type PublicProductBoardFactorsQueryResult = Apollo.QueryResult<Types.PublicProductBoardFactorsQuery, Types.PublicProductBoardFactorsQueryVariables>;
export const AddProductBoardItemDependencyDocument = gql`
    mutation AddProductBoardItemDependency($input: AddProductBoardItemDependencyInput!) {
  addProductBoardItemDependency(input: $input) {
    blockingItem {
      id
      updatedAt
      blockingItems {
        ...ProductBoardItemDependency
      }
      status {
        ...ProductBoardStatusPreview
      }
    }
    blockedByItem {
      id
      updatedAt
      blockedByItems {
        ...ProductBoardItemDependency
      }
      status {
        ...ProductBoardStatusPreview
      }
    }
  }
}
    ${ProductBoardItemDependencyFragmentDoc}
${ProductBoardStatusPreviewFragmentDoc}`;
export type AddProductBoardItemDependencyMutationFn = Apollo.MutationFunction<Types.AddProductBoardItemDependencyMutation, Types.AddProductBoardItemDependencyMutationVariables>;

/**
 * __useAddProductBoardItemDependencyMutation__
 *
 * To run a mutation, you first call `useAddProductBoardItemDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductBoardItemDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductBoardItemDependencyMutation, { data, loading, error }] = useAddProductBoardItemDependencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductBoardItemDependencyMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddProductBoardItemDependencyMutation, Types.AddProductBoardItemDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddProductBoardItemDependencyMutation, Types.AddProductBoardItemDependencyMutationVariables>(AddProductBoardItemDependencyDocument, options);
      }
export type AddProductBoardItemDependencyMutationHookResult = ReturnType<typeof useAddProductBoardItemDependencyMutation>;
export type AddProductBoardItemDependencyMutationResult = Apollo.MutationResult<Types.AddProductBoardItemDependencyMutation>;
export type AddProductBoardItemDependencyMutationOptions = Apollo.BaseMutationOptions<Types.AddProductBoardItemDependencyMutation, Types.AddProductBoardItemDependencyMutationVariables>;
export const AttachIntegrationTasksToProductBoardItemDocument = gql`
    mutation AttachIntegrationTasksToProductBoardItem($input: AttachIntegrationTasksToProductBoardItemInput!) {
  attachIntegrationTasksToProductBoardItem(input: $input) {
    id
  }
}
    `;
export type AttachIntegrationTasksToProductBoardItemMutationFn = Apollo.MutationFunction<Types.AttachIntegrationTasksToProductBoardItemMutation, Types.AttachIntegrationTasksToProductBoardItemMutationVariables>;

/**
 * __useAttachIntegrationTasksToProductBoardItemMutation__
 *
 * To run a mutation, you first call `useAttachIntegrationTasksToProductBoardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachIntegrationTasksToProductBoardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachIntegrationTasksToProductBoardItemMutation, { data, loading, error }] = useAttachIntegrationTasksToProductBoardItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachIntegrationTasksToProductBoardItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttachIntegrationTasksToProductBoardItemMutation, Types.AttachIntegrationTasksToProductBoardItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttachIntegrationTasksToProductBoardItemMutation, Types.AttachIntegrationTasksToProductBoardItemMutationVariables>(AttachIntegrationTasksToProductBoardItemDocument, options);
      }
export type AttachIntegrationTasksToProductBoardItemMutationHookResult = ReturnType<typeof useAttachIntegrationTasksToProductBoardItemMutation>;
export type AttachIntegrationTasksToProductBoardItemMutationResult = Apollo.MutationResult<Types.AttachIntegrationTasksToProductBoardItemMutation>;
export type AttachIntegrationTasksToProductBoardItemMutationOptions = Apollo.BaseMutationOptions<Types.AttachIntegrationTasksToProductBoardItemMutation, Types.AttachIntegrationTasksToProductBoardItemMutationVariables>;
export const ConnectProductBoardItemsToLaunchDocument = gql`
    mutation ConnectProductBoardItemsToLaunch($launchId: String!, $productBoardItemsIds: [String!]!) {
  connectProductBoardItemsToLaunch(
    launchId: $launchId
    productBoardItemsIds: $productBoardItemsIds
  ) {
    ...ProductBoardItemTableRow
  }
}
    ${ProductBoardItemTableRowFragmentDoc}`;
export type ConnectProductBoardItemsToLaunchMutationFn = Apollo.MutationFunction<Types.ConnectProductBoardItemsToLaunchMutation, Types.ConnectProductBoardItemsToLaunchMutationVariables>;

/**
 * __useConnectProductBoardItemsToLaunchMutation__
 *
 * To run a mutation, you first call `useConnectProductBoardItemsToLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectProductBoardItemsToLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectProductBoardItemsToLaunchMutation, { data, loading, error }] = useConnectProductBoardItemsToLaunchMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      productBoardItemsIds: // value for 'productBoardItemsIds'
 *   },
 * });
 */
export function useConnectProductBoardItemsToLaunchMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConnectProductBoardItemsToLaunchMutation, Types.ConnectProductBoardItemsToLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConnectProductBoardItemsToLaunchMutation, Types.ConnectProductBoardItemsToLaunchMutationVariables>(ConnectProductBoardItemsToLaunchDocument, options);
      }
export type ConnectProductBoardItemsToLaunchMutationHookResult = ReturnType<typeof useConnectProductBoardItemsToLaunchMutation>;
export type ConnectProductBoardItemsToLaunchMutationResult = Apollo.MutationResult<Types.ConnectProductBoardItemsToLaunchMutation>;
export type ConnectProductBoardItemsToLaunchMutationOptions = Apollo.BaseMutationOptions<Types.ConnectProductBoardItemsToLaunchMutation, Types.ConnectProductBoardItemsToLaunchMutationVariables>;
export const CreateProductBoardItemDocument = gql`
    mutation CreateProductBoardItem($input: CreateProductBoardItemInput!) {
  createProductBoardItem(input: $input) {
    ...ProductBoardItemDetailed
  }
}
    ${ProductBoardItemDetailedFragmentDoc}`;
export type CreateProductBoardItemMutationFn = Apollo.MutationFunction<Types.CreateProductBoardItemMutation, Types.CreateProductBoardItemMutationVariables>;

/**
 * __useCreateProductBoardItemMutation__
 *
 * To run a mutation, you first call `useCreateProductBoardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBoardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBoardItemMutation, { data, loading, error }] = useCreateProductBoardItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductBoardItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductBoardItemMutation, Types.CreateProductBoardItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductBoardItemMutation, Types.CreateProductBoardItemMutationVariables>(CreateProductBoardItemDocument, options);
      }
export type CreateProductBoardItemMutationHookResult = ReturnType<typeof useCreateProductBoardItemMutation>;
export type CreateProductBoardItemMutationResult = Apollo.MutationResult<Types.CreateProductBoardItemMutation>;
export type CreateProductBoardItemMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductBoardItemMutation, Types.CreateProductBoardItemMutationVariables>;
export const DeleteProductBoardItemsDocument = gql`
    mutation DeleteProductBoardItems($ids: [String!]!) {
  deleteProductBoardItems(ids: $ids) {
    id
  }
}
    `;
export type DeleteProductBoardItemsMutationFn = Apollo.MutationFunction<Types.DeleteProductBoardItemsMutation, Types.DeleteProductBoardItemsMutationVariables>;

/**
 * __useDeleteProductBoardItemsMutation__
 *
 * To run a mutation, you first call `useDeleteProductBoardItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductBoardItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductBoardItemsMutation, { data, loading, error }] = useDeleteProductBoardItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProductBoardItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductBoardItemsMutation, Types.DeleteProductBoardItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductBoardItemsMutation, Types.DeleteProductBoardItemsMutationVariables>(DeleteProductBoardItemsDocument, options);
      }
export type DeleteProductBoardItemsMutationHookResult = ReturnType<typeof useDeleteProductBoardItemsMutation>;
export type DeleteProductBoardItemsMutationResult = Apollo.MutationResult<Types.DeleteProductBoardItemsMutation>;
export type DeleteProductBoardItemsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductBoardItemsMutation, Types.DeleteProductBoardItemsMutationVariables>;
export const DetachEngineeringTaskFromRoadmapItemDocument = gql`
    mutation DetachEngineeringTaskFromRoadmapItem($input: AttachIntegrationTasksToProductBoardItemInput!) {
  removeIntegrationTasksFromProductBoardItem(input: $input) {
    id
  }
}
    `;
export type DetachEngineeringTaskFromRoadmapItemMutationFn = Apollo.MutationFunction<Types.DetachEngineeringTaskFromRoadmapItemMutation, Types.DetachEngineeringTaskFromRoadmapItemMutationVariables>;

/**
 * __useDetachEngineeringTaskFromRoadmapItemMutation__
 *
 * To run a mutation, you first call `useDetachEngineeringTaskFromRoadmapItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachEngineeringTaskFromRoadmapItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachEngineeringTaskFromRoadmapItemMutation, { data, loading, error }] = useDetachEngineeringTaskFromRoadmapItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetachEngineeringTaskFromRoadmapItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.DetachEngineeringTaskFromRoadmapItemMutation, Types.DetachEngineeringTaskFromRoadmapItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DetachEngineeringTaskFromRoadmapItemMutation, Types.DetachEngineeringTaskFromRoadmapItemMutationVariables>(DetachEngineeringTaskFromRoadmapItemDocument, options);
      }
export type DetachEngineeringTaskFromRoadmapItemMutationHookResult = ReturnType<typeof useDetachEngineeringTaskFromRoadmapItemMutation>;
export type DetachEngineeringTaskFromRoadmapItemMutationResult = Apollo.MutationResult<Types.DetachEngineeringTaskFromRoadmapItemMutation>;
export type DetachEngineeringTaskFromRoadmapItemMutationOptions = Apollo.BaseMutationOptions<Types.DetachEngineeringTaskFromRoadmapItemMutation, Types.DetachEngineeringTaskFromRoadmapItemMutationVariables>;
export const DragProductBoardItemDocument = gql`
    mutation DragProductBoardItem($input: DragInput!) {
  dragProductBoardItem(input: $input) {
    ...ProductBoardItemTableRow
  }
}
    ${ProductBoardItemTableRowFragmentDoc}`;
export type DragProductBoardItemMutationFn = Apollo.MutationFunction<Types.DragProductBoardItemMutation, Types.DragProductBoardItemMutationVariables>;

/**
 * __useDragProductBoardItemMutation__
 *
 * To run a mutation, you first call `useDragProductBoardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDragProductBoardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dragProductBoardItemMutation, { data, loading, error }] = useDragProductBoardItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDragProductBoardItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.DragProductBoardItemMutation, Types.DragProductBoardItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DragProductBoardItemMutation, Types.DragProductBoardItemMutationVariables>(DragProductBoardItemDocument, options);
      }
export type DragProductBoardItemMutationHookResult = ReturnType<typeof useDragProductBoardItemMutation>;
export type DragProductBoardItemMutationResult = Apollo.MutationResult<Types.DragProductBoardItemMutation>;
export type DragProductBoardItemMutationOptions = Apollo.BaseMutationOptions<Types.DragProductBoardItemMutation, Types.DragProductBoardItemMutationVariables>;
export const ExportProductBoardItemsToCsvDocument = gql`
    mutation ExportProductBoardItemsToCsv($filter: ProductBoardItemsFilterInput) {
  exportProductBoardItemsToCsv(filter: $filter)
}
    `;
export type ExportProductBoardItemsToCsvMutationFn = Apollo.MutationFunction<Types.ExportProductBoardItemsToCsvMutation, Types.ExportProductBoardItemsToCsvMutationVariables>;

/**
 * __useExportProductBoardItemsToCsvMutation__
 *
 * To run a mutation, you first call `useExportProductBoardItemsToCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportProductBoardItemsToCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportProductBoardItemsToCsvMutation, { data, loading, error }] = useExportProductBoardItemsToCsvMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportProductBoardItemsToCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportProductBoardItemsToCsvMutation, Types.ExportProductBoardItemsToCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportProductBoardItemsToCsvMutation, Types.ExportProductBoardItemsToCsvMutationVariables>(ExportProductBoardItemsToCsvDocument, options);
      }
export type ExportProductBoardItemsToCsvMutationHookResult = ReturnType<typeof useExportProductBoardItemsToCsvMutation>;
export type ExportProductBoardItemsToCsvMutationResult = Apollo.MutationResult<Types.ExportProductBoardItemsToCsvMutation>;
export type ExportProductBoardItemsToCsvMutationOptions = Apollo.BaseMutationOptions<Types.ExportProductBoardItemsToCsvMutation, Types.ExportProductBoardItemsToCsvMutationVariables>;
export const ImportProductBoardItemsFromCsvDocument = gql`
    mutation ImportProductBoardItemsFromCsv($input: ImportProductBoardItemsFromCsvInput!) {
  importProductBoardItemsFromCsv(input: $input) {
    ...ProductBoardItemTableRow
  }
}
    ${ProductBoardItemTableRowFragmentDoc}`;
export type ImportProductBoardItemsFromCsvMutationFn = Apollo.MutationFunction<Types.ImportProductBoardItemsFromCsvMutation, Types.ImportProductBoardItemsFromCsvMutationVariables>;

/**
 * __useImportProductBoardItemsFromCsvMutation__
 *
 * To run a mutation, you first call `useImportProductBoardItemsFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportProductBoardItemsFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importProductBoardItemsFromCsvMutation, { data, loading, error }] = useImportProductBoardItemsFromCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportProductBoardItemsFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportProductBoardItemsFromCsvMutation, Types.ImportProductBoardItemsFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportProductBoardItemsFromCsvMutation, Types.ImportProductBoardItemsFromCsvMutationVariables>(ImportProductBoardItemsFromCsvDocument, options);
      }
export type ImportProductBoardItemsFromCsvMutationHookResult = ReturnType<typeof useImportProductBoardItemsFromCsvMutation>;
export type ImportProductBoardItemsFromCsvMutationResult = Apollo.MutationResult<Types.ImportProductBoardItemsFromCsvMutation>;
export type ImportProductBoardItemsFromCsvMutationOptions = Apollo.BaseMutationOptions<Types.ImportProductBoardItemsFromCsvMutation, Types.ImportProductBoardItemsFromCsvMutationVariables>;
export const RemoveProductBoardItemDependencyDocument = gql`
    mutation RemoveProductBoardItemDependency($input: RemoveProductBoardItemDependencyInput!) {
  removeProductBoardItemDependency(input: $input) {
    blockingItem {
      id
      updatedAt
      blockingItems {
        ...ProductBoardItemDependency
      }
    }
    blockedByItem {
      id
      updatedAt
      blockedByItems {
        ...ProductBoardItemDependency
      }
    }
  }
}
    ${ProductBoardItemDependencyFragmentDoc}`;
export type RemoveProductBoardItemDependencyMutationFn = Apollo.MutationFunction<Types.RemoveProductBoardItemDependencyMutation, Types.RemoveProductBoardItemDependencyMutationVariables>;

/**
 * __useRemoveProductBoardItemDependencyMutation__
 *
 * To run a mutation, you first call `useRemoveProductBoardItemDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductBoardItemDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductBoardItemDependencyMutation, { data, loading, error }] = useRemoveProductBoardItemDependencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProductBoardItemDependencyMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveProductBoardItemDependencyMutation, Types.RemoveProductBoardItemDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveProductBoardItemDependencyMutation, Types.RemoveProductBoardItemDependencyMutationVariables>(RemoveProductBoardItemDependencyDocument, options);
      }
export type RemoveProductBoardItemDependencyMutationHookResult = ReturnType<typeof useRemoveProductBoardItemDependencyMutation>;
export type RemoveProductBoardItemDependencyMutationResult = Apollo.MutationResult<Types.RemoveProductBoardItemDependencyMutation>;
export type RemoveProductBoardItemDependencyMutationOptions = Apollo.BaseMutationOptions<Types.RemoveProductBoardItemDependencyMutation, Types.RemoveProductBoardItemDependencyMutationVariables>;
export const UpdateBlockingProductBoardItemDocument = gql`
    mutation UpdateBlockingProductBoardItem($input: UpdateProductBoardItemInput!) {
  updateProductBoardItem(input: $input) {
    ...BlockingProductBoardItem
  }
}
    ${BlockingProductBoardItemFragmentDoc}`;
export type UpdateBlockingProductBoardItemMutationFn = Apollo.MutationFunction<Types.UpdateBlockingProductBoardItemMutation, Types.UpdateBlockingProductBoardItemMutationVariables>;

/**
 * __useUpdateBlockingProductBoardItemMutation__
 *
 * To run a mutation, you first call `useUpdateBlockingProductBoardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockingProductBoardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockingProductBoardItemMutation, { data, loading, error }] = useUpdateBlockingProductBoardItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlockingProductBoardItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBlockingProductBoardItemMutation, Types.UpdateBlockingProductBoardItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBlockingProductBoardItemMutation, Types.UpdateBlockingProductBoardItemMutationVariables>(UpdateBlockingProductBoardItemDocument, options);
      }
export type UpdateBlockingProductBoardItemMutationHookResult = ReturnType<typeof useUpdateBlockingProductBoardItemMutation>;
export type UpdateBlockingProductBoardItemMutationResult = Apollo.MutationResult<Types.UpdateBlockingProductBoardItemMutation>;
export type UpdateBlockingProductBoardItemMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBlockingProductBoardItemMutation, Types.UpdateBlockingProductBoardItemMutationVariables>;
export const UpdateProductBoardItemDocument = gql`
    mutation UpdateProductBoardItem($input: UpdateProductBoardItemInput!) {
  updateProductBoardItem(input: $input) {
    ...ProductBoardItemDetailed
  }
}
    ${ProductBoardItemDetailedFragmentDoc}`;
export type UpdateProductBoardItemMutationFn = Apollo.MutationFunction<Types.UpdateProductBoardItemMutation, Types.UpdateProductBoardItemMutationVariables>;

/**
 * __useUpdateProductBoardItemMutation__
 *
 * To run a mutation, you first call `useUpdateProductBoardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBoardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBoardItemMutation, { data, loading, error }] = useUpdateProductBoardItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBoardItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductBoardItemMutation, Types.UpdateProductBoardItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductBoardItemMutation, Types.UpdateProductBoardItemMutationVariables>(UpdateProductBoardItemDocument, options);
      }
export type UpdateProductBoardItemMutationHookResult = ReturnType<typeof useUpdateProductBoardItemMutation>;
export type UpdateProductBoardItemMutationResult = Apollo.MutationResult<Types.UpdateProductBoardItemMutation>;
export type UpdateProductBoardItemMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductBoardItemMutation, Types.UpdateProductBoardItemMutationVariables>;
export const UpdateProductBoardItemTableRowDataDocument = gql`
    mutation UpdateProductBoardItemTableRowData($input: UpdateProductBoardItemInput!) {
  updateProductBoardItem(input: $input) {
    ...ProductBoardItemTableRowData
  }
}
    ${ProductBoardItemTableRowDataFragmentDoc}`;
export type UpdateProductBoardItemTableRowDataMutationFn = Apollo.MutationFunction<Types.UpdateProductBoardItemTableRowDataMutation, Types.UpdateProductBoardItemTableRowDataMutationVariables>;

/**
 * __useUpdateProductBoardItemTableRowDataMutation__
 *
 * To run a mutation, you first call `useUpdateProductBoardItemTableRowDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBoardItemTableRowDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBoardItemTableRowDataMutation, { data, loading, error }] = useUpdateProductBoardItemTableRowDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBoardItemTableRowDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductBoardItemTableRowDataMutation, Types.UpdateProductBoardItemTableRowDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductBoardItemTableRowDataMutation, Types.UpdateProductBoardItemTableRowDataMutationVariables>(UpdateProductBoardItemTableRowDataDocument, options);
      }
export type UpdateProductBoardItemTableRowDataMutationHookResult = ReturnType<typeof useUpdateProductBoardItemTableRowDataMutation>;
export type UpdateProductBoardItemTableRowDataMutationResult = Apollo.MutationResult<Types.UpdateProductBoardItemTableRowDataMutation>;
export type UpdateProductBoardItemTableRowDataMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductBoardItemTableRowDataMutation, Types.UpdateProductBoardItemTableRowDataMutationVariables>;
export const UpdateProductBoardItemDependenciesDocument = gql`
    mutation UpdateProductBoardItemDependencies($input: UpdateProductBoardItemInput!) {
  updateProductBoardItem(input: $input) {
    ...ProductBoardItemDependencies
  }
}
    ${ProductBoardItemDependenciesFragmentDoc}`;
export type UpdateProductBoardItemDependenciesMutationFn = Apollo.MutationFunction<Types.UpdateProductBoardItemDependenciesMutation, Types.UpdateProductBoardItemDependenciesMutationVariables>;

/**
 * __useUpdateProductBoardItemDependenciesMutation__
 *
 * To run a mutation, you first call `useUpdateProductBoardItemDependenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBoardItemDependenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBoardItemDependenciesMutation, { data, loading, error }] = useUpdateProductBoardItemDependenciesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBoardItemDependenciesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductBoardItemDependenciesMutation, Types.UpdateProductBoardItemDependenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductBoardItemDependenciesMutation, Types.UpdateProductBoardItemDependenciesMutationVariables>(UpdateProductBoardItemDependenciesDocument, options);
      }
export type UpdateProductBoardItemDependenciesMutationHookResult = ReturnType<typeof useUpdateProductBoardItemDependenciesMutation>;
export type UpdateProductBoardItemDependenciesMutationResult = Apollo.MutationResult<Types.UpdateProductBoardItemDependenciesMutation>;
export type UpdateProductBoardItemDependenciesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductBoardItemDependenciesMutation, Types.UpdateProductBoardItemDependenciesMutationVariables>;
export const BlockingProductBoardItemDocument = gql`
    query BlockingProductBoardItem($id: String!) {
  productBoardItem(id: $id) {
    ...BlockingProductBoardItem
  }
}
    ${BlockingProductBoardItemFragmentDoc}`;

/**
 * __useBlockingProductBoardItemQuery__
 *
 * To run a query within a React component, call `useBlockingProductBoardItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockingProductBoardItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockingProductBoardItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockingProductBoardItemQuery(baseOptions: Apollo.QueryHookOptions<Types.BlockingProductBoardItemQuery, Types.BlockingProductBoardItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BlockingProductBoardItemQuery, Types.BlockingProductBoardItemQueryVariables>(BlockingProductBoardItemDocument, options);
      }
export function useBlockingProductBoardItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BlockingProductBoardItemQuery, Types.BlockingProductBoardItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BlockingProductBoardItemQuery, Types.BlockingProductBoardItemQueryVariables>(BlockingProductBoardItemDocument, options);
        }
export type BlockingProductBoardItemQueryHookResult = ReturnType<typeof useBlockingProductBoardItemQuery>;
export type BlockingProductBoardItemLazyQueryHookResult = ReturnType<typeof useBlockingProductBoardItemLazyQuery>;
export type BlockingProductBoardItemQueryResult = Apollo.QueryResult<Types.BlockingProductBoardItemQuery, Types.BlockingProductBoardItemQueryVariables>;
export const PublicBlockingProductBoardItemDocument = gql`
    query PublicBlockingProductBoardItem($id: String!) {
  publicProductRoadmapItem(id: $id) {
    ...BlockingProductBoardItem
  }
}
    ${BlockingProductBoardItemFragmentDoc}`;

/**
 * __usePublicBlockingProductBoardItemQuery__
 *
 * To run a query within a React component, call `usePublicBlockingProductBoardItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicBlockingProductBoardItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicBlockingProductBoardItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicBlockingProductBoardItemQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicBlockingProductBoardItemQuery, Types.PublicBlockingProductBoardItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicBlockingProductBoardItemQuery, Types.PublicBlockingProductBoardItemQueryVariables>(PublicBlockingProductBoardItemDocument, options);
      }
export function usePublicBlockingProductBoardItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicBlockingProductBoardItemQuery, Types.PublicBlockingProductBoardItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicBlockingProductBoardItemQuery, Types.PublicBlockingProductBoardItemQueryVariables>(PublicBlockingProductBoardItemDocument, options);
        }
export type PublicBlockingProductBoardItemQueryHookResult = ReturnType<typeof usePublicBlockingProductBoardItemQuery>;
export type PublicBlockingProductBoardItemLazyQueryHookResult = ReturnType<typeof usePublicBlockingProductBoardItemLazyQuery>;
export type PublicBlockingProductBoardItemQueryResult = Apollo.QueryResult<Types.PublicBlockingProductBoardItemQuery, Types.PublicBlockingProductBoardItemQueryVariables>;
export const CreateProductRoadmapItemModalContentDocument = gql`
    query CreateProductRoadmapItemModalContent {
  productBoardReleases {
    ...ProductBoardReleasePreview
  }
  productBoardStatuses {
    ...ProductBoardStatusPreview
  }
}
    ${ProductBoardReleasePreviewFragmentDoc}
${ProductBoardStatusPreviewFragmentDoc}`;

/**
 * __useCreateProductRoadmapItemModalContentQuery__
 *
 * To run a query within a React component, call `useCreateProductRoadmapItemModalContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProductRoadmapItemModalContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProductRoadmapItemModalContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateProductRoadmapItemModalContentQuery(baseOptions?: Apollo.QueryHookOptions<Types.CreateProductRoadmapItemModalContentQuery, Types.CreateProductRoadmapItemModalContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CreateProductRoadmapItemModalContentQuery, Types.CreateProductRoadmapItemModalContentQueryVariables>(CreateProductRoadmapItemModalContentDocument, options);
      }
export function useCreateProductRoadmapItemModalContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CreateProductRoadmapItemModalContentQuery, Types.CreateProductRoadmapItemModalContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CreateProductRoadmapItemModalContentQuery, Types.CreateProductRoadmapItemModalContentQueryVariables>(CreateProductRoadmapItemModalContentDocument, options);
        }
export type CreateProductRoadmapItemModalContentQueryHookResult = ReturnType<typeof useCreateProductRoadmapItemModalContentQuery>;
export type CreateProductRoadmapItemModalContentLazyQueryHookResult = ReturnType<typeof useCreateProductRoadmapItemModalContentLazyQuery>;
export type CreateProductRoadmapItemModalContentQueryResult = Apollo.QueryResult<Types.CreateProductRoadmapItemModalContentQuery, Types.CreateProductRoadmapItemModalContentQueryVariables>;
export const PaginatedProductBoardItemsDocument = gql`
    query PaginatedProductBoardItems($viewId: String, $filter: ProductBoardItemsFilterInput, $pagination: PaginationInput, $sort: ProductBoardItemsSortInput) {
  paginatedProductBoardItems(
    viewId: $viewId
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    limit
    totalPages
    docs {
      ...ProductBoardItemTableRow
    }
  }
}
    ${ProductBoardItemTableRowFragmentDoc}`;

/**
 * __usePaginatedProductBoardItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedProductBoardItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProductBoardItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProductBoardItemsQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedProductBoardItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedProductBoardItemsQuery, Types.PaginatedProductBoardItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedProductBoardItemsQuery, Types.PaginatedProductBoardItemsQueryVariables>(PaginatedProductBoardItemsDocument, options);
      }
export function usePaginatedProductBoardItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedProductBoardItemsQuery, Types.PaginatedProductBoardItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedProductBoardItemsQuery, Types.PaginatedProductBoardItemsQueryVariables>(PaginatedProductBoardItemsDocument, options);
        }
export type PaginatedProductBoardItemsQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsQuery>;
export type PaginatedProductBoardItemsLazyQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsLazyQuery>;
export type PaginatedProductBoardItemsQueryResult = Apollo.QueryResult<Types.PaginatedProductBoardItemsQuery, Types.PaginatedProductBoardItemsQueryVariables>;
export const PublicPaginatedProductBoardItemsDocument = gql`
    query PublicPaginatedProductBoardItems($viewId: String, $filter: ProductBoardItemsFilterInput, $pagination: PaginationInput, $sort: ProductBoardItemsSortInput) {
  publicPaginatedProductRoadmapItems(
    viewId: $viewId
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    limit
    totalPages
    docs {
      ...ProductBoardItemTableRow
    }
  }
}
    ${ProductBoardItemTableRowFragmentDoc}`;

/**
 * __usePublicPaginatedProductBoardItemsQuery__
 *
 * To run a query within a React component, call `usePublicPaginatedProductBoardItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPaginatedProductBoardItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPaginatedProductBoardItemsQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePublicPaginatedProductBoardItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicPaginatedProductBoardItemsQuery, Types.PublicPaginatedProductBoardItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPaginatedProductBoardItemsQuery, Types.PublicPaginatedProductBoardItemsQueryVariables>(PublicPaginatedProductBoardItemsDocument, options);
      }
export function usePublicPaginatedProductBoardItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPaginatedProductBoardItemsQuery, Types.PublicPaginatedProductBoardItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPaginatedProductBoardItemsQuery, Types.PublicPaginatedProductBoardItemsQueryVariables>(PublicPaginatedProductBoardItemsDocument, options);
        }
export type PublicPaginatedProductBoardItemsQueryHookResult = ReturnType<typeof usePublicPaginatedProductBoardItemsQuery>;
export type PublicPaginatedProductBoardItemsLazyQueryHookResult = ReturnType<typeof usePublicPaginatedProductBoardItemsLazyQuery>;
export type PublicPaginatedProductBoardItemsQueryResult = Apollo.QueryResult<Types.PublicPaginatedProductBoardItemsQuery, Types.PublicPaginatedProductBoardItemsQueryVariables>;
export const PaginatedProductBoardItemsPreviewDocument = gql`
    query PaginatedProductBoardItemsPreview($filter: ProductBoardItemsFilterInput, $pagination: PaginationInput, $sort: ProductBoardItemsSortInput) {
  paginatedProductBoardItems(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    totalPages
    docs {
      ...ProductBoardItemPreview
    }
  }
}
    ${ProductBoardItemPreviewFragmentDoc}`;

/**
 * __usePaginatedProductBoardItemsPreviewQuery__
 *
 * To run a query within a React component, call `usePaginatedProductBoardItemsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProductBoardItemsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProductBoardItemsPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedProductBoardItemsPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedProductBoardItemsPreviewQuery, Types.PaginatedProductBoardItemsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedProductBoardItemsPreviewQuery, Types.PaginatedProductBoardItemsPreviewQueryVariables>(PaginatedProductBoardItemsPreviewDocument, options);
      }
export function usePaginatedProductBoardItemsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedProductBoardItemsPreviewQuery, Types.PaginatedProductBoardItemsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedProductBoardItemsPreviewQuery, Types.PaginatedProductBoardItemsPreviewQueryVariables>(PaginatedProductBoardItemsPreviewDocument, options);
        }
export type PaginatedProductBoardItemsPreviewQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsPreviewQuery>;
export type PaginatedProductBoardItemsPreviewLazyQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsPreviewLazyQuery>;
export type PaginatedProductBoardItemsPreviewQueryResult = Apollo.QueryResult<Types.PaginatedProductBoardItemsPreviewQuery, Types.PaginatedProductBoardItemsPreviewQueryVariables>;
export const PublicPaginatedProductBoardItemsPreviewDocument = gql`
    query PublicPaginatedProductBoardItemsPreview($filter: ProductBoardItemsFilterInput, $pagination: PaginationInput) {
  publicPaginatedProductRoadmapItems(filter: $filter, pagination: $pagination) {
    page
    totalPages
    docs {
      ...ProductBoardItemPreview
    }
  }
}
    ${ProductBoardItemPreviewFragmentDoc}`;

/**
 * __usePublicPaginatedProductBoardItemsPreviewQuery__
 *
 * To run a query within a React component, call `usePublicPaginatedProductBoardItemsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPaginatedProductBoardItemsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPaginatedProductBoardItemsPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePublicPaginatedProductBoardItemsPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicPaginatedProductBoardItemsPreviewQuery, Types.PublicPaginatedProductBoardItemsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPaginatedProductBoardItemsPreviewQuery, Types.PublicPaginatedProductBoardItemsPreviewQueryVariables>(PublicPaginatedProductBoardItemsPreviewDocument, options);
      }
export function usePublicPaginatedProductBoardItemsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPaginatedProductBoardItemsPreviewQuery, Types.PublicPaginatedProductBoardItemsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPaginatedProductBoardItemsPreviewQuery, Types.PublicPaginatedProductBoardItemsPreviewQueryVariables>(PublicPaginatedProductBoardItemsPreviewDocument, options);
        }
export type PublicPaginatedProductBoardItemsPreviewQueryHookResult = ReturnType<typeof usePublicPaginatedProductBoardItemsPreviewQuery>;
export type PublicPaginatedProductBoardItemsPreviewLazyQueryHookResult = ReturnType<typeof usePublicPaginatedProductBoardItemsPreviewLazyQuery>;
export type PublicPaginatedProductBoardItemsPreviewQueryResult = Apollo.QueryResult<Types.PublicPaginatedProductBoardItemsPreviewQuery, Types.PublicPaginatedProductBoardItemsPreviewQueryVariables>;
export const ProductBoardItemDocument = gql`
    query ProductBoardItem($id: String!) {
  productBoardItem(id: $id) {
    ...ProductBoardItemDetailed
  }
}
    ${ProductBoardItemDetailedFragmentDoc}`;

/**
 * __useProductBoardItemQuery__
 *
 * To run a query within a React component, call `useProductBoardItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductBoardItemQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardItemQuery, Types.ProductBoardItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardItemQuery, Types.ProductBoardItemQueryVariables>(ProductBoardItemDocument, options);
      }
export function useProductBoardItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardItemQuery, Types.ProductBoardItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardItemQuery, Types.ProductBoardItemQueryVariables>(ProductBoardItemDocument, options);
        }
export type ProductBoardItemQueryHookResult = ReturnType<typeof useProductBoardItemQuery>;
export type ProductBoardItemLazyQueryHookResult = ReturnType<typeof useProductBoardItemLazyQuery>;
export type ProductBoardItemQueryResult = Apollo.QueryResult<Types.ProductBoardItemQuery, Types.ProductBoardItemQueryVariables>;
export const PublicProductBoardItemDocument = gql`
    query PublicProductBoardItem($id: String!) {
  publicProductRoadmapItem(id: $id) {
    ...ProductBoardItemDetailed
  }
}
    ${ProductBoardItemDetailedFragmentDoc}`;

/**
 * __usePublicProductBoardItemQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicProductBoardItemQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicProductBoardItemQuery, Types.PublicProductBoardItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardItemQuery, Types.PublicProductBoardItemQueryVariables>(PublicProductBoardItemDocument, options);
      }
export function usePublicProductBoardItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardItemQuery, Types.PublicProductBoardItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardItemQuery, Types.PublicProductBoardItemQueryVariables>(PublicProductBoardItemDocument, options);
        }
export type PublicProductBoardItemQueryHookResult = ReturnType<typeof usePublicProductBoardItemQuery>;
export type PublicProductBoardItemLazyQueryHookResult = ReturnType<typeof usePublicProductBoardItemLazyQuery>;
export type PublicProductBoardItemQueryResult = Apollo.QueryResult<Types.PublicProductBoardItemQuery, Types.PublicProductBoardItemQueryVariables>;
export const ProductBoardItemDependenciesDocument = gql`
    query ProductBoardItemDependencies($id: String!) {
  productBoardItem(id: $id) {
    ...ProductBoardItemDependencies
  }
}
    ${ProductBoardItemDependenciesFragmentDoc}`;

/**
 * __useProductBoardItemDependenciesQuery__
 *
 * To run a query within a React component, call `useProductBoardItemDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardItemDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardItemDependenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductBoardItemDependenciesQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardItemDependenciesQuery, Types.ProductBoardItemDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardItemDependenciesQuery, Types.ProductBoardItemDependenciesQueryVariables>(ProductBoardItemDependenciesDocument, options);
      }
export function useProductBoardItemDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardItemDependenciesQuery, Types.ProductBoardItemDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardItemDependenciesQuery, Types.ProductBoardItemDependenciesQueryVariables>(ProductBoardItemDependenciesDocument, options);
        }
export type ProductBoardItemDependenciesQueryHookResult = ReturnType<typeof useProductBoardItemDependenciesQuery>;
export type ProductBoardItemDependenciesLazyQueryHookResult = ReturnType<typeof useProductBoardItemDependenciesLazyQuery>;
export type ProductBoardItemDependenciesQueryResult = Apollo.QueryResult<Types.ProductBoardItemDependenciesQuery, Types.ProductBoardItemDependenciesQueryVariables>;
export const PublicProductBoardItemDependenciesDocument = gql`
    query PublicProductBoardItemDependencies($id: String!) {
  publicProductRoadmapItem(id: $id) {
    ...ProductBoardItemDependencies
  }
}
    ${ProductBoardItemDependenciesFragmentDoc}`;

/**
 * __usePublicProductBoardItemDependenciesQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardItemDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardItemDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardItemDependenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicProductBoardItemDependenciesQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicProductBoardItemDependenciesQuery, Types.PublicProductBoardItemDependenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardItemDependenciesQuery, Types.PublicProductBoardItemDependenciesQueryVariables>(PublicProductBoardItemDependenciesDocument, options);
      }
export function usePublicProductBoardItemDependenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardItemDependenciesQuery, Types.PublicProductBoardItemDependenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardItemDependenciesQuery, Types.PublicProductBoardItemDependenciesQueryVariables>(PublicProductBoardItemDependenciesDocument, options);
        }
export type PublicProductBoardItemDependenciesQueryHookResult = ReturnType<typeof usePublicProductBoardItemDependenciesQuery>;
export type PublicProductBoardItemDependenciesLazyQueryHookResult = ReturnType<typeof usePublicProductBoardItemDependenciesLazyQuery>;
export type PublicProductBoardItemDependenciesQueryResult = Apollo.QueryResult<Types.PublicProductBoardItemDependenciesQuery, Types.PublicProductBoardItemDependenciesQueryVariables>;
export const ProductBoardItemFilterOptionsDocument = gql`
    query ProductBoardItemFilterOptions {
  productBoardItemFilterOptions {
    tagOptions {
      ...TagFilterOption
    }
    productLineTagOptions {
      ...TagFilterOption
    }
    CDPAccountOptions {
      ...CDPAccountFilterOption
    }
    assigneeOptions {
      ...UserFilterOption
    }
    competitorOptions {
      ...CompetitorCompanyFilterOption
    }
    feedbackPostOptions {
      ...FeedbackPostFilterOption
    }
    insightOptions {
      ...FilterOption
    }
    launchOptions {
      ...LaunchFilterOption
    }
    personaOptions {
      ...PersonaFilterOption
    }
    releaseOptions {
      ...ProductBoardReleaseFilterOption
    }
    statusOptions {
      ...ProductBoardStatusFilterOption
    }
    roadmapOptions {
      ...FilterOption
    }
    dealOptions {
      ...DealFilterOption
    }
    accountIndustries
    accountTypes
  }
}
    ${TagFilterOptionFragmentDoc}
${CdpAccountFilterOptionFragmentDoc}
${UserFilterOptionFragmentDoc}
${CompetitorCompanyFilterOptionFragmentDoc}
${FeedbackPostFilterOptionFragmentDoc}
${FilterOptionFragmentDoc}
${LaunchFilterOptionFragmentDoc}
${PersonaFilterOptionFragmentDoc}
${ProductBoardReleaseFilterOptionFragmentDoc}
${ProductBoardStatusFilterOptionFragmentDoc}
${DealFilterOptionFragmentDoc}`;

/**
 * __useProductBoardItemFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProductBoardItemFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardItemFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardItemFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBoardItemFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardItemFilterOptionsQuery, Types.ProductBoardItemFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardItemFilterOptionsQuery, Types.ProductBoardItemFilterOptionsQueryVariables>(ProductBoardItemFilterOptionsDocument, options);
      }
export function useProductBoardItemFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardItemFilterOptionsQuery, Types.ProductBoardItemFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardItemFilterOptionsQuery, Types.ProductBoardItemFilterOptionsQueryVariables>(ProductBoardItemFilterOptionsDocument, options);
        }
export type ProductBoardItemFilterOptionsQueryHookResult = ReturnType<typeof useProductBoardItemFilterOptionsQuery>;
export type ProductBoardItemFilterOptionsLazyQueryHookResult = ReturnType<typeof useProductBoardItemFilterOptionsLazyQuery>;
export type ProductBoardItemFilterOptionsQueryResult = Apollo.QueryResult<Types.ProductBoardItemFilterOptionsQuery, Types.ProductBoardItemFilterOptionsQueryVariables>;
export const PublicRoadmapItemFiltersDocument = gql`
    query PublicRoadmapItemFilters {
  organization: publicOrganization {
    id
    users {
      ...PublicOrganizationUserFilterOptionData
    }
  }
  roadmapItemTags: tags(input: {types: [ROADMAP_ITEM]}) {
    ...TagFilterOptionData
  }
  productLineTags: tags(input: {types: [PRODUCT_LINE]}) {
    ...TagFilterOptionData
  }
  productBoardRoadmaps: publicProductRoadmaps {
    ...ProductBoardRoadmapFilterOptionData
  }
  productBoardReleases: publicProductRoadmapReleases {
    ...ProductBoardReleaseFilterOptionData
  }
  productBoardStatuses: publicProductRoadmapStatuses {
    ...ProductBoardStatusFilterOptionData
  }
  availableCDPAccountIndustries
  availableCDPAccountTypes
}
    ${PublicOrganizationUserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}
${ProductBoardRoadmapFilterOptionDataFragmentDoc}
${ProductBoardReleaseFilterOptionDataFragmentDoc}
${ProductBoardStatusFilterOptionDataFragmentDoc}`;

/**
 * __usePublicRoadmapItemFiltersQuery__
 *
 * To run a query within a React component, call `usePublicRoadmapItemFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicRoadmapItemFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicRoadmapItemFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicRoadmapItemFiltersQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicRoadmapItemFiltersQuery, Types.PublicRoadmapItemFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicRoadmapItemFiltersQuery, Types.PublicRoadmapItemFiltersQueryVariables>(PublicRoadmapItemFiltersDocument, options);
      }
export function usePublicRoadmapItemFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicRoadmapItemFiltersQuery, Types.PublicRoadmapItemFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicRoadmapItemFiltersQuery, Types.PublicRoadmapItemFiltersQueryVariables>(PublicRoadmapItemFiltersDocument, options);
        }
export type PublicRoadmapItemFiltersQueryHookResult = ReturnType<typeof usePublicRoadmapItemFiltersQuery>;
export type PublicRoadmapItemFiltersLazyQueryHookResult = ReturnType<typeof usePublicRoadmapItemFiltersLazyQuery>;
export type PublicRoadmapItemFiltersQueryResult = Apollo.QueryResult<Types.PublicRoadmapItemFiltersQuery, Types.PublicRoadmapItemFiltersQueryVariables>;
export const ProductRoadmapItemPageContentDocument = gql`
    query ProductRoadmapItemPageContent {
  productBoardReleases {
    ...ProductBoardReleasePreview
  }
  productBoardStatuses {
    ...ProductBoardStatus
  }
  tags(input: {types: [ROADMAP_ITEM]}) {
    ...Tag
  }
}
    ${ProductBoardReleasePreviewFragmentDoc}
${ProductBoardStatusFragmentDoc}
${TagFragmentDoc}`;

/**
 * __useProductRoadmapItemPageContentQuery__
 *
 * To run a query within a React component, call `useProductRoadmapItemPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRoadmapItemPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRoadmapItemPageContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductRoadmapItemPageContentQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductRoadmapItemPageContentQuery, Types.ProductRoadmapItemPageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductRoadmapItemPageContentQuery, Types.ProductRoadmapItemPageContentQueryVariables>(ProductRoadmapItemPageContentDocument, options);
      }
export function useProductRoadmapItemPageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductRoadmapItemPageContentQuery, Types.ProductRoadmapItemPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductRoadmapItemPageContentQuery, Types.ProductRoadmapItemPageContentQueryVariables>(ProductRoadmapItemPageContentDocument, options);
        }
export type ProductRoadmapItemPageContentQueryHookResult = ReturnType<typeof useProductRoadmapItemPageContentQuery>;
export type ProductRoadmapItemPageContentLazyQueryHookResult = ReturnType<typeof useProductRoadmapItemPageContentLazyQuery>;
export type ProductRoadmapItemPageContentQueryResult = Apollo.QueryResult<Types.ProductRoadmapItemPageContentQuery, Types.ProductRoadmapItemPageContentQueryVariables>;
export const PublicProductRoadmapItemPageContentDocument = gql`
    query PublicProductRoadmapItemPageContent {
  publicProductRoadmapReleases {
    ...ProductBoardReleasePreview
  }
  publicProductRoadmapStatuses {
    ...ProductBoardStatus
  }
  tags(input: {types: [ROADMAP_ITEM]}) {
    ...Tag
  }
}
    ${ProductBoardReleasePreviewFragmentDoc}
${ProductBoardStatusFragmentDoc}
${TagFragmentDoc}`;

/**
 * __usePublicProductRoadmapItemPageContentQuery__
 *
 * To run a query within a React component, call `usePublicProductRoadmapItemPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductRoadmapItemPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductRoadmapItemPageContentQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicProductRoadmapItemPageContentQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductRoadmapItemPageContentQuery, Types.PublicProductRoadmapItemPageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductRoadmapItemPageContentQuery, Types.PublicProductRoadmapItemPageContentQueryVariables>(PublicProductRoadmapItemPageContentDocument, options);
      }
export function usePublicProductRoadmapItemPageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductRoadmapItemPageContentQuery, Types.PublicProductRoadmapItemPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductRoadmapItemPageContentQuery, Types.PublicProductRoadmapItemPageContentQueryVariables>(PublicProductRoadmapItemPageContentDocument, options);
        }
export type PublicProductRoadmapItemPageContentQueryHookResult = ReturnType<typeof usePublicProductRoadmapItemPageContentQuery>;
export type PublicProductRoadmapItemPageContentLazyQueryHookResult = ReturnType<typeof usePublicProductRoadmapItemPageContentLazyQuery>;
export type PublicProductRoadmapItemPageContentQueryResult = Apollo.QueryResult<Types.PublicProductRoadmapItemPageContentQuery, Types.PublicProductRoadmapItemPageContentQueryVariables>;
export const RoadmapItemFiltersDocument = gql`
    query RoadmapItemFilters {
  organization {
    id
    users {
      ...OrganizationUserFilterOptionData
    }
  }
  roadmapItemTags: tags(input: {types: [ROADMAP_ITEM]}) {
    ...TagFilterOptionData
  }
  productLineTags: tags(input: {types: [PRODUCT_LINE]}) {
    ...TagFilterOptionData
  }
  productBoardReleases {
    ...ProductBoardReleaseFilterOptionData
  }
  productBoardRoadmaps {
    ...ProductBoardRoadmapFilterOptionData
  }
  productBoardStatuses {
    ...ProductBoardStatusFilterOptionData
  }
  insights {
    ...InsightFilterOptionData
  }
  launches {
    ...LaunchFilterOptionData
  }
  companies {
    ...CompanyFilterOptionData
  }
  personas {
    ...PersonaFilterOptionData
  }
  feedbackPosts {
    ...ProductIdeaFilterOptionData
  }
  deals {
    ...DealFilterOptionData
  }
  availableCDPAccountIndustries
  availableCDPAccountTypes
}
    ${OrganizationUserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}
${ProductBoardReleaseFilterOptionDataFragmentDoc}
${ProductBoardRoadmapFilterOptionDataFragmentDoc}
${ProductBoardStatusFilterOptionDataFragmentDoc}
${InsightFilterOptionDataFragmentDoc}
${LaunchFilterOptionDataFragmentDoc}
${CompanyFilterOptionDataFragmentDoc}
${PersonaFilterOptionDataFragmentDoc}
${ProductIdeaFilterOptionDataFragmentDoc}
${DealFilterOptionDataFragmentDoc}`;

/**
 * __useRoadmapItemFiltersQuery__
 *
 * To run a query within a React component, call `useRoadmapItemFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadmapItemFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadmapItemFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoadmapItemFiltersQuery(baseOptions?: Apollo.QueryHookOptions<Types.RoadmapItemFiltersQuery, Types.RoadmapItemFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RoadmapItemFiltersQuery, Types.RoadmapItemFiltersQueryVariables>(RoadmapItemFiltersDocument, options);
      }
export function useRoadmapItemFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RoadmapItemFiltersQuery, Types.RoadmapItemFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RoadmapItemFiltersQuery, Types.RoadmapItemFiltersQueryVariables>(RoadmapItemFiltersDocument, options);
        }
export type RoadmapItemFiltersQueryHookResult = ReturnType<typeof useRoadmapItemFiltersQuery>;
export type RoadmapItemFiltersLazyQueryHookResult = ReturnType<typeof useRoadmapItemFiltersLazyQuery>;
export type RoadmapItemFiltersQueryResult = Apollo.QueryResult<Types.RoadmapItemFiltersQuery, Types.RoadmapItemFiltersQueryVariables>;
export const ProductBoardItemsGroupsDocument = gql`
    query ProductBoardItemsGroups($viewId: String, $filter: ProductBoardItemsFilterInput!, $groupBy: ProductBoardItemsGroupBy!, $pagination: PaginationInput) {
  productBoardItemsGroups(
    viewId: $viewId
    filter: $filter
    groupBy: $groupBy
    pagination: $pagination
  ) {
    ...ProductBoardItemsGroups
  }
}
    ${ProductBoardItemsGroupsFragmentDoc}`;

/**
 * __useProductBoardItemsGroupsQuery__
 *
 * To run a query within a React component, call `useProductBoardItemsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardItemsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardItemsGroupsQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProductBoardItemsGroupsQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductBoardItemsGroupsQuery, Types.ProductBoardItemsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardItemsGroupsQuery, Types.ProductBoardItemsGroupsQueryVariables>(ProductBoardItemsGroupsDocument, options);
      }
export function useProductBoardItemsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardItemsGroupsQuery, Types.ProductBoardItemsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardItemsGroupsQuery, Types.ProductBoardItemsGroupsQueryVariables>(ProductBoardItemsGroupsDocument, options);
        }
export type ProductBoardItemsGroupsQueryHookResult = ReturnType<typeof useProductBoardItemsGroupsQuery>;
export type ProductBoardItemsGroupsLazyQueryHookResult = ReturnType<typeof useProductBoardItemsGroupsLazyQuery>;
export type ProductBoardItemsGroupsQueryResult = Apollo.QueryResult<Types.ProductBoardItemsGroupsQuery, Types.ProductBoardItemsGroupsQueryVariables>;
export const PublicProductBoardItemsGroupsDocument = gql`
    query PublicProductBoardItemsGroups($viewId: String, $filter: ProductBoardItemsFilterInput!, $groupBy: ProductBoardItemsGroupBy!, $pagination: PaginationInput) {
  productBoardItemsGroups(
    viewId: $viewId
    filter: $filter
    groupBy: $groupBy
    pagination: $pagination
  ) {
    ...ProductBoardItemsGroups
  }
}
    ${ProductBoardItemsGroupsFragmentDoc}`;

/**
 * __usePublicProductBoardItemsGroupsQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardItemsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardItemsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardItemsGroupsQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePublicProductBoardItemsGroupsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicProductBoardItemsGroupsQuery, Types.PublicProductBoardItemsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardItemsGroupsQuery, Types.PublicProductBoardItemsGroupsQueryVariables>(PublicProductBoardItemsGroupsDocument, options);
      }
export function usePublicProductBoardItemsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardItemsGroupsQuery, Types.PublicProductBoardItemsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardItemsGroupsQuery, Types.PublicProductBoardItemsGroupsQueryVariables>(PublicProductBoardItemsGroupsDocument, options);
        }
export type PublicProductBoardItemsGroupsQueryHookResult = ReturnType<typeof usePublicProductBoardItemsGroupsQuery>;
export type PublicProductBoardItemsGroupsLazyQueryHookResult = ReturnType<typeof usePublicProductBoardItemsGroupsLazyQuery>;
export type PublicProductBoardItemsGroupsQueryResult = Apollo.QueryResult<Types.PublicProductBoardItemsGroupsQuery, Types.PublicProductBoardItemsGroupsQueryVariables>;
export const CreateProductBoardReleaseDocument = gql`
    mutation CreateProductBoardRelease($input: CreateProductBoardReleaseInput!) {
  createProductBoardRelease(input: $input) {
    ...ProductBoardRelease
  }
}
    ${ProductBoardReleaseFragmentDoc}`;
export type CreateProductBoardReleaseMutationFn = Apollo.MutationFunction<Types.CreateProductBoardReleaseMutation, Types.CreateProductBoardReleaseMutationVariables>;

/**
 * __useCreateProductBoardReleaseMutation__
 *
 * To run a mutation, you first call `useCreateProductBoardReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBoardReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBoardReleaseMutation, { data, loading, error }] = useCreateProductBoardReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductBoardReleaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductBoardReleaseMutation, Types.CreateProductBoardReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductBoardReleaseMutation, Types.CreateProductBoardReleaseMutationVariables>(CreateProductBoardReleaseDocument, options);
      }
export type CreateProductBoardReleaseMutationHookResult = ReturnType<typeof useCreateProductBoardReleaseMutation>;
export type CreateProductBoardReleaseMutationResult = Apollo.MutationResult<Types.CreateProductBoardReleaseMutation>;
export type CreateProductBoardReleaseMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductBoardReleaseMutation, Types.CreateProductBoardReleaseMutationVariables>;
export const DeleteProductBoardReleaseDocument = gql`
    mutation DeleteProductBoardRelease($id: String!) {
  deleteProductBoardRelease(id: $id) {
    id
  }
}
    `;
export type DeleteProductBoardReleaseMutationFn = Apollo.MutationFunction<Types.DeleteProductBoardReleaseMutation, Types.DeleteProductBoardReleaseMutationVariables>;

/**
 * __useDeleteProductBoardReleaseMutation__
 *
 * To run a mutation, you first call `useDeleteProductBoardReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductBoardReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductBoardReleaseMutation, { data, loading, error }] = useDeleteProductBoardReleaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductBoardReleaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductBoardReleaseMutation, Types.DeleteProductBoardReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductBoardReleaseMutation, Types.DeleteProductBoardReleaseMutationVariables>(DeleteProductBoardReleaseDocument, options);
      }
export type DeleteProductBoardReleaseMutationHookResult = ReturnType<typeof useDeleteProductBoardReleaseMutation>;
export type DeleteProductBoardReleaseMutationResult = Apollo.MutationResult<Types.DeleteProductBoardReleaseMutation>;
export type DeleteProductBoardReleaseMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductBoardReleaseMutation, Types.DeleteProductBoardReleaseMutationVariables>;
export const UpdateProductBoardReleaseDocument = gql`
    mutation UpdateProductBoardRelease($input: UpdateProductBoardReleaseInput!) {
  updateProductBoardRelease(input: $input) {
    ...ProductBoardRelease
  }
}
    ${ProductBoardReleaseFragmentDoc}`;
export type UpdateProductBoardReleaseMutationFn = Apollo.MutationFunction<Types.UpdateProductBoardReleaseMutation, Types.UpdateProductBoardReleaseMutationVariables>;

/**
 * __useUpdateProductBoardReleaseMutation__
 *
 * To run a mutation, you first call `useUpdateProductBoardReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBoardReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBoardReleaseMutation, { data, loading, error }] = useUpdateProductBoardReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBoardReleaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductBoardReleaseMutation, Types.UpdateProductBoardReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductBoardReleaseMutation, Types.UpdateProductBoardReleaseMutationVariables>(UpdateProductBoardReleaseDocument, options);
      }
export type UpdateProductBoardReleaseMutationHookResult = ReturnType<typeof useUpdateProductBoardReleaseMutation>;
export type UpdateProductBoardReleaseMutationResult = Apollo.MutationResult<Types.UpdateProductBoardReleaseMutation>;
export type UpdateProductBoardReleaseMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductBoardReleaseMutation, Types.UpdateProductBoardReleaseMutationVariables>;
export const ProductBoardReleaseIndicatorsDocument = gql`
    query ProductBoardReleaseIndicators($input: ProductBoardReleasesInput) {
  productBoardReleases(input: $input) {
    ...ProductBoardReleaseIndicators
  }
}
    ${ProductBoardReleaseIndicatorsFragmentDoc}`;

/**
 * __useProductBoardReleaseIndicatorsQuery__
 *
 * To run a query within a React component, call `useProductBoardReleaseIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardReleaseIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardReleaseIndicatorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductBoardReleaseIndicatorsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardReleaseIndicatorsQuery, Types.ProductBoardReleaseIndicatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardReleaseIndicatorsQuery, Types.ProductBoardReleaseIndicatorsQueryVariables>(ProductBoardReleaseIndicatorsDocument, options);
      }
export function useProductBoardReleaseIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardReleaseIndicatorsQuery, Types.ProductBoardReleaseIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardReleaseIndicatorsQuery, Types.ProductBoardReleaseIndicatorsQueryVariables>(ProductBoardReleaseIndicatorsDocument, options);
        }
export type ProductBoardReleaseIndicatorsQueryHookResult = ReturnType<typeof useProductBoardReleaseIndicatorsQuery>;
export type ProductBoardReleaseIndicatorsLazyQueryHookResult = ReturnType<typeof useProductBoardReleaseIndicatorsLazyQuery>;
export type ProductBoardReleaseIndicatorsQueryResult = Apollo.QueryResult<Types.ProductBoardReleaseIndicatorsQuery, Types.ProductBoardReleaseIndicatorsQueryVariables>;
export const ProductBoardReleasesDocument = gql`
    query ProductBoardReleases($input: ProductBoardReleasesInput, $dateRange: DateRangeInput) {
  productBoardReleases(input: $input, dateRange: $dateRange) {
    ...ProductBoardRelease
  }
}
    ${ProductBoardReleaseFragmentDoc}`;

/**
 * __useProductBoardReleasesQuery__
 *
 * To run a query within a React component, call `useProductBoardReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardReleasesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useProductBoardReleasesQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardReleasesQuery, Types.ProductBoardReleasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardReleasesQuery, Types.ProductBoardReleasesQueryVariables>(ProductBoardReleasesDocument, options);
      }
export function useProductBoardReleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardReleasesQuery, Types.ProductBoardReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardReleasesQuery, Types.ProductBoardReleasesQueryVariables>(ProductBoardReleasesDocument, options);
        }
export type ProductBoardReleasesQueryHookResult = ReturnType<typeof useProductBoardReleasesQuery>;
export type ProductBoardReleasesLazyQueryHookResult = ReturnType<typeof useProductBoardReleasesLazyQuery>;
export type ProductBoardReleasesQueryResult = Apollo.QueryResult<Types.ProductBoardReleasesQuery, Types.ProductBoardReleasesQueryVariables>;
export const PublicProductBoardReleasesDocument = gql`
    query PublicProductBoardReleases($input: ProductBoardReleasesInput, $itemsInput: ProductBoardItemsFilterInput, $dateRange: DateRangeInput) {
  publicProductRoadmapReleases(input: $input, dateRange: $dateRange) {
    ...ProductBoardRelease
  }
}
    ${ProductBoardReleaseFragmentDoc}`;

/**
 * __usePublicProductBoardReleasesQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardReleasesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      itemsInput: // value for 'itemsInput'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function usePublicProductBoardReleasesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductBoardReleasesQuery, Types.PublicProductBoardReleasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardReleasesQuery, Types.PublicProductBoardReleasesQueryVariables>(PublicProductBoardReleasesDocument, options);
      }
export function usePublicProductBoardReleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardReleasesQuery, Types.PublicProductBoardReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardReleasesQuery, Types.PublicProductBoardReleasesQueryVariables>(PublicProductBoardReleasesDocument, options);
        }
export type PublicProductBoardReleasesQueryHookResult = ReturnType<typeof usePublicProductBoardReleasesQuery>;
export type PublicProductBoardReleasesLazyQueryHookResult = ReturnType<typeof usePublicProductBoardReleasesLazyQuery>;
export type PublicProductBoardReleasesQueryResult = Apollo.QueryResult<Types.PublicProductBoardReleasesQuery, Types.PublicProductBoardReleasesQueryVariables>;
export const ProductBoardReleasesWithItemsDocument = gql`
    query ProductBoardReleasesWithItems($dateRange: DateRangeInput, $input: ProductBoardReleasesInput, $itemsFilter: ProductBoardItemsFilterInput, $itemsSort: ProductBoardItemsSortInput, $itemsPagination: PaginationInput) {
  productBoardReleases(input: $input, dateRange: $dateRange) {
    ...ProductBoardReleaseWithItems
  }
}
    ${ProductBoardReleaseWithItemsFragmentDoc}`;

/**
 * __useProductBoardReleasesWithItemsQuery__
 *
 * To run a query within a React component, call `useProductBoardReleasesWithItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardReleasesWithItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardReleasesWithItemsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      input: // value for 'input'
 *      itemsFilter: // value for 'itemsFilter'
 *      itemsSort: // value for 'itemsSort'
 *      itemsPagination: // value for 'itemsPagination'
 *   },
 * });
 */
export function useProductBoardReleasesWithItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardReleasesWithItemsQuery, Types.ProductBoardReleasesWithItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardReleasesWithItemsQuery, Types.ProductBoardReleasesWithItemsQueryVariables>(ProductBoardReleasesWithItemsDocument, options);
      }
export function useProductBoardReleasesWithItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardReleasesWithItemsQuery, Types.ProductBoardReleasesWithItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardReleasesWithItemsQuery, Types.ProductBoardReleasesWithItemsQueryVariables>(ProductBoardReleasesWithItemsDocument, options);
        }
export type ProductBoardReleasesWithItemsQueryHookResult = ReturnType<typeof useProductBoardReleasesWithItemsQuery>;
export type ProductBoardReleasesWithItemsLazyQueryHookResult = ReturnType<typeof useProductBoardReleasesWithItemsLazyQuery>;
export type ProductBoardReleasesWithItemsQueryResult = Apollo.QueryResult<Types.ProductBoardReleasesWithItemsQuery, Types.ProductBoardReleasesWithItemsQueryVariables>;
export const PublicProductBoardReleasesWithItemsDocument = gql`
    query PublicProductBoardReleasesWithItems($dateRange: DateRangeInput, $input: ProductBoardReleasesInput, $itemsFilter: ProductBoardItemsFilterInput, $itemsSort: ProductBoardItemsSortInput, $itemsPagination: PaginationInput) {
  publicProductRoadmapReleases(input: $input, dateRange: $dateRange) {
    ...ProductBoardReleaseWithItems
  }
}
    ${ProductBoardReleaseWithItemsFragmentDoc}`;

/**
 * __usePublicProductBoardReleasesWithItemsQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardReleasesWithItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardReleasesWithItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardReleasesWithItemsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      input: // value for 'input'
 *      itemsFilter: // value for 'itemsFilter'
 *      itemsSort: // value for 'itemsSort'
 *      itemsPagination: // value for 'itemsPagination'
 *   },
 * });
 */
export function usePublicProductBoardReleasesWithItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductBoardReleasesWithItemsQuery, Types.PublicProductBoardReleasesWithItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardReleasesWithItemsQuery, Types.PublicProductBoardReleasesWithItemsQueryVariables>(PublicProductBoardReleasesWithItemsDocument, options);
      }
export function usePublicProductBoardReleasesWithItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardReleasesWithItemsQuery, Types.PublicProductBoardReleasesWithItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardReleasesWithItemsQuery, Types.PublicProductBoardReleasesWithItemsQueryVariables>(PublicProductBoardReleasesWithItemsDocument, options);
        }
export type PublicProductBoardReleasesWithItemsQueryHookResult = ReturnType<typeof usePublicProductBoardReleasesWithItemsQuery>;
export type PublicProductBoardReleasesWithItemsLazyQueryHookResult = ReturnType<typeof usePublicProductBoardReleasesWithItemsLazyQuery>;
export type PublicProductBoardReleasesWithItemsQueryResult = Apollo.QueryResult<Types.PublicProductBoardReleasesWithItemsQuery, Types.PublicProductBoardReleasesWithItemsQueryVariables>;
export const CreateProductBoardStatusDocument = gql`
    mutation CreateProductBoardStatus($input: CreateProductBoardStatusInput!) {
  createProductBoardStatus(input: $input) {
    ...ProductBoardStatus
  }
}
    ${ProductBoardStatusFragmentDoc}`;
export type CreateProductBoardStatusMutationFn = Apollo.MutationFunction<Types.CreateProductBoardStatusMutation, Types.CreateProductBoardStatusMutationVariables>;

/**
 * __useCreateProductBoardStatusMutation__
 *
 * To run a mutation, you first call `useCreateProductBoardStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBoardStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBoardStatusMutation, { data, loading, error }] = useCreateProductBoardStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductBoardStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductBoardStatusMutation, Types.CreateProductBoardStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductBoardStatusMutation, Types.CreateProductBoardStatusMutationVariables>(CreateProductBoardStatusDocument, options);
      }
export type CreateProductBoardStatusMutationHookResult = ReturnType<typeof useCreateProductBoardStatusMutation>;
export type CreateProductBoardStatusMutationResult = Apollo.MutationResult<Types.CreateProductBoardStatusMutation>;
export type CreateProductBoardStatusMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductBoardStatusMutation, Types.CreateProductBoardStatusMutationVariables>;
export const DeleteProductBoardStatusDocument = gql`
    mutation DeleteProductBoardStatus($id: String!) {
  deleteProductBoardStatus(id: $id) {
    id
  }
}
    `;
export type DeleteProductBoardStatusMutationFn = Apollo.MutationFunction<Types.DeleteProductBoardStatusMutation, Types.DeleteProductBoardStatusMutationVariables>;

/**
 * __useDeleteProductBoardStatusMutation__
 *
 * To run a mutation, you first call `useDeleteProductBoardStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductBoardStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductBoardStatusMutation, { data, loading, error }] = useDeleteProductBoardStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductBoardStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductBoardStatusMutation, Types.DeleteProductBoardStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductBoardStatusMutation, Types.DeleteProductBoardStatusMutationVariables>(DeleteProductBoardStatusDocument, options);
      }
export type DeleteProductBoardStatusMutationHookResult = ReturnType<typeof useDeleteProductBoardStatusMutation>;
export type DeleteProductBoardStatusMutationResult = Apollo.MutationResult<Types.DeleteProductBoardStatusMutation>;
export type DeleteProductBoardStatusMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductBoardStatusMutation, Types.DeleteProductBoardStatusMutationVariables>;
export const UpdateProductBoardStatusDocument = gql`
    mutation UpdateProductBoardStatus($input: UpdateProductBoardStatusInput!) {
  updateProductBoardStatus(input: $input) {
    ...ProductBoardStatus
  }
}
    ${ProductBoardStatusFragmentDoc}`;
export type UpdateProductBoardStatusMutationFn = Apollo.MutationFunction<Types.UpdateProductBoardStatusMutation, Types.UpdateProductBoardStatusMutationVariables>;

/**
 * __useUpdateProductBoardStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProductBoardStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBoardStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBoardStatusMutation, { data, loading, error }] = useUpdateProductBoardStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBoardStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductBoardStatusMutation, Types.UpdateProductBoardStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductBoardStatusMutation, Types.UpdateProductBoardStatusMutationVariables>(UpdateProductBoardStatusDocument, options);
      }
export type UpdateProductBoardStatusMutationHookResult = ReturnType<typeof useUpdateProductBoardStatusMutation>;
export type UpdateProductBoardStatusMutationResult = Apollo.MutationResult<Types.UpdateProductBoardStatusMutation>;
export type UpdateProductBoardStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductBoardStatusMutation, Types.UpdateProductBoardStatusMutationVariables>;
export const ProductBoardStatusesDocument = gql`
    query ProductBoardStatuses {
  productBoardStatuses {
    ...ProductBoardStatus
  }
}
    ${ProductBoardStatusFragmentDoc}`;

/**
 * __useProductBoardStatusesQuery__
 *
 * To run a query within a React component, call `useProductBoardStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBoardStatusesQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardStatusesQuery, Types.ProductBoardStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardStatusesQuery, Types.ProductBoardStatusesQueryVariables>(ProductBoardStatusesDocument, options);
      }
export function useProductBoardStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardStatusesQuery, Types.ProductBoardStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardStatusesQuery, Types.ProductBoardStatusesQueryVariables>(ProductBoardStatusesDocument, options);
        }
export type ProductBoardStatusesQueryHookResult = ReturnType<typeof useProductBoardStatusesQuery>;
export type ProductBoardStatusesLazyQueryHookResult = ReturnType<typeof useProductBoardStatusesLazyQuery>;
export type ProductBoardStatusesQueryResult = Apollo.QueryResult<Types.ProductBoardStatusesQuery, Types.ProductBoardStatusesQueryVariables>;
export const PublicProductBoardStatusesDocument = gql`
    query PublicProductBoardStatuses {
  publicProductRoadmapStatuses {
    ...ProductBoardStatus
  }
}
    ${ProductBoardStatusFragmentDoc}`;

/**
 * __usePublicProductBoardStatusesQuery__
 *
 * To run a query within a React component, call `usePublicProductBoardStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductBoardStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductBoardStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicProductBoardStatusesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductBoardStatusesQuery, Types.PublicProductBoardStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductBoardStatusesQuery, Types.PublicProductBoardStatusesQueryVariables>(PublicProductBoardStatusesDocument, options);
      }
export function usePublicProductBoardStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductBoardStatusesQuery, Types.PublicProductBoardStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductBoardStatusesQuery, Types.PublicProductBoardStatusesQueryVariables>(PublicProductBoardStatusesDocument, options);
        }
export type PublicProductBoardStatusesQueryHookResult = ReturnType<typeof usePublicProductBoardStatusesQuery>;
export type PublicProductBoardStatusesLazyQueryHookResult = ReturnType<typeof usePublicProductBoardStatusesLazyQuery>;
export type PublicProductBoardStatusesQueryResult = Apollo.QueryResult<Types.PublicProductBoardStatusesQuery, Types.PublicProductBoardStatusesQueryVariables>;
export const UpdateRoadmapsPublicPagesSettingsDocument = gql`
    mutation UpdateRoadmapsPublicPagesSettings($input: UpdateRoadmapsPublicPagesSettingsInput!) {
  updateRoadmapsPublicPagesSettings(input: $input) {
    ...RoadmapsPublicPagesSettings
  }
}
    ${RoadmapsPublicPagesSettingsFragmentDoc}`;
export type UpdateRoadmapsPublicPagesSettingsMutationFn = Apollo.MutationFunction<Types.UpdateRoadmapsPublicPagesSettingsMutation, Types.UpdateRoadmapsPublicPagesSettingsMutationVariables>;

/**
 * __useUpdateRoadmapsPublicPagesSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateRoadmapsPublicPagesSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoadmapsPublicPagesSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoadmapsPublicPagesSettingsMutation, { data, loading, error }] = useUpdateRoadmapsPublicPagesSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoadmapsPublicPagesSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRoadmapsPublicPagesSettingsMutation, Types.UpdateRoadmapsPublicPagesSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRoadmapsPublicPagesSettingsMutation, Types.UpdateRoadmapsPublicPagesSettingsMutationVariables>(UpdateRoadmapsPublicPagesSettingsDocument, options);
      }
export type UpdateRoadmapsPublicPagesSettingsMutationHookResult = ReturnType<typeof useUpdateRoadmapsPublicPagesSettingsMutation>;
export type UpdateRoadmapsPublicPagesSettingsMutationResult = Apollo.MutationResult<Types.UpdateRoadmapsPublicPagesSettingsMutation>;
export type UpdateRoadmapsPublicPagesSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRoadmapsPublicPagesSettingsMutation, Types.UpdateRoadmapsPublicPagesSettingsMutationVariables>;
export const UpdateCalendarPublicPageSettingsDocument = gql`
    mutation UpdateCalendarPublicPageSettings($input: UpdateCalendarPublicPageSettingsInput!) {
  updateCalendarPublicPageSettings(input: $input) {
    ...CalendarPublicPageSettings
  }
}
    ${CalendarPublicPageSettingsFragmentDoc}`;
export type UpdateCalendarPublicPageSettingsMutationFn = Apollo.MutationFunction<Types.UpdateCalendarPublicPageSettingsMutation, Types.UpdateCalendarPublicPageSettingsMutationVariables>;

/**
 * __useUpdateCalendarPublicPageSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarPublicPageSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarPublicPageSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarPublicPageSettingsMutation, { data, loading, error }] = useUpdateCalendarPublicPageSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalendarPublicPageSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCalendarPublicPageSettingsMutation, Types.UpdateCalendarPublicPageSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCalendarPublicPageSettingsMutation, Types.UpdateCalendarPublicPageSettingsMutationVariables>(UpdateCalendarPublicPageSettingsDocument, options);
      }
export type UpdateCalendarPublicPageSettingsMutationHookResult = ReturnType<typeof useUpdateCalendarPublicPageSettingsMutation>;
export type UpdateCalendarPublicPageSettingsMutationResult = Apollo.MutationResult<Types.UpdateCalendarPublicPageSettingsMutation>;
export type UpdateCalendarPublicPageSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCalendarPublicPageSettingsMutation, Types.UpdateCalendarPublicPageSettingsMutationVariables>;
export const RoadmapsPublicPagesSettingsDocument = gql`
    query RoadmapsPublicPagesSettings {
  organization {
    ...RoadmapsPublicPagesSettings
  }
}
    ${RoadmapsPublicPagesSettingsFragmentDoc}`;

/**
 * __useRoadmapsPublicPagesSettingsQuery__
 *
 * To run a query within a React component, call `useRoadmapsPublicPagesSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadmapsPublicPagesSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadmapsPublicPagesSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoadmapsPublicPagesSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.RoadmapsPublicPagesSettingsQuery, Types.RoadmapsPublicPagesSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RoadmapsPublicPagesSettingsQuery, Types.RoadmapsPublicPagesSettingsQueryVariables>(RoadmapsPublicPagesSettingsDocument, options);
      }
export function useRoadmapsPublicPagesSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RoadmapsPublicPagesSettingsQuery, Types.RoadmapsPublicPagesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RoadmapsPublicPagesSettingsQuery, Types.RoadmapsPublicPagesSettingsQueryVariables>(RoadmapsPublicPagesSettingsDocument, options);
        }
export type RoadmapsPublicPagesSettingsQueryHookResult = ReturnType<typeof useRoadmapsPublicPagesSettingsQuery>;
export type RoadmapsPublicPagesSettingsLazyQueryHookResult = ReturnType<typeof useRoadmapsPublicPagesSettingsLazyQuery>;
export type RoadmapsPublicPagesSettingsQueryResult = Apollo.QueryResult<Types.RoadmapsPublicPagesSettingsQuery, Types.RoadmapsPublicPagesSettingsQueryVariables>;
export const CalendarPublicPageSettingsDocument = gql`
    query CalendarPublicPageSettings {
  organization {
    ...CalendarPublicPageSettings
  }
}
    ${CalendarPublicPageSettingsFragmentDoc}`;

/**
 * __useCalendarPublicPageSettingsQuery__
 *
 * To run a query within a React component, call `useCalendarPublicPageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarPublicPageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarPublicPageSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarPublicPageSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CalendarPublicPageSettingsQuery, Types.CalendarPublicPageSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CalendarPublicPageSettingsQuery, Types.CalendarPublicPageSettingsQueryVariables>(CalendarPublicPageSettingsDocument, options);
      }
export function useCalendarPublicPageSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CalendarPublicPageSettingsQuery, Types.CalendarPublicPageSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CalendarPublicPageSettingsQuery, Types.CalendarPublicPageSettingsQueryVariables>(CalendarPublicPageSettingsDocument, options);
        }
export type CalendarPublicPageSettingsQueryHookResult = ReturnType<typeof useCalendarPublicPageSettingsQuery>;
export type CalendarPublicPageSettingsLazyQueryHookResult = ReturnType<typeof useCalendarPublicPageSettingsLazyQuery>;
export type CalendarPublicPageSettingsQueryResult = Apollo.QueryResult<Types.CalendarPublicPageSettingsQuery, Types.CalendarPublicPageSettingsQueryVariables>;
export const ImportInsightsFromCsvDocument = gql`
    mutation ImportInsightsFromCsv($input: ImportInsightsFromCsvInput!) {
  importInsightsFromCsv(input: $input) {
    id
  }
}
    `;
export type ImportInsightsFromCsvMutationFn = Apollo.MutationFunction<Types.ImportInsightsFromCsvMutation, Types.ImportInsightsFromCsvMutationVariables>;

/**
 * __useImportInsightsFromCsvMutation__
 *
 * To run a mutation, you first call `useImportInsightsFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportInsightsFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importInsightsFromCsvMutation, { data, loading, error }] = useImportInsightsFromCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportInsightsFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportInsightsFromCsvMutation, Types.ImportInsightsFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportInsightsFromCsvMutation, Types.ImportInsightsFromCsvMutationVariables>(ImportInsightsFromCsvDocument, options);
      }
export type ImportInsightsFromCsvMutationHookResult = ReturnType<typeof useImportInsightsFromCsvMutation>;
export type ImportInsightsFromCsvMutationResult = Apollo.MutationResult<Types.ImportInsightsFromCsvMutation>;
export type ImportInsightsFromCsvMutationOptions = Apollo.BaseMutationOptions<Types.ImportInsightsFromCsvMutation, Types.ImportInsightsFromCsvMutationVariables>;
export const CreateRetroDocument = gql`
    mutation CreateRetro($input: CreateRetroInput!) {
  createRetro(input: $input) {
    ...RetroData
  }
}
    ${RetroDataFragmentDoc}`;
export type CreateRetroMutationFn = Apollo.MutationFunction<Types.CreateRetroMutation, Types.CreateRetroMutationVariables>;

/**
 * __useCreateRetroMutation__
 *
 * To run a mutation, you first call `useCreateRetroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRetroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRetroMutation, { data, loading, error }] = useCreateRetroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRetroMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateRetroMutation, Types.CreateRetroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateRetroMutation, Types.CreateRetroMutationVariables>(CreateRetroDocument, options);
      }
export type CreateRetroMutationHookResult = ReturnType<typeof useCreateRetroMutation>;
export type CreateRetroMutationResult = Apollo.MutationResult<Types.CreateRetroMutation>;
export type CreateRetroMutationOptions = Apollo.BaseMutationOptions<Types.CreateRetroMutation, Types.CreateRetroMutationVariables>;
export const GetRetroResponsesDocument = gql`
    query GetRetroResponses($input: RetroResultsInput!, $filter: FilterRetroInput, $sort: SortRetroInput) {
  getRetroResponses(input: $input) {
    ...RetroAnswers
  }
  retro(filter: $filter, sort: $sort) {
    id
    takeaways
  }
}
    ${RetroAnswersFragmentDoc}`;

/**
 * __useGetRetroResponsesQuery__
 *
 * To run a query within a React component, call `useGetRetroResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetroResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetroResponsesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetRetroResponsesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRetroResponsesQuery, Types.GetRetroResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRetroResponsesQuery, Types.GetRetroResponsesQueryVariables>(GetRetroResponsesDocument, options);
      }
export function useGetRetroResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRetroResponsesQuery, Types.GetRetroResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRetroResponsesQuery, Types.GetRetroResponsesQueryVariables>(GetRetroResponsesDocument, options);
        }
export type GetRetroResponsesQueryHookResult = ReturnType<typeof useGetRetroResponsesQuery>;
export type GetRetroResponsesLazyQueryHookResult = ReturnType<typeof useGetRetroResponsesLazyQuery>;
export type GetRetroResponsesQueryResult = Apollo.QueryResult<Types.GetRetroResponsesQuery, Types.GetRetroResponsesQueryVariables>;
export const UpdateRetroDocument = gql`
    mutation UpdateRetro($input: UpdateRetroInput!) {
  updateRetro(input: $input) {
    takeaways
  }
}
    `;
export type UpdateRetroMutationFn = Apollo.MutationFunction<Types.UpdateRetroMutation, Types.UpdateRetroMutationVariables>;

/**
 * __useUpdateRetroMutation__
 *
 * To run a mutation, you first call `useUpdateRetroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRetroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRetroMutation, { data, loading, error }] = useUpdateRetroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRetroMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRetroMutation, Types.UpdateRetroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRetroMutation, Types.UpdateRetroMutationVariables>(UpdateRetroDocument, options);
      }
export type UpdateRetroMutationHookResult = ReturnType<typeof useUpdateRetroMutation>;
export type UpdateRetroMutationResult = Apollo.MutationResult<Types.UpdateRetroMutation>;
export type UpdateRetroMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRetroMutation, Types.UpdateRetroMutationVariables>;
export const CreateSurveyDocument = gql`
    mutation CreateSurvey($input: CreateSurveyInput!) {
  createSurvey(input: $input) {
    id
    name
    webLink
    resultLink
    sentOn
    status
    surveyType
    recipients {
      id
      firstname
      lastname
      email
      sent
    }
  }
}
    `;
export type CreateSurveyMutationFn = Apollo.MutationFunction<Types.CreateSurveyMutation, Types.CreateSurveyMutationVariables>;

/**
 * __useCreateSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyMutation, { data, loading, error }] = useCreateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSurveyMutation, Types.CreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSurveyMutation, Types.CreateSurveyMutationVariables>(CreateSurveyDocument, options);
      }
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>;
export type CreateSurveyMutationResult = Apollo.MutationResult<Types.CreateSurveyMutation>;
export type CreateSurveyMutationOptions = Apollo.BaseMutationOptions<Types.CreateSurveyMutation, Types.CreateSurveyMutationVariables>;
export const RemoveSurveyDocument = gql`
    mutation RemoveSurvey($id: String!) {
  removeSurvey(id: $id) {
    id
  }
}
    `;
export type RemoveSurveyMutationFn = Apollo.MutationFunction<Types.RemoveSurveyMutation, Types.RemoveSurveyMutationVariables>;

/**
 * __useRemoveSurveyMutation__
 *
 * To run a mutation, you first call `useRemoveSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSurveyMutation, { data, loading, error }] = useRemoveSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSurveyMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveSurveyMutation, Types.RemoveSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveSurveyMutation, Types.RemoveSurveyMutationVariables>(RemoveSurveyDocument, options);
      }
export type RemoveSurveyMutationHookResult = ReturnType<typeof useRemoveSurveyMutation>;
export type RemoveSurveyMutationResult = Apollo.MutationResult<Types.RemoveSurveyMutation>;
export type RemoveSurveyMutationOptions = Apollo.BaseMutationOptions<Types.RemoveSurveyMutation, Types.RemoveSurveyMutationVariables>;
export const SendSurveyDocument = gql`
    mutation SendSurvey($input: SendSurveyInput!) {
  sendSurvey(input: $input) {
    id
    name
    status
    surveyType
    recipients {
      id
      firstname
      lastname
      email
      sent
    }
  }
}
    `;
export type SendSurveyMutationFn = Apollo.MutationFunction<Types.SendSurveyMutation, Types.SendSurveyMutationVariables>;

/**
 * __useSendSurveyMutation__
 *
 * To run a mutation, you first call `useSendSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSurveyMutation, { data, loading, error }] = useSendSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSurveyMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendSurveyMutation, Types.SendSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendSurveyMutation, Types.SendSurveyMutationVariables>(SendSurveyDocument, options);
      }
export type SendSurveyMutationHookResult = ReturnType<typeof useSendSurveyMutation>;
export type SendSurveyMutationResult = Apollo.MutationResult<Types.SendSurveyMutation>;
export type SendSurveyMutationOptions = Apollo.BaseMutationOptions<Types.SendSurveyMutation, Types.SendSurveyMutationVariables>;
export const UpdateSurveyDocument = gql`
    mutation UpdateSurvey($input: UpdateSurveyInput!) {
  updateSurvey(input: $input) {
    id
    name
    webLink
  }
}
    `;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<Types.UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>;
export const UpdateSurveyRecipientsDocument = gql`
    mutation UpdateSurveyRecipients($input: CreateSurveyRecipientsInput!) {
  updateSurveyRecipients(input: $input) {
    ...Survey
  }
}
    ${SurveyFragmentDoc}`;
export type UpdateSurveyRecipientsMutationFn = Apollo.MutationFunction<Types.UpdateSurveyRecipientsMutation, Types.UpdateSurveyRecipientsMutationVariables>;

/**
 * __useUpdateSurveyRecipientsMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyRecipientsMutation, { data, loading, error }] = useUpdateSurveyRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurveyRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSurveyRecipientsMutation, Types.UpdateSurveyRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSurveyRecipientsMutation, Types.UpdateSurveyRecipientsMutationVariables>(UpdateSurveyRecipientsDocument, options);
      }
export type UpdateSurveyRecipientsMutationHookResult = ReturnType<typeof useUpdateSurveyRecipientsMutation>;
export type UpdateSurveyRecipientsMutationResult = Apollo.MutationResult<Types.UpdateSurveyRecipientsMutation>;
export type UpdateSurveyRecipientsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSurveyRecipientsMutation, Types.UpdateSurveyRecipientsMutationVariables>;
export const GetSurveyTypesDocument = gql`
    query GetSurveyTypes {
  surveyTypes {
    type
    inputs {
      key
      placeholder
      label
      required
      type
      maxLength
      minLength
    }
  }
}
    `;

/**
 * __useGetSurveyTypesQuery__
 *
 * To run a query within a React component, call `useGetSurveyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveyTypesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSurveyTypesQuery, Types.GetSurveyTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveyTypesQuery, Types.GetSurveyTypesQueryVariables>(GetSurveyTypesDocument, options);
      }
export function useGetSurveyTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveyTypesQuery, Types.GetSurveyTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveyTypesQuery, Types.GetSurveyTypesQueryVariables>(GetSurveyTypesDocument, options);
        }
export type GetSurveyTypesQueryHookResult = ReturnType<typeof useGetSurveyTypesQuery>;
export type GetSurveyTypesLazyQueryHookResult = ReturnType<typeof useGetSurveyTypesLazyQuery>;
export type GetSurveyTypesQueryResult = Apollo.QueryResult<Types.GetSurveyTypesQuery, Types.GetSurveyTypesQueryVariables>;
export const SurveysDocument = gql`
    query Surveys($pagination: PaginationInput) {
  surveys(pagination: $pagination) {
    totalPages
    page
    docs {
      ...Survey
    }
  }
}
    ${SurveyFragmentDoc}`;

/**
 * __useSurveysQuery__
 *
 * To run a query within a React component, call `useSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveysQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSurveysQuery(baseOptions?: Apollo.QueryHookOptions<Types.SurveysQuery, Types.SurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SurveysQuery, Types.SurveysQueryVariables>(SurveysDocument, options);
      }
export function useSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SurveysQuery, Types.SurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SurveysQuery, Types.SurveysQueryVariables>(SurveysDocument, options);
        }
export type SurveysQueryHookResult = ReturnType<typeof useSurveysQuery>;
export type SurveysLazyQueryHookResult = ReturnType<typeof useSurveysLazyQuery>;
export type SurveysQueryResult = Apollo.QueryResult<Types.SurveysQuery, Types.SurveysQueryVariables>;
export const SurveysCountDocument = gql`
    query SurveysCount($pagination: PaginationInput) {
  surveys(pagination: $pagination) {
    totalDocs
  }
}
    `;

/**
 * __useSurveysCountQuery__
 *
 * To run a query within a React component, call `useSurveysCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveysCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveysCountQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSurveysCountQuery(baseOptions?: Apollo.QueryHookOptions<Types.SurveysCountQuery, Types.SurveysCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SurveysCountQuery, Types.SurveysCountQueryVariables>(SurveysCountDocument, options);
      }
export function useSurveysCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SurveysCountQuery, Types.SurveysCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SurveysCountQuery, Types.SurveysCountQueryVariables>(SurveysCountDocument, options);
        }
export type SurveysCountQueryHookResult = ReturnType<typeof useSurveysCountQuery>;
export type SurveysCountLazyQueryHookResult = ReturnType<typeof useSurveysCountLazyQuery>;
export type SurveysCountQueryResult = Apollo.QueryResult<Types.SurveysCountQuery, Types.SurveysCountQueryVariables>;
export const TagsDocument = gql`
    query Tags($input: FindTagsInput) {
  tags(input: $input) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TagsQuery, Types.TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TagsQuery, Types.TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TagsQuery, Types.TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TagsQuery, Types.TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<Types.TagsQuery, Types.TagsQueryVariables>;
export const PublicLaunchPageTagsDocument = gql`
    query PublicLaunchPageTags($input: FindTagsInput) {
  publicLaunchPageTags(input: $input) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __usePublicLaunchPageTagsQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicLaunchPageTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageTagsQuery, Types.PublicLaunchPageTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageTagsQuery, Types.PublicLaunchPageTagsQueryVariables>(PublicLaunchPageTagsDocument, options);
      }
export function usePublicLaunchPageTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageTagsQuery, Types.PublicLaunchPageTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageTagsQuery, Types.PublicLaunchPageTagsQueryVariables>(PublicLaunchPageTagsDocument, options);
        }
export type PublicLaunchPageTagsQueryHookResult = ReturnType<typeof usePublicLaunchPageTagsQuery>;
export type PublicLaunchPageTagsLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageTagsLazyQuery>;
export type PublicLaunchPageTagsQueryResult = Apollo.QueryResult<Types.PublicLaunchPageTagsQuery, Types.PublicLaunchPageTagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<Types.CreateTagMutation, Types.CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTagMutation, Types.CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTagMutation, Types.CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<Types.CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<Types.CreateTagMutation, Types.CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<Types.UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($input: DeleteTagInput!) {
  deleteTag(input: $input) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type DeleteTagMutationFn = Apollo.MutationFunction<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<Types.DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>;
export const AddTagToTaskDocument = gql`
    mutation AddTagToTask($input: AssignTagToTasksInput!) {
  addTagToTask(input: $input) {
    id
    parentId
    tags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type AddTagToTaskMutationFn = Apollo.MutationFunction<Types.AddTagToTaskMutation, Types.AddTagToTaskMutationVariables>;

/**
 * __useAddTagToTaskMutation__
 *
 * To run a mutation, you first call `useAddTagToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToTaskMutation, { data, loading, error }] = useAddTagToTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTagToTaskMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddTagToTaskMutation, Types.AddTagToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddTagToTaskMutation, Types.AddTagToTaskMutationVariables>(AddTagToTaskDocument, options);
      }
export type AddTagToTaskMutationHookResult = ReturnType<typeof useAddTagToTaskMutation>;
export type AddTagToTaskMutationResult = Apollo.MutationResult<Types.AddTagToTaskMutation>;
export type AddTagToTaskMutationOptions = Apollo.BaseMutationOptions<Types.AddTagToTaskMutation, Types.AddTagToTaskMutationVariables>;
export const CreateDefaultTasksDocument = gql`
    mutation CreateDefaultTasks($input: CreateDefaultLaunchTasksInput!) {
  createDefaultTasks(input: $input) {
    id
  }
}
    `;
export type CreateDefaultTasksMutationFn = Apollo.MutationFunction<Types.CreateDefaultTasksMutation, Types.CreateDefaultTasksMutationVariables>;

/**
 * __useCreateDefaultTasksMutation__
 *
 * To run a mutation, you first call `useCreateDefaultTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultTasksMutation, { data, loading, error }] = useCreateDefaultTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDefaultTasksMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDefaultTasksMutation, Types.CreateDefaultTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDefaultTasksMutation, Types.CreateDefaultTasksMutationVariables>(CreateDefaultTasksDocument, options);
      }
export type CreateDefaultTasksMutationHookResult = ReturnType<typeof useCreateDefaultTasksMutation>;
export type CreateDefaultTasksMutationResult = Apollo.MutationResult<Types.CreateDefaultTasksMutation>;
export type CreateDefaultTasksMutationOptions = Apollo.BaseMutationOptions<Types.CreateDefaultTasksMutation, Types.CreateDefaultTasksMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    ...TaskPreview
    subtasks {
      ...TaskPreview
    }
  }
}
    ${TaskPreviewFragmentDoc}`;
export type CreateTaskMutationFn = Apollo.MutationFunction<Types.CreateTaskMutation, Types.CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTaskMutation, Types.CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTaskMutation, Types.CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<Types.CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<Types.CreateTaskMutation, Types.CreateTaskMutationVariables>;
export const DeleteTagFromTasksDocument = gql`
    mutation DeleteTagFromTasks($input: DeleteTagFromTasksInput!) {
  removeTagFromTask(input: $input) {
    parentId
    ...TaskWithTags
  }
}
    ${TaskWithTagsFragmentDoc}`;
export type DeleteTagFromTasksMutationFn = Apollo.MutationFunction<Types.DeleteTagFromTasksMutation, Types.DeleteTagFromTasksMutationVariables>;

/**
 * __useDeleteTagFromTasksMutation__
 *
 * To run a mutation, you first call `useDeleteTagFromTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagFromTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagFromTasksMutation, { data, loading, error }] = useDeleteTagFromTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagFromTasksMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTagFromTasksMutation, Types.DeleteTagFromTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTagFromTasksMutation, Types.DeleteTagFromTasksMutationVariables>(DeleteTagFromTasksDocument, options);
      }
export type DeleteTagFromTasksMutationHookResult = ReturnType<typeof useDeleteTagFromTasksMutation>;
export type DeleteTagFromTasksMutationResult = Apollo.MutationResult<Types.DeleteTagFromTasksMutation>;
export type DeleteTagFromTasksMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTagFromTasksMutation, Types.DeleteTagFromTasksMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($input: DeleteTaskInput!) {
  deleteTask(id: $input) {
    id
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<Types.DeleteTaskMutation, Types.DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTaskMutation, Types.DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTaskMutation, Types.DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<Types.DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTaskMutation, Types.DeleteTaskMutationVariables>;
export const DeleteTasksDocument = gql`
    mutation DeleteTasks($input: DeleteTasksInput!) {
  deleteTasks(input: $input) {
    id
  }
}
    `;
export type DeleteTasksMutationFn = Apollo.MutationFunction<Types.DeleteTasksMutation, Types.DeleteTasksMutationVariables>;

/**
 * __useDeleteTasksMutation__
 *
 * To run a mutation, you first call `useDeleteTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTasksMutation, { data, loading, error }] = useDeleteTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTasksMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTasksMutation, Types.DeleteTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTasksMutation, Types.DeleteTasksMutationVariables>(DeleteTasksDocument, options);
      }
export type DeleteTasksMutationHookResult = ReturnType<typeof useDeleteTasksMutation>;
export type DeleteTasksMutationResult = Apollo.MutationResult<Types.DeleteTasksMutation>;
export type DeleteTasksMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTasksMutation, Types.DeleteTasksMutationVariables>;
export const ExportTasksToCsvDocument = gql`
    mutation ExportTasksToCsv($filter: FilterTasksInput) {
  exportTasksToCsv(filter: $filter)
}
    `;
export type ExportTasksToCsvMutationFn = Apollo.MutationFunction<Types.ExportTasksToCsvMutation, Types.ExportTasksToCsvMutationVariables>;

/**
 * __useExportTasksToCsvMutation__
 *
 * To run a mutation, you first call `useExportTasksToCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTasksToCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTasksToCsvMutation, { data, loading, error }] = useExportTasksToCsvMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportTasksToCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportTasksToCsvMutation, Types.ExportTasksToCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportTasksToCsvMutation, Types.ExportTasksToCsvMutationVariables>(ExportTasksToCsvDocument, options);
      }
export type ExportTasksToCsvMutationHookResult = ReturnType<typeof useExportTasksToCsvMutation>;
export type ExportTasksToCsvMutationResult = Apollo.MutationResult<Types.ExportTasksToCsvMutation>;
export type ExportTasksToCsvMutationOptions = Apollo.BaseMutationOptions<Types.ExportTasksToCsvMutation, Types.ExportTasksToCsvMutationVariables>;
export const ImportTasksFromCsvDocument = gql`
    mutation ImportTasksFromCsv($input: ImportTasksFromCsvInput!) {
  importTasksFromCsv(input: $input) {
    id
  }
}
    `;
export type ImportTasksFromCsvMutationFn = Apollo.MutationFunction<Types.ImportTasksFromCsvMutation, Types.ImportTasksFromCsvMutationVariables>;

/**
 * __useImportTasksFromCsvMutation__
 *
 * To run a mutation, you first call `useImportTasksFromCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTasksFromCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTasksFromCsvMutation, { data, loading, error }] = useImportTasksFromCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportTasksFromCsvMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportTasksFromCsvMutation, Types.ImportTasksFromCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportTasksFromCsvMutation, Types.ImportTasksFromCsvMutationVariables>(ImportTasksFromCsvDocument, options);
      }
export type ImportTasksFromCsvMutationHookResult = ReturnType<typeof useImportTasksFromCsvMutation>;
export type ImportTasksFromCsvMutationResult = Apollo.MutationResult<Types.ImportTasksFromCsvMutation>;
export type ImportTasksFromCsvMutationOptions = Apollo.BaseMutationOptions<Types.ImportTasksFromCsvMutation, Types.ImportTasksFromCsvMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<Types.UpdateTaskMutation, Types.UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTaskMutation, Types.UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTaskMutation, Types.UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<Types.UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTaskMutation, Types.UpdateTaskMutationVariables>;
export const UpdateTaskPreviewDocument = gql`
    mutation UpdateTaskPreview($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    ...TaskPreview
    subtasks {
      ...TaskPreview
    }
  }
}
    ${TaskPreviewFragmentDoc}`;
export type UpdateTaskPreviewMutationFn = Apollo.MutationFunction<Types.UpdateTaskPreviewMutation, Types.UpdateTaskPreviewMutationVariables>;

/**
 * __useUpdateTaskPreviewMutation__
 *
 * To run a mutation, you first call `useUpdateTaskPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskPreviewMutation, { data, loading, error }] = useUpdateTaskPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskPreviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTaskPreviewMutation, Types.UpdateTaskPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTaskPreviewMutation, Types.UpdateTaskPreviewMutationVariables>(UpdateTaskPreviewDocument, options);
      }
export type UpdateTaskPreviewMutationHookResult = ReturnType<typeof useUpdateTaskPreviewMutation>;
export type UpdateTaskPreviewMutationResult = Apollo.MutationResult<Types.UpdateTaskPreviewMutation>;
export type UpdateTaskPreviewMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTaskPreviewMutation, Types.UpdateTaskPreviewMutationVariables>;
export const LaunchTasksFiltersOptionsDocument = gql`
    query LaunchTasksFiltersOptions($launchId: String!) {
  assignees: tasksAssignees(filter: {launchIds: [$launchId]}) {
    ...UserDetails
  }
  tags(
    input: {launchId: $launchId, parentName: TASKS, types: [TASK, PRODUCT_LINE]}
  ) {
    ...Tag
  }
}
    ${UserDetailsFragmentDoc}
${TagFragmentDoc}`;

/**
 * __useLaunchTasksFiltersOptionsQuery__
 *
 * To run a query within a React component, call `useLaunchTasksFiltersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchTasksFiltersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchTasksFiltersOptionsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchTasksFiltersOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchTasksFiltersOptionsQuery, Types.LaunchTasksFiltersOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchTasksFiltersOptionsQuery, Types.LaunchTasksFiltersOptionsQueryVariables>(LaunchTasksFiltersOptionsDocument, options);
      }
export function useLaunchTasksFiltersOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchTasksFiltersOptionsQuery, Types.LaunchTasksFiltersOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchTasksFiltersOptionsQuery, Types.LaunchTasksFiltersOptionsQueryVariables>(LaunchTasksFiltersOptionsDocument, options);
        }
export type LaunchTasksFiltersOptionsQueryHookResult = ReturnType<typeof useLaunchTasksFiltersOptionsQuery>;
export type LaunchTasksFiltersOptionsLazyQueryHookResult = ReturnType<typeof useLaunchTasksFiltersOptionsLazyQuery>;
export type LaunchTasksFiltersOptionsQueryResult = Apollo.QueryResult<Types.LaunchTasksFiltersOptionsQuery, Types.LaunchTasksFiltersOptionsQueryVariables>;
export const OutsideTasksFiltersOptionsDocument = gql`
    query OutsideTasksFiltersOptions {
  assignees: tasksAssignees(filter: {launchIds: null}) {
    ...UserDetails
  }
  tags(input: {parentName: TASKS, types: [TASK, PRODUCT_LINE], launchId: null}) {
    ...Tag
  }
}
    ${UserDetailsFragmentDoc}
${TagFragmentDoc}`;

/**
 * __useOutsideTasksFiltersOptionsQuery__
 *
 * To run a query within a React component, call `useOutsideTasksFiltersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutsideTasksFiltersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutsideTasksFiltersOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutsideTasksFiltersOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OutsideTasksFiltersOptionsQuery, Types.OutsideTasksFiltersOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OutsideTasksFiltersOptionsQuery, Types.OutsideTasksFiltersOptionsQueryVariables>(OutsideTasksFiltersOptionsDocument, options);
      }
export function useOutsideTasksFiltersOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OutsideTasksFiltersOptionsQuery, Types.OutsideTasksFiltersOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OutsideTasksFiltersOptionsQuery, Types.OutsideTasksFiltersOptionsQueryVariables>(OutsideTasksFiltersOptionsDocument, options);
        }
export type OutsideTasksFiltersOptionsQueryHookResult = ReturnType<typeof useOutsideTasksFiltersOptionsQuery>;
export type OutsideTasksFiltersOptionsLazyQueryHookResult = ReturnType<typeof useOutsideTasksFiltersOptionsLazyQuery>;
export type OutsideTasksFiltersOptionsQueryResult = Apollo.QueryResult<Types.OutsideTasksFiltersOptionsQuery, Types.OutsideTasksFiltersOptionsQueryVariables>;
export const PaginatedTasksDocument = gql`
    query PaginatedTasks($sort: SortTasksInput!, $filter: FilterTasksInput!, $pagination: PaginationInput!) {
  paginatedTasks(sort: $sort, filter: $filter, pagination: $pagination) {
    page
    nextPage
    totalDocs
    totalPages
    docs {
      ...TaskPreview
      subtasks(filter: $filter) {
        ...TaskPreview
      }
    }
    groups {
      key
      count
    }
  }
}
    ${TaskPreviewFragmentDoc}`;

/**
 * __usePaginatedTasksQuery__
 *
 * To run a query within a React component, call `usePaginatedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedTasksQuery, Types.PaginatedTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedTasksQuery, Types.PaginatedTasksQueryVariables>(PaginatedTasksDocument, options);
      }
export function usePaginatedTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedTasksQuery, Types.PaginatedTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedTasksQuery, Types.PaginatedTasksQueryVariables>(PaginatedTasksDocument, options);
        }
export type PaginatedTasksQueryHookResult = ReturnType<typeof usePaginatedTasksQuery>;
export type PaginatedTasksLazyQueryHookResult = ReturnType<typeof usePaginatedTasksLazyQuery>;
export type PaginatedTasksQueryResult = Apollo.QueryResult<Types.PaginatedTasksQuery, Types.PaginatedTasksQueryVariables>;
export const PaginatedTasksPreviewDocument = gql`
    query PaginatedTasksPreview($sort: SortTasksInput!, $filter: FilterTasksInput!, $pagination: PaginationInput!) {
  paginatedTasks(sort: $sort, filter: $filter, pagination: $pagination) {
    page
    nextPage
    totalDocs
    totalPages
    docs {
      ...PaginatedTasksPreview
    }
    groups {
      key
      count
    }
  }
}
    ${PaginatedTasksPreviewFragmentDoc}`;

/**
 * __usePaginatedTasksPreviewQuery__
 *
 * To run a query within a React component, call `usePaginatedTasksPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTasksPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTasksPreviewQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedTasksPreviewQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedTasksPreviewQuery, Types.PaginatedTasksPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedTasksPreviewQuery, Types.PaginatedTasksPreviewQueryVariables>(PaginatedTasksPreviewDocument, options);
      }
export function usePaginatedTasksPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedTasksPreviewQuery, Types.PaginatedTasksPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedTasksPreviewQuery, Types.PaginatedTasksPreviewQueryVariables>(PaginatedTasksPreviewDocument, options);
        }
export type PaginatedTasksPreviewQueryHookResult = ReturnType<typeof usePaginatedTasksPreviewQuery>;
export type PaginatedTasksPreviewLazyQueryHookResult = ReturnType<typeof usePaginatedTasksPreviewLazyQuery>;
export type PaginatedTasksPreviewQueryResult = Apollo.QueryResult<Types.PaginatedTasksPreviewQuery, Types.PaginatedTasksPreviewQueryVariables>;
export const PublicLaunchPagePaginatedTasksDocument = gql`
    query PublicLaunchPagePaginatedTasks($sort: SortTasksInput!, $filter: FilterTasksInput!, $pagination: PaginationInput) {
  publicLaunchPagePaginatedTasks(
    sort: $sort
    filter: $filter
    pagination: $pagination
  ) {
    page
    nextPage
    totalPages
    docs {
      ...TaskPreview
      subtasks(filter: $filter) {
        ...TaskPreview
      }
    }
    groups {
      key
      count
    }
  }
}
    ${TaskPreviewFragmentDoc}`;

/**
 * __usePublicLaunchPagePaginatedTasksQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPagePaginatedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPagePaginatedTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPagePaginatedTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePublicLaunchPagePaginatedTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicLaunchPagePaginatedTasksQuery, Types.PublicLaunchPagePaginatedTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPagePaginatedTasksQuery, Types.PublicLaunchPagePaginatedTasksQueryVariables>(PublicLaunchPagePaginatedTasksDocument, options);
      }
export function usePublicLaunchPagePaginatedTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPagePaginatedTasksQuery, Types.PublicLaunchPagePaginatedTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPagePaginatedTasksQuery, Types.PublicLaunchPagePaginatedTasksQueryVariables>(PublicLaunchPagePaginatedTasksDocument, options);
        }
export type PublicLaunchPagePaginatedTasksQueryHookResult = ReturnType<typeof usePublicLaunchPagePaginatedTasksQuery>;
export type PublicLaunchPagePaginatedTasksLazyQueryHookResult = ReturnType<typeof usePublicLaunchPagePaginatedTasksLazyQuery>;
export type PublicLaunchPagePaginatedTasksQueryResult = Apollo.QueryResult<Types.PublicLaunchPagePaginatedTasksQuery, Types.PublicLaunchPagePaginatedTasksQueryVariables>;
export const PublicLaunchPageTasksProgressDocument = gql`
    query PublicLaunchPageTasksProgress {
  publicLaunchPageTasksProgress {
    ...TasksProgress
  }
}
    ${TasksProgressFragmentDoc}`;

/**
 * __usePublicLaunchPageTasksProgressQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageTasksProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageTasksProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageTasksProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchPageTasksProgressQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageTasksProgressQuery, Types.PublicLaunchPageTasksProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageTasksProgressQuery, Types.PublicLaunchPageTasksProgressQueryVariables>(PublicLaunchPageTasksProgressDocument, options);
      }
export function usePublicLaunchPageTasksProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageTasksProgressQuery, Types.PublicLaunchPageTasksProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageTasksProgressQuery, Types.PublicLaunchPageTasksProgressQueryVariables>(PublicLaunchPageTasksProgressDocument, options);
        }
export type PublicLaunchPageTasksProgressQueryHookResult = ReturnType<typeof usePublicLaunchPageTasksProgressQuery>;
export type PublicLaunchPageTasksProgressLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageTasksProgressLazyQuery>;
export type PublicLaunchPageTasksProgressQueryResult = Apollo.QueryResult<Types.PublicLaunchPageTasksProgressQuery, Types.PublicLaunchPageTasksProgressQueryVariables>;
export const PublicLaunchPageUpcomingTasksDocument = gql`
    query PublicLaunchPageUpcomingTasks($pagination: PaginationInput = {limit: 3, page: 1}, $filter: FilterTasksInput = {statuses: [NOT_STARTED, IN_PROCESS, IN_REVIEW]}, $sort: SortTasksInput = {groupBy: STATUS, groupsSort: DUE_DATE, docsSort: DUE_DATE}) {
  publicLaunchPagePaginatedTasks(
    sort: $sort
    filter: $filter
    pagination: $pagination
  ) {
    docs {
      ...TaskPreview
      subtasks(filter: $filter) {
        ...TaskPreview
      }
    }
  }
}
    ${TaskPreviewFragmentDoc}`;

/**
 * __usePublicLaunchPageUpcomingTasksQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPageUpcomingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPageUpcomingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPageUpcomingTasksQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePublicLaunchPageUpcomingTasksQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchPageUpcomingTasksQuery, Types.PublicLaunchPageUpcomingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPageUpcomingTasksQuery, Types.PublicLaunchPageUpcomingTasksQueryVariables>(PublicLaunchPageUpcomingTasksDocument, options);
      }
export function usePublicLaunchPageUpcomingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPageUpcomingTasksQuery, Types.PublicLaunchPageUpcomingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPageUpcomingTasksQuery, Types.PublicLaunchPageUpcomingTasksQueryVariables>(PublicLaunchPageUpcomingTasksDocument, options);
        }
export type PublicLaunchPageUpcomingTasksQueryHookResult = ReturnType<typeof usePublicLaunchPageUpcomingTasksQuery>;
export type PublicLaunchPageUpcomingTasksLazyQueryHookResult = ReturnType<typeof usePublicLaunchPageUpcomingTasksLazyQuery>;
export type PublicLaunchPageUpcomingTasksQueryResult = Apollo.QueryResult<Types.PublicLaunchPageUpcomingTasksQuery, Types.PublicLaunchPageUpcomingTasksQueryVariables>;
export const TagsForTasksGroupByDocument = gql`
    query TagsForTasksGroupBy($isPreBuilt: Boolean) {
  tagsForTasksGroupBy(isPreBuilt: $isPreBuilt) {
    id
    label
    color
    isPreBuilt
  }
}
    `;

/**
 * __useTagsForTasksGroupByQuery__
 *
 * To run a query within a React component, call `useTagsForTasksGroupByQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsForTasksGroupByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsForTasksGroupByQuery({
 *   variables: {
 *      isPreBuilt: // value for 'isPreBuilt'
 *   },
 * });
 */
export function useTagsForTasksGroupByQuery(baseOptions?: Apollo.QueryHookOptions<Types.TagsForTasksGroupByQuery, Types.TagsForTasksGroupByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TagsForTasksGroupByQuery, Types.TagsForTasksGroupByQueryVariables>(TagsForTasksGroupByDocument, options);
      }
export function useTagsForTasksGroupByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TagsForTasksGroupByQuery, Types.TagsForTasksGroupByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TagsForTasksGroupByQuery, Types.TagsForTasksGroupByQueryVariables>(TagsForTasksGroupByDocument, options);
        }
export type TagsForTasksGroupByQueryHookResult = ReturnType<typeof useTagsForTasksGroupByQuery>;
export type TagsForTasksGroupByLazyQueryHookResult = ReturnType<typeof useTagsForTasksGroupByLazyQuery>;
export type TagsForTasksGroupByQueryResult = Apollo.QueryResult<Types.TagsForTasksGroupByQuery, Types.TagsForTasksGroupByQueryVariables>;
export const TaskDocument = gql`
    query Task($id: String!) {
  task(id: $id) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<Types.TaskQuery, Types.TaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TaskQuery, Types.TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TaskQuery, Types.TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TaskQuery, Types.TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = Apollo.QueryResult<Types.TaskQuery, Types.TaskQueryVariables>;
export const TaskBlockerTasksDocument = gql`
    query TaskBlockerTasks($id: String!) {
  task(id: $id) {
    id
    blockerTasks {
      ...BlocksTask
    }
  }
}
    ${BlocksTaskFragmentDoc}`;

/**
 * __useTaskBlockerTasksQuery__
 *
 * To run a query within a React component, call `useTaskBlockerTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBlockerTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBlockerTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskBlockerTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.TaskBlockerTasksQuery, Types.TaskBlockerTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TaskBlockerTasksQuery, Types.TaskBlockerTasksQueryVariables>(TaskBlockerTasksDocument, options);
      }
export function useTaskBlockerTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TaskBlockerTasksQuery, Types.TaskBlockerTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TaskBlockerTasksQuery, Types.TaskBlockerTasksQueryVariables>(TaskBlockerTasksDocument, options);
        }
export type TaskBlockerTasksQueryHookResult = ReturnType<typeof useTaskBlockerTasksQuery>;
export type TaskBlockerTasksLazyQueryHookResult = ReturnType<typeof useTaskBlockerTasksLazyQuery>;
export type TaskBlockerTasksQueryResult = Apollo.QueryResult<Types.TaskBlockerTasksQuery, Types.TaskBlockerTasksQueryVariables>;
export const TaskBlockingTasksDocument = gql`
    query TaskBlockingTasks($id: String!) {
  task(id: $id) {
    id
    blockingTasks {
      ...BlocksTask
    }
  }
}
    ${BlocksTaskFragmentDoc}`;

/**
 * __useTaskBlockingTasksQuery__
 *
 * To run a query within a React component, call `useTaskBlockingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBlockingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBlockingTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskBlockingTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.TaskBlockingTasksQuery, Types.TaskBlockingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TaskBlockingTasksQuery, Types.TaskBlockingTasksQueryVariables>(TaskBlockingTasksDocument, options);
      }
export function useTaskBlockingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TaskBlockingTasksQuery, Types.TaskBlockingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TaskBlockingTasksQuery, Types.TaskBlockingTasksQueryVariables>(TaskBlockingTasksDocument, options);
        }
export type TaskBlockingTasksQueryHookResult = ReturnType<typeof useTaskBlockingTasksQuery>;
export type TaskBlockingTasksLazyQueryHookResult = ReturnType<typeof useTaskBlockingTasksLazyQuery>;
export type TaskBlockingTasksQueryResult = Apollo.QueryResult<Types.TaskBlockingTasksQuery, Types.TaskBlockingTasksQueryVariables>;
export const TasksProgressDocument = gql`
    query TasksProgress($launchId: String) {
  tasksProgress(launchId: $launchId) {
    ...TasksProgress
  }
}
    ${TasksProgressFragmentDoc}`;

/**
 * __useTasksProgressQuery__
 *
 * To run a query within a React component, call `useTasksProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksProgressQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useTasksProgressQuery(baseOptions?: Apollo.QueryHookOptions<Types.TasksProgressQuery, Types.TasksProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TasksProgressQuery, Types.TasksProgressQueryVariables>(TasksProgressDocument, options);
      }
export function useTasksProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TasksProgressQuery, Types.TasksProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TasksProgressQuery, Types.TasksProgressQueryVariables>(TasksProgressDocument, options);
        }
export type TasksProgressQueryHookResult = ReturnType<typeof useTasksProgressQuery>;
export type TasksProgressLazyQueryHookResult = ReturnType<typeof useTasksProgressLazyQuery>;
export type TasksProgressQueryResult = Apollo.QueryResult<Types.TasksProgressQuery, Types.TasksProgressQueryVariables>;
export const UpcomingTasksDocument = gql`
    query UpcomingTasks($pagination: PaginationInput = {limit: 3, page: 1}, $filter: FilterTasksInput = {statuses: [NOT_STARTED, IN_PROCESS, IN_REVIEW]}, $sort: SortTasksInput = {groupBy: STATUS, groupsSort: DUE_DATE, docsSort: DUE_DATE}) {
  paginatedTasks(sort: $sort, filter: $filter, pagination: $pagination) {
    docs {
      ...TaskPreview
      subtasks(filter: $filter) {
        ...TaskPreview
      }
    }
  }
}
    ${TaskPreviewFragmentDoc}`;

/**
 * __useUpcomingTasksQuery__
 *
 * To run a query within a React component, call `useUpcomingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingTasksQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useUpcomingTasksQuery(baseOptions?: Apollo.QueryHookOptions<Types.UpcomingTasksQuery, Types.UpcomingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UpcomingTasksQuery, Types.UpcomingTasksQueryVariables>(UpcomingTasksDocument, options);
      }
export function useUpcomingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UpcomingTasksQuery, Types.UpcomingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UpcomingTasksQuery, Types.UpcomingTasksQueryVariables>(UpcomingTasksDocument, options);
        }
export type UpcomingTasksQueryHookResult = ReturnType<typeof useUpcomingTasksQuery>;
export type UpcomingTasksLazyQueryHookResult = ReturnType<typeof useUpcomingTasksLazyQuery>;
export type UpcomingTasksQueryResult = Apollo.QueryResult<Types.UpcomingTasksQuery, Types.UpcomingTasksQueryVariables>;
export const CustomOrganizationTemplatesDocument = gql`
    query CustomOrganizationTemplates {
  customOrganizationTemplates {
    ...CustomOrganizationTemplate
  }
}
    ${CustomOrganizationTemplateFragmentDoc}`;

/**
 * __useCustomOrganizationTemplatesQuery__
 *
 * To run a query within a React component, call `useCustomOrganizationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomOrganizationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomOrganizationTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomOrganizationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CustomOrganizationTemplatesQuery, Types.CustomOrganizationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CustomOrganizationTemplatesQuery, Types.CustomOrganizationTemplatesQueryVariables>(CustomOrganizationTemplatesDocument, options);
      }
export function useCustomOrganizationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CustomOrganizationTemplatesQuery, Types.CustomOrganizationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CustomOrganizationTemplatesQuery, Types.CustomOrganizationTemplatesQueryVariables>(CustomOrganizationTemplatesDocument, options);
        }
export type CustomOrganizationTemplatesQueryHookResult = ReturnType<typeof useCustomOrganizationTemplatesQuery>;
export type CustomOrganizationTemplatesLazyQueryHookResult = ReturnType<typeof useCustomOrganizationTemplatesLazyQuery>;
export type CustomOrganizationTemplatesQueryResult = Apollo.QueryResult<Types.CustomOrganizationTemplatesQuery, Types.CustomOrganizationTemplatesQueryVariables>;
export const TemplateDocument = gql`
    query Template($id: String!) {
  template(id: $id) {
    id
    name
    launchTier
    description
    organizationId
    templateSections {
      id
      name
      templateModules {
        id
      }
    }
    templateTasks {
      name
      type
      description
      tags
      defaultDueDateDuration
      subTasks {
        name
        type
        description
        tags
        defaultDueDateDuration
      }
    }
  }
}
    `;

/**
 * __useTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateQuery(baseOptions: Apollo.QueryHookOptions<Types.TemplateQuery, Types.TemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TemplateQuery, Types.TemplateQueryVariables>(TemplateDocument, options);
      }
export function useTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TemplateQuery, Types.TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TemplateQuery, Types.TemplateQueryVariables>(TemplateDocument, options);
        }
export type TemplateQueryHookResult = ReturnType<typeof useTemplateQuery>;
export type TemplateLazyQueryHookResult = ReturnType<typeof useTemplateLazyQuery>;
export type TemplateQueryResult = Apollo.QueryResult<Types.TemplateQuery, Types.TemplateQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<Types.CreateUserMutation, Types.CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateUserMutation, Types.CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateUserMutation, Types.CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<Types.CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<Types.CreateUserMutation, Types.CreateUserMutationVariables>;
export const DismissBannerDocument = gql`
    mutation DismissBanner($banner: DisplayedBanner!) {
  dismissBanner(banner: $banner) {
    id
  }
}
    `;
export type DismissBannerMutationFn = Apollo.MutationFunction<Types.DismissBannerMutation, Types.DismissBannerMutationVariables>;

/**
 * __useDismissBannerMutation__
 *
 * To run a mutation, you first call `useDismissBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissBannerMutation, { data, loading, error }] = useDismissBannerMutation({
 *   variables: {
 *      banner: // value for 'banner'
 *   },
 * });
 */
export function useDismissBannerMutation(baseOptions?: Apollo.MutationHookOptions<Types.DismissBannerMutation, Types.DismissBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DismissBannerMutation, Types.DismissBannerMutationVariables>(DismissBannerDocument, options);
      }
export type DismissBannerMutationHookResult = ReturnType<typeof useDismissBannerMutation>;
export type DismissBannerMutationResult = Apollo.MutationResult<Types.DismissBannerMutation>;
export type DismissBannerMutationOptions = Apollo.BaseMutationOptions<Types.DismissBannerMutation, Types.DismissBannerMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...ProfileData
  }
}
    ${ProfileDataFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Types.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export const UpdateUserInOrganizationDocument = gql`
    mutation UpdateUserInOrganization($input: UpdateUserInOrganizationInput!) {
  updateUserInOrganization(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export type UpdateUserInOrganizationMutationFn = Apollo.MutationFunction<Types.UpdateUserInOrganizationMutation, Types.UpdateUserInOrganizationMutationVariables>;

/**
 * __useUpdateUserInOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateUserInOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInOrganizationMutation, { data, loading, error }] = useUpdateUserInOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserInOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserInOrganizationMutation, Types.UpdateUserInOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserInOrganizationMutation, Types.UpdateUserInOrganizationMutationVariables>(UpdateUserInOrganizationDocument, options);
      }
export type UpdateUserInOrganizationMutationHookResult = ReturnType<typeof useUpdateUserInOrganizationMutation>;
export type UpdateUserInOrganizationMutationResult = Apollo.MutationResult<Types.UpdateUserInOrganizationMutation>;
export type UpdateUserInOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserInOrganizationMutation, Types.UpdateUserInOrganizationMutationVariables>;
export const UserThemeDocument = gql`
    query UserTheme($id: String!) {
  user(id: $id) {
    id
    theme
  }
}
    `;

/**
 * __useUserThemeQuery__
 *
 * To run a query within a React component, call `useUserThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserThemeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserThemeQuery(baseOptions: Apollo.QueryHookOptions<Types.UserThemeQuery, Types.UserThemeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UserThemeQuery, Types.UserThemeQueryVariables>(UserThemeDocument, options);
      }
export function useUserThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UserThemeQuery, Types.UserThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UserThemeQuery, Types.UserThemeQueryVariables>(UserThemeDocument, options);
        }
export type UserThemeQueryHookResult = ReturnType<typeof useUserThemeQuery>;
export type UserThemeLazyQueryHookResult = ReturnType<typeof useUserThemeLazyQuery>;
export type UserThemeQueryResult = Apollo.QueryResult<Types.UserThemeQuery, Types.UserThemeQueryVariables>;
export const LaunchCustomProgressDocument = gql`
    query LaunchCustomProgress($id: String!) {
  launch(id: $id) {
    ...LaunchCustomProgress
  }
}
    ${LaunchCustomProgressFragmentDoc}`;

/**
 * __useLaunchCustomProgressQuery__
 *
 * To run a query within a React component, call `useLaunchCustomProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCustomProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCustomProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchCustomProgressQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchCustomProgressQuery, Types.LaunchCustomProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCustomProgressQuery, Types.LaunchCustomProgressQueryVariables>(LaunchCustomProgressDocument, options);
      }
export function useLaunchCustomProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCustomProgressQuery, Types.LaunchCustomProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCustomProgressQuery, Types.LaunchCustomProgressQueryVariables>(LaunchCustomProgressDocument, options);
        }
export type LaunchCustomProgressQueryHookResult = ReturnType<typeof useLaunchCustomProgressQuery>;
export type LaunchCustomProgressLazyQueryHookResult = ReturnType<typeof useLaunchCustomProgressLazyQuery>;
export type LaunchCustomProgressQueryResult = Apollo.QueryResult<Types.LaunchCustomProgressQuery, Types.LaunchCustomProgressQueryVariables>;
export const SentTestMailDocument = gql`
    mutation sentTestMail($email: String!) {
  sendTestMail(email: $email)
}
    `;
export type SentTestMailMutationFn = Apollo.MutationFunction<Types.SentTestMailMutation, Types.SentTestMailMutationVariables>;

/**
 * __useSentTestMailMutation__
 *
 * To run a mutation, you first call `useSentTestMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSentTestMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sentTestMailMutation, { data, loading, error }] = useSentTestMailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSentTestMailMutation(baseOptions?: Apollo.MutationHookOptions<Types.SentTestMailMutation, Types.SentTestMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SentTestMailMutation, Types.SentTestMailMutationVariables>(SentTestMailDocument, options);
      }
export type SentTestMailMutationHookResult = ReturnType<typeof useSentTestMailMutation>;
export type SentTestMailMutationResult = Apollo.MutationResult<Types.SentTestMailMutation>;
export type SentTestMailMutationOptions = Apollo.BaseMutationOptions<Types.SentTestMailMutation, Types.SentTestMailMutationVariables>;
export const GetMissionControlPerformanceDataDocument = gql`
    query GetMissionControlPerformanceData($input: PerformanceDataFilterInput!) {
  getObjectivesCompletion(input: $input)
  getRetroScore(input: $input)
  getKPIPerformance(input: $input)
}
    `;

/**
 * __useGetMissionControlPerformanceDataQuery__
 *
 * To run a query within a React component, call `useGetMissionControlPerformanceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissionControlPerformanceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissionControlPerformanceDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMissionControlPerformanceDataQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMissionControlPerformanceDataQuery, Types.GetMissionControlPerformanceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMissionControlPerformanceDataQuery, Types.GetMissionControlPerformanceDataQueryVariables>(GetMissionControlPerformanceDataDocument, options);
      }
export function useGetMissionControlPerformanceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMissionControlPerformanceDataQuery, Types.GetMissionControlPerformanceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMissionControlPerformanceDataQuery, Types.GetMissionControlPerformanceDataQueryVariables>(GetMissionControlPerformanceDataDocument, options);
        }
export type GetMissionControlPerformanceDataQueryHookResult = ReturnType<typeof useGetMissionControlPerformanceDataQuery>;
export type GetMissionControlPerformanceDataLazyQueryHookResult = ReturnType<typeof useGetMissionControlPerformanceDataLazyQuery>;
export type GetMissionControlPerformanceDataQueryResult = Apollo.QueryResult<Types.GetMissionControlPerformanceDataQuery, Types.GetMissionControlPerformanceDataQueryVariables>;
export const GetOverdueTasksDocument = gql`
    query GetOverdueTasks($sort: SortTasksInput!, $pagination: PaginationInput) {
  getOverdueTasks(pagination: $pagination, sort: $sort) {
    docs {
      ...OverdueTasks
    }
    totalDocs
    totalPages
  }
}
    ${OverdueTasksFragmentDoc}`;

/**
 * __useGetOverdueTasksQuery__
 *
 * To run a query within a React component, call `useGetOverdueTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverdueTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverdueTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetOverdueTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOverdueTasksQuery, Types.GetOverdueTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOverdueTasksQuery, Types.GetOverdueTasksQueryVariables>(GetOverdueTasksDocument, options);
      }
export function useGetOverdueTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOverdueTasksQuery, Types.GetOverdueTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOverdueTasksQuery, Types.GetOverdueTasksQueryVariables>(GetOverdueTasksDocument, options);
        }
export type GetOverdueTasksQueryHookResult = ReturnType<typeof useGetOverdueTasksQuery>;
export type GetOverdueTasksLazyQueryHookResult = ReturnType<typeof useGetOverdueTasksLazyQuery>;
export type GetOverdueTasksQueryResult = Apollo.QueryResult<Types.GetOverdueTasksQuery, Types.GetOverdueTasksQueryVariables>;
export const PendingApprovalAssetsDocument = gql`
    query PendingApprovalAssets($sort: SortAssetsInput) {
  pendingApprovalAssets(sort: $sort) {
    ...PendingApprovalAssets
  }
}
    ${PendingApprovalAssetsFragmentDoc}`;

/**
 * __usePendingApprovalAssetsQuery__
 *
 * To run a query within a React component, call `usePendingApprovalAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingApprovalAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingApprovalAssetsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePendingApprovalAssetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PendingApprovalAssetsQuery, Types.PendingApprovalAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PendingApprovalAssetsQuery, Types.PendingApprovalAssetsQueryVariables>(PendingApprovalAssetsDocument, options);
      }
export function usePendingApprovalAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PendingApprovalAssetsQuery, Types.PendingApprovalAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PendingApprovalAssetsQuery, Types.PendingApprovalAssetsQueryVariables>(PendingApprovalAssetsDocument, options);
        }
export type PendingApprovalAssetsQueryHookResult = ReturnType<typeof usePendingApprovalAssetsQuery>;
export type PendingApprovalAssetsLazyQueryHookResult = ReturnType<typeof usePendingApprovalAssetsLazyQuery>;
export type PendingApprovalAssetsQueryResult = Apollo.QueryResult<Types.PendingApprovalAssetsQuery, Types.PendingApprovalAssetsQueryVariables>;
export const AssignTagToReleaseNoteDocument = gql`
    mutation AssignTagToReleaseNote($input: UpdateReleaseNoteTagInput!) {
  assignTagToReleaseNote(input: $input) {
    id
  }
}
    `;
export type AssignTagToReleaseNoteMutationFn = Apollo.MutationFunction<Types.AssignTagToReleaseNoteMutation, Types.AssignTagToReleaseNoteMutationVariables>;

/**
 * __useAssignTagToReleaseNoteMutation__
 *
 * To run a mutation, you first call `useAssignTagToReleaseNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTagToReleaseNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTagToReleaseNoteMutation, { data, loading, error }] = useAssignTagToReleaseNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTagToReleaseNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.AssignTagToReleaseNoteMutation, Types.AssignTagToReleaseNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AssignTagToReleaseNoteMutation, Types.AssignTagToReleaseNoteMutationVariables>(AssignTagToReleaseNoteDocument, options);
      }
export type AssignTagToReleaseNoteMutationHookResult = ReturnType<typeof useAssignTagToReleaseNoteMutation>;
export type AssignTagToReleaseNoteMutationResult = Apollo.MutationResult<Types.AssignTagToReleaseNoteMutation>;
export type AssignTagToReleaseNoteMutationOptions = Apollo.BaseMutationOptions<Types.AssignTagToReleaseNoteMutation, Types.AssignTagToReleaseNoteMutationVariables>;
export const DeleteTagFromReleaseNoteDocument = gql`
    mutation DeleteTagFromReleaseNote($input: UpdateReleaseNoteTagInput!) {
  deleteTagFromReleaseNote(input: $input) {
    id
  }
}
    `;
export type DeleteTagFromReleaseNoteMutationFn = Apollo.MutationFunction<Types.DeleteTagFromReleaseNoteMutation, Types.DeleteTagFromReleaseNoteMutationVariables>;

/**
 * __useDeleteTagFromReleaseNoteMutation__
 *
 * To run a mutation, you first call `useDeleteTagFromReleaseNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagFromReleaseNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagFromReleaseNoteMutation, { data, loading, error }] = useDeleteTagFromReleaseNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagFromReleaseNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTagFromReleaseNoteMutation, Types.DeleteTagFromReleaseNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTagFromReleaseNoteMutation, Types.DeleteTagFromReleaseNoteMutationVariables>(DeleteTagFromReleaseNoteDocument, options);
      }
export type DeleteTagFromReleaseNoteMutationHookResult = ReturnType<typeof useDeleteTagFromReleaseNoteMutation>;
export type DeleteTagFromReleaseNoteMutationResult = Apollo.MutationResult<Types.DeleteTagFromReleaseNoteMutation>;
export type DeleteTagFromReleaseNoteMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTagFromReleaseNoteMutation, Types.DeleteTagFromReleaseNoteMutationVariables>;
export const RemoveUserFromOrganizationDocument = gql`
    mutation RemoveUserFromOrganization($userId: String!) {
  removeUserFromOrganization(userId: $userId) {
    id
  }
}
    `;
export type RemoveUserFromOrganizationMutationFn = Apollo.MutationFunction<Types.RemoveUserFromOrganizationMutation, Types.RemoveUserFromOrganizationMutationVariables>;

/**
 * __useRemoveUserFromOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganizationMutation, { data, loading, error }] = useRemoveUserFromOrganizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveUserFromOrganizationMutation, Types.RemoveUserFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveUserFromOrganizationMutation, Types.RemoveUserFromOrganizationMutationVariables>(RemoveUserFromOrganizationDocument, options);
      }
export type RemoveUserFromOrganizationMutationHookResult = ReturnType<typeof useRemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationResult = Apollo.MutationResult<Types.RemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveUserFromOrganizationMutation, Types.RemoveUserFromOrganizationMutationVariables>;
export const ActiveSubscriptionsDocument = gql`
    query ActiveSubscriptions {
  activeSubscriptions {
    ...SubscriptionContent
  }
}
    ${SubscriptionContentFragmentDoc}`;

/**
 * __useActiveSubscriptionsQuery__
 *
 * To run a query within a React component, call `useActiveSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ActiveSubscriptionsQuery, Types.ActiveSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ActiveSubscriptionsQuery, Types.ActiveSubscriptionsQueryVariables>(ActiveSubscriptionsDocument, options);
      }
export function useActiveSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ActiveSubscriptionsQuery, Types.ActiveSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ActiveSubscriptionsQuery, Types.ActiveSubscriptionsQueryVariables>(ActiveSubscriptionsDocument, options);
        }
export type ActiveSubscriptionsQueryHookResult = ReturnType<typeof useActiveSubscriptionsQuery>;
export type ActiveSubscriptionsLazyQueryHookResult = ReturnType<typeof useActiveSubscriptionsLazyQuery>;
export type ActiveSubscriptionsQueryResult = Apollo.QueryResult<Types.ActiveSubscriptionsQuery, Types.ActiveSubscriptionsQueryVariables>;
export const PaymentMethodsDocument = gql`
    query PaymentMethods {
  getOrganizationPaymentMethods {
    id
    cardBrand
    cardLast4
  }
}
    `;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaymentMethodsQuery, Types.PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaymentMethodsQuery, Types.PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaymentMethodsQuery, Types.PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaymentMethodsQuery, Types.PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<Types.PaymentMethodsQuery, Types.PaymentMethodsQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices {
  invoices {
    id
    amount_due
    amount_paid
    amount_remaining
    createdAt
    invoice_pdf
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<Types.InvoicesQuery, Types.InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InvoicesQuery, Types.InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InvoicesQuery, Types.InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InvoicesQuery, Types.InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<Types.InvoicesQuery, Types.InvoicesQueryVariables>;
export const BillingDataDocument = gql`
    query BillingData {
  availableProducts {
    ...ProductContent
  }
  activeSubscriptions {
    ...SubscriptionContent
  }
  invoices {
    id
    amount_due
    amount_paid
    createdAt
    invoice_pdf
  }
}
    ${ProductContentFragmentDoc}
${SubscriptionContentFragmentDoc}`;

/**
 * __useBillingDataQuery__
 *
 * To run a query within a React component, call `useBillingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.BillingDataQuery, Types.BillingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BillingDataQuery, Types.BillingDataQueryVariables>(BillingDataDocument, options);
      }
export function useBillingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BillingDataQuery, Types.BillingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BillingDataQuery, Types.BillingDataQueryVariables>(BillingDataDocument, options);
        }
export type BillingDataQueryHookResult = ReturnType<typeof useBillingDataQuery>;
export type BillingDataLazyQueryHookResult = ReturnType<typeof useBillingDataLazyQuery>;
export type BillingDataQueryResult = Apollo.QueryResult<Types.BillingDataQuery, Types.BillingDataQueryVariables>;
export const AvailableProductsDocument = gql`
    query AvailableProducts {
  availableProducts {
    ...ProductContent
  }
}
    ${ProductContentFragmentDoc}`;

/**
 * __useAvailableProductsQuery__
 *
 * To run a query within a React component, call `useAvailableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableProductsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AvailableProductsQuery, Types.AvailableProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AvailableProductsQuery, Types.AvailableProductsQueryVariables>(AvailableProductsDocument, options);
      }
export function useAvailableProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AvailableProductsQuery, Types.AvailableProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AvailableProductsQuery, Types.AvailableProductsQueryVariables>(AvailableProductsDocument, options);
        }
export type AvailableProductsQueryHookResult = ReturnType<typeof useAvailableProductsQuery>;
export type AvailableProductsLazyQueryHookResult = ReturnType<typeof useAvailableProductsLazyQuery>;
export type AvailableProductsQueryResult = Apollo.QueryResult<Types.AvailableProductsQuery, Types.AvailableProductsQueryVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation UpdatePaymentMethod {
  updatePaymentMethod
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<Types.UpdatePaymentMethodMutation, Types.UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePaymentMethodMutation, Types.UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePaymentMethodMutation, Types.UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<Types.UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePaymentMethodMutation, Types.UpdatePaymentMethodMutationVariables>;
export const UpdateCustomerEmailDocument = gql`
    mutation UpdateCustomerEmail($email: String!) {
  updateCustomerEmail(email: $email)
}
    `;
export type UpdateCustomerEmailMutationFn = Apollo.MutationFunction<Types.UpdateCustomerEmailMutation, Types.UpdateCustomerEmailMutationVariables>;

/**
 * __useUpdateCustomerEmailMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerEmailMutation, { data, loading, error }] = useUpdateCustomerEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateCustomerEmailMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCustomerEmailMutation, Types.UpdateCustomerEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCustomerEmailMutation, Types.UpdateCustomerEmailMutationVariables>(UpdateCustomerEmailDocument, options);
      }
export type UpdateCustomerEmailMutationHookResult = ReturnType<typeof useUpdateCustomerEmailMutation>;
export type UpdateCustomerEmailMutationResult = Apollo.MutationResult<Types.UpdateCustomerEmailMutation>;
export type UpdateCustomerEmailMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomerEmailMutation, Types.UpdateCustomerEmailMutationVariables>;
export const CreateCheckoutLinkDocument = gql`
    mutation CreateCheckoutLink($quantity: Float!, $priceId: String!) {
  createCheckoutLink(quantity: $quantity, priceId: $priceId)
}
    `;
export type CreateCheckoutLinkMutationFn = Apollo.MutationFunction<Types.CreateCheckoutLinkMutation, Types.CreateCheckoutLinkMutationVariables>;

/**
 * __useCreateCheckoutLinkMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutLinkMutation, { data, loading, error }] = useCreateCheckoutLinkMutation({
 *   variables: {
 *      quantity: // value for 'quantity'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useCreateCheckoutLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCheckoutLinkMutation, Types.CreateCheckoutLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCheckoutLinkMutation, Types.CreateCheckoutLinkMutationVariables>(CreateCheckoutLinkDocument, options);
      }
export type CreateCheckoutLinkMutationHookResult = ReturnType<typeof useCreateCheckoutLinkMutation>;
export type CreateCheckoutLinkMutationResult = Apollo.MutationResult<Types.CreateCheckoutLinkMutation>;
export type CreateCheckoutLinkMutationOptions = Apollo.BaseMutationOptions<Types.CreateCheckoutLinkMutation, Types.CreateCheckoutLinkMutationVariables>;
export const StartFreeTrialDocument = gql`
    mutation StartFreeTrial {
  startFreeTrial {
    ...SubscriptionContent
  }
}
    ${SubscriptionContentFragmentDoc}`;
export type StartFreeTrialMutationFn = Apollo.MutationFunction<Types.StartFreeTrialMutation, Types.StartFreeTrialMutationVariables>;

/**
 * __useStartFreeTrialMutation__
 *
 * To run a mutation, you first call `useStartFreeTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFreeTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFreeTrialMutation, { data, loading, error }] = useStartFreeTrialMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartFreeTrialMutation(baseOptions?: Apollo.MutationHookOptions<Types.StartFreeTrialMutation, Types.StartFreeTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.StartFreeTrialMutation, Types.StartFreeTrialMutationVariables>(StartFreeTrialDocument, options);
      }
export type StartFreeTrialMutationHookResult = ReturnType<typeof useStartFreeTrialMutation>;
export type StartFreeTrialMutationResult = Apollo.MutationResult<Types.StartFreeTrialMutation>;
export type StartFreeTrialMutationOptions = Apollo.BaseMutationOptions<Types.StartFreeTrialMutation, Types.StartFreeTrialMutationVariables>;
export const ExtendFreeTrialDocument = gql`
    mutation ExtendFreeTrial {
  extendFreeTrial {
    ...SubscriptionContent
  }
}
    ${SubscriptionContentFragmentDoc}`;
export type ExtendFreeTrialMutationFn = Apollo.MutationFunction<Types.ExtendFreeTrialMutation, Types.ExtendFreeTrialMutationVariables>;

/**
 * __useExtendFreeTrialMutation__
 *
 * To run a mutation, you first call `useExtendFreeTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendFreeTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendFreeTrialMutation, { data, loading, error }] = useExtendFreeTrialMutation({
 *   variables: {
 *   },
 * });
 */
export function useExtendFreeTrialMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExtendFreeTrialMutation, Types.ExtendFreeTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExtendFreeTrialMutation, Types.ExtendFreeTrialMutationVariables>(ExtendFreeTrialDocument, options);
      }
export type ExtendFreeTrialMutationHookResult = ReturnType<typeof useExtendFreeTrialMutation>;
export type ExtendFreeTrialMutationResult = Apollo.MutationResult<Types.ExtendFreeTrialMutation>;
export type ExtendFreeTrialMutationOptions = Apollo.BaseMutationOptions<Types.ExtendFreeTrialMutation, Types.ExtendFreeTrialMutationVariables>;
export const AskForDemoDocument = gql`
    mutation AskForDemo($input: AskForDemoInput!) {
  askForDemo(input: $input)
}
    `;
export type AskForDemoMutationFn = Apollo.MutationFunction<Types.AskForDemoMutation, Types.AskForDemoMutationVariables>;

/**
 * __useAskForDemoMutation__
 *
 * To run a mutation, you first call `useAskForDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskForDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askForDemoMutation, { data, loading, error }] = useAskForDemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAskForDemoMutation(baseOptions?: Apollo.MutationHookOptions<Types.AskForDemoMutation, Types.AskForDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AskForDemoMutation, Types.AskForDemoMutationVariables>(AskForDemoDocument, options);
      }
export type AskForDemoMutationHookResult = ReturnType<typeof useAskForDemoMutation>;
export type AskForDemoMutationResult = Apollo.MutationResult<Types.AskForDemoMutation>;
export type AskForDemoMutationOptions = Apollo.BaseMutationOptions<Types.AskForDemoMutation, Types.AskForDemoMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($quantity: Float!, $priceId: String!) {
  createSubscription(quantity: $quantity, priceId: $priceId) {
    ...SubscriptionContent
  }
}
    ${SubscriptionContentFragmentDoc}`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<Types.CreateSubscriptionMutation, Types.CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      quantity: // value for 'quantity'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSubscriptionMutation, Types.CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSubscriptionMutation, Types.CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<Types.CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<Types.CreateSubscriptionMutation, Types.CreateSubscriptionMutationVariables>;
export const OrganizationExternalPageSettingsDocument = gql`
    query OrganizationExternalPageSettings {
  organization {
    ...OrganizationExternalPageSettings
  }
}
    ${OrganizationExternalPageSettingsFragmentDoc}`;

/**
 * __useOrganizationExternalPageSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationExternalPageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationExternalPageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationExternalPageSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationExternalPageSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationExternalPageSettingsQuery, Types.OrganizationExternalPageSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationExternalPageSettingsQuery, Types.OrganizationExternalPageSettingsQueryVariables>(OrganizationExternalPageSettingsDocument, options);
      }
export function useOrganizationExternalPageSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationExternalPageSettingsQuery, Types.OrganizationExternalPageSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationExternalPageSettingsQuery, Types.OrganizationExternalPageSettingsQueryVariables>(OrganizationExternalPageSettingsDocument, options);
        }
export type OrganizationExternalPageSettingsQueryHookResult = ReturnType<typeof useOrganizationExternalPageSettingsQuery>;
export type OrganizationExternalPageSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationExternalPageSettingsLazyQuery>;
export type OrganizationExternalPageSettingsQueryResult = Apollo.QueryResult<Types.OrganizationExternalPageSettingsQuery, Types.OrganizationExternalPageSettingsQueryVariables>;
export const UpdateOrganizationExternalPageSettingsDocument = gql`
    mutation UpdateOrganizationExternalPageSettings($input: UpdateOrganizationExternalPageInput!) {
  updateOrganizationExternalPageSettings(input: $input) {
    ...OrganizationExternalPageSettings
  }
}
    ${OrganizationExternalPageSettingsFragmentDoc}`;
export type UpdateOrganizationExternalPageSettingsMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationExternalPageSettingsMutation, Types.UpdateOrganizationExternalPageSettingsMutationVariables>;

/**
 * __useUpdateOrganizationExternalPageSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationExternalPageSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationExternalPageSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationExternalPageSettingsMutation, { data, loading, error }] = useUpdateOrganizationExternalPageSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationExternalPageSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationExternalPageSettingsMutation, Types.UpdateOrganizationExternalPageSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationExternalPageSettingsMutation, Types.UpdateOrganizationExternalPageSettingsMutationVariables>(UpdateOrganizationExternalPageSettingsDocument, options);
      }
export type UpdateOrganizationExternalPageSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationExternalPageSettingsMutation>;
export type UpdateOrganizationExternalPageSettingsMutationResult = Apollo.MutationResult<Types.UpdateOrganizationExternalPageSettingsMutation>;
export type UpdateOrganizationExternalPageSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationExternalPageSettingsMutation, Types.UpdateOrganizationExternalPageSettingsMutationVariables>;
export const ValidateOrganizationExternalPageDomainDocument = gql`
    mutation ValidateOrganizationExternalPageDomain {
  validateOrganizationExternalPageDomain {
    id
    externalPageSettings {
      isVerified
    }
  }
}
    `;
export type ValidateOrganizationExternalPageDomainMutationFn = Apollo.MutationFunction<Types.ValidateOrganizationExternalPageDomainMutation, Types.ValidateOrganizationExternalPageDomainMutationVariables>;

/**
 * __useValidateOrganizationExternalPageDomainMutation__
 *
 * To run a mutation, you first call `useValidateOrganizationExternalPageDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOrganizationExternalPageDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOrganizationExternalPageDomainMutation, { data, loading, error }] = useValidateOrganizationExternalPageDomainMutation({
 *   variables: {
 *   },
 * });
 */
export function useValidateOrganizationExternalPageDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidateOrganizationExternalPageDomainMutation, Types.ValidateOrganizationExternalPageDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidateOrganizationExternalPageDomainMutation, Types.ValidateOrganizationExternalPageDomainMutationVariables>(ValidateOrganizationExternalPageDomainDocument, options);
      }
export type ValidateOrganizationExternalPageDomainMutationHookResult = ReturnType<typeof useValidateOrganizationExternalPageDomainMutation>;
export type ValidateOrganizationExternalPageDomainMutationResult = Apollo.MutationResult<Types.ValidateOrganizationExternalPageDomainMutation>;
export type ValidateOrganizationExternalPageDomainMutationOptions = Apollo.BaseMutationOptions<Types.ValidateOrganizationExternalPageDomainMutation, Types.ValidateOrganizationExternalPageDomainMutationVariables>;
export const OrganizationExternalPageReleaseNotesSettingsDocument = gql`
    query OrganizationExternalPageReleaseNotesSettings {
  organization {
    ...OrganizationExternalPageReleaseNotesSettings
  }
}
    ${OrganizationExternalPageReleaseNotesSettingsFragmentDoc}`;

/**
 * __useOrganizationExternalPageReleaseNotesSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationExternalPageReleaseNotesSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationExternalPageReleaseNotesSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationExternalPageReleaseNotesSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationExternalPageReleaseNotesSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationExternalPageReleaseNotesSettingsQuery, Types.OrganizationExternalPageReleaseNotesSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationExternalPageReleaseNotesSettingsQuery, Types.OrganizationExternalPageReleaseNotesSettingsQueryVariables>(OrganizationExternalPageReleaseNotesSettingsDocument, options);
      }
export function useOrganizationExternalPageReleaseNotesSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationExternalPageReleaseNotesSettingsQuery, Types.OrganizationExternalPageReleaseNotesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationExternalPageReleaseNotesSettingsQuery, Types.OrganizationExternalPageReleaseNotesSettingsQueryVariables>(OrganizationExternalPageReleaseNotesSettingsDocument, options);
        }
export type OrganizationExternalPageReleaseNotesSettingsQueryHookResult = ReturnType<typeof useOrganizationExternalPageReleaseNotesSettingsQuery>;
export type OrganizationExternalPageReleaseNotesSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationExternalPageReleaseNotesSettingsLazyQuery>;
export type OrganizationExternalPageReleaseNotesSettingsQueryResult = Apollo.QueryResult<Types.OrganizationExternalPageReleaseNotesSettingsQuery, Types.OrganizationExternalPageReleaseNotesSettingsQueryVariables>;
export const UpdateOrganizationExternalPageReleaseNotesSettingsDocument = gql`
    mutation UpdateOrganizationExternalPageReleaseNotesSettings($input: UpdateOrganizationExternalPageReleaseNotesInput!) {
  updateOrganizationExternalPageReleaseNotesSettings(input: $input) {
    ...OrganizationExternalPageSettings
  }
}
    ${OrganizationExternalPageSettingsFragmentDoc}`;
export type UpdateOrganizationExternalPageReleaseNotesSettingsMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutation, Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutationVariables>;

/**
 * __useUpdateOrganizationExternalPageReleaseNotesSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationExternalPageReleaseNotesSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationExternalPageReleaseNotesSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationExternalPageReleaseNotesSettingsMutation, { data, loading, error }] = useUpdateOrganizationExternalPageReleaseNotesSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationExternalPageReleaseNotesSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutation, Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutation, Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutationVariables>(UpdateOrganizationExternalPageReleaseNotesSettingsDocument, options);
      }
export type UpdateOrganizationExternalPageReleaseNotesSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationExternalPageReleaseNotesSettingsMutation>;
export type UpdateOrganizationExternalPageReleaseNotesSettingsMutationResult = Apollo.MutationResult<Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutation>;
export type UpdateOrganizationExternalPageReleaseNotesSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutation, Types.UpdateOrganizationExternalPageReleaseNotesSettingsMutationVariables>;
export const RemoveOrganizationDocument = gql`
    mutation RemoveOrganization {
  removeOrganization {
    id
  }
}
    `;
export type RemoveOrganizationMutationFn = Apollo.MutationFunction<Types.RemoveOrganizationMutation, Types.RemoveOrganizationMutationVariables>;

/**
 * __useRemoveOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationMutation, { data, loading, error }] = useRemoveOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveOrganizationMutation, Types.RemoveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveOrganizationMutation, Types.RemoveOrganizationMutationVariables>(RemoveOrganizationDocument, options);
      }
export type RemoveOrganizationMutationHookResult = ReturnType<typeof useRemoveOrganizationMutation>;
export type RemoveOrganizationMutationResult = Apollo.MutationResult<Types.RemoveOrganizationMutation>;
export type RemoveOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveOrganizationMutation, Types.RemoveOrganizationMutationVariables>;
export const PublicApproveModulesDocument = gql`
    mutation PublicApproveModules($input: PublicApproveModuleInput!) {
  publicApproveModules(input: $input) {
    id
  }
}
    `;
export type PublicApproveModulesMutationFn = Apollo.MutationFunction<Types.PublicApproveModulesMutation, Types.PublicApproveModulesMutationVariables>;

/**
 * __usePublicApproveModulesMutation__
 *
 * To run a mutation, you first call `usePublicApproveModulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicApproveModulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicApproveModulesMutation, { data, loading, error }] = usePublicApproveModulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicApproveModulesMutation(baseOptions?: Apollo.MutationHookOptions<Types.PublicApproveModulesMutation, Types.PublicApproveModulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PublicApproveModulesMutation, Types.PublicApproveModulesMutationVariables>(PublicApproveModulesDocument, options);
      }
export type PublicApproveModulesMutationHookResult = ReturnType<typeof usePublicApproveModulesMutation>;
export type PublicApproveModulesMutationResult = Apollo.MutationResult<Types.PublicApproveModulesMutation>;
export type PublicApproveModulesMutationOptions = Apollo.BaseMutationOptions<Types.PublicApproveModulesMutation, Types.PublicApproveModulesMutationVariables>;
export const LoginWithPasswordDocument = gql`
    mutation LoginWithPassword($input: LogInInput!) {
  loginWithPassword(input: $input) {
    ...AuthorizationData
  }
}
    ${AuthorizationDataFragmentDoc}`;
export type LoginWithPasswordMutationFn = Apollo.MutationFunction<Types.LoginWithPasswordMutation, Types.LoginWithPasswordMutationVariables>;

/**
 * __useLoginWithPasswordMutation__
 *
 * To run a mutation, you first call `useLoginWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithPasswordMutation, { data, loading, error }] = useLoginWithPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginWithPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.LoginWithPasswordMutation, Types.LoginWithPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LoginWithPasswordMutation, Types.LoginWithPasswordMutationVariables>(LoginWithPasswordDocument, options);
      }
export type LoginWithPasswordMutationHookResult = ReturnType<typeof useLoginWithPasswordMutation>;
export type LoginWithPasswordMutationResult = Apollo.MutationResult<Types.LoginWithPasswordMutation>;
export type LoginWithPasswordMutationOptions = Apollo.BaseMutationOptions<Types.LoginWithPasswordMutation, Types.LoginWithPasswordMutationVariables>;
export const SignupWithPasswordDocument = gql`
    mutation SignupWithPassword($input: RegisterUserInput!) {
  signupWithPassword(input: $input) {
    ...AuthorizationData
  }
}
    ${AuthorizationDataFragmentDoc}`;
export type SignupWithPasswordMutationFn = Apollo.MutationFunction<Types.SignupWithPasswordMutation, Types.SignupWithPasswordMutationVariables>;

/**
 * __useSignupWithPasswordMutation__
 *
 * To run a mutation, you first call `useSignupWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupWithPasswordMutation, { data, loading, error }] = useSignupWithPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupWithPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignupWithPasswordMutation, Types.SignupWithPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignupWithPasswordMutation, Types.SignupWithPasswordMutationVariables>(SignupWithPasswordDocument, options);
      }
export type SignupWithPasswordMutationHookResult = ReturnType<typeof useSignupWithPasswordMutation>;
export type SignupWithPasswordMutationResult = Apollo.MutationResult<Types.SignupWithPasswordMutation>;
export type SignupWithPasswordMutationOptions = Apollo.BaseMutationOptions<Types.SignupWithPasswordMutation, Types.SignupWithPasswordMutationVariables>;
export const EmailForgotPasswordDocument = gql`
    mutation EmailForgotPassword($email: String!) {
  emailForgotPassword(email: $email)
}
    `;
export type EmailForgotPasswordMutationFn = Apollo.MutationFunction<Types.EmailForgotPasswordMutation, Types.EmailForgotPasswordMutationVariables>;

/**
 * __useEmailForgotPasswordMutation__
 *
 * To run a mutation, you first call `useEmailForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailForgotPasswordMutation, { data, loading, error }] = useEmailForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.EmailForgotPasswordMutation, Types.EmailForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EmailForgotPasswordMutation, Types.EmailForgotPasswordMutationVariables>(EmailForgotPasswordDocument, options);
      }
export type EmailForgotPasswordMutationHookResult = ReturnType<typeof useEmailForgotPasswordMutation>;
export type EmailForgotPasswordMutationResult = Apollo.MutationResult<Types.EmailForgotPasswordMutation>;
export type EmailForgotPasswordMutationOptions = Apollo.BaseMutationOptions<Types.EmailForgotPasswordMutation, Types.EmailForgotPasswordMutationVariables>;
export const CheckUserExistsDocument = gql`
    mutation CheckUserExists($email: String!) {
  checkUserExists(email: $email)
}
    `;
export type CheckUserExistsMutationFn = Apollo.MutationFunction<Types.CheckUserExistsMutation, Types.CheckUserExistsMutationVariables>;

/**
 * __useCheckUserExistsMutation__
 *
 * To run a mutation, you first call `useCheckUserExistsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckUserExistsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkUserExistsMutation, { data, loading, error }] = useCheckUserExistsMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckUserExistsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CheckUserExistsMutation, Types.CheckUserExistsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CheckUserExistsMutation, Types.CheckUserExistsMutationVariables>(CheckUserExistsDocument, options);
      }
export type CheckUserExistsMutationHookResult = ReturnType<typeof useCheckUserExistsMutation>;
export type CheckUserExistsMutationResult = Apollo.MutationResult<Types.CheckUserExistsMutation>;
export type CheckUserExistsMutationOptions = Apollo.BaseMutationOptions<Types.CheckUserExistsMutation, Types.CheckUserExistsMutationVariables>;
export const LoginWithGoogleDocument = gql`
    mutation LoginWithGoogle($code: String!) {
  loginWithGoogle(code: $code) {
    ...AuthorizationData
  }
}
    ${AuthorizationDataFragmentDoc}`;
export type LoginWithGoogleMutationFn = Apollo.MutationFunction<Types.LoginWithGoogleMutation, Types.LoginWithGoogleMutationVariables>;

/**
 * __useLoginWithGoogleMutation__
 *
 * To run a mutation, you first call `useLoginWithGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithGoogleMutation, { data, loading, error }] = useLoginWithGoogleMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useLoginWithGoogleMutation(baseOptions?: Apollo.MutationHookOptions<Types.LoginWithGoogleMutation, Types.LoginWithGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LoginWithGoogleMutation, Types.LoginWithGoogleMutationVariables>(LoginWithGoogleDocument, options);
      }
export type LoginWithGoogleMutationHookResult = ReturnType<typeof useLoginWithGoogleMutation>;
export type LoginWithGoogleMutationResult = Apollo.MutationResult<Types.LoginWithGoogleMutation>;
export type LoginWithGoogleMutationOptions = Apollo.BaseMutationOptions<Types.LoginWithGoogleMutation, Types.LoginWithGoogleMutationVariables>;
export const SignUpWithGoogleDocument = gql`
    mutation SignUpWithGoogle($code: String!) {
  signupWithGoogle(code: $code) {
    ...AuthorizationData
  }
}
    ${AuthorizationDataFragmentDoc}`;
export type SignUpWithGoogleMutationFn = Apollo.MutationFunction<Types.SignUpWithGoogleMutation, Types.SignUpWithGoogleMutationVariables>;

/**
 * __useSignUpWithGoogleMutation__
 *
 * To run a mutation, you first call `useSignUpWithGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpWithGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpWithGoogleMutation, { data, loading, error }] = useSignUpWithGoogleMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignUpWithGoogleMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignUpWithGoogleMutation, Types.SignUpWithGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignUpWithGoogleMutation, Types.SignUpWithGoogleMutationVariables>(SignUpWithGoogleDocument, options);
      }
export type SignUpWithGoogleMutationHookResult = ReturnType<typeof useSignUpWithGoogleMutation>;
export type SignUpWithGoogleMutationResult = Apollo.MutationResult<Types.SignUpWithGoogleMutation>;
export type SignUpWithGoogleMutationOptions = Apollo.BaseMutationOptions<Types.SignUpWithGoogleMutation, Types.SignUpWithGoogleMutationVariables>;
export const LoginWithSsoDocument = gql`
    mutation LoginWithSSO($input: LoginWithSSOInput!) {
  loginWithSSO(input: $input) {
    ...AuthorizationData
  }
}
    ${AuthorizationDataFragmentDoc}`;
export type LoginWithSsoMutationFn = Apollo.MutationFunction<Types.LoginWithSsoMutation, Types.LoginWithSsoMutationVariables>;

/**
 * __useLoginWithSsoMutation__
 *
 * To run a mutation, you first call `useLoginWithSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithSsoMutation, { data, loading, error }] = useLoginWithSsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginWithSsoMutation(baseOptions?: Apollo.MutationHookOptions<Types.LoginWithSsoMutation, Types.LoginWithSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LoginWithSsoMutation, Types.LoginWithSsoMutationVariables>(LoginWithSsoDocument, options);
      }
export type LoginWithSsoMutationHookResult = ReturnType<typeof useLoginWithSsoMutation>;
export type LoginWithSsoMutationResult = Apollo.MutationResult<Types.LoginWithSsoMutation>;
export type LoginWithSsoMutationOptions = Apollo.BaseMutationOptions<Types.LoginWithSsoMutation, Types.LoginWithSsoMutationVariables>;
export const EmailResendVerificationTokenDocument = gql`
    mutation EmailResendVerificationToken($input: VerifyEmailInput!) {
  emailResendVerificationToken(input: $input)
}
    `;
export type EmailResendVerificationTokenMutationFn = Apollo.MutationFunction<Types.EmailResendVerificationTokenMutation, Types.EmailResendVerificationTokenMutationVariables>;

/**
 * __useEmailResendVerificationTokenMutation__
 *
 * To run a mutation, you first call `useEmailResendVerificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailResendVerificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailResendVerificationTokenMutation, { data, loading, error }] = useEmailResendVerificationTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailResendVerificationTokenMutation(baseOptions?: Apollo.MutationHookOptions<Types.EmailResendVerificationTokenMutation, Types.EmailResendVerificationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EmailResendVerificationTokenMutation, Types.EmailResendVerificationTokenMutationVariables>(EmailResendVerificationTokenDocument, options);
      }
export type EmailResendVerificationTokenMutationHookResult = ReturnType<typeof useEmailResendVerificationTokenMutation>;
export type EmailResendVerificationTokenMutationResult = Apollo.MutationResult<Types.EmailResendVerificationTokenMutation>;
export type EmailResendVerificationTokenMutationOptions = Apollo.BaseMutationOptions<Types.EmailResendVerificationTokenMutation, Types.EmailResendVerificationTokenMutationVariables>;
export const VerifyEmailTokenDocument = gql`
    mutation VerifyEmailToken($emailToken: String!) {
  verifyEmailToken(emailToken: $emailToken)
}
    `;
export type VerifyEmailTokenMutationFn = Apollo.MutationFunction<Types.VerifyEmailTokenMutation, Types.VerifyEmailTokenMutationVariables>;

/**
 * __useVerifyEmailTokenMutation__
 *
 * To run a mutation, you first call `useVerifyEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailTokenMutation, { data, loading, error }] = useVerifyEmailTokenMutation({
 *   variables: {
 *      emailToken: // value for 'emailToken'
 *   },
 * });
 */
export function useVerifyEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<Types.VerifyEmailTokenMutation, Types.VerifyEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VerifyEmailTokenMutation, Types.VerifyEmailTokenMutationVariables>(VerifyEmailTokenDocument, options);
      }
export type VerifyEmailTokenMutationHookResult = ReturnType<typeof useVerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationResult = Apollo.MutationResult<Types.VerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationOptions = Apollo.BaseMutationOptions<Types.VerifyEmailTokenMutation, Types.VerifyEmailTokenMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
    name
    slug
    isFree
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<Types.CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationMutation, Types.CreateOrganizationMutationVariables>;
export const AcceptOrganizationInviteDocument = gql`
    mutation AcceptOrganizationInvite {
  acceptOrganizationInvite {
    id
  }
}
    `;
export type AcceptOrganizationInviteMutationFn = Apollo.MutationFunction<Types.AcceptOrganizationInviteMutation, Types.AcceptOrganizationInviteMutationVariables>;

/**
 * __useAcceptOrganizationInviteMutation__
 *
 * To run a mutation, you first call `useAcceptOrganizationInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrganizationInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrganizationInviteMutation, { data, loading, error }] = useAcceptOrganizationInviteMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptOrganizationInviteMutation(baseOptions?: Apollo.MutationHookOptions<Types.AcceptOrganizationInviteMutation, Types.AcceptOrganizationInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AcceptOrganizationInviteMutation, Types.AcceptOrganizationInviteMutationVariables>(AcceptOrganizationInviteDocument, options);
      }
export type AcceptOrganizationInviteMutationHookResult = ReturnType<typeof useAcceptOrganizationInviteMutation>;
export type AcceptOrganizationInviteMutationResult = Apollo.MutationResult<Types.AcceptOrganizationInviteMutation>;
export type AcceptOrganizationInviteMutationOptions = Apollo.BaseMutationOptions<Types.AcceptOrganizationInviteMutation, Types.AcceptOrganizationInviteMutationVariables>;
export const JoinOrganizationWithMatchingDomainDocument = gql`
    mutation JoinOrganizationWithMatchingDomain {
  joinOrganizationWithMatchingDomain {
    id
  }
}
    `;
export type JoinOrganizationWithMatchingDomainMutationFn = Apollo.MutationFunction<Types.JoinOrganizationWithMatchingDomainMutation, Types.JoinOrganizationWithMatchingDomainMutationVariables>;

/**
 * __useJoinOrganizationWithMatchingDomainMutation__
 *
 * To run a mutation, you first call `useJoinOrganizationWithMatchingDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinOrganizationWithMatchingDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinOrganizationWithMatchingDomainMutation, { data, loading, error }] = useJoinOrganizationWithMatchingDomainMutation({
 *   variables: {
 *   },
 * });
 */
export function useJoinOrganizationWithMatchingDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.JoinOrganizationWithMatchingDomainMutation, Types.JoinOrganizationWithMatchingDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.JoinOrganizationWithMatchingDomainMutation, Types.JoinOrganizationWithMatchingDomainMutationVariables>(JoinOrganizationWithMatchingDomainDocument, options);
      }
export type JoinOrganizationWithMatchingDomainMutationHookResult = ReturnType<typeof useJoinOrganizationWithMatchingDomainMutation>;
export type JoinOrganizationWithMatchingDomainMutationResult = Apollo.MutationResult<Types.JoinOrganizationWithMatchingDomainMutation>;
export type JoinOrganizationWithMatchingDomainMutationOptions = Apollo.BaseMutationOptions<Types.JoinOrganizationWithMatchingDomainMutation, Types.JoinOrganizationWithMatchingDomainMutationVariables>;
export const UserDocument = gql`
    query User($id: String!) {
  user(id: $id) {
    ...ProfileData
  }
}
    ${ProfileDataFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<Types.UserQuery, Types.UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UserQuery, Types.UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UserQuery, Types.UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UserQuery, Types.UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<Types.UserQuery, Types.UserQueryVariables>;
export const CookieDocument = gql`
    query Cookie {
  cookie {
    userId @client
    organizationId @client
    organizationName @client
    organizationSlug @client
  }
}
    `;

/**
 * __useCookieQuery__
 *
 * To run a query within a React component, call `useCookieQuery` and pass it any options that fit your needs.
 * When your component renders, `useCookieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCookieQuery({
 *   variables: {
 *   },
 * });
 */
export function useCookieQuery(baseOptions?: Apollo.QueryHookOptions<Types.CookieQuery, Types.CookieQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CookieQuery, Types.CookieQueryVariables>(CookieDocument, options);
      }
export function useCookieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CookieQuery, Types.CookieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CookieQuery, Types.CookieQueryVariables>(CookieDocument, options);
        }
export type CookieQueryHookResult = ReturnType<typeof useCookieQuery>;
export type CookieLazyQueryHookResult = ReturnType<typeof useCookieLazyQuery>;
export type CookieQueryResult = Apollo.QueryResult<Types.CookieQuery, Types.CookieQueryVariables>;
export const OrganizationInvitesDocument = gql`
    query OrganizationInvites {
  organizationInvites {
    ...OrganizationData
  }
}
    ${OrganizationDataFragmentDoc}`;

/**
 * __useOrganizationInvitesQuery__
 *
 * To run a query within a React component, call `useOrganizationInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationInvitesQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationInvitesQuery, Types.OrganizationInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationInvitesQuery, Types.OrganizationInvitesQueryVariables>(OrganizationInvitesDocument, options);
      }
export function useOrganizationInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationInvitesQuery, Types.OrganizationInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationInvitesQuery, Types.OrganizationInvitesQueryVariables>(OrganizationInvitesDocument, options);
        }
export type OrganizationInvitesQueryHookResult = ReturnType<typeof useOrganizationInvitesQuery>;
export type OrganizationInvitesLazyQueryHookResult = ReturnType<typeof useOrganizationInvitesLazyQuery>;
export type OrganizationInvitesQueryResult = Apollo.QueryResult<Types.OrganizationInvitesQuery, Types.OrganizationInvitesQueryVariables>;
export const SameDomainOrganizationDocument = gql`
    query SameDomainOrganization {
  sameDomainOrganization {
    ...OrganizationData
  }
}
    ${OrganizationDataFragmentDoc}`;

/**
 * __useSameDomainOrganizationQuery__
 *
 * To run a query within a React component, call `useSameDomainOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSameDomainOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSameDomainOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSameDomainOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<Types.SameDomainOrganizationQuery, Types.SameDomainOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SameDomainOrganizationQuery, Types.SameDomainOrganizationQueryVariables>(SameDomainOrganizationDocument, options);
      }
export function useSameDomainOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SameDomainOrganizationQuery, Types.SameDomainOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SameDomainOrganizationQuery, Types.SameDomainOrganizationQueryVariables>(SameDomainOrganizationDocument, options);
        }
export type SameDomainOrganizationQueryHookResult = ReturnType<typeof useSameDomainOrganizationQuery>;
export type SameDomainOrganizationLazyQueryHookResult = ReturnType<typeof useSameDomainOrganizationLazyQuery>;
export type SameDomainOrganizationQueryResult = Apollo.QueryResult<Types.SameDomainOrganizationQuery, Types.SameDomainOrganizationQueryVariables>;
export const UploadOrganizationTemplatesDocument = gql`
    mutation UploadOrganizationTemplates($input: CreateOrganizationMultipleTemplateInput!) {
  uploadOrganizationTemplates(input: $input) {
    files {
      name
    }
  }
}
    `;
export type UploadOrganizationTemplatesMutationFn = Apollo.MutationFunction<Types.UploadOrganizationTemplatesMutation, Types.UploadOrganizationTemplatesMutationVariables>;

/**
 * __useUploadOrganizationTemplatesMutation__
 *
 * To run a mutation, you first call `useUploadOrganizationTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOrganizationTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOrganizationTemplatesMutation, { data, loading, error }] = useUploadOrganizationTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadOrganizationTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadOrganizationTemplatesMutation, Types.UploadOrganizationTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadOrganizationTemplatesMutation, Types.UploadOrganizationTemplatesMutationVariables>(UploadOrganizationTemplatesDocument, options);
      }
export type UploadOrganizationTemplatesMutationHookResult = ReturnType<typeof useUploadOrganizationTemplatesMutation>;
export type UploadOrganizationTemplatesMutationResult = Apollo.MutationResult<Types.UploadOrganizationTemplatesMutation>;
export type UploadOrganizationTemplatesMutationOptions = Apollo.BaseMutationOptions<Types.UploadOrganizationTemplatesMutation, Types.UploadOrganizationTemplatesMutationVariables>;
export const CreateAssetForCopyDocument = gql`
    mutation CreateAssetForCopy($input: CreateAssetInput!) {
  createAsset(input: $input) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export type CreateAssetForCopyMutationFn = Apollo.MutationFunction<Types.CreateAssetForCopyMutation, Types.CreateAssetForCopyMutationVariables>;

/**
 * __useCreateAssetForCopyMutation__
 *
 * To run a mutation, you first call `useCreateAssetForCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetForCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetForCopyMutation, { data, loading, error }] = useCreateAssetForCopyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetForCopyMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAssetForCopyMutation, Types.CreateAssetForCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAssetForCopyMutation, Types.CreateAssetForCopyMutationVariables>(CreateAssetForCopyDocument, options);
      }
export type CreateAssetForCopyMutationHookResult = ReturnType<typeof useCreateAssetForCopyMutation>;
export type CreateAssetForCopyMutationResult = Apollo.MutationResult<Types.CreateAssetForCopyMutation>;
export type CreateAssetForCopyMutationOptions = Apollo.BaseMutationOptions<Types.CreateAssetForCopyMutation, Types.CreateAssetForCopyMutationVariables>;
export const UpdateAssetForCopyDocument = gql`
    mutation UpdateAssetForCopy($input: UpdateAssetInput!) {
  updateAsset(input: $input) {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export type UpdateAssetForCopyMutationFn = Apollo.MutationFunction<Types.UpdateAssetForCopyMutation, Types.UpdateAssetForCopyMutationVariables>;

/**
 * __useUpdateAssetForCopyMutation__
 *
 * To run a mutation, you first call `useUpdateAssetForCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetForCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetForCopyMutation, { data, loading, error }] = useUpdateAssetForCopyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetForCopyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAssetForCopyMutation, Types.UpdateAssetForCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAssetForCopyMutation, Types.UpdateAssetForCopyMutationVariables>(UpdateAssetForCopyDocument, options);
      }
export type UpdateAssetForCopyMutationHookResult = ReturnType<typeof useUpdateAssetForCopyMutation>;
export type UpdateAssetForCopyMutationResult = Apollo.MutationResult<Types.UpdateAssetForCopyMutation>;
export type UpdateAssetForCopyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAssetForCopyMutation, Types.UpdateAssetForCopyMutationVariables>;
export const AssetPreviewForCopyDocument = gql`
    query AssetPreviewForCopy($id: String!) {
  asset(id: $id) {
    ...AssetPreviewForCopy
  }
}
    ${AssetPreviewForCopyFragmentDoc}`;

/**
 * __useAssetPreviewForCopyQuery__
 *
 * To run a query within a React component, call `useAssetPreviewForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetPreviewForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetPreviewForCopyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetPreviewForCopyQuery(baseOptions: Apollo.QueryHookOptions<Types.AssetPreviewForCopyQuery, Types.AssetPreviewForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AssetPreviewForCopyQuery, Types.AssetPreviewForCopyQueryVariables>(AssetPreviewForCopyDocument, options);
      }
export function useAssetPreviewForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AssetPreviewForCopyQuery, Types.AssetPreviewForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AssetPreviewForCopyQuery, Types.AssetPreviewForCopyQueryVariables>(AssetPreviewForCopyDocument, options);
        }
export type AssetPreviewForCopyQueryHookResult = ReturnType<typeof useAssetPreviewForCopyQuery>;
export type AssetPreviewForCopyLazyQueryHookResult = ReturnType<typeof useAssetPreviewForCopyLazyQuery>;
export type AssetPreviewForCopyQueryResult = Apollo.QueryResult<Types.AssetPreviewForCopyQuery, Types.AssetPreviewForCopyQueryVariables>;
export const AssetsPreviewForCopyDocument = gql`
    query AssetsPreviewForCopy($filter: FilterAssetsInput, $sort: SortAssetsInput) {
  assets(filter: $filter, sort: $sort) {
    ...AssetPreviewForCopy
  }
}
    ${AssetPreviewForCopyFragmentDoc}`;

/**
 * __useAssetsPreviewForCopyQuery__
 *
 * To run a query within a React component, call `useAssetsPreviewForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsPreviewForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsPreviewForCopyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAssetsPreviewForCopyQuery(baseOptions?: Apollo.QueryHookOptions<Types.AssetsPreviewForCopyQuery, Types.AssetsPreviewForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AssetsPreviewForCopyQuery, Types.AssetsPreviewForCopyQueryVariables>(AssetsPreviewForCopyDocument, options);
      }
export function useAssetsPreviewForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AssetsPreviewForCopyQuery, Types.AssetsPreviewForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AssetsPreviewForCopyQuery, Types.AssetsPreviewForCopyQueryVariables>(AssetsPreviewForCopyDocument, options);
        }
export type AssetsPreviewForCopyQueryHookResult = ReturnType<typeof useAssetsPreviewForCopyQuery>;
export type AssetsPreviewForCopyLazyQueryHookResult = ReturnType<typeof useAssetsPreviewForCopyLazyQuery>;
export type AssetsPreviewForCopyQueryResult = Apollo.QueryResult<Types.AssetsPreviewForCopyQuery, Types.AssetsPreviewForCopyQueryVariables>;
export const CountAssetsDocument = gql`
    query CountAssets($filter: FilterAssetsInput) {
  countAssets(filter: $filter)
}
    `;

/**
 * __useCountAssetsQuery__
 *
 * To run a query within a React component, call `useCountAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountAssetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountAssetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountAssetsQuery, Types.CountAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountAssetsQuery, Types.CountAssetsQueryVariables>(CountAssetsDocument, options);
      }
export function useCountAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountAssetsQuery, Types.CountAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountAssetsQuery, Types.CountAssetsQueryVariables>(CountAssetsDocument, options);
        }
export type CountAssetsQueryHookResult = ReturnType<typeof useCountAssetsQuery>;
export type CountAssetsLazyQueryHookResult = ReturnType<typeof useCountAssetsLazyQuery>;
export type CountAssetsQueryResult = Apollo.QueryResult<Types.CountAssetsQuery, Types.CountAssetsQueryVariables>;
export const UpdateChecklistDocument = gql`
    mutation UpdateChecklist($input: UpdateChecklistInput!) {
  updateChecklist(input: $input) {
    ...Checklist
  }
}
    ${ChecklistFragmentDoc}`;
export type UpdateChecklistMutationFn = Apollo.MutationFunction<Types.UpdateChecklistMutation, Types.UpdateChecklistMutationVariables>;

/**
 * __useUpdateChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistMutation, { data, loading, error }] = useUpdateChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChecklistMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistMutation, Types.UpdateChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistMutation, Types.UpdateChecklistMutationVariables>(UpdateChecklistDocument, options);
      }
export type UpdateChecklistMutationHookResult = ReturnType<typeof useUpdateChecklistMutation>;
export type UpdateChecklistMutationResult = Apollo.MutationResult<Types.UpdateChecklistMutation>;
export type UpdateChecklistMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistMutation, Types.UpdateChecklistMutationVariables>;
export const ChecklistDocument = gql`
    query Checklist {
  checklist {
    ...Checklist
  }
}
    ${ChecklistFragmentDoc}`;

/**
 * __useChecklistQuery__
 *
 * To run a query within a React component, call `useChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistQuery, Types.ChecklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistQuery, Types.ChecklistQueryVariables>(ChecklistDocument, options);
      }
export function useChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistQuery, Types.ChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistQuery, Types.ChecklistQueryVariables>(ChecklistDocument, options);
        }
export type ChecklistQueryHookResult = ReturnType<typeof useChecklistQuery>;
export type ChecklistLazyQueryHookResult = ReturnType<typeof useChecklistLazyQuery>;
export type ChecklistQueryResult = Apollo.QueryResult<Types.ChecklistQuery, Types.ChecklistQueryVariables>;
export const PaginatedCompaniesForCopyDocument = gql`
    query PaginatedCompaniesForCopy($pagination: PaginationInput, $filter: PaginatedCompaniesFilterInput, $sort: SortCompetitorCompaniesInput) {
  paginatedCompanies(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...CompanyForCopy
    }
  }
}
    ${CompanyForCopyFragmentDoc}`;

/**
 * __usePaginatedCompaniesForCopyQuery__
 *
 * To run a query within a React component, call `usePaginatedCompaniesForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCompaniesForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCompaniesForCopyQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCompaniesForCopyQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedCompaniesForCopyQuery, Types.PaginatedCompaniesForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCompaniesForCopyQuery, Types.PaginatedCompaniesForCopyQueryVariables>(PaginatedCompaniesForCopyDocument, options);
      }
export function usePaginatedCompaniesForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCompaniesForCopyQuery, Types.PaginatedCompaniesForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCompaniesForCopyQuery, Types.PaginatedCompaniesForCopyQueryVariables>(PaginatedCompaniesForCopyDocument, options);
        }
export type PaginatedCompaniesForCopyQueryHookResult = ReturnType<typeof usePaginatedCompaniesForCopyQuery>;
export type PaginatedCompaniesForCopyLazyQueryHookResult = ReturnType<typeof usePaginatedCompaniesForCopyLazyQuery>;
export type PaginatedCompaniesForCopyQueryResult = Apollo.QueryResult<Types.PaginatedCompaniesForCopyQuery, Types.PaginatedCompaniesForCopyQueryVariables>;
export const PaginatedCompaniesConnectionDataDocument = gql`
    query PaginatedCompaniesConnectionData($pagination: PaginationInput, $filter: PaginatedCompaniesFilterInput, $sort: SortCompetitorCompaniesInput) {
  paginatedCompanies(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...CompanyConnectionData
    }
  }
}
    ${CompanyConnectionDataFragmentDoc}`;

/**
 * __usePaginatedCompaniesConnectionDataQuery__
 *
 * To run a query within a React component, call `usePaginatedCompaniesConnectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCompaniesConnectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCompaniesConnectionDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCompaniesConnectionDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedCompaniesConnectionDataQuery, Types.PaginatedCompaniesConnectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCompaniesConnectionDataQuery, Types.PaginatedCompaniesConnectionDataQueryVariables>(PaginatedCompaniesConnectionDataDocument, options);
      }
export function usePaginatedCompaniesConnectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCompaniesConnectionDataQuery, Types.PaginatedCompaniesConnectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCompaniesConnectionDataQuery, Types.PaginatedCompaniesConnectionDataQueryVariables>(PaginatedCompaniesConnectionDataDocument, options);
        }
export type PaginatedCompaniesConnectionDataQueryHookResult = ReturnType<typeof usePaginatedCompaniesConnectionDataQuery>;
export type PaginatedCompaniesConnectionDataLazyQueryHookResult = ReturnType<typeof usePaginatedCompaniesConnectionDataLazyQuery>;
export type PaginatedCompaniesConnectionDataQueryResult = Apollo.QueryResult<Types.PaginatedCompaniesConnectionDataQuery, Types.PaginatedCompaniesConnectionDataQueryVariables>;
export const PaginatedFeedbackPostsConnectionDataDocument = gql`
    query PaginatedFeedbackPostsConnectionData($pagination: PaginationInput!, $filter: FilterFeedbackPostsInput, $sort: SortFeedbackPostsInput) {
  paginatedFeedbackPosts(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    limit
    docs {
      ...FeedbackPostConnectionData
    }
  }
}
    ${FeedbackPostConnectionDataFragmentDoc}`;

/**
 * __usePaginatedFeedbackPostsConnectionDataQuery__
 *
 * To run a query within a React component, call `usePaginatedFeedbackPostsConnectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFeedbackPostsConnectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFeedbackPostsConnectionDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedFeedbackPostsConnectionDataQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedFeedbackPostsConnectionDataQuery, Types.PaginatedFeedbackPostsConnectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedFeedbackPostsConnectionDataQuery, Types.PaginatedFeedbackPostsConnectionDataQueryVariables>(PaginatedFeedbackPostsConnectionDataDocument, options);
      }
export function usePaginatedFeedbackPostsConnectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedFeedbackPostsConnectionDataQuery, Types.PaginatedFeedbackPostsConnectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedFeedbackPostsConnectionDataQuery, Types.PaginatedFeedbackPostsConnectionDataQueryVariables>(PaginatedFeedbackPostsConnectionDataDocument, options);
        }
export type PaginatedFeedbackPostsConnectionDataQueryHookResult = ReturnType<typeof usePaginatedFeedbackPostsConnectionDataQuery>;
export type PaginatedFeedbackPostsConnectionDataLazyQueryHookResult = ReturnType<typeof usePaginatedFeedbackPostsConnectionDataLazyQuery>;
export type PaginatedFeedbackPostsConnectionDataQueryResult = Apollo.QueryResult<Types.PaginatedFeedbackPostsConnectionDataQuery, Types.PaginatedFeedbackPostsConnectionDataQueryVariables>;
export const PaginatedInsightsConnectionDataDocument = gql`
    query PaginatedInsightsConnectionData($pagination: PaginationInput, $filter: FilterInsightsInput, $sort: SortInsightsInput) {
  paginatedInsights(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...InsightConnectionData
    }
  }
}
    ${InsightConnectionDataFragmentDoc}`;

/**
 * __usePaginatedInsightsConnectionDataQuery__
 *
 * To run a query within a React component, call `usePaginatedInsightsConnectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInsightsConnectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInsightsConnectionDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedInsightsConnectionDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedInsightsConnectionDataQuery, Types.PaginatedInsightsConnectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedInsightsConnectionDataQuery, Types.PaginatedInsightsConnectionDataQueryVariables>(PaginatedInsightsConnectionDataDocument, options);
      }
export function usePaginatedInsightsConnectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedInsightsConnectionDataQuery, Types.PaginatedInsightsConnectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedInsightsConnectionDataQuery, Types.PaginatedInsightsConnectionDataQueryVariables>(PaginatedInsightsConnectionDataDocument, options);
        }
export type PaginatedInsightsConnectionDataQueryHookResult = ReturnType<typeof usePaginatedInsightsConnectionDataQuery>;
export type PaginatedInsightsConnectionDataLazyQueryHookResult = ReturnType<typeof usePaginatedInsightsConnectionDataLazyQuery>;
export type PaginatedInsightsConnectionDataQueryResult = Apollo.QueryResult<Types.PaginatedInsightsConnectionDataQuery, Types.PaginatedInsightsConnectionDataQueryVariables>;
export const PaginatedLaunchesConnectionDataDocument = gql`
    query PaginatedLaunchesConnectionData($pagination: PaginationInput, $filter: FilterLaunchInput, $sort: SortLaunchInput) {
  paginatedLaunches(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...LaunchConnectionData
    }
  }
}
    ${LaunchConnectionDataFragmentDoc}`;

/**
 * __usePaginatedLaunchesConnectionDataQuery__
 *
 * To run a query within a React component, call `usePaginatedLaunchesConnectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedLaunchesConnectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedLaunchesConnectionDataQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedLaunchesConnectionDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedLaunchesConnectionDataQuery, Types.PaginatedLaunchesConnectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedLaunchesConnectionDataQuery, Types.PaginatedLaunchesConnectionDataQueryVariables>(PaginatedLaunchesConnectionDataDocument, options);
      }
export function usePaginatedLaunchesConnectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedLaunchesConnectionDataQuery, Types.PaginatedLaunchesConnectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedLaunchesConnectionDataQuery, Types.PaginatedLaunchesConnectionDataQueryVariables>(PaginatedLaunchesConnectionDataDocument, options);
        }
export type PaginatedLaunchesConnectionDataQueryHookResult = ReturnType<typeof usePaginatedLaunchesConnectionDataQuery>;
export type PaginatedLaunchesConnectionDataLazyQueryHookResult = ReturnType<typeof usePaginatedLaunchesConnectionDataLazyQuery>;
export type PaginatedLaunchesConnectionDataQueryResult = Apollo.QueryResult<Types.PaginatedLaunchesConnectionDataQuery, Types.PaginatedLaunchesConnectionDataQueryVariables>;
export const PaginatedPersonasConnectionDataDocument = gql`
    query PaginatedPersonasConnectionData($input: PaginatedPersonasInput!) {
  paginatedPersonas(input: $input) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...PersonaConnectionData
    }
  }
}
    ${PersonaConnectionDataFragmentDoc}`;

/**
 * __usePaginatedPersonasConnectionDataQuery__
 *
 * To run a query within a React component, call `usePaginatedPersonasConnectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedPersonasConnectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedPersonasConnectionDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedPersonasConnectionDataQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedPersonasConnectionDataQuery, Types.PaginatedPersonasConnectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedPersonasConnectionDataQuery, Types.PaginatedPersonasConnectionDataQueryVariables>(PaginatedPersonasConnectionDataDocument, options);
      }
export function usePaginatedPersonasConnectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedPersonasConnectionDataQuery, Types.PaginatedPersonasConnectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedPersonasConnectionDataQuery, Types.PaginatedPersonasConnectionDataQueryVariables>(PaginatedPersonasConnectionDataDocument, options);
        }
export type PaginatedPersonasConnectionDataQueryHookResult = ReturnType<typeof usePaginatedPersonasConnectionDataQuery>;
export type PaginatedPersonasConnectionDataLazyQueryHookResult = ReturnType<typeof usePaginatedPersonasConnectionDataLazyQuery>;
export type PaginatedPersonasConnectionDataQueryResult = Apollo.QueryResult<Types.PaginatedPersonasConnectionDataQuery, Types.PaginatedPersonasConnectionDataQueryVariables>;
export const PaginatedProductBoardItemsConnectionDataDocument = gql`
    query PaginatedProductBoardItemsConnectionData($filter: ProductBoardItemsFilterInput, $pagination: PaginationInput, $sort: ProductBoardItemsSortInput) {
  paginatedProductBoardItems(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    limit
    totalPages
    totalDocs
    docs {
      ...ProductBoardItemConnectionData
    }
  }
}
    ${ProductBoardItemConnectionDataFragmentDoc}`;

/**
 * __usePaginatedProductBoardItemsConnectionDataQuery__
 *
 * To run a query within a React component, call `usePaginatedProductBoardItemsConnectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProductBoardItemsConnectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProductBoardItemsConnectionDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedProductBoardItemsConnectionDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedProductBoardItemsConnectionDataQuery, Types.PaginatedProductBoardItemsConnectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedProductBoardItemsConnectionDataQuery, Types.PaginatedProductBoardItemsConnectionDataQueryVariables>(PaginatedProductBoardItemsConnectionDataDocument, options);
      }
export function usePaginatedProductBoardItemsConnectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedProductBoardItemsConnectionDataQuery, Types.PaginatedProductBoardItemsConnectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedProductBoardItemsConnectionDataQuery, Types.PaginatedProductBoardItemsConnectionDataQueryVariables>(PaginatedProductBoardItemsConnectionDataDocument, options);
        }
export type PaginatedProductBoardItemsConnectionDataQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsConnectionDataQuery>;
export type PaginatedProductBoardItemsConnectionDataLazyQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsConnectionDataLazyQuery>;
export type PaginatedProductBoardItemsConnectionDataQueryResult = Apollo.QueryResult<Types.PaginatedProductBoardItemsConnectionDataQuery, Types.PaginatedProductBoardItemsConnectionDataQueryVariables>;
export const CdpAccountDetailDocument = gql`
    query CDPAccountDetail($id: String!) {
  cdpAccount(id: $id) {
    ...CDPAccountDetail
  }
}
    ${CdpAccountDetailFragmentDoc}`;

/**
 * __useCdpAccountDetailQuery__
 *
 * To run a query within a React component, call `useCdpAccountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCdpAccountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCdpAccountDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCdpAccountDetailQuery(baseOptions: Apollo.QueryHookOptions<Types.CdpAccountDetailQuery, Types.CdpAccountDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CdpAccountDetailQuery, Types.CdpAccountDetailQueryVariables>(CdpAccountDetailDocument, options);
      }
export function useCdpAccountDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CdpAccountDetailQuery, Types.CdpAccountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CdpAccountDetailQuery, Types.CdpAccountDetailQueryVariables>(CdpAccountDetailDocument, options);
        }
export type CdpAccountDetailQueryHookResult = ReturnType<typeof useCdpAccountDetailQuery>;
export type CdpAccountDetailLazyQueryHookResult = ReturnType<typeof useCdpAccountDetailLazyQuery>;
export type CdpAccountDetailQueryResult = Apollo.QueryResult<Types.CdpAccountDetailQuery, Types.CdpAccountDetailQueryVariables>;
export const CdpContactDetailDocument = gql`
    query CDPContactDetail($id: String!) {
  cdpContact(id: $id) {
    ...CDPContactDetail
  }
}
    ${CdpContactDetailFragmentDoc}`;

/**
 * __useCdpContactDetailQuery__
 *
 * To run a query within a React component, call `useCdpContactDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCdpContactDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCdpContactDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCdpContactDetailQuery(baseOptions: Apollo.QueryHookOptions<Types.CdpContactDetailQuery, Types.CdpContactDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CdpContactDetailQuery, Types.CdpContactDetailQueryVariables>(CdpContactDetailDocument, options);
      }
export function useCdpContactDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CdpContactDetailQuery, Types.CdpContactDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CdpContactDetailQuery, Types.CdpContactDetailQueryVariables>(CdpContactDetailDocument, options);
        }
export type CdpContactDetailQueryHookResult = ReturnType<typeof useCdpContactDetailQuery>;
export type CdpContactDetailLazyQueryHookResult = ReturnType<typeof useCdpContactDetailLazyQuery>;
export type CdpContactDetailQueryResult = Apollo.QueryResult<Types.CdpContactDetailQuery, Types.CdpContactDetailQueryVariables>;
export const PaginatedFeedbackPostsForCopyDocument = gql`
    query PaginatedFeedbackPostsForCopy($pagination: PaginationInput!, $filter: FilterFeedbackPostsInput, $sort: SortFeedbackPostsInput) {
  paginatedFeedbackPosts(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    limit
    docs {
      ...FeedbackPostForCopy
    }
  }
}
    ${FeedbackPostForCopyFragmentDoc}`;

/**
 * __usePaginatedFeedbackPostsForCopyQuery__
 *
 * To run a query within a React component, call `usePaginatedFeedbackPostsForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFeedbackPostsForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFeedbackPostsForCopyQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedFeedbackPostsForCopyQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedFeedbackPostsForCopyQuery, Types.PaginatedFeedbackPostsForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedFeedbackPostsForCopyQuery, Types.PaginatedFeedbackPostsForCopyQueryVariables>(PaginatedFeedbackPostsForCopyDocument, options);
      }
export function usePaginatedFeedbackPostsForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedFeedbackPostsForCopyQuery, Types.PaginatedFeedbackPostsForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedFeedbackPostsForCopyQuery, Types.PaginatedFeedbackPostsForCopyQueryVariables>(PaginatedFeedbackPostsForCopyDocument, options);
        }
export type PaginatedFeedbackPostsForCopyQueryHookResult = ReturnType<typeof usePaginatedFeedbackPostsForCopyQuery>;
export type PaginatedFeedbackPostsForCopyLazyQueryHookResult = ReturnType<typeof usePaginatedFeedbackPostsForCopyLazyQuery>;
export type PaginatedFeedbackPostsForCopyQueryResult = Apollo.QueryResult<Types.PaginatedFeedbackPostsForCopyQuery, Types.PaginatedFeedbackPostsForCopyQueryVariables>;
export const PaginatedInsightsForCopyDocument = gql`
    query PaginatedInsightsForCopy($pagination: PaginationInput, $filter: FilterInsightsInput, $sort: SortInsightsInput) {
  paginatedInsights(pagination: $pagination, filter: $filter, sort: $sort) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...InsightForCopy
    }
  }
}
    ${InsightForCopyFragmentDoc}`;

/**
 * __usePaginatedInsightsForCopyQuery__
 *
 * To run a query within a React component, call `usePaginatedInsightsForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInsightsForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInsightsForCopyQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedInsightsForCopyQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedInsightsForCopyQuery, Types.PaginatedInsightsForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedInsightsForCopyQuery, Types.PaginatedInsightsForCopyQueryVariables>(PaginatedInsightsForCopyDocument, options);
      }
export function usePaginatedInsightsForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedInsightsForCopyQuery, Types.PaginatedInsightsForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedInsightsForCopyQuery, Types.PaginatedInsightsForCopyQueryVariables>(PaginatedInsightsForCopyDocument, options);
        }
export type PaginatedInsightsForCopyQueryHookResult = ReturnType<typeof usePaginatedInsightsForCopyQuery>;
export type PaginatedInsightsForCopyLazyQueryHookResult = ReturnType<typeof usePaginatedInsightsForCopyLazyQuery>;
export type PaginatedInsightsForCopyQueryResult = Apollo.QueryResult<Types.PaginatedInsightsForCopyQuery, Types.PaginatedInsightsForCopyQueryVariables>;
export const UpdateInsightGeneratedItemDocument = gql`
    mutation UpdateInsightGeneratedItem($input: UpdateInsightGeneratedItemInput!) {
  updateInsightsGeneratedItem(input: $input) {
    ...InsightsGeneratedItemObj
  }
}
    ${InsightsGeneratedItemObjFragmentDoc}`;
export type UpdateInsightGeneratedItemMutationFn = Apollo.MutationFunction<Types.UpdateInsightGeneratedItemMutation, Types.UpdateInsightGeneratedItemMutationVariables>;

/**
 * __useUpdateInsightGeneratedItemMutation__
 *
 * To run a mutation, you first call `useUpdateInsightGeneratedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightGeneratedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightGeneratedItemMutation, { data, loading, error }] = useUpdateInsightGeneratedItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInsightGeneratedItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightGeneratedItemMutation, Types.UpdateInsightGeneratedItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightGeneratedItemMutation, Types.UpdateInsightGeneratedItemMutationVariables>(UpdateInsightGeneratedItemDocument, options);
      }
export type UpdateInsightGeneratedItemMutationHookResult = ReturnType<typeof useUpdateInsightGeneratedItemMutation>;
export type UpdateInsightGeneratedItemMutationResult = Apollo.MutationResult<Types.UpdateInsightGeneratedItemMutation>;
export type UpdateInsightGeneratedItemMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightGeneratedItemMutation, Types.UpdateInsightGeneratedItemMutationVariables>;
export const CheckInitialTrendGenerationStateDocument = gql`
    query CheckInitialTrendGenerationState {
  checkInitialTrendGenerationState
}
    `;

/**
 * __useCheckInitialTrendGenerationStateQuery__
 *
 * To run a query within a React component, call `useCheckInitialTrendGenerationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInitialTrendGenerationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInitialTrendGenerationStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckInitialTrendGenerationStateQuery(baseOptions?: Apollo.QueryHookOptions<Types.CheckInitialTrendGenerationStateQuery, Types.CheckInitialTrendGenerationStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CheckInitialTrendGenerationStateQuery, Types.CheckInitialTrendGenerationStateQueryVariables>(CheckInitialTrendGenerationStateDocument, options);
      }
export function useCheckInitialTrendGenerationStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CheckInitialTrendGenerationStateQuery, Types.CheckInitialTrendGenerationStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CheckInitialTrendGenerationStateQuery, Types.CheckInitialTrendGenerationStateQueryVariables>(CheckInitialTrendGenerationStateDocument, options);
        }
export type CheckInitialTrendGenerationStateQueryHookResult = ReturnType<typeof useCheckInitialTrendGenerationStateQuery>;
export type CheckInitialTrendGenerationStateLazyQueryHookResult = ReturnType<typeof useCheckInitialTrendGenerationStateLazyQuery>;
export type CheckInitialTrendGenerationStateQueryResult = Apollo.QueryResult<Types.CheckInitialTrendGenerationStateQuery, Types.CheckInitialTrendGenerationStateQueryVariables>;
export const InsightGeneratedItemDocument = gql`
    query InsightGeneratedItem($id: String!) {
  insightsGeneratedItem(id: $id) {
    ...InsightsGeneratedItemObj
  }
}
    ${InsightsGeneratedItemObjFragmentDoc}`;

/**
 * __useInsightGeneratedItemQuery__
 *
 * To run a query within a React component, call `useInsightGeneratedItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightGeneratedItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightGeneratedItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightGeneratedItemQuery(baseOptions: Apollo.QueryHookOptions<Types.InsightGeneratedItemQuery, Types.InsightGeneratedItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightGeneratedItemQuery, Types.InsightGeneratedItemQueryVariables>(InsightGeneratedItemDocument, options);
      }
export function useInsightGeneratedItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightGeneratedItemQuery, Types.InsightGeneratedItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightGeneratedItemQuery, Types.InsightGeneratedItemQueryVariables>(InsightGeneratedItemDocument, options);
        }
export type InsightGeneratedItemQueryHookResult = ReturnType<typeof useInsightGeneratedItemQuery>;
export type InsightGeneratedItemLazyQueryHookResult = ReturnType<typeof useInsightGeneratedItemLazyQuery>;
export type InsightGeneratedItemQueryResult = Apollo.QueryResult<Types.InsightGeneratedItemQuery, Types.InsightGeneratedItemQueryVariables>;
export const InsightTrendItemDocument = gql`
    query InsightTrendItem($id: String!) {
  insightsTrendItem(id: $id) {
    ...InsightsTrendItemObj
  }
}
    ${InsightsTrendItemObjFragmentDoc}`;

/**
 * __useInsightTrendItemQuery__
 *
 * To run a query within a React component, call `useInsightTrendItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightTrendItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightTrendItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightTrendItemQuery(baseOptions: Apollo.QueryHookOptions<Types.InsightTrendItemQuery, Types.InsightTrendItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightTrendItemQuery, Types.InsightTrendItemQueryVariables>(InsightTrendItemDocument, options);
      }
export function useInsightTrendItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightTrendItemQuery, Types.InsightTrendItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightTrendItemQuery, Types.InsightTrendItemQueryVariables>(InsightTrendItemDocument, options);
        }
export type InsightTrendItemQueryHookResult = ReturnType<typeof useInsightTrendItemQuery>;
export type InsightTrendItemLazyQueryHookResult = ReturnType<typeof useInsightTrendItemLazyQuery>;
export type InsightTrendItemQueryResult = Apollo.QueryResult<Types.InsightTrendItemQuery, Types.InsightTrendItemQueryVariables>;
export const InsightsGeneratedItemsTrendGraphDocument = gql`
    query InsightsGeneratedItemsTrendGraph($filter: FilterInsightGeneratedItemTrendGraphInput!) {
  insightsGeneratedTrendGraph(filter: $filter) {
    count
    labels
  }
}
    `;

/**
 * __useInsightsGeneratedItemsTrendGraphQuery__
 *
 * To run a query within a React component, call `useInsightsGeneratedItemsTrendGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsGeneratedItemsTrendGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsGeneratedItemsTrendGraphQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInsightsGeneratedItemsTrendGraphQuery(baseOptions: Apollo.QueryHookOptions<Types.InsightsGeneratedItemsTrendGraphQuery, Types.InsightsGeneratedItemsTrendGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightsGeneratedItemsTrendGraphQuery, Types.InsightsGeneratedItemsTrendGraphQueryVariables>(InsightsGeneratedItemsTrendGraphDocument, options);
      }
export function useInsightsGeneratedItemsTrendGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightsGeneratedItemsTrendGraphQuery, Types.InsightsGeneratedItemsTrendGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightsGeneratedItemsTrendGraphQuery, Types.InsightsGeneratedItemsTrendGraphQueryVariables>(InsightsGeneratedItemsTrendGraphDocument, options);
        }
export type InsightsGeneratedItemsTrendGraphQueryHookResult = ReturnType<typeof useInsightsGeneratedItemsTrendGraphQuery>;
export type InsightsGeneratedItemsTrendGraphLazyQueryHookResult = ReturnType<typeof useInsightsGeneratedItemsTrendGraphLazyQuery>;
export type InsightsGeneratedItemsTrendGraphQueryResult = Apollo.QueryResult<Types.InsightsGeneratedItemsTrendGraphQuery, Types.InsightsGeneratedItemsTrendGraphQueryVariables>;
export const InsightsTrendItemsGraphDocument = gql`
    query InsightsTrendItemsGraph($filter: FilterInsightTrendItemGraphInput!) {
  insightsTrendItemGraph(filter: $filter) {
    count
    labels
  }
}
    `;

/**
 * __useInsightsTrendItemsGraphQuery__
 *
 * To run a query within a React component, call `useInsightsTrendItemsGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsTrendItemsGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsTrendItemsGraphQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInsightsTrendItemsGraphQuery(baseOptions: Apollo.QueryHookOptions<Types.InsightsTrendItemsGraphQuery, Types.InsightsTrendItemsGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightsTrendItemsGraphQuery, Types.InsightsTrendItemsGraphQueryVariables>(InsightsTrendItemsGraphDocument, options);
      }
export function useInsightsTrendItemsGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightsTrendItemsGraphQuery, Types.InsightsTrendItemsGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightsTrendItemsGraphQuery, Types.InsightsTrendItemsGraphQueryVariables>(InsightsTrendItemsGraphDocument, options);
        }
export type InsightsTrendItemsGraphQueryHookResult = ReturnType<typeof useInsightsTrendItemsGraphQuery>;
export type InsightsTrendItemsGraphLazyQueryHookResult = ReturnType<typeof useInsightsTrendItemsGraphLazyQuery>;
export type InsightsTrendItemsGraphQueryResult = Apollo.QueryResult<Types.InsightsTrendItemsGraphQuery, Types.InsightsTrendItemsGraphQueryVariables>;
export const PaginatedInsightGeneratedItemsDocument = gql`
    query PaginatedInsightGeneratedItems($filter: FilterInsightGeneratedItemInput, $pagination: PaginationInput, $sort: SortInsightGeneratedItemsInput) {
  paginatedInsightGeneratedItems(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    limit
    totalPages
    docs {
      ...InsightsGeneratedItemObj
    }
  }
}
    ${InsightsGeneratedItemObjFragmentDoc}`;

/**
 * __usePaginatedInsightGeneratedItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedInsightGeneratedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInsightGeneratedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInsightGeneratedItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedInsightGeneratedItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedInsightGeneratedItemsQuery, Types.PaginatedInsightGeneratedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedInsightGeneratedItemsQuery, Types.PaginatedInsightGeneratedItemsQueryVariables>(PaginatedInsightGeneratedItemsDocument, options);
      }
export function usePaginatedInsightGeneratedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedInsightGeneratedItemsQuery, Types.PaginatedInsightGeneratedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedInsightGeneratedItemsQuery, Types.PaginatedInsightGeneratedItemsQueryVariables>(PaginatedInsightGeneratedItemsDocument, options);
        }
export type PaginatedInsightGeneratedItemsQueryHookResult = ReturnType<typeof usePaginatedInsightGeneratedItemsQuery>;
export type PaginatedInsightGeneratedItemsLazyQueryHookResult = ReturnType<typeof usePaginatedInsightGeneratedItemsLazyQuery>;
export type PaginatedInsightGeneratedItemsQueryResult = Apollo.QueryResult<Types.PaginatedInsightGeneratedItemsQuery, Types.PaginatedInsightGeneratedItemsQueryVariables>;
export const PaginatedInsightsSummarizedTrendItemsDocument = gql`
    query PaginatedInsightsSummarizedTrendItems($filter: FilterInsightTrendItemInput, $pagination: PaginationInput, $sort: SortInsightTrendItemsInput) {
  paginatedInsightTrendItems(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    limit
    totalPages
    docs {
      ...InsightsSummarizedTrendItemObj
    }
  }
}
    ${InsightsSummarizedTrendItemObjFragmentDoc}`;

/**
 * __usePaginatedInsightsSummarizedTrendItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedInsightsSummarizedTrendItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInsightsSummarizedTrendItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInsightsSummarizedTrendItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedInsightsSummarizedTrendItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedInsightsSummarizedTrendItemsQuery, Types.PaginatedInsightsSummarizedTrendItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedInsightsSummarizedTrendItemsQuery, Types.PaginatedInsightsSummarizedTrendItemsQueryVariables>(PaginatedInsightsSummarizedTrendItemsDocument, options);
      }
export function usePaginatedInsightsSummarizedTrendItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedInsightsSummarizedTrendItemsQuery, Types.PaginatedInsightsSummarizedTrendItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedInsightsSummarizedTrendItemsQuery, Types.PaginatedInsightsSummarizedTrendItemsQueryVariables>(PaginatedInsightsSummarizedTrendItemsDocument, options);
        }
export type PaginatedInsightsSummarizedTrendItemsQueryHookResult = ReturnType<typeof usePaginatedInsightsSummarizedTrendItemsQuery>;
export type PaginatedInsightsSummarizedTrendItemsLazyQueryHookResult = ReturnType<typeof usePaginatedInsightsSummarizedTrendItemsLazyQuery>;
export type PaginatedInsightsSummarizedTrendItemsQueryResult = Apollo.QueryResult<Types.PaginatedInsightsSummarizedTrendItemsQuery, Types.PaginatedInsightsSummarizedTrendItemsQueryVariables>;
export const PaginatedInsightsTrendItemsDocument = gql`
    query PaginatedInsightsTrendItems($filter: FilterInsightTrendItemInput, $pagination: PaginationInput, $sort: SortInsightTrendItemsInput) {
  paginatedInsightTrendItems(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    limit
    totalPages
    docs {
      ...InsightsTrendItemObj
    }
  }
}
    ${InsightsTrendItemObjFragmentDoc}`;

/**
 * __usePaginatedInsightsTrendItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedInsightsTrendItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInsightsTrendItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInsightsTrendItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedInsightsTrendItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedInsightsTrendItemsQuery, Types.PaginatedInsightsTrendItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedInsightsTrendItemsQuery, Types.PaginatedInsightsTrendItemsQueryVariables>(PaginatedInsightsTrendItemsDocument, options);
      }
export function usePaginatedInsightsTrendItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedInsightsTrendItemsQuery, Types.PaginatedInsightsTrendItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedInsightsTrendItemsQuery, Types.PaginatedInsightsTrendItemsQueryVariables>(PaginatedInsightsTrendItemsDocument, options);
        }
export type PaginatedInsightsTrendItemsQueryHookResult = ReturnType<typeof usePaginatedInsightsTrendItemsQuery>;
export type PaginatedInsightsTrendItemsLazyQueryHookResult = ReturnType<typeof usePaginatedInsightsTrendItemsLazyQuery>;
export type PaginatedInsightsTrendItemsQueryResult = Apollo.QueryResult<Types.PaginatedInsightsTrendItemsQuery, Types.PaginatedInsightsTrendItemsQueryVariables>;
export const TopInsightGeneratedItemDocument = gql`
    query TopInsightGeneratedItem($filter: FilterInsightGeneratedItemInput) {
  topInsightItem: paginatedInsightGeneratedItems(
    filter: $filter
    pagination: {limit: 1, page: 1}
    sort: {noOfInsights: {order: DESC}}
  ) {
    docs {
      ...InsightsGeneratedItemObj
    }
  }
}
    ${InsightsGeneratedItemObjFragmentDoc}`;

/**
 * __useTopInsightGeneratedItemQuery__
 *
 * To run a query within a React component, call `useTopInsightGeneratedItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopInsightGeneratedItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopInsightGeneratedItemQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTopInsightGeneratedItemQuery(baseOptions?: Apollo.QueryHookOptions<Types.TopInsightGeneratedItemQuery, Types.TopInsightGeneratedItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TopInsightGeneratedItemQuery, Types.TopInsightGeneratedItemQueryVariables>(TopInsightGeneratedItemDocument, options);
      }
export function useTopInsightGeneratedItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TopInsightGeneratedItemQuery, Types.TopInsightGeneratedItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TopInsightGeneratedItemQuery, Types.TopInsightGeneratedItemQueryVariables>(TopInsightGeneratedItemDocument, options);
        }
export type TopInsightGeneratedItemQueryHookResult = ReturnType<typeof useTopInsightGeneratedItemQuery>;
export type TopInsightGeneratedItemLazyQueryHookResult = ReturnType<typeof useTopInsightGeneratedItemLazyQuery>;
export type TopInsightGeneratedItemQueryResult = Apollo.QueryResult<Types.TopInsightGeneratedItemQuery, Types.TopInsightGeneratedItemQueryVariables>;
export const TopInsightsTrendItemsDocument = gql`
    query TopInsightsTrendItems($filter: FilterInsightTrendItemInput) {
  topInsightItem: paginatedInsightTrendItems(
    filter: $filter
    pagination: {limit: 1, page: 1}
    sort: {noOfInsights: {order: DESC}}
  ) {
    docs {
      ...InsightsTrendItemObj
    }
  }
}
    ${InsightsTrendItemObjFragmentDoc}`;

/**
 * __useTopInsightsTrendItemsQuery__
 *
 * To run a query within a React component, call `useTopInsightsTrendItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopInsightsTrendItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopInsightsTrendItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTopInsightsTrendItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TopInsightsTrendItemsQuery, Types.TopInsightsTrendItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TopInsightsTrendItemsQuery, Types.TopInsightsTrendItemsQueryVariables>(TopInsightsTrendItemsDocument, options);
      }
export function useTopInsightsTrendItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TopInsightsTrendItemsQuery, Types.TopInsightsTrendItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TopInsightsTrendItemsQuery, Types.TopInsightsTrendItemsQueryVariables>(TopInsightsTrendItemsDocument, options);
        }
export type TopInsightsTrendItemsQueryHookResult = ReturnType<typeof useTopInsightsTrendItemsQuery>;
export type TopInsightsTrendItemsLazyQueryHookResult = ReturnType<typeof useTopInsightsTrendItemsLazyQuery>;
export type TopInsightsTrendItemsQueryResult = Apollo.QueryResult<Types.TopInsightsTrendItemsQuery, Types.TopInsightsTrendItemsQueryVariables>;
export const MarketingInsightsSummaryDocument = gql`
    query MarketingInsightsSummary {
  marketingInsightsSummary {
    ...InsightsMarketingSummary
  }
}
    ${InsightsMarketingSummaryFragmentDoc}`;

/**
 * __useMarketingInsightsSummaryQuery__
 *
 * To run a query within a React component, call `useMarketingInsightsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingInsightsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingInsightsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingInsightsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<Types.MarketingInsightsSummaryQuery, Types.MarketingInsightsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MarketingInsightsSummaryQuery, Types.MarketingInsightsSummaryQueryVariables>(MarketingInsightsSummaryDocument, options);
      }
export function useMarketingInsightsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MarketingInsightsSummaryQuery, Types.MarketingInsightsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MarketingInsightsSummaryQuery, Types.MarketingInsightsSummaryQueryVariables>(MarketingInsightsSummaryDocument, options);
        }
export type MarketingInsightsSummaryQueryHookResult = ReturnType<typeof useMarketingInsightsSummaryQuery>;
export type MarketingInsightsSummaryLazyQueryHookResult = ReturnType<typeof useMarketingInsightsSummaryLazyQuery>;
export type MarketingInsightsSummaryQueryResult = Apollo.QueryResult<Types.MarketingInsightsSummaryQuery, Types.MarketingInsightsSummaryQueryVariables>;
export const ProductInsightsSummaryDocument = gql`
    query ProductInsightsSummary {
  productInsightsSummary {
    ...InsightsProductSummary
  }
}
    ${InsightsProductSummaryFragmentDoc}`;

/**
 * __useProductInsightsSummaryQuery__
 *
 * To run a query within a React component, call `useProductInsightsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInsightsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInsightsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductInsightsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductInsightsSummaryQuery, Types.ProductInsightsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductInsightsSummaryQuery, Types.ProductInsightsSummaryQueryVariables>(ProductInsightsSummaryDocument, options);
      }
export function useProductInsightsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductInsightsSummaryQuery, Types.ProductInsightsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductInsightsSummaryQuery, Types.ProductInsightsSummaryQueryVariables>(ProductInsightsSummaryDocument, options);
        }
export type ProductInsightsSummaryQueryHookResult = ReturnType<typeof useProductInsightsSummaryQuery>;
export type ProductInsightsSummaryLazyQueryHookResult = ReturnType<typeof useProductInsightsSummaryLazyQuery>;
export type ProductInsightsSummaryQueryResult = Apollo.QueryResult<Types.ProductInsightsSummaryQuery, Types.ProductInsightsSummaryQueryVariables>;
export const ProductInsightsSummaryCreatedDocument = gql`
    subscription ProductInsightsSummaryCreated {
  productInsightsSummaryCreated
}
    `;

/**
 * __useProductInsightsSummaryCreatedSubscription__
 *
 * To run a query within a React component, call `useProductInsightsSummaryCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProductInsightsSummaryCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInsightsSummaryCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProductInsightsSummaryCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<Types.ProductInsightsSummaryCreatedSubscription, Types.ProductInsightsSummaryCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.ProductInsightsSummaryCreatedSubscription, Types.ProductInsightsSummaryCreatedSubscriptionVariables>(ProductInsightsSummaryCreatedDocument, options);
      }
export type ProductInsightsSummaryCreatedSubscriptionHookResult = ReturnType<typeof useProductInsightsSummaryCreatedSubscription>;
export type ProductInsightsSummaryCreatedSubscriptionResult = Apollo.SubscriptionResult<Types.ProductInsightsSummaryCreatedSubscription>;
export const MarketingInsightsSummaryCreatedDocument = gql`
    subscription MarketingInsightsSummaryCreated {
  marketingInsightsSummaryCreated
}
    `;

/**
 * __useMarketingInsightsSummaryCreatedSubscription__
 *
 * To run a query within a React component, call `useMarketingInsightsSummaryCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMarketingInsightsSummaryCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingInsightsSummaryCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMarketingInsightsSummaryCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<Types.MarketingInsightsSummaryCreatedSubscription, Types.MarketingInsightsSummaryCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.MarketingInsightsSummaryCreatedSubscription, Types.MarketingInsightsSummaryCreatedSubscriptionVariables>(MarketingInsightsSummaryCreatedDocument, options);
      }
export type MarketingInsightsSummaryCreatedSubscriptionHookResult = ReturnType<typeof useMarketingInsightsSummaryCreatedSubscription>;
export type MarketingInsightsSummaryCreatedSubscriptionResult = Apollo.SubscriptionResult<Types.MarketingInsightsSummaryCreatedSubscription>;
export const CreateDefaultAssetsDocument = gql`
    mutation CreateDefaultAssets($input: CreateDefaultLaunchAssetsInput!) {
  createDefaultAssets(input: $input) {
    ...LaunchCopilotAsset
  }
}
    ${LaunchCopilotAssetFragmentDoc}`;
export type CreateDefaultAssetsMutationFn = Apollo.MutationFunction<Types.CreateDefaultAssetsMutation, Types.CreateDefaultAssetsMutationVariables>;

/**
 * __useCreateDefaultAssetsMutation__
 *
 * To run a mutation, you first call `useCreateDefaultAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultAssetsMutation, { data, loading, error }] = useCreateDefaultAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDefaultAssetsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDefaultAssetsMutation, Types.CreateDefaultAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDefaultAssetsMutation, Types.CreateDefaultAssetsMutationVariables>(CreateDefaultAssetsDocument, options);
      }
export type CreateDefaultAssetsMutationHookResult = ReturnType<typeof useCreateDefaultAssetsMutation>;
export type CreateDefaultAssetsMutationResult = Apollo.MutationResult<Types.CreateDefaultAssetsMutation>;
export type CreateDefaultAssetsMutationOptions = Apollo.BaseMutationOptions<Types.CreateDefaultAssetsMutation, Types.CreateDefaultAssetsMutationVariables>;
export const LaunchCopilotCreateAssetDocument = gql`
    mutation LaunchCopilotCreateAsset($input: CreateAssetInput!) {
  createAsset(input: $input) {
    ...LaunchCopilotAsset
  }
}
    ${LaunchCopilotAssetFragmentDoc}`;
export type LaunchCopilotCreateAssetMutationFn = Apollo.MutationFunction<Types.LaunchCopilotCreateAssetMutation, Types.LaunchCopilotCreateAssetMutationVariables>;

/**
 * __useLaunchCopilotCreateAssetMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotCreateAssetMutation, { data, loading, error }] = useLaunchCopilotCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotCreateAssetMutation, Types.LaunchCopilotCreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotCreateAssetMutation, Types.LaunchCopilotCreateAssetMutationVariables>(LaunchCopilotCreateAssetDocument, options);
      }
export type LaunchCopilotCreateAssetMutationHookResult = ReturnType<typeof useLaunchCopilotCreateAssetMutation>;
export type LaunchCopilotCreateAssetMutationResult = Apollo.MutationResult<Types.LaunchCopilotCreateAssetMutation>;
export type LaunchCopilotCreateAssetMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotCreateAssetMutation, Types.LaunchCopilotCreateAssetMutationVariables>;
export const LaunchCopilotDeleteAssetDocument = gql`
    mutation LaunchCopilotDeleteAsset($id: String!) {
  deleteAsset(id: $id) {
    ...LaunchCopilotAsset
  }
}
    ${LaunchCopilotAssetFragmentDoc}`;
export type LaunchCopilotDeleteAssetMutationFn = Apollo.MutationFunction<Types.LaunchCopilotDeleteAssetMutation, Types.LaunchCopilotDeleteAssetMutationVariables>;

/**
 * __useLaunchCopilotDeleteAssetMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotDeleteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotDeleteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotDeleteAssetMutation, { data, loading, error }] = useLaunchCopilotDeleteAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchCopilotDeleteAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotDeleteAssetMutation, Types.LaunchCopilotDeleteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotDeleteAssetMutation, Types.LaunchCopilotDeleteAssetMutationVariables>(LaunchCopilotDeleteAssetDocument, options);
      }
export type LaunchCopilotDeleteAssetMutationHookResult = ReturnType<typeof useLaunchCopilotDeleteAssetMutation>;
export type LaunchCopilotDeleteAssetMutationResult = Apollo.MutationResult<Types.LaunchCopilotDeleteAssetMutation>;
export type LaunchCopilotDeleteAssetMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotDeleteAssetMutation, Types.LaunchCopilotDeleteAssetMutationVariables>;
export const LaunchCopilotUpdateAssetDocument = gql`
    mutation LaunchCopilotUpdateAsset($input: UpdateAssetInput!) {
  updateAsset(input: $input) {
    ...LaunchCopilotAsset
  }
}
    ${LaunchCopilotAssetFragmentDoc}`;
export type LaunchCopilotUpdateAssetMutationFn = Apollo.MutationFunction<Types.LaunchCopilotUpdateAssetMutation, Types.LaunchCopilotUpdateAssetMutationVariables>;

/**
 * __useLaunchCopilotUpdateAssetMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotUpdateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotUpdateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotUpdateAssetMutation, { data, loading, error }] = useLaunchCopilotUpdateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotUpdateAssetMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotUpdateAssetMutation, Types.LaunchCopilotUpdateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotUpdateAssetMutation, Types.LaunchCopilotUpdateAssetMutationVariables>(LaunchCopilotUpdateAssetDocument, options);
      }
export type LaunchCopilotUpdateAssetMutationHookResult = ReturnType<typeof useLaunchCopilotUpdateAssetMutation>;
export type LaunchCopilotUpdateAssetMutationResult = Apollo.MutationResult<Types.LaunchCopilotUpdateAssetMutation>;
export type LaunchCopilotUpdateAssetMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotUpdateAssetMutation, Types.LaunchCopilotUpdateAssetMutationVariables>;
export const LaunchCopilotAssetsDocument = gql`
    query LaunchCopilotAssets($filter: FilterAssetsInput, $pagination: PaginationInput, $sort: SortAssetsInput) {
  paginatedAssets(filter: $filter, pagination: $pagination, sort: $sort) {
    docs {
      ...LaunchCopilotAsset
    }
    totalDocs
    totalPages
    page
    limit
  }
}
    ${LaunchCopilotAssetFragmentDoc}`;

/**
 * __useLaunchCopilotAssetsQuery__
 *
 * To run a query within a React component, call `useLaunchCopilotAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCopilotAssetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLaunchCopilotAssetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchCopilotAssetsQuery, Types.LaunchCopilotAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCopilotAssetsQuery, Types.LaunchCopilotAssetsQueryVariables>(LaunchCopilotAssetsDocument, options);
      }
export function useLaunchCopilotAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCopilotAssetsQuery, Types.LaunchCopilotAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCopilotAssetsQuery, Types.LaunchCopilotAssetsQueryVariables>(LaunchCopilotAssetsDocument, options);
        }
export type LaunchCopilotAssetsQueryHookResult = ReturnType<typeof useLaunchCopilotAssetsQuery>;
export type LaunchCopilotAssetsLazyQueryHookResult = ReturnType<typeof useLaunchCopilotAssetsLazyQuery>;
export type LaunchCopilotAssetsQueryResult = Apollo.QueryResult<Types.LaunchCopilotAssetsQuery, Types.LaunchCopilotAssetsQueryVariables>;
export const PreviewDefaultAssetsDocument = gql`
    query PreviewDefaultAssets($launchId: String!) {
  previewDefaultAssets(launchId: $launchId) {
    ...PreviewDefaultAsset
  }
}
    ${PreviewDefaultAssetFragmentDoc}`;

/**
 * __usePreviewDefaultAssetsQuery__
 *
 * To run a query within a React component, call `usePreviewDefaultAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDefaultAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDefaultAssetsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function usePreviewDefaultAssetsQuery(baseOptions: Apollo.QueryHookOptions<Types.PreviewDefaultAssetsQuery, Types.PreviewDefaultAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreviewDefaultAssetsQuery, Types.PreviewDefaultAssetsQueryVariables>(PreviewDefaultAssetsDocument, options);
      }
export function usePreviewDefaultAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreviewDefaultAssetsQuery, Types.PreviewDefaultAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreviewDefaultAssetsQuery, Types.PreviewDefaultAssetsQueryVariables>(PreviewDefaultAssetsDocument, options);
        }
export type PreviewDefaultAssetsQueryHookResult = ReturnType<typeof usePreviewDefaultAssetsQuery>;
export type PreviewDefaultAssetsLazyQueryHookResult = ReturnType<typeof usePreviewDefaultAssetsLazyQuery>;
export type PreviewDefaultAssetsQueryResult = Apollo.QueryResult<Types.PreviewDefaultAssetsQuery, Types.PreviewDefaultAssetsQueryVariables>;
export const LaunchCopilotPreferencesDocument = gql`
    query LaunchCopilotPreferences($id: String!) {
  launch(id: $id) {
    ...LaunchCopilotPreferences
  }
}
    ${LaunchCopilotPreferencesFragmentDoc}`;

/**
 * __useLaunchCopilotPreferencesQuery__
 *
 * To run a query within a React component, call `useLaunchCopilotPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCopilotPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchCopilotPreferencesQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchCopilotPreferencesQuery, Types.LaunchCopilotPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCopilotPreferencesQuery, Types.LaunchCopilotPreferencesQueryVariables>(LaunchCopilotPreferencesDocument, options);
      }
export function useLaunchCopilotPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCopilotPreferencesQuery, Types.LaunchCopilotPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCopilotPreferencesQuery, Types.LaunchCopilotPreferencesQueryVariables>(LaunchCopilotPreferencesDocument, options);
        }
export type LaunchCopilotPreferencesQueryHookResult = ReturnType<typeof useLaunchCopilotPreferencesQuery>;
export type LaunchCopilotPreferencesLazyQueryHookResult = ReturnType<typeof useLaunchCopilotPreferencesLazyQuery>;
export type LaunchCopilotPreferencesQueryResult = Apollo.QueryResult<Types.LaunchCopilotPreferencesQuery, Types.LaunchCopilotPreferencesQueryVariables>;
export const LaunchCopilotCreateTaskDocument = gql`
    mutation LaunchCopilotCreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    ...LaunchCopilotTask
  }
}
    ${LaunchCopilotTaskFragmentDoc}`;
export type LaunchCopilotCreateTaskMutationFn = Apollo.MutationFunction<Types.LaunchCopilotCreateTaskMutation, Types.LaunchCopilotCreateTaskMutationVariables>;

/**
 * __useLaunchCopilotCreateTaskMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotCreateTaskMutation, { data, loading, error }] = useLaunchCopilotCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotCreateTaskMutation, Types.LaunchCopilotCreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotCreateTaskMutation, Types.LaunchCopilotCreateTaskMutationVariables>(LaunchCopilotCreateTaskDocument, options);
      }
export type LaunchCopilotCreateTaskMutationHookResult = ReturnType<typeof useLaunchCopilotCreateTaskMutation>;
export type LaunchCopilotCreateTaskMutationResult = Apollo.MutationResult<Types.LaunchCopilotCreateTaskMutation>;
export type LaunchCopilotCreateTaskMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotCreateTaskMutation, Types.LaunchCopilotCreateTaskMutationVariables>;
export const LaunchCopilotDeleteTaskDocument = gql`
    mutation LaunchCopilotDeleteTask($input: DeleteTaskInput!) {
  deleteTask(id: $input) {
    ...LaunchCopilotTask
  }
}
    ${LaunchCopilotTaskFragmentDoc}`;
export type LaunchCopilotDeleteTaskMutationFn = Apollo.MutationFunction<Types.LaunchCopilotDeleteTaskMutation, Types.LaunchCopilotDeleteTaskMutationVariables>;

/**
 * __useLaunchCopilotDeleteTaskMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotDeleteTaskMutation, { data, loading, error }] = useLaunchCopilotDeleteTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotDeleteTaskMutation, Types.LaunchCopilotDeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotDeleteTaskMutation, Types.LaunchCopilotDeleteTaskMutationVariables>(LaunchCopilotDeleteTaskDocument, options);
      }
export type LaunchCopilotDeleteTaskMutationHookResult = ReturnType<typeof useLaunchCopilotDeleteTaskMutation>;
export type LaunchCopilotDeleteTaskMutationResult = Apollo.MutationResult<Types.LaunchCopilotDeleteTaskMutation>;
export type LaunchCopilotDeleteTaskMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotDeleteTaskMutation, Types.LaunchCopilotDeleteTaskMutationVariables>;
export const LaunchCopilotDeleteTasksDocument = gql`
    mutation LaunchCopilotDeleteTasks($input: DeleteTasksInput!) {
  deleteTasks(input: $input) {
    ...LaunchCopilotTask
  }
}
    ${LaunchCopilotTaskFragmentDoc}`;
export type LaunchCopilotDeleteTasksMutationFn = Apollo.MutationFunction<Types.LaunchCopilotDeleteTasksMutation, Types.LaunchCopilotDeleteTasksMutationVariables>;

/**
 * __useLaunchCopilotDeleteTasksMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotDeleteTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotDeleteTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotDeleteTasksMutation, { data, loading, error }] = useLaunchCopilotDeleteTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotDeleteTasksMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotDeleteTasksMutation, Types.LaunchCopilotDeleteTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotDeleteTasksMutation, Types.LaunchCopilotDeleteTasksMutationVariables>(LaunchCopilotDeleteTasksDocument, options);
      }
export type LaunchCopilotDeleteTasksMutationHookResult = ReturnType<typeof useLaunchCopilotDeleteTasksMutation>;
export type LaunchCopilotDeleteTasksMutationResult = Apollo.MutationResult<Types.LaunchCopilotDeleteTasksMutation>;
export type LaunchCopilotDeleteTasksMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotDeleteTasksMutation, Types.LaunchCopilotDeleteTasksMutationVariables>;
export const LaunchCopilotUpdateTaskDocument = gql`
    mutation LaunchCopilotUpdateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    ...LaunchCopilotTask
  }
}
    ${LaunchCopilotTaskFragmentDoc}`;
export type LaunchCopilotUpdateTaskMutationFn = Apollo.MutationFunction<Types.LaunchCopilotUpdateTaskMutation, Types.LaunchCopilotUpdateTaskMutationVariables>;

/**
 * __useLaunchCopilotUpdateTaskMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotUpdateTaskMutation, { data, loading, error }] = useLaunchCopilotUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotUpdateTaskMutation, Types.LaunchCopilotUpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotUpdateTaskMutation, Types.LaunchCopilotUpdateTaskMutationVariables>(LaunchCopilotUpdateTaskDocument, options);
      }
export type LaunchCopilotUpdateTaskMutationHookResult = ReturnType<typeof useLaunchCopilotUpdateTaskMutation>;
export type LaunchCopilotUpdateTaskMutationResult = Apollo.MutationResult<Types.LaunchCopilotUpdateTaskMutation>;
export type LaunchCopilotUpdateTaskMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotUpdateTaskMutation, Types.LaunchCopilotUpdateTaskMutationVariables>;
export const LaunchCopilotTasksDocument = gql`
    query LaunchCopilotTasks($pagination: PaginationInput, $filter: FilterTasksInput, $sort: SortTasksInput) {
  paginatedTasks(pagination: $pagination, filter: $filter, sort: $sort) {
    docs {
      ...LaunchCopilotTask
    }
    groups {
      key
      count
    }
    totalDocs
    totalPages
    page
    limit
  }
}
    ${LaunchCopilotTaskFragmentDoc}`;

/**
 * __useLaunchCopilotTasksQuery__
 *
 * To run a query within a React component, call `useLaunchCopilotTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCopilotTasksQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLaunchCopilotTasksQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchCopilotTasksQuery, Types.LaunchCopilotTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCopilotTasksQuery, Types.LaunchCopilotTasksQueryVariables>(LaunchCopilotTasksDocument, options);
      }
export function useLaunchCopilotTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCopilotTasksQuery, Types.LaunchCopilotTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCopilotTasksQuery, Types.LaunchCopilotTasksQueryVariables>(LaunchCopilotTasksDocument, options);
        }
export type LaunchCopilotTasksQueryHookResult = ReturnType<typeof useLaunchCopilotTasksQuery>;
export type LaunchCopilotTasksLazyQueryHookResult = ReturnType<typeof useLaunchCopilotTasksLazyQuery>;
export type LaunchCopilotTasksQueryResult = Apollo.QueryResult<Types.LaunchCopilotTasksQuery, Types.LaunchCopilotTasksQueryVariables>;
export const PreviewDefaultTasksDocument = gql`
    query PreviewDefaultTasks($launchId: String!) {
  previewDefaultTasks(launchId: $launchId) {
    ...PreviewDefaultTask
  }
}
    ${PreviewDefaultTaskFragmentDoc}`;

/**
 * __usePreviewDefaultTasksQuery__
 *
 * To run a query within a React component, call `usePreviewDefaultTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDefaultTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDefaultTasksQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function usePreviewDefaultTasksQuery(baseOptions: Apollo.QueryHookOptions<Types.PreviewDefaultTasksQuery, Types.PreviewDefaultTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreviewDefaultTasksQuery, Types.PreviewDefaultTasksQueryVariables>(PreviewDefaultTasksDocument, options);
      }
export function usePreviewDefaultTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreviewDefaultTasksQuery, Types.PreviewDefaultTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreviewDefaultTasksQuery, Types.PreviewDefaultTasksQueryVariables>(PreviewDefaultTasksDocument, options);
        }
export type PreviewDefaultTasksQueryHookResult = ReturnType<typeof usePreviewDefaultTasksQuery>;
export type PreviewDefaultTasksLazyQueryHookResult = ReturnType<typeof usePreviewDefaultTasksLazyQuery>;
export type PreviewDefaultTasksQueryResult = Apollo.QueryResult<Types.PreviewDefaultTasksQuery, Types.PreviewDefaultTasksQueryVariables>;
export const LaunchCopilotCreateChannelDocument = gql`
    mutation LaunchCopilotCreateChannel($input: CreateChannelInput!) {
  createChannel(input: $input) {
    ...LaunchCopilotChannel
  }
}
    ${LaunchCopilotChannelFragmentDoc}`;
export type LaunchCopilotCreateChannelMutationFn = Apollo.MutationFunction<Types.LaunchCopilotCreateChannelMutation, Types.LaunchCopilotCreateChannelMutationVariables>;

/**
 * __useLaunchCopilotCreateChannelMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotCreateChannelMutation, { data, loading, error }] = useLaunchCopilotCreateChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotCreateChannelMutation, Types.LaunchCopilotCreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotCreateChannelMutation, Types.LaunchCopilotCreateChannelMutationVariables>(LaunchCopilotCreateChannelDocument, options);
      }
export type LaunchCopilotCreateChannelMutationHookResult = ReturnType<typeof useLaunchCopilotCreateChannelMutation>;
export type LaunchCopilotCreateChannelMutationResult = Apollo.MutationResult<Types.LaunchCopilotCreateChannelMutation>;
export type LaunchCopilotCreateChannelMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotCreateChannelMutation, Types.LaunchCopilotCreateChannelMutationVariables>;
export const LaunchCopilotCreateMilestoneDocument = gql`
    mutation LaunchCopilotCreateMilestone($input: CreateMilestoneInput!) {
  createMilestone(input: $input) {
    ...LaunchCopilotMilestone
  }
}
    ${LaunchCopilotMilestoneFragmentDoc}`;
export type LaunchCopilotCreateMilestoneMutationFn = Apollo.MutationFunction<Types.LaunchCopilotCreateMilestoneMutation, Types.LaunchCopilotCreateMilestoneMutationVariables>;

/**
 * __useLaunchCopilotCreateMilestoneMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotCreateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotCreateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotCreateMilestoneMutation, { data, loading, error }] = useLaunchCopilotCreateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotCreateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotCreateMilestoneMutation, Types.LaunchCopilotCreateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotCreateMilestoneMutation, Types.LaunchCopilotCreateMilestoneMutationVariables>(LaunchCopilotCreateMilestoneDocument, options);
      }
export type LaunchCopilotCreateMilestoneMutationHookResult = ReturnType<typeof useLaunchCopilotCreateMilestoneMutation>;
export type LaunchCopilotCreateMilestoneMutationResult = Apollo.MutationResult<Types.LaunchCopilotCreateMilestoneMutation>;
export type LaunchCopilotCreateMilestoneMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotCreateMilestoneMutation, Types.LaunchCopilotCreateMilestoneMutationVariables>;
export const LaunchCopilotCreatePhaseDocument = gql`
    mutation LaunchCopilotCreatePhase($input: AddLaunchPhaseInput!) {
  addLaunchPhase(input: $input) {
    id
    phases {
      ...LaunchCopilotPhase
    }
  }
}
    ${LaunchCopilotPhaseFragmentDoc}`;
export type LaunchCopilotCreatePhaseMutationFn = Apollo.MutationFunction<Types.LaunchCopilotCreatePhaseMutation, Types.LaunchCopilotCreatePhaseMutationVariables>;

/**
 * __useLaunchCopilotCreatePhaseMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotCreatePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotCreatePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotCreatePhaseMutation, { data, loading, error }] = useLaunchCopilotCreatePhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotCreatePhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotCreatePhaseMutation, Types.LaunchCopilotCreatePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotCreatePhaseMutation, Types.LaunchCopilotCreatePhaseMutationVariables>(LaunchCopilotCreatePhaseDocument, options);
      }
export type LaunchCopilotCreatePhaseMutationHookResult = ReturnType<typeof useLaunchCopilotCreatePhaseMutation>;
export type LaunchCopilotCreatePhaseMutationResult = Apollo.MutationResult<Types.LaunchCopilotCreatePhaseMutation>;
export type LaunchCopilotCreatePhaseMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotCreatePhaseMutation, Types.LaunchCopilotCreatePhaseMutationVariables>;
export const LaunchCopilotCreateTimeframeDocument = gql`
    mutation LaunchCopilotCreateTimeframe($input: CreateChannelTimeframeInput!) {
  createChannelTimeframe(input: $input) {
    ...LaunchCopilotChannelTimeframe
  }
}
    ${LaunchCopilotChannelTimeframeFragmentDoc}`;
export type LaunchCopilotCreateTimeframeMutationFn = Apollo.MutationFunction<Types.LaunchCopilotCreateTimeframeMutation, Types.LaunchCopilotCreateTimeframeMutationVariables>;

/**
 * __useLaunchCopilotCreateTimeframeMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotCreateTimeframeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotCreateTimeframeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotCreateTimeframeMutation, { data, loading, error }] = useLaunchCopilotCreateTimeframeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotCreateTimeframeMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotCreateTimeframeMutation, Types.LaunchCopilotCreateTimeframeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotCreateTimeframeMutation, Types.LaunchCopilotCreateTimeframeMutationVariables>(LaunchCopilotCreateTimeframeDocument, options);
      }
export type LaunchCopilotCreateTimeframeMutationHookResult = ReturnType<typeof useLaunchCopilotCreateTimeframeMutation>;
export type LaunchCopilotCreateTimeframeMutationResult = Apollo.MutationResult<Types.LaunchCopilotCreateTimeframeMutation>;
export type LaunchCopilotCreateTimeframeMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotCreateTimeframeMutation, Types.LaunchCopilotCreateTimeframeMutationVariables>;
export const LaunchCopilotDeleteChannelDocument = gql`
    mutation LaunchCopilotDeleteChannel($input: DeleteChannelInput!) {
  deleteChannel(input: $input) {
    ...LaunchCopilotChannel
  }
}
    ${LaunchCopilotChannelFragmentDoc}`;
export type LaunchCopilotDeleteChannelMutationFn = Apollo.MutationFunction<Types.LaunchCopilotDeleteChannelMutation, Types.LaunchCopilotDeleteChannelMutationVariables>;

/**
 * __useLaunchCopilotDeleteChannelMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotDeleteChannelMutation, { data, loading, error }] = useLaunchCopilotDeleteChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotDeleteChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotDeleteChannelMutation, Types.LaunchCopilotDeleteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotDeleteChannelMutation, Types.LaunchCopilotDeleteChannelMutationVariables>(LaunchCopilotDeleteChannelDocument, options);
      }
export type LaunchCopilotDeleteChannelMutationHookResult = ReturnType<typeof useLaunchCopilotDeleteChannelMutation>;
export type LaunchCopilotDeleteChannelMutationResult = Apollo.MutationResult<Types.LaunchCopilotDeleteChannelMutation>;
export type LaunchCopilotDeleteChannelMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotDeleteChannelMutation, Types.LaunchCopilotDeleteChannelMutationVariables>;
export const LaunchCopilotDeleteMilestoneDocument = gql`
    mutation LaunchCopilotDeleteMilestone($input: DeleteMilestoneInput!) {
  deleteMilestone(input: $input) {
    ...LaunchCopilotMilestone
  }
}
    ${LaunchCopilotMilestoneFragmentDoc}`;
export type LaunchCopilotDeleteMilestoneMutationFn = Apollo.MutationFunction<Types.LaunchCopilotDeleteMilestoneMutation, Types.LaunchCopilotDeleteMilestoneMutationVariables>;

/**
 * __useLaunchCopilotDeleteMilestoneMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotDeleteMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotDeleteMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotDeleteMilestoneMutation, { data, loading, error }] = useLaunchCopilotDeleteMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotDeleteMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotDeleteMilestoneMutation, Types.LaunchCopilotDeleteMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotDeleteMilestoneMutation, Types.LaunchCopilotDeleteMilestoneMutationVariables>(LaunchCopilotDeleteMilestoneDocument, options);
      }
export type LaunchCopilotDeleteMilestoneMutationHookResult = ReturnType<typeof useLaunchCopilotDeleteMilestoneMutation>;
export type LaunchCopilotDeleteMilestoneMutationResult = Apollo.MutationResult<Types.LaunchCopilotDeleteMilestoneMutation>;
export type LaunchCopilotDeleteMilestoneMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotDeleteMilestoneMutation, Types.LaunchCopilotDeleteMilestoneMutationVariables>;
export const LaunchCopilotDeletePhaseDocument = gql`
    mutation LaunchCopilotDeletePhase($launchId: String!, $phaseId: String!) {
  removeLaunchPhase(launchId: $launchId, phaseId: $phaseId) {
    id
    phases {
      ...LaunchCopilotPhase
    }
  }
}
    ${LaunchCopilotPhaseFragmentDoc}`;
export type LaunchCopilotDeletePhaseMutationFn = Apollo.MutationFunction<Types.LaunchCopilotDeletePhaseMutation, Types.LaunchCopilotDeletePhaseMutationVariables>;

/**
 * __useLaunchCopilotDeletePhaseMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotDeletePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotDeletePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotDeletePhaseMutation, { data, loading, error }] = useLaunchCopilotDeletePhaseMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useLaunchCopilotDeletePhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotDeletePhaseMutation, Types.LaunchCopilotDeletePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotDeletePhaseMutation, Types.LaunchCopilotDeletePhaseMutationVariables>(LaunchCopilotDeletePhaseDocument, options);
      }
export type LaunchCopilotDeletePhaseMutationHookResult = ReturnType<typeof useLaunchCopilotDeletePhaseMutation>;
export type LaunchCopilotDeletePhaseMutationResult = Apollo.MutationResult<Types.LaunchCopilotDeletePhaseMutation>;
export type LaunchCopilotDeletePhaseMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotDeletePhaseMutation, Types.LaunchCopilotDeletePhaseMutationVariables>;
export const LaunchCopilotDeleteTimeframeDocument = gql`
    mutation LaunchCopilotDeleteTimeframe($input: DeleteChannelTimeframeInput!) {
  deleteChannelTimeframe(input: $input) {
    ...LaunchCopilotChannelTimeframe
  }
}
    ${LaunchCopilotChannelTimeframeFragmentDoc}`;
export type LaunchCopilotDeleteTimeframeMutationFn = Apollo.MutationFunction<Types.LaunchCopilotDeleteTimeframeMutation, Types.LaunchCopilotDeleteTimeframeMutationVariables>;

/**
 * __useLaunchCopilotDeleteTimeframeMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotDeleteTimeframeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotDeleteTimeframeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotDeleteTimeframeMutation, { data, loading, error }] = useLaunchCopilotDeleteTimeframeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotDeleteTimeframeMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotDeleteTimeframeMutation, Types.LaunchCopilotDeleteTimeframeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotDeleteTimeframeMutation, Types.LaunchCopilotDeleteTimeframeMutationVariables>(LaunchCopilotDeleteTimeframeDocument, options);
      }
export type LaunchCopilotDeleteTimeframeMutationHookResult = ReturnType<typeof useLaunchCopilotDeleteTimeframeMutation>;
export type LaunchCopilotDeleteTimeframeMutationResult = Apollo.MutationResult<Types.LaunchCopilotDeleteTimeframeMutation>;
export type LaunchCopilotDeleteTimeframeMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotDeleteTimeframeMutation, Types.LaunchCopilotDeleteTimeframeMutationVariables>;
export const LaunchCopilotUpdateChannelDocument = gql`
    mutation LaunchCopilotUpdateChannel($input: UpdateChannelInput!) {
  updateChannel(input: $input) {
    ...LaunchCopilotChannel
  }
}
    ${LaunchCopilotChannelFragmentDoc}`;
export type LaunchCopilotUpdateChannelMutationFn = Apollo.MutationFunction<Types.LaunchCopilotUpdateChannelMutation, Types.LaunchCopilotUpdateChannelMutationVariables>;

/**
 * __useLaunchCopilotUpdateChannelMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotUpdateChannelMutation, { data, loading, error }] = useLaunchCopilotUpdateChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotUpdateChannelMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotUpdateChannelMutation, Types.LaunchCopilotUpdateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotUpdateChannelMutation, Types.LaunchCopilotUpdateChannelMutationVariables>(LaunchCopilotUpdateChannelDocument, options);
      }
export type LaunchCopilotUpdateChannelMutationHookResult = ReturnType<typeof useLaunchCopilotUpdateChannelMutation>;
export type LaunchCopilotUpdateChannelMutationResult = Apollo.MutationResult<Types.LaunchCopilotUpdateChannelMutation>;
export type LaunchCopilotUpdateChannelMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotUpdateChannelMutation, Types.LaunchCopilotUpdateChannelMutationVariables>;
export const LaunchCopilotUpdateMilestoneDocument = gql`
    mutation LaunchCopilotUpdateMilestone($input: UpdateMilestoneInput!) {
  updateMilestone(input: $input) {
    ...LaunchCopilotMilestone
  }
}
    ${LaunchCopilotMilestoneFragmentDoc}`;
export type LaunchCopilotUpdateMilestoneMutationFn = Apollo.MutationFunction<Types.LaunchCopilotUpdateMilestoneMutation, Types.LaunchCopilotUpdateMilestoneMutationVariables>;

/**
 * __useLaunchCopilotUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotUpdateMilestoneMutation, { data, loading, error }] = useLaunchCopilotUpdateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotUpdateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotUpdateMilestoneMutation, Types.LaunchCopilotUpdateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotUpdateMilestoneMutation, Types.LaunchCopilotUpdateMilestoneMutationVariables>(LaunchCopilotUpdateMilestoneDocument, options);
      }
export type LaunchCopilotUpdateMilestoneMutationHookResult = ReturnType<typeof useLaunchCopilotUpdateMilestoneMutation>;
export type LaunchCopilotUpdateMilestoneMutationResult = Apollo.MutationResult<Types.LaunchCopilotUpdateMilestoneMutation>;
export type LaunchCopilotUpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotUpdateMilestoneMutation, Types.LaunchCopilotUpdateMilestoneMutationVariables>;
export const LaunchCopilotUpdatePhaseDocument = gql`
    mutation LaunchCopilotUpdatePhase($input: UpdateLaunchPhaseInput!) {
  updateLaunchPhase(input: $input) {
    id
    phases {
      ...LaunchCopilotPhase
    }
  }
}
    ${LaunchCopilotPhaseFragmentDoc}`;
export type LaunchCopilotUpdatePhaseMutationFn = Apollo.MutationFunction<Types.LaunchCopilotUpdatePhaseMutation, Types.LaunchCopilotUpdatePhaseMutationVariables>;

/**
 * __useLaunchCopilotUpdatePhaseMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotUpdatePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotUpdatePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotUpdatePhaseMutation, { data, loading, error }] = useLaunchCopilotUpdatePhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotUpdatePhaseMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotUpdatePhaseMutation, Types.LaunchCopilotUpdatePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotUpdatePhaseMutation, Types.LaunchCopilotUpdatePhaseMutationVariables>(LaunchCopilotUpdatePhaseDocument, options);
      }
export type LaunchCopilotUpdatePhaseMutationHookResult = ReturnType<typeof useLaunchCopilotUpdatePhaseMutation>;
export type LaunchCopilotUpdatePhaseMutationResult = Apollo.MutationResult<Types.LaunchCopilotUpdatePhaseMutation>;
export type LaunchCopilotUpdatePhaseMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotUpdatePhaseMutation, Types.LaunchCopilotUpdatePhaseMutationVariables>;
export const LaunchCopilotUpdateTimeframeDocument = gql`
    mutation LaunchCopilotUpdateTimeframe($input: UpdateChannelTimeframeInput!) {
  updateChannelTimeframe(input: $input) {
    ...LaunchCopilotChannelTimeframe
  }
}
    ${LaunchCopilotChannelTimeframeFragmentDoc}`;
export type LaunchCopilotUpdateTimeframeMutationFn = Apollo.MutationFunction<Types.LaunchCopilotUpdateTimeframeMutation, Types.LaunchCopilotUpdateTimeframeMutationVariables>;

/**
 * __useLaunchCopilotUpdateTimeframeMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotUpdateTimeframeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotUpdateTimeframeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotUpdateTimeframeMutation, { data, loading, error }] = useLaunchCopilotUpdateTimeframeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotUpdateTimeframeMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotUpdateTimeframeMutation, Types.LaunchCopilotUpdateTimeframeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotUpdateTimeframeMutation, Types.LaunchCopilotUpdateTimeframeMutationVariables>(LaunchCopilotUpdateTimeframeDocument, options);
      }
export type LaunchCopilotUpdateTimeframeMutationHookResult = ReturnType<typeof useLaunchCopilotUpdateTimeframeMutation>;
export type LaunchCopilotUpdateTimeframeMutationResult = Apollo.MutationResult<Types.LaunchCopilotUpdateTimeframeMutation>;
export type LaunchCopilotUpdateTimeframeMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotUpdateTimeframeMutation, Types.LaunchCopilotUpdateTimeframeMutationVariables>;
export const LaunchCopilotChannelsDocument = gql`
    query LaunchCopilotChannels($launchId: String!) {
  launch(id: $launchId) {
    id
    launchDate
    gtmTimeline {
      launchId
      channels {
        ...LaunchCopilotChannel
      }
      milestones {
        ...LaunchCopilotMilestone
      }
    }
    phases {
      ...LaunchCopilotPhase
    }
  }
}
    ${LaunchCopilotChannelFragmentDoc}
${LaunchCopilotMilestoneFragmentDoc}
${LaunchCopilotPhaseFragmentDoc}`;

/**
 * __useLaunchCopilotChannelsQuery__
 *
 * To run a query within a React component, call `useLaunchCopilotChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCopilotChannelsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchCopilotChannelsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchCopilotChannelsQuery, Types.LaunchCopilotChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCopilotChannelsQuery, Types.LaunchCopilotChannelsQueryVariables>(LaunchCopilotChannelsDocument, options);
      }
export function useLaunchCopilotChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCopilotChannelsQuery, Types.LaunchCopilotChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCopilotChannelsQuery, Types.LaunchCopilotChannelsQueryVariables>(LaunchCopilotChannelsDocument, options);
        }
export type LaunchCopilotChannelsQueryHookResult = ReturnType<typeof useLaunchCopilotChannelsQuery>;
export type LaunchCopilotChannelsLazyQueryHookResult = ReturnType<typeof useLaunchCopilotChannelsLazyQuery>;
export type LaunchCopilotChannelsQueryResult = Apollo.QueryResult<Types.LaunchCopilotChannelsQuery, Types.LaunchCopilotChannelsQueryVariables>;
export const PreviewDefaultChannelsDocument = gql`
    query PreviewDefaultChannels($input: CreateDefaultChannelsInput!) {
  previewDefaultChannels(input: $input) {
    ...PreviewDefaultChannel
  }
}
    ${PreviewDefaultChannelFragmentDoc}`;

/**
 * __usePreviewDefaultChannelsQuery__
 *
 * To run a query within a React component, call `usePreviewDefaultChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDefaultChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDefaultChannelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewDefaultChannelsQuery(baseOptions: Apollo.QueryHookOptions<Types.PreviewDefaultChannelsQuery, Types.PreviewDefaultChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreviewDefaultChannelsQuery, Types.PreviewDefaultChannelsQueryVariables>(PreviewDefaultChannelsDocument, options);
      }
export function usePreviewDefaultChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreviewDefaultChannelsQuery, Types.PreviewDefaultChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreviewDefaultChannelsQuery, Types.PreviewDefaultChannelsQueryVariables>(PreviewDefaultChannelsDocument, options);
        }
export type PreviewDefaultChannelsQueryHookResult = ReturnType<typeof usePreviewDefaultChannelsQuery>;
export type PreviewDefaultChannelsLazyQueryHookResult = ReturnType<typeof usePreviewDefaultChannelsLazyQuery>;
export type PreviewDefaultChannelsQueryResult = Apollo.QueryResult<Types.PreviewDefaultChannelsQuery, Types.PreviewDefaultChannelsQueryVariables>;
export const UpdateLaunchModuleDocument = gql`
    mutation UpdateLaunchModule($input: UpdateLaunchModuleDetailsInput!) {
  updateLaunchModuleDetails(input: $input) {
    id
    editor
    approvalStatus
    dueDate
    isVisible
    name
    tagsIds
  }
}
    `;
export type UpdateLaunchModuleMutationFn = Apollo.MutationFunction<Types.UpdateLaunchModuleMutation, Types.UpdateLaunchModuleMutationVariables>;

/**
 * __useUpdateLaunchModuleMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchModuleMutation, { data, loading, error }] = useUpdateLaunchModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchModuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchModuleMutation, Types.UpdateLaunchModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchModuleMutation, Types.UpdateLaunchModuleMutationVariables>(UpdateLaunchModuleDocument, options);
      }
export type UpdateLaunchModuleMutationHookResult = ReturnType<typeof useUpdateLaunchModuleMutation>;
export type UpdateLaunchModuleMutationResult = Apollo.MutationResult<Types.UpdateLaunchModuleMutation>;
export type UpdateLaunchModuleMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchModuleMutation, Types.UpdateLaunchModuleMutationVariables>;
export const UpdateLaunchModulesVisibleStatesDocument = gql`
    mutation UpdateLaunchModulesVisibleStates($launchModuleIds: [String!]!, $isVisible: Boolean) {
  updateLaunchModuleDetails(
    input: {launchModuleIds: $launchModuleIds, isVisible: $isVisible}
  ) {
    ...LaunchModulesVisibleStates
  }
}
    ${LaunchModulesVisibleStatesFragmentDoc}`;
export type UpdateLaunchModulesVisibleStatesMutationFn = Apollo.MutationFunction<Types.UpdateLaunchModulesVisibleStatesMutation, Types.UpdateLaunchModulesVisibleStatesMutationVariables>;

/**
 * __useUpdateLaunchModulesVisibleStatesMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchModulesVisibleStatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchModulesVisibleStatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchModulesVisibleStatesMutation, { data, loading, error }] = useUpdateLaunchModulesVisibleStatesMutation({
 *   variables: {
 *      launchModuleIds: // value for 'launchModuleIds'
 *      isVisible: // value for 'isVisible'
 *   },
 * });
 */
export function useUpdateLaunchModulesVisibleStatesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchModulesVisibleStatesMutation, Types.UpdateLaunchModulesVisibleStatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchModulesVisibleStatesMutation, Types.UpdateLaunchModulesVisibleStatesMutationVariables>(UpdateLaunchModulesVisibleStatesDocument, options);
      }
export type UpdateLaunchModulesVisibleStatesMutationHookResult = ReturnType<typeof useUpdateLaunchModulesVisibleStatesMutation>;
export type UpdateLaunchModulesVisibleStatesMutationResult = Apollo.MutationResult<Types.UpdateLaunchModulesVisibleStatesMutation>;
export type UpdateLaunchModulesVisibleStatesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchModulesVisibleStatesMutation, Types.UpdateLaunchModulesVisibleStatesMutationVariables>;
export const LaunchModuleDocument = gql`
    query LaunchModule($id: String!) {
  launchModule(id: $id) {
    ...LaunchModule
  }
}
    ${LaunchModuleFragmentDoc}`;

/**
 * __useLaunchModuleQuery__
 *
 * To run a query within a React component, call `useLaunchModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchModuleQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchModuleQuery, Types.LaunchModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchModuleQuery, Types.LaunchModuleQueryVariables>(LaunchModuleDocument, options);
      }
export function useLaunchModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchModuleQuery, Types.LaunchModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchModuleQuery, Types.LaunchModuleQueryVariables>(LaunchModuleDocument, options);
        }
export type LaunchModuleQueryHookResult = ReturnType<typeof useLaunchModuleQuery>;
export type LaunchModuleLazyQueryHookResult = ReturnType<typeof useLaunchModuleLazyQuery>;
export type LaunchModuleQueryResult = Apollo.QueryResult<Types.LaunchModuleQuery, Types.LaunchModuleQueryVariables>;
export const UpdateLaunchInfoForModuleDocument = gql`
    mutation UpdateLaunchInfoForModule($input: UpdateLaunchDetailsInput!) {
  updateLaunchDetails(input: $input) {
    ...LaunchInfoForModule
  }
}
    ${LaunchInfoForModuleFragmentDoc}`;
export type UpdateLaunchInfoForModuleMutationFn = Apollo.MutationFunction<Types.UpdateLaunchInfoForModuleMutation, Types.UpdateLaunchInfoForModuleMutationVariables>;

/**
 * __useUpdateLaunchInfoForModuleMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchInfoForModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchInfoForModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchInfoForModuleMutation, { data, loading, error }] = useUpdateLaunchInfoForModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchInfoForModuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchInfoForModuleMutation, Types.UpdateLaunchInfoForModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchInfoForModuleMutation, Types.UpdateLaunchInfoForModuleMutationVariables>(UpdateLaunchInfoForModuleDocument, options);
      }
export type UpdateLaunchInfoForModuleMutationHookResult = ReturnType<typeof useUpdateLaunchInfoForModuleMutation>;
export type UpdateLaunchInfoForModuleMutationResult = Apollo.MutationResult<Types.UpdateLaunchInfoForModuleMutation>;
export type UpdateLaunchInfoForModuleMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchInfoForModuleMutation, Types.UpdateLaunchInfoForModuleMutationVariables>;
export const UpdateLaunchSectionsVisibleStatesDocument = gql`
    mutation UpdateLaunchSectionsVisibleStates($id: String!, $sectionVisibilityPreferences: SectionVisibilityPreferencesInput) {
  updateLaunchDetails(
    input: {id: $id, sectionVisibilityPreferences: $sectionVisibilityPreferences}
  ) {
    ...LaunchSectionsVisibleStates
  }
}
    ${LaunchSectionsVisibleStatesFragmentDoc}`;
export type UpdateLaunchSectionsVisibleStatesMutationFn = Apollo.MutationFunction<Types.UpdateLaunchSectionsVisibleStatesMutation, Types.UpdateLaunchSectionsVisibleStatesMutationVariables>;

/**
 * __useUpdateLaunchSectionsVisibleStatesMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchSectionsVisibleStatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchSectionsVisibleStatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchSectionsVisibleStatesMutation, { data, loading, error }] = useUpdateLaunchSectionsVisibleStatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionVisibilityPreferences: // value for 'sectionVisibilityPreferences'
 *   },
 * });
 */
export function useUpdateLaunchSectionsVisibleStatesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchSectionsVisibleStatesMutation, Types.UpdateLaunchSectionsVisibleStatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchSectionsVisibleStatesMutation, Types.UpdateLaunchSectionsVisibleStatesMutationVariables>(UpdateLaunchSectionsVisibleStatesDocument, options);
      }
export type UpdateLaunchSectionsVisibleStatesMutationHookResult = ReturnType<typeof useUpdateLaunchSectionsVisibleStatesMutation>;
export type UpdateLaunchSectionsVisibleStatesMutationResult = Apollo.MutationResult<Types.UpdateLaunchSectionsVisibleStatesMutation>;
export type UpdateLaunchSectionsVisibleStatesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchSectionsVisibleStatesMutation, Types.UpdateLaunchSectionsVisibleStatesMutationVariables>;
export const LaunchForChannelsDocument = gql`
    query LaunchForChannels($id: String!) {
  launch(id: $id) {
    ...LaunchForChannels
  }
}
    ${LaunchForChannelsFragmentDoc}`;

/**
 * __useLaunchForChannelsQuery__
 *
 * To run a query within a React component, call `useLaunchForChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchForChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchForChannelsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchForChannelsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchForChannelsQuery, Types.LaunchForChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchForChannelsQuery, Types.LaunchForChannelsQueryVariables>(LaunchForChannelsDocument, options);
      }
export function useLaunchForChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchForChannelsQuery, Types.LaunchForChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchForChannelsQuery, Types.LaunchForChannelsQueryVariables>(LaunchForChannelsDocument, options);
        }
export type LaunchForChannelsQueryHookResult = ReturnType<typeof useLaunchForChannelsQuery>;
export type LaunchForChannelsLazyQueryHookResult = ReturnType<typeof useLaunchForChannelsLazyQuery>;
export type LaunchForChannelsQueryResult = Apollo.QueryResult<Types.LaunchForChannelsQuery, Types.LaunchForChannelsQueryVariables>;
export const LaunchForDisplayModuleDocument = gql`
    query LaunchForDisplayModule($id: String!, $sectionfilter: FilterLaunchSectionInput, $moduleFilter: FilterLaunchModuleInput) {
  launch(id: $id) {
    ...LaunchForDisplayModule
  }
}
    ${LaunchForDisplayModuleFragmentDoc}`;

/**
 * __useLaunchForDisplayModuleQuery__
 *
 * To run a query within a React component, call `useLaunchForDisplayModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchForDisplayModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchForDisplayModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sectionfilter: // value for 'sectionfilter'
 *      moduleFilter: // value for 'moduleFilter'
 *   },
 * });
 */
export function useLaunchForDisplayModuleQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchForDisplayModuleQuery, Types.LaunchForDisplayModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchForDisplayModuleQuery, Types.LaunchForDisplayModuleQueryVariables>(LaunchForDisplayModuleDocument, options);
      }
export function useLaunchForDisplayModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchForDisplayModuleQuery, Types.LaunchForDisplayModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchForDisplayModuleQuery, Types.LaunchForDisplayModuleQueryVariables>(LaunchForDisplayModuleDocument, options);
        }
export type LaunchForDisplayModuleQueryHookResult = ReturnType<typeof useLaunchForDisplayModuleQuery>;
export type LaunchForDisplayModuleLazyQueryHookResult = ReturnType<typeof useLaunchForDisplayModuleLazyQuery>;
export type LaunchForDisplayModuleQueryResult = Apollo.QueryResult<Types.LaunchForDisplayModuleQuery, Types.LaunchForDisplayModuleQueryVariables>;
export const LaunchInfoForModuleDocument = gql`
    query LaunchInfoForModule($id: String!) {
  launch(id: $id) {
    ...LaunchInfoForModule
  }
}
    ${LaunchInfoForModuleFragmentDoc}`;

/**
 * __useLaunchInfoForModuleQuery__
 *
 * To run a query within a React component, call `useLaunchInfoForModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchInfoForModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchInfoForModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchInfoForModuleQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchInfoForModuleQuery, Types.LaunchInfoForModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchInfoForModuleQuery, Types.LaunchInfoForModuleQueryVariables>(LaunchInfoForModuleDocument, options);
      }
export function useLaunchInfoForModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchInfoForModuleQuery, Types.LaunchInfoForModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchInfoForModuleQuery, Types.LaunchInfoForModuleQueryVariables>(LaunchInfoForModuleDocument, options);
        }
export type LaunchInfoForModuleQueryHookResult = ReturnType<typeof useLaunchInfoForModuleQuery>;
export type LaunchInfoForModuleLazyQueryHookResult = ReturnType<typeof useLaunchInfoForModuleLazyQuery>;
export type LaunchInfoForModuleQueryResult = Apollo.QueryResult<Types.LaunchInfoForModuleQuery, Types.LaunchInfoForModuleQueryVariables>;
export const LaunchModulesVisibleStatesDocument = gql`
    query LaunchModulesVisibleStates($id: String!, $sectionfilter: FilterLaunchSectionInput, $moduleFilter: FilterLaunchModuleInput) {
  launch(id: $id) {
    id
    name
    launchSections(filter: $sectionfilter) {
      id
      name
      hideModules
      launchModules(filter: $moduleFilter) {
        ...LaunchModulesVisibleStates
      }
    }
  }
}
    ${LaunchModulesVisibleStatesFragmentDoc}`;

/**
 * __useLaunchModulesVisibleStatesQuery__
 *
 * To run a query within a React component, call `useLaunchModulesVisibleStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchModulesVisibleStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchModulesVisibleStatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sectionfilter: // value for 'sectionfilter'
 *      moduleFilter: // value for 'moduleFilter'
 *   },
 * });
 */
export function useLaunchModulesVisibleStatesQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchModulesVisibleStatesQuery, Types.LaunchModulesVisibleStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchModulesVisibleStatesQuery, Types.LaunchModulesVisibleStatesQueryVariables>(LaunchModulesVisibleStatesDocument, options);
      }
export function useLaunchModulesVisibleStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchModulesVisibleStatesQuery, Types.LaunchModulesVisibleStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchModulesVisibleStatesQuery, Types.LaunchModulesVisibleStatesQueryVariables>(LaunchModulesVisibleStatesDocument, options);
        }
export type LaunchModulesVisibleStatesQueryHookResult = ReturnType<typeof useLaunchModulesVisibleStatesQuery>;
export type LaunchModulesVisibleStatesLazyQueryHookResult = ReturnType<typeof useLaunchModulesVisibleStatesLazyQuery>;
export type LaunchModulesVisibleStatesQueryResult = Apollo.QueryResult<Types.LaunchModulesVisibleStatesQuery, Types.LaunchModulesVisibleStatesQueryVariables>;
export const LaunchSectionsVisibleStatesDocument = gql`
    query LaunchSectionsVisibleStates($id: String!) {
  launch(id: $id) {
    ...LaunchSectionsVisibleStates
  }
}
    ${LaunchSectionsVisibleStatesFragmentDoc}`;

/**
 * __useLaunchSectionsVisibleStatesQuery__
 *
 * To run a query within a React component, call `useLaunchSectionsVisibleStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchSectionsVisibleStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchSectionsVisibleStatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchSectionsVisibleStatesQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchSectionsVisibleStatesQuery, Types.LaunchSectionsVisibleStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchSectionsVisibleStatesQuery, Types.LaunchSectionsVisibleStatesQueryVariables>(LaunchSectionsVisibleStatesDocument, options);
      }
export function useLaunchSectionsVisibleStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchSectionsVisibleStatesQuery, Types.LaunchSectionsVisibleStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchSectionsVisibleStatesQuery, Types.LaunchSectionsVisibleStatesQueryVariables>(LaunchSectionsVisibleStatesDocument, options);
        }
export type LaunchSectionsVisibleStatesQueryHookResult = ReturnType<typeof useLaunchSectionsVisibleStatesQuery>;
export type LaunchSectionsVisibleStatesLazyQueryHookResult = ReturnType<typeof useLaunchSectionsVisibleStatesLazyQuery>;
export type LaunchSectionsVisibleStatesQueryResult = Apollo.QueryResult<Types.LaunchSectionsVisibleStatesQuery, Types.LaunchSectionsVisibleStatesQueryVariables>;
export const PaginatedLaunchesForImportModuleDocument = gql`
    query PaginatedLaunchesForImportModule($pagination: PaginationInput = {page: 1, limit: 10}, $filter: FilterLaunchInput, $sort: SortLaunchInput, $sectionfilter: FilterLaunchSectionInput, $moduleFilter: FilterLaunchModuleInput) {
  paginatedLaunches(pagination: $pagination, filter: $filter, sort: $sort) {
    docs {
      ...LaunchForImortModule
    }
    page
    limit
    totalDocs
    totalPages
    hasNextPage
  }
}
    ${LaunchForImortModuleFragmentDoc}`;

/**
 * __usePaginatedLaunchesForImportModuleQuery__
 *
 * To run a query within a React component, call `usePaginatedLaunchesForImportModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedLaunchesForImportModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedLaunchesForImportModuleQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      sectionfilter: // value for 'sectionfilter'
 *      moduleFilter: // value for 'moduleFilter'
 *   },
 * });
 */
export function usePaginatedLaunchesForImportModuleQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedLaunchesForImportModuleQuery, Types.PaginatedLaunchesForImportModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedLaunchesForImportModuleQuery, Types.PaginatedLaunchesForImportModuleQueryVariables>(PaginatedLaunchesForImportModuleDocument, options);
      }
export function usePaginatedLaunchesForImportModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedLaunchesForImportModuleQuery, Types.PaginatedLaunchesForImportModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedLaunchesForImportModuleQuery, Types.PaginatedLaunchesForImportModuleQueryVariables>(PaginatedLaunchesForImportModuleDocument, options);
        }
export type PaginatedLaunchesForImportModuleQueryHookResult = ReturnType<typeof usePaginatedLaunchesForImportModuleQuery>;
export type PaginatedLaunchesForImportModuleLazyQueryHookResult = ReturnType<typeof usePaginatedLaunchesForImportModuleLazyQuery>;
export type PaginatedLaunchesForImportModuleQueryResult = Apollo.QueryResult<Types.PaginatedLaunchesForImportModuleQuery, Types.PaginatedLaunchesForImportModuleQueryVariables>;
export const RoadmapMenuOptionDataDocument = gql`
    query RoadmapMenuOptionData($input: ProductBoardRoadmapsInput) {
  productBoardRoadmaps(input: $input) {
    ...RoadmapMenuOptionData
  }
}
    ${RoadmapMenuOptionDataFragmentDoc}`;

/**
 * __useRoadmapMenuOptionDataQuery__
 *
 * To run a query within a React component, call `useRoadmapMenuOptionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadmapMenuOptionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadmapMenuOptionDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRoadmapMenuOptionDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.RoadmapMenuOptionDataQuery, Types.RoadmapMenuOptionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RoadmapMenuOptionDataQuery, Types.RoadmapMenuOptionDataQueryVariables>(RoadmapMenuOptionDataDocument, options);
      }
export function useRoadmapMenuOptionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RoadmapMenuOptionDataQuery, Types.RoadmapMenuOptionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RoadmapMenuOptionDataQuery, Types.RoadmapMenuOptionDataQueryVariables>(RoadmapMenuOptionDataDocument, options);
        }
export type RoadmapMenuOptionDataQueryHookResult = ReturnType<typeof useRoadmapMenuOptionDataQuery>;
export type RoadmapMenuOptionDataLazyQueryHookResult = ReturnType<typeof useRoadmapMenuOptionDataLazyQuery>;
export type RoadmapMenuOptionDataQueryResult = Apollo.QueryResult<Types.RoadmapMenuOptionDataQuery, Types.RoadmapMenuOptionDataQueryVariables>;
export const UpdateMessageLibraryDocument = gql`
    mutation UpdateMessageLibrary($input: UpdateMessagingLibraryInput!) {
  updateMessageLibrary(input: $input) {
    ...MessageLibrary
  }
}
    ${MessageLibraryFragmentDoc}`;
export type UpdateMessageLibraryMutationFn = Apollo.MutationFunction<Types.UpdateMessageLibraryMutation, Types.UpdateMessageLibraryMutationVariables>;

/**
 * __useUpdateMessageLibraryMutation__
 *
 * To run a mutation, you first call `useUpdateMessageLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageLibraryMutation, { data, loading, error }] = useUpdateMessageLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageLibraryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMessageLibraryMutation, Types.UpdateMessageLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMessageLibraryMutation, Types.UpdateMessageLibraryMutationVariables>(UpdateMessageLibraryDocument, options);
      }
export type UpdateMessageLibraryMutationHookResult = ReturnType<typeof useUpdateMessageLibraryMutation>;
export type UpdateMessageLibraryMutationResult = Apollo.MutationResult<Types.UpdateMessageLibraryMutation>;
export type UpdateMessageLibraryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMessageLibraryMutation, Types.UpdateMessageLibraryMutationVariables>;
export const MessagingLibrariesDocument = gql`
    query MessagingLibraries {
  messageLibraries {
    ...MessageLibrary
  }
}
    ${MessageLibraryFragmentDoc}`;

/**
 * __useMessagingLibrariesQuery__
 *
 * To run a query within a React component, call `useMessagingLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingLibrariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessagingLibrariesQuery(baseOptions?: Apollo.QueryHookOptions<Types.MessagingLibrariesQuery, Types.MessagingLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MessagingLibrariesQuery, Types.MessagingLibrariesQueryVariables>(MessagingLibrariesDocument, options);
      }
export function useMessagingLibrariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MessagingLibrariesQuery, Types.MessagingLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MessagingLibrariesQuery, Types.MessagingLibrariesQueryVariables>(MessagingLibrariesDocument, options);
        }
export type MessagingLibrariesQueryHookResult = ReturnType<typeof useMessagingLibrariesQuery>;
export type MessagingLibrariesLazyQueryHookResult = ReturnType<typeof useMessagingLibrariesLazyQuery>;
export type MessagingLibrariesQueryResult = Apollo.QueryResult<Types.MessagingLibrariesQuery, Types.MessagingLibrariesQueryVariables>;
export const AiContextualChatDocument = gql`
    mutation AiContextualChat($input: ContextualChatDto!) {
  contextualChat(input: $input)
}
    `;
export type AiContextualChatMutationFn = Apollo.MutationFunction<Types.AiContextualChatMutation, Types.AiContextualChatMutationVariables>;

/**
 * __useAiContextualChatMutation__
 *
 * To run a mutation, you first call `useAiContextualChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiContextualChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiContextualChatMutation, { data, loading, error }] = useAiContextualChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiContextualChatMutation(baseOptions?: Apollo.MutationHookOptions<Types.AiContextualChatMutation, Types.AiContextualChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AiContextualChatMutation, Types.AiContextualChatMutationVariables>(AiContextualChatDocument, options);
      }
export type AiContextualChatMutationHookResult = ReturnType<typeof useAiContextualChatMutation>;
export type AiContextualChatMutationResult = Apollo.MutationResult<Types.AiContextualChatMutation>;
export type AiContextualChatMutationOptions = Apollo.BaseMutationOptions<Types.AiContextualChatMutation, Types.AiContextualChatMutationVariables>;
export const DefaultCrmIntegrationStatusDocument = gql`
    query DefaultCrmIntegrationStatus {
  crmIntegrationStatus
}
    `;

/**
 * __useDefaultCrmIntegrationStatusQuery__
 *
 * To run a query within a React component, call `useDefaultCrmIntegrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultCrmIntegrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultCrmIntegrationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultCrmIntegrationStatusQuery(baseOptions?: Apollo.QueryHookOptions<Types.DefaultCrmIntegrationStatusQuery, Types.DefaultCrmIntegrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DefaultCrmIntegrationStatusQuery, Types.DefaultCrmIntegrationStatusQueryVariables>(DefaultCrmIntegrationStatusDocument, options);
      }
export function useDefaultCrmIntegrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DefaultCrmIntegrationStatusQuery, Types.DefaultCrmIntegrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DefaultCrmIntegrationStatusQuery, Types.DefaultCrmIntegrationStatusQueryVariables>(DefaultCrmIntegrationStatusDocument, options);
        }
export type DefaultCrmIntegrationStatusQueryHookResult = ReturnType<typeof useDefaultCrmIntegrationStatusQuery>;
export type DefaultCrmIntegrationStatusLazyQueryHookResult = ReturnType<typeof useDefaultCrmIntegrationStatusLazyQuery>;
export type DefaultCrmIntegrationStatusQueryResult = Apollo.QueryResult<Types.DefaultCrmIntegrationStatusQuery, Types.DefaultCrmIntegrationStatusQueryVariables>;
export const ProductGapsCrmIntegrationStatusDocument = gql`
    query ProductGapsCrmIntegrationStatus {
  productGapsIntegrationStatus
}
    `;

/**
 * __useProductGapsCrmIntegrationStatusQuery__
 *
 * To run a query within a React component, call `useProductGapsCrmIntegrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGapsCrmIntegrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGapsCrmIntegrationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductGapsCrmIntegrationStatusQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductGapsCrmIntegrationStatusQuery, Types.ProductGapsCrmIntegrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductGapsCrmIntegrationStatusQuery, Types.ProductGapsCrmIntegrationStatusQueryVariables>(ProductGapsCrmIntegrationStatusDocument, options);
      }
export function useProductGapsCrmIntegrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductGapsCrmIntegrationStatusQuery, Types.ProductGapsCrmIntegrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductGapsCrmIntegrationStatusQuery, Types.ProductGapsCrmIntegrationStatusQueryVariables>(ProductGapsCrmIntegrationStatusDocument, options);
        }
export type ProductGapsCrmIntegrationStatusQueryHookResult = ReturnType<typeof useProductGapsCrmIntegrationStatusQuery>;
export type ProductGapsCrmIntegrationStatusLazyQueryHookResult = ReturnType<typeof useProductGapsCrmIntegrationStatusLazyQuery>;
export type ProductGapsCrmIntegrationStatusQueryResult = Apollo.QueryResult<Types.ProductGapsCrmIntegrationStatusQuery, Types.ProductGapsCrmIntegrationStatusQueryVariables>;
export const WinLossCrmIntegrationStatusDocument = gql`
    query WinLossCrmIntegrationStatus {
  winLossIntegrationStatus
}
    `;

/**
 * __useWinLossCrmIntegrationStatusQuery__
 *
 * To run a query within a React component, call `useWinLossCrmIntegrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWinLossCrmIntegrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWinLossCrmIntegrationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useWinLossCrmIntegrationStatusQuery(baseOptions?: Apollo.QueryHookOptions<Types.WinLossCrmIntegrationStatusQuery, Types.WinLossCrmIntegrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.WinLossCrmIntegrationStatusQuery, Types.WinLossCrmIntegrationStatusQueryVariables>(WinLossCrmIntegrationStatusDocument, options);
      }
export function useWinLossCrmIntegrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.WinLossCrmIntegrationStatusQuery, Types.WinLossCrmIntegrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.WinLossCrmIntegrationStatusQuery, Types.WinLossCrmIntegrationStatusQueryVariables>(WinLossCrmIntegrationStatusDocument, options);
        }
export type WinLossCrmIntegrationStatusQueryHookResult = ReturnType<typeof useWinLossCrmIntegrationStatusQuery>;
export type WinLossCrmIntegrationStatusLazyQueryHookResult = ReturnType<typeof useWinLossCrmIntegrationStatusLazyQuery>;
export type WinLossCrmIntegrationStatusQueryResult = Apollo.QueryResult<Types.WinLossCrmIntegrationStatusQuery, Types.WinLossCrmIntegrationStatusQueryVariables>;
export const GetEditAccessDocument = gql`
    mutation GetEditAccess {
  getEditAccess
}
    `;
export type GetEditAccessMutationFn = Apollo.MutationFunction<Types.GetEditAccessMutation, Types.GetEditAccessMutationVariables>;

/**
 * __useGetEditAccessMutation__
 *
 * To run a mutation, you first call `useGetEditAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEditAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEditAccessMutation, { data, loading, error }] = useGetEditAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetEditAccessMutation(baseOptions?: Apollo.MutationHookOptions<Types.GetEditAccessMutation, Types.GetEditAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GetEditAccessMutation, Types.GetEditAccessMutationVariables>(GetEditAccessDocument, options);
      }
export type GetEditAccessMutationHookResult = ReturnType<typeof useGetEditAccessMutation>;
export type GetEditAccessMutationResult = Apollo.MutationResult<Types.GetEditAccessMutation>;
export type GetEditAccessMutationOptions = Apollo.BaseMutationOptions<Types.GetEditAccessMutation, Types.GetEditAccessMutationVariables>;
export const CopyPersonaDocument = gql`
    mutation CopyPersona($input: CopyPersonaInput!) {
  copyPersona(input: $input) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;
export type CopyPersonaMutationFn = Apollo.MutationFunction<Types.CopyPersonaMutation, Types.CopyPersonaMutationVariables>;

/**
 * __useCopyPersonaMutation__
 *
 * To run a mutation, you first call `useCopyPersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPersonaMutation, { data, loading, error }] = useCopyPersonaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyPersonaMutation(baseOptions?: Apollo.MutationHookOptions<Types.CopyPersonaMutation, Types.CopyPersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CopyPersonaMutation, Types.CopyPersonaMutationVariables>(CopyPersonaDocument, options);
      }
export type CopyPersonaMutationHookResult = ReturnType<typeof useCopyPersonaMutation>;
export type CopyPersonaMutationResult = Apollo.MutationResult<Types.CopyPersonaMutation>;
export type CopyPersonaMutationOptions = Apollo.BaseMutationOptions<Types.CopyPersonaMutation, Types.CopyPersonaMutationVariables>;
export const CreatePersonaDocument = gql`
    mutation CreatePersona($input: CreatePersonaInput) {
  createPersona(input: $input) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;
export type CreatePersonaMutationFn = Apollo.MutationFunction<Types.CreatePersonaMutation, Types.CreatePersonaMutationVariables>;

/**
 * __useCreatePersonaMutation__
 *
 * To run a mutation, you first call `useCreatePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonaMutation, { data, loading, error }] = useCreatePersonaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePersonaMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePersonaMutation, Types.CreatePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePersonaMutation, Types.CreatePersonaMutationVariables>(CreatePersonaDocument, options);
      }
export type CreatePersonaMutationHookResult = ReturnType<typeof useCreatePersonaMutation>;
export type CreatePersonaMutationResult = Apollo.MutationResult<Types.CreatePersonaMutation>;
export type CreatePersonaMutationOptions = Apollo.BaseMutationOptions<Types.CreatePersonaMutation, Types.CreatePersonaMutationVariables>;
export const CreatePersonaDemographicsCategoryDocument = gql`
    mutation CreatePersonaDemographicsCategory($input: CreatePersonaDemographicsCategoryInput!) {
  createPersonaDemographicsCategory(input: $input) {
    ...PersonaDemographicsCategory
  }
}
    ${PersonaDemographicsCategoryFragmentDoc}`;
export type CreatePersonaDemographicsCategoryMutationFn = Apollo.MutationFunction<Types.CreatePersonaDemographicsCategoryMutation, Types.CreatePersonaDemographicsCategoryMutationVariables>;

/**
 * __useCreatePersonaDemographicsCategoryMutation__
 *
 * To run a mutation, you first call `useCreatePersonaDemographicsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonaDemographicsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonaDemographicsCategoryMutation, { data, loading, error }] = useCreatePersonaDemographicsCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePersonaDemographicsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePersonaDemographicsCategoryMutation, Types.CreatePersonaDemographicsCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePersonaDemographicsCategoryMutation, Types.CreatePersonaDemographicsCategoryMutationVariables>(CreatePersonaDemographicsCategoryDocument, options);
      }
export type CreatePersonaDemographicsCategoryMutationHookResult = ReturnType<typeof useCreatePersonaDemographicsCategoryMutation>;
export type CreatePersonaDemographicsCategoryMutationResult = Apollo.MutationResult<Types.CreatePersonaDemographicsCategoryMutation>;
export type CreatePersonaDemographicsCategoryMutationOptions = Apollo.BaseMutationOptions<Types.CreatePersonaDemographicsCategoryMutation, Types.CreatePersonaDemographicsCategoryMutationVariables>;
export const CreatePersonaNoteDocument = gql`
    mutation CreatePersonaNote($input: CreatePersonaNoteInput!) {
  createPersonaNote(input: $input) {
    ...PersonaNote
  }
}
    ${PersonaNoteFragmentDoc}`;
export type CreatePersonaNoteMutationFn = Apollo.MutationFunction<Types.CreatePersonaNoteMutation, Types.CreatePersonaNoteMutationVariables>;

/**
 * __useCreatePersonaNoteMutation__
 *
 * To run a mutation, you first call `useCreatePersonaNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonaNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonaNoteMutation, { data, loading, error }] = useCreatePersonaNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePersonaNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePersonaNoteMutation, Types.CreatePersonaNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePersonaNoteMutation, Types.CreatePersonaNoteMutationVariables>(CreatePersonaNoteDocument, options);
      }
export type CreatePersonaNoteMutationHookResult = ReturnType<typeof useCreatePersonaNoteMutation>;
export type CreatePersonaNoteMutationResult = Apollo.MutationResult<Types.CreatePersonaNoteMutation>;
export type CreatePersonaNoteMutationOptions = Apollo.BaseMutationOptions<Types.CreatePersonaNoteMutation, Types.CreatePersonaNoteMutationVariables>;
export const DeletePersonaDocument = gql`
    mutation DeletePersona($input: DeletePersonaInput!) {
  deletePersona(input: $input) {
    id
  }
}
    `;
export type DeletePersonaMutationFn = Apollo.MutationFunction<Types.DeletePersonaMutation, Types.DeletePersonaMutationVariables>;

/**
 * __useDeletePersonaMutation__
 *
 * To run a mutation, you first call `useDeletePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonaMutation, { data, loading, error }] = useDeletePersonaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePersonaMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePersonaMutation, Types.DeletePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePersonaMutation, Types.DeletePersonaMutationVariables>(DeletePersonaDocument, options);
      }
export type DeletePersonaMutationHookResult = ReturnType<typeof useDeletePersonaMutation>;
export type DeletePersonaMutationResult = Apollo.MutationResult<Types.DeletePersonaMutation>;
export type DeletePersonaMutationOptions = Apollo.BaseMutationOptions<Types.DeletePersonaMutation, Types.DeletePersonaMutationVariables>;
export const DeletePersonaDemographicsCategoryDocument = gql`
    mutation DeletePersonaDemographicsCategory($input: DeletePersonaDemographicsCategoryInput!) {
  deletePersonaDemographicsCategory(input: $input) {
    id
  }
}
    `;
export type DeletePersonaDemographicsCategoryMutationFn = Apollo.MutationFunction<Types.DeletePersonaDemographicsCategoryMutation, Types.DeletePersonaDemographicsCategoryMutationVariables>;

/**
 * __useDeletePersonaDemographicsCategoryMutation__
 *
 * To run a mutation, you first call `useDeletePersonaDemographicsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonaDemographicsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonaDemographicsCategoryMutation, { data, loading, error }] = useDeletePersonaDemographicsCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePersonaDemographicsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePersonaDemographicsCategoryMutation, Types.DeletePersonaDemographicsCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePersonaDemographicsCategoryMutation, Types.DeletePersonaDemographicsCategoryMutationVariables>(DeletePersonaDemographicsCategoryDocument, options);
      }
export type DeletePersonaDemographicsCategoryMutationHookResult = ReturnType<typeof useDeletePersonaDemographicsCategoryMutation>;
export type DeletePersonaDemographicsCategoryMutationResult = Apollo.MutationResult<Types.DeletePersonaDemographicsCategoryMutation>;
export type DeletePersonaDemographicsCategoryMutationOptions = Apollo.BaseMutationOptions<Types.DeletePersonaDemographicsCategoryMutation, Types.DeletePersonaDemographicsCategoryMutationVariables>;
export const DeletePersonaNoteDocument = gql`
    mutation DeletePersonaNote($input: DeletePersonaNoteInput!) {
  deletePersonaNote(input: $input) {
    id
  }
}
    `;
export type DeletePersonaNoteMutationFn = Apollo.MutationFunction<Types.DeletePersonaNoteMutation, Types.DeletePersonaNoteMutationVariables>;

/**
 * __useDeletePersonaNoteMutation__
 *
 * To run a mutation, you first call `useDeletePersonaNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonaNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonaNoteMutation, { data, loading, error }] = useDeletePersonaNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePersonaNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePersonaNoteMutation, Types.DeletePersonaNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePersonaNoteMutation, Types.DeletePersonaNoteMutationVariables>(DeletePersonaNoteDocument, options);
      }
export type DeletePersonaNoteMutationHookResult = ReturnType<typeof useDeletePersonaNoteMutation>;
export type DeletePersonaNoteMutationResult = Apollo.MutationResult<Types.DeletePersonaNoteMutation>;
export type DeletePersonaNoteMutationOptions = Apollo.BaseMutationOptions<Types.DeletePersonaNoteMutation, Types.DeletePersonaNoteMutationVariables>;
export const GeneratePersonaDocument = gql`
    mutation GeneratePersona($input: GeneratePersonaInfoInput!) {
  generatePersonaInfo(input: $input) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;
export type GeneratePersonaMutationFn = Apollo.MutationFunction<Types.GeneratePersonaMutation, Types.GeneratePersonaMutationVariables>;

/**
 * __useGeneratePersonaMutation__
 *
 * To run a mutation, you first call `useGeneratePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePersonaMutation, { data, loading, error }] = useGeneratePersonaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePersonaMutation(baseOptions?: Apollo.MutationHookOptions<Types.GeneratePersonaMutation, Types.GeneratePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GeneratePersonaMutation, Types.GeneratePersonaMutationVariables>(GeneratePersonaDocument, options);
      }
export type GeneratePersonaMutationHookResult = ReturnType<typeof useGeneratePersonaMutation>;
export type GeneratePersonaMutationResult = Apollo.MutationResult<Types.GeneratePersonaMutation>;
export type GeneratePersonaMutationOptions = Apollo.BaseMutationOptions<Types.GeneratePersonaMutation, Types.GeneratePersonaMutationVariables>;
export const UpdatePersonaDocument = gql`
    mutation UpdatePersona($input: UpdatePersonaInput!) {
  updatePersona(input: $input) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;
export type UpdatePersonaMutationFn = Apollo.MutationFunction<Types.UpdatePersonaMutation, Types.UpdatePersonaMutationVariables>;

/**
 * __useUpdatePersonaMutation__
 *
 * To run a mutation, you first call `useUpdatePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonaMutation, { data, loading, error }] = useUpdatePersonaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonaMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePersonaMutation, Types.UpdatePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePersonaMutation, Types.UpdatePersonaMutationVariables>(UpdatePersonaDocument, options);
      }
export type UpdatePersonaMutationHookResult = ReturnType<typeof useUpdatePersonaMutation>;
export type UpdatePersonaMutationResult = Apollo.MutationResult<Types.UpdatePersonaMutation>;
export type UpdatePersonaMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePersonaMutation, Types.UpdatePersonaMutationVariables>;
export const UpdatePersonaDemographicsCategoryDocument = gql`
    mutation UpdatePersonaDemographicsCategory($input: UpdatePersonaDemographicsCategoryInput!) {
  updatePersonaDemographicsCategory(input: $input) {
    ...PersonaDemographicsCategory
  }
}
    ${PersonaDemographicsCategoryFragmentDoc}`;
export type UpdatePersonaDemographicsCategoryMutationFn = Apollo.MutationFunction<Types.UpdatePersonaDemographicsCategoryMutation, Types.UpdatePersonaDemographicsCategoryMutationVariables>;

/**
 * __useUpdatePersonaDemographicsCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePersonaDemographicsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonaDemographicsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonaDemographicsCategoryMutation, { data, loading, error }] = useUpdatePersonaDemographicsCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonaDemographicsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePersonaDemographicsCategoryMutation, Types.UpdatePersonaDemographicsCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePersonaDemographicsCategoryMutation, Types.UpdatePersonaDemographicsCategoryMutationVariables>(UpdatePersonaDemographicsCategoryDocument, options);
      }
export type UpdatePersonaDemographicsCategoryMutationHookResult = ReturnType<typeof useUpdatePersonaDemographicsCategoryMutation>;
export type UpdatePersonaDemographicsCategoryMutationResult = Apollo.MutationResult<Types.UpdatePersonaDemographicsCategoryMutation>;
export type UpdatePersonaDemographicsCategoryMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePersonaDemographicsCategoryMutation, Types.UpdatePersonaDemographicsCategoryMutationVariables>;
export const UpdatePersonaInfoDocument = gql`
    mutation UpdatePersonaInfo($input: UpdatePersonaInput!) {
  updatePersona(input: $input) {
    ...PersonaInfo
  }
}
    ${PersonaInfoFragmentDoc}`;
export type UpdatePersonaInfoMutationFn = Apollo.MutationFunction<Types.UpdatePersonaInfoMutation, Types.UpdatePersonaInfoMutationVariables>;

/**
 * __useUpdatePersonaInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePersonaInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonaInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonaInfoMutation, { data, loading, error }] = useUpdatePersonaInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonaInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePersonaInfoMutation, Types.UpdatePersonaInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePersonaInfoMutation, Types.UpdatePersonaInfoMutationVariables>(UpdatePersonaInfoDocument, options);
      }
export type UpdatePersonaInfoMutationHookResult = ReturnType<typeof useUpdatePersonaInfoMutation>;
export type UpdatePersonaInfoMutationResult = Apollo.MutationResult<Types.UpdatePersonaInfoMutation>;
export type UpdatePersonaInfoMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePersonaInfoMutation, Types.UpdatePersonaInfoMutationVariables>;
export const UpdatePersonaNoteDocument = gql`
    mutation UpdatePersonaNote($input: UpdatePersonaNoteInput!) {
  updatePersonaNote(input: $input) {
    ...PersonaNote
  }
}
    ${PersonaNoteFragmentDoc}`;
export type UpdatePersonaNoteMutationFn = Apollo.MutationFunction<Types.UpdatePersonaNoteMutation, Types.UpdatePersonaNoteMutationVariables>;

/**
 * __useUpdatePersonaNoteMutation__
 *
 * To run a mutation, you first call `useUpdatePersonaNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonaNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonaNoteMutation, { data, loading, error }] = useUpdatePersonaNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonaNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePersonaNoteMutation, Types.UpdatePersonaNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePersonaNoteMutation, Types.UpdatePersonaNoteMutationVariables>(UpdatePersonaNoteDocument, options);
      }
export type UpdatePersonaNoteMutationHookResult = ReturnType<typeof useUpdatePersonaNoteMutation>;
export type UpdatePersonaNoteMutationResult = Apollo.MutationResult<Types.UpdatePersonaNoteMutation>;
export type UpdatePersonaNoteMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePersonaNoteMutation, Types.UpdatePersonaNoteMutationVariables>;
export const CountPersonasDocument = gql`
    query CountPersonas($input: PersonasInput) {
  countPersonas(input: $input)
}
    `;

/**
 * __useCountPersonasQuery__
 *
 * To run a query within a React component, call `useCountPersonasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPersonasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPersonasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCountPersonasQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountPersonasQuery, Types.CountPersonasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountPersonasQuery, Types.CountPersonasQueryVariables>(CountPersonasDocument, options);
      }
export function useCountPersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountPersonasQuery, Types.CountPersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountPersonasQuery, Types.CountPersonasQueryVariables>(CountPersonasDocument, options);
        }
export type CountPersonasQueryHookResult = ReturnType<typeof useCountPersonasQuery>;
export type CountPersonasLazyQueryHookResult = ReturnType<typeof useCountPersonasLazyQuery>;
export type CountPersonasQueryResult = Apollo.QueryResult<Types.CountPersonasQuery, Types.CountPersonasQueryVariables>;
export const PaginatedPersonasForCopyDocument = gql`
    query PaginatedPersonasForCopy($input: PaginatedPersonasInput!) {
  paginatedPersonas(input: $input) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...PersonaForCopy
    }
  }
}
    ${PersonaForCopyFragmentDoc}`;

/**
 * __usePaginatedPersonasForCopyQuery__
 *
 * To run a query within a React component, call `usePaginatedPersonasForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedPersonasForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedPersonasForCopyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedPersonasForCopyQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedPersonasForCopyQuery, Types.PaginatedPersonasForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedPersonasForCopyQuery, Types.PaginatedPersonasForCopyQueryVariables>(PaginatedPersonasForCopyDocument, options);
      }
export function usePaginatedPersonasForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedPersonasForCopyQuery, Types.PaginatedPersonasForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedPersonasForCopyQuery, Types.PaginatedPersonasForCopyQueryVariables>(PaginatedPersonasForCopyDocument, options);
        }
export type PaginatedPersonasForCopyQueryHookResult = ReturnType<typeof usePaginatedPersonasForCopyQuery>;
export type PaginatedPersonasForCopyLazyQueryHookResult = ReturnType<typeof usePaginatedPersonasForCopyLazyQuery>;
export type PaginatedPersonasForCopyQueryResult = Apollo.QueryResult<Types.PaginatedPersonasForCopyQuery, Types.PaginatedPersonasForCopyQueryVariables>;
export const PaginatedPersonasInfoDocument = gql`
    query PaginatedPersonasInfo($input: PaginatedPersonasInput!) {
  paginatedPersonas(input: $input) {
    totalPages
    totalDocs
    docs {
      ...PersonaInfo
    }
  }
}
    ${PersonaInfoFragmentDoc}`;

/**
 * __usePaginatedPersonasInfoQuery__
 *
 * To run a query within a React component, call `usePaginatedPersonasInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedPersonasInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedPersonasInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedPersonasInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedPersonasInfoQuery, Types.PaginatedPersonasInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedPersonasInfoQuery, Types.PaginatedPersonasInfoQueryVariables>(PaginatedPersonasInfoDocument, options);
      }
export function usePaginatedPersonasInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedPersonasInfoQuery, Types.PaginatedPersonasInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedPersonasInfoQuery, Types.PaginatedPersonasInfoQueryVariables>(PaginatedPersonasInfoDocument, options);
        }
export type PaginatedPersonasInfoQueryHookResult = ReturnType<typeof usePaginatedPersonasInfoQuery>;
export type PaginatedPersonasInfoLazyQueryHookResult = ReturnType<typeof usePaginatedPersonasInfoLazyQuery>;
export type PaginatedPersonasInfoQueryResult = Apollo.QueryResult<Types.PaginatedPersonasInfoQuery, Types.PaginatedPersonasInfoQueryVariables>;
export const PersonaDocument = gql`
    query Persona($input: PersonaInput!) {
  persona(input: $input) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;

/**
 * __usePersonaQuery__
 *
 * To run a query within a React component, call `usePersonaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonaQuery(baseOptions: Apollo.QueryHookOptions<Types.PersonaQuery, Types.PersonaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PersonaQuery, Types.PersonaQueryVariables>(PersonaDocument, options);
      }
export function usePersonaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PersonaQuery, Types.PersonaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PersonaQuery, Types.PersonaQueryVariables>(PersonaDocument, options);
        }
export type PersonaQueryHookResult = ReturnType<typeof usePersonaQuery>;
export type PersonaLazyQueryHookResult = ReturnType<typeof usePersonaLazyQuery>;
export type PersonaQueryResult = Apollo.QueryResult<Types.PersonaQuery, Types.PersonaQueryVariables>;
export const PersonaInfoDocument = gql`
    query PersonaInfo($input: PersonaInput!) {
  persona(input: $input) {
    ...PersonaInfo
  }
}
    ${PersonaInfoFragmentDoc}`;

/**
 * __usePersonaInfoQuery__
 *
 * To run a query within a React component, call `usePersonaInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonaInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonaInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonaInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.PersonaInfoQuery, Types.PersonaInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PersonaInfoQuery, Types.PersonaInfoQueryVariables>(PersonaInfoDocument, options);
      }
export function usePersonaInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PersonaInfoQuery, Types.PersonaInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PersonaInfoQuery, Types.PersonaInfoQueryVariables>(PersonaInfoDocument, options);
        }
export type PersonaInfoQueryHookResult = ReturnType<typeof usePersonaInfoQuery>;
export type PersonaInfoLazyQueryHookResult = ReturnType<typeof usePersonaInfoLazyQuery>;
export type PersonaInfoQueryResult = Apollo.QueryResult<Types.PersonaInfoQuery, Types.PersonaInfoQueryVariables>;
export const PersonasDocument = gql`
    query Personas($input: PersonasInput!) {
  personas(input: $input) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;

/**
 * __usePersonasQuery__
 *
 * To run a query within a React component, call `usePersonasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonasQuery(baseOptions: Apollo.QueryHookOptions<Types.PersonasQuery, Types.PersonasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PersonasQuery, Types.PersonasQueryVariables>(PersonasDocument, options);
      }
export function usePersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PersonasQuery, Types.PersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PersonasQuery, Types.PersonasQueryVariables>(PersonasDocument, options);
        }
export type PersonasQueryHookResult = ReturnType<typeof usePersonasQuery>;
export type PersonasLazyQueryHookResult = ReturnType<typeof usePersonasLazyQuery>;
export type PersonasQueryResult = Apollo.QueryResult<Types.PersonasQuery, Types.PersonasQueryVariables>;
export const PersonasInfoDocument = gql`
    query PersonasInfo($input: PersonasInput!) {
  personas(input: $input) {
    ...PersonaInfo
  }
}
    ${PersonaInfoFragmentDoc}`;

/**
 * __usePersonasInfoQuery__
 *
 * To run a query within a React component, call `usePersonasInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonasInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonasInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonasInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.PersonasInfoQuery, Types.PersonasInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PersonasInfoQuery, Types.PersonasInfoQueryVariables>(PersonasInfoDocument, options);
      }
export function usePersonasInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PersonasInfoQuery, Types.PersonasInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PersonasInfoQuery, Types.PersonasInfoQueryVariables>(PersonasInfoDocument, options);
        }
export type PersonasInfoQueryHookResult = ReturnType<typeof usePersonasInfoQuery>;
export type PersonasInfoLazyQueryHookResult = ReturnType<typeof usePersonasInfoLazyQuery>;
export type PersonasInfoQueryResult = Apollo.QueryResult<Types.PersonasInfoQuery, Types.PersonasInfoQueryVariables>;
export const PublicLaunchPagePersonasDocument = gql`
    query PublicLaunchPagePersonas($input: PersonasInput!) {
  publicLaunchPagePersonas(input: $input) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;

/**
 * __usePublicLaunchPagePersonasQuery__
 *
 * To run a query within a React component, call `usePublicLaunchPagePersonasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchPagePersonasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchPagePersonasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicLaunchPagePersonasQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicLaunchPagePersonasQuery, Types.PublicLaunchPagePersonasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchPagePersonasQuery, Types.PublicLaunchPagePersonasQueryVariables>(PublicLaunchPagePersonasDocument, options);
      }
export function usePublicLaunchPagePersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchPagePersonasQuery, Types.PublicLaunchPagePersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchPagePersonasQuery, Types.PublicLaunchPagePersonasQueryVariables>(PublicLaunchPagePersonasDocument, options);
        }
export type PublicLaunchPagePersonasQueryHookResult = ReturnType<typeof usePublicLaunchPagePersonasQuery>;
export type PublicLaunchPagePersonasLazyQueryHookResult = ReturnType<typeof usePublicLaunchPagePersonasLazyQuery>;
export type PublicLaunchPagePersonasQueryResult = Apollo.QueryResult<Types.PublicLaunchPagePersonasQuery, Types.PublicLaunchPagePersonasQueryVariables>;
export const DuplicateProductBoardItemTableRowDocument = gql`
    mutation DuplicateProductBoardItemTableRow($id: String!) {
  duplicateProductBoardItem(id: $id) {
    ...ProductBoardItemTableRow
  }
}
    ${ProductBoardItemTableRowFragmentDoc}`;
export type DuplicateProductBoardItemTableRowMutationFn = Apollo.MutationFunction<Types.DuplicateProductBoardItemTableRowMutation, Types.DuplicateProductBoardItemTableRowMutationVariables>;

/**
 * __useDuplicateProductBoardItemTableRowMutation__
 *
 * To run a mutation, you first call `useDuplicateProductBoardItemTableRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProductBoardItemTableRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProductBoardItemTableRowMutation, { data, loading, error }] = useDuplicateProductBoardItemTableRowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateProductBoardItemTableRowMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateProductBoardItemTableRowMutation, Types.DuplicateProductBoardItemTableRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateProductBoardItemTableRowMutation, Types.DuplicateProductBoardItemTableRowMutationVariables>(DuplicateProductBoardItemTableRowDocument, options);
      }
export type DuplicateProductBoardItemTableRowMutationHookResult = ReturnType<typeof useDuplicateProductBoardItemTableRowMutation>;
export type DuplicateProductBoardItemTableRowMutationResult = Apollo.MutationResult<Types.DuplicateProductBoardItemTableRowMutation>;
export type DuplicateProductBoardItemTableRowMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateProductBoardItemTableRowMutation, Types.DuplicateProductBoardItemTableRowMutationVariables>;
export const PaginatedProductBoardItemsForCopyDocument = gql`
    query PaginatedProductBoardItemsForCopy($filter: ProductBoardItemsFilterInput, $pagination: PaginationInput, $sort: ProductBoardItemsSortInput) {
  paginatedProductBoardItems(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    page
    limit
    totalPages
    totalDocs
    docs {
      ...ProductBoardItemForCopy
    }
  }
}
    ${ProductBoardItemForCopyFragmentDoc}`;

/**
 * __usePaginatedProductBoardItemsForCopyQuery__
 *
 * To run a query within a React component, call `usePaginatedProductBoardItemsForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProductBoardItemsForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProductBoardItemsForCopyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedProductBoardItemsForCopyQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedProductBoardItemsForCopyQuery, Types.PaginatedProductBoardItemsForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedProductBoardItemsForCopyQuery, Types.PaginatedProductBoardItemsForCopyQueryVariables>(PaginatedProductBoardItemsForCopyDocument, options);
      }
export function usePaginatedProductBoardItemsForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedProductBoardItemsForCopyQuery, Types.PaginatedProductBoardItemsForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedProductBoardItemsForCopyQuery, Types.PaginatedProductBoardItemsForCopyQueryVariables>(PaginatedProductBoardItemsForCopyDocument, options);
        }
export type PaginatedProductBoardItemsForCopyQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsForCopyQuery>;
export type PaginatedProductBoardItemsForCopyLazyQueryHookResult = ReturnType<typeof usePaginatedProductBoardItemsForCopyLazyQuery>;
export type PaginatedProductBoardItemsForCopyQueryResult = Apollo.QueryResult<Types.PaginatedProductBoardItemsForCopyQuery, Types.PaginatedProductBoardItemsForCopyQueryVariables>;
export const DeleteProductIdeaDocument = gql`
    mutation DeleteProductIdea($id: String!) {
  deleteProductIdea: deleteFeedbackPostAsAdmin(id: $id) {
    id
  }
}
    `;
export type DeleteProductIdeaMutationFn = Apollo.MutationFunction<Types.DeleteProductIdeaMutation, Types.DeleteProductIdeaMutationVariables>;

/**
 * __useDeleteProductIdeaMutation__
 *
 * To run a mutation, you first call `useDeleteProductIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductIdeaMutation, { data, loading, error }] = useDeleteProductIdeaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductIdeaMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductIdeaMutation, Types.DeleteProductIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductIdeaMutation, Types.DeleteProductIdeaMutationVariables>(DeleteProductIdeaDocument, options);
      }
export type DeleteProductIdeaMutationHookResult = ReturnType<typeof useDeleteProductIdeaMutation>;
export type DeleteProductIdeaMutationResult = Apollo.MutationResult<Types.DeleteProductIdeaMutation>;
export type DeleteProductIdeaMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductIdeaMutation, Types.DeleteProductIdeaMutationVariables>;
export const CreatePublicPageDocument = gql`
    mutation CreatePublicPage($input: CreatePublicPageInput!) {
  createPublicPage(input: $input) {
    ...PublicPage
  }
}
    ${PublicPageFragmentDoc}`;
export type CreatePublicPageMutationFn = Apollo.MutationFunction<Types.CreatePublicPageMutation, Types.CreatePublicPageMutationVariables>;

/**
 * __useCreatePublicPageMutation__
 *
 * To run a mutation, you first call `useCreatePublicPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicPageMutation, { data, loading, error }] = useCreatePublicPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePublicPageMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePublicPageMutation, Types.CreatePublicPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePublicPageMutation, Types.CreatePublicPageMutationVariables>(CreatePublicPageDocument, options);
      }
export type CreatePublicPageMutationHookResult = ReturnType<typeof useCreatePublicPageMutation>;
export type CreatePublicPageMutationResult = Apollo.MutationResult<Types.CreatePublicPageMutation>;
export type CreatePublicPageMutationOptions = Apollo.BaseMutationOptions<Types.CreatePublicPageMutation, Types.CreatePublicPageMutationVariables>;
export const DeletePublicPageDocument = gql`
    mutation DeletePublicPage($id: String!) {
  deletePublicPage(id: $id) {
    ...PublicPage
  }
}
    ${PublicPageFragmentDoc}`;
export type DeletePublicPageMutationFn = Apollo.MutationFunction<Types.DeletePublicPageMutation, Types.DeletePublicPageMutationVariables>;

/**
 * __useDeletePublicPageMutation__
 *
 * To run a mutation, you first call `useDeletePublicPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePublicPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePublicPageMutation, { data, loading, error }] = useDeletePublicPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePublicPageMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePublicPageMutation, Types.DeletePublicPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePublicPageMutation, Types.DeletePublicPageMutationVariables>(DeletePublicPageDocument, options);
      }
export type DeletePublicPageMutationHookResult = ReturnType<typeof useDeletePublicPageMutation>;
export type DeletePublicPageMutationResult = Apollo.MutationResult<Types.DeletePublicPageMutation>;
export type DeletePublicPageMutationOptions = Apollo.BaseMutationOptions<Types.DeletePublicPageMutation, Types.DeletePublicPageMutationVariables>;
export const UpdatePublicFeedbackBoardDocument = gql`
    mutation UpdatePublicFeedbackBoard($input: UpdateFeedbackBoardInput!) {
  updateFeedbackBoard(input: $input) {
    ...PublicFeedbackBoard
  }
}
    ${PublicFeedbackBoardFragmentDoc}`;
export type UpdatePublicFeedbackBoardMutationFn = Apollo.MutationFunction<Types.UpdatePublicFeedbackBoardMutation, Types.UpdatePublicFeedbackBoardMutationVariables>;

/**
 * __useUpdatePublicFeedbackBoardMutation__
 *
 * To run a mutation, you first call `useUpdatePublicFeedbackBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicFeedbackBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicFeedbackBoardMutation, { data, loading, error }] = useUpdatePublicFeedbackBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePublicFeedbackBoardMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePublicFeedbackBoardMutation, Types.UpdatePublicFeedbackBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePublicFeedbackBoardMutation, Types.UpdatePublicFeedbackBoardMutationVariables>(UpdatePublicFeedbackBoardDocument, options);
      }
export type UpdatePublicFeedbackBoardMutationHookResult = ReturnType<typeof useUpdatePublicFeedbackBoardMutation>;
export type UpdatePublicFeedbackBoardMutationResult = Apollo.MutationResult<Types.UpdatePublicFeedbackBoardMutation>;
export type UpdatePublicFeedbackBoardMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePublicFeedbackBoardMutation, Types.UpdatePublicFeedbackBoardMutationVariables>;
export const UpdatePublicPageDocument = gql`
    mutation UpdatePublicPage($input: UpdatePublicPageInput!) {
  updatePublicPage(input: $input) {
    ...PublicPage
  }
}
    ${PublicPageFragmentDoc}`;
export type UpdatePublicPageMutationFn = Apollo.MutationFunction<Types.UpdatePublicPageMutation, Types.UpdatePublicPageMutationVariables>;

/**
 * __useUpdatePublicPageMutation__
 *
 * To run a mutation, you first call `useUpdatePublicPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicPageMutation, { data, loading, error }] = useUpdatePublicPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePublicPageMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePublicPageMutation, Types.UpdatePublicPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePublicPageMutation, Types.UpdatePublicPageMutationVariables>(UpdatePublicPageDocument, options);
      }
export type UpdatePublicPageMutationHookResult = ReturnType<typeof useUpdatePublicPageMutation>;
export type UpdatePublicPageMutationResult = Apollo.MutationResult<Types.UpdatePublicPageMutation>;
export type UpdatePublicPageMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePublicPageMutation, Types.UpdatePublicPageMutationVariables>;
export const ValidatePublicPageDomainDocument = gql`
    mutation ValidatePublicPageDomain($id: String!) {
  validatePublicPageDomain(id: $id) {
    ...PublicPage
  }
}
    ${PublicPageFragmentDoc}`;
export type ValidatePublicPageDomainMutationFn = Apollo.MutationFunction<Types.ValidatePublicPageDomainMutation, Types.ValidatePublicPageDomainMutationVariables>;

/**
 * __useValidatePublicPageDomainMutation__
 *
 * To run a mutation, you first call `useValidatePublicPageDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePublicPageDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePublicPageDomainMutation, { data, loading, error }] = useValidatePublicPageDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidatePublicPageDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidatePublicPageDomainMutation, Types.ValidatePublicPageDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidatePublicPageDomainMutation, Types.ValidatePublicPageDomainMutationVariables>(ValidatePublicPageDomainDocument, options);
      }
export type ValidatePublicPageDomainMutationHookResult = ReturnType<typeof useValidatePublicPageDomainMutation>;
export type ValidatePublicPageDomainMutationResult = Apollo.MutationResult<Types.ValidatePublicPageDomainMutation>;
export type ValidatePublicPageDomainMutationOptions = Apollo.BaseMutationOptions<Types.ValidatePublicPageDomainMutation, Types.ValidatePublicPageDomainMutationVariables>;
export const PublicFeedbackBoardsDocument = gql`
    query PublicFeedbackBoards {
  feedbackBoards {
    ...PublicFeedbackBoard
  }
}
    ${PublicFeedbackBoardFragmentDoc}`;

/**
 * __usePublicFeedbackBoardsQuery__
 *
 * To run a query within a React component, call `usePublicFeedbackBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicFeedbackBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicFeedbackBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicFeedbackBoardsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicFeedbackBoardsQuery, Types.PublicFeedbackBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicFeedbackBoardsQuery, Types.PublicFeedbackBoardsQueryVariables>(PublicFeedbackBoardsDocument, options);
      }
export function usePublicFeedbackBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicFeedbackBoardsQuery, Types.PublicFeedbackBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicFeedbackBoardsQuery, Types.PublicFeedbackBoardsQueryVariables>(PublicFeedbackBoardsDocument, options);
        }
export type PublicFeedbackBoardsQueryHookResult = ReturnType<typeof usePublicFeedbackBoardsQuery>;
export type PublicFeedbackBoardsLazyQueryHookResult = ReturnType<typeof usePublicFeedbackBoardsLazyQuery>;
export type PublicFeedbackBoardsQueryResult = Apollo.QueryResult<Types.PublicFeedbackBoardsQuery, Types.PublicFeedbackBoardsQueryVariables>;
export const PublicPageDocument = gql`
    query PublicPage($id: String!) {
  publicPage(id: $id) {
    ...PublicPage
  }
}
    ${PublicPageFragmentDoc}`;

/**
 * __usePublicPageQuery__
 *
 * To run a query within a React component, call `usePublicPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicPageQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicPageQuery, Types.PublicPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPageQuery, Types.PublicPageQueryVariables>(PublicPageDocument, options);
      }
export function usePublicPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPageQuery, Types.PublicPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPageQuery, Types.PublicPageQueryVariables>(PublicPageDocument, options);
        }
export type PublicPageQueryHookResult = ReturnType<typeof usePublicPageQuery>;
export type PublicPageLazyQueryHookResult = ReturnType<typeof usePublicPageLazyQuery>;
export type PublicPageQueryResult = Apollo.QueryResult<Types.PublicPageQuery, Types.PublicPageQueryVariables>;
export const PublicPageFeedbackPostsDocument = gql`
    query PublicPageFeedbackPosts($pagination: PaginationInput, $publicPageId: String!) {
  publicPageFeedbackPosts(pagination: $pagination, publicPageId: $publicPageId) {
    docs {
      ...PublicFeedbackPost
    }
    page
    limit
    totalDocs
    totalPages
  }
}
    ${PublicFeedbackPostFragmentDoc}`;

/**
 * __usePublicPageFeedbackPostsQuery__
 *
 * To run a query within a React component, call `usePublicPageFeedbackPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPageFeedbackPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPageFeedbackPostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      publicPageId: // value for 'publicPageId'
 *   },
 * });
 */
export function usePublicPageFeedbackPostsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicPageFeedbackPostsQuery, Types.PublicPageFeedbackPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPageFeedbackPostsQuery, Types.PublicPageFeedbackPostsQueryVariables>(PublicPageFeedbackPostsDocument, options);
      }
export function usePublicPageFeedbackPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPageFeedbackPostsQuery, Types.PublicPageFeedbackPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPageFeedbackPostsQuery, Types.PublicPageFeedbackPostsQueryVariables>(PublicPageFeedbackPostsDocument, options);
        }
export type PublicPageFeedbackPostsQueryHookResult = ReturnType<typeof usePublicPageFeedbackPostsQuery>;
export type PublicPageFeedbackPostsLazyQueryHookResult = ReturnType<typeof usePublicPageFeedbackPostsLazyQuery>;
export type PublicPageFeedbackPostsQueryResult = Apollo.QueryResult<Types.PublicPageFeedbackPostsQuery, Types.PublicPageFeedbackPostsQueryVariables>;
export const PublicPagePaginatedReleaseNotesDocument = gql`
    query PublicPagePaginatedReleaseNotes($pagination: PaginationInput, $publicPageId: String!) {
  publicPagePaginatedReleaseNotes(
    pagination: $pagination
    publicPageId: $publicPageId
  ) {
    docs {
      ...PublicReleaseNote
    }
    page
    limit
    totalDocs
    totalPages
  }
}
    ${PublicReleaseNoteFragmentDoc}`;

/**
 * __usePublicPagePaginatedReleaseNotesQuery__
 *
 * To run a query within a React component, call `usePublicPagePaginatedReleaseNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPagePaginatedReleaseNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPagePaginatedReleaseNotesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      publicPageId: // value for 'publicPageId'
 *   },
 * });
 */
export function usePublicPagePaginatedReleaseNotesQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicPagePaginatedReleaseNotesQuery, Types.PublicPagePaginatedReleaseNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPagePaginatedReleaseNotesQuery, Types.PublicPagePaginatedReleaseNotesQueryVariables>(PublicPagePaginatedReleaseNotesDocument, options);
      }
export function usePublicPagePaginatedReleaseNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPagePaginatedReleaseNotesQuery, Types.PublicPagePaginatedReleaseNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPagePaginatedReleaseNotesQuery, Types.PublicPagePaginatedReleaseNotesQueryVariables>(PublicPagePaginatedReleaseNotesDocument, options);
        }
export type PublicPagePaginatedReleaseNotesQueryHookResult = ReturnType<typeof usePublicPagePaginatedReleaseNotesQuery>;
export type PublicPagePaginatedReleaseNotesLazyQueryHookResult = ReturnType<typeof usePublicPagePaginatedReleaseNotesLazyQuery>;
export type PublicPagePaginatedReleaseNotesQueryResult = Apollo.QueryResult<Types.PublicPagePaginatedReleaseNotesQuery, Types.PublicPagePaginatedReleaseNotesQueryVariables>;
export const PublicPagesDocument = gql`
    query PublicPages($filter: PaginatedPublicPagesFilterInput, $pagination: PaginationInput) {
  publicPages(filter: $filter, pagination: $pagination) {
    docs {
      ...PublicPage
    }
    page
    limit
    totalDocs
    totalPages
  }
}
    ${PublicPageFragmentDoc}`;

/**
 * __usePublicPagesQuery__
 *
 * To run a query within a React component, call `usePublicPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePublicPagesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicPagesQuery, Types.PublicPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPagesQuery, Types.PublicPagesQueryVariables>(PublicPagesDocument, options);
      }
export function usePublicPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPagesQuery, Types.PublicPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPagesQuery, Types.PublicPagesQueryVariables>(PublicPagesDocument, options);
        }
export type PublicPagesQueryHookResult = ReturnType<typeof usePublicPagesQuery>;
export type PublicPagesLazyQueryHookResult = ReturnType<typeof usePublicPagesLazyQuery>;
export type PublicPagesQueryResult = Apollo.QueryResult<Types.PublicPagesQuery, Types.PublicPagesQueryVariables>;
export const PublicPagesPreviewDocument = gql`
    query PublicPagesPreview($filter: PaginatedPublicPagesFilterInput, $pagination: PaginationInput) {
  publicPages(filter: $filter, pagination: $pagination) {
    docs {
      ...PublicPagePreview
    }
    page
    limit
    totalDocs
    totalPages
  }
}
    ${PublicPagePreviewFragmentDoc}`;

/**
 * __usePublicPagesPreviewQuery__
 *
 * To run a query within a React component, call `usePublicPagesPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPagesPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPagesPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePublicPagesPreviewQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicPagesPreviewQuery, Types.PublicPagesPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPagesPreviewQuery, Types.PublicPagesPreviewQueryVariables>(PublicPagesPreviewDocument, options);
      }
export function usePublicPagesPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPagesPreviewQuery, Types.PublicPagesPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPagesPreviewQuery, Types.PublicPagesPreviewQueryVariables>(PublicPagesPreviewDocument, options);
        }
export type PublicPagesPreviewQueryHookResult = ReturnType<typeof usePublicPagesPreviewQuery>;
export type PublicPagesPreviewLazyQueryHookResult = ReturnType<typeof usePublicPagesPreviewLazyQuery>;
export type PublicPagesPreviewQueryResult = Apollo.QueryResult<Types.PublicPagesPreviewQuery, Types.PublicPagesPreviewQueryVariables>;
export const CreateReleaseNoteDocument = gql`
    mutation CreateReleaseNote($input: CreateReleaseNoteInput!) {
  createReleaseNote(input: $input) {
    ...ReleaseNote
  }
}
    ${ReleaseNoteFragmentDoc}`;
export type CreateReleaseNoteMutationFn = Apollo.MutationFunction<Types.CreateReleaseNoteMutation, Types.CreateReleaseNoteMutationVariables>;

/**
 * __useCreateReleaseNoteMutation__
 *
 * To run a mutation, you first call `useCreateReleaseNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReleaseNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReleaseNoteMutation, { data, loading, error }] = useCreateReleaseNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReleaseNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateReleaseNoteMutation, Types.CreateReleaseNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateReleaseNoteMutation, Types.CreateReleaseNoteMutationVariables>(CreateReleaseNoteDocument, options);
      }
export type CreateReleaseNoteMutationHookResult = ReturnType<typeof useCreateReleaseNoteMutation>;
export type CreateReleaseNoteMutationResult = Apollo.MutationResult<Types.CreateReleaseNoteMutation>;
export type CreateReleaseNoteMutationOptions = Apollo.BaseMutationOptions<Types.CreateReleaseNoteMutation, Types.CreateReleaseNoteMutationVariables>;
export const DeleteReleaseNoteDocument = gql`
    mutation DeleteReleaseNote($id: String!) {
  deleteReleaseNote(id: $id) {
    id
  }
}
    `;
export type DeleteReleaseNoteMutationFn = Apollo.MutationFunction<Types.DeleteReleaseNoteMutation, Types.DeleteReleaseNoteMutationVariables>;

/**
 * __useDeleteReleaseNoteMutation__
 *
 * To run a mutation, you first call `useDeleteReleaseNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReleaseNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReleaseNoteMutation, { data, loading, error }] = useDeleteReleaseNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReleaseNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteReleaseNoteMutation, Types.DeleteReleaseNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteReleaseNoteMutation, Types.DeleteReleaseNoteMutationVariables>(DeleteReleaseNoteDocument, options);
      }
export type DeleteReleaseNoteMutationHookResult = ReturnType<typeof useDeleteReleaseNoteMutation>;
export type DeleteReleaseNoteMutationResult = Apollo.MutationResult<Types.DeleteReleaseNoteMutation>;
export type DeleteReleaseNoteMutationOptions = Apollo.BaseMutationOptions<Types.DeleteReleaseNoteMutation, Types.DeleteReleaseNoteMutationVariables>;
export const UpdateReleaseNoteDocument = gql`
    mutation UpdateReleaseNote($input: UpdateReleaseNoteInput!) {
  updateReleaseNote(input: $input) {
    id
    internal
  }
}
    `;
export type UpdateReleaseNoteMutationFn = Apollo.MutationFunction<Types.UpdateReleaseNoteMutation, Types.UpdateReleaseNoteMutationVariables>;

/**
 * __useUpdateReleaseNoteMutation__
 *
 * To run a mutation, you first call `useUpdateReleaseNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReleaseNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReleaseNoteMutation, { data, loading, error }] = useUpdateReleaseNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReleaseNoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateReleaseNoteMutation, Types.UpdateReleaseNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateReleaseNoteMutation, Types.UpdateReleaseNoteMutationVariables>(UpdateReleaseNoteDocument, options);
      }
export type UpdateReleaseNoteMutationHookResult = ReturnType<typeof useUpdateReleaseNoteMutation>;
export type UpdateReleaseNoteMutationResult = Apollo.MutationResult<Types.UpdateReleaseNoteMutation>;
export type UpdateReleaseNoteMutationOptions = Apollo.BaseMutationOptions<Types.UpdateReleaseNoteMutation, Types.UpdateReleaseNoteMutationVariables>;
export const CountReleaseNotesDocument = gql`
    query CountReleaseNotes($filter: ReleaseNotesFilterInput) {
  countReleaseNotes(filter: $filter)
}
    `;

/**
 * __useCountReleaseNotesQuery__
 *
 * To run a query within a React component, call `useCountReleaseNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountReleaseNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountReleaseNotesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountReleaseNotesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountReleaseNotesQuery, Types.CountReleaseNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountReleaseNotesQuery, Types.CountReleaseNotesQueryVariables>(CountReleaseNotesDocument, options);
      }
export function useCountReleaseNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountReleaseNotesQuery, Types.CountReleaseNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountReleaseNotesQuery, Types.CountReleaseNotesQueryVariables>(CountReleaseNotesDocument, options);
        }
export type CountReleaseNotesQueryHookResult = ReturnType<typeof useCountReleaseNotesQuery>;
export type CountReleaseNotesLazyQueryHookResult = ReturnType<typeof useCountReleaseNotesLazyQuery>;
export type CountReleaseNotesQueryResult = Apollo.QueryResult<Types.CountReleaseNotesQuery, Types.CountReleaseNotesQueryVariables>;
export const PaginatedReleaseNotesDocument = gql`
    query PaginatedReleaseNotes($pagination: PaginationInput, $filter: ReleaseNotesFilterInput) {
  paginatedReleaseNotes(pagination: $pagination, filter: $filter) {
    totalPages
    totalDocs
    page
    limit
    docs {
      ...ReleaseNote
    }
  }
}
    ${ReleaseNoteFragmentDoc}`;

/**
 * __usePaginatedReleaseNotesQuery__
 *
 * To run a query within a React component, call `usePaginatedReleaseNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedReleaseNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedReleaseNotesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedReleaseNotesQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedReleaseNotesQuery, Types.PaginatedReleaseNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedReleaseNotesQuery, Types.PaginatedReleaseNotesQueryVariables>(PaginatedReleaseNotesDocument, options);
      }
export function usePaginatedReleaseNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedReleaseNotesQuery, Types.PaginatedReleaseNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedReleaseNotesQuery, Types.PaginatedReleaseNotesQueryVariables>(PaginatedReleaseNotesDocument, options);
        }
export type PaginatedReleaseNotesQueryHookResult = ReturnType<typeof usePaginatedReleaseNotesQuery>;
export type PaginatedReleaseNotesLazyQueryHookResult = ReturnType<typeof usePaginatedReleaseNotesLazyQuery>;
export type PaginatedReleaseNotesQueryResult = Apollo.QueryResult<Types.PaginatedReleaseNotesQuery, Types.PaginatedReleaseNotesQueryVariables>;
export const RoadmapsForOptionDocument = gql`
    query RoadmapsForOption($input: ProductBoardRoadmapsInput) {
  productBoardRoadmaps(input: $input) {
    ...RoadmapForOption
  }
}
    ${RoadmapForOptionFragmentDoc}`;

/**
 * __useRoadmapsForOptionQuery__
 *
 * To run a query within a React component, call `useRoadmapsForOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadmapsForOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadmapsForOptionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRoadmapsForOptionQuery(baseOptions?: Apollo.QueryHookOptions<Types.RoadmapsForOptionQuery, Types.RoadmapsForOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RoadmapsForOptionQuery, Types.RoadmapsForOptionQueryVariables>(RoadmapsForOptionDocument, options);
      }
export function useRoadmapsForOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RoadmapsForOptionQuery, Types.RoadmapsForOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RoadmapsForOptionQuery, Types.RoadmapsForOptionQueryVariables>(RoadmapsForOptionDocument, options);
        }
export type RoadmapsForOptionQueryHookResult = ReturnType<typeof useRoadmapsForOptionQuery>;
export type RoadmapsForOptionLazyQueryHookResult = ReturnType<typeof useRoadmapsForOptionLazyQuery>;
export type RoadmapsForOptionQueryResult = Apollo.QueryResult<Types.RoadmapsForOptionQuery, Types.RoadmapsForOptionQueryVariables>;
export const CountTasksDocument = gql`
    query CountTasks($filter: FilterTasksInput) {
  countTasks(filter: $filter)
}
    `;

/**
 * __useCountTasksQuery__
 *
 * To run a query within a React component, call `useCountTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountTasksQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountTasksQuery, Types.CountTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountTasksQuery, Types.CountTasksQueryVariables>(CountTasksDocument, options);
      }
export function useCountTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountTasksQuery, Types.CountTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountTasksQuery, Types.CountTasksQueryVariables>(CountTasksDocument, options);
        }
export type CountTasksQueryHookResult = ReturnType<typeof useCountTasksQuery>;
export type CountTasksLazyQueryHookResult = ReturnType<typeof useCountTasksLazyQuery>;
export type CountTasksQueryResult = Apollo.QueryResult<Types.CountTasksQuery, Types.CountTasksQueryVariables>;
export const LaunchTaskGroupOptionsDocument = gql`
    query LaunchTaskGroupOptions($launchId: String!) {
  assignees: tasksAssignees {
    id
    name
    email
    avatarColor @client
    profileImage
  }
  tags: tags(
    input: {launchId: $launchId, parentName: TASKS, types: [TASK, PRODUCT_LINE]}
  ) {
    id
    type
    label
    color
  }
}
    `;

/**
 * __useLaunchTaskGroupOptionsQuery__
 *
 * To run a query within a React component, call `useLaunchTaskGroupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchTaskGroupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchTaskGroupOptionsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchTaskGroupOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchTaskGroupOptionsQuery, Types.LaunchTaskGroupOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchTaskGroupOptionsQuery, Types.LaunchTaskGroupOptionsQueryVariables>(LaunchTaskGroupOptionsDocument, options);
      }
export function useLaunchTaskGroupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchTaskGroupOptionsQuery, Types.LaunchTaskGroupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchTaskGroupOptionsQuery, Types.LaunchTaskGroupOptionsQueryVariables>(LaunchTaskGroupOptionsDocument, options);
        }
export type LaunchTaskGroupOptionsQueryHookResult = ReturnType<typeof useLaunchTaskGroupOptionsQuery>;
export type LaunchTaskGroupOptionsLazyQueryHookResult = ReturnType<typeof useLaunchTaskGroupOptionsLazyQuery>;
export type LaunchTaskGroupOptionsQueryResult = Apollo.QueryResult<Types.LaunchTaskGroupOptionsQuery, Types.LaunchTaskGroupOptionsQueryVariables>;
export const PublicLaunchTaskGroupOptionsDocument = gql`
    query PublicLaunchTaskGroupOptions($launchId: String!) {
  assignees: publicTaskAssignees {
    id
    name
    email
    avatarColor @client
    profileImage
  }
  tags: publicLaunchPageTags(
    input: {launchId: $launchId, parentName: TASKS, types: [TASK, PRODUCT_LINE]}
  ) {
    id
    type
    label
    color
  }
}
    `;

/**
 * __usePublicLaunchTaskGroupOptionsQuery__
 *
 * To run a query within a React component, call `usePublicLaunchTaskGroupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchTaskGroupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchTaskGroupOptionsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function usePublicLaunchTaskGroupOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicLaunchTaskGroupOptionsQuery, Types.PublicLaunchTaskGroupOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchTaskGroupOptionsQuery, Types.PublicLaunchTaskGroupOptionsQueryVariables>(PublicLaunchTaskGroupOptionsDocument, options);
      }
export function usePublicLaunchTaskGroupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchTaskGroupOptionsQuery, Types.PublicLaunchTaskGroupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchTaskGroupOptionsQuery, Types.PublicLaunchTaskGroupOptionsQueryVariables>(PublicLaunchTaskGroupOptionsDocument, options);
        }
export type PublicLaunchTaskGroupOptionsQueryHookResult = ReturnType<typeof usePublicLaunchTaskGroupOptionsQuery>;
export type PublicLaunchTaskGroupOptionsLazyQueryHookResult = ReturnType<typeof usePublicLaunchTaskGroupOptionsLazyQuery>;
export type PublicLaunchTaskGroupOptionsQueryResult = Apollo.QueryResult<Types.PublicLaunchTaskGroupOptionsQuery, Types.PublicLaunchTaskGroupOptionsQueryVariables>;
export const TaskGroupOptionsDocument = gql`
    query TaskGroupOptions {
  assignees: tasksAssignees {
    id
    name
    email
    avatarColor @client
    profileImage
  }
  tags: tagsForTasksGroupBy {
    id
    type
    label
    color
  }
}
    `;

/**
 * __useTaskGroupOptionsQuery__
 *
 * To run a query within a React component, call `useTaskGroupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskGroupOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TaskGroupOptionsQuery, Types.TaskGroupOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TaskGroupOptionsQuery, Types.TaskGroupOptionsQueryVariables>(TaskGroupOptionsDocument, options);
      }
export function useTaskGroupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TaskGroupOptionsQuery, Types.TaskGroupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TaskGroupOptionsQuery, Types.TaskGroupOptionsQueryVariables>(TaskGroupOptionsDocument, options);
        }
export type TaskGroupOptionsQueryHookResult = ReturnType<typeof useTaskGroupOptionsQuery>;
export type TaskGroupOptionsLazyQueryHookResult = ReturnType<typeof useTaskGroupOptionsLazyQuery>;
export type TaskGroupOptionsQueryResult = Apollo.QueryResult<Types.TaskGroupOptionsQuery, Types.TaskGroupOptionsQueryVariables>;
export const CreateTestimonialDocument = gql`
    mutation CreateTestimonial($input: CreateTestimonialInput!) {
  createTestimonial(input: $input) {
    ...Testimonial
  }
}
    ${TestimonialFragmentDoc}`;
export type CreateTestimonialMutationFn = Apollo.MutationFunction<Types.CreateTestimonialMutation, Types.CreateTestimonialMutationVariables>;

/**
 * __useCreateTestimonialMutation__
 *
 * To run a mutation, you first call `useCreateTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestimonialMutation, { data, loading, error }] = useCreateTestimonialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTestimonialMutation, Types.CreateTestimonialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTestimonialMutation, Types.CreateTestimonialMutationVariables>(CreateTestimonialDocument, options);
      }
export type CreateTestimonialMutationHookResult = ReturnType<typeof useCreateTestimonialMutation>;
export type CreateTestimonialMutationResult = Apollo.MutationResult<Types.CreateTestimonialMutation>;
export type CreateTestimonialMutationOptions = Apollo.BaseMutationOptions<Types.CreateTestimonialMutation, Types.CreateTestimonialMutationVariables>;
export const DeleteTestimonialDocument = gql`
    mutation DeleteTestimonial($id: String!) {
  deleteTestimonial(id: $id) {
    id
  }
}
    `;
export type DeleteTestimonialMutationFn = Apollo.MutationFunction<Types.DeleteTestimonialMutation, Types.DeleteTestimonialMutationVariables>;

/**
 * __useDeleteTestimonialMutation__
 *
 * To run a mutation, you first call `useDeleteTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestimonialMutation, { data, loading, error }] = useDeleteTestimonialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTestimonialMutation, Types.DeleteTestimonialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTestimonialMutation, Types.DeleteTestimonialMutationVariables>(DeleteTestimonialDocument, options);
      }
export type DeleteTestimonialMutationHookResult = ReturnType<typeof useDeleteTestimonialMutation>;
export type DeleteTestimonialMutationResult = Apollo.MutationResult<Types.DeleteTestimonialMutation>;
export type DeleteTestimonialMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTestimonialMutation, Types.DeleteTestimonialMutationVariables>;
export const UpdateTestimonialCompanyDocument = gql`
    mutation UpdateTestimonialCompany($id: String!, $company: String!) {
  updateTestimonial(input: {id: $id, company: $company}) {
    id
    company
    updatedAt
  }
}
    `;
export type UpdateTestimonialCompanyMutationFn = Apollo.MutationFunction<Types.UpdateTestimonialCompanyMutation, Types.UpdateTestimonialCompanyMutationVariables>;

/**
 * __useUpdateTestimonialCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialCompanyMutation, { data, loading, error }] = useUpdateTestimonialCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useUpdateTestimonialCompanyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTestimonialCompanyMutation, Types.UpdateTestimonialCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTestimonialCompanyMutation, Types.UpdateTestimonialCompanyMutationVariables>(UpdateTestimonialCompanyDocument, options);
      }
export type UpdateTestimonialCompanyMutationHookResult = ReturnType<typeof useUpdateTestimonialCompanyMutation>;
export type UpdateTestimonialCompanyMutationResult = Apollo.MutationResult<Types.UpdateTestimonialCompanyMutation>;
export type UpdateTestimonialCompanyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTestimonialCompanyMutation, Types.UpdateTestimonialCompanyMutationVariables>;
export const UpdateTestimonialNameDocument = gql`
    mutation UpdateTestimonialName($id: String!, $name: String!) {
  updateTestimonial(input: {id: $id, name: $name}) {
    id
    name
    updatedAt
  }
}
    `;
export type UpdateTestimonialNameMutationFn = Apollo.MutationFunction<Types.UpdateTestimonialNameMutation, Types.UpdateTestimonialNameMutationVariables>;

/**
 * __useUpdateTestimonialNameMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialNameMutation, { data, loading, error }] = useUpdateTestimonialNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateTestimonialNameMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTestimonialNameMutation, Types.UpdateTestimonialNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTestimonialNameMutation, Types.UpdateTestimonialNameMutationVariables>(UpdateTestimonialNameDocument, options);
      }
export type UpdateTestimonialNameMutationHookResult = ReturnType<typeof useUpdateTestimonialNameMutation>;
export type UpdateTestimonialNameMutationResult = Apollo.MutationResult<Types.UpdateTestimonialNameMutation>;
export type UpdateTestimonialNameMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTestimonialNameMutation, Types.UpdateTestimonialNameMutationVariables>;
export const UpdateTestimonialQuoteDocument = gql`
    mutation UpdateTestimonialQuote($id: String!, $quote: String!) {
  updateTestimonial(input: {id: $id, quote: $quote}) {
    id
    quote
    updatedAt
  }
}
    `;
export type UpdateTestimonialQuoteMutationFn = Apollo.MutationFunction<Types.UpdateTestimonialQuoteMutation, Types.UpdateTestimonialQuoteMutationVariables>;

/**
 * __useUpdateTestimonialQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialQuoteMutation, { data, loading, error }] = useUpdateTestimonialQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quote: // value for 'quote'
 *   },
 * });
 */
export function useUpdateTestimonialQuoteMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTestimonialQuoteMutation, Types.UpdateTestimonialQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTestimonialQuoteMutation, Types.UpdateTestimonialQuoteMutationVariables>(UpdateTestimonialQuoteDocument, options);
      }
export type UpdateTestimonialQuoteMutationHookResult = ReturnType<typeof useUpdateTestimonialQuoteMutation>;
export type UpdateTestimonialQuoteMutationResult = Apollo.MutationResult<Types.UpdateTestimonialQuoteMutation>;
export type UpdateTestimonialQuoteMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTestimonialQuoteMutation, Types.UpdateTestimonialQuoteMutationVariables>;
export const UpdateTestimonialRegisteredOnDocument = gql`
    mutation UpdateTestimonialRegisteredOn($id: String!, $registeredOn: DateTime!) {
  updateTestimonial(input: {id: $id, registeredOn: $registeredOn}) {
    id
    registeredOn
    updatedAt
  }
}
    `;
export type UpdateTestimonialRegisteredOnMutationFn = Apollo.MutationFunction<Types.UpdateTestimonialRegisteredOnMutation, Types.UpdateTestimonialRegisteredOnMutationVariables>;

/**
 * __useUpdateTestimonialRegisteredOnMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialRegisteredOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialRegisteredOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialRegisteredOnMutation, { data, loading, error }] = useUpdateTestimonialRegisteredOnMutation({
 *   variables: {
 *      id: // value for 'id'
 *      registeredOn: // value for 'registeredOn'
 *   },
 * });
 */
export function useUpdateTestimonialRegisteredOnMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTestimonialRegisteredOnMutation, Types.UpdateTestimonialRegisteredOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTestimonialRegisteredOnMutation, Types.UpdateTestimonialRegisteredOnMutationVariables>(UpdateTestimonialRegisteredOnDocument, options);
      }
export type UpdateTestimonialRegisteredOnMutationHookResult = ReturnType<typeof useUpdateTestimonialRegisteredOnMutation>;
export type UpdateTestimonialRegisteredOnMutationResult = Apollo.MutationResult<Types.UpdateTestimonialRegisteredOnMutation>;
export type UpdateTestimonialRegisteredOnMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTestimonialRegisteredOnMutation, Types.UpdateTestimonialRegisteredOnMutationVariables>;
export const UpdateTestimonialStatusDocument = gql`
    mutation UpdateTestimonialStatus($id: String!, $status: TESTIMONIAL_STATUS!) {
  updateTestimonial(input: {id: $id, status: $status}) {
    id
    status
    updatedAt
  }
}
    `;
export type UpdateTestimonialStatusMutationFn = Apollo.MutationFunction<Types.UpdateTestimonialStatusMutation, Types.UpdateTestimonialStatusMutationVariables>;

/**
 * __useUpdateTestimonialStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialStatusMutation, { data, loading, error }] = useUpdateTestimonialStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateTestimonialStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTestimonialStatusMutation, Types.UpdateTestimonialStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTestimonialStatusMutation, Types.UpdateTestimonialStatusMutationVariables>(UpdateTestimonialStatusDocument, options);
      }
export type UpdateTestimonialStatusMutationHookResult = ReturnType<typeof useUpdateTestimonialStatusMutation>;
export type UpdateTestimonialStatusMutationResult = Apollo.MutationResult<Types.UpdateTestimonialStatusMutation>;
export type UpdateTestimonialStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTestimonialStatusMutation, Types.UpdateTestimonialStatusMutationVariables>;
export const UpdateTestimonialTagsDocument = gql`
    mutation UpdateTestimonialTags($id: String!, $tags: [String!]!) {
  updateTestimonial(input: {id: $id, tags: $tags}) {
    id
    updatedAt
    tags {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;
export type UpdateTestimonialTagsMutationFn = Apollo.MutationFunction<Types.UpdateTestimonialTagsMutation, Types.UpdateTestimonialTagsMutationVariables>;

/**
 * __useUpdateTestimonialTagsMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialTagsMutation, { data, loading, error }] = useUpdateTestimonialTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateTestimonialTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTestimonialTagsMutation, Types.UpdateTestimonialTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTestimonialTagsMutation, Types.UpdateTestimonialTagsMutationVariables>(UpdateTestimonialTagsDocument, options);
      }
export type UpdateTestimonialTagsMutationHookResult = ReturnType<typeof useUpdateTestimonialTagsMutation>;
export type UpdateTestimonialTagsMutationResult = Apollo.MutationResult<Types.UpdateTestimonialTagsMutation>;
export type UpdateTestimonialTagsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTestimonialTagsMutation, Types.UpdateTestimonialTagsMutationVariables>;
export const CountTestimonialsDocument = gql`
    query CountTestimonials($filter: TestimonialsFilterInput) {
  countTestimonials(filter: $filter)
}
    `;

/**
 * __useCountTestimonialsQuery__
 *
 * To run a query within a React component, call `useCountTestimonialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTestimonialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTestimonialsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountTestimonialsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountTestimonialsQuery, Types.CountTestimonialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountTestimonialsQuery, Types.CountTestimonialsQueryVariables>(CountTestimonialsDocument, options);
      }
export function useCountTestimonialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountTestimonialsQuery, Types.CountTestimonialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountTestimonialsQuery, Types.CountTestimonialsQueryVariables>(CountTestimonialsDocument, options);
        }
export type CountTestimonialsQueryHookResult = ReturnType<typeof useCountTestimonialsQuery>;
export type CountTestimonialsLazyQueryHookResult = ReturnType<typeof useCountTestimonialsLazyQuery>;
export type CountTestimonialsQueryResult = Apollo.QueryResult<Types.CountTestimonialsQuery, Types.CountTestimonialsQueryVariables>;
export const PaginatedTestimonialsDocument = gql`
    query PaginatedTestimonials($pagination: PaginationInput, $filter: TestimonialsFilterInput) {
  paginatedTestimonials(pagination: $pagination, filter: $filter) {
    ...PaginatedTestimonials
  }
}
    ${PaginatedTestimonialsFragmentDoc}`;

/**
 * __usePaginatedTestimonialsQuery__
 *
 * To run a query within a React component, call `usePaginatedTestimonialsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTestimonialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTestimonialsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedTestimonialsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedTestimonialsQuery, Types.PaginatedTestimonialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedTestimonialsQuery, Types.PaginatedTestimonialsQueryVariables>(PaginatedTestimonialsDocument, options);
      }
export function usePaginatedTestimonialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedTestimonialsQuery, Types.PaginatedTestimonialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedTestimonialsQuery, Types.PaginatedTestimonialsQueryVariables>(PaginatedTestimonialsDocument, options);
        }
export type PaginatedTestimonialsQueryHookResult = ReturnType<typeof usePaginatedTestimonialsQuery>;
export type PaginatedTestimonialsLazyQueryHookResult = ReturnType<typeof usePaginatedTestimonialsLazyQuery>;
export type PaginatedTestimonialsQueryResult = Apollo.QueryResult<Types.PaginatedTestimonialsQuery, Types.PaginatedTestimonialsQueryVariables>;
export const AssetDataForApprovalDocument = gql`
    query AssetDataForApproval($id: String!) {
  asset(id: $id) {
    id
    approverDetails {
      userId
      userDetails {
        ...UserDataForApproval
      }
    }
  }
}
    ${UserDataForApprovalFragmentDoc}`;

/**
 * __useAssetDataForApprovalQuery__
 *
 * To run a query within a React component, call `useAssetDataForApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetDataForApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetDataForApprovalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetDataForApprovalQuery(baseOptions: Apollo.QueryHookOptions<Types.AssetDataForApprovalQuery, Types.AssetDataForApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AssetDataForApprovalQuery, Types.AssetDataForApprovalQueryVariables>(AssetDataForApprovalDocument, options);
      }
export function useAssetDataForApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AssetDataForApprovalQuery, Types.AssetDataForApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AssetDataForApprovalQuery, Types.AssetDataForApprovalQueryVariables>(AssetDataForApprovalDocument, options);
        }
export type AssetDataForApprovalQueryHookResult = ReturnType<typeof useAssetDataForApprovalQuery>;
export type AssetDataForApprovalLazyQueryHookResult = ReturnType<typeof useAssetDataForApprovalLazyQuery>;
export type AssetDataForApprovalQueryResult = Apollo.QueryResult<Types.AssetDataForApprovalQuery, Types.AssetDataForApprovalQueryVariables>;
export const UserDataForApprovalDocument = gql`
    query UserDataForApproval($filter: FilterUserInput!) {
  users(filter: $filter) {
    ...UserDataForApproval
  }
}
    ${UserDataForApprovalFragmentDoc}`;

/**
 * __useUserDataForApprovalQuery__
 *
 * To run a query within a React component, call `useUserDataForApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataForApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataForApprovalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserDataForApprovalQuery(baseOptions: Apollo.QueryHookOptions<Types.UserDataForApprovalQuery, Types.UserDataForApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UserDataForApprovalQuery, Types.UserDataForApprovalQueryVariables>(UserDataForApprovalDocument, options);
      }
export function useUserDataForApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UserDataForApprovalQuery, Types.UserDataForApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UserDataForApprovalQuery, Types.UserDataForApprovalQueryVariables>(UserDataForApprovalDocument, options);
        }
export type UserDataForApprovalQueryHookResult = ReturnType<typeof useUserDataForApprovalQuery>;
export type UserDataForApprovalLazyQueryHookResult = ReturnType<typeof useUserDataForApprovalLazyQuery>;
export type UserDataForApprovalQueryResult = Apollo.QueryResult<Types.UserDataForApprovalQuery, Types.UserDataForApprovalQueryVariables>;
export const LaunchAssetsFilterOptionsDocument = gql`
    query LaunchAssetsFilterOptions($launchId: String!) {
  assetFilterOptions(filter: {launchIds: [$launchId]}) {
    tagOptions {
      ...TagFilterOption
    }
    approverOptions {
      ...UserFilterOption
    }
    ownerOptions {
      ...UserFilterOption
    }
  }
}
    ${TagFilterOptionFragmentDoc}
${UserFilterOptionFragmentDoc}`;

/**
 * __useLaunchAssetsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useLaunchAssetsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchAssetsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchAssetsFilterOptionsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchAssetsFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchAssetsFilterOptionsQuery, Types.LaunchAssetsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchAssetsFilterOptionsQuery, Types.LaunchAssetsFilterOptionsQueryVariables>(LaunchAssetsFilterOptionsDocument, options);
      }
export function useLaunchAssetsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchAssetsFilterOptionsQuery, Types.LaunchAssetsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchAssetsFilterOptionsQuery, Types.LaunchAssetsFilterOptionsQueryVariables>(LaunchAssetsFilterOptionsDocument, options);
        }
export type LaunchAssetsFilterOptionsQueryHookResult = ReturnType<typeof useLaunchAssetsFilterOptionsQuery>;
export type LaunchAssetsFilterOptionsLazyQueryHookResult = ReturnType<typeof useLaunchAssetsFilterOptionsLazyQuery>;
export type LaunchAssetsFilterOptionsQueryResult = Apollo.QueryResult<Types.LaunchAssetsFilterOptionsQuery, Types.LaunchAssetsFilterOptionsQueryVariables>;
export const PublicLaunchAssetsFilterOptionsDocument = gql`
    query PublicLaunchAssetsFilterOptions {
  organization: publicOrganization {
    id
    haveGtm
    users {
      ...PublicOrganizationUserFilterOptionData
    }
  }
  tags: publicLaunchPageTags(input: {types: [ASSET, CHANNEL]}) {
    ...TagFilterOptionData
  }
}
    ${PublicOrganizationUserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}`;

/**
 * __usePublicLaunchAssetsFilterOptionsQuery__
 *
 * To run a query within a React component, call `usePublicLaunchAssetsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchAssetsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchAssetsFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicLaunchAssetsFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicLaunchAssetsFilterOptionsQuery, Types.PublicLaunchAssetsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchAssetsFilterOptionsQuery, Types.PublicLaunchAssetsFilterOptionsQueryVariables>(PublicLaunchAssetsFilterOptionsDocument, options);
      }
export function usePublicLaunchAssetsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchAssetsFilterOptionsQuery, Types.PublicLaunchAssetsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchAssetsFilterOptionsQuery, Types.PublicLaunchAssetsFilterOptionsQueryVariables>(PublicLaunchAssetsFilterOptionsDocument, options);
        }
export type PublicLaunchAssetsFilterOptionsQueryHookResult = ReturnType<typeof usePublicLaunchAssetsFilterOptionsQuery>;
export type PublicLaunchAssetsFilterOptionsLazyQueryHookResult = ReturnType<typeof usePublicLaunchAssetsFilterOptionsLazyQuery>;
export type PublicLaunchAssetsFilterOptionsQueryResult = Apollo.QueryResult<Types.PublicLaunchAssetsFilterOptionsQuery, Types.PublicLaunchAssetsFilterOptionsQueryVariables>;
export const OrganizationAssetsFilterOptionsDocument = gql`
    query OrganizationAssetsFilterOptions {
  assetFilterOptions {
    tagOptions {
      ...TagFilterOption
    }
    launchOptions {
      ...LaunchFilterOption
    }
    approverOptions {
      ...UserFilterOption
    }
    ownerOptions {
      ...UserFilterOption
    }
  }
}
    ${TagFilterOptionFragmentDoc}
${LaunchFilterOptionFragmentDoc}
${UserFilterOptionFragmentDoc}`;

/**
 * __useOrganizationAssetsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useOrganizationAssetsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAssetsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAssetsFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationAssetsFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationAssetsFilterOptionsQuery, Types.OrganizationAssetsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationAssetsFilterOptionsQuery, Types.OrganizationAssetsFilterOptionsQueryVariables>(OrganizationAssetsFilterOptionsDocument, options);
      }
export function useOrganizationAssetsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationAssetsFilterOptionsQuery, Types.OrganizationAssetsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationAssetsFilterOptionsQuery, Types.OrganizationAssetsFilterOptionsQueryVariables>(OrganizationAssetsFilterOptionsDocument, options);
        }
export type OrganizationAssetsFilterOptionsQueryHookResult = ReturnType<typeof useOrganizationAssetsFilterOptionsQuery>;
export type OrganizationAssetsFilterOptionsLazyQueryHookResult = ReturnType<typeof useOrganizationAssetsFilterOptionsLazyQuery>;
export type OrganizationAssetsFilterOptionsQueryResult = Apollo.QueryResult<Types.OrganizationAssetsFilterOptionsQuery, Types.OrganizationAssetsFilterOptionsQueryVariables>;
export const SendDesktopLinkEmailDocument = gql`
    mutation SendDesktopLinkEmail {
  sendDesktopLinkEmail
}
    `;
export type SendDesktopLinkEmailMutationFn = Apollo.MutationFunction<Types.SendDesktopLinkEmailMutation, Types.SendDesktopLinkEmailMutationVariables>;

/**
 * __useSendDesktopLinkEmailMutation__
 *
 * To run a mutation, you first call `useSendDesktopLinkEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDesktopLinkEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDesktopLinkEmailMutation, { data, loading, error }] = useSendDesktopLinkEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendDesktopLinkEmailMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendDesktopLinkEmailMutation, Types.SendDesktopLinkEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendDesktopLinkEmailMutation, Types.SendDesktopLinkEmailMutationVariables>(SendDesktopLinkEmailDocument, options);
      }
export type SendDesktopLinkEmailMutationHookResult = ReturnType<typeof useSendDesktopLinkEmailMutation>;
export type SendDesktopLinkEmailMutationResult = Apollo.MutationResult<Types.SendDesktopLinkEmailMutation>;
export type SendDesktopLinkEmailMutationOptions = Apollo.BaseMutationOptions<Types.SendDesktopLinkEmailMutation, Types.SendDesktopLinkEmailMutationVariables>;
export const ChangeSubscriptionDocument = gql`
    mutation ChangeSubscription($newPriceIds: [String!]!) {
  MBChangeProductInSubscription(newPriceIds: $newPriceIds) {
    ...MapleSubscription
  }
}
    ${MapleSubscriptionFragmentDoc}`;
export type ChangeSubscriptionMutationFn = Apollo.MutationFunction<Types.ChangeSubscriptionMutation, Types.ChangeSubscriptionMutationVariables>;

/**
 * __useChangeSubscriptionMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionMutation, { data, loading, error }] = useChangeSubscriptionMutation({
 *   variables: {
 *      newPriceIds: // value for 'newPriceIds'
 *   },
 * });
 */
export function useChangeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChangeSubscriptionMutation, Types.ChangeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChangeSubscriptionMutation, Types.ChangeSubscriptionMutationVariables>(ChangeSubscriptionDocument, options);
      }
export type ChangeSubscriptionMutationHookResult = ReturnType<typeof useChangeSubscriptionMutation>;
export type ChangeSubscriptionMutationResult = Apollo.MutationResult<Types.ChangeSubscriptionMutation>;
export type ChangeSubscriptionMutationOptions = Apollo.BaseMutationOptions<Types.ChangeSubscriptionMutation, Types.ChangeSubscriptionMutationVariables>;
export const ChecklistAiCopywritingDocument = gql`
    query ChecklistAiCopywriting {
  checklist {
    ...ChecklistAiCopywriting
  }
}
    ${ChecklistAiCopywritingFragmentDoc}`;

/**
 * __useChecklistAiCopywritingQuery__
 *
 * To run a query within a React component, call `useChecklistAiCopywritingQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistAiCopywritingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistAiCopywritingQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistAiCopywritingQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistAiCopywritingQuery, Types.ChecklistAiCopywritingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistAiCopywritingQuery, Types.ChecklistAiCopywritingQueryVariables>(ChecklistAiCopywritingDocument, options);
      }
export function useChecklistAiCopywritingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistAiCopywritingQuery, Types.ChecklistAiCopywritingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistAiCopywritingQuery, Types.ChecklistAiCopywritingQueryVariables>(ChecklistAiCopywritingDocument, options);
        }
export type ChecklistAiCopywritingQueryHookResult = ReturnType<typeof useChecklistAiCopywritingQuery>;
export type ChecklistAiCopywritingLazyQueryHookResult = ReturnType<typeof useChecklistAiCopywritingLazyQuery>;
export type ChecklistAiCopywritingQueryResult = Apollo.QueryResult<Types.ChecklistAiCopywritingQuery, Types.ChecklistAiCopywritingQueryVariables>;
export const UpdateChecklistAiCopywritingDocument = gql`
    mutation UpdateChecklistAiCopywriting($aiCopywriting: UpdateAiCopywritingSectionInput!) {
  updateChecklist(input: {aiCopywriting: $aiCopywriting}) {
    ...ChecklistAiCopywriting
  }
}
    ${ChecklistAiCopywritingFragmentDoc}`;
export type UpdateChecklistAiCopywritingMutationFn = Apollo.MutationFunction<Types.UpdateChecklistAiCopywritingMutation, Types.UpdateChecklistAiCopywritingMutationVariables>;

/**
 * __useUpdateChecklistAiCopywritingMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistAiCopywritingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistAiCopywritingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistAiCopywritingMutation, { data, loading, error }] = useUpdateChecklistAiCopywritingMutation({
 *   variables: {
 *      aiCopywriting: // value for 'aiCopywriting'
 *   },
 * });
 */
export function useUpdateChecklistAiCopywritingMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistAiCopywritingMutation, Types.UpdateChecklistAiCopywritingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistAiCopywritingMutation, Types.UpdateChecklistAiCopywritingMutationVariables>(UpdateChecklistAiCopywritingDocument, options);
      }
export type UpdateChecklistAiCopywritingMutationHookResult = ReturnType<typeof useUpdateChecklistAiCopywritingMutation>;
export type UpdateChecklistAiCopywritingMutationResult = Apollo.MutationResult<Types.UpdateChecklistAiCopywritingMutation>;
export type UpdateChecklistAiCopywritingMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistAiCopywritingMutation, Types.UpdateChecklistAiCopywritingMutationVariables>;
export const ChecklistCampaignPlanningDocument = gql`
    query ChecklistCampaignPlanning {
  checklist {
    ...ChecklistCampaignPlanning
  }
}
    ${ChecklistCampaignPlanningFragmentDoc}`;

/**
 * __useChecklistCampaignPlanningQuery__
 *
 * To run a query within a React component, call `useChecklistCampaignPlanningQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistCampaignPlanningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistCampaignPlanningQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistCampaignPlanningQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistCampaignPlanningQuery, Types.ChecklistCampaignPlanningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistCampaignPlanningQuery, Types.ChecklistCampaignPlanningQueryVariables>(ChecklistCampaignPlanningDocument, options);
      }
export function useChecklistCampaignPlanningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistCampaignPlanningQuery, Types.ChecklistCampaignPlanningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistCampaignPlanningQuery, Types.ChecklistCampaignPlanningQueryVariables>(ChecklistCampaignPlanningDocument, options);
        }
export type ChecklistCampaignPlanningQueryHookResult = ReturnType<typeof useChecklistCampaignPlanningQuery>;
export type ChecklistCampaignPlanningLazyQueryHookResult = ReturnType<typeof useChecklistCampaignPlanningLazyQuery>;
export type ChecklistCampaignPlanningQueryResult = Apollo.QueryResult<Types.ChecklistCampaignPlanningQuery, Types.ChecklistCampaignPlanningQueryVariables>;
export const UpdateChecklistCampaignPlanningDocument = gql`
    mutation UpdateChecklistCampaignPlanning($campaignPlanning: UpdateCampaignPlanningSectionInput!) {
  updateChecklist(input: {campaignPlanning: $campaignPlanning}) {
    ...ChecklistCampaignPlanning
  }
}
    ${ChecklistCampaignPlanningFragmentDoc}`;
export type UpdateChecklistCampaignPlanningMutationFn = Apollo.MutationFunction<Types.UpdateChecklistCampaignPlanningMutation, Types.UpdateChecklistCampaignPlanningMutationVariables>;

/**
 * __useUpdateChecklistCampaignPlanningMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistCampaignPlanningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistCampaignPlanningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistCampaignPlanningMutation, { data, loading, error }] = useUpdateChecklistCampaignPlanningMutation({
 *   variables: {
 *      campaignPlanning: // value for 'campaignPlanning'
 *   },
 * });
 */
export function useUpdateChecklistCampaignPlanningMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistCampaignPlanningMutation, Types.UpdateChecklistCampaignPlanningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistCampaignPlanningMutation, Types.UpdateChecklistCampaignPlanningMutationVariables>(UpdateChecklistCampaignPlanningDocument, options);
      }
export type UpdateChecklistCampaignPlanningMutationHookResult = ReturnType<typeof useUpdateChecklistCampaignPlanningMutation>;
export type UpdateChecklistCampaignPlanningMutationResult = Apollo.MutationResult<Types.UpdateChecklistCampaignPlanningMutation>;
export type UpdateChecklistCampaignPlanningMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistCampaignPlanningMutation, Types.UpdateChecklistCampaignPlanningMutationVariables>;
export const ChecklistCompetitiveIntelDocument = gql`
    query ChecklistCompetitiveIntel {
  checklist {
    ...ChecklistCompetitiveIntel
  }
}
    ${ChecklistCompetitiveIntelFragmentDoc}`;

/**
 * __useChecklistCompetitiveIntelQuery__
 *
 * To run a query within a React component, call `useChecklistCompetitiveIntelQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistCompetitiveIntelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistCompetitiveIntelQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistCompetitiveIntelQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistCompetitiveIntelQuery, Types.ChecklistCompetitiveIntelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistCompetitiveIntelQuery, Types.ChecklistCompetitiveIntelQueryVariables>(ChecklistCompetitiveIntelDocument, options);
      }
export function useChecklistCompetitiveIntelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistCompetitiveIntelQuery, Types.ChecklistCompetitiveIntelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistCompetitiveIntelQuery, Types.ChecklistCompetitiveIntelQueryVariables>(ChecklistCompetitiveIntelDocument, options);
        }
export type ChecklistCompetitiveIntelQueryHookResult = ReturnType<typeof useChecklistCompetitiveIntelQuery>;
export type ChecklistCompetitiveIntelLazyQueryHookResult = ReturnType<typeof useChecklistCompetitiveIntelLazyQuery>;
export type ChecklistCompetitiveIntelQueryResult = Apollo.QueryResult<Types.ChecklistCompetitiveIntelQuery, Types.ChecklistCompetitiveIntelQueryVariables>;
export const UpdateChecklistCompetitiveIntelDocument = gql`
    mutation UpdateChecklistCompetitiveIntel($competitiveIntel: UpdateCompetitiveIntelSectionInput!) {
  updateChecklist(input: {competitiveIntel: $competitiveIntel}) {
    ...ChecklistCompetitiveIntel
  }
}
    ${ChecklistCompetitiveIntelFragmentDoc}`;
export type UpdateChecklistCompetitiveIntelMutationFn = Apollo.MutationFunction<Types.UpdateChecklistCompetitiveIntelMutation, Types.UpdateChecklistCompetitiveIntelMutationVariables>;

/**
 * __useUpdateChecklistCompetitiveIntelMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistCompetitiveIntelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistCompetitiveIntelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistCompetitiveIntelMutation, { data, loading, error }] = useUpdateChecklistCompetitiveIntelMutation({
 *   variables: {
 *      competitiveIntel: // value for 'competitiveIntel'
 *   },
 * });
 */
export function useUpdateChecklistCompetitiveIntelMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistCompetitiveIntelMutation, Types.UpdateChecklistCompetitiveIntelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistCompetitiveIntelMutation, Types.UpdateChecklistCompetitiveIntelMutationVariables>(UpdateChecklistCompetitiveIntelDocument, options);
      }
export type UpdateChecklistCompetitiveIntelMutationHookResult = ReturnType<typeof useUpdateChecklistCompetitiveIntelMutation>;
export type UpdateChecklistCompetitiveIntelMutationResult = Apollo.MutationResult<Types.UpdateChecklistCompetitiveIntelMutation>;
export type UpdateChecklistCompetitiveIntelMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistCompetitiveIntelMutation, Types.UpdateChecklistCompetitiveIntelMutationVariables>;
export const FillOrganizationWithOnboardingDataDocument = gql`
    mutation FillOrganizationWithOnboardingData($input: FillOrganizationWithOnboardingDataInput!) {
  fillOrganizationWithOnboardingData(input: $input) {
    id
    logo
    aiSettings {
      companyName
      companyWebsite
      companyDescription
      brandGuidelines
    }
  }
}
    `;
export type FillOrganizationWithOnboardingDataMutationFn = Apollo.MutationFunction<Types.FillOrganizationWithOnboardingDataMutation, Types.FillOrganizationWithOnboardingDataMutationVariables>;

/**
 * __useFillOrganizationWithOnboardingDataMutation__
 *
 * To run a mutation, you first call `useFillOrganizationWithOnboardingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillOrganizationWithOnboardingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillOrganizationWithOnboardingDataMutation, { data, loading, error }] = useFillOrganizationWithOnboardingDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillOrganizationWithOnboardingDataMutation(baseOptions?: Apollo.MutationHookOptions<Types.FillOrganizationWithOnboardingDataMutation, Types.FillOrganizationWithOnboardingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.FillOrganizationWithOnboardingDataMutation, Types.FillOrganizationWithOnboardingDataMutationVariables>(FillOrganizationWithOnboardingDataDocument, options);
      }
export type FillOrganizationWithOnboardingDataMutationHookResult = ReturnType<typeof useFillOrganizationWithOnboardingDataMutation>;
export type FillOrganizationWithOnboardingDataMutationResult = Apollo.MutationResult<Types.FillOrganizationWithOnboardingDataMutation>;
export type FillOrganizationWithOnboardingDataMutationOptions = Apollo.BaseMutationOptions<Types.FillOrganizationWithOnboardingDataMutation, Types.FillOrganizationWithOnboardingDataMutationVariables>;
export const UpdateChecklistWorkspaceConfigDocument = gql`
    mutation UpdateChecklistWorkspaceConfig($workspaceConfig: UpdateWorkspaceConfigSectionInput!) {
  updateChecklist(input: {workspaceConfig: $workspaceConfig}) {
    ...ChecklistWorkspaceConfig
  }
}
    ${ChecklistWorkspaceConfigFragmentDoc}`;
export type UpdateChecklistWorkspaceConfigMutationFn = Apollo.MutationFunction<Types.UpdateChecklistWorkspaceConfigMutation, Types.UpdateChecklistWorkspaceConfigMutationVariables>;

/**
 * __useUpdateChecklistWorkspaceConfigMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistWorkspaceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistWorkspaceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistWorkspaceConfigMutation, { data, loading, error }] = useUpdateChecklistWorkspaceConfigMutation({
 *   variables: {
 *      workspaceConfig: // value for 'workspaceConfig'
 *   },
 * });
 */
export function useUpdateChecklistWorkspaceConfigMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistWorkspaceConfigMutation, Types.UpdateChecklistWorkspaceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistWorkspaceConfigMutation, Types.UpdateChecklistWorkspaceConfigMutationVariables>(UpdateChecklistWorkspaceConfigDocument, options);
      }
export type UpdateChecklistWorkspaceConfigMutationHookResult = ReturnType<typeof useUpdateChecklistWorkspaceConfigMutation>;
export type UpdateChecklistWorkspaceConfigMutationResult = Apollo.MutationResult<Types.UpdateChecklistWorkspaceConfigMutation>;
export type UpdateChecklistWorkspaceConfigMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistWorkspaceConfigMutation, Types.UpdateChecklistWorkspaceConfigMutationVariables>;
export const ChecklistWorkspaceConfigDocument = gql`
    query ChecklistWorkspaceConfig {
  checklist {
    ...ChecklistWorkspaceConfig
  }
}
    ${ChecklistWorkspaceConfigFragmentDoc}`;

/**
 * __useChecklistWorkspaceConfigQuery__
 *
 * To run a query within a React component, call `useChecklistWorkspaceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistWorkspaceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistWorkspaceConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistWorkspaceConfigQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistWorkspaceConfigQuery, Types.ChecklistWorkspaceConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistWorkspaceConfigQuery, Types.ChecklistWorkspaceConfigQueryVariables>(ChecklistWorkspaceConfigDocument, options);
      }
export function useChecklistWorkspaceConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistWorkspaceConfigQuery, Types.ChecklistWorkspaceConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistWorkspaceConfigQuery, Types.ChecklistWorkspaceConfigQueryVariables>(ChecklistWorkspaceConfigDocument, options);
        }
export type ChecklistWorkspaceConfigQueryHookResult = ReturnType<typeof useChecklistWorkspaceConfigQuery>;
export type ChecklistWorkspaceConfigLazyQueryHookResult = ReturnType<typeof useChecklistWorkspaceConfigLazyQuery>;
export type ChecklistWorkspaceConfigQueryResult = Apollo.QueryResult<Types.ChecklistWorkspaceConfigQuery, Types.ChecklistWorkspaceConfigQueryVariables>;
export const CompanyInfoFromWebsiteDocument = gql`
    query CompanyInfoFromWebsite($companyDomain: String, $refresh: Boolean) {
  companyInfoFromWebsite(companyDomain: $companyDomain, refresh: $refresh) {
    ...CompanyInfoFromWebsite
  }
}
    ${CompanyInfoFromWebsiteFragmentDoc}`;

/**
 * __useCompanyInfoFromWebsiteQuery__
 *
 * To run a query within a React component, call `useCompanyInfoFromWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInfoFromWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInfoFromWebsiteQuery({
 *   variables: {
 *      companyDomain: // value for 'companyDomain'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useCompanyInfoFromWebsiteQuery(baseOptions?: Apollo.QueryHookOptions<Types.CompanyInfoFromWebsiteQuery, Types.CompanyInfoFromWebsiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CompanyInfoFromWebsiteQuery, Types.CompanyInfoFromWebsiteQueryVariables>(CompanyInfoFromWebsiteDocument, options);
      }
export function useCompanyInfoFromWebsiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CompanyInfoFromWebsiteQuery, Types.CompanyInfoFromWebsiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CompanyInfoFromWebsiteQuery, Types.CompanyInfoFromWebsiteQueryVariables>(CompanyInfoFromWebsiteDocument, options);
        }
export type CompanyInfoFromWebsiteQueryHookResult = ReturnType<typeof useCompanyInfoFromWebsiteQuery>;
export type CompanyInfoFromWebsiteLazyQueryHookResult = ReturnType<typeof useCompanyInfoFromWebsiteLazyQuery>;
export type CompanyInfoFromWebsiteQueryResult = Apollo.QueryResult<Types.CompanyInfoFromWebsiteQuery, Types.CompanyInfoFromWebsiteQueryVariables>;
export const ChecklistRoadmappingDocument = gql`
    query ChecklistRoadmapping {
  checklist {
    ...ChecklistRoadmapping
  }
}
    ${ChecklistRoadmappingFragmentDoc}`;

/**
 * __useChecklistRoadmappingQuery__
 *
 * To run a query within a React component, call `useChecklistRoadmappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistRoadmappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistRoadmappingQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistRoadmappingQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistRoadmappingQuery, Types.ChecklistRoadmappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistRoadmappingQuery, Types.ChecklistRoadmappingQueryVariables>(ChecklistRoadmappingDocument, options);
      }
export function useChecklistRoadmappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistRoadmappingQuery, Types.ChecklistRoadmappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistRoadmappingQuery, Types.ChecklistRoadmappingQueryVariables>(ChecklistRoadmappingDocument, options);
        }
export type ChecklistRoadmappingQueryHookResult = ReturnType<typeof useChecklistRoadmappingQuery>;
export type ChecklistRoadmappingLazyQueryHookResult = ReturnType<typeof useChecklistRoadmappingLazyQuery>;
export type ChecklistRoadmappingQueryResult = Apollo.QueryResult<Types.ChecklistRoadmappingQuery, Types.ChecklistRoadmappingQueryVariables>;
export const UpdateChecklistRoadmappingDocument = gql`
    mutation UpdateChecklistRoadmapping($roadmapping: UpdateRoadmappingSectionInput!) {
  updateChecklist(input: {roadmapping: $roadmapping}) {
    ...ChecklistRoadmapping
  }
}
    ${ChecklistRoadmappingFragmentDoc}`;
export type UpdateChecklistRoadmappingMutationFn = Apollo.MutationFunction<Types.UpdateChecklistRoadmappingMutation, Types.UpdateChecklistRoadmappingMutationVariables>;

/**
 * __useUpdateChecklistRoadmappingMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistRoadmappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistRoadmappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistRoadmappingMutation, { data, loading, error }] = useUpdateChecklistRoadmappingMutation({
 *   variables: {
 *      roadmapping: // value for 'roadmapping'
 *   },
 * });
 */
export function useUpdateChecklistRoadmappingMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistRoadmappingMutation, Types.UpdateChecklistRoadmappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistRoadmappingMutation, Types.UpdateChecklistRoadmappingMutationVariables>(UpdateChecklistRoadmappingDocument, options);
      }
export type UpdateChecklistRoadmappingMutationHookResult = ReturnType<typeof useUpdateChecklistRoadmappingMutation>;
export type UpdateChecklistRoadmappingMutationResult = Apollo.MutationResult<Types.UpdateChecklistRoadmappingMutation>;
export type UpdateChecklistRoadmappingMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistRoadmappingMutation, Types.UpdateChecklistRoadmappingMutationVariables>;
export const ChecklistVoiceOfCustomerDocument = gql`
    query ChecklistVoiceOfCustomer {
  checklist {
    ...ChecklistVoiceOfCustomer
  }
}
    ${ChecklistVoiceOfCustomerFragmentDoc}`;

/**
 * __useChecklistVoiceOfCustomerQuery__
 *
 * To run a query within a React component, call `useChecklistVoiceOfCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistVoiceOfCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistVoiceOfCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistVoiceOfCustomerQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistVoiceOfCustomerQuery, Types.ChecklistVoiceOfCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistVoiceOfCustomerQuery, Types.ChecklistVoiceOfCustomerQueryVariables>(ChecklistVoiceOfCustomerDocument, options);
      }
export function useChecklistVoiceOfCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistVoiceOfCustomerQuery, Types.ChecklistVoiceOfCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistVoiceOfCustomerQuery, Types.ChecklistVoiceOfCustomerQueryVariables>(ChecklistVoiceOfCustomerDocument, options);
        }
export type ChecklistVoiceOfCustomerQueryHookResult = ReturnType<typeof useChecklistVoiceOfCustomerQuery>;
export type ChecklistVoiceOfCustomerLazyQueryHookResult = ReturnType<typeof useChecklistVoiceOfCustomerLazyQuery>;
export type ChecklistVoiceOfCustomerQueryResult = Apollo.QueryResult<Types.ChecklistVoiceOfCustomerQuery, Types.ChecklistVoiceOfCustomerQueryVariables>;
export const UpdateChecklistVoiceOfCustomerDocument = gql`
    mutation UpdateChecklistVoiceOfCustomer($voiceOfCustomer: UpdateVoiceOfCustomerSectionInput!) {
  updateChecklist(input: {voiceOfCustomer: $voiceOfCustomer}) {
    ...ChecklistVoiceOfCustomer
  }
}
    ${ChecklistVoiceOfCustomerFragmentDoc}`;
export type UpdateChecklistVoiceOfCustomerMutationFn = Apollo.MutationFunction<Types.UpdateChecklistVoiceOfCustomerMutation, Types.UpdateChecklistVoiceOfCustomerMutationVariables>;

/**
 * __useUpdateChecklistVoiceOfCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistVoiceOfCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistVoiceOfCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistVoiceOfCustomerMutation, { data, loading, error }] = useUpdateChecklistVoiceOfCustomerMutation({
 *   variables: {
 *      voiceOfCustomer: // value for 'voiceOfCustomer'
 *   },
 * });
 */
export function useUpdateChecklistVoiceOfCustomerMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistVoiceOfCustomerMutation, Types.UpdateChecklistVoiceOfCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistVoiceOfCustomerMutation, Types.UpdateChecklistVoiceOfCustomerMutationVariables>(UpdateChecklistVoiceOfCustomerDocument, options);
      }
export type UpdateChecklistVoiceOfCustomerMutationHookResult = ReturnType<typeof useUpdateChecklistVoiceOfCustomerMutation>;
export type UpdateChecklistVoiceOfCustomerMutationResult = Apollo.MutationResult<Types.UpdateChecklistVoiceOfCustomerMutation>;
export type UpdateChecklistVoiceOfCustomerMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistVoiceOfCustomerMutation, Types.UpdateChecklistVoiceOfCustomerMutationVariables>;
export const ChecklistWinlossAnalysisDocument = gql`
    query ChecklistWinlossAnalysis {
  checklist {
    ...ChecklistWinlossAnalysis
  }
}
    ${ChecklistWinlossAnalysisFragmentDoc}`;

/**
 * __useChecklistWinlossAnalysisQuery__
 *
 * To run a query within a React component, call `useChecklistWinlossAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistWinlossAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistWinlossAnalysisQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecklistWinlossAnalysisQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChecklistWinlossAnalysisQuery, Types.ChecklistWinlossAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChecklistWinlossAnalysisQuery, Types.ChecklistWinlossAnalysisQueryVariables>(ChecklistWinlossAnalysisDocument, options);
      }
export function useChecklistWinlossAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChecklistWinlossAnalysisQuery, Types.ChecklistWinlossAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChecklistWinlossAnalysisQuery, Types.ChecklistWinlossAnalysisQueryVariables>(ChecklistWinlossAnalysisDocument, options);
        }
export type ChecklistWinlossAnalysisQueryHookResult = ReturnType<typeof useChecklistWinlossAnalysisQuery>;
export type ChecklistWinlossAnalysisLazyQueryHookResult = ReturnType<typeof useChecklistWinlossAnalysisLazyQuery>;
export type ChecklistWinlossAnalysisQueryResult = Apollo.QueryResult<Types.ChecklistWinlossAnalysisQuery, Types.ChecklistWinlossAnalysisQueryVariables>;
export const UpdateChecklistWinlossAnalysisDocument = gql`
    mutation UpdateChecklistWinlossAnalysis($winloss: UpdateWinLossAnalysisSectionInput!) {
  updateChecklist(input: {winloss: $winloss}) {
    ...ChecklistWinlossAnalysis
  }
}
    ${ChecklistWinlossAnalysisFragmentDoc}`;
export type UpdateChecklistWinlossAnalysisMutationFn = Apollo.MutationFunction<Types.UpdateChecklistWinlossAnalysisMutation, Types.UpdateChecklistWinlossAnalysisMutationVariables>;

/**
 * __useUpdateChecklistWinlossAnalysisMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistWinlossAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistWinlossAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistWinlossAnalysisMutation, { data, loading, error }] = useUpdateChecklistWinlossAnalysisMutation({
 *   variables: {
 *      winloss: // value for 'winloss'
 *   },
 * });
 */
export function useUpdateChecklistWinlossAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChecklistWinlossAnalysisMutation, Types.UpdateChecklistWinlossAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChecklistWinlossAnalysisMutation, Types.UpdateChecklistWinlossAnalysisMutationVariables>(UpdateChecklistWinlossAnalysisDocument, options);
      }
export type UpdateChecklistWinlossAnalysisMutationHookResult = ReturnType<typeof useUpdateChecklistWinlossAnalysisMutation>;
export type UpdateChecklistWinlossAnalysisMutationResult = Apollo.MutationResult<Types.UpdateChecklistWinlossAnalysisMutation>;
export type UpdateChecklistWinlossAnalysisMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChecklistWinlossAnalysisMutation, Types.UpdateChecklistWinlossAnalysisMutationVariables>;
export const GenerateMessagingSummaryDocument = gql`
    mutation GenerateMessagingSummary($competitorName: String!, $competitorURL: String!) {
  generateCompetitorCompanyMessagingSummary(
    competitorName: $competitorName
    competitorURL: $competitorURL
  )
}
    `;
export type GenerateMessagingSummaryMutationFn = Apollo.MutationFunction<Types.GenerateMessagingSummaryMutation, Types.GenerateMessagingSummaryMutationVariables>;

/**
 * __useGenerateMessagingSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateMessagingSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMessagingSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMessagingSummaryMutation, { data, loading, error }] = useGenerateMessagingSummaryMutation({
 *   variables: {
 *      competitorName: // value for 'competitorName'
 *      competitorURL: // value for 'competitorURL'
 *   },
 * });
 */
export function useGenerateMessagingSummaryMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateMessagingSummaryMutation, Types.GenerateMessagingSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateMessagingSummaryMutation, Types.GenerateMessagingSummaryMutationVariables>(GenerateMessagingSummaryDocument, options);
      }
export type GenerateMessagingSummaryMutationHookResult = ReturnType<typeof useGenerateMessagingSummaryMutation>;
export type GenerateMessagingSummaryMutationResult = Apollo.MutationResult<Types.GenerateMessagingSummaryMutation>;
export type GenerateMessagingSummaryMutationOptions = Apollo.BaseMutationOptions<Types.GenerateMessagingSummaryMutation, Types.GenerateMessagingSummaryMutationVariables>;
export const CreateFeatureDocument = gql`
    mutation CreateFeature($input: CreateCompetitiveIntelligenceFeaturesInput!) {
  createCompetitiveIntelligenceFeature(input: $input) {
    name
    competitorBattlecardId
  }
}
    `;
export type CreateFeatureMutationFn = Apollo.MutationFunction<Types.CreateFeatureMutation, Types.CreateFeatureMutationVariables>;

/**
 * __useCreateFeatureMutation__
 *
 * To run a mutation, you first call `useCreateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureMutation, { data, loading, error }] = useCreateFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFeatureMutation, Types.CreateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFeatureMutation, Types.CreateFeatureMutationVariables>(CreateFeatureDocument, options);
      }
export type CreateFeatureMutationHookResult = ReturnType<typeof useCreateFeatureMutation>;
export type CreateFeatureMutationResult = Apollo.MutationResult<Types.CreateFeatureMutation>;
export type CreateFeatureMutationOptions = Apollo.BaseMutationOptions<Types.CreateFeatureMutation, Types.CreateFeatureMutationVariables>;
export const CreateFeatureCategoryDocument = gql`
    mutation CreateFeatureCategory($input: CreateFeatureTableCategoryInput!) {
  createFeatureTableCategory(input: $input) {
    id
    name
    competitorBattlecardId
  }
}
    `;
export type CreateFeatureCategoryMutationFn = Apollo.MutationFunction<Types.CreateFeatureCategoryMutation, Types.CreateFeatureCategoryMutationVariables>;

/**
 * __useCreateFeatureCategoryMutation__
 *
 * To run a mutation, you first call `useCreateFeatureCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureCategoryMutation, { data, loading, error }] = useCreateFeatureCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeatureCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFeatureCategoryMutation, Types.CreateFeatureCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFeatureCategoryMutation, Types.CreateFeatureCategoryMutationVariables>(CreateFeatureCategoryDocument, options);
      }
export type CreateFeatureCategoryMutationHookResult = ReturnType<typeof useCreateFeatureCategoryMutation>;
export type CreateFeatureCategoryMutationResult = Apollo.MutationResult<Types.CreateFeatureCategoryMutation>;
export type CreateFeatureCategoryMutationOptions = Apollo.BaseMutationOptions<Types.CreateFeatureCategoryMutation, Types.CreateFeatureCategoryMutationVariables>;
export const DeleteFeatureDocument = gql`
    mutation DeleteFeature($featureIds: [String!]!) {
  deleteCompetitiveIntelligenceFeatures(featureIds: $featureIds)
}
    `;
export type DeleteFeatureMutationFn = Apollo.MutationFunction<Types.DeleteFeatureMutation, Types.DeleteFeatureMutationVariables>;

/**
 * __useDeleteFeatureMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureMutation, { data, loading, error }] = useDeleteFeatureMutation({
 *   variables: {
 *      featureIds: // value for 'featureIds'
 *   },
 * });
 */
export function useDeleteFeatureMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeatureMutation, Types.DeleteFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeatureMutation, Types.DeleteFeatureMutationVariables>(DeleteFeatureDocument, options);
      }
export type DeleteFeatureMutationHookResult = ReturnType<typeof useDeleteFeatureMutation>;
export type DeleteFeatureMutationResult = Apollo.MutationResult<Types.DeleteFeatureMutation>;
export type DeleteFeatureMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeatureMutation, Types.DeleteFeatureMutationVariables>;
export const DeleteFeatureCategoryDocument = gql`
    mutation DeleteFeatureCategory($categoryIds: [String!]!) {
  deleteFeatureTableCategories(categoryIds: $categoryIds)
}
    `;
export type DeleteFeatureCategoryMutationFn = Apollo.MutationFunction<Types.DeleteFeatureCategoryMutation, Types.DeleteFeatureCategoryMutationVariables>;

/**
 * __useDeleteFeatureCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureCategoryMutation, { data, loading, error }] = useDeleteFeatureCategoryMutation({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *   },
 * });
 */
export function useDeleteFeatureCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeatureCategoryMutation, Types.DeleteFeatureCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeatureCategoryMutation, Types.DeleteFeatureCategoryMutationVariables>(DeleteFeatureCategoryDocument, options);
      }
export type DeleteFeatureCategoryMutationHookResult = ReturnType<typeof useDeleteFeatureCategoryMutation>;
export type DeleteFeatureCategoryMutationResult = Apollo.MutationResult<Types.DeleteFeatureCategoryMutation>;
export type DeleteFeatureCategoryMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeatureCategoryMutation, Types.DeleteFeatureCategoryMutationVariables>;
export const FeatureCategoriesDocument = gql`
    query FeatureCategories($battlecardId: String!) {
  featureTableCategories(input: {competitorBattlecardId: $battlecardId}) {
    id
    name
  }
}
    `;

/**
 * __useFeatureCategoriesQuery__
 *
 * To run a query within a React component, call `useFeatureCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureCategoriesQuery({
 *   variables: {
 *      battlecardId: // value for 'battlecardId'
 *   },
 * });
 */
export function useFeatureCategoriesQuery(baseOptions: Apollo.QueryHookOptions<Types.FeatureCategoriesQuery, Types.FeatureCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeatureCategoriesQuery, Types.FeatureCategoriesQueryVariables>(FeatureCategoriesDocument, options);
      }
export function useFeatureCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeatureCategoriesQuery, Types.FeatureCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeatureCategoriesQuery, Types.FeatureCategoriesQueryVariables>(FeatureCategoriesDocument, options);
        }
export type FeatureCategoriesQueryHookResult = ReturnType<typeof useFeatureCategoriesQuery>;
export type FeatureCategoriesLazyQueryHookResult = ReturnType<typeof useFeatureCategoriesLazyQuery>;
export type FeatureCategoriesQueryResult = Apollo.QueryResult<Types.FeatureCategoriesQuery, Types.FeatureCategoriesQueryVariables>;
export const FeatureTableStatusDocument = gql`
    query FeatureTableStatus($battlecardId: String!) {
  featureTable(input: {competitorBattlecardId: $battlecardId}) {
    ...CompanyFeatureTableStatus
  }
}
    ${CompanyFeatureTableStatusFragmentDoc}`;

/**
 * __useFeatureTableStatusQuery__
 *
 * To run a query within a React component, call `useFeatureTableStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureTableStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureTableStatusQuery({
 *   variables: {
 *      battlecardId: // value for 'battlecardId'
 *   },
 * });
 */
export function useFeatureTableStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.FeatureTableStatusQuery, Types.FeatureTableStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeatureTableStatusQuery, Types.FeatureTableStatusQueryVariables>(FeatureTableStatusDocument, options);
      }
export function useFeatureTableStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeatureTableStatusQuery, Types.FeatureTableStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeatureTableStatusQuery, Types.FeatureTableStatusQueryVariables>(FeatureTableStatusDocument, options);
        }
export type FeatureTableStatusQueryHookResult = ReturnType<typeof useFeatureTableStatusQuery>;
export type FeatureTableStatusLazyQueryHookResult = ReturnType<typeof useFeatureTableStatusLazyQuery>;
export type FeatureTableStatusQueryResult = Apollo.QueryResult<Types.FeatureTableStatusQuery, Types.FeatureTableStatusQueryVariables>;
export const FeaturesDocument = gql`
    query Features($battlecardId: String!) {
  competitiveIntelligenceFeatures(
    input: {competitorBattlecardId: $battlecardId}
    filter: {}
  ) {
    ...CompanyFeature
  }
}
    ${CompanyFeatureFragmentDoc}`;

/**
 * __useFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesQuery({
 *   variables: {
 *      battlecardId: // value for 'battlecardId'
 *   },
 * });
 */
export function useFeaturesQuery(baseOptions: Apollo.QueryHookOptions<Types.FeaturesQuery, Types.FeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FeaturesQuery, Types.FeaturesQueryVariables>(FeaturesDocument, options);
      }
export function useFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FeaturesQuery, Types.FeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FeaturesQuery, Types.FeaturesQueryVariables>(FeaturesDocument, options);
        }
export type FeaturesQueryHookResult = ReturnType<typeof useFeaturesQuery>;
export type FeaturesLazyQueryHookResult = ReturnType<typeof useFeaturesLazyQuery>;
export type FeaturesQueryResult = Apollo.QueryResult<Types.FeaturesQuery, Types.FeaturesQueryVariables>;
export const GenerateFeatureTableDocument = gql`
    mutation GenerateFeatureTable($input: GenerateFeatureTableInput!) {
  generateFeatureTable(input: $input)
}
    `;
export type GenerateFeatureTableMutationFn = Apollo.MutationFunction<Types.GenerateFeatureTableMutation, Types.GenerateFeatureTableMutationVariables>;

/**
 * __useGenerateFeatureTableMutation__
 *
 * To run a mutation, you first call `useGenerateFeatureTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFeatureTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFeatureTableMutation, { data, loading, error }] = useGenerateFeatureTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateFeatureTableMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateFeatureTableMutation, Types.GenerateFeatureTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateFeatureTableMutation, Types.GenerateFeatureTableMutationVariables>(GenerateFeatureTableDocument, options);
      }
export type GenerateFeatureTableMutationHookResult = ReturnType<typeof useGenerateFeatureTableMutation>;
export type GenerateFeatureTableMutationResult = Apollo.MutationResult<Types.GenerateFeatureTableMutation>;
export type GenerateFeatureTableMutationOptions = Apollo.BaseMutationOptions<Types.GenerateFeatureTableMutation, Types.GenerateFeatureTableMutationVariables>;
export const UpdateFeatureDocument = gql`
    mutation UpdateFeature($input: UpdateCompetitiveIntelligenceFeaturesInput!) {
  updateCompetitiveIntelligenceFeature(input: $input) {
    ...CompanyFeature
  }
}
    ${CompanyFeatureFragmentDoc}`;
export type UpdateFeatureMutationFn = Apollo.MutationFunction<Types.UpdateFeatureMutation, Types.UpdateFeatureMutationVariables>;

/**
 * __useUpdateFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureMutation, { data, loading, error }] = useUpdateFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeatureMutation, Types.UpdateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeatureMutation, Types.UpdateFeatureMutationVariables>(UpdateFeatureDocument, options);
      }
export type UpdateFeatureMutationHookResult = ReturnType<typeof useUpdateFeatureMutation>;
export type UpdateFeatureMutationResult = Apollo.MutationResult<Types.UpdateFeatureMutation>;
export type UpdateFeatureMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeatureMutation, Types.UpdateFeatureMutationVariables>;
export const UpdateFeatureCategoryDocument = gql`
    mutation UpdateFeatureCategory($input: UpdateFeatureTableCategoryInput!) {
  updateFeatureTableCategory(input: $input) {
    id
    name
  }
}
    `;
export type UpdateFeatureCategoryMutationFn = Apollo.MutationFunction<Types.UpdateFeatureCategoryMutation, Types.UpdateFeatureCategoryMutationVariables>;

/**
 * __useUpdateFeatureCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureCategoryMutation, { data, loading, error }] = useUpdateFeatureCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeatureCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeatureCategoryMutation, Types.UpdateFeatureCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeatureCategoryMutation, Types.UpdateFeatureCategoryMutationVariables>(UpdateFeatureCategoryDocument, options);
      }
export type UpdateFeatureCategoryMutationHookResult = ReturnType<typeof useUpdateFeatureCategoryMutation>;
export type UpdateFeatureCategoryMutationResult = Apollo.MutationResult<Types.UpdateFeatureCategoryMutation>;
export type UpdateFeatureCategoryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeatureCategoryMutation, Types.UpdateFeatureCategoryMutationVariables>;
export const UpdateUserNotificationPreferencesDocument = gql`
    mutation UpdateUserNotificationPreferences($id: String!, $notificationPreferences: NotificationPreferencesInput!) {
  updateUserNotificationPreferences: updateUser(
    input: {id: $id, notificationPreferences: $notificationPreferences}
  ) {
    id
    notificationPreferences {
      ...UserNotificationsPreferences
    }
  }
}
    ${UserNotificationsPreferencesFragmentDoc}`;
export type UpdateUserNotificationPreferencesMutationFn = Apollo.MutationFunction<Types.UpdateUserNotificationPreferencesMutation, Types.UpdateUserNotificationPreferencesMutationVariables>;

/**
 * __useUpdateUserNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationPreferencesMutation, { data, loading, error }] = useUpdateUserNotificationPreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notificationPreferences: // value for 'notificationPreferences'
 *   },
 * });
 */
export function useUpdateUserNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserNotificationPreferencesMutation, Types.UpdateUserNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserNotificationPreferencesMutation, Types.UpdateUserNotificationPreferencesMutationVariables>(UpdateUserNotificationPreferencesDocument, options);
      }
export type UpdateUserNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateUserNotificationPreferencesMutation>;
export type UpdateUserNotificationPreferencesMutationResult = Apollo.MutationResult<Types.UpdateUserNotificationPreferencesMutation>;
export type UpdateUserNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserNotificationPreferencesMutation, Types.UpdateUserNotificationPreferencesMutationVariables>;
export const UserNotificationsPreferencesDocument = gql`
    query UserNotificationsPreferences($id: String!) {
  user(id: $id) {
    id
    notificationPreferences {
      ...UserNotificationsPreferences
    }
  }
}
    ${UserNotificationsPreferencesFragmentDoc}`;

/**
 * __useUserNotificationsPreferencesQuery__
 *
 * To run a query within a React component, call `useUserNotificationsPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserNotificationsPreferencesQuery(baseOptions: Apollo.QueryHookOptions<Types.UserNotificationsPreferencesQuery, Types.UserNotificationsPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UserNotificationsPreferencesQuery, Types.UserNotificationsPreferencesQueryVariables>(UserNotificationsPreferencesDocument, options);
      }
export function useUserNotificationsPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UserNotificationsPreferencesQuery, Types.UserNotificationsPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UserNotificationsPreferencesQuery, Types.UserNotificationsPreferencesQueryVariables>(UserNotificationsPreferencesDocument, options);
        }
export type UserNotificationsPreferencesQueryHookResult = ReturnType<typeof useUserNotificationsPreferencesQuery>;
export type UserNotificationsPreferencesLazyQueryHookResult = ReturnType<typeof useUserNotificationsPreferencesLazyQuery>;
export type UserNotificationsPreferencesQueryResult = Apollo.QueryResult<Types.UserNotificationsPreferencesQuery, Types.UserNotificationsPreferencesQueryVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount {
  deleteUserData
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<Types.DeleteAccountMutation, Types.DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAccountMutation, Types.DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAccountMutation, Types.DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<Types.DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAccountMutation, Types.DeleteAccountMutationVariables>;
export const SetNewPasswordDocument = gql`
    mutation SetNewPassword($input: ResetPasswordInput!) {
  setNewPassword(input: $input) {
    ...AuthorizationData
  }
}
    ${AuthorizationDataFragmentDoc}`;
export type SetNewPasswordMutationFn = Apollo.MutationFunction<Types.SetNewPasswordMutation, Types.SetNewPasswordMutationVariables>;

/**
 * __useSetNewPasswordMutation__
 *
 * To run a mutation, you first call `useSetNewPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewPasswordMutation, { data, loading, error }] = useSetNewPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNewPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetNewPasswordMutation, Types.SetNewPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetNewPasswordMutation, Types.SetNewPasswordMutationVariables>(SetNewPasswordDocument, options);
      }
export type SetNewPasswordMutationHookResult = ReturnType<typeof useSetNewPasswordMutation>;
export type SetNewPasswordMutationResult = Apollo.MutationResult<Types.SetNewPasswordMutation>;
export type SetNewPasswordMutationOptions = Apollo.BaseMutationOptions<Types.SetNewPasswordMutation, Types.SetNewPasswordMutationVariables>;
export const UpdateUserPersonaInfoDocument = gql`
    mutation UpdateUserPersonaInfo($id: String!, $email: String!, $name: String, $profileImage: String) {
  updateUserPersonaInfo: updateUser(
    input: {id: $id, email: $email, name: $name, profileImage: $profileImage}
  ) {
    id
    name
    email
    profileImage
  }
}
    `;
export type UpdateUserPersonaInfoMutationFn = Apollo.MutationFunction<Types.UpdateUserPersonaInfoMutation, Types.UpdateUserPersonaInfoMutationVariables>;

/**
 * __useUpdateUserPersonaInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserPersonaInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPersonaInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPersonaInfoMutation, { data, loading, error }] = useUpdateUserPersonaInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      profileImage: // value for 'profileImage'
 *   },
 * });
 */
export function useUpdateUserPersonaInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserPersonaInfoMutation, Types.UpdateUserPersonaInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserPersonaInfoMutation, Types.UpdateUserPersonaInfoMutationVariables>(UpdateUserPersonaInfoDocument, options);
      }
export type UpdateUserPersonaInfoMutationHookResult = ReturnType<typeof useUpdateUserPersonaInfoMutation>;
export type UpdateUserPersonaInfoMutationResult = Apollo.MutationResult<Types.UpdateUserPersonaInfoMutation>;
export type UpdateUserPersonaInfoMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserPersonaInfoMutation, Types.UpdateUserPersonaInfoMutationVariables>;
export const AccountFilterOptionsDocument = gql`
    query AccountFilterOptions {
  availableCDPAccountIndustries
  availableCDPAccountTypes
}
    `;

/**
 * __useAccountFilterOptionsQuery__
 *
 * To run a query within a React component, call `useAccountFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AccountFilterOptionsQuery, Types.AccountFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AccountFilterOptionsQuery, Types.AccountFilterOptionsQueryVariables>(AccountFilterOptionsDocument, options);
      }
export function useAccountFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AccountFilterOptionsQuery, Types.AccountFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AccountFilterOptionsQuery, Types.AccountFilterOptionsQueryVariables>(AccountFilterOptionsDocument, options);
        }
export type AccountFilterOptionsQueryHookResult = ReturnType<typeof useAccountFilterOptionsQuery>;
export type AccountFilterOptionsLazyQueryHookResult = ReturnType<typeof useAccountFilterOptionsLazyQuery>;
export type AccountFilterOptionsQueryResult = Apollo.QueryResult<Types.AccountFilterOptionsQuery, Types.AccountFilterOptionsQueryVariables>;
export const CdpAccountOptionsDocument = gql`
    query CDPAccountOptions {
  getCDPAccounts {
    ...CDPAccountFilterOptionData
  }
}
    ${CdpAccountFilterOptionDataFragmentDoc}`;

/**
 * __useCdpAccountOptionsQuery__
 *
 * To run a query within a React component, call `useCdpAccountOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCdpAccountOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCdpAccountOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCdpAccountOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CdpAccountOptionsQuery, Types.CdpAccountOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CdpAccountOptionsQuery, Types.CdpAccountOptionsQueryVariables>(CdpAccountOptionsDocument, options);
      }
export function useCdpAccountOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CdpAccountOptionsQuery, Types.CdpAccountOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CdpAccountOptionsQuery, Types.CdpAccountOptionsQueryVariables>(CdpAccountOptionsDocument, options);
        }
export type CdpAccountOptionsQueryHookResult = ReturnType<typeof useCdpAccountOptionsQuery>;
export type CdpAccountOptionsLazyQueryHookResult = ReturnType<typeof useCdpAccountOptionsLazyQuery>;
export type CdpAccountOptionsQueryResult = Apollo.QueryResult<Types.CdpAccountOptionsQuery, Types.CdpAccountOptionsQueryVariables>;
export const CreateCdpAccountDocument = gql`
    mutation CreateCDPAccount($input: CDPAccountCreateInput!) {
  createCDPAccount(input: $input) {
    ...CDPAccount
  }
}
    ${CdpAccountFragmentDoc}`;
export type CreateCdpAccountMutationFn = Apollo.MutationFunction<Types.CreateCdpAccountMutation, Types.CreateCdpAccountMutationVariables>;

/**
 * __useCreateCdpAccountMutation__
 *
 * To run a mutation, you first call `useCreateCdpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCdpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCdpAccountMutation, { data, loading, error }] = useCreateCdpAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCdpAccountMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCdpAccountMutation, Types.CreateCdpAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCdpAccountMutation, Types.CreateCdpAccountMutationVariables>(CreateCdpAccountDocument, options);
      }
export type CreateCdpAccountMutationHookResult = ReturnType<typeof useCreateCdpAccountMutation>;
export type CreateCdpAccountMutationResult = Apollo.MutationResult<Types.CreateCdpAccountMutation>;
export type CreateCdpAccountMutationOptions = Apollo.BaseMutationOptions<Types.CreateCdpAccountMutation, Types.CreateCdpAccountMutationVariables>;
export const DeleteCdpAccountDocument = gql`
    mutation DeleteCDPAccount($accountIds: [String!]!) {
  deleteCDPAccounts(accountIds: $accountIds)
}
    `;
export type DeleteCdpAccountMutationFn = Apollo.MutationFunction<Types.DeleteCdpAccountMutation, Types.DeleteCdpAccountMutationVariables>;

/**
 * __useDeleteCdpAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCdpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCdpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCdpAccountMutation, { data, loading, error }] = useDeleteCdpAccountMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useDeleteCdpAccountMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCdpAccountMutation, Types.DeleteCdpAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCdpAccountMutation, Types.DeleteCdpAccountMutationVariables>(DeleteCdpAccountDocument, options);
      }
export type DeleteCdpAccountMutationHookResult = ReturnType<typeof useDeleteCdpAccountMutation>;
export type DeleteCdpAccountMutationResult = Apollo.MutationResult<Types.DeleteCdpAccountMutation>;
export type DeleteCdpAccountMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCdpAccountMutation, Types.DeleteCdpAccountMutationVariables>;
export const PaginatedCdpAccountOptionsDocument = gql`
    query PaginatedCDPAccountOptions($pagination: PaginationInput!, $filter: CDPAccountItemsFilterInput, $sort: CDPAccountItemsSortInput) {
  paginatedCDPAccounts(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    docs {
      ...CDPAccountFilterOptionData
    }
  }
}
    ${CdpAccountFilterOptionDataFragmentDoc}`;

/**
 * __usePaginatedCdpAccountOptionsQuery__
 *
 * To run a query within a React component, call `usePaginatedCdpAccountOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCdpAccountOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCdpAccountOptionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCdpAccountOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedCdpAccountOptionsQuery, Types.PaginatedCdpAccountOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCdpAccountOptionsQuery, Types.PaginatedCdpAccountOptionsQueryVariables>(PaginatedCdpAccountOptionsDocument, options);
      }
export function usePaginatedCdpAccountOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCdpAccountOptionsQuery, Types.PaginatedCdpAccountOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCdpAccountOptionsQuery, Types.PaginatedCdpAccountOptionsQueryVariables>(PaginatedCdpAccountOptionsDocument, options);
        }
export type PaginatedCdpAccountOptionsQueryHookResult = ReturnType<typeof usePaginatedCdpAccountOptionsQuery>;
export type PaginatedCdpAccountOptionsLazyQueryHookResult = ReturnType<typeof usePaginatedCdpAccountOptionsLazyQuery>;
export type PaginatedCdpAccountOptionsQueryResult = Apollo.QueryResult<Types.PaginatedCdpAccountOptionsQuery, Types.PaginatedCdpAccountOptionsQueryVariables>;
export const PaginatedCdpAccountsDocument = gql`
    query PaginatedCDPAccounts($pagination: PaginationInput!, $filter: CDPAccountItemsFilterInput, $sort: CDPAccountItemsSortInput) {
  paginatedCDPAccounts(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    docs {
      ...CDPAccount
    }
  }
}
    ${CdpAccountFragmentDoc}`;

/**
 * __usePaginatedCdpAccountsQuery__
 *
 * To run a query within a React component, call `usePaginatedCdpAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCdpAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCdpAccountsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCdpAccountsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedCdpAccountsQuery, Types.PaginatedCdpAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCdpAccountsQuery, Types.PaginatedCdpAccountsQueryVariables>(PaginatedCdpAccountsDocument, options);
      }
export function usePaginatedCdpAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCdpAccountsQuery, Types.PaginatedCdpAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCdpAccountsQuery, Types.PaginatedCdpAccountsQueryVariables>(PaginatedCdpAccountsDocument, options);
        }
export type PaginatedCdpAccountsQueryHookResult = ReturnType<typeof usePaginatedCdpAccountsQuery>;
export type PaginatedCdpAccountsLazyQueryHookResult = ReturnType<typeof usePaginatedCdpAccountsLazyQuery>;
export type PaginatedCdpAccountsQueryResult = Apollo.QueryResult<Types.PaginatedCdpAccountsQuery, Types.PaginatedCdpAccountsQueryVariables>;
export const UpdateCdpAccountDocument = gql`
    mutation UpdateCDPAccount($input: CDPAccountUpdateInput!) {
  updateCDPAccount(input: $input) {
    ...CDPAccount
  }
}
    ${CdpAccountFragmentDoc}`;
export type UpdateCdpAccountMutationFn = Apollo.MutationFunction<Types.UpdateCdpAccountMutation, Types.UpdateCdpAccountMutationVariables>;

/**
 * __useUpdateCdpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCdpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCdpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCdpAccountMutation, { data, loading, error }] = useUpdateCdpAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCdpAccountMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCdpAccountMutation, Types.UpdateCdpAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCdpAccountMutation, Types.UpdateCdpAccountMutationVariables>(UpdateCdpAccountDocument, options);
      }
export type UpdateCdpAccountMutationHookResult = ReturnType<typeof useUpdateCdpAccountMutation>;
export type UpdateCdpAccountMutationResult = Apollo.MutationResult<Types.UpdateCdpAccountMutation>;
export type UpdateCdpAccountMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCdpAccountMutation, Types.UpdateCdpAccountMutationVariables>;
export const CdpContactOptionsDocument = gql`
    query CDPContactOptions($filter: CDPContactItemsFilterInput) {
  getCDPContacts(filter: $filter) {
    ...CDPContactFilterOptionData
  }
}
    ${CdpContactFilterOptionDataFragmentDoc}`;

/**
 * __useCdpContactOptionsQuery__
 *
 * To run a query within a React component, call `useCdpContactOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCdpContactOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCdpContactOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCdpContactOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CdpContactOptionsQuery, Types.CdpContactOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CdpContactOptionsQuery, Types.CdpContactOptionsQueryVariables>(CdpContactOptionsDocument, options);
      }
export function useCdpContactOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CdpContactOptionsQuery, Types.CdpContactOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CdpContactOptionsQuery, Types.CdpContactOptionsQueryVariables>(CdpContactOptionsDocument, options);
        }
export type CdpContactOptionsQueryHookResult = ReturnType<typeof useCdpContactOptionsQuery>;
export type CdpContactOptionsLazyQueryHookResult = ReturnType<typeof useCdpContactOptionsLazyQuery>;
export type CdpContactOptionsQueryResult = Apollo.QueryResult<Types.CdpContactOptionsQuery, Types.CdpContactOptionsQueryVariables>;
export const CdpOwnerOptionsDocument = gql`
    query CDPOwnerOptions($filter: CDPOwnerItemsFilterInput) {
  getCDPOwners(filter: $filter) {
    ...CDPOwnerFilterOptionData
  }
}
    ${CdpOwnerFilterOptionDataFragmentDoc}`;

/**
 * __useCdpOwnerOptionsQuery__
 *
 * To run a query within a React component, call `useCdpOwnerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCdpOwnerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCdpOwnerOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCdpOwnerOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CdpOwnerOptionsQuery, Types.CdpOwnerOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CdpOwnerOptionsQuery, Types.CdpOwnerOptionsQueryVariables>(CdpOwnerOptionsDocument, options);
      }
export function useCdpOwnerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CdpOwnerOptionsQuery, Types.CdpOwnerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CdpOwnerOptionsQuery, Types.CdpOwnerOptionsQueryVariables>(CdpOwnerOptionsDocument, options);
        }
export type CdpOwnerOptionsQueryHookResult = ReturnType<typeof useCdpOwnerOptionsQuery>;
export type CdpOwnerOptionsLazyQueryHookResult = ReturnType<typeof useCdpOwnerOptionsLazyQuery>;
export type CdpOwnerOptionsQueryResult = Apollo.QueryResult<Types.CdpOwnerOptionsQuery, Types.CdpOwnerOptionsQueryVariables>;
export const ContactFilterOptionsDocument = gql`
    query ContactFilterOptions {
  availableCDPContactStages
  availableCDPContactRoles
  getCDPAccounts {
    ...CDPAccountFilterOptionData
  }
  getCDPOwners {
    ...CDPOwnerFilterOptionData
  }
}
    ${CdpAccountFilterOptionDataFragmentDoc}
${CdpOwnerFilterOptionDataFragmentDoc}`;

/**
 * __useContactFilterOptionsQuery__
 *
 * To run a query within a React component, call `useContactFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ContactFilterOptionsQuery, Types.ContactFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContactFilterOptionsQuery, Types.ContactFilterOptionsQueryVariables>(ContactFilterOptionsDocument, options);
      }
export function useContactFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContactFilterOptionsQuery, Types.ContactFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContactFilterOptionsQuery, Types.ContactFilterOptionsQueryVariables>(ContactFilterOptionsDocument, options);
        }
export type ContactFilterOptionsQueryHookResult = ReturnType<typeof useContactFilterOptionsQuery>;
export type ContactFilterOptionsLazyQueryHookResult = ReturnType<typeof useContactFilterOptionsLazyQuery>;
export type ContactFilterOptionsQueryResult = Apollo.QueryResult<Types.ContactFilterOptionsQuery, Types.ContactFilterOptionsQueryVariables>;
export const CreateCdpContactDocument = gql`
    mutation CreateCDPContact($input: CDPContactCreateInput!) {
  createCDPContact(input: $input) {
    ...CDPContact
  }
}
    ${CdpContactFragmentDoc}`;
export type CreateCdpContactMutationFn = Apollo.MutationFunction<Types.CreateCdpContactMutation, Types.CreateCdpContactMutationVariables>;

/**
 * __useCreateCdpContactMutation__
 *
 * To run a mutation, you first call `useCreateCdpContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCdpContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCdpContactMutation, { data, loading, error }] = useCreateCdpContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCdpContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCdpContactMutation, Types.CreateCdpContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCdpContactMutation, Types.CreateCdpContactMutationVariables>(CreateCdpContactDocument, options);
      }
export type CreateCdpContactMutationHookResult = ReturnType<typeof useCreateCdpContactMutation>;
export type CreateCdpContactMutationResult = Apollo.MutationResult<Types.CreateCdpContactMutation>;
export type CreateCdpContactMutationOptions = Apollo.BaseMutationOptions<Types.CreateCdpContactMutation, Types.CreateCdpContactMutationVariables>;
export const CreateCdpOwnerDocument = gql`
    mutation CreateCDPOwner($input: CDPOwnerCreateInput!) {
  createCDPOwner(input: $input) {
    ...CDPOwner
  }
}
    ${CdpOwnerFragmentDoc}`;
export type CreateCdpOwnerMutationFn = Apollo.MutationFunction<Types.CreateCdpOwnerMutation, Types.CreateCdpOwnerMutationVariables>;

/**
 * __useCreateCdpOwnerMutation__
 *
 * To run a mutation, you first call `useCreateCdpOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCdpOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCdpOwnerMutation, { data, loading, error }] = useCreateCdpOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCdpOwnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCdpOwnerMutation, Types.CreateCdpOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCdpOwnerMutation, Types.CreateCdpOwnerMutationVariables>(CreateCdpOwnerDocument, options);
      }
export type CreateCdpOwnerMutationHookResult = ReturnType<typeof useCreateCdpOwnerMutation>;
export type CreateCdpOwnerMutationResult = Apollo.MutationResult<Types.CreateCdpOwnerMutation>;
export type CreateCdpOwnerMutationOptions = Apollo.BaseMutationOptions<Types.CreateCdpOwnerMutation, Types.CreateCdpOwnerMutationVariables>;
export const DeleteCdpContactsDocument = gql`
    mutation DeleteCDPContacts($contactIds: [String!]!) {
  deleteCDPContacts(contactIds: $contactIds)
}
    `;
export type DeleteCdpContactsMutationFn = Apollo.MutationFunction<Types.DeleteCdpContactsMutation, Types.DeleteCdpContactsMutationVariables>;

/**
 * __useDeleteCdpContactsMutation__
 *
 * To run a mutation, you first call `useDeleteCdpContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCdpContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCdpContactsMutation, { data, loading, error }] = useDeleteCdpContactsMutation({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useDeleteCdpContactsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCdpContactsMutation, Types.DeleteCdpContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCdpContactsMutation, Types.DeleteCdpContactsMutationVariables>(DeleteCdpContactsDocument, options);
      }
export type DeleteCdpContactsMutationHookResult = ReturnType<typeof useDeleteCdpContactsMutation>;
export type DeleteCdpContactsMutationResult = Apollo.MutationResult<Types.DeleteCdpContactsMutation>;
export type DeleteCdpContactsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCdpContactsMutation, Types.DeleteCdpContactsMutationVariables>;
export const PaginatedCdpContactOptionsDocument = gql`
    query PaginatedCDPContactOptions($pagination: PaginationInput!, $filter: CDPContactItemsFilterInput, $sort: CDPContactItemsSortInput) {
  paginatedCDPContacts(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    docs {
      ...CDPContactFilterOptionData
    }
  }
}
    ${CdpContactFilterOptionDataFragmentDoc}`;

/**
 * __usePaginatedCdpContactOptionsQuery__
 *
 * To run a query within a React component, call `usePaginatedCdpContactOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCdpContactOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCdpContactOptionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCdpContactOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedCdpContactOptionsQuery, Types.PaginatedCdpContactOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCdpContactOptionsQuery, Types.PaginatedCdpContactOptionsQueryVariables>(PaginatedCdpContactOptionsDocument, options);
      }
export function usePaginatedCdpContactOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCdpContactOptionsQuery, Types.PaginatedCdpContactOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCdpContactOptionsQuery, Types.PaginatedCdpContactOptionsQueryVariables>(PaginatedCdpContactOptionsDocument, options);
        }
export type PaginatedCdpContactOptionsQueryHookResult = ReturnType<typeof usePaginatedCdpContactOptionsQuery>;
export type PaginatedCdpContactOptionsLazyQueryHookResult = ReturnType<typeof usePaginatedCdpContactOptionsLazyQuery>;
export type PaginatedCdpContactOptionsQueryResult = Apollo.QueryResult<Types.PaginatedCdpContactOptionsQuery, Types.PaginatedCdpContactOptionsQueryVariables>;
export const PaginatedCdpContactsDocument = gql`
    query PaginatedCDPContacts($pagination: PaginationInput!, $filter: CDPContactItemsFilterInput, $sort: CDPContactItemsSortInput) {
  paginatedCDPContacts(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    docs {
      ...CDPContact
    }
  }
}
    ${CdpContactFragmentDoc}`;

/**
 * __usePaginatedCdpContactsQuery__
 *
 * To run a query within a React component, call `usePaginatedCdpContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCdpContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCdpContactsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCdpContactsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedCdpContactsQuery, Types.PaginatedCdpContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCdpContactsQuery, Types.PaginatedCdpContactsQueryVariables>(PaginatedCdpContactsDocument, options);
      }
export function usePaginatedCdpContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCdpContactsQuery, Types.PaginatedCdpContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCdpContactsQuery, Types.PaginatedCdpContactsQueryVariables>(PaginatedCdpContactsDocument, options);
        }
export type PaginatedCdpContactsQueryHookResult = ReturnType<typeof usePaginatedCdpContactsQuery>;
export type PaginatedCdpContactsLazyQueryHookResult = ReturnType<typeof usePaginatedCdpContactsLazyQuery>;
export type PaginatedCdpContactsQueryResult = Apollo.QueryResult<Types.PaginatedCdpContactsQuery, Types.PaginatedCdpContactsQueryVariables>;
export const UpdateCdpContactDocument = gql`
    mutation UpdateCDPContact($input: CDPContactUpdateInput!) {
  updateCDPContact(input: $input) {
    ...CDPContact
  }
}
    ${CdpContactFragmentDoc}`;
export type UpdateCdpContactMutationFn = Apollo.MutationFunction<Types.UpdateCdpContactMutation, Types.UpdateCdpContactMutationVariables>;

/**
 * __useUpdateCdpContactMutation__
 *
 * To run a mutation, you first call `useUpdateCdpContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCdpContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCdpContactMutation, { data, loading, error }] = useUpdateCdpContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCdpContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCdpContactMutation, Types.UpdateCdpContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCdpContactMutation, Types.UpdateCdpContactMutationVariables>(UpdateCdpContactDocument, options);
      }
export type UpdateCdpContactMutationHookResult = ReturnType<typeof useUpdateCdpContactMutation>;
export type UpdateCdpContactMutationResult = Apollo.MutationResult<Types.UpdateCdpContactMutation>;
export type UpdateCdpContactMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCdpContactMutation, Types.UpdateCdpContactMutationVariables>;
export const CreateCdpDealDocument = gql`
    mutation CreateCDPDeal($input: CDPDealCreateInput!) {
  createCDPDeal(input: $input) {
    ...CDPDeal
  }
}
    ${CdpDealFragmentDoc}`;
export type CreateCdpDealMutationFn = Apollo.MutationFunction<Types.CreateCdpDealMutation, Types.CreateCdpDealMutationVariables>;

/**
 * __useCreateCdpDealMutation__
 *
 * To run a mutation, you first call `useCreateCdpDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCdpDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCdpDealMutation, { data, loading, error }] = useCreateCdpDealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCdpDealMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateCdpDealMutation, Types.CreateCdpDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateCdpDealMutation, Types.CreateCdpDealMutationVariables>(CreateCdpDealDocument, options);
      }
export type CreateCdpDealMutationHookResult = ReturnType<typeof useCreateCdpDealMutation>;
export type CreateCdpDealMutationResult = Apollo.MutationResult<Types.CreateCdpDealMutation>;
export type CreateCdpDealMutationOptions = Apollo.BaseMutationOptions<Types.CreateCdpDealMutation, Types.CreateCdpDealMutationVariables>;
export const DealFilterDataDocument = gql`
    query DealFilterData {
  availableCDPDealStages
  availableCDPDealTypes
  getCDPAccounts {
    ...CDPAccountFilterOptionData
  }
  getCDPOwners {
    ...CDPOwnerFilterOptionData
  }
}
    ${CdpAccountFilterOptionDataFragmentDoc}
${CdpOwnerFilterOptionDataFragmentDoc}`;

/**
 * __useDealFilterDataQuery__
 *
 * To run a query within a React component, call `useDealFilterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealFilterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealFilterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealFilterDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.DealFilterDataQuery, Types.DealFilterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DealFilterDataQuery, Types.DealFilterDataQueryVariables>(DealFilterDataDocument, options);
      }
export function useDealFilterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DealFilterDataQuery, Types.DealFilterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DealFilterDataQuery, Types.DealFilterDataQueryVariables>(DealFilterDataDocument, options);
        }
export type DealFilterDataQueryHookResult = ReturnType<typeof useDealFilterDataQuery>;
export type DealFilterDataLazyQueryHookResult = ReturnType<typeof useDealFilterDataLazyQuery>;
export type DealFilterDataQueryResult = Apollo.QueryResult<Types.DealFilterDataQuery, Types.DealFilterDataQueryVariables>;
export const DeleteCdpDealsDocument = gql`
    mutation DeleteCDPDeals($dealIds: [String!]!) {
  deleteCDPDeals(dealIds: $dealIds)
}
    `;
export type DeleteCdpDealsMutationFn = Apollo.MutationFunction<Types.DeleteCdpDealsMutation, Types.DeleteCdpDealsMutationVariables>;

/**
 * __useDeleteCdpDealsMutation__
 *
 * To run a mutation, you first call `useDeleteCdpDealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCdpDealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCdpDealsMutation, { data, loading, error }] = useDeleteCdpDealsMutation({
 *   variables: {
 *      dealIds: // value for 'dealIds'
 *   },
 * });
 */
export function useDeleteCdpDealsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCdpDealsMutation, Types.DeleteCdpDealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCdpDealsMutation, Types.DeleteCdpDealsMutationVariables>(DeleteCdpDealsDocument, options);
      }
export type DeleteCdpDealsMutationHookResult = ReturnType<typeof useDeleteCdpDealsMutation>;
export type DeleteCdpDealsMutationResult = Apollo.MutationResult<Types.DeleteCdpDealsMutation>;
export type DeleteCdpDealsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCdpDealsMutation, Types.DeleteCdpDealsMutationVariables>;
export const PaginatedCdpDealsDocument = gql`
    query PaginatedCDPDeals($pagination: PaginationInput!, $filter: CDPDealItemsFilterInput, $sort: CDPDealItemsSortInput) {
  paginatedCDPDeals(pagination: $pagination, filter: $filter, sort: $sort) {
    totalDocs
    totalPages
    page
    docs {
      ...CDPDeal
    }
  }
}
    ${CdpDealFragmentDoc}`;

/**
 * __usePaginatedCdpDealsQuery__
 *
 * To run a query within a React component, call `usePaginatedCdpDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCdpDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCdpDealsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaginatedCdpDealsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedCdpDealsQuery, Types.PaginatedCdpDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedCdpDealsQuery, Types.PaginatedCdpDealsQueryVariables>(PaginatedCdpDealsDocument, options);
      }
export function usePaginatedCdpDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedCdpDealsQuery, Types.PaginatedCdpDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedCdpDealsQuery, Types.PaginatedCdpDealsQueryVariables>(PaginatedCdpDealsDocument, options);
        }
export type PaginatedCdpDealsQueryHookResult = ReturnType<typeof usePaginatedCdpDealsQuery>;
export type PaginatedCdpDealsLazyQueryHookResult = ReturnType<typeof usePaginatedCdpDealsLazyQuery>;
export type PaginatedCdpDealsQueryResult = Apollo.QueryResult<Types.PaginatedCdpDealsQuery, Types.PaginatedCdpDealsQueryVariables>;
export const DealFilterOptionsDocument = gql`
    query DealFilterOptions {
  dealFilterOptions {
    stages
    sources
    companyOptions {
      ...DealCompanyFilterOption
    }
    ownerOptions {
      ...FilterOption
    }
  }
}
    ${DealCompanyFilterOptionFragmentDoc}
${FilterOptionFragmentDoc}`;

/**
 * __useDealFilterOptionsQuery__
 *
 * To run a query within a React component, call `useDealFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.DealFilterOptionsQuery, Types.DealFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DealFilterOptionsQuery, Types.DealFilterOptionsQueryVariables>(DealFilterOptionsDocument, options);
      }
export function useDealFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DealFilterOptionsQuery, Types.DealFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DealFilterOptionsQuery, Types.DealFilterOptionsQueryVariables>(DealFilterOptionsDocument, options);
        }
export type DealFilterOptionsQueryHookResult = ReturnType<typeof useDealFilterOptionsQuery>;
export type DealFilterOptionsLazyQueryHookResult = ReturnType<typeof useDealFilterOptionsLazyQuery>;
export type DealFilterOptionsQueryResult = Apollo.QueryResult<Types.DealFilterOptionsQuery, Types.DealFilterOptionsQueryVariables>;
export const InsightGeneratedItemFilterOptionsDocument = gql`
    query InsightGeneratedItemFilterOptions {
  insightGeneratedItemFilterOptions {
    tagOptions {
      ...TagFilterOption
    }
    CDPAccountOptions {
      ...CDPAccountFilterOption
    }
  }
}
    ${TagFilterOptionFragmentDoc}
${CdpAccountFilterOptionFragmentDoc}`;

/**
 * __useInsightGeneratedItemFilterOptionsQuery__
 *
 * To run a query within a React component, call `useInsightGeneratedItemFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightGeneratedItemFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightGeneratedItemFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightGeneratedItemFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.InsightGeneratedItemFilterOptionsQuery, Types.InsightGeneratedItemFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightGeneratedItemFilterOptionsQuery, Types.InsightGeneratedItemFilterOptionsQueryVariables>(InsightGeneratedItemFilterOptionsDocument, options);
      }
export function useInsightGeneratedItemFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightGeneratedItemFilterOptionsQuery, Types.InsightGeneratedItemFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightGeneratedItemFilterOptionsQuery, Types.InsightGeneratedItemFilterOptionsQueryVariables>(InsightGeneratedItemFilterOptionsDocument, options);
        }
export type InsightGeneratedItemFilterOptionsQueryHookResult = ReturnType<typeof useInsightGeneratedItemFilterOptionsQuery>;
export type InsightGeneratedItemFilterOptionsLazyQueryHookResult = ReturnType<typeof useInsightGeneratedItemFilterOptionsLazyQuery>;
export type InsightGeneratedItemFilterOptionsQueryResult = Apollo.QueryResult<Types.InsightGeneratedItemFilterOptionsQuery, Types.InsightGeneratedItemFilterOptionsQueryVariables>;
export const InsightFilterOptionsDocument = gql`
    query InsightFilterOptions {
  insightFilterOptions {
    tagOptions {
      ...TagFilterOption
    }
    productLineTagOptions {
      ...TagFilterOption
    }
    personaOptions {
      ...PersonaFilterOption
    }
    launchOptions {
      ...LaunchFilterOption
    }
    taskOptions {
      ...FilterOption
    }
    feedbackPostOptions {
      ...FeedbackPostFilterOption
    }
    productBoardItemOptions {
      ...FilterOption
    }
    competitorOptions {
      ...CompetitorCompanyFilterOption
    }
    creatorOptions {
      ...UserFilterOption
    }
    CDPAccountOptions {
      ...CDPAccountFilterOption
    }
    CDPContactOptions {
      ...FilterOption
    }
    CDPOwnerOptions {
      ...FilterOption
    }
    accountIndustries
    accountTypes
    conversationTypes
  }
}
    ${TagFilterOptionFragmentDoc}
${PersonaFilterOptionFragmentDoc}
${LaunchFilterOptionFragmentDoc}
${FilterOptionFragmentDoc}
${FeedbackPostFilterOptionFragmentDoc}
${CompetitorCompanyFilterOptionFragmentDoc}
${UserFilterOptionFragmentDoc}
${CdpAccountFilterOptionFragmentDoc}`;

/**
 * __useInsightFilterOptionsQuery__
 *
 * To run a query within a React component, call `useInsightFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.InsightFilterOptionsQuery, Types.InsightFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightFilterOptionsQuery, Types.InsightFilterOptionsQueryVariables>(InsightFilterOptionsDocument, options);
      }
export function useInsightFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightFilterOptionsQuery, Types.InsightFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightFilterOptionsQuery, Types.InsightFilterOptionsQueryVariables>(InsightFilterOptionsDocument, options);
        }
export type InsightFilterOptionsQueryHookResult = ReturnType<typeof useInsightFilterOptionsQuery>;
export type InsightFilterOptionsLazyQueryHookResult = ReturnType<typeof useInsightFilterOptionsLazyQuery>;
export type InsightFilterOptionsQueryResult = Apollo.QueryResult<Types.InsightFilterOptionsQuery, Types.InsightFilterOptionsQueryVariables>;
export const LaunchesFilterDataDocument = gql`
    query LaunchesFilterData {
  launchesFilterOptions {
    owners {
      ...UserFilterOptionData
    }
    members {
      ...UserFilterOptionData
    }
    tags {
      ...TagFilterOptionData
    }
  }
  launchTypes {
    ...LaunchTypeFilterOptionData
  }
}
    ${UserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}
${LaunchTypeFilterOptionDataFragmentDoc}`;

/**
 * __useLaunchesFilterDataQuery__
 *
 * To run a query within a React component, call `useLaunchesFilterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchesFilterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchesFilterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaunchesFilterDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchesFilterDataQuery, Types.LaunchesFilterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchesFilterDataQuery, Types.LaunchesFilterDataQueryVariables>(LaunchesFilterDataDocument, options);
      }
export function useLaunchesFilterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchesFilterDataQuery, Types.LaunchesFilterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchesFilterDataQuery, Types.LaunchesFilterDataQueryVariables>(LaunchesFilterDataDocument, options);
        }
export type LaunchesFilterDataQueryHookResult = ReturnType<typeof useLaunchesFilterDataQuery>;
export type LaunchesFilterDataLazyQueryHookResult = ReturnType<typeof useLaunchesFilterDataLazyQuery>;
export type LaunchesFilterDataQueryResult = Apollo.QueryResult<Types.LaunchesFilterDataQuery, Types.LaunchesFilterDataQueryVariables>;
export const ProductIdeaFilterOptionsDocument = gql`
    query ProductIdeaFilterOptions {
  productIdeaFilterOptions: feedbackPostFilterOptions {
    tagOptions {
      ...TagFilterOption
    }
    productLineTagOptions {
      ...TagFilterOption
    }
    insightOptions {
      ...FilterOption
    }
    productBoardItemOptions {
      ...FilterOption
    }
    authorOptions {
      ...FeedbackUserFilterOption
    }
    assigneeOptions {
      ...UserFilterOption
    }
    CDPAccountOptions {
      ...CDPAccountFilterOption
    }
    accountIndustries
    accountTypes
  }
}
    ${TagFilterOptionFragmentDoc}
${FilterOptionFragmentDoc}
${FeedbackUserFilterOptionFragmentDoc}
${UserFilterOptionFragmentDoc}
${CdpAccountFilterOptionFragmentDoc}`;

/**
 * __useProductIdeaFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProductIdeaFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdeaFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdeaFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductIdeaFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductIdeaFilterOptionsQuery, Types.ProductIdeaFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductIdeaFilterOptionsQuery, Types.ProductIdeaFilterOptionsQueryVariables>(ProductIdeaFilterOptionsDocument, options);
      }
export function useProductIdeaFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductIdeaFilterOptionsQuery, Types.ProductIdeaFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductIdeaFilterOptionsQuery, Types.ProductIdeaFilterOptionsQueryVariables>(ProductIdeaFilterOptionsDocument, options);
        }
export type ProductIdeaFilterOptionsQueryHookResult = ReturnType<typeof useProductIdeaFilterOptionsQuery>;
export type ProductIdeaFilterOptionsLazyQueryHookResult = ReturnType<typeof useProductIdeaFilterOptionsLazyQuery>;
export type ProductIdeaFilterOptionsQueryResult = Apollo.QueryResult<Types.ProductIdeaFilterOptionsQuery, Types.ProductIdeaFilterOptionsQueryVariables>;
export const PublicProductIdeasFilterDataDocument = gql`
    query PublicProductIdeasFilterData {
  organization {
    id
    users {
      ...OrganizationUserFilterOptionData
    }
  }
  feedbackPostTags: tags(input: {types: [FEEDBACK_POST]}) {
    ...TagFilterOptionData
  }
  availableCDPAccountIndustries
  availableCDPAccountTypes
  tags(input: {types: [FEEDBACK_POST]}) {
    ...Tag
  }
}
    ${OrganizationUserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}
${TagFragmentDoc}`;

/**
 * __usePublicProductIdeasFilterDataQuery__
 *
 * To run a query within a React component, call `usePublicProductIdeasFilterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProductIdeasFilterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProductIdeasFilterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicProductIdeasFilterDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicProductIdeasFilterDataQuery, Types.PublicProductIdeasFilterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicProductIdeasFilterDataQuery, Types.PublicProductIdeasFilterDataQueryVariables>(PublicProductIdeasFilterDataDocument, options);
      }
export function usePublicProductIdeasFilterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicProductIdeasFilterDataQuery, Types.PublicProductIdeasFilterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicProductIdeasFilterDataQuery, Types.PublicProductIdeasFilterDataQueryVariables>(PublicProductIdeasFilterDataDocument, options);
        }
export type PublicProductIdeasFilterDataQueryHookResult = ReturnType<typeof usePublicProductIdeasFilterDataQuery>;
export type PublicProductIdeasFilterDataLazyQueryHookResult = ReturnType<typeof usePublicProductIdeasFilterDataLazyQuery>;
export type PublicProductIdeasFilterDataQueryResult = Apollo.QueryResult<Types.PublicProductIdeasFilterDataQuery, Types.PublicProductIdeasFilterDataQueryVariables>;
export const LaunchTaskFilterOptionsDocument = gql`
    query LaunchTaskFilterOptions($launchId: String!) {
  taskFilterOptions(filter: {launchIds: [$launchId]}) {
    tagOptions {
      ...TagFilterOption
    }
    assigneeOptions {
      ...UserFilterOption
    }
    ownerOptions {
      ...UserFilterOption
    }
  }
}
    ${TagFilterOptionFragmentDoc}
${UserFilterOptionFragmentDoc}`;

/**
 * __useLaunchTaskFilterOptionsQuery__
 *
 * To run a query within a React component, call `useLaunchTaskFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchTaskFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchTaskFilterOptionsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchTaskFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchTaskFilterOptionsQuery, Types.LaunchTaskFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchTaskFilterOptionsQuery, Types.LaunchTaskFilterOptionsQueryVariables>(LaunchTaskFilterOptionsDocument, options);
      }
export function useLaunchTaskFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchTaskFilterOptionsQuery, Types.LaunchTaskFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchTaskFilterOptionsQuery, Types.LaunchTaskFilterOptionsQueryVariables>(LaunchTaskFilterOptionsDocument, options);
        }
export type LaunchTaskFilterOptionsQueryHookResult = ReturnType<typeof useLaunchTaskFilterOptionsQuery>;
export type LaunchTaskFilterOptionsLazyQueryHookResult = ReturnType<typeof useLaunchTaskFilterOptionsLazyQuery>;
export type LaunchTaskFilterOptionsQueryResult = Apollo.QueryResult<Types.LaunchTaskFilterOptionsQuery, Types.LaunchTaskFilterOptionsQueryVariables>;
export const PublicLaunchTasksFilterOptionsDocument = gql`
    query PublicLaunchTasksFilterOptions($launchId: String!) {
  assignees: publicTaskAssignees {
    ...UserFilterOptionData
  }
  tags: publicLaunchPageTags(
    input: {launchId: $launchId, parentName: TASKS, types: [TASK, PRODUCT_LINE]}
  ) {
    ...TagFilterOptionData
  }
}
    ${UserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}`;

/**
 * __usePublicLaunchTasksFilterOptionsQuery__
 *
 * To run a query within a React component, call `usePublicLaunchTasksFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLaunchTasksFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLaunchTasksFilterOptionsQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function usePublicLaunchTasksFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicLaunchTasksFilterOptionsQuery, Types.PublicLaunchTasksFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicLaunchTasksFilterOptionsQuery, Types.PublicLaunchTasksFilterOptionsQueryVariables>(PublicLaunchTasksFilterOptionsDocument, options);
      }
export function usePublicLaunchTasksFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicLaunchTasksFilterOptionsQuery, Types.PublicLaunchTasksFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicLaunchTasksFilterOptionsQuery, Types.PublicLaunchTasksFilterOptionsQueryVariables>(PublicLaunchTasksFilterOptionsDocument, options);
        }
export type PublicLaunchTasksFilterOptionsQueryHookResult = ReturnType<typeof usePublicLaunchTasksFilterOptionsQuery>;
export type PublicLaunchTasksFilterOptionsLazyQueryHookResult = ReturnType<typeof usePublicLaunchTasksFilterOptionsLazyQuery>;
export type PublicLaunchTasksFilterOptionsQueryResult = Apollo.QueryResult<Types.PublicLaunchTasksFilterOptionsQuery, Types.PublicLaunchTasksFilterOptionsQueryVariables>;
export const TaskFilterOptionsDocument = gql`
    query TaskFilterOptions {
  taskFilterOptions {
    tagOptions {
      ...TagFilterOption
    }
    launchOptions {
      ...LaunchFilterOption
    }
    assigneeOptions {
      ...UserFilterOption
    }
    ownerOptions {
      ...UserFilterOption
    }
  }
}
    ${TagFilterOptionFragmentDoc}
${LaunchFilterOptionFragmentDoc}
${UserFilterOptionFragmentDoc}`;

/**
 * __useTaskFilterOptionsQuery__
 *
 * To run a query within a React component, call `useTaskFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TaskFilterOptionsQuery, Types.TaskFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TaskFilterOptionsQuery, Types.TaskFilterOptionsQueryVariables>(TaskFilterOptionsDocument, options);
      }
export function useTaskFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TaskFilterOptionsQuery, Types.TaskFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TaskFilterOptionsQuery, Types.TaskFilterOptionsQueryVariables>(TaskFilterOptionsDocument, options);
        }
export type TaskFilterOptionsQueryHookResult = ReturnType<typeof useTaskFilterOptionsQuery>;
export type TaskFilterOptionsLazyQueryHookResult = ReturnType<typeof useTaskFilterOptionsLazyQuery>;
export type TaskFilterOptionsQueryResult = Apollo.QueryResult<Types.TaskFilterOptionsQuery, Types.TaskFilterOptionsQueryVariables>;
export const CreateInsightIntegrationDocument = gql`
    mutation CreateInsightIntegration($input: CreateInsightIntegrationInput!) {
  createInsightIntegration(input: $input) {
    ...InsightIntegration
  }
}
    ${InsightIntegrationFragmentDoc}`;
export type CreateInsightIntegrationMutationFn = Apollo.MutationFunction<Types.CreateInsightIntegrationMutation, Types.CreateInsightIntegrationMutationVariables>;

/**
 * __useCreateInsightIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateInsightIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightIntegrationMutation, { data, loading, error }] = useCreateInsightIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInsightIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInsightIntegrationMutation, Types.CreateInsightIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInsightIntegrationMutation, Types.CreateInsightIntegrationMutationVariables>(CreateInsightIntegrationDocument, options);
      }
export type CreateInsightIntegrationMutationHookResult = ReturnType<typeof useCreateInsightIntegrationMutation>;
export type CreateInsightIntegrationMutationResult = Apollo.MutationResult<Types.CreateInsightIntegrationMutation>;
export type CreateInsightIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.CreateInsightIntegrationMutation, Types.CreateInsightIntegrationMutationVariables>;
export const DeleteInsightIntegrationDocument = gql`
    mutation DeleteInsightIntegration($id: String!) {
  deleteInsightIntegration(id: $id) {
    id
  }
}
    `;
export type DeleteInsightIntegrationMutationFn = Apollo.MutationFunction<Types.DeleteInsightIntegrationMutation, Types.DeleteInsightIntegrationMutationVariables>;

/**
 * __useDeleteInsightIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteInsightIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightIntegrationMutation, { data, loading, error }] = useDeleteInsightIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsightIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInsightIntegrationMutation, Types.DeleteInsightIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInsightIntegrationMutation, Types.DeleteInsightIntegrationMutationVariables>(DeleteInsightIntegrationDocument, options);
      }
export type DeleteInsightIntegrationMutationHookResult = ReturnType<typeof useDeleteInsightIntegrationMutation>;
export type DeleteInsightIntegrationMutationResult = Apollo.MutationResult<Types.DeleteInsightIntegrationMutation>;
export type DeleteInsightIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInsightIntegrationMutation, Types.DeleteInsightIntegrationMutationVariables>;
export const SelectInsightIntegrationItemsDocument = gql`
    mutation SelectInsightIntegrationItems($input: SelectInsightIntegrationItemsInput!) {
  selectInsightIntegrationItems(input: $input)
}
    `;
export type SelectInsightIntegrationItemsMutationFn = Apollo.MutationFunction<Types.SelectInsightIntegrationItemsMutation, Types.SelectInsightIntegrationItemsMutationVariables>;

/**
 * __useSelectInsightIntegrationItemsMutation__
 *
 * To run a mutation, you first call `useSelectInsightIntegrationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectInsightIntegrationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectInsightIntegrationItemsMutation, { data, loading, error }] = useSelectInsightIntegrationItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectInsightIntegrationItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SelectInsightIntegrationItemsMutation, Types.SelectInsightIntegrationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SelectInsightIntegrationItemsMutation, Types.SelectInsightIntegrationItemsMutationVariables>(SelectInsightIntegrationItemsDocument, options);
      }
export type SelectInsightIntegrationItemsMutationHookResult = ReturnType<typeof useSelectInsightIntegrationItemsMutation>;
export type SelectInsightIntegrationItemsMutationResult = Apollo.MutationResult<Types.SelectInsightIntegrationItemsMutation>;
export type SelectInsightIntegrationItemsMutationOptions = Apollo.BaseMutationOptions<Types.SelectInsightIntegrationItemsMutation, Types.SelectInsightIntegrationItemsMutationVariables>;
export const UpdateInsightIntegrationDocument = gql`
    mutation UpdateInsightIntegration($input: UpdateInsightIntegrationInput!) {
  updateInsightIntegration(input: $input) {
    ...InsightIntegration
  }
}
    ${InsightIntegrationFragmentDoc}`;
export type UpdateInsightIntegrationMutationFn = Apollo.MutationFunction<Types.UpdateInsightIntegrationMutation, Types.UpdateInsightIntegrationMutationVariables>;

/**
 * __useUpdateInsightIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightIntegrationMutation, { data, loading, error }] = useUpdateInsightIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInsightIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightIntegrationMutation, Types.UpdateInsightIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightIntegrationMutation, Types.UpdateInsightIntegrationMutationVariables>(UpdateInsightIntegrationDocument, options);
      }
export type UpdateInsightIntegrationMutationHookResult = ReturnType<typeof useUpdateInsightIntegrationMutation>;
export type UpdateInsightIntegrationMutationResult = Apollo.MutationResult<Types.UpdateInsightIntegrationMutation>;
export type UpdateInsightIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightIntegrationMutation, Types.UpdateInsightIntegrationMutationVariables>;
export const InsightIntegrationOAuthUrlDocument = gql`
    query InsightIntegrationOAuthUrl($input: InsightIntegrationOAuthUrlInput!) {
  insightIntegrationOAuthUrl(input: $input)
}
    `;

/**
 * __useInsightIntegrationOAuthUrlQuery__
 *
 * To run a query within a React component, call `useInsightIntegrationOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightIntegrationOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightIntegrationOAuthUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsightIntegrationOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.InsightIntegrationOAuthUrlQuery, Types.InsightIntegrationOAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightIntegrationOAuthUrlQuery, Types.InsightIntegrationOAuthUrlQueryVariables>(InsightIntegrationOAuthUrlDocument, options);
      }
export function useInsightIntegrationOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightIntegrationOAuthUrlQuery, Types.InsightIntegrationOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightIntegrationOAuthUrlQuery, Types.InsightIntegrationOAuthUrlQueryVariables>(InsightIntegrationOAuthUrlDocument, options);
        }
export type InsightIntegrationOAuthUrlQueryHookResult = ReturnType<typeof useInsightIntegrationOAuthUrlQuery>;
export type InsightIntegrationOAuthUrlLazyQueryHookResult = ReturnType<typeof useInsightIntegrationOAuthUrlLazyQuery>;
export type InsightIntegrationOAuthUrlQueryResult = Apollo.QueryResult<Types.InsightIntegrationOAuthUrlQuery, Types.InsightIntegrationOAuthUrlQueryVariables>;
export const InsightIntegrationsDocument = gql`
    query InsightIntegrations {
  insightIntegrations {
    ...InsightIntegration
  }
}
    ${InsightIntegrationFragmentDoc}`;

/**
 * __useInsightIntegrationsQuery__
 *
 * To run a query within a React component, call `useInsightIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.InsightIntegrationsQuery, Types.InsightIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightIntegrationsQuery, Types.InsightIntegrationsQueryVariables>(InsightIntegrationsDocument, options);
      }
export function useInsightIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightIntegrationsQuery, Types.InsightIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightIntegrationsQuery, Types.InsightIntegrationsQueryVariables>(InsightIntegrationsDocument, options);
        }
export type InsightIntegrationsQueryHookResult = ReturnType<typeof useInsightIntegrationsQuery>;
export type InsightIntegrationsLazyQueryHookResult = ReturnType<typeof useInsightIntegrationsLazyQuery>;
export type InsightIntegrationsQueryResult = Apollo.QueryResult<Types.InsightIntegrationsQuery, Types.InsightIntegrationsQueryVariables>;
export const DeleteInsightDocument = gql`
    mutation DeleteInsight($id: String!) {
  deleteInsight(id: $id) {
    id
  }
}
    `;
export type DeleteInsightMutationFn = Apollo.MutationFunction<Types.DeleteInsightMutation, Types.DeleteInsightMutationVariables>;

/**
 * __useDeleteInsightMutation__
 *
 * To run a mutation, you first call `useDeleteInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightMutation, { data, loading, error }] = useDeleteInsightMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsightMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInsightMutation, Types.DeleteInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInsightMutation, Types.DeleteInsightMutationVariables>(DeleteInsightDocument, options);
      }
export type DeleteInsightMutationHookResult = ReturnType<typeof useDeleteInsightMutation>;
export type DeleteInsightMutationResult = Apollo.MutationResult<Types.DeleteInsightMutation>;
export type DeleteInsightMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInsightMutation, Types.DeleteInsightMutationVariables>;
export const CreateInsightsViewDocument = gql`
    mutation CreateInsightsView($input: CreateInsightsViewInput!) {
  createInsightsView(input: $input) {
    ...InsightsView
  }
}
    ${InsightsViewFragmentDoc}`;
export type CreateInsightsViewMutationFn = Apollo.MutationFunction<Types.CreateInsightsViewMutation, Types.CreateInsightsViewMutationVariables>;

/**
 * __useCreateInsightsViewMutation__
 *
 * To run a mutation, you first call `useCreateInsightsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightsViewMutation, { data, loading, error }] = useCreateInsightsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInsightsViewMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInsightsViewMutation, Types.CreateInsightsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInsightsViewMutation, Types.CreateInsightsViewMutationVariables>(CreateInsightsViewDocument, options);
      }
export type CreateInsightsViewMutationHookResult = ReturnType<typeof useCreateInsightsViewMutation>;
export type CreateInsightsViewMutationResult = Apollo.MutationResult<Types.CreateInsightsViewMutation>;
export type CreateInsightsViewMutationOptions = Apollo.BaseMutationOptions<Types.CreateInsightsViewMutation, Types.CreateInsightsViewMutationVariables>;
export const InsightsViewsDocument = gql`
    query InsightsViews {
  insightsViews {
    ...InsightsView
  }
}
    ${InsightsViewFragmentDoc}`;

/**
 * __useInsightsViewsQuery__
 *
 * To run a query within a React component, call `useInsightsViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightsViewsQuery(baseOptions?: Apollo.QueryHookOptions<Types.InsightsViewsQuery, Types.InsightsViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InsightsViewsQuery, Types.InsightsViewsQueryVariables>(InsightsViewsDocument, options);
      }
export function useInsightsViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InsightsViewsQuery, Types.InsightsViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InsightsViewsQuery, Types.InsightsViewsQueryVariables>(InsightsViewsDocument, options);
        }
export type InsightsViewsQueryHookResult = ReturnType<typeof useInsightsViewsQuery>;
export type InsightsViewsLazyQueryHookResult = ReturnType<typeof useInsightsViewsLazyQuery>;
export type InsightsViewsQueryResult = Apollo.QueryResult<Types.InsightsViewsQuery, Types.InsightsViewsQueryVariables>;
export const CreateFeedbackPostsAsAdminDocument = gql`
    mutation CreateFeedbackPostsAsAdmin($input: CreateFeedbackPostsAsAdminInput!) {
  createFeedbackPostsAsAdmin(input: $input) {
    ...FeedbackPost
  }
}
    ${FeedbackPostFragmentDoc}`;
export type CreateFeedbackPostsAsAdminMutationFn = Apollo.MutationFunction<Types.CreateFeedbackPostsAsAdminMutation, Types.CreateFeedbackPostsAsAdminMutationVariables>;

/**
 * __useCreateFeedbackPostsAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackPostsAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackPostsAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackPostsAsAdminMutation, { data, loading, error }] = useCreateFeedbackPostsAsAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackPostsAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFeedbackPostsAsAdminMutation, Types.CreateFeedbackPostsAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFeedbackPostsAsAdminMutation, Types.CreateFeedbackPostsAsAdminMutationVariables>(CreateFeedbackPostsAsAdminDocument, options);
      }
export type CreateFeedbackPostsAsAdminMutationHookResult = ReturnType<typeof useCreateFeedbackPostsAsAdminMutation>;
export type CreateFeedbackPostsAsAdminMutationResult = Apollo.MutationResult<Types.CreateFeedbackPostsAsAdminMutation>;
export type CreateFeedbackPostsAsAdminMutationOptions = Apollo.BaseMutationOptions<Types.CreateFeedbackPostsAsAdminMutation, Types.CreateFeedbackPostsAsAdminMutationVariables>;
export const CreateDemoInsightsDocument = gql`
    mutation CreateDemoInsights {
  createDemoInsights {
    id
  }
}
    `;
export type CreateDemoInsightsMutationFn = Apollo.MutationFunction<Types.CreateDemoInsightsMutation, Types.CreateDemoInsightsMutationVariables>;

/**
 * __useCreateDemoInsightsMutation__
 *
 * To run a mutation, you first call `useCreateDemoInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemoInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemoInsightsMutation, { data, loading, error }] = useCreateDemoInsightsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDemoInsightsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDemoInsightsMutation, Types.CreateDemoInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDemoInsightsMutation, Types.CreateDemoInsightsMutationVariables>(CreateDemoInsightsDocument, options);
      }
export type CreateDemoInsightsMutationHookResult = ReturnType<typeof useCreateDemoInsightsMutation>;
export type CreateDemoInsightsMutationResult = Apollo.MutationResult<Types.CreateDemoInsightsMutation>;
export type CreateDemoInsightsMutationOptions = Apollo.BaseMutationOptions<Types.CreateDemoInsightsMutation, Types.CreateDemoInsightsMutationVariables>;
export const UpdateInsightAccountDocument = gql`
    mutation UpdateInsightAccount($id: String!, $accountId: String) {
  updateInsight(input: {id: $id, accountId: $accountId}) {
    id
    account {
      id
      name
      logo
    }
    updatedAt
  }
}
    `;
export type UpdateInsightAccountMutationFn = Apollo.MutationFunction<Types.UpdateInsightAccountMutation, Types.UpdateInsightAccountMutationVariables>;

/**
 * __useUpdateInsightAccountMutation__
 *
 * To run a mutation, you first call `useUpdateInsightAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightAccountMutation, { data, loading, error }] = useUpdateInsightAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useUpdateInsightAccountMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightAccountMutation, Types.UpdateInsightAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightAccountMutation, Types.UpdateInsightAccountMutationVariables>(UpdateInsightAccountDocument, options);
      }
export type UpdateInsightAccountMutationHookResult = ReturnType<typeof useUpdateInsightAccountMutation>;
export type UpdateInsightAccountMutationResult = Apollo.MutationResult<Types.UpdateInsightAccountMutation>;
export type UpdateInsightAccountMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightAccountMutation, Types.UpdateInsightAccountMutationVariables>;
export const UpdateInsightAssigneeDocument = gql`
    mutation UpdateInsightAssignee($id: String!, $assigneeId: String) {
  updateInsight(input: {id: $id, assigneeId: $assigneeId}) {
    id
    assignee {
      id
      name
      email
    }
    updatedAt
  }
}
    `;
export type UpdateInsightAssigneeMutationFn = Apollo.MutationFunction<Types.UpdateInsightAssigneeMutation, Types.UpdateInsightAssigneeMutationVariables>;

/**
 * __useUpdateInsightAssigneeMutation__
 *
 * To run a mutation, you first call `useUpdateInsightAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightAssigneeMutation, { data, loading, error }] = useUpdateInsightAssigneeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useUpdateInsightAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightAssigneeMutation, Types.UpdateInsightAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightAssigneeMutation, Types.UpdateInsightAssigneeMutationVariables>(UpdateInsightAssigneeDocument, options);
      }
export type UpdateInsightAssigneeMutationHookResult = ReturnType<typeof useUpdateInsightAssigneeMutation>;
export type UpdateInsightAssigneeMutationResult = Apollo.MutationResult<Types.UpdateInsightAssigneeMutation>;
export type UpdateInsightAssigneeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightAssigneeMutation, Types.UpdateInsightAssigneeMutationVariables>;
export const UpdateInsightContactDocument = gql`
    mutation UpdateInsightContact($id: String!, $contactId: String) {
  updateInsight(input: {id: $id, contactId: $contactId}) {
    id
    contact {
      id
      name
    }
    updatedAt
  }
}
    `;
export type UpdateInsightContactMutationFn = Apollo.MutationFunction<Types.UpdateInsightContactMutation, Types.UpdateInsightContactMutationVariables>;

/**
 * __useUpdateInsightContactMutation__
 *
 * To run a mutation, you first call `useUpdateInsightContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightContactMutation, { data, loading, error }] = useUpdateInsightContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useUpdateInsightContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInsightContactMutation, Types.UpdateInsightContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInsightContactMutation, Types.UpdateInsightContactMutationVariables>(UpdateInsightContactDocument, options);
      }
export type UpdateInsightContactMutationHookResult = ReturnType<typeof useUpdateInsightContactMutation>;
export type UpdateInsightContactMutationResult = Apollo.MutationResult<Types.UpdateInsightContactMutation>;
export type UpdateInsightContactMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInsightContactMutation, Types.UpdateInsightContactMutationVariables>;
export const IntegrationTaskFilterOptionsDocument = gql`
    query IntegrationTaskFilterOptions($integrationIds: [String!]!) {
  assignees: integrationsTasksAssignees(integrationsIds: $integrationIds)
  types: productIntegrationTaskTypes(integrationIds: $integrationIds)
}
    `;

/**
 * __useIntegrationTaskFilterOptionsQuery__
 *
 * To run a query within a React component, call `useIntegrationTaskFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationTaskFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationTaskFilterOptionsQuery({
 *   variables: {
 *      integrationIds: // value for 'integrationIds'
 *   },
 * });
 */
export function useIntegrationTaskFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationTaskFilterOptionsQuery, Types.IntegrationTaskFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationTaskFilterOptionsQuery, Types.IntegrationTaskFilterOptionsQueryVariables>(IntegrationTaskFilterOptionsDocument, options);
      }
export function useIntegrationTaskFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationTaskFilterOptionsQuery, Types.IntegrationTaskFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationTaskFilterOptionsQuery, Types.IntegrationTaskFilterOptionsQueryVariables>(IntegrationTaskFilterOptionsDocument, options);
        }
export type IntegrationTaskFilterOptionsQueryHookResult = ReturnType<typeof useIntegrationTaskFilterOptionsQuery>;
export type IntegrationTaskFilterOptionsLazyQueryHookResult = ReturnType<typeof useIntegrationTaskFilterOptionsLazyQuery>;
export type IntegrationTaskFilterOptionsQueryResult = Apollo.QueryResult<Types.IntegrationTaskFilterOptionsQuery, Types.IntegrationTaskFilterOptionsQueryVariables>;
export const ProductBoardOptionsDocument = gql`
    query ProductBoardOptions {
  feedbackBoards {
    id
    name
  }
}
    `;

/**
 * __useProductBoardOptionsQuery__
 *
 * To run a query within a React component, call `useProductBoardOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBoardOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardOptionsQuery, Types.ProductBoardOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardOptionsQuery, Types.ProductBoardOptionsQueryVariables>(ProductBoardOptionsDocument, options);
      }
export function useProductBoardOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardOptionsQuery, Types.ProductBoardOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardOptionsQuery, Types.ProductBoardOptionsQueryVariables>(ProductBoardOptionsDocument, options);
        }
export type ProductBoardOptionsQueryHookResult = ReturnType<typeof useProductBoardOptionsQuery>;
export type ProductBoardOptionsLazyQueryHookResult = ReturnType<typeof useProductBoardOptionsLazyQuery>;
export type ProductBoardOptionsQueryResult = Apollo.QueryResult<Types.ProductBoardOptionsQuery, Types.ProductBoardOptionsQueryVariables>;
export const ProductIdeaBoardOptionsDocument = gql`
    query ProductIdeaBoardOptions($filter: FeedbackBoardsFilterInput, $sort: FeedbackBoardsSortInput) {
  productIdeaBoardOptions: feedbackBoards(filter: $filter, sort: $sort) {
    id
    name
  }
}
    `;

/**
 * __useProductIdeaBoardOptionsQuery__
 *
 * To run a query within a React component, call `useProductIdeaBoardOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdeaBoardOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdeaBoardOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductIdeaBoardOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductIdeaBoardOptionsQuery, Types.ProductIdeaBoardOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductIdeaBoardOptionsQuery, Types.ProductIdeaBoardOptionsQueryVariables>(ProductIdeaBoardOptionsDocument, options);
      }
export function useProductIdeaBoardOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductIdeaBoardOptionsQuery, Types.ProductIdeaBoardOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductIdeaBoardOptionsQuery, Types.ProductIdeaBoardOptionsQueryVariables>(ProductIdeaBoardOptionsDocument, options);
        }
export type ProductIdeaBoardOptionsQueryHookResult = ReturnType<typeof useProductIdeaBoardOptionsQuery>;
export type ProductIdeaBoardOptionsLazyQueryHookResult = ReturnType<typeof useProductIdeaBoardOptionsLazyQuery>;
export type ProductIdeaBoardOptionsQueryResult = Apollo.QueryResult<Types.ProductIdeaBoardOptionsQuery, Types.ProductIdeaBoardOptionsQueryVariables>;
export const ImportAllClariCopilotInsightIntegrationItemsDocument = gql`
    mutation ImportAllClariCopilotInsightIntegrationItems($filter: InsightIntegrationItemsFilterInput!, $options: ImportAllInsightIntegrationItemsOptionsInput!) {
  importAllClariCopilotInsightIntegrationItems(filter: $filter, options: $options)
}
    `;
export type ImportAllClariCopilotInsightIntegrationItemsMutationFn = Apollo.MutationFunction<Types.ImportAllClariCopilotInsightIntegrationItemsMutation, Types.ImportAllClariCopilotInsightIntegrationItemsMutationVariables>;

/**
 * __useImportAllClariCopilotInsightIntegrationItemsMutation__
 *
 * To run a mutation, you first call `useImportAllClariCopilotInsightIntegrationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAllClariCopilotInsightIntegrationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAllClariCopilotInsightIntegrationItemsMutation, { data, loading, error }] = useImportAllClariCopilotInsightIntegrationItemsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useImportAllClariCopilotInsightIntegrationItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportAllClariCopilotInsightIntegrationItemsMutation, Types.ImportAllClariCopilotInsightIntegrationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportAllClariCopilotInsightIntegrationItemsMutation, Types.ImportAllClariCopilotInsightIntegrationItemsMutationVariables>(ImportAllClariCopilotInsightIntegrationItemsDocument, options);
      }
export type ImportAllClariCopilotInsightIntegrationItemsMutationHookResult = ReturnType<typeof useImportAllClariCopilotInsightIntegrationItemsMutation>;
export type ImportAllClariCopilotInsightIntegrationItemsMutationResult = Apollo.MutationResult<Types.ImportAllClariCopilotInsightIntegrationItemsMutation>;
export type ImportAllClariCopilotInsightIntegrationItemsMutationOptions = Apollo.BaseMutationOptions<Types.ImportAllClariCopilotInsightIntegrationItemsMutation, Types.ImportAllClariCopilotInsightIntegrationItemsMutationVariables>;
export const ImportAllGongInsightIntegrationItemsDocument = gql`
    mutation ImportAllGongInsightIntegrationItems($filter: InsightIntegrationItemsFilterInput!, $options: ImportAllInsightIntegrationItemsOptionsInput!) {
  importAllGongInsightIntegrationItems(filter: $filter, options: $options)
}
    `;
export type ImportAllGongInsightIntegrationItemsMutationFn = Apollo.MutationFunction<Types.ImportAllGongInsightIntegrationItemsMutation, Types.ImportAllGongInsightIntegrationItemsMutationVariables>;

/**
 * __useImportAllGongInsightIntegrationItemsMutation__
 *
 * To run a mutation, you first call `useImportAllGongInsightIntegrationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAllGongInsightIntegrationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAllGongInsightIntegrationItemsMutation, { data, loading, error }] = useImportAllGongInsightIntegrationItemsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useImportAllGongInsightIntegrationItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportAllGongInsightIntegrationItemsMutation, Types.ImportAllGongInsightIntegrationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportAllGongInsightIntegrationItemsMutation, Types.ImportAllGongInsightIntegrationItemsMutationVariables>(ImportAllGongInsightIntegrationItemsDocument, options);
      }
export type ImportAllGongInsightIntegrationItemsMutationHookResult = ReturnType<typeof useImportAllGongInsightIntegrationItemsMutation>;
export type ImportAllGongInsightIntegrationItemsMutationResult = Apollo.MutationResult<Types.ImportAllGongInsightIntegrationItemsMutation>;
export type ImportAllGongInsightIntegrationItemsMutationOptions = Apollo.BaseMutationOptions<Types.ImportAllGongInsightIntegrationItemsMutation, Types.ImportAllGongInsightIntegrationItemsMutationVariables>;
export const ImportAllIntercomInsightIntegrationItemsDocument = gql`
    mutation ImportAllIntercomInsightIntegrationItems($filter: IntercomInsightIntegrationItemsFilterInput!, $options: ImportAllInsightIntegrationItemsOptionsInput!) {
  importAllIntercomInsightIntegrationItems(filter: $filter, options: $options)
}
    `;
export type ImportAllIntercomInsightIntegrationItemsMutationFn = Apollo.MutationFunction<Types.ImportAllIntercomInsightIntegrationItemsMutation, Types.ImportAllIntercomInsightIntegrationItemsMutationVariables>;

/**
 * __useImportAllIntercomInsightIntegrationItemsMutation__
 *
 * To run a mutation, you first call `useImportAllIntercomInsightIntegrationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAllIntercomInsightIntegrationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAllIntercomInsightIntegrationItemsMutation, { data, loading, error }] = useImportAllIntercomInsightIntegrationItemsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useImportAllIntercomInsightIntegrationItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportAllIntercomInsightIntegrationItemsMutation, Types.ImportAllIntercomInsightIntegrationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportAllIntercomInsightIntegrationItemsMutation, Types.ImportAllIntercomInsightIntegrationItemsMutationVariables>(ImportAllIntercomInsightIntegrationItemsDocument, options);
      }
export type ImportAllIntercomInsightIntegrationItemsMutationHookResult = ReturnType<typeof useImportAllIntercomInsightIntegrationItemsMutation>;
export type ImportAllIntercomInsightIntegrationItemsMutationResult = Apollo.MutationResult<Types.ImportAllIntercomInsightIntegrationItemsMutation>;
export type ImportAllIntercomInsightIntegrationItemsMutationOptions = Apollo.BaseMutationOptions<Types.ImportAllIntercomInsightIntegrationItemsMutation, Types.ImportAllIntercomInsightIntegrationItemsMutationVariables>;
export const ImportAllZendeskInsightIntegrationItemsDocument = gql`
    mutation ImportAllZendeskInsightIntegrationItems($filter: ZendeskInsightIntegrationItemsFilterInput!, $options: ImportAllInsightIntegrationItemsOptionsInput!) {
  importAllZendeskInsightIntegrationItems(filter: $filter, options: $options)
}
    `;
export type ImportAllZendeskInsightIntegrationItemsMutationFn = Apollo.MutationFunction<Types.ImportAllZendeskInsightIntegrationItemsMutation, Types.ImportAllZendeskInsightIntegrationItemsMutationVariables>;

/**
 * __useImportAllZendeskInsightIntegrationItemsMutation__
 *
 * To run a mutation, you first call `useImportAllZendeskInsightIntegrationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAllZendeskInsightIntegrationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAllZendeskInsightIntegrationItemsMutation, { data, loading, error }] = useImportAllZendeskInsightIntegrationItemsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useImportAllZendeskInsightIntegrationItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportAllZendeskInsightIntegrationItemsMutation, Types.ImportAllZendeskInsightIntegrationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportAllZendeskInsightIntegrationItemsMutation, Types.ImportAllZendeskInsightIntegrationItemsMutationVariables>(ImportAllZendeskInsightIntegrationItemsDocument, options);
      }
export type ImportAllZendeskInsightIntegrationItemsMutationHookResult = ReturnType<typeof useImportAllZendeskInsightIntegrationItemsMutation>;
export type ImportAllZendeskInsightIntegrationItemsMutationResult = Apollo.MutationResult<Types.ImportAllZendeskInsightIntegrationItemsMutation>;
export type ImportAllZendeskInsightIntegrationItemsMutationOptions = Apollo.BaseMutationOptions<Types.ImportAllZendeskInsightIntegrationItemsMutation, Types.ImportAllZendeskInsightIntegrationItemsMutationVariables>;
export const ImportAllZoomInsightIntegrationItemsDocument = gql`
    mutation ImportAllZoomInsightIntegrationItems($filter: InsightIntegrationItemsFilterInput!, $options: ImportAllInsightIntegrationItemsOptionsInput!) {
  importAllZoomInsightIntegrationItems(filter: $filter, options: $options)
}
    `;
export type ImportAllZoomInsightIntegrationItemsMutationFn = Apollo.MutationFunction<Types.ImportAllZoomInsightIntegrationItemsMutation, Types.ImportAllZoomInsightIntegrationItemsMutationVariables>;

/**
 * __useImportAllZoomInsightIntegrationItemsMutation__
 *
 * To run a mutation, you first call `useImportAllZoomInsightIntegrationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAllZoomInsightIntegrationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAllZoomInsightIntegrationItemsMutation, { data, loading, error }] = useImportAllZoomInsightIntegrationItemsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useImportAllZoomInsightIntegrationItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportAllZoomInsightIntegrationItemsMutation, Types.ImportAllZoomInsightIntegrationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportAllZoomInsightIntegrationItemsMutation, Types.ImportAllZoomInsightIntegrationItemsMutationVariables>(ImportAllZoomInsightIntegrationItemsDocument, options);
      }
export type ImportAllZoomInsightIntegrationItemsMutationHookResult = ReturnType<typeof useImportAllZoomInsightIntegrationItemsMutation>;
export type ImportAllZoomInsightIntegrationItemsMutationResult = Apollo.MutationResult<Types.ImportAllZoomInsightIntegrationItemsMutation>;
export type ImportAllZoomInsightIntegrationItemsMutationOptions = Apollo.BaseMutationOptions<Types.ImportAllZoomInsightIntegrationItemsMutation, Types.ImportAllZoomInsightIntegrationItemsMutationVariables>;
export const LaunchConnectionForCopyDocument = gql`
    query LaunchConnectionForCopy($launchId: String!) {
  launch(id: $launchId) {
    ...LaunchConnectionForCopy
  }
}
    ${LaunchConnectionForCopyFragmentDoc}`;

/**
 * __useLaunchConnectionForCopyQuery__
 *
 * To run a query within a React component, call `useLaunchConnectionForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchConnectionForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchConnectionForCopyQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useLaunchConnectionForCopyQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchConnectionForCopyQuery, Types.LaunchConnectionForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchConnectionForCopyQuery, Types.LaunchConnectionForCopyQueryVariables>(LaunchConnectionForCopyDocument, options);
      }
export function useLaunchConnectionForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchConnectionForCopyQuery, Types.LaunchConnectionForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchConnectionForCopyQuery, Types.LaunchConnectionForCopyQueryVariables>(LaunchConnectionForCopyDocument, options);
        }
export type LaunchConnectionForCopyQueryHookResult = ReturnType<typeof useLaunchConnectionForCopyQuery>;
export type LaunchConnectionForCopyLazyQueryHookResult = ReturnType<typeof useLaunchConnectionForCopyLazyQuery>;
export type LaunchConnectionForCopyQueryResult = Apollo.QueryResult<Types.LaunchConnectionForCopyQuery, Types.LaunchConnectionForCopyQueryVariables>;
export const LaunchCopilotUpdateOptionsDocument = gql`
    mutation LaunchCopilotUpdateOptions($input: UpdateLaunchCopilotOptionsInput!) {
  updateCopilotOptions(input: $input) {
    ...LaunchCopilotPreferences
  }
}
    ${LaunchCopilotPreferencesFragmentDoc}`;
export type LaunchCopilotUpdateOptionsMutationFn = Apollo.MutationFunction<Types.LaunchCopilotUpdateOptionsMutation, Types.LaunchCopilotUpdateOptionsMutationVariables>;

/**
 * __useLaunchCopilotUpdateOptionsMutation__
 *
 * To run a mutation, you first call `useLaunchCopilotUpdateOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotUpdateOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchCopilotUpdateOptionsMutation, { data, loading, error }] = useLaunchCopilotUpdateOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLaunchCopilotUpdateOptionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.LaunchCopilotUpdateOptionsMutation, Types.LaunchCopilotUpdateOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LaunchCopilotUpdateOptionsMutation, Types.LaunchCopilotUpdateOptionsMutationVariables>(LaunchCopilotUpdateOptionsDocument, options);
      }
export type LaunchCopilotUpdateOptionsMutationHookResult = ReturnType<typeof useLaunchCopilotUpdateOptionsMutation>;
export type LaunchCopilotUpdateOptionsMutationResult = Apollo.MutationResult<Types.LaunchCopilotUpdateOptionsMutation>;
export type LaunchCopilotUpdateOptionsMutationOptions = Apollo.BaseMutationOptions<Types.LaunchCopilotUpdateOptionsMutation, Types.LaunchCopilotUpdateOptionsMutationVariables>;
export const LaunchCopilotCtaDataDocument = gql`
    query LaunchCopilotCTAData($id: String!) {
  launch(id: $id) {
    id
    supportsCopilot
  }
}
    `;

/**
 * __useLaunchCopilotCtaDataQuery__
 *
 * To run a query within a React component, call `useLaunchCopilotCtaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchCopilotCtaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchCopilotCtaDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchCopilotCtaDataQuery(baseOptions: Apollo.QueryHookOptions<Types.LaunchCopilotCtaDataQuery, Types.LaunchCopilotCtaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchCopilotCtaDataQuery, Types.LaunchCopilotCtaDataQueryVariables>(LaunchCopilotCtaDataDocument, options);
      }
export function useLaunchCopilotCtaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchCopilotCtaDataQuery, Types.LaunchCopilotCtaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchCopilotCtaDataQuery, Types.LaunchCopilotCtaDataQueryVariables>(LaunchCopilotCtaDataDocument, options);
        }
export type LaunchCopilotCtaDataQueryHookResult = ReturnType<typeof useLaunchCopilotCtaDataQuery>;
export type LaunchCopilotCtaDataLazyQueryHookResult = ReturnType<typeof useLaunchCopilotCtaDataLazyQuery>;
export type LaunchCopilotCtaDataQueryResult = Apollo.QueryResult<Types.LaunchCopilotCtaDataQuery, Types.LaunchCopilotCtaDataQueryVariables>;
export const UpdateLaunchModuleEditorDocument = gql`
    mutation UpdateLaunchModuleEditor($input: UpdateLaunchModuleUserInputInput!) {
  updateLaunchModuleUserInput(input: $input) {
    id
    ...ModuleEditorContent
  }
}
    ${ModuleEditorContentFragmentDoc}`;
export type UpdateLaunchModuleEditorMutationFn = Apollo.MutationFunction<Types.UpdateLaunchModuleEditorMutation, Types.UpdateLaunchModuleEditorMutationVariables>;

/**
 * __useUpdateLaunchModuleEditorMutation__
 *
 * To run a mutation, you first call `useUpdateLaunchModuleEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaunchModuleEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaunchModuleEditorMutation, { data, loading, error }] = useUpdateLaunchModuleEditorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaunchModuleEditorMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateLaunchModuleEditorMutation, Types.UpdateLaunchModuleEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateLaunchModuleEditorMutation, Types.UpdateLaunchModuleEditorMutationVariables>(UpdateLaunchModuleEditorDocument, options);
      }
export type UpdateLaunchModuleEditorMutationHookResult = ReturnType<typeof useUpdateLaunchModuleEditorMutation>;
export type UpdateLaunchModuleEditorMutationResult = Apollo.MutationResult<Types.UpdateLaunchModuleEditorMutation>;
export type UpdateLaunchModuleEditorMutationOptions = Apollo.BaseMutationOptions<Types.UpdateLaunchModuleEditorMutation, Types.UpdateLaunchModuleEditorMutationVariables>;
export const GptGetLaunchSummaryDocument = gql`
    query GPTGetLaunchSummary($launchId: String!) {
  GPTGetLaunchSummary(launchId: $launchId)
}
    `;

/**
 * __useGptGetLaunchSummaryQuery__
 *
 * To run a query within a React component, call `useGptGetLaunchSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGptGetLaunchSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGptGetLaunchSummaryQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useGptGetLaunchSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.GptGetLaunchSummaryQuery, Types.GptGetLaunchSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GptGetLaunchSummaryQuery, Types.GptGetLaunchSummaryQueryVariables>(GptGetLaunchSummaryDocument, options);
      }
export function useGptGetLaunchSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GptGetLaunchSummaryQuery, Types.GptGetLaunchSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GptGetLaunchSummaryQuery, Types.GptGetLaunchSummaryQueryVariables>(GptGetLaunchSummaryDocument, options);
        }
export type GptGetLaunchSummaryQueryHookResult = ReturnType<typeof useGptGetLaunchSummaryQuery>;
export type GptGetLaunchSummaryLazyQueryHookResult = ReturnType<typeof useGptGetLaunchSummaryLazyQuery>;
export type GptGetLaunchSummaryQueryResult = Apollo.QueryResult<Types.GptGetLaunchSummaryQuery, Types.GptGetLaunchSummaryQueryVariables>;
export const GptGetPositioningStrategyDocument = gql`
    query GPTGetPositioningStrategy($input: GPTGetPositioningStrategyInput!) {
  GPTGetPositioningStrategy(input: $input)
}
    `;

/**
 * __useGptGetPositioningStrategyQuery__
 *
 * To run a query within a React component, call `useGptGetPositioningStrategyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGptGetPositioningStrategyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGptGetPositioningStrategyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGptGetPositioningStrategyQuery(baseOptions: Apollo.QueryHookOptions<Types.GptGetPositioningStrategyQuery, Types.GptGetPositioningStrategyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GptGetPositioningStrategyQuery, Types.GptGetPositioningStrategyQueryVariables>(GptGetPositioningStrategyDocument, options);
      }
export function useGptGetPositioningStrategyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GptGetPositioningStrategyQuery, Types.GptGetPositioningStrategyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GptGetPositioningStrategyQuery, Types.GptGetPositioningStrategyQueryVariables>(GptGetPositioningStrategyDocument, options);
        }
export type GptGetPositioningStrategyQueryHookResult = ReturnType<typeof useGptGetPositioningStrategyQuery>;
export type GptGetPositioningStrategyLazyQueryHookResult = ReturnType<typeof useGptGetPositioningStrategyLazyQuery>;
export type GptGetPositioningStrategyQueryResult = Apollo.QueryResult<Types.GptGetPositioningStrategyQuery, Types.GptGetPositioningStrategyQueryVariables>;
export const GptGetMessagingStrategyDocument = gql`
    query GPTGetMessagingStrategy($launchId: String!, $description: String!) {
  GPTGetMessagingStrategy(launchId: $launchId, description: $description)
}
    `;

/**
 * __useGptGetMessagingStrategyQuery__
 *
 * To run a query within a React component, call `useGptGetMessagingStrategyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGptGetMessagingStrategyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGptGetMessagingStrategyQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGptGetMessagingStrategyQuery(baseOptions: Apollo.QueryHookOptions<Types.GptGetMessagingStrategyQuery, Types.GptGetMessagingStrategyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GptGetMessagingStrategyQuery, Types.GptGetMessagingStrategyQueryVariables>(GptGetMessagingStrategyDocument, options);
      }
export function useGptGetMessagingStrategyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GptGetMessagingStrategyQuery, Types.GptGetMessagingStrategyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GptGetMessagingStrategyQuery, Types.GptGetMessagingStrategyQueryVariables>(GptGetMessagingStrategyDocument, options);
        }
export type GptGetMessagingStrategyQueryHookResult = ReturnType<typeof useGptGetMessagingStrategyQuery>;
export type GptGetMessagingStrategyLazyQueryHookResult = ReturnType<typeof useGptGetMessagingStrategyLazyQuery>;
export type GptGetMessagingStrategyQueryResult = Apollo.QueryResult<Types.GptGetMessagingStrategyQuery, Types.GptGetMessagingStrategyQueryVariables>;
export const GptGetObjectivesDocument = gql`
    query GPTGetObjectives($input: GPTGetObjectivesInput!) {
  GPTGetObjectives(input: $input)
}
    `;

/**
 * __useGptGetObjectivesQuery__
 *
 * To run a query within a React component, call `useGptGetObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGptGetObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGptGetObjectivesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGptGetObjectivesQuery(baseOptions: Apollo.QueryHookOptions<Types.GptGetObjectivesQuery, Types.GptGetObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GptGetObjectivesQuery, Types.GptGetObjectivesQueryVariables>(GptGetObjectivesDocument, options);
      }
export function useGptGetObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GptGetObjectivesQuery, Types.GptGetObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GptGetObjectivesQuery, Types.GptGetObjectivesQueryVariables>(GptGetObjectivesDocument, options);
        }
export type GptGetObjectivesQueryHookResult = ReturnType<typeof useGptGetObjectivesQuery>;
export type GptGetObjectivesLazyQueryHookResult = ReturnType<typeof useGptGetObjectivesLazyQuery>;
export type GptGetObjectivesQueryResult = Apollo.QueryResult<Types.GptGetObjectivesQuery, Types.GptGetObjectivesQueryVariables>;
export const DeleteUserRolesInLaunchModuleDocument = gql`
    mutation DeleteUserRolesInLaunchModule($input: RemoveUsersFromLaunchInput!) {
  deleteUserRolesInLaunchModule(input: $input) {
    id
    users {
      ...LaunchUser
    }
  }
}
    ${LaunchUserFragmentDoc}`;
export type DeleteUserRolesInLaunchModuleMutationFn = Apollo.MutationFunction<Types.DeleteUserRolesInLaunchModuleMutation, Types.DeleteUserRolesInLaunchModuleMutationVariables>;

/**
 * __useDeleteUserRolesInLaunchModuleMutation__
 *
 * To run a mutation, you first call `useDeleteUserRolesInLaunchModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRolesInLaunchModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRolesInLaunchModuleMutation, { data, loading, error }] = useDeleteUserRolesInLaunchModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserRolesInLaunchModuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteUserRolesInLaunchModuleMutation, Types.DeleteUserRolesInLaunchModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteUserRolesInLaunchModuleMutation, Types.DeleteUserRolesInLaunchModuleMutationVariables>(DeleteUserRolesInLaunchModuleDocument, options);
      }
export type DeleteUserRolesInLaunchModuleMutationHookResult = ReturnType<typeof useDeleteUserRolesInLaunchModuleMutation>;
export type DeleteUserRolesInLaunchModuleMutationResult = Apollo.MutationResult<Types.DeleteUserRolesInLaunchModuleMutation>;
export type DeleteUserRolesInLaunchModuleMutationOptions = Apollo.BaseMutationOptions<Types.DeleteUserRolesInLaunchModuleMutation, Types.DeleteUserRolesInLaunchModuleMutationVariables>;
export const UserDataForInviteToLaunchDocument = gql`
    query UserDataForInviteToLaunch($filter: FilterUserInput!) {
  users(filter: $filter) {
    ...UserDataForInviteToLaunch
  }
}
    ${UserDataForInviteToLaunchFragmentDoc}`;

/**
 * __useUserDataForInviteToLaunchQuery__
 *
 * To run a query within a React component, call `useUserDataForInviteToLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataForInviteToLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataForInviteToLaunchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserDataForInviteToLaunchQuery(baseOptions: Apollo.QueryHookOptions<Types.UserDataForInviteToLaunchQuery, Types.UserDataForInviteToLaunchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UserDataForInviteToLaunchQuery, Types.UserDataForInviteToLaunchQueryVariables>(UserDataForInviteToLaunchDocument, options);
      }
export function useUserDataForInviteToLaunchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UserDataForInviteToLaunchQuery, Types.UserDataForInviteToLaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UserDataForInviteToLaunchQuery, Types.UserDataForInviteToLaunchQueryVariables>(UserDataForInviteToLaunchDocument, options);
        }
export type UserDataForInviteToLaunchQueryHookResult = ReturnType<typeof useUserDataForInviteToLaunchQuery>;
export type UserDataForInviteToLaunchLazyQueryHookResult = ReturnType<typeof useUserDataForInviteToLaunchLazyQuery>;
export type UserDataForInviteToLaunchQueryResult = Apollo.QueryResult<Types.UserDataForInviteToLaunchQuery, Types.UserDataForInviteToLaunchQueryVariables>;
export const IntegrationSubtaskColumnsDocument = gql`
    query IntegrationSubtaskColumns($integrationProjectId: String!) {
  integrationColumns(
    input: {integrationProjectId: $integrationProjectId, subtaskBoard: true}
  ) {
    id
    title
  }
}
    `;

/**
 * __useIntegrationSubtaskColumnsQuery__
 *
 * To run a query within a React component, call `useIntegrationSubtaskColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSubtaskColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationSubtaskColumnsQuery({
 *   variables: {
 *      integrationProjectId: // value for 'integrationProjectId'
 *   },
 * });
 */
export function useIntegrationSubtaskColumnsQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationSubtaskColumnsQuery, Types.IntegrationSubtaskColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationSubtaskColumnsQuery, Types.IntegrationSubtaskColumnsQueryVariables>(IntegrationSubtaskColumnsDocument, options);
      }
export function useIntegrationSubtaskColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationSubtaskColumnsQuery, Types.IntegrationSubtaskColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationSubtaskColumnsQuery, Types.IntegrationSubtaskColumnsQueryVariables>(IntegrationSubtaskColumnsDocument, options);
        }
export type IntegrationSubtaskColumnsQueryHookResult = ReturnType<typeof useIntegrationSubtaskColumnsQuery>;
export type IntegrationSubtaskColumnsLazyQueryHookResult = ReturnType<typeof useIntegrationSubtaskColumnsLazyQuery>;
export type IntegrationSubtaskColumnsQueryResult = Apollo.QueryResult<Types.IntegrationSubtaskColumnsQuery, Types.IntegrationSubtaskColumnsQueryVariables>;
export const IntegrationTaskColumnsDocument = gql`
    query IntegrationTaskColumns($integrationProjectId: String!) {
  integrationColumns(
    input: {integrationProjectId: $integrationProjectId, subtaskBoard: false}
  ) {
    id
    title
  }
}
    `;

/**
 * __useIntegrationTaskColumnsQuery__
 *
 * To run a query within a React component, call `useIntegrationTaskColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationTaskColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationTaskColumnsQuery({
 *   variables: {
 *      integrationProjectId: // value for 'integrationProjectId'
 *   },
 * });
 */
export function useIntegrationTaskColumnsQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationTaskColumnsQuery, Types.IntegrationTaskColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationTaskColumnsQuery, Types.IntegrationTaskColumnsQueryVariables>(IntegrationTaskColumnsDocument, options);
      }
export function useIntegrationTaskColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationTaskColumnsQuery, Types.IntegrationTaskColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationTaskColumnsQuery, Types.IntegrationTaskColumnsQueryVariables>(IntegrationTaskColumnsDocument, options);
        }
export type IntegrationTaskColumnsQueryHookResult = ReturnType<typeof useIntegrationTaskColumnsQuery>;
export type IntegrationTaskColumnsLazyQueryHookResult = ReturnType<typeof useIntegrationTaskColumnsLazyQuery>;
export type IntegrationTaskColumnsQueryResult = Apollo.QueryResult<Types.IntegrationTaskColumnsQuery, Types.IntegrationTaskColumnsQueryVariables>;
export const GetMessagingForMessagingLibraryDocument = gql`
    query GetMessagingForMessagingLibrary($productLineTagId: String!, $description: String!) {
  getMessagingForMessagingLibrary(
    productLineTagId: $productLineTagId
    description: $description
  )
}
    `;

/**
 * __useGetMessagingForMessagingLibraryQuery__
 *
 * To run a query within a React component, call `useGetMessagingForMessagingLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingForMessagingLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingForMessagingLibraryQuery({
 *   variables: {
 *      productLineTagId: // value for 'productLineTagId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGetMessagingForMessagingLibraryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMessagingForMessagingLibraryQuery, Types.GetMessagingForMessagingLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMessagingForMessagingLibraryQuery, Types.GetMessagingForMessagingLibraryQueryVariables>(GetMessagingForMessagingLibraryDocument, options);
      }
export function useGetMessagingForMessagingLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMessagingForMessagingLibraryQuery, Types.GetMessagingForMessagingLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMessagingForMessagingLibraryQuery, Types.GetMessagingForMessagingLibraryQueryVariables>(GetMessagingForMessagingLibraryDocument, options);
        }
export type GetMessagingForMessagingLibraryQueryHookResult = ReturnType<typeof useGetMessagingForMessagingLibraryQuery>;
export type GetMessagingForMessagingLibraryLazyQueryHookResult = ReturnType<typeof useGetMessagingForMessagingLibraryLazyQuery>;
export type GetMessagingForMessagingLibraryQueryResult = Apollo.QueryResult<Types.GetMessagingForMessagingLibraryQuery, Types.GetMessagingForMessagingLibraryQueryVariables>;
export const GetPositioningStrategyForMessagingLibraryDocument = gql`
    query GetPositioningStrategyForMessagingLibrary($input: GetAIPositioningStrategyInputForMessaging!) {
  getPositioningStrategyForMessagingLibrary(input: $input)
}
    `;

/**
 * __useGetPositioningStrategyForMessagingLibraryQuery__
 *
 * To run a query within a React component, call `useGetPositioningStrategyForMessagingLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositioningStrategyForMessagingLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositioningStrategyForMessagingLibraryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPositioningStrategyForMessagingLibraryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPositioningStrategyForMessagingLibraryQuery, Types.GetPositioningStrategyForMessagingLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPositioningStrategyForMessagingLibraryQuery, Types.GetPositioningStrategyForMessagingLibraryQueryVariables>(GetPositioningStrategyForMessagingLibraryDocument, options);
      }
export function useGetPositioningStrategyForMessagingLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPositioningStrategyForMessagingLibraryQuery, Types.GetPositioningStrategyForMessagingLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPositioningStrategyForMessagingLibraryQuery, Types.GetPositioningStrategyForMessagingLibraryQueryVariables>(GetPositioningStrategyForMessagingLibraryDocument, options);
        }
export type GetPositioningStrategyForMessagingLibraryQueryHookResult = ReturnType<typeof useGetPositioningStrategyForMessagingLibraryQuery>;
export type GetPositioningStrategyForMessagingLibraryLazyQueryHookResult = ReturnType<typeof useGetPositioningStrategyForMessagingLibraryLazyQuery>;
export type GetPositioningStrategyForMessagingLibraryQueryResult = Apollo.QueryResult<Types.GetPositioningStrategyForMessagingLibraryQuery, Types.GetPositioningStrategyForMessagingLibraryQueryVariables>;
export const CountLaunchesDocument = gql`
    query CountLaunches {
  countLaunches
}
    `;

/**
 * __useCountLaunchesQuery__
 *
 * To run a query within a React component, call `useCountLaunchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountLaunchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountLaunchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountLaunchesQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountLaunchesQuery, Types.CountLaunchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountLaunchesQuery, Types.CountLaunchesQueryVariables>(CountLaunchesDocument, options);
      }
export function useCountLaunchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountLaunchesQuery, Types.CountLaunchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountLaunchesQuery, Types.CountLaunchesQueryVariables>(CountLaunchesDocument, options);
        }
export type CountLaunchesQueryHookResult = ReturnType<typeof useCountLaunchesQuery>;
export type CountLaunchesLazyQueryHookResult = ReturnType<typeof useCountLaunchesLazyQuery>;
export type CountLaunchesQueryResult = Apollo.QueryResult<Types.CountLaunchesQuery, Types.CountLaunchesQueryVariables>;
export const CountRoadmapItemsDocument = gql`
    query CountRoadmapItems {
  countRoadmapItems: countProductBoardItems
}
    `;

/**
 * __useCountRoadmapItemsQuery__
 *
 * To run a query within a React component, call `useCountRoadmapItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountRoadmapItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountRoadmapItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountRoadmapItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountRoadmapItemsQuery, Types.CountRoadmapItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountRoadmapItemsQuery, Types.CountRoadmapItemsQueryVariables>(CountRoadmapItemsDocument, options);
      }
export function useCountRoadmapItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountRoadmapItemsQuery, Types.CountRoadmapItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountRoadmapItemsQuery, Types.CountRoadmapItemsQueryVariables>(CountRoadmapItemsDocument, options);
        }
export type CountRoadmapItemsQueryHookResult = ReturnType<typeof useCountRoadmapItemsQuery>;
export type CountRoadmapItemsLazyQueryHookResult = ReturnType<typeof useCountRoadmapItemsLazyQuery>;
export type CountRoadmapItemsQueryResult = Apollo.QueryResult<Types.CountRoadmapItemsQuery, Types.CountRoadmapItemsQueryVariables>;
export const ObjectivesFilterOptionsDocument = gql`
    query ObjectivesFilterOptions {
  releaseOptions: productBoardReleases {
    value: id
    label: name
    iconColor
  }
  roadmapOptions: productBoardRoadmaps {
    value: id
    label: name
  }
  organization {
    id
    users {
      ...OrganizationUserInfo
    }
  }
}
    ${OrganizationUserInfoFragmentDoc}`;

/**
 * __useObjectivesFilterOptionsQuery__
 *
 * To run a query within a React component, call `useObjectivesFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectivesFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectivesFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useObjectivesFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ObjectivesFilterOptionsQuery, Types.ObjectivesFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ObjectivesFilterOptionsQuery, Types.ObjectivesFilterOptionsQueryVariables>(ObjectivesFilterOptionsDocument, options);
      }
export function useObjectivesFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ObjectivesFilterOptionsQuery, Types.ObjectivesFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ObjectivesFilterOptionsQuery, Types.ObjectivesFilterOptionsQueryVariables>(ObjectivesFilterOptionsDocument, options);
        }
export type ObjectivesFilterOptionsQueryHookResult = ReturnType<typeof useObjectivesFilterOptionsQuery>;
export type ObjectivesFilterOptionsLazyQueryHookResult = ReturnType<typeof useObjectivesFilterOptionsLazyQuery>;
export type ObjectivesFilterOptionsQueryResult = Apollo.QueryResult<Types.ObjectivesFilterOptionsQuery, Types.ObjectivesFilterOptionsQueryVariables>;
export const AddUserToOrganizationDocument = gql`
    mutation AddUserToOrganization($input: CreateNewUserInOrganizationInput!) {
  addNewUserToOrganization(input: $input) {
    ...OrganizationUser
    userDetails {
      ...UserDetails
    }
  }
}
    ${OrganizationUserFragmentDoc}
${UserDetailsFragmentDoc}`;
export type AddUserToOrganizationMutationFn = Apollo.MutationFunction<Types.AddUserToOrganizationMutation, Types.AddUserToOrganizationMutationVariables>;

/**
 * __useAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganizationMutation, { data, loading, error }] = useAddUserToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddUserToOrganizationMutation, Types.AddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddUserToOrganizationMutation, Types.AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument, options);
      }
export type AddUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationResult = Apollo.MutationResult<Types.AddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.AddUserToOrganizationMutation, Types.AddUserToOrganizationMutationVariables>;
export const PaginatedOrganizationUsersDocument = gql`
    query PaginatedOrganizationUsers($pagination: PaginationInput, $search: String) {
  paginatedOrganizationUsers: usersInOrganization(
    pagination: $pagination
    search: $search
  ) {
    hasNextPage
    totalPages
    totalDocs
    page
    docs {
      ...OrganizationUserDataForTable
    }
  }
}
    ${OrganizationUserDataForTableFragmentDoc}`;

/**
 * __usePaginatedOrganizationUsersQuery__
 *
 * To run a query within a React component, call `usePaginatedOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedOrganizationUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePaginatedOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.PaginatedOrganizationUsersQuery, Types.PaginatedOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedOrganizationUsersQuery, Types.PaginatedOrganizationUsersQueryVariables>(PaginatedOrganizationUsersDocument, options);
      }
export function usePaginatedOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedOrganizationUsersQuery, Types.PaginatedOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedOrganizationUsersQuery, Types.PaginatedOrganizationUsersQueryVariables>(PaginatedOrganizationUsersDocument, options);
        }
export type PaginatedOrganizationUsersQueryHookResult = ReturnType<typeof usePaginatedOrganizationUsersQuery>;
export type PaginatedOrganizationUsersLazyQueryHookResult = ReturnType<typeof usePaginatedOrganizationUsersLazyQuery>;
export type PaginatedOrganizationUsersQueryResult = Apollo.QueryResult<Types.PaginatedOrganizationUsersQuery, Types.PaginatedOrganizationUsersQueryVariables>;
export const ResendWelcomeMailDocument = gql`
    mutation ResendWelcomeMail($userId: String!) {
  resendWelcomeMail(userId: $userId)
}
    `;
export type ResendWelcomeMailMutationFn = Apollo.MutationFunction<Types.ResendWelcomeMailMutation, Types.ResendWelcomeMailMutationVariables>;

/**
 * __useResendWelcomeMailMutation__
 *
 * To run a mutation, you first call `useResendWelcomeMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWelcomeMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWelcomeMailMutation, { data, loading, error }] = useResendWelcomeMailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendWelcomeMailMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResendWelcomeMailMutation, Types.ResendWelcomeMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResendWelcomeMailMutation, Types.ResendWelcomeMailMutationVariables>(ResendWelcomeMailDocument, options);
      }
export type ResendWelcomeMailMutationHookResult = ReturnType<typeof useResendWelcomeMailMutation>;
export type ResendWelcomeMailMutationResult = Apollo.MutationResult<Types.ResendWelcomeMailMutation>;
export type ResendWelcomeMailMutationOptions = Apollo.BaseMutationOptions<Types.ResendWelcomeMailMutation, Types.ResendWelcomeMailMutationVariables>;
export const CreateProductIdeasViewDocument = gql`
    mutation CreateProductIdeasView($input: CreateFeedbackPostsViewInput!) {
  createProductIdeasView: createFeedbackPostView(input: $input) {
    ...ProductIdeasView
  }
}
    ${ProductIdeasViewFragmentDoc}`;
export type CreateProductIdeasViewMutationFn = Apollo.MutationFunction<Types.CreateProductIdeasViewMutation, Types.CreateProductIdeasViewMutationVariables>;

/**
 * __useCreateProductIdeasViewMutation__
 *
 * To run a mutation, you first call `useCreateProductIdeasViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductIdeasViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductIdeasViewMutation, { data, loading, error }] = useCreateProductIdeasViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductIdeasViewMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductIdeasViewMutation, Types.CreateProductIdeasViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductIdeasViewMutation, Types.CreateProductIdeasViewMutationVariables>(CreateProductIdeasViewDocument, options);
      }
export type CreateProductIdeasViewMutationHookResult = ReturnType<typeof useCreateProductIdeasViewMutation>;
export type CreateProductIdeasViewMutationResult = Apollo.MutationResult<Types.CreateProductIdeasViewMutation>;
export type CreateProductIdeasViewMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductIdeasViewMutation, Types.CreateProductIdeasViewMutationVariables>;
export const ProductIdeasBoardCustomColumnsDocument = gql`
    query ProductIdeasBoardCustomColumns($id: String!) {
  productIdeasBoard: feedbackBoard(id: $id) {
    ...ProductIdeasBoardWithCustomColumns
  }
}
    ${ProductIdeasBoardWithCustomColumnsFragmentDoc}`;

/**
 * __useProductIdeasBoardCustomColumnsQuery__
 *
 * To run a query within a React component, call `useProductIdeasBoardCustomColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdeasBoardCustomColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdeasBoardCustomColumnsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductIdeasBoardCustomColumnsQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductIdeasBoardCustomColumnsQuery, Types.ProductIdeasBoardCustomColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductIdeasBoardCustomColumnsQuery, Types.ProductIdeasBoardCustomColumnsQueryVariables>(ProductIdeasBoardCustomColumnsDocument, options);
      }
export function useProductIdeasBoardCustomColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductIdeasBoardCustomColumnsQuery, Types.ProductIdeasBoardCustomColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductIdeasBoardCustomColumnsQuery, Types.ProductIdeasBoardCustomColumnsQueryVariables>(ProductIdeasBoardCustomColumnsDocument, options);
        }
export type ProductIdeasBoardCustomColumnsQueryHookResult = ReturnType<typeof useProductIdeasBoardCustomColumnsQuery>;
export type ProductIdeasBoardCustomColumnsLazyQueryHookResult = ReturnType<typeof useProductIdeasBoardCustomColumnsLazyQuery>;
export type ProductIdeasBoardCustomColumnsQueryResult = Apollo.QueryResult<Types.ProductIdeasBoardCustomColumnsQuery, Types.ProductIdeasBoardCustomColumnsQueryVariables>;
export const ProductIdeasViewsDocument = gql`
    query ProductIdeasViews {
  productIdeasViews: feedbackPostsViews {
    ...ProductIdeasView
  }
}
    ${ProductIdeasViewFragmentDoc}`;

/**
 * __useProductIdeasViewsQuery__
 *
 * To run a query within a React component, call `useProductIdeasViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdeasViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdeasViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductIdeasViewsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductIdeasViewsQuery, Types.ProductIdeasViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductIdeasViewsQuery, Types.ProductIdeasViewsQueryVariables>(ProductIdeasViewsDocument, options);
      }
export function useProductIdeasViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductIdeasViewsQuery, Types.ProductIdeasViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductIdeasViewsQuery, Types.ProductIdeasViewsQueryVariables>(ProductIdeasViewsDocument, options);
        }
export type ProductIdeasViewsQueryHookResult = ReturnType<typeof useProductIdeasViewsQuery>;
export type ProductIdeasViewsLazyQueryHookResult = ReturnType<typeof useProductIdeasViewsLazyQuery>;
export type ProductIdeasViewsQueryResult = Apollo.QueryResult<Types.ProductIdeasViewsQuery, Types.ProductIdeasViewsQueryVariables>;
export const CountProductIdeasDocument = gql`
    query CountProductIdeas {
  countProductIdeas: countFeedbackPosts
}
    `;

/**
 * __useCountProductIdeasQuery__
 *
 * To run a query within a React component, call `useCountProductIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountProductIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountProductIdeasQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountProductIdeasQuery(baseOptions?: Apollo.QueryHookOptions<Types.CountProductIdeasQuery, Types.CountProductIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountProductIdeasQuery, Types.CountProductIdeasQueryVariables>(CountProductIdeasDocument, options);
      }
export function useCountProductIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountProductIdeasQuery, Types.CountProductIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountProductIdeasQuery, Types.CountProductIdeasQueryVariables>(CountProductIdeasDocument, options);
        }
export type CountProductIdeasQueryHookResult = ReturnType<typeof useCountProductIdeasQuery>;
export type CountProductIdeasLazyQueryHookResult = ReturnType<typeof useCountProductIdeasLazyQuery>;
export type CountProductIdeasQueryResult = Apollo.QueryResult<Types.CountProductIdeasQuery, Types.CountProductIdeasQueryVariables>;
export const ProductSummaryFilterOptionsDocument = gql`
    query ProductSummaryFilterOptions {
  roadmapFilterOptions: productBoardRoadmaps {
    value: id
    label: name
  }
}
    `;

/**
 * __useProductSummaryFilterOptionsQuery__
 *
 * To run a query within a React component, call `useProductSummaryFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSummaryFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSummaryFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductSummaryFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductSummaryFilterOptionsQuery, Types.ProductSummaryFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductSummaryFilterOptionsQuery, Types.ProductSummaryFilterOptionsQueryVariables>(ProductSummaryFilterOptionsDocument, options);
      }
export function useProductSummaryFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductSummaryFilterOptionsQuery, Types.ProductSummaryFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductSummaryFilterOptionsQuery, Types.ProductSummaryFilterOptionsQueryVariables>(ProductSummaryFilterOptionsDocument, options);
        }
export type ProductSummaryFilterOptionsQueryHookResult = ReturnType<typeof useProductSummaryFilterOptionsQuery>;
export type ProductSummaryFilterOptionsLazyQueryHookResult = ReturnType<typeof useProductSummaryFilterOptionsLazyQuery>;
export type ProductSummaryFilterOptionsQueryResult = Apollo.QueryResult<Types.ProductSummaryFilterOptionsQuery, Types.ProductSummaryFilterOptionsQueryVariables>;
export const OrganizationDataForCreateEntityCtaDocument = gql`
    query OrganizationDataForCreateEntityCTA {
  organization {
    id
    isActive
    users {
      userId
      role
    }
  }
}
    `;

/**
 * __useOrganizationDataForCreateEntityCtaQuery__
 *
 * To run a query within a React component, call `useOrganizationDataForCreateEntityCtaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDataForCreateEntityCtaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDataForCreateEntityCtaQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationDataForCreateEntityCtaQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationDataForCreateEntityCtaQuery, Types.OrganizationDataForCreateEntityCtaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationDataForCreateEntityCtaQuery, Types.OrganizationDataForCreateEntityCtaQueryVariables>(OrganizationDataForCreateEntityCtaDocument, options);
      }
export function useOrganizationDataForCreateEntityCtaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationDataForCreateEntityCtaQuery, Types.OrganizationDataForCreateEntityCtaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationDataForCreateEntityCtaQuery, Types.OrganizationDataForCreateEntityCtaQueryVariables>(OrganizationDataForCreateEntityCtaDocument, options);
        }
export type OrganizationDataForCreateEntityCtaQueryHookResult = ReturnType<typeof useOrganizationDataForCreateEntityCtaQuery>;
export type OrganizationDataForCreateEntityCtaLazyQueryHookResult = ReturnType<typeof useOrganizationDataForCreateEntityCtaLazyQuery>;
export type OrganizationDataForCreateEntityCtaQueryResult = Apollo.QueryResult<Types.OrganizationDataForCreateEntityCtaQuery, Types.OrganizationDataForCreateEntityCtaQueryVariables>;
export const OrganizationReleaseNoteFilterOptionsDocument = gql`
    query OrganizationReleaseNoteFilterOptions {
  organization {
    id
    users {
      ...OrganizationUserFilterOptionData
    }
  }
  tags(input: {types: [RELEASE_NOTE]}) {
    ...TagFilterOptionData
  }
}
    ${OrganizationUserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}`;

/**
 * __useOrganizationReleaseNoteFilterOptionsQuery__
 *
 * To run a query within a React component, call `useOrganizationReleaseNoteFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationReleaseNoteFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationReleaseNoteFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationReleaseNoteFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationReleaseNoteFilterOptionsQuery, Types.OrganizationReleaseNoteFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationReleaseNoteFilterOptionsQuery, Types.OrganizationReleaseNoteFilterOptionsQueryVariables>(OrganizationReleaseNoteFilterOptionsDocument, options);
      }
export function useOrganizationReleaseNoteFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationReleaseNoteFilterOptionsQuery, Types.OrganizationReleaseNoteFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationReleaseNoteFilterOptionsQuery, Types.OrganizationReleaseNoteFilterOptionsQueryVariables>(OrganizationReleaseNoteFilterOptionsDocument, options);
        }
export type OrganizationReleaseNoteFilterOptionsQueryHookResult = ReturnType<typeof useOrganizationReleaseNoteFilterOptionsQuery>;
export type OrganizationReleaseNoteFilterOptionsLazyQueryHookResult = ReturnType<typeof useOrganizationReleaseNoteFilterOptionsLazyQuery>;
export type OrganizationReleaseNoteFilterOptionsQueryResult = Apollo.QueryResult<Types.OrganizationReleaseNoteFilterOptionsQuery, Types.OrganizationReleaseNoteFilterOptionsQueryVariables>;
export const PublicReleaseNoteFilterOptionsDocument = gql`
    query PublicReleaseNoteFilterOptions {
  organization {
    id
    users {
      ...OrganizationUserFilterOptionData
    }
  }
  tags(input: {types: [RELEASE_NOTE]}) {
    ...TagFilterOptionData
  }
}
    ${OrganizationUserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}`;

/**
 * __usePublicReleaseNoteFilterOptionsQuery__
 *
 * To run a query within a React component, call `usePublicReleaseNoteFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicReleaseNoteFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicReleaseNoteFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicReleaseNoteFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicReleaseNoteFilterOptionsQuery, Types.PublicReleaseNoteFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicReleaseNoteFilterOptionsQuery, Types.PublicReleaseNoteFilterOptionsQueryVariables>(PublicReleaseNoteFilterOptionsDocument, options);
      }
export function usePublicReleaseNoteFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicReleaseNoteFilterOptionsQuery, Types.PublicReleaseNoteFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicReleaseNoteFilterOptionsQuery, Types.PublicReleaseNoteFilterOptionsQueryVariables>(PublicReleaseNoteFilterOptionsDocument, options);
        }
export type PublicReleaseNoteFilterOptionsQueryHookResult = ReturnType<typeof usePublicReleaseNoteFilterOptionsQuery>;
export type PublicReleaseNoteFilterOptionsLazyQueryHookResult = ReturnType<typeof usePublicReleaseNoteFilterOptionsLazyQuery>;
export type PublicReleaseNoteFilterOptionsQueryResult = Apollo.QueryResult<Types.PublicReleaseNoteFilterOptionsQuery, Types.PublicReleaseNoteFilterOptionsQueryVariables>;
export const GenerateReleaseNotesFromRoadmapItemsDocument = gql`
    mutation GenerateReleaseNotesFromRoadmapItems($itemIds: [String!]!) {
  generateReleaseNoteFromProductRoadmapItems(productRoadmapItemIds: $itemIds) {
    ...ReleaseNote
  }
}
    ${ReleaseNoteFragmentDoc}`;
export type GenerateReleaseNotesFromRoadmapItemsMutationFn = Apollo.MutationFunction<Types.GenerateReleaseNotesFromRoadmapItemsMutation, Types.GenerateReleaseNotesFromRoadmapItemsMutationVariables>;

/**
 * __useGenerateReleaseNotesFromRoadmapItemsMutation__
 *
 * To run a mutation, you first call `useGenerateReleaseNotesFromRoadmapItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReleaseNotesFromRoadmapItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReleaseNotesFromRoadmapItemsMutation, { data, loading, error }] = useGenerateReleaseNotesFromRoadmapItemsMutation({
 *   variables: {
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useGenerateReleaseNotesFromRoadmapItemsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateReleaseNotesFromRoadmapItemsMutation, Types.GenerateReleaseNotesFromRoadmapItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateReleaseNotesFromRoadmapItemsMutation, Types.GenerateReleaseNotesFromRoadmapItemsMutationVariables>(GenerateReleaseNotesFromRoadmapItemsDocument, options);
      }
export type GenerateReleaseNotesFromRoadmapItemsMutationHookResult = ReturnType<typeof useGenerateReleaseNotesFromRoadmapItemsMutation>;
export type GenerateReleaseNotesFromRoadmapItemsMutationResult = Apollo.MutationResult<Types.GenerateReleaseNotesFromRoadmapItemsMutation>;
export type GenerateReleaseNotesFromRoadmapItemsMutationOptions = Apollo.BaseMutationOptions<Types.GenerateReleaseNotesFromRoadmapItemsMutation, Types.GenerateReleaseNotesFromRoadmapItemsMutationVariables>;
export const CreateRoadmapItemsViewDocument = gql`
    mutation CreateRoadmapItemsView($input: CreateProductBoardItemsViewInput!) {
  createRoadmapItemsView: createProductBoardItemsView(input: $input) {
    ...RoadmapItemsView
  }
}
    ${RoadmapItemsViewFragmentDoc}`;
export type CreateRoadmapItemsViewMutationFn = Apollo.MutationFunction<Types.CreateRoadmapItemsViewMutation, Types.CreateRoadmapItemsViewMutationVariables>;

/**
 * __useCreateRoadmapItemsViewMutation__
 *
 * To run a mutation, you first call `useCreateRoadmapItemsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoadmapItemsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoadmapItemsViewMutation, { data, loading, error }] = useCreateRoadmapItemsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoadmapItemsViewMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateRoadmapItemsViewMutation, Types.CreateRoadmapItemsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateRoadmapItemsViewMutation, Types.CreateRoadmapItemsViewMutationVariables>(CreateRoadmapItemsViewDocument, options);
      }
export type CreateRoadmapItemsViewMutationHookResult = ReturnType<typeof useCreateRoadmapItemsViewMutation>;
export type CreateRoadmapItemsViewMutationResult = Apollo.MutationResult<Types.CreateRoadmapItemsViewMutation>;
export type CreateRoadmapItemsViewMutationOptions = Apollo.BaseMutationOptions<Types.CreateRoadmapItemsViewMutation, Types.CreateRoadmapItemsViewMutationVariables>;
export const DeleteRoadmapItemsViewDocument = gql`
    mutation DeleteRoadmapItemsView($id: String!) {
  deleteRoadmapItemsView: deleteProductBoardItemsView(id: $id) {
    id
  }
}
    `;
export type DeleteRoadmapItemsViewMutationFn = Apollo.MutationFunction<Types.DeleteRoadmapItemsViewMutation, Types.DeleteRoadmapItemsViewMutationVariables>;

/**
 * __useDeleteRoadmapItemsViewMutation__
 *
 * To run a mutation, you first call `useDeleteRoadmapItemsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoadmapItemsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoadmapItemsViewMutation, { data, loading, error }] = useDeleteRoadmapItemsViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoadmapItemsViewMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRoadmapItemsViewMutation, Types.DeleteRoadmapItemsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRoadmapItemsViewMutation, Types.DeleteRoadmapItemsViewMutationVariables>(DeleteRoadmapItemsViewDocument, options);
      }
export type DeleteRoadmapItemsViewMutationHookResult = ReturnType<typeof useDeleteRoadmapItemsViewMutation>;
export type DeleteRoadmapItemsViewMutationResult = Apollo.MutationResult<Types.DeleteRoadmapItemsViewMutation>;
export type DeleteRoadmapItemsViewMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRoadmapItemsViewMutation, Types.DeleteRoadmapItemsViewMutationVariables>;
export const UpdateRoadmapItemsViewDocument = gql`
    mutation UpdateRoadmapItemsView($input: UpdateProductBoardItemsViewInput!) {
  UpdateRoadmapItemsView: updateProductBoardItemsView(input: $input) {
    ...RoadmapItemsView
  }
}
    ${RoadmapItemsViewFragmentDoc}`;
export type UpdateRoadmapItemsViewMutationFn = Apollo.MutationFunction<Types.UpdateRoadmapItemsViewMutation, Types.UpdateRoadmapItemsViewMutationVariables>;

/**
 * __useUpdateRoadmapItemsViewMutation__
 *
 * To run a mutation, you first call `useUpdateRoadmapItemsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoadmapItemsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoadmapItemsViewMutation, { data, loading, error }] = useUpdateRoadmapItemsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoadmapItemsViewMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRoadmapItemsViewMutation, Types.UpdateRoadmapItemsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRoadmapItemsViewMutation, Types.UpdateRoadmapItemsViewMutationVariables>(UpdateRoadmapItemsViewDocument, options);
      }
export type UpdateRoadmapItemsViewMutationHookResult = ReturnType<typeof useUpdateRoadmapItemsViewMutation>;
export type UpdateRoadmapItemsViewMutationResult = Apollo.MutationResult<Types.UpdateRoadmapItemsViewMutation>;
export type UpdateRoadmapItemsViewMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRoadmapItemsViewMutation, Types.UpdateRoadmapItemsViewMutationVariables>;
export const MoveProductBoardItemDocument = gql`
    mutation MoveProductBoardItem($input: MoveProductBoardItemInput!) {
  moveProductBoardItem(input: $input) {
    ...RoadmapItemsView
  }
}
    ${RoadmapItemsViewFragmentDoc}`;
export type MoveProductBoardItemMutationFn = Apollo.MutationFunction<Types.MoveProductBoardItemMutation, Types.MoveProductBoardItemMutationVariables>;

/**
 * __useMoveProductBoardItemMutation__
 *
 * To run a mutation, you first call `useMoveProductBoardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProductBoardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProductBoardItemMutation, { data, loading, error }] = useMoveProductBoardItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveProductBoardItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.MoveProductBoardItemMutation, Types.MoveProductBoardItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MoveProductBoardItemMutation, Types.MoveProductBoardItemMutationVariables>(MoveProductBoardItemDocument, options);
      }
export type MoveProductBoardItemMutationHookResult = ReturnType<typeof useMoveProductBoardItemMutation>;
export type MoveProductBoardItemMutationResult = Apollo.MutationResult<Types.MoveProductBoardItemMutation>;
export type MoveProductBoardItemMutationOptions = Apollo.BaseMutationOptions<Types.MoveProductBoardItemMutation, Types.MoveProductBoardItemMutationVariables>;
export const RoadmapDisplayPropertiesDocument = gql`
    query RoadmapDisplayProperties {
  productBoardCustomColumns {
    ...RoadmapColumnDisplayProperty
  }
  productBoardFactors {
    ...RoadmapFactorDisplayProperty
  }
}
    ${RoadmapColumnDisplayPropertyFragmentDoc}
${RoadmapFactorDisplayPropertyFragmentDoc}`;

/**
 * __useRoadmapDisplayPropertiesQuery__
 *
 * To run a query within a React component, call `useRoadmapDisplayPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadmapDisplayPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadmapDisplayPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoadmapDisplayPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<Types.RoadmapDisplayPropertiesQuery, Types.RoadmapDisplayPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RoadmapDisplayPropertiesQuery, Types.RoadmapDisplayPropertiesQueryVariables>(RoadmapDisplayPropertiesDocument, options);
      }
export function useRoadmapDisplayPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RoadmapDisplayPropertiesQuery, Types.RoadmapDisplayPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RoadmapDisplayPropertiesQuery, Types.RoadmapDisplayPropertiesQueryVariables>(RoadmapDisplayPropertiesDocument, options);
        }
export type RoadmapDisplayPropertiesQueryHookResult = ReturnType<typeof useRoadmapDisplayPropertiesQuery>;
export type RoadmapDisplayPropertiesLazyQueryHookResult = ReturnType<typeof useRoadmapDisplayPropertiesLazyQuery>;
export type RoadmapDisplayPropertiesQueryResult = Apollo.QueryResult<Types.RoadmapDisplayPropertiesQuery, Types.RoadmapDisplayPropertiesQueryVariables>;
export const RoadmapItemsViewsDocument = gql`
    query RoadmapItemsViews {
  roadmapItemsViews: productBoardItemViews {
    ...RoadmapItemsView
  }
}
    ${RoadmapItemsViewFragmentDoc}`;

/**
 * __useRoadmapItemsViewsQuery__
 *
 * To run a query within a React component, call `useRoadmapItemsViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadmapItemsViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoadmapItemsViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoadmapItemsViewsQuery(baseOptions?: Apollo.QueryHookOptions<Types.RoadmapItemsViewsQuery, Types.RoadmapItemsViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RoadmapItemsViewsQuery, Types.RoadmapItemsViewsQueryVariables>(RoadmapItemsViewsDocument, options);
      }
export function useRoadmapItemsViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RoadmapItemsViewsQuery, Types.RoadmapItemsViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RoadmapItemsViewsQuery, Types.RoadmapItemsViewsQueryVariables>(RoadmapItemsViewsDocument, options);
        }
export type RoadmapItemsViewsQueryHookResult = ReturnType<typeof useRoadmapItemsViewsQuery>;
export type RoadmapItemsViewsLazyQueryHookResult = ReturnType<typeof useRoadmapItemsViewsLazyQuery>;
export type RoadmapItemsViewsQueryResult = Apollo.QueryResult<Types.RoadmapItemsViewsQuery, Types.RoadmapItemsViewsQueryVariables>;
export const GenerateTagsForAllInsightsDocument = gql`
    mutation GenerateTagsForAllInsights {
  generateTagsForAllInsightsInOrg
}
    `;
export type GenerateTagsForAllInsightsMutationFn = Apollo.MutationFunction<Types.GenerateTagsForAllInsightsMutation, Types.GenerateTagsForAllInsightsMutationVariables>;

/**
 * __useGenerateTagsForAllInsightsMutation__
 *
 * To run a mutation, you first call `useGenerateTagsForAllInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTagsForAllInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTagsForAllInsightsMutation, { data, loading, error }] = useGenerateTagsForAllInsightsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateTagsForAllInsightsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateTagsForAllInsightsMutation, Types.GenerateTagsForAllInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateTagsForAllInsightsMutation, Types.GenerateTagsForAllInsightsMutationVariables>(GenerateTagsForAllInsightsDocument, options);
      }
export type GenerateTagsForAllInsightsMutationHookResult = ReturnType<typeof useGenerateTagsForAllInsightsMutation>;
export type GenerateTagsForAllInsightsMutationResult = Apollo.MutationResult<Types.GenerateTagsForAllInsightsMutation>;
export type GenerateTagsForAllInsightsMutationOptions = Apollo.BaseMutationOptions<Types.GenerateTagsForAllInsightsMutation, Types.GenerateTagsForAllInsightsMutationVariables>;
export const TagsSettingsDocument = gql`
    query TagsSettings($filter: PaginatedTagsFilterInput, $sort: SortTagsInput, $pagination: PaginationInput) {
  paginatedTags(sort: $sort, filter: $filter, pagination: $pagination) {
    page
    totalDocs
    totalPages
    docs {
      ...Tag
    }
  }
}
    ${TagFragmentDoc}`;

/**
 * __useTagsSettingsQuery__
 *
 * To run a query within a React component, call `useTagsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsSettingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useTagsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TagsSettingsQuery, Types.TagsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TagsSettingsQuery, Types.TagsSettingsQueryVariables>(TagsSettingsDocument, options);
      }
export function useTagsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TagsSettingsQuery, Types.TagsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TagsSettingsQuery, Types.TagsSettingsQueryVariables>(TagsSettingsDocument, options);
        }
export type TagsSettingsQueryHookResult = ReturnType<typeof useTagsSettingsQuery>;
export type TagsSettingsLazyQueryHookResult = ReturnType<typeof useTagsSettingsLazyQuery>;
export type TagsSettingsQueryResult = Apollo.QueryResult<Types.TagsSettingsQuery, Types.TagsSettingsQueryVariables>;
export const AutoInsightsTaggingSettingDocument = gql`
    mutation AutoInsightsTaggingSetting($enable: Boolean!) {
  autoInsightsTaggingSetting(enable: $enable) {
    ...OrganizationContent
  }
}
    ${OrganizationContentFragmentDoc}`;
export type AutoInsightsTaggingSettingMutationFn = Apollo.MutationFunction<Types.AutoInsightsTaggingSettingMutation, Types.AutoInsightsTaggingSettingMutationVariables>;

/**
 * __useAutoInsightsTaggingSettingMutation__
 *
 * To run a mutation, you first call `useAutoInsightsTaggingSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoInsightsTaggingSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoInsightsTaggingSettingMutation, { data, loading, error }] = useAutoInsightsTaggingSettingMutation({
 *   variables: {
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useAutoInsightsTaggingSettingMutation(baseOptions?: Apollo.MutationHookOptions<Types.AutoInsightsTaggingSettingMutation, Types.AutoInsightsTaggingSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AutoInsightsTaggingSettingMutation, Types.AutoInsightsTaggingSettingMutationVariables>(AutoInsightsTaggingSettingDocument, options);
      }
export type AutoInsightsTaggingSettingMutationHookResult = ReturnType<typeof useAutoInsightsTaggingSettingMutation>;
export type AutoInsightsTaggingSettingMutationResult = Apollo.MutationResult<Types.AutoInsightsTaggingSettingMutation>;
export type AutoInsightsTaggingSettingMutationOptions = Apollo.BaseMutationOptions<Types.AutoInsightsTaggingSettingMutation, Types.AutoInsightsTaggingSettingMutationVariables>;
export const RoadmapToInsightsMappingSettingDocument = gql`
    mutation RoadmapToInsightsMappingSetting($enable: Boolean!) {
  roadmapToInsightsMappingSetting(enable: $enable) {
    ...OrganizationContent
  }
}
    ${OrganizationContentFragmentDoc}`;
export type RoadmapToInsightsMappingSettingMutationFn = Apollo.MutationFunction<Types.RoadmapToInsightsMappingSettingMutation, Types.RoadmapToInsightsMappingSettingMutationVariables>;

/**
 * __useRoadmapToInsightsMappingSettingMutation__
 *
 * To run a mutation, you first call `useRoadmapToInsightsMappingSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoadmapToInsightsMappingSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roadmapToInsightsMappingSettingMutation, { data, loading, error }] = useRoadmapToInsightsMappingSettingMutation({
 *   variables: {
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useRoadmapToInsightsMappingSettingMutation(baseOptions?: Apollo.MutationHookOptions<Types.RoadmapToInsightsMappingSettingMutation, Types.RoadmapToInsightsMappingSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RoadmapToInsightsMappingSettingMutation, Types.RoadmapToInsightsMappingSettingMutationVariables>(RoadmapToInsightsMappingSettingDocument, options);
      }
export type RoadmapToInsightsMappingSettingMutationHookResult = ReturnType<typeof useRoadmapToInsightsMappingSettingMutation>;
export type RoadmapToInsightsMappingSettingMutationResult = Apollo.MutationResult<Types.RoadmapToInsightsMappingSettingMutation>;
export type RoadmapToInsightsMappingSettingMutationOptions = Apollo.BaseMutationOptions<Types.RoadmapToInsightsMappingSettingMutation, Types.RoadmapToInsightsMappingSettingMutationVariables>;
export const OrganizationUserOptionsDocument = gql`
    query OrganizationUserOptions {
  organization {
    id
    users {
      ...OrganizationUserFilterOptionData
    }
  }
}
    ${OrganizationUserFilterOptionDataFragmentDoc}`;

/**
 * __useOrganizationUserOptionsQuery__
 *
 * To run a query within a React component, call `useOrganizationUserOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUserOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationUserOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationUserOptionsQuery, Types.OrganizationUserOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationUserOptionsQuery, Types.OrganizationUserOptionsQueryVariables>(OrganizationUserOptionsDocument, options);
      }
export function useOrganizationUserOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationUserOptionsQuery, Types.OrganizationUserOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationUserOptionsQuery, Types.OrganizationUserOptionsQueryVariables>(OrganizationUserOptionsDocument, options);
        }
export type OrganizationUserOptionsQueryHookResult = ReturnType<typeof useOrganizationUserOptionsQuery>;
export type OrganizationUserOptionsLazyQueryHookResult = ReturnType<typeof useOrganizationUserOptionsLazyQuery>;
export type OrganizationUserOptionsQueryResult = Apollo.QueryResult<Types.OrganizationUserOptionsQuery, Types.OrganizationUserOptionsQueryVariables>;
export const TaskTagsOptionsDocument = gql`
    query TaskTagsOptions {
  tags(input: {types: [TASK, PRODUCT_LINE, CHANNEL]}) {
    ...TagFilterOptionData
  }
}
    ${TagFilterOptionDataFragmentDoc}`;

/**
 * __useTaskTagsOptionsQuery__
 *
 * To run a query within a React component, call `useTaskTagsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTagsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTagsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskTagsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TaskTagsOptionsQuery, Types.TaskTagsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TaskTagsOptionsQuery, Types.TaskTagsOptionsQueryVariables>(TaskTagsOptionsDocument, options);
      }
export function useTaskTagsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TaskTagsOptionsQuery, Types.TaskTagsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TaskTagsOptionsQuery, Types.TaskTagsOptionsQueryVariables>(TaskTagsOptionsDocument, options);
        }
export type TaskTagsOptionsQueryHookResult = ReturnType<typeof useTaskTagsOptionsQuery>;
export type TaskTagsOptionsLazyQueryHookResult = ReturnType<typeof useTaskTagsOptionsLazyQuery>;
export type TaskTagsOptionsQueryResult = Apollo.QueryResult<Types.TaskTagsOptionsQuery, Types.TaskTagsOptionsQueryVariables>;
export const CreateTestimonialsFromInsightsDocument = gql`
    mutation CreateTestimonialsFromInsights($input: CreateTestimonialsFromInsightsInput!) {
  createTestimonialsFromInsights(input: $input) {
    ...TestimonialFromInsightObj
  }
}
    ${TestimonialFromInsightObjFragmentDoc}`;
export type CreateTestimonialsFromInsightsMutationFn = Apollo.MutationFunction<Types.CreateTestimonialsFromInsightsMutation, Types.CreateTestimonialsFromInsightsMutationVariables>;

/**
 * __useCreateTestimonialsFromInsightsMutation__
 *
 * To run a mutation, you first call `useCreateTestimonialsFromInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestimonialsFromInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestimonialsFromInsightsMutation, { data, loading, error }] = useCreateTestimonialsFromInsightsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestimonialsFromInsightsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTestimonialsFromInsightsMutation, Types.CreateTestimonialsFromInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTestimonialsFromInsightsMutation, Types.CreateTestimonialsFromInsightsMutationVariables>(CreateTestimonialsFromInsightsDocument, options);
      }
export type CreateTestimonialsFromInsightsMutationHookResult = ReturnType<typeof useCreateTestimonialsFromInsightsMutation>;
export type CreateTestimonialsFromInsightsMutationResult = Apollo.MutationResult<Types.CreateTestimonialsFromInsightsMutation>;
export type CreateTestimonialsFromInsightsMutationOptions = Apollo.BaseMutationOptions<Types.CreateTestimonialsFromInsightsMutation, Types.CreateTestimonialsFromInsightsMutationVariables>;
export const GenerateTestimonialsFromInsightsDocument = gql`
    mutation GenerateTestimonialsFromInsights {
  generateTestimonialsFromInsights {
    ...GeneratedTestimonialFromInsightObj
  }
}
    ${GeneratedTestimonialFromInsightObjFragmentDoc}`;
export type GenerateTestimonialsFromInsightsMutationFn = Apollo.MutationFunction<Types.GenerateTestimonialsFromInsightsMutation, Types.GenerateTestimonialsFromInsightsMutationVariables>;

/**
 * __useGenerateTestimonialsFromInsightsMutation__
 *
 * To run a mutation, you first call `useGenerateTestimonialsFromInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTestimonialsFromInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTestimonialsFromInsightsMutation, { data, loading, error }] = useGenerateTestimonialsFromInsightsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateTestimonialsFromInsightsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateTestimonialsFromInsightsMutation, Types.GenerateTestimonialsFromInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateTestimonialsFromInsightsMutation, Types.GenerateTestimonialsFromInsightsMutationVariables>(GenerateTestimonialsFromInsightsDocument, options);
      }
export type GenerateTestimonialsFromInsightsMutationHookResult = ReturnType<typeof useGenerateTestimonialsFromInsightsMutation>;
export type GenerateTestimonialsFromInsightsMutationResult = Apollo.MutationResult<Types.GenerateTestimonialsFromInsightsMutation>;
export type GenerateTestimonialsFromInsightsMutationOptions = Apollo.BaseMutationOptions<Types.GenerateTestimonialsFromInsightsMutation, Types.GenerateTestimonialsFromInsightsMutationVariables>;
export const TestimonialsFilterOptionsDocument = gql`
    query TestimonialsFilterOptions {
  tags(input: {types: [RESEARCH_HUB_TESTIMONIALS, PRODUCT_LINE, LAUNCH_NAME]}) {
    ...TagFilterOptionData
  }
}
    ${TagFilterOptionDataFragmentDoc}`;

/**
 * __useTestimonialsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useTestimonialsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestimonialsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestimonialsFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestimonialsFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TestimonialsFilterOptionsQuery, Types.TestimonialsFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TestimonialsFilterOptionsQuery, Types.TestimonialsFilterOptionsQueryVariables>(TestimonialsFilterOptionsDocument, options);
      }
export function useTestimonialsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TestimonialsFilterOptionsQuery, Types.TestimonialsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TestimonialsFilterOptionsQuery, Types.TestimonialsFilterOptionsQueryVariables>(TestimonialsFilterOptionsDocument, options);
        }
export type TestimonialsFilterOptionsQueryHookResult = ReturnType<typeof useTestimonialsFilterOptionsQuery>;
export type TestimonialsFilterOptionsLazyQueryHookResult = ReturnType<typeof useTestimonialsFilterOptionsLazyQuery>;
export type TestimonialsFilterOptionsQueryResult = Apollo.QueryResult<Types.TestimonialsFilterOptionsQuery, Types.TestimonialsFilterOptionsQueryVariables>;
export const LaunchTimelineFilterOptionsDocument = gql`
    query LaunchTimelineFilterOptions {
  tasksAssignees {
    ...UserFilterOptionData
  }
  tasksTags: tags(input: {types: [TASK, PRODUCT_LINE]}) {
    ...TagFilterOptionData
  }
  productBoardReleases {
    ...ProductBoardReleaseFilterOptionData
  }
}
    ${UserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}
${ProductBoardReleaseFilterOptionDataFragmentDoc}`;

/**
 * __useLaunchTimelineFilterOptionsQuery__
 *
 * To run a query within a React component, call `useLaunchTimelineFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchTimelineFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchTimelineFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaunchTimelineFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.LaunchTimelineFilterOptionsQuery, Types.LaunchTimelineFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LaunchTimelineFilterOptionsQuery, Types.LaunchTimelineFilterOptionsQueryVariables>(LaunchTimelineFilterOptionsDocument, options);
      }
export function useLaunchTimelineFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LaunchTimelineFilterOptionsQuery, Types.LaunchTimelineFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LaunchTimelineFilterOptionsQuery, Types.LaunchTimelineFilterOptionsQueryVariables>(LaunchTimelineFilterOptionsDocument, options);
        }
export type LaunchTimelineFilterOptionsQueryHookResult = ReturnType<typeof useLaunchTimelineFilterOptionsQuery>;
export type LaunchTimelineFilterOptionsLazyQueryHookResult = ReturnType<typeof useLaunchTimelineFilterOptionsLazyQuery>;
export type LaunchTimelineFilterOptionsQueryResult = Apollo.QueryResult<Types.LaunchTimelineFilterOptionsQuery, Types.LaunchTimelineFilterOptionsQueryVariables>;
export const OrganizationTimelineFilterOptionsDocument = gql`
    query OrganizationTimelineFilterOptions {
  launchOptions: launchesFilterOptions {
    owners {
      ...UserFilterOptionData
    }
    tags {
      ...TagFilterOptionData
    }
  }
  launchTypes {
    ...LaunchTypeFilterOptionData
  }
  tasksAssignees {
    ...UserFilterOptionData
  }
  tasksTags: tags(input: {types: [TASK, PRODUCT_LINE]}) {
    ...TagFilterOptionData
  }
  productBoardReleases {
    ...ProductBoardReleaseFilterOptionData
  }
}
    ${UserFilterOptionDataFragmentDoc}
${TagFilterOptionDataFragmentDoc}
${LaunchTypeFilterOptionDataFragmentDoc}
${ProductBoardReleaseFilterOptionDataFragmentDoc}`;

/**
 * __useOrganizationTimelineFilterOptionsQuery__
 *
 * To run a query within a React component, call `useOrganizationTimelineFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTimelineFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTimelineFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationTimelineFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationTimelineFilterOptionsQuery, Types.OrganizationTimelineFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationTimelineFilterOptionsQuery, Types.OrganizationTimelineFilterOptionsQueryVariables>(OrganizationTimelineFilterOptionsDocument, options);
      }
export function useOrganizationTimelineFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationTimelineFilterOptionsQuery, Types.OrganizationTimelineFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationTimelineFilterOptionsQuery, Types.OrganizationTimelineFilterOptionsQueryVariables>(OrganizationTimelineFilterOptionsDocument, options);
        }
export type OrganizationTimelineFilterOptionsQueryHookResult = ReturnType<typeof useOrganizationTimelineFilterOptionsQuery>;
export type OrganizationTimelineFilterOptionsLazyQueryHookResult = ReturnType<typeof useOrganizationTimelineFilterOptionsLazyQuery>;
export type OrganizationTimelineFilterOptionsQueryResult = Apollo.QueryResult<Types.OrganizationTimelineFilterOptionsQuery, Types.OrganizationTimelineFilterOptionsQueryVariables>;
export const ClearbitForOnboardingDocument = gql`
    query ClearbitForOnboarding($companyDomain: String) {
  clearbitForOnboarding(companyDomain: $companyDomain) {
    ...CompanyInfoFromWebsite
  }
}
    ${CompanyInfoFromWebsiteFragmentDoc}`;

/**
 * __useClearbitForOnboardingQuery__
 *
 * To run a query within a React component, call `useClearbitForOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClearbitForOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClearbitForOnboardingQuery({
 *   variables: {
 *      companyDomain: // value for 'companyDomain'
 *   },
 * });
 */
export function useClearbitForOnboardingQuery(baseOptions?: Apollo.QueryHookOptions<Types.ClearbitForOnboardingQuery, Types.ClearbitForOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ClearbitForOnboardingQuery, Types.ClearbitForOnboardingQueryVariables>(ClearbitForOnboardingDocument, options);
      }
export function useClearbitForOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ClearbitForOnboardingQuery, Types.ClearbitForOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ClearbitForOnboardingQuery, Types.ClearbitForOnboardingQueryVariables>(ClearbitForOnboardingDocument, options);
        }
export type ClearbitForOnboardingQueryHookResult = ReturnType<typeof useClearbitForOnboardingQuery>;
export type ClearbitForOnboardingLazyQueryHookResult = ReturnType<typeof useClearbitForOnboardingLazyQuery>;
export type ClearbitForOnboardingQueryResult = Apollo.QueryResult<Types.ClearbitForOnboardingQuery, Types.ClearbitForOnboardingQueryVariables>;
export const ExportRoadmapTasksDocument = gql`
    mutation ExportRoadmapTasks($input: ExportRoadmapTasksInput!) {
  exportRoadmapTasks(input: $input) {
    id
  }
}
    `;
export type ExportRoadmapTasksMutationFn = Apollo.MutationFunction<Types.ExportRoadmapTasksMutation, Types.ExportRoadmapTasksMutationVariables>;

/**
 * __useExportRoadmapTasksMutation__
 *
 * To run a mutation, you first call `useExportRoadmapTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportRoadmapTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportRoadmapTasksMutation, { data, loading, error }] = useExportRoadmapTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportRoadmapTasksMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportRoadmapTasksMutation, Types.ExportRoadmapTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportRoadmapTasksMutation, Types.ExportRoadmapTasksMutationVariables>(ExportRoadmapTasksDocument, options);
      }
export type ExportRoadmapTasksMutationHookResult = ReturnType<typeof useExportRoadmapTasksMutation>;
export type ExportRoadmapTasksMutationResult = Apollo.MutationResult<Types.ExportRoadmapTasksMutation>;
export type ExportRoadmapTasksMutationOptions = Apollo.BaseMutationOptions<Types.ExportRoadmapTasksMutation, Types.ExportRoadmapTasksMutationVariables>;
export const GenerateJiraDescriptionFromProductBoardDocument = gql`
    mutation GenerateJIRADescriptionFromProductBoard($roadmapItemId: String!) {
  generateJIRATicketDetailsFromProductBoardItem(
    productBoardItemId: $roadmapItemId
  ) {
    title
    description
  }
}
    `;
export type GenerateJiraDescriptionFromProductBoardMutationFn = Apollo.MutationFunction<Types.GenerateJiraDescriptionFromProductBoardMutation, Types.GenerateJiraDescriptionFromProductBoardMutationVariables>;

/**
 * __useGenerateJiraDescriptionFromProductBoardMutation__
 *
 * To run a mutation, you first call `useGenerateJiraDescriptionFromProductBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateJiraDescriptionFromProductBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateJiraDescriptionFromProductBoardMutation, { data, loading, error }] = useGenerateJiraDescriptionFromProductBoardMutation({
 *   variables: {
 *      roadmapItemId: // value for 'roadmapItemId'
 *   },
 * });
 */
export function useGenerateJiraDescriptionFromProductBoardMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateJiraDescriptionFromProductBoardMutation, Types.GenerateJiraDescriptionFromProductBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateJiraDescriptionFromProductBoardMutation, Types.GenerateJiraDescriptionFromProductBoardMutationVariables>(GenerateJiraDescriptionFromProductBoardDocument, options);
      }
export type GenerateJiraDescriptionFromProductBoardMutationHookResult = ReturnType<typeof useGenerateJiraDescriptionFromProductBoardMutation>;
export type GenerateJiraDescriptionFromProductBoardMutationResult = Apollo.MutationResult<Types.GenerateJiraDescriptionFromProductBoardMutation>;
export type GenerateJiraDescriptionFromProductBoardMutationOptions = Apollo.BaseMutationOptions<Types.GenerateJiraDescriptionFromProductBoardMutation, Types.GenerateJiraDescriptionFromProductBoardMutationVariables>;
export const PaginatedClariCopilotInsightIntegrationItemsDocument = gql`
    query PaginatedClariCopilotInsightIntegrationItems($filter: InsightIntegrationItemsFilterInput!, $pagination: ClariCopilotInsightIntegrationItemsPaginationInput!) {
  paginatedClariCopilotInsightIntegrationItems(
    filter: $filter
    pagination: $pagination
  ) {
    cursor
    hasNextPage
    totalDocs
    docs {
      ...InsightIntegrationItem
    }
  }
}
    ${InsightIntegrationItemFragmentDoc}`;

/**
 * __usePaginatedClariCopilotInsightIntegrationItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedClariCopilotInsightIntegrationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedClariCopilotInsightIntegrationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedClariCopilotInsightIntegrationItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedClariCopilotInsightIntegrationItemsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedClariCopilotInsightIntegrationItemsQuery, Types.PaginatedClariCopilotInsightIntegrationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedClariCopilotInsightIntegrationItemsQuery, Types.PaginatedClariCopilotInsightIntegrationItemsQueryVariables>(PaginatedClariCopilotInsightIntegrationItemsDocument, options);
      }
export function usePaginatedClariCopilotInsightIntegrationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedClariCopilotInsightIntegrationItemsQuery, Types.PaginatedClariCopilotInsightIntegrationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedClariCopilotInsightIntegrationItemsQuery, Types.PaginatedClariCopilotInsightIntegrationItemsQueryVariables>(PaginatedClariCopilotInsightIntegrationItemsDocument, options);
        }
export type PaginatedClariCopilotInsightIntegrationItemsQueryHookResult = ReturnType<typeof usePaginatedClariCopilotInsightIntegrationItemsQuery>;
export type PaginatedClariCopilotInsightIntegrationItemsLazyQueryHookResult = ReturnType<typeof usePaginatedClariCopilotInsightIntegrationItemsLazyQuery>;
export type PaginatedClariCopilotInsightIntegrationItemsQueryResult = Apollo.QueryResult<Types.PaginatedClariCopilotInsightIntegrationItemsQuery, Types.PaginatedClariCopilotInsightIntegrationItemsQueryVariables>;
export const ConfigureHubspotCrmIntegrationDocument = gql`
    mutation ConfigureHubspotCRMIntegration($input: ConfigureHubspotCRMIntegrationInput!) {
  configureHubspotCRMIntegration(input: $input) {
    ...CrmIntegration
  }
}
    ${CrmIntegrationFragmentDoc}`;
export type ConfigureHubspotCrmIntegrationMutationFn = Apollo.MutationFunction<Types.ConfigureHubspotCrmIntegrationMutation, Types.ConfigureHubspotCrmIntegrationMutationVariables>;

/**
 * __useConfigureHubspotCrmIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureHubspotCrmIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureHubspotCrmIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureHubspotCrmIntegrationMutation, { data, loading, error }] = useConfigureHubspotCrmIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureHubspotCrmIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConfigureHubspotCrmIntegrationMutation, Types.ConfigureHubspotCrmIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConfigureHubspotCrmIntegrationMutation, Types.ConfigureHubspotCrmIntegrationMutationVariables>(ConfigureHubspotCrmIntegrationDocument, options);
      }
export type ConfigureHubspotCrmIntegrationMutationHookResult = ReturnType<typeof useConfigureHubspotCrmIntegrationMutation>;
export type ConfigureHubspotCrmIntegrationMutationResult = Apollo.MutationResult<Types.ConfigureHubspotCrmIntegrationMutation>;
export type ConfigureHubspotCrmIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ConfigureHubspotCrmIntegrationMutation, Types.ConfigureHubspotCrmIntegrationMutationVariables>;
export const ConfigureWinlossHubspotCrmIntegrationDocument = gql`
    mutation ConfigureWinlossHubspotCRMIntegration($input: ConfigureWinlossHubspotCRMIntegrationInput!) {
  configureWinlossHubspotCRMIntegration(input: $input) {
    ...CrmIntegration
  }
}
    ${CrmIntegrationFragmentDoc}`;
export type ConfigureWinlossHubspotCrmIntegrationMutationFn = Apollo.MutationFunction<Types.ConfigureWinlossHubspotCrmIntegrationMutation, Types.ConfigureWinlossHubspotCrmIntegrationMutationVariables>;

/**
 * __useConfigureWinlossHubspotCrmIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureWinlossHubspotCrmIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureWinlossHubspotCrmIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureWinlossHubspotCrmIntegrationMutation, { data, loading, error }] = useConfigureWinlossHubspotCrmIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureWinlossHubspotCrmIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConfigureWinlossHubspotCrmIntegrationMutation, Types.ConfigureWinlossHubspotCrmIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConfigureWinlossHubspotCrmIntegrationMutation, Types.ConfigureWinlossHubspotCrmIntegrationMutationVariables>(ConfigureWinlossHubspotCrmIntegrationDocument, options);
      }
export type ConfigureWinlossHubspotCrmIntegrationMutationHookResult = ReturnType<typeof useConfigureWinlossHubspotCrmIntegrationMutation>;
export type ConfigureWinlossHubspotCrmIntegrationMutationResult = Apollo.MutationResult<Types.ConfigureWinlossHubspotCrmIntegrationMutation>;
export type ConfigureWinlossHubspotCrmIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ConfigureWinlossHubspotCrmIntegrationMutation, Types.ConfigureWinlossHubspotCrmIntegrationMutationVariables>;
export const ConfigureMicrosoftDynamicsCrmIntegrationDocument = gql`
    mutation ConfigureMicrosoftDynamicsCRMIntegration($input: ConfigureMicrosoftDynamicsCRMIntegrationInput!) {
  configureMicrosoftDynamicsCRMIntegration(input: $input) {
    ...CrmIntegration
  }
}
    ${CrmIntegrationFragmentDoc}`;
export type ConfigureMicrosoftDynamicsCrmIntegrationMutationFn = Apollo.MutationFunction<Types.ConfigureMicrosoftDynamicsCrmIntegrationMutation, Types.ConfigureMicrosoftDynamicsCrmIntegrationMutationVariables>;

/**
 * __useConfigureMicrosoftDynamicsCrmIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureMicrosoftDynamicsCrmIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureMicrosoftDynamicsCrmIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureMicrosoftDynamicsCrmIntegrationMutation, { data, loading, error }] = useConfigureMicrosoftDynamicsCrmIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureMicrosoftDynamicsCrmIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConfigureMicrosoftDynamicsCrmIntegrationMutation, Types.ConfigureMicrosoftDynamicsCrmIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConfigureMicrosoftDynamicsCrmIntegrationMutation, Types.ConfigureMicrosoftDynamicsCrmIntegrationMutationVariables>(ConfigureMicrosoftDynamicsCrmIntegrationDocument, options);
      }
export type ConfigureMicrosoftDynamicsCrmIntegrationMutationHookResult = ReturnType<typeof useConfigureMicrosoftDynamicsCrmIntegrationMutation>;
export type ConfigureMicrosoftDynamicsCrmIntegrationMutationResult = Apollo.MutationResult<Types.ConfigureMicrosoftDynamicsCrmIntegrationMutation>;
export type ConfigureMicrosoftDynamicsCrmIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ConfigureMicrosoftDynamicsCrmIntegrationMutation, Types.ConfigureMicrosoftDynamicsCrmIntegrationMutationVariables>;
export const ConfigureSalesforceCrmIntegrationDocument = gql`
    mutation ConfigureSalesforceCRMIntegration($input: ConfigureSalesforceCRMIntegrationInput!) {
  configureSalesforceCRMIntegration(input: $input) {
    ...CrmIntegration
  }
}
    ${CrmIntegrationFragmentDoc}`;
export type ConfigureSalesforceCrmIntegrationMutationFn = Apollo.MutationFunction<Types.ConfigureSalesforceCrmIntegrationMutation, Types.ConfigureSalesforceCrmIntegrationMutationVariables>;

/**
 * __useConfigureSalesforceCrmIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureSalesforceCrmIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureSalesforceCrmIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureSalesforceCrmIntegrationMutation, { data, loading, error }] = useConfigureSalesforceCrmIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureSalesforceCrmIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConfigureSalesforceCrmIntegrationMutation, Types.ConfigureSalesforceCrmIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConfigureSalesforceCrmIntegrationMutation, Types.ConfigureSalesforceCrmIntegrationMutationVariables>(ConfigureSalesforceCrmIntegrationDocument, options);
      }
export type ConfigureSalesforceCrmIntegrationMutationHookResult = ReturnType<typeof useConfigureSalesforceCrmIntegrationMutation>;
export type ConfigureSalesforceCrmIntegrationMutationResult = Apollo.MutationResult<Types.ConfigureSalesforceCrmIntegrationMutation>;
export type ConfigureSalesforceCrmIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ConfigureSalesforceCrmIntegrationMutation, Types.ConfigureSalesforceCrmIntegrationMutationVariables>;
export const ConfigureWinlossSalesforceCrmIntegrationDocument = gql`
    mutation ConfigureWinlossSalesforceCRMIntegration($input: ConfigureWinLossSalesforceCRMIntegrationInput!) {
  configureWinlossSalesforceCRMIntegration(input: $input) {
    ...CrmIntegration
  }
}
    ${CrmIntegrationFragmentDoc}`;
export type ConfigureWinlossSalesforceCrmIntegrationMutationFn = Apollo.MutationFunction<Types.ConfigureWinlossSalesforceCrmIntegrationMutation, Types.ConfigureWinlossSalesforceCrmIntegrationMutationVariables>;

/**
 * __useConfigureWinlossSalesforceCrmIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureWinlossSalesforceCrmIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureWinlossSalesforceCrmIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureWinlossSalesforceCrmIntegrationMutation, { data, loading, error }] = useConfigureWinlossSalesforceCrmIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureWinlossSalesforceCrmIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConfigureWinlossSalesforceCrmIntegrationMutation, Types.ConfigureWinlossSalesforceCrmIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConfigureWinlossSalesforceCrmIntegrationMutation, Types.ConfigureWinlossSalesforceCrmIntegrationMutationVariables>(ConfigureWinlossSalesforceCrmIntegrationDocument, options);
      }
export type ConfigureWinlossSalesforceCrmIntegrationMutationHookResult = ReturnType<typeof useConfigureWinlossSalesforceCrmIntegrationMutation>;
export type ConfigureWinlossSalesforceCrmIntegrationMutationResult = Apollo.MutationResult<Types.ConfigureWinlossSalesforceCrmIntegrationMutation>;
export type ConfigureWinlossSalesforceCrmIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ConfigureWinlossSalesforceCrmIntegrationMutation, Types.ConfigureWinlossSalesforceCrmIntegrationMutationVariables>;
export const PaginatedGongInsightIntegrationItemsDocument = gql`
    query PaginatedGongInsightIntegrationItems($filter: InsightIntegrationItemsFilterInput!, $pagination: GongInsightIntegrationItemsPaginationInput) {
  paginatedGongInsightIntegrationItems(filter: $filter, pagination: $pagination) {
    cursor
    hasNextPage
    totalDocs
    docs {
      ...InsightIntegrationItem
    }
  }
}
    ${InsightIntegrationItemFragmentDoc}`;

/**
 * __usePaginatedGongInsightIntegrationItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedGongInsightIntegrationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedGongInsightIntegrationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedGongInsightIntegrationItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedGongInsightIntegrationItemsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedGongInsightIntegrationItemsQuery, Types.PaginatedGongInsightIntegrationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedGongInsightIntegrationItemsQuery, Types.PaginatedGongInsightIntegrationItemsQueryVariables>(PaginatedGongInsightIntegrationItemsDocument, options);
      }
export function usePaginatedGongInsightIntegrationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedGongInsightIntegrationItemsQuery, Types.PaginatedGongInsightIntegrationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedGongInsightIntegrationItemsQuery, Types.PaginatedGongInsightIntegrationItemsQueryVariables>(PaginatedGongInsightIntegrationItemsDocument, options);
        }
export type PaginatedGongInsightIntegrationItemsQueryHookResult = ReturnType<typeof usePaginatedGongInsightIntegrationItemsQuery>;
export type PaginatedGongInsightIntegrationItemsLazyQueryHookResult = ReturnType<typeof usePaginatedGongInsightIntegrationItemsLazyQuery>;
export type PaginatedGongInsightIntegrationItemsQueryResult = Apollo.QueryResult<Types.PaginatedGongInsightIntegrationItemsQuery, Types.PaginatedGongInsightIntegrationItemsQueryVariables>;
export const ImportRoadmapItemsFromIntegrationDocument = gql`
    mutation ImportRoadmapItemsFromIntegration($input: ImportProductBoardItemsFromIntegrationInput!) {
  importProductBoardItemsFromIntegration(input: $input) {
    ...ProductBoardItemPreview
  }
}
    ${ProductBoardItemPreviewFragmentDoc}`;
export type ImportRoadmapItemsFromIntegrationMutationFn = Apollo.MutationFunction<Types.ImportRoadmapItemsFromIntegrationMutation, Types.ImportRoadmapItemsFromIntegrationMutationVariables>;

/**
 * __useImportRoadmapItemsFromIntegrationMutation__
 *
 * To run a mutation, you first call `useImportRoadmapItemsFromIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRoadmapItemsFromIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRoadmapItemsFromIntegrationMutation, { data, loading, error }] = useImportRoadmapItemsFromIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportRoadmapItemsFromIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImportRoadmapItemsFromIntegrationMutation, Types.ImportRoadmapItemsFromIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImportRoadmapItemsFromIntegrationMutation, Types.ImportRoadmapItemsFromIntegrationMutationVariables>(ImportRoadmapItemsFromIntegrationDocument, options);
      }
export type ImportRoadmapItemsFromIntegrationMutationHookResult = ReturnType<typeof useImportRoadmapItemsFromIntegrationMutation>;
export type ImportRoadmapItemsFromIntegrationMutationResult = Apollo.MutationResult<Types.ImportRoadmapItemsFromIntegrationMutation>;
export type ImportRoadmapItemsFromIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.ImportRoadmapItemsFromIntegrationMutation, Types.ImportRoadmapItemsFromIntegrationMutationVariables>;
export const ProductBoardRoadmapsForImportDocument = gql`
    query ProductBoardRoadmapsForImport {
  productBoardRoadmaps {
    id
    name
  }
}
    `;

/**
 * __useProductBoardRoadmapsForImportQuery__
 *
 * To run a query within a React component, call `useProductBoardRoadmapsForImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardRoadmapsForImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardRoadmapsForImportQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBoardRoadmapsForImportQuery(baseOptions?: Apollo.QueryHookOptions<Types.ProductBoardRoadmapsForImportQuery, Types.ProductBoardRoadmapsForImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductBoardRoadmapsForImportQuery, Types.ProductBoardRoadmapsForImportQueryVariables>(ProductBoardRoadmapsForImportDocument, options);
      }
export function useProductBoardRoadmapsForImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductBoardRoadmapsForImportQuery, Types.ProductBoardRoadmapsForImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductBoardRoadmapsForImportQuery, Types.ProductBoardRoadmapsForImportQueryVariables>(ProductBoardRoadmapsForImportDocument, options);
        }
export type ProductBoardRoadmapsForImportQueryHookResult = ReturnType<typeof useProductBoardRoadmapsForImportQuery>;
export type ProductBoardRoadmapsForImportLazyQueryHookResult = ReturnType<typeof useProductBoardRoadmapsForImportLazyQuery>;
export type ProductBoardRoadmapsForImportQueryResult = Apollo.QueryResult<Types.ProductBoardRoadmapsForImportQuery, Types.ProductBoardRoadmapsForImportQueryVariables>;
export const PaginatedIntercomInsightIntegrationItemsDocument = gql`
    query PaginatedIntercomInsightIntegrationItems($filter: IntercomInsightIntegrationItemsFilterInput!, $pagination: IntercomInsightIntegrationItemsPaginationInput!) {
  paginatedIntercomInsightIntegrationItems(
    filter: $filter
    pagination: $pagination
  ) {
    cursor
    hasNextPage
    totalDocs
    docs {
      ...InsightIntegrationItem
    }
  }
}
    ${InsightIntegrationItemFragmentDoc}`;

/**
 * __usePaginatedIntercomInsightIntegrationItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedIntercomInsightIntegrationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedIntercomInsightIntegrationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedIntercomInsightIntegrationItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedIntercomInsightIntegrationItemsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedIntercomInsightIntegrationItemsQuery, Types.PaginatedIntercomInsightIntegrationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedIntercomInsightIntegrationItemsQuery, Types.PaginatedIntercomInsightIntegrationItemsQueryVariables>(PaginatedIntercomInsightIntegrationItemsDocument, options);
      }
export function usePaginatedIntercomInsightIntegrationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedIntercomInsightIntegrationItemsQuery, Types.PaginatedIntercomInsightIntegrationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedIntercomInsightIntegrationItemsQuery, Types.PaginatedIntercomInsightIntegrationItemsQueryVariables>(PaginatedIntercomInsightIntegrationItemsDocument, options);
        }
export type PaginatedIntercomInsightIntegrationItemsQueryHookResult = ReturnType<typeof usePaginatedIntercomInsightIntegrationItemsQuery>;
export type PaginatedIntercomInsightIntegrationItemsLazyQueryHookResult = ReturnType<typeof usePaginatedIntercomInsightIntegrationItemsLazyQuery>;
export type PaginatedIntercomInsightIntegrationItemsQueryResult = Apollo.QueryResult<Types.PaginatedIntercomInsightIntegrationItemsQuery, Types.PaginatedIntercomInsightIntegrationItemsQueryVariables>;
export const CreateSlackInsightIntegrationDocument = gql`
    mutation CreateSlackInsightIntegration {
  createSlackInsightIntegration {
    ...InsightIntegration
  }
}
    ${InsightIntegrationFragmentDoc}`;
export type CreateSlackInsightIntegrationMutationFn = Apollo.MutationFunction<Types.CreateSlackInsightIntegrationMutation, Types.CreateSlackInsightIntegrationMutationVariables>;

/**
 * __useCreateSlackInsightIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateSlackInsightIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackInsightIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackInsightIntegrationMutation, { data, loading, error }] = useCreateSlackInsightIntegrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSlackInsightIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSlackInsightIntegrationMutation, Types.CreateSlackInsightIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSlackInsightIntegrationMutation, Types.CreateSlackInsightIntegrationMutationVariables>(CreateSlackInsightIntegrationDocument, options);
      }
export type CreateSlackInsightIntegrationMutationHookResult = ReturnType<typeof useCreateSlackInsightIntegrationMutation>;
export type CreateSlackInsightIntegrationMutationResult = Apollo.MutationResult<Types.CreateSlackInsightIntegrationMutation>;
export type CreateSlackInsightIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.CreateSlackInsightIntegrationMutation, Types.CreateSlackInsightIntegrationMutationVariables>;
export const PaginatedSlackInsightIntegrationItemsDocument = gql`
    query PaginatedSlackInsightIntegrationItems($filter: SlackInsightIntegrationItemsFilterInput!, $pagination: SlackInsightIntegrationItemsPaginationInput!) {
  paginatedSlackInsightIntegrationItems(filter: $filter, pagination: $pagination) {
    cursor
    hasNextPage
    totalDocs
    docs {
      ...InsightIntegrationItem
    }
  }
}
    ${InsightIntegrationItemFragmentDoc}`;

/**
 * __usePaginatedSlackInsightIntegrationItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedSlackInsightIntegrationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedSlackInsightIntegrationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedSlackInsightIntegrationItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedSlackInsightIntegrationItemsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedSlackInsightIntegrationItemsQuery, Types.PaginatedSlackInsightIntegrationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedSlackInsightIntegrationItemsQuery, Types.PaginatedSlackInsightIntegrationItemsQueryVariables>(PaginatedSlackInsightIntegrationItemsDocument, options);
      }
export function usePaginatedSlackInsightIntegrationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedSlackInsightIntegrationItemsQuery, Types.PaginatedSlackInsightIntegrationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedSlackInsightIntegrationItemsQuery, Types.PaginatedSlackInsightIntegrationItemsQueryVariables>(PaginatedSlackInsightIntegrationItemsDocument, options);
        }
export type PaginatedSlackInsightIntegrationItemsQueryHookResult = ReturnType<typeof usePaginatedSlackInsightIntegrationItemsQuery>;
export type PaginatedSlackInsightIntegrationItemsLazyQueryHookResult = ReturnType<typeof usePaginatedSlackInsightIntegrationItemsLazyQuery>;
export type PaginatedSlackInsightIntegrationItemsQueryResult = Apollo.QueryResult<Types.PaginatedSlackInsightIntegrationItemsQuery, Types.PaginatedSlackInsightIntegrationItemsQueryVariables>;
export const PaginatedZendeskInsightIntegrationItemsDocument = gql`
    query PaginatedZendeskInsightIntegrationItems($filter: ZendeskInsightIntegrationItemsFilterInput!, $pagination: ZendeskInsightIntegrationItemsPaginationInput!) {
  paginatedZendeskInsightIntegrationItems(
    filter: $filter
    pagination: $pagination
  ) {
    cursor
    hasNextPage
    totalDocs
    docs {
      ...InsightIntegrationItem
    }
  }
}
    ${InsightIntegrationItemFragmentDoc}`;

/**
 * __usePaginatedZendeskInsightIntegrationItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedZendeskInsightIntegrationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedZendeskInsightIntegrationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedZendeskInsightIntegrationItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedZendeskInsightIntegrationItemsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedZendeskInsightIntegrationItemsQuery, Types.PaginatedZendeskInsightIntegrationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedZendeskInsightIntegrationItemsQuery, Types.PaginatedZendeskInsightIntegrationItemsQueryVariables>(PaginatedZendeskInsightIntegrationItemsDocument, options);
      }
export function usePaginatedZendeskInsightIntegrationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedZendeskInsightIntegrationItemsQuery, Types.PaginatedZendeskInsightIntegrationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedZendeskInsightIntegrationItemsQuery, Types.PaginatedZendeskInsightIntegrationItemsQueryVariables>(PaginatedZendeskInsightIntegrationItemsDocument, options);
        }
export type PaginatedZendeskInsightIntegrationItemsQueryHookResult = ReturnType<typeof usePaginatedZendeskInsightIntegrationItemsQuery>;
export type PaginatedZendeskInsightIntegrationItemsLazyQueryHookResult = ReturnType<typeof usePaginatedZendeskInsightIntegrationItemsLazyQuery>;
export type PaginatedZendeskInsightIntegrationItemsQueryResult = Apollo.QueryResult<Types.PaginatedZendeskInsightIntegrationItemsQuery, Types.PaginatedZendeskInsightIntegrationItemsQueryVariables>;
export const PaginatedZoomInsightIntegrationItemsDocument = gql`
    query PaginatedZoomInsightIntegrationItems($filter: InsightIntegrationItemsFilterInput!, $pagination: ZoomInsightIntegrationItemsPaginationInput!) {
  paginatedZoomInsightIntegrationItems(filter: $filter, pagination: $pagination) {
    cursor
    hasNextPage
    totalDocs
    docs {
      ...InsightIntegrationItem
    }
  }
}
    ${InsightIntegrationItemFragmentDoc}`;

/**
 * __usePaginatedZoomInsightIntegrationItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedZoomInsightIntegrationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedZoomInsightIntegrationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedZoomInsightIntegrationItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedZoomInsightIntegrationItemsQuery(baseOptions: Apollo.QueryHookOptions<Types.PaginatedZoomInsightIntegrationItemsQuery, Types.PaginatedZoomInsightIntegrationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PaginatedZoomInsightIntegrationItemsQuery, Types.PaginatedZoomInsightIntegrationItemsQueryVariables>(PaginatedZoomInsightIntegrationItemsDocument, options);
      }
export function usePaginatedZoomInsightIntegrationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PaginatedZoomInsightIntegrationItemsQuery, Types.PaginatedZoomInsightIntegrationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PaginatedZoomInsightIntegrationItemsQuery, Types.PaginatedZoomInsightIntegrationItemsQueryVariables>(PaginatedZoomInsightIntegrationItemsDocument, options);
        }
export type PaginatedZoomInsightIntegrationItemsQueryHookResult = ReturnType<typeof usePaginatedZoomInsightIntegrationItemsQuery>;
export type PaginatedZoomInsightIntegrationItemsLazyQueryHookResult = ReturnType<typeof usePaginatedZoomInsightIntegrationItemsLazyQuery>;
export type PaginatedZoomInsightIntegrationItemsQueryResult = Apollo.QueryResult<Types.PaginatedZoomInsightIntegrationItemsQuery, Types.PaginatedZoomInsightIntegrationItemsQueryVariables>;
export const OrganizationSidebarDataDocument = gql`
    query OrganizationSidebarData {
  organization {
    id
    logo
    name
    billingVersion
    mapleBillingCustomerId
    hasPaidSubscriptionMB
    hasPaidSubscription
    chatGTMEnabled
    isFree
    isDemo
    isActive
    createdAt
    users {
      userId
      role
    }
  }
}
    `;

/**
 * __useOrganizationSidebarDataQuery__
 *
 * To run a query within a React component, call `useOrganizationSidebarDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSidebarDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSidebarDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSidebarDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationSidebarDataQuery, Types.OrganizationSidebarDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationSidebarDataQuery, Types.OrganizationSidebarDataQueryVariables>(OrganizationSidebarDataDocument, options);
      }
export function useOrganizationSidebarDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationSidebarDataQuery, Types.OrganizationSidebarDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationSidebarDataQuery, Types.OrganizationSidebarDataQueryVariables>(OrganizationSidebarDataDocument, options);
        }
export type OrganizationSidebarDataQueryHookResult = ReturnType<typeof useOrganizationSidebarDataQuery>;
export type OrganizationSidebarDataLazyQueryHookResult = ReturnType<typeof useOrganizationSidebarDataLazyQuery>;
export type OrganizationSidebarDataQueryResult = Apollo.QueryResult<Types.OrganizationSidebarDataQuery, Types.OrganizationSidebarDataQueryVariables>;
export const OrganizationSidebarUpgradeBillingButtonDataDocument = gql`
    query OrganizationSidebarUpgradeBillingButtonData {
  isShowUpgradeButtonMB: MBShowUpgradeButton
  isShowUpgradeButton: showUpgradeButton
}
    `;

/**
 * __useOrganizationSidebarUpgradeBillingButtonDataQuery__
 *
 * To run a query within a React component, call `useOrganizationSidebarUpgradeBillingButtonDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSidebarUpgradeBillingButtonDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSidebarUpgradeBillingButtonDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSidebarUpgradeBillingButtonDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationSidebarUpgradeBillingButtonDataQuery, Types.OrganizationSidebarUpgradeBillingButtonDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationSidebarUpgradeBillingButtonDataQuery, Types.OrganizationSidebarUpgradeBillingButtonDataQueryVariables>(OrganizationSidebarUpgradeBillingButtonDataDocument, options);
      }
export function useOrganizationSidebarUpgradeBillingButtonDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationSidebarUpgradeBillingButtonDataQuery, Types.OrganizationSidebarUpgradeBillingButtonDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationSidebarUpgradeBillingButtonDataQuery, Types.OrganizationSidebarUpgradeBillingButtonDataQueryVariables>(OrganizationSidebarUpgradeBillingButtonDataDocument, options);
        }
export type OrganizationSidebarUpgradeBillingButtonDataQueryHookResult = ReturnType<typeof useOrganizationSidebarUpgradeBillingButtonDataQuery>;
export type OrganizationSidebarUpgradeBillingButtonDataLazyQueryHookResult = ReturnType<typeof useOrganizationSidebarUpgradeBillingButtonDataLazyQuery>;
export type OrganizationSidebarUpgradeBillingButtonDataQueryResult = Apollo.QueryResult<Types.OrganizationSidebarUpgradeBillingButtonDataQuery, Types.OrganizationSidebarUpgradeBillingButtonDataQueryVariables>;
export const GetNewsArticlesDocument = gql`
    query GetNewsArticles($createdAtGte: DateTime!) {
  paginatedNewsDigest(createdAtGte: $createdAtGte) {
    docs {
      ...CompanyNewsArticleSummary
    }
    totalDocs
  }
}
    ${CompanyNewsArticleSummaryFragmentDoc}`;

/**
 * __useGetNewsArticlesQuery__
 *
 * To run a query within a React component, call `useGetNewsArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsArticlesQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetNewsArticlesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetNewsArticlesQuery, Types.GetNewsArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNewsArticlesQuery, Types.GetNewsArticlesQueryVariables>(GetNewsArticlesDocument, options);
      }
export function useGetNewsArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNewsArticlesQuery, Types.GetNewsArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNewsArticlesQuery, Types.GetNewsArticlesQueryVariables>(GetNewsArticlesDocument, options);
        }
export type GetNewsArticlesQueryHookResult = ReturnType<typeof useGetNewsArticlesQuery>;
export type GetNewsArticlesLazyQueryHookResult = ReturnType<typeof useGetNewsArticlesLazyQuery>;
export type GetNewsArticlesQueryResult = Apollo.QueryResult<Types.GetNewsArticlesQuery, Types.GetNewsArticlesQueryVariables>;
export const GetReviewsDigestDocument = gql`
    query GetReviewsDigest($createdAtGte: DateTime!) {
  paginatedReviewsDigest(createdAtGte: $createdAtGte) {
    docs {
      ...CompanyReviewDigestSummary
    }
    totalDocs
  }
}
    ${CompanyReviewDigestSummaryFragmentDoc}`;

/**
 * __useGetReviewsDigestQuery__
 *
 * To run a query within a React component, call `useGetReviewsDigestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewsDigestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewsDigestQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetReviewsDigestQuery(baseOptions: Apollo.QueryHookOptions<Types.GetReviewsDigestQuery, Types.GetReviewsDigestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetReviewsDigestQuery, Types.GetReviewsDigestQueryVariables>(GetReviewsDigestDocument, options);
      }
export function useGetReviewsDigestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetReviewsDigestQuery, Types.GetReviewsDigestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetReviewsDigestQuery, Types.GetReviewsDigestQueryVariables>(GetReviewsDigestDocument, options);
        }
export type GetReviewsDigestQueryHookResult = ReturnType<typeof useGetReviewsDigestQuery>;
export type GetReviewsDigestLazyQueryHookResult = ReturnType<typeof useGetReviewsDigestLazyQuery>;
export type GetReviewsDigestQueryResult = Apollo.QueryResult<Types.GetReviewsDigestQuery, Types.GetReviewsDigestQueryVariables>;
export const GetWinlossInsightsDocument = gql`
    query GetWinlossInsights($createdAtGte: DateTime!) {
  paginatedWinlossInsightsDigest(createdAtGte: $createdAtGte) {
    docs {
      ...WinLossInsightDigestSummary
    }
    totalDocs
  }
}
    ${WinLossInsightDigestSummaryFragmentDoc}`;

/**
 * __useGetWinlossInsightsQuery__
 *
 * To run a query within a React component, call `useGetWinlossInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinlossInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinlossInsightsQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetWinlossInsightsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWinlossInsightsQuery, Types.GetWinlossInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWinlossInsightsQuery, Types.GetWinlossInsightsQueryVariables>(GetWinlossInsightsDocument, options);
      }
export function useGetWinlossInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWinlossInsightsQuery, Types.GetWinlossInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWinlossInsightsQuery, Types.GetWinlossInsightsQueryVariables>(GetWinlossInsightsDocument, options);
        }
export type GetWinlossInsightsQueryHookResult = ReturnType<typeof useGetWinlossInsightsQuery>;
export type GetWinlossInsightsLazyQueryHookResult = ReturnType<typeof useGetWinlossInsightsLazyQuery>;
export type GetWinlossInsightsQueryResult = Apollo.QueryResult<Types.GetWinlossInsightsQuery, Types.GetWinlossInsightsQueryVariables>;
export const GetWinlossRevenueDocument = gql`
    query GetWinlossRevenue($createdAtGte: DateTime!) {
  winlossLostRevenueDigest(createdAtGte: $createdAtGte) {
    wonDeals
    wonRevenue
    lostDeals
    lostRevenue
    totalDeals
    totalRevenue
  }
}
    `;

/**
 * __useGetWinlossRevenueQuery__
 *
 * To run a query within a React component, call `useGetWinlossRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinlossRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinlossRevenueQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetWinlossRevenueQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWinlossRevenueQuery, Types.GetWinlossRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWinlossRevenueQuery, Types.GetWinlossRevenueQueryVariables>(GetWinlossRevenueDocument, options);
      }
export function useGetWinlossRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWinlossRevenueQuery, Types.GetWinlossRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWinlossRevenueQuery, Types.GetWinlossRevenueQueryVariables>(GetWinlossRevenueDocument, options);
        }
export type GetWinlossRevenueQueryHookResult = ReturnType<typeof useGetWinlossRevenueQuery>;
export type GetWinlossRevenueLazyQueryHookResult = ReturnType<typeof useGetWinlossRevenueLazyQuery>;
export type GetWinlossRevenueQueryResult = Apollo.QueryResult<Types.GetWinlossRevenueQuery, Types.GetWinlossRevenueQueryVariables>;
export const GetCreatedInsightsDocument = gql`
    query GetCreatedInsights($createdAtGte: DateTime) {
  paginatedInsights(filter: {createdAtGte: $createdAtGte}) {
    totalDocs
    docs {
      ...Insight
    }
  }
}
    ${InsightFragmentDoc}`;

/**
 * __useGetCreatedInsightsQuery__
 *
 * To run a query within a React component, call `useGetCreatedInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatedInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatedInsightsQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetCreatedInsightsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetCreatedInsightsQuery, Types.GetCreatedInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCreatedInsightsQuery, Types.GetCreatedInsightsQueryVariables>(GetCreatedInsightsDocument, options);
      }
export function useGetCreatedInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCreatedInsightsQuery, Types.GetCreatedInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCreatedInsightsQuery, Types.GetCreatedInsightsQueryVariables>(GetCreatedInsightsDocument, options);
        }
export type GetCreatedInsightsQueryHookResult = ReturnType<typeof useGetCreatedInsightsQuery>;
export type GetCreatedInsightsLazyQueryHookResult = ReturnType<typeof useGetCreatedInsightsLazyQuery>;
export type GetCreatedInsightsQueryResult = Apollo.QueryResult<Types.GetCreatedInsightsQuery, Types.GetCreatedInsightsQueryVariables>;
export const GetSummarizedInsightsDocument = gql`
    query GetSummarizedInsights($summaryUpdatedAtGte: DateTime) {
  paginatedInsights(filter: {summaryUpdatedAtGte: $summaryUpdatedAtGte}) {
    totalDocs
    docs {
      ...Insight
    }
  }
}
    ${InsightFragmentDoc}`;

/**
 * __useGetSummarizedInsightsQuery__
 *
 * To run a query within a React component, call `useGetSummarizedInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummarizedInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummarizedInsightsQuery({
 *   variables: {
 *      summaryUpdatedAtGte: // value for 'summaryUpdatedAtGte'
 *   },
 * });
 */
export function useGetSummarizedInsightsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSummarizedInsightsQuery, Types.GetSummarizedInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSummarizedInsightsQuery, Types.GetSummarizedInsightsQueryVariables>(GetSummarizedInsightsDocument, options);
      }
export function useGetSummarizedInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSummarizedInsightsQuery, Types.GetSummarizedInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSummarizedInsightsQuery, Types.GetSummarizedInsightsQueryVariables>(GetSummarizedInsightsDocument, options);
        }
export type GetSummarizedInsightsQueryHookResult = ReturnType<typeof useGetSummarizedInsightsQuery>;
export type GetSummarizedInsightsLazyQueryHookResult = ReturnType<typeof useGetSummarizedInsightsLazyQuery>;
export type GetSummarizedInsightsQueryResult = Apollo.QueryResult<Types.GetSummarizedInsightsQuery, Types.GetSummarizedInsightsQueryVariables>;
export const GetTaggedInsightsDocument = gql`
    query GetTaggedInsights($tagsUpdatedAtGte: DateTime) {
  paginatedInsights(filter: {createdAtGte: $tagsUpdatedAtGte}) {
    totalDocs
    docs {
      ...Insight
    }
  }
}
    ${InsightFragmentDoc}`;

/**
 * __useGetTaggedInsightsQuery__
 *
 * To run a query within a React component, call `useGetTaggedInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaggedInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaggedInsightsQuery({
 *   variables: {
 *      tagsUpdatedAtGte: // value for 'tagsUpdatedAtGte'
 *   },
 * });
 */
export function useGetTaggedInsightsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetTaggedInsightsQuery, Types.GetTaggedInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTaggedInsightsQuery, Types.GetTaggedInsightsQueryVariables>(GetTaggedInsightsDocument, options);
      }
export function useGetTaggedInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTaggedInsightsQuery, Types.GetTaggedInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTaggedInsightsQuery, Types.GetTaggedInsightsQueryVariables>(GetTaggedInsightsDocument, options);
        }
export type GetTaggedInsightsQueryHookResult = ReturnType<typeof useGetTaggedInsightsQuery>;
export type GetTaggedInsightsLazyQueryHookResult = ReturnType<typeof useGetTaggedInsightsLazyQuery>;
export type GetTaggedInsightsQueryResult = Apollo.QueryResult<Types.GetTaggedInsightsQuery, Types.GetTaggedInsightsQueryVariables>;
export const GetCampaignPlansDocument = gql`
    query GetCampaignPlans($createdAtGte: DateTime) {
  paginatedLaunches(filter: {createdAtGte: $createdAtGte}) {
    totalDocs
    docs {
      ...PaginatedLaunchesPreview
    }
  }
}
    ${PaginatedLaunchesPreviewFragmentDoc}`;

/**
 * __useGetCampaignPlansQuery__
 *
 * To run a query within a React component, call `useGetCampaignPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPlansQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetCampaignPlansQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetCampaignPlansQuery, Types.GetCampaignPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCampaignPlansQuery, Types.GetCampaignPlansQueryVariables>(GetCampaignPlansDocument, options);
      }
export function useGetCampaignPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCampaignPlansQuery, Types.GetCampaignPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCampaignPlansQuery, Types.GetCampaignPlansQueryVariables>(GetCampaignPlansDocument, options);
        }
export type GetCampaignPlansQueryHookResult = ReturnType<typeof useGetCampaignPlansQuery>;
export type GetCampaignPlansLazyQueryHookResult = ReturnType<typeof useGetCampaignPlansLazyQuery>;
export type GetCampaignPlansQueryResult = Apollo.QueryResult<Types.GetCampaignPlansQuery, Types.GetCampaignPlansQueryVariables>;
export const GetEnabledTeammatesDocument = gql`
    query GetEnabledTeammates($createdAtGte: DateTime) {
  paginatedAnnouncements(filter: {createdAtGte: $createdAtGte}) {
    totalDocs
    docs {
      ...Announcement
    }
  }
}
    ${AnnouncementFragmentDoc}`;

/**
 * __useGetEnabledTeammatesQuery__
 *
 * To run a query within a React component, call `useGetEnabledTeammatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledTeammatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledTeammatesQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetEnabledTeammatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetEnabledTeammatesQuery, Types.GetEnabledTeammatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEnabledTeammatesQuery, Types.GetEnabledTeammatesQueryVariables>(GetEnabledTeammatesDocument, options);
      }
export function useGetEnabledTeammatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEnabledTeammatesQuery, Types.GetEnabledTeammatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEnabledTeammatesQuery, Types.GetEnabledTeammatesQueryVariables>(GetEnabledTeammatesDocument, options);
        }
export type GetEnabledTeammatesQueryHookResult = ReturnType<typeof useGetEnabledTeammatesQuery>;
export type GetEnabledTeammatesLazyQueryHookResult = ReturnType<typeof useGetEnabledTeammatesLazyQuery>;
export type GetEnabledTeammatesQueryResult = Apollo.QueryResult<Types.GetEnabledTeammatesQuery, Types.GetEnabledTeammatesQueryVariables>;
export const GetMarketingAssetsDocument = gql`
    query GetMarketingAssets($createdAtGte: DateTime) {
  paginatedAssets(filter: {createdAtGte: $createdAtGte}) {
    totalDocs
    docs {
      ...AssetsLaunch
    }
  }
}
    ${AssetsLaunchFragmentDoc}`;

/**
 * __useGetMarketingAssetsQuery__
 *
 * To run a query within a React component, call `useGetMarketingAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketingAssetsQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetMarketingAssetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMarketingAssetsQuery, Types.GetMarketingAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMarketingAssetsQuery, Types.GetMarketingAssetsQueryVariables>(GetMarketingAssetsDocument, options);
      }
export function useGetMarketingAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMarketingAssetsQuery, Types.GetMarketingAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMarketingAssetsQuery, Types.GetMarketingAssetsQueryVariables>(GetMarketingAssetsDocument, options);
        }
export type GetMarketingAssetsQueryHookResult = ReturnType<typeof useGetMarketingAssetsQuery>;
export type GetMarketingAssetsLazyQueryHookResult = ReturnType<typeof useGetMarketingAssetsLazyQuery>;
export type GetMarketingAssetsQueryResult = Apollo.QueryResult<Types.GetMarketingAssetsQuery, Types.GetMarketingAssetsQueryVariables>;
export const GeneratedProductIdeasDocument = gql`
    query GeneratedProductIdeas($filter: FilterFeedbackPostsInput, $pagination: PaginationInput!) {
  paginatedFeedbackPosts(filter: $filter, pagination: $pagination) {
    docs {
      ...FeedbackPostSummary
    }
    totalDocs
  }
}
    ${FeedbackPostSummaryFragmentDoc}`;

/**
 * __useGeneratedProductIdeasQuery__
 *
 * To run a query within a React component, call `useGeneratedProductIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratedProductIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratedProductIdeasQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGeneratedProductIdeasQuery(baseOptions: Apollo.QueryHookOptions<Types.GeneratedProductIdeasQuery, Types.GeneratedProductIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GeneratedProductIdeasQuery, Types.GeneratedProductIdeasQueryVariables>(GeneratedProductIdeasDocument, options);
      }
export function useGeneratedProductIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GeneratedProductIdeasQuery, Types.GeneratedProductIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GeneratedProductIdeasQuery, Types.GeneratedProductIdeasQueryVariables>(GeneratedProductIdeasDocument, options);
        }
export type GeneratedProductIdeasQueryHookResult = ReturnType<typeof useGeneratedProductIdeasQuery>;
export type GeneratedProductIdeasLazyQueryHookResult = ReturnType<typeof useGeneratedProductIdeasLazyQuery>;
export type GeneratedProductIdeasQueryResult = Apollo.QueryResult<Types.GeneratedProductIdeasQuery, Types.GeneratedProductIdeasQueryVariables>;
export const GetProductGapsCrmIntegrationStatusDocument = gql`
    query GetProductGapsCrmIntegrationStatus {
  productGapsIntegrationStatus
}
    `;

/**
 * __useGetProductGapsCrmIntegrationStatusQuery__
 *
 * To run a query within a React component, call `useGetProductGapsCrmIntegrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGapsCrmIntegrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGapsCrmIntegrationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductGapsCrmIntegrationStatusQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetProductGapsCrmIntegrationStatusQuery, Types.GetProductGapsCrmIntegrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProductGapsCrmIntegrationStatusQuery, Types.GetProductGapsCrmIntegrationStatusQueryVariables>(GetProductGapsCrmIntegrationStatusDocument, options);
      }
export function useGetProductGapsCrmIntegrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProductGapsCrmIntegrationStatusQuery, Types.GetProductGapsCrmIntegrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProductGapsCrmIntegrationStatusQuery, Types.GetProductGapsCrmIntegrationStatusQueryVariables>(GetProductGapsCrmIntegrationStatusDocument, options);
        }
export type GetProductGapsCrmIntegrationStatusQueryHookResult = ReturnType<typeof useGetProductGapsCrmIntegrationStatusQuery>;
export type GetProductGapsCrmIntegrationStatusLazyQueryHookResult = ReturnType<typeof useGetProductGapsCrmIntegrationStatusLazyQuery>;
export type GetProductGapsCrmIntegrationStatusQueryResult = Apollo.QueryResult<Types.GetProductGapsCrmIntegrationStatusQuery, Types.GetProductGapsCrmIntegrationStatusQueryVariables>;
export const GetProductIdeasRevenueDocument = gql`
    query GetProductIdeasRevenue($createdAtGte: DateTime!) {
  revenueDigest(createdAtGte: $createdAtGte)
}
    `;

/**
 * __useGetProductIdeasRevenueQuery__
 *
 * To run a query within a React component, call `useGetProductIdeasRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductIdeasRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductIdeasRevenueQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *   },
 * });
 */
export function useGetProductIdeasRevenueQuery(baseOptions: Apollo.QueryHookOptions<Types.GetProductIdeasRevenueQuery, Types.GetProductIdeasRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProductIdeasRevenueQuery, Types.GetProductIdeasRevenueQueryVariables>(GetProductIdeasRevenueDocument, options);
      }
export function useGetProductIdeasRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProductIdeasRevenueQuery, Types.GetProductIdeasRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProductIdeasRevenueQuery, Types.GetProductIdeasRevenueQueryVariables>(GetProductIdeasRevenueDocument, options);
        }
export type GetProductIdeasRevenueQueryHookResult = ReturnType<typeof useGetProductIdeasRevenueQuery>;
export type GetProductIdeasRevenueLazyQueryHookResult = ReturnType<typeof useGetProductIdeasRevenueLazyQuery>;
export type GetProductIdeasRevenueQueryResult = Apollo.QueryResult<Types.GetProductIdeasRevenueQuery, Types.GetProductIdeasRevenueQueryVariables>;
export const ImportedProductIdeasDocument = gql`
    query ImportedProductIdeas($filter: FilterFeedbackPostsInput, $pagination: PaginationInput!) {
  paginatedFeedbackPosts(filter: $filter, pagination: $pagination) {
    docs {
      ...FeedbackPostSummary
    }
    totalDocs
  }
}
    ${FeedbackPostSummaryFragmentDoc}`;

/**
 * __useImportedProductIdeasQuery__
 *
 * To run a query within a React component, call `useImportedProductIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportedProductIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportedProductIdeasQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useImportedProductIdeasQuery(baseOptions: Apollo.QueryHookOptions<Types.ImportedProductIdeasQuery, Types.ImportedProductIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ImportedProductIdeasQuery, Types.ImportedProductIdeasQueryVariables>(ImportedProductIdeasDocument, options);
      }
export function useImportedProductIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ImportedProductIdeasQuery, Types.ImportedProductIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ImportedProductIdeasQuery, Types.ImportedProductIdeasQueryVariables>(ImportedProductIdeasDocument, options);
        }
export type ImportedProductIdeasQueryHookResult = ReturnType<typeof useImportedProductIdeasQuery>;
export type ImportedProductIdeasLazyQueryHookResult = ReturnType<typeof useImportedProductIdeasLazyQuery>;
export type ImportedProductIdeasQueryResult = Apollo.QueryResult<Types.ImportedProductIdeasQuery, Types.ImportedProductIdeasQueryVariables>;
export const MappedDealsToProductIdeasDocument = gql`
    query MappedDealsToProductIdeas($createdAtGte: DateTime!, $pagination: PaginationInput!) {
  existingProductIdeasDigest(
    filter: {createdAtGte: $createdAtGte}
    pagination: $pagination
  ) {
    docs {
      ...DealsFeedbackPostDigest
    }
    totalDocs
  }
}
    ${DealsFeedbackPostDigestFragmentDoc}`;

/**
 * __useMappedDealsToProductIdeasQuery__
 *
 * To run a query within a React component, call `useMappedDealsToProductIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useMappedDealsToProductIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMappedDealsToProductIdeasQuery({
 *   variables: {
 *      createdAtGte: // value for 'createdAtGte'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMappedDealsToProductIdeasQuery(baseOptions: Apollo.QueryHookOptions<Types.MappedDealsToProductIdeasQuery, Types.MappedDealsToProductIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MappedDealsToProductIdeasQuery, Types.MappedDealsToProductIdeasQueryVariables>(MappedDealsToProductIdeasDocument, options);
      }
export function useMappedDealsToProductIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MappedDealsToProductIdeasQuery, Types.MappedDealsToProductIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MappedDealsToProductIdeasQuery, Types.MappedDealsToProductIdeasQueryVariables>(MappedDealsToProductIdeasDocument, options);
        }
export type MappedDealsToProductIdeasQueryHookResult = ReturnType<typeof useMappedDealsToProductIdeasQuery>;
export type MappedDealsToProductIdeasLazyQueryHookResult = ReturnType<typeof useMappedDealsToProductIdeasLazyQuery>;
export type MappedDealsToProductIdeasQueryResult = Apollo.QueryResult<Types.MappedDealsToProductIdeasQuery, Types.MappedDealsToProductIdeasQueryVariables>;
export const OrganizationAiSettingsDocument = gql`
    query OrganizationAiSettings {
  organization {
    id
    aiSettings {
      ...OrganizationAISettings
    }
  }
}
    ${OrganizationAiSettingsFragmentDoc}`;

/**
 * __useOrganizationAiSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationAiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAiSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationAiSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationAiSettingsQuery, Types.OrganizationAiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationAiSettingsQuery, Types.OrganizationAiSettingsQueryVariables>(OrganizationAiSettingsDocument, options);
      }
export function useOrganizationAiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationAiSettingsQuery, Types.OrganizationAiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationAiSettingsQuery, Types.OrganizationAiSettingsQueryVariables>(OrganizationAiSettingsDocument, options);
        }
export type OrganizationAiSettingsQueryHookResult = ReturnType<typeof useOrganizationAiSettingsQuery>;
export type OrganizationAiSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationAiSettingsLazyQuery>;
export type OrganizationAiSettingsQueryResult = Apollo.QueryResult<Types.OrganizationAiSettingsQuery, Types.OrganizationAiSettingsQueryVariables>;
export const OrganizationAiSettingsPageDocument = gql`
    query OrganizationAiSettingsPage {
  organization {
    ...Organization
    aiSettings {
      ...OrganizationAISettings
    }
  }
}
    ${OrganizationFragmentDoc}
${OrganizationAiSettingsFragmentDoc}`;

/**
 * __useOrganizationAiSettingsPageQuery__
 *
 * To run a query within a React component, call `useOrganizationAiSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAiSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAiSettingsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationAiSettingsPageQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationAiSettingsPageQuery, Types.OrganizationAiSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationAiSettingsPageQuery, Types.OrganizationAiSettingsPageQueryVariables>(OrganizationAiSettingsPageDocument, options);
      }
export function useOrganizationAiSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationAiSettingsPageQuery, Types.OrganizationAiSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationAiSettingsPageQuery, Types.OrganizationAiSettingsPageQueryVariables>(OrganizationAiSettingsPageDocument, options);
        }
export type OrganizationAiSettingsPageQueryHookResult = ReturnType<typeof useOrganizationAiSettingsPageQuery>;
export type OrganizationAiSettingsPageLazyQueryHookResult = ReturnType<typeof useOrganizationAiSettingsPageLazyQuery>;
export type OrganizationAiSettingsPageQueryResult = Apollo.QueryResult<Types.OrganizationAiSettingsPageQuery, Types.OrganizationAiSettingsPageQueryVariables>;
export const UpdateOrganizationAiSettingsDocument = gql`
    mutation UpdateOrganizationAiSettings($id: String!, $aiSettings: UpdateAiSettingsInput!) {
  updateOrganization(input: {id: $id, aiSettings: $aiSettings}) {
    id
    aiSettings {
      ...OrganizationAISettings
    }
  }
}
    ${OrganizationAiSettingsFragmentDoc}`;
export type UpdateOrganizationAiSettingsMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationAiSettingsMutation, Types.UpdateOrganizationAiSettingsMutationVariables>;

/**
 * __useUpdateOrganizationAiSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAiSettingsMutation, { data, loading, error }] = useUpdateOrganizationAiSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aiSettings: // value for 'aiSettings'
 *   },
 * });
 */
export function useUpdateOrganizationAiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationAiSettingsMutation, Types.UpdateOrganizationAiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationAiSettingsMutation, Types.UpdateOrganizationAiSettingsMutationVariables>(UpdateOrganizationAiSettingsDocument, options);
      }
export type UpdateOrganizationAiSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationAiSettingsMutation>;
export type UpdateOrganizationAiSettingsMutationResult = Apollo.MutationResult<Types.UpdateOrganizationAiSettingsMutation>;
export type UpdateOrganizationAiSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationAiSettingsMutation, Types.UpdateOrganizationAiSettingsMutationVariables>;